/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(609);
	module.exports = __webpack_require__(654);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(42);


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(104);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(278), __esModule: true };

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(268);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(267);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(164);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(26);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(463);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(710);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(259);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	function new_byte(count) {
	    return new Int8Array(count);
	}
	
	function new_short(count) {
	    return new Int16Array(count);
	}
	
	function new_int(count) {
	    return new Int32Array(count);
	}
	
	function new_float(count) {
	    return new Float32Array(count);
	}
	
	function new_double(count) {
	    return new Float64Array(count);
	}
	
	function new_float_n(args) {
	    if (args.length == 1) {
	        return new_float(args[0]);
	    }
	    var sz = args[0];
	    args = args.slice(1);
	    var A = [];
	    for (var i = 0; i < sz; i++) {
	        A.push(new_float_n(args));
	    }
	    return A;
	}
	function new_int_n(args) {
	    if (args.length == 1) {
	        return new_int(args[0]);
	    }
	    var sz = args[0];
	    args = args.slice(1);
	    var A = [];
	    for (var i = 0; i < sz; i++) {
	        A.push(new_int_n(args));
	    }
	    return A;
	}
	
	function new_short_n(args) {
	    if (args.length == 1) {
	        return new_short(args[0]);
	    }
	    var sz = args[0];
	    args = args.slice(1);
	    var A = [];
	    for (var i = 0; i < sz; i++) {
	        A.push(new_short_n(args));
	    }
	    return A;
	}
	
	function new_array_n(args) {
	    if (args.length == 1) {
	        return new Array(args[0]);
	    }
	    var sz = args[0];
	    args = args.slice(1);
	    var A = [];
	    for (var i = 0; i < sz; i++) {
	        A.push(new_array_n(args));
	    }
	    return A;
	}
	
	
	var Arrays = {};
	
	Arrays.fill = function (a, fromIndex, toIndex, val) {
	    if (arguments.length == 2) {
	        for (var i = 0; i < a.length; i++) {
	            a[i] = arguments[1];
	        }
	    } else {
	        for (var i = fromIndex; i < toIndex; i++) {
	            a[i] = val;
	        }
	    }
	};
	
	var System = {};
	
	System.arraycopy = function (src, srcPos, dest, destPos, length) {
	    var srcEnd = srcPos + length;
	    while (srcPos < srcEnd)
	        dest[destPos++] = src[srcPos++];
	};
	
	
	var Util = {};
	Util.SQRT2 = 1.41421356237309504880;
	Util.FAST_LOG10 = function (x) {
	    return Math.log10(x);
	};
	
	Util.FAST_LOG10_X = function (x, y) {
	    return Math.log10(x) * y;
	};
	
	function ShortBlock(ordinal) {
	    this.ordinal = ordinal;
	}
	/**
	 * LAME may use them, even different block types for L/R.
	 */
	ShortBlock.short_block_allowed = new ShortBlock(0);
	/**
	 * LAME may use them, but always same block types in L/R.
	 */
	ShortBlock.short_block_coupled = new ShortBlock(1);
	/**
	 * LAME will not use short blocks, long blocks only.
	 */
	ShortBlock.short_block_dispensed = new ShortBlock(2);
	/**
	 * LAME will not use long blocks, short blocks only.
	 */
	ShortBlock.short_block_forced = new ShortBlock(3);
	
	var Float = {};
	Float.MAX_VALUE = 3.4028235e+38;
	
	function VbrMode(ordinal) {
	    this.ordinal = ordinal;
	}
	VbrMode.vbr_off = new VbrMode(0);
	VbrMode.vbr_mt = new VbrMode(1);
	VbrMode.vbr_rh = new VbrMode(2);
	VbrMode.vbr_abr = new VbrMode(3);
	VbrMode.vbr_mtrh = new VbrMode(4);
	VbrMode.vbr_default = VbrMode.vbr_mtrh;
	
	var assert = function (x) {
	    //console.assert(x);
	};
	
	module.exports = {
	    "System": System,
	    "VbrMode": VbrMode,
	    "Float": Float,
	    "ShortBlock": ShortBlock,
	    "Util": Util,
	    "Arrays": Arrays,
	    "new_array_n": new_array_n,
	    "new_byte": new_byte,
	    "new_double": new_double,
	    "new_float": new_float,
	    "new_float_n": new_float_n,
	    "new_int": new_int,
	    "new_int_n": new_int_n,
	    "new_short": new_short,
	    "new_short_n": new_short_n,
	    "assert": assert
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMProperty = __webpack_require__(65);
	var ReactDOMComponentFlags = __webpack_require__(217);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(439);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setFirstLogin = setFirstLogin;
	exports.refreshLogin = refreshLogin;
	exports.loginUser = loginUser;
	exports.registerUser = registerUser;
	exports.joinGroup = joinGroup;
	exports.registerSingleUser = registerSingleUser;
	exports.registerSingleFreeUser = registerSingleFreeUser;
	exports.registerTrialUser = registerTrialUser;
	exports.receiveLogout = receiveLogout;
	exports.logoutUser = logoutUser;
	exports.validateTrialToken = validateTrialToken;
	exports.sendResetPasswordLink = sendResetPasswordLink;
	exports.resetPassword = resetPassword;
	exports.fetchExercises = fetchExercises;
	exports.launchExercise = launchExercise;
	exports.clearExercise = clearExercise;
	exports.createExercise = createExercise;
	exports.updateExercise = updateExercise;
	exports.deleteExercise = deleteExercise;
	exports.downloadReport = downloadReport;
	exports.launchText = launchText;
	exports.selectText = selectText;
	exports.clearText = clearText;
	exports.updateSource = updateSource;
	exports.updateTranslation = updateTranslation;
	exports.nextSentence = nextSentence;
	exports.prevSentence = prevSentence;
	exports.spliceSentence = spliceSentence;
	exports.setUtteranceLength = setUtteranceLength;
	exports.setRecording = setRecording;
	exports.addResults = addResults;
	exports.addHistory = addHistory;
	exports.changeSettings = changeSettings;
	exports.changePassword = changePassword;
	exports.validateToken = validateToken;
	exports.validateEmail = validateEmail;
	exports.fetchGroup = fetchGroup;
	exports.updateGroup = updateGroup;
	exports.generateToken = generateToken;
	exports.fetchGroupUsers = fetchGroupUsers;
	exports.updateUser = updateUser;
	exports.removeUser = removeUser;
	exports.sendInvitation = sendInvitation;
	exports.createSubscription = createSubscription;
	exports.updateCreditCard = updateCreditCard;
	exports.resumeSubscription = resumeSubscription;
	exports.claimCoupon = claimCoupon;
	exports.getSubscriptions = getSubscriptions;
	exports.getPlan = getPlan;
	exports.getInvoices = getInvoices;
	exports.cancelSubscription = cancelSubscription;
	
	var _api = __webpack_require__(247);
	
	var _getjwtdata = __webpack_require__(155);
	
	var _getjwtdata2 = _interopRequireDefault(_getjwtdata);
	
	var _textHelpers = __webpack_require__(662);
	
	var _textHelpers2 = _interopRequireDefault(_textHelpers);
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	var _config = __webpack_require__(246);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _store = __webpack_require__(251);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint consistent-return: "warn"*/
	// actions.js
	//
	// The middleware to call the API
	
	
	function requestLogin() {
	  return {
	    type: types.LOGIN_REQUEST,
	    isFetching: true,
	    isAuthenticated: false,
	    localData: {},
	    errors: []
	  };
	}
	
	function setFirstLogin() {
	  console.log("set first login");
	  return {
	    type: types.HAS_LOGGED_IN,
	    hasLoggedIn: true
	  };
	}
	
	function receiveLogin(payload, remember) {
	  var user = _getjwtdata2.default.decode(payload);
	  var localData = _store2.default.get(user.id);
	  return {
	    type: types.LOGIN_SUCCESS,
	    isFetching: false,
	    isAuthenticated: true,
	    user: user,
	    localData: localData,
	    rememberUser: remember
	  };
	}
	
	function refreshLogin(payload) {
	  var user = _getjwtdata2.default.decode(payload);
	  return {
	    type: types.LOGIN_REFRESH,
	    user: user
	  };
	}
	
	function loginError(errors) {
	  return {
	    type: types.LOGIN_FAILURE,
	    isFetching: false,
	    isAuthenticated: false,
	    errors: errors
	  };
	}
	
	// Calls the API to get a token and
	// dispatches actions along the way
	function loginUser(creds) {
	  var config = {
	    method: "POST",
	    headers: {
	      "Content-Type": "application/json",
	      Accept: "application/json"
	    },
	    body: JSON.stringify(creds)
	  };
	
	  return function (dispatch) {
	    // We dispatch requestLogin to kickoff the call to the API
	    dispatch(requestLogin(creds));
	
	    return fetch(_config2.default + "/login", config).then(function (response) {
	      return response.json().then(function (payload) {
	        return {
	          payload: payload,
	          response: response
	        };
	      });
	    }).then(function (_ref) {
	      var payload = _ref.payload,
	          response = _ref.response;
	
	      if (!response.ok) {
	        // If there was a problem, we want to
	        // dispatch the error condition
	        dispatch(loginError(payload.errors));
	        return;
	      }
	      // If login was successful, set the token in local storage
	      if (creds.remember) {
	        localStorage.setItem("token", payload);
	      } else {
	        localStorage.removeItem("token"); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
	        sessionStorage.setItem("token", payload);
	      }
	      // Dispatch the success action
	      dispatch(receiveLogin(payload, creds.remember));
	    }).catch(function (err) {
	      return dispatch(loginError({ errors: [err] }));
	    });
	  };
	}
	
	function requestRegistration() {
	  return {
	    type: types.REGISTRATION_REQUEST,
	    isFetching: true
	  };
	}
	
	function receiveRegistration() {
	  return {
	    type: types.REGISTRATION_SUCCESS,
	    isFetching: false,
	    isRegistered: true
	  };
	}
	
	function registrationError(message) {
	  return {
	    type: types.REGISTRATION_FAILURE,
	    isFetching: false,
	    isRegistered: false,
	    message: message
	  };
	}
	
	// Calls the API to get a token and
	// dispatches actions along the way
	function registerUser(creds) {
	  var config = {
	    method: "POST",
	    headers: {
	      "Content-Type": "application/json",
	      Accept: "application/json"
	    },
	    body: JSON.stringify(creds)
	  };
	
	  return function (dispatch) {
	    // We dispatch requestLogin to kickoff the call to the API
	    dispatch(requestRegistration(creds));
	
	    return fetch(_config2.default + "/register", config).then(function (response) {
	      return response.json().then(function (data) {
	        return {
	          data: data,
	          response: response
	        };
	      });
	    }).then(function (_ref2) {
	      var data = _ref2.data,
	          response = _ref2.response;
	
	      if (!response.ok) {
	        // If there was a problem, we want to
	        // dispatch the error condition
	        dispatch(registrationError(data.errors));
	        return;
	      }
	      // If login was successful, set the token in local storage
	      sessionStorage.setItem("token", data);
	      // Dispatch the success action
	      dispatch(receiveRegistration(data));
	      dispatch(receiveLogin(data));
	    }).catch(function (err) {
	      return dispatch(registrationError({ errors: [err] }));
	    });
	  };
	}
	
	function joinGroup(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/join-group",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.JOIN_GROUP_REQUEST, types.JOIN_GROUP_SUCCESS, types.JOIN_GROUP_FAILURE]
	  });
	}
	
	function requestSingleRegistration() {
	  return {
	    type: types.SINGLE_REGISTRATION_REQUEST,
	    isFetching: true,
	    token: null
	  };
	}
	
	function receiveSingleRegistration(data) {
	  return {
	    type: types.SINGLE_REGISTRATION_SUCCESS,
	    isFetching: false,
	    isRegistered: true,
	    token: data
	  };
	}
	
	function singleRegistrationError(errors) {
	  return {
	    type: types.SINGLE_REGISTRATION_FAILURE,
	    isFetching: false,
	    isRegistered: false,
	    token: null,
	    errors: errors
	  };
	}
	
	// Calls the API to get a token and
	// dispatches actions along the way
	function registerSingleUser(creds) {
	  /*
	  const config = {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json',
	      Accept: 'application/json',
	    },
	    body: JSON.stringify(creds),
	  };
	   return (dispatch) => {
	    // We dispatch requestLogin to kickoff the call to the API
	    dispatch(requestSingleRegistration(creds));
	     return fetch(`${server}/register-free-trial`, config)
	      .then(response =>
	        response.json()
	        .then(data => ({
	          data,
	          response,
	        })),
	      )
	      .then(({
	        data,
	        response,
	      }) => {
	        if (!response.ok) {
	          // If there was a problem, we want to
	          // dispatch the error condition
	          dispatch(singleRegistrationError(data.errors));
	          //return Promise.reject(data.errors);
	        } else {
	          // If login was successful, set the token in local storage
	          if (creds.remember) {
	            localStorage.setItem('token', data);
	          } else {
	            localStorage.removeItem('token'); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
	            sessionStorage.setItem('token', data);
	          }
	        dispatch(receiveSingleRegistration(data));
	         // Wait for login, this gives time to prepare the user for the transition in the UI
	        setTimeout(() => {
	          dispatch(receiveLogin(data,creds.remember));
	        }, 3000)
	        }
	      })
	      .catch(err => dispatch(singleRegistrationError(err)) );
	  };
	  */
	}
	
	function requestSingleFreeRegistration() {
	  return {
	    type: types.SINGLE_FREE_REGISTRATION_REQUEST,
	    isFetching: true,
	    token: null
	  };
	}
	
	function receiveSingleFreeRegistration(data) {
	  return {
	    type: types.SINGLE_FREE_REGISTRATION_SUCCESS,
	    isFetching: false,
	    isRegistered: true,
	    token: data
	  };
	}
	
	function singleFreeRegistrationError(errors) {
	  return {
	    type: types.SINGLE_FREE_REGISTRATION_FAILURE,
	    isFetching: false,
	    isRegistered: false,
	    token: null,
	    errors: errors
	  };
	}
	
	// Calls the API to get a token and
	// dispatches actions along the way
	function registerSingleFreeUser(creds) {
	  /*
	  const config = {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json',
	      Accept: 'application/json',
	    },
	    body: JSON.stringify(creds),
	  };
	   return (dispatch) => {
	    // We dispatch requestLogin to kickoff the call to the API
	    dispatch(requestSingleFreeRegistration(creds));
	     return fetch(`${server}/register-free`, config)
	      .then(response =>
	        response.json()
	        .then(data => ({
	          data,
	          response,
	        })),
	      )
	      .then(({
	        data,
	        response,
	      }) => {
	        if (!response.ok) {
	          // If there was a problem, we want to
	          // dispatch the error condition
	          dispatch(singleFreeRegistrationError(data.errors));
	          //return Promise.reject(data.errors);
	        } else {
	          // If login was successful, set the token in local storage
	          if (creds.remember) {
	            localStorage.setItem('token', data);
	          } else {
	            localStorage.removeItem('token'); // Prevents a scenario where the persistent token remains in storage after user logs in using sessionStorage
	            sessionStorage.setItem('token', data);
	          }
	        dispatch(receiveSingleFreeRegistration(data));
	        }
	      })
	      .catch(err => dispatch(singleFreeRegistrationError(err)) );
	  };*/
	}
	
	function requestTrialRegistration() {
	  return {
	    type: types.TRIAL_REGISTRATION_REQUEST,
	    isFetching: true
	  };
	}
	
	function receiveTrialRegistration() {
	  return {
	    type: types.TRIAL_REGISTRATION_SUCCESS,
	    isFetching: false,
	    isRegistered: true
	  };
	}
	
	function trialRegistrationError(message) {
	  return {
	    type: types.TRIAL_REGISTRATION_FAILURE,
	    isFetching: false,
	    isRegistered: false,
	    message: message
	  };
	}
	
	function registerTrialUser(creds) {
	  var config = {
	    method: "POST",
	    headers: {
	      "Content-Type": "application/json",
	      Accept: "application/json"
	    },
	    body: JSON.stringify(creds)
	  };
	
	  return function (dispatch) {
	    // We dispatch requestLogin to kickoff the call to the API
	    dispatch(requestTrialRegistration(creds));
	
	    return fetch(_config2.default + "/start-trial/register", config).then(function (response) {
	      return response.json().then(function (data) {
	        return {
	          data: data,
	          response: response
	        };
	      });
	    }).then(function (_ref4) {
	      var data = _ref4.data,
	          response = _ref4.response;
	
	      if (!response.ok) {
	        // If there was a problem, we want to
	        // dispatch the error condition
	        dispatch(trialRegistrationError(data));
	        return;
	      }
	      // If login was successful, set the token in local storage
	      sessionStorage.setItem("token", data);
	      // Dispatch the success action
	      dispatch(receiveTrialRegistration(data));
	      dispatch(receiveLogin(data, false));
	    }).catch(function (err) {
	      return dispatch(trialRegistrationError({ errors: [err] }));
	    });
	  };
	}
	
	// Three possible states for our logout process as well.
	// Since we are using JWTs, we just need to remove the token
	// from localStorage. These actions are more useful if we
	// were calling the API to log the user out
	function requestLogout() {
	  return {
	    type: types.LOGOUT_REQUEST,
	    isFetching: true
	  };
	}
	
	function receiveLogout() {
	  return {
	    type: types.LOGOUT_SUCCESS,
	    isFetching: false,
	    isAuthenticated: false,
	    user: {},
	    remember: false
	  };
	}
	
	function logoutError(message) {
	  return {
	    type: types.LOGOUT_FAILURE,
	    isFetching: false,
	    message: message,
	    user: {}
	  };
	}
	
	// Logs the user out
	function logoutUser() {
	  var token = localStorage.getItem("token") || sessionStorage.getItem("token");
	
	  var headers = new Headers();
	  headers.append("Authorization", "Bearer " + token, "Content-Type", "Accept");
	
	  var config = {
	    method: "POST",
	    headers: headers
	  };
	
	  return function (dispatch) {
	    dispatch(requestLogout());
	
	    return fetch(_config2.default + "/logout", config).then(function (response) {
	      return response.json().then(function (data) {
	        return {
	          data: data,
	          response: response
	        };
	      });
	    }).then(function (_ref5) {
	      var data = _ref5.data,
	          response = _ref5.response;
	
	      localStorage.removeItem("token");
	      if (!response.ok) {
	        // If there was a problem, we want to
	        // dispatch the error condition
	
	        dispatch(logoutError(data.errors));
	        dispatch(receiveLogout());
	        return;
	      }
	      // Dispatch the success action
	      dispatch(receiveLogout());
	    }).catch(function (err) {
	      return dispatch(logoutError({ errors: [err] }));
	    });
	  };
	}
	
	function validateTrialToken(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/start-trial/validate",
	    method: "POST",
	    body: body,
	    authenticated: false,
	    types: [types.VALIDATE_TRIAL_TOKEN_REQUEST, types.VALIDATE_TRIAL_TOKEN_SUCCESS, types.VALIDATE_TRIAL_TOKEN_FAILURE]
	  });
	}
	
	// Password Reset
	/*
	function requestPasswordEmail(email) {
	  return {
	    type: types.PASSWORD_EMAIL_REQUEST,
	    isFetching: true,
	  };
	}
	
	function receivePasswordEmail() {
	  return {
	    type: types.PASSWORD_EMAIL_SUCCESS,
	  };
	}
	
	function passwordEmailError(message) {
	  return {
	    type: types.PASSWORD_EMAIL_FAILURE,
	    message,
	  };
	}*/
	
	function sendResetPasswordLink(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/password/email",
	    method: "POST",
	    body: body,
	    authenticated: false,
	    types: [types.PASSWORD_EMAIL_REQUEST, types.PASSWORD_EMAIL_SUCCESS, types.PASSWORD_EMAIL_FAILURE]
	  });
	}
	
	/*
	function requestPasswordReset(creds) {
	  return {
	    type: types.PASSWORD_RESET_REQUEST,
	    isFetching: true,
	    hasFetched: false,
	    isSuccess: false,
	    creds,
	  };
	}
	
	function receivePasswordReset() {
	  return {
	    type: types.PASSWORD_RESET_SUCCESS,
	    isFetching: false,
	    hasFetched: true,
	    isSuccess: true,
	  };
	}
	
	function passwordResetError(message) {
	  return {
	    type: types.PASSWORD_RESET_FAILURE,
	    isFetching: false,
	    hasFetched: true,
	    isSuccess: false,
	    message,
	  };
	} */
	
	function resetPassword(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/password/reset",
	    method: "POST",
	    body: body,
	    authenticated: false,
	    types: [types.PASSWORD_RESET_REQUEST, types.PASSWORD_RESET_SUCCESS, types.PASSWORD_RESET_FAILURE]
	  });
	}
	
	function fetchExercises() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/exercises",
	    method: "GET",
	    authenticated: true,
	    types: [types.EXERCISE_REQUEST, types.EXERCISE_SUCCESS, types.EXERCISE_FAILURE]
	  });
	}
	
	function launchExercise(index) {
	  return {
	    type: types.LAUNCH_EXERCISE,
	    activeExercise: index
	  };
	}
	
	function clearExercise() {
	  return {
	    type: types.CLEAR_EXERCISE,
	    activeExercise: 0
	  };
	}
	
	function createExercise(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/exercises",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.EXERCISE_CREATE_REQUEST, types.EXERCISE_CREATE_SUCCESS, types.EXERCISE_CREATE_FAILURE]
	  });
	}
	
	function updateExercise(id, body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/exercises/" + id,
	    method: "PUT",
	    body: body,
	    authenticated: true,
	    types: [types.EXERCISE_UPDATE_REQUEST, types.EXERCISE_UPDATE_SUCCESS, types.EXERCISE_UPDATE_FAILURE]
	  });
	}
	
	// Uses the API middlware to get a quote
	function deleteExercise(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/exercises/" + id,
	    method: "DELETE",
	    authenticated: true,
	    types: [types.EXERCISE_DELETE_REQUEST, types.EXERCISE_DELETE_SUCCESS, types.EXERCISE_DELETE_FAILURE]
	  });
	}
	
	function downloadReport(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/exercises/download-report",
	    method: "POST",
	    body: body,
	    type: "blob",
	    authenticated: true,
	    types: [types.HISTORY_REPORT_REQUEST, types.HISTORY_REPORT_SUCCESS, types.HISTORY_REPORT_FAILURE]
	  });
	}
	
	function launchText(text) {
	  return {
	    type: types.LAUNCH_TEXT,
	    activeText: 0,
	    texts: (0, _textHelpers2.default)(text)
	  };
	}
	
	function selectText(index) {
	  return {
	    type: types.SELECT_TEXT,
	    index: index
	  };
	}
	
	function clearText() {
	  return {
	    type: types.CLEAR_TEXT
	  };
	}
	
	function updateSource(source) {
	  return {
	    type: types.UPDATE_SOURCE,
	    source: source
	  };
	}
	
	function updateTranslation(translation) {
	  console.log("update translation");
	  return {
	    type: types.UPDATE_TRANSLATION,
	    translation: translation
	  };
	}
	
	function nextSentence() {
	  return {
	    type: types.NEXT_SENTENCE
	  };
	}
	
	function prevSentence() {
	  return {
	    type: types.PREV_SENTENCE
	  };
	}
	
	function spliceSentence() {
	  return {
	    type: types.SPLICE_SENTENCE
	  };
	}
	
	function setUtteranceLength(length) {
	  return {
	    type: types.SET_UTTERANCE_LENGTH,
	    utteranceLength: length
	  };
	}
	
	function setRecording(buffer, float32ArrayBuffers) {
	  return {
	    type: types.SET_RECORDING,
	    buffer: buffer,
	    float32ArrayBuffers: float32ArrayBuffers
	  };
	}
	
	function addResults(results) {
	  return {
	    type: types.ADD_RESULTS,
	    results: results
	  };
	}
	
	function addHistory(history) {
	  return {
	    type: types.ADD_HISTORY,
	    text: history.text,
	    results: history.results,
	    language: history.language
	  };
	}
	
	function changeSettings(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.CHANGE_SETTINGS_REQUEST, types.CHANGE_SETTINGS_SUCCESS, types.CHANGE_SETTINGS_FAILURE]
	  });
	}
	
	function changePassword(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/password",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.CHANGE_PASSWORD_REQUEST, types.CHANGE_PASSWORD_SUCCESS, types.CHANGE_PASSWORD_FAILURE]
	  });
	}
	
	function validateToken(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/validate/token",
	    method: "POST",
	    body: body,
	    authenticated: false,
	    types: [types.VALIDATE_TOKEN_REQUEST, types.VALIDATE_TOKEN_SUCCESS, types.VALIDATE_TOKEN_FAILURE]
	  });
	}
	
	function validateEmail(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/validate/email",
	    method: "POST",
	    body: body,
	    authenticated: false,
	    types: [types.VALIDATE_EMAIL_REQUEST, types.VALIDATE_EMAIL_SUCCESS, types.VALIDATE_EMAIL_FAILURE]
	  });
	}
	
	function fetchGroup() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings",
	    method: "GET",
	    authenticated: true,
	    types: [types.GROUP_REQUEST, types.GROUP_SUCCESS, types.GROUP_FAILURE]
	  });
	}
	
	function updateGroup(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings",
	    method: "PUT",
	    body: body,
	    authenticated: true,
	    types: [types.GROUP_UPDATE_REQUEST, types.GROUP_UPDATE_SUCCESS, types.GROUP_UPDATE_FAILURE]
	  });
	}
	
	function generateToken() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings/generatetoken",
	    method: "POST",
	    authenticated: true,
	    types: [types.GROUP_TOKEN_REFRESH_REQUEST, types.GROUP_TOKEN_REFRESH_SUCCESS, types.GROUP_TOKEN_REFRESH_FAILURE]
	  });
	}
	
	function fetchGroupUsers() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings/users",
	    method: "GET",
	    authenticated: true,
	    types: [types.GROUP_USERS_REQUEST, types.GROUP_USERS_SUCCESS, types.GROUP_USERS_FAILURE]
	  });
	}
	
	function updateUser(id, body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings/users/" + id,
	    method: "PUT",
	    body: body,
	    authenticated: true,
	    types: [types.GROUP_USER_UPDATE_REQUEST, types.GROUP_USER_UPDATE_SUCCESS, types.GROUP_USER_UPDATE_FAILURE]
	  });
	}
	
	function removeUser(id) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings/users/" + id,
	    method: "DELETE",
	    authenticated: true,
	    types: [types.GROUP_USER_REMOVE_REQUEST, types.GROUP_USER_REMOVE_SUCCESS, types.GROUP_USER_REMOVE_FAILURE]
	  });
	}
	
	function sendInvitation(emails) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/group-settings/sendtoken",
	    method: "POST",
	    body: {
	      emails: emails
	    },
	    authenticated: true,
	    types: [types.GROUP_SEND_INVITATION_REQUEST, types.GROUP_SEND_INVITATION_SUCCESS, types.GROUP_SEND_INVITATION_FAILURE]
	  });
	}
	
	function createSubscription(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/subscribe",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.CREATE_SUBSCRIPTION_REQUEST, types.CREATE_SUBSCRIPTION_SUCCESS, types.CREATE_SUBSCRIPTION_FAILURE]
	  });
	}
	
	function updateCreditCard(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/update-card",
	    method: "POST",
	    authenticated: true,
	    body: body,
	    types: [types.UPDATE_CARD_REQUEST, types.UPDATE_CARD_SUCCESS, types.UPDATE_CARD_FAILURE]
	  });
	}
	
	function resumeSubscription() {
	  /*
	  return {
	    [CALL_API]: {
	      endpoint: "/account/resume-subscription",
	      method: "POST",
	      authenticated: true,
	      types: [
	        types.RESUME_SUBSCRIPTION_REQUEST,
	        types.RESUME_SUBSCRIPTION_SUCCESS,
	        types.RESUME_SUBSCRIPTION_FAILURE
	      ]
	    }
	  };*/
	}
	
	function claimCoupon(body) {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/claim-coupon",
	    method: "POST",
	    body: body,
	    authenticated: true,
	    types: [types.CLAIM_COUPON_REQUEST, types.CLAIM_COUPON_SUCCESS, types.CLAIM_COUPON_FAILURE]
	  });
	}
	
	function getSubscriptions() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/subscriptions",
	    method: "GET",
	    authenticated: true,
	    types: [types.SUBSCRIPTIONS_REQUEST, types.SUBSCRIPTIONS_SUCCESS, types.SUBSCRIPTIONS_FAILURE]
	  });
	}
	
	function getPlan() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/plan",
	    method: "GET",
	    authenticated: false,
	    types: [types.PLAN_REQUEST, types.PLAN_SUCCESS, types.PLAN_FAILURE]
	  });
	}
	
	function getInvoices() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/invoices",
	    method: "GET",
	    authenticated: true,
	    types: [types.INVOICES_REQUEST, types.INVOICES_SUCCESS, types.INVOICES_FAILURE]
	  });
	}
	
	function cancelSubscription() {
	  return _defineProperty({}, _api.CALL_API, {
	    endpoint: "/account/subscription",
	    method: "DELETE",
	    authenticated: true,
	    types: [types.CANCEL_SUBSCRIPTION_REQUEST, types.CANCEL_SUBSCRIPTION_SUCCESS, types.CANCEL_SUBSCRIPTION_FAILURE]
	  });
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	/**
	 * ENCDELAY The encoder delay.
	 *
	 * Minimum allowed is MDCTDELAY (see below)
	 *
	 * The first 96 samples will be attenuated, so using a value less than 96
	 * will result in corrupt data for the first 96-ENCDELAY samples.
	 *
	 * suggested: 576 set to 1160 to sync with FhG.
	 */
	Encoder.ENCDELAY = 576;
	/**
	 * make sure there is at least one complete frame after the last frame
	 * containing real data
	 *
	 * Using a value of 288 would be sufficient for a a very sophisticated
	 * decoder that can decode granule-by-granule instead of frame by frame. But
	 * lets not assume this, and assume the decoder will not decode frame N
	 * unless it also has data for frame N+1
	 */
	Encoder.POSTDELAY = 1152;
	
	/**
	 * delay of the MDCT used in mdct.c original ISO routines had a delay of
	 * 528! Takehiro's routines:
	 */
	Encoder.MDCTDELAY = 48;
	Encoder.FFTOFFSET = (224 + Encoder.MDCTDELAY);
	
	/**
	 * Most decoders, including the one we use, have a delay of 528 samples.
	 */
	Encoder.DECDELAY = 528;
	
	/**
	 * number of subbands
	 */
	Encoder.SBLIMIT = 32;
	
	/**
	 * parition bands bands
	 */
	Encoder.CBANDS = 64;
	
	/**
	 * number of critical bands/scale factor bands where masking is computed
	 */
	Encoder.SBPSY_l = 21;
	Encoder.SBPSY_s = 12;
	
	/**
	 * total number of scalefactor bands encoded
	 */
	Encoder.SBMAX_l = 22;
	Encoder.SBMAX_s = 13;
	Encoder.PSFB21 = 6;
	Encoder.PSFB12 = 6;
	
	/**
	 * FFT sizes
	 */
	Encoder.BLKSIZE = 1024;
	Encoder.HBLKSIZE = (Encoder.BLKSIZE / 2 + 1);
	Encoder.BLKSIZE_s = 256;
	Encoder.HBLKSIZE_s = (Encoder.BLKSIZE_s / 2 + 1);
	
	Encoder.NORM_TYPE = 0;
	Encoder.START_TYPE = 1;
	Encoder.SHORT_TYPE = 2;
	Encoder.STOP_TYPE = 3;
	
	/**
	 * <PRE>
	 * Mode Extention:
	 * When we are in stereo mode, there are 4 possible methods to store these
	 * two channels. The stereo modes -m? are using a subset of them.
	 *
	 *  -ms: MPG_MD_LR_LR
	 *  -mj: MPG_MD_LR_LR and MPG_MD_MS_LR
	 *  -mf: MPG_MD_MS_LR
	 *  -mi: all
	 * </PRE>
	 */
	Encoder.MPG_MD_LR_LR = 0;
	Encoder.MPG_MD_LR_I = 1;
	Encoder.MPG_MD_MS_LR = 2;
	Encoder.MPG_MD_MS_I = 3;
	
	Encoder.fircoef = [-0.0207887 * 5, -0.0378413 * 5,
	    -0.0432472 * 5, -0.031183 * 5, 7.79609e-18 * 5, 0.0467745 * 5,
	    0.10091 * 5, 0.151365 * 5, 0.187098 * 5];
	
	function Encoder() {
	    var NewMDCT = __webpack_require__(402);
	    var III_psy_ratio = __webpack_require__(399);
	
	    var FFTOFFSET = Encoder.FFTOFFSET;
	    var MPG_MD_MS_LR = Encoder.MPG_MD_MS_LR;
	    //BitStream bs;
	    //PsyModel psy;
	    //VBRTag vbr;
	    //QuantizePVT qupvt;
	    var bs = null;
	    this.psy = null;
	    var psy = null;
	    var vbr = null;
	    var qupvt = null;
	
	    //public final void setModules(BitStream bs, PsyModel psy, QuantizePVT qupvt,
	    //    VBRTag vbr) {
	    this.setModules = function (_bs, _psy, _qupvt, _vbr) {
	        bs = _bs;
	        this.psy = _psy;
	        psy = _psy;
	        vbr = _vbr;
	        qupvt = _qupvt;
	    };
	
	    var newMDCT = new NewMDCT();
	
	    /***********************************************************************
	     *
	     * encoder and decoder delays
	     *
	     ***********************************************************************/
	
	    /**
	     * <PRE>
	     * layer III enc->dec delay:  1056 (1057?)   (observed)
	     * layer  II enc->dec delay:   480  (481?)   (observed)
	     *
	     * polyphase 256-16             (dec or enc)        = 240
	     * mdct      256+32  (9*32)     (dec or enc)        = 288
	     * total:    512+16
	     *
	     * My guess is that delay of polyphase filterbank is actualy 240.5
	     * (there are technical reasons for this, see postings in mp3encoder).
	     * So total Encode+Decode delay = ENCDELAY + 528 + 1
	     * </PRE>
	     */
	
	
	    /**
	     * auto-adjust of ATH, useful for low volume Gabriel Bouvigne 3 feb 2001
	     *
	     * modifies some values in gfp.internal_flags.ATH (gfc.ATH)
	     */
	//private void adjust_ATH(final LameInternalFlags gfc) {
	    function adjust_ATH(gfc) {
	        var gr2_max, max_pow;
	
	        if (gfc.ATH.useAdjust == 0) {
	            gfc.ATH.adjust = 1.0;
	            /* no adjustment */
	            return;
	        }
	
	        /* jd - 2001 mar 12, 27, jun 30 */
	        /* loudness based on equal loudness curve; */
	        /* use granule with maximum combined loudness */
	        max_pow = gfc.loudness_sq[0][0];
	        gr2_max = gfc.loudness_sq[1][0];
	        if (gfc.channels_out == 2) {
	            max_pow += gfc.loudness_sq[0][1];
	            gr2_max += gfc.loudness_sq[1][1];
	        } else {
	            max_pow += max_pow;
	            gr2_max += gr2_max;
	        }
	        if (gfc.mode_gr == 2) {
	            max_pow = Math.max(max_pow, gr2_max);
	        }
	        max_pow *= 0.5;
	        /* max_pow approaches 1.0 for full band noise */
	
	        /* jd - 2001 mar 31, jun 30 */
	        /* user tuning of ATH adjustment region */
	        max_pow *= gfc.ATH.aaSensitivityP;
	
	        /*
	         * adjust ATH depending on range of maximum value
	         */
	
	        /* jd - 2001 feb27, mar12,20, jun30, jul22 */
	        /* continuous curves based on approximation */
	        /* to GB's original values. */
	        /* For an increase in approximate loudness, */
	        /* set ATH adjust to adjust_limit immediately */
	        /* after a delay of one frame. */
	        /* For a loudness decrease, reduce ATH adjust */
	        /* towards adjust_limit gradually. */
	        /* max_pow is a loudness squared or a power. */
	        if (max_pow > 0.03125) { /* ((1 - 0.000625)/ 31.98) from curve below */
	            if (gfc.ATH.adjust >= 1.0) {
	                gfc.ATH.adjust = 1.0;
	            } else {
	                /* preceding frame has lower ATH adjust; */
	                /* ascend only to the preceding adjust_limit */
	                /* in case there is leading low volume */
	                if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
	                    gfc.ATH.adjust = gfc.ATH.adjustLimit;
	                }
	            }
	            gfc.ATH.adjustLimit = 1.0;
	        } else { /* adjustment curve */
	            /* about 32 dB maximum adjust (0.000625) */
	            var adj_lim_new = 31.98 * max_pow + 0.000625;
	            if (gfc.ATH.adjust >= adj_lim_new) { /* descend gradually */
	                gfc.ATH.adjust *= adj_lim_new * 0.075 + 0.925;
	                if (gfc.ATH.adjust < adj_lim_new) { /* stop descent */
	                    gfc.ATH.adjust = adj_lim_new;
	                }
	            } else { /* ascend */
	                if (gfc.ATH.adjustLimit >= adj_lim_new) {
	                    gfc.ATH.adjust = adj_lim_new;
	                } else {
	                    /* preceding frame has lower ATH adjust; */
	                    /* ascend only to the preceding adjust_limit */
	                    if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
	                        gfc.ATH.adjust = gfc.ATH.adjustLimit;
	                    }
	                }
	            }
	            gfc.ATH.adjustLimit = adj_lim_new;
	        }
	    }
	
	    /**
	     * <PRE>
	     *  some simple statistics
	     *
	     *  bitrate index 0: free bitrate . not allowed in VBR mode
	     *  : bitrates, kbps depending on MPEG version
	     *  bitrate index 15: forbidden
	     *
	     *  mode_ext:
	     *  0:  LR
	     *  1:  LR-i
	     *  2:  MS
	     *  3:  MS-i
	     * </PRE>
	     */
	    function updateStats(gfc) {
	        var gr, ch;
	        assert(0 <= gfc.bitrate_index && gfc.bitrate_index < 16);
	        assert(0 <= gfc.mode_ext && gfc.mode_ext < 4);
	
	        /* count bitrate indices */
	        gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][4]++;
	        gfc.bitrate_stereoMode_Hist[15][4]++;
	
	        /* count 'em for every mode extension in case of 2 channel encoding */
	        if (gfc.channels_out == 2) {
	            gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][gfc.mode_ext]++;
	            gfc.bitrate_stereoMode_Hist[15][gfc.mode_ext]++;
	        }
	        for (gr = 0; gr < gfc.mode_gr; ++gr) {
	            for (ch = 0; ch < gfc.channels_out; ++ch) {
	                var bt = gfc.l3_side.tt[gr][ch].block_type | 0;
	                if (gfc.l3_side.tt[gr][ch].mixed_block_flag != 0)
	                    bt = 4;
	                gfc.bitrate_blockType_Hist[gfc.bitrate_index][bt]++;
	                gfc.bitrate_blockType_Hist[gfc.bitrate_index][5]++;
	                gfc.bitrate_blockType_Hist[15][bt]++;
	                gfc.bitrate_blockType_Hist[15][5]++;
	            }
	        }
	    }
	
	    function lame_encode_frame_init(gfp, inbuf) {
	        var gfc = gfp.internal_flags;
	
	        var ch, gr;
	
	        if (gfc.lame_encode_frame_init == 0) {
	            /* prime the MDCT/polyphase filterbank with a short block */
	            var i, j;
	            var primebuff0 = new_float(286 + 1152 + 576);
	            var primebuff1 = new_float(286 + 1152 + 576);
	            gfc.lame_encode_frame_init = 1;
	            for (i = 0, j = 0; i < 286 + 576 * (1 + gfc.mode_gr); ++i) {
	                if (i < 576 * gfc.mode_gr) {
	                    primebuff0[i] = 0;
	                    if (gfc.channels_out == 2)
	                        primebuff1[i] = 0;
	                } else {
	                    primebuff0[i] = inbuf[0][j];
	                    if (gfc.channels_out == 2)
	                        primebuff1[i] = inbuf[1][j];
	                    ++j;
	                }
	            }
	            /* polyphase filtering / mdct */
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    gfc.l3_side.tt[gr][ch].block_type = Encoder.SHORT_TYPE;
	                }
	            }
	            newMDCT.mdct_sub48(gfc, primebuff0, primebuff1);
	
	            /* check FFT will not use a negative starting offset */
	            assert(576 >= Encoder.FFTOFFSET);
	            /* check if we have enough data for FFT */
	            assert(gfc.mf_size >= (Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET));
	            /* check if we have enough data for polyphase filterbank */
	            assert(gfc.mf_size >= (512 + gfp.framesize - 32));
	        }
	
	    }
	
	    /**
	     * <PRE>
	     * encodeframe()           Layer 3
	     *
	     * encode a single frame
	     *
	     *
	     *    lame_encode_frame()
	     *
	     *
	     *                           gr 0            gr 1
	     *    inbuf:           |--------------|--------------|--------------|
	     *
	     *
	     *    Polyphase (18 windows, each shifted 32)
	     *    gr 0:
	     *    window1          <----512---.
	     *    window18                 <----512---.
	     *
	     *    gr 1:
	     *    window1                         <----512---.
	     *    window18                                <----512---.
	     *
	     *
	     *
	     *    MDCT output:  |--------------|--------------|--------------|
	     *
	     *    FFT's                    <---------1024---------.
	     *                                             <---------1024-------.
	     *
	     *
	     *
	     *        inbuf = buffer of PCM data size=MP3 framesize
	     *        encoder acts on inbuf[ch][0], but output is delayed by MDCTDELAY
	     *        so the MDCT coefficints are from inbuf[ch][-MDCTDELAY]
	     *
	     *        psy-model FFT has a 1 granule delay, so we feed it data for the
	     *        next granule.
	     *        FFT is centered over granule:  224+576+224
	     *        So FFT starts at:   576-224-MDCTDELAY
	     *
	     *        MPEG2:  FFT ends at:  BLKSIZE+576-224-MDCTDELAY      (1328)
	     *        MPEG1:  FFT ends at:  BLKSIZE+2*576-224-MDCTDELAY    (1904)
	     *
	     *        MPEG2:  polyphase first window:  [0..511]
	     *                          18th window:   [544..1055]          (1056)
	     *        MPEG1:            36th window:   [1120..1631]         (1632)
	     *                data needed:  512+framesize-32
	     *
	     *        A close look newmdct.c shows that the polyphase filterbank
	     *        only uses data from [0..510] for each window.  Perhaps because the window
	     *        used by the filterbank is zero for the last point, so Takehiro's
	     *        code doesn't bother to compute with it.
	     *
	     *        FFT starts at 576-224-MDCTDELAY (304)  = 576-FFTOFFSET
	     *
	     * </PRE>
	     */
	
	
	    this.lame_encode_mp3_frame = function (gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
	        var mp3count;
	        var masking_LR = new_array_n([2, 2]);
	        /*
	         * LR masking &
	         * energy
	         */
	        masking_LR[0][0] = new III_psy_ratio();
	        masking_LR[0][1] = new III_psy_ratio();
	        masking_LR[1][0] = new III_psy_ratio();
	        masking_LR[1][1] = new III_psy_ratio();
	        var masking_MS = new_array_n([2, 2]);
	        /* MS masking & energy */
	        masking_MS[0][0] = new III_psy_ratio();
	        masking_MS[0][1] = new III_psy_ratio();
	        masking_MS[1][0] = new III_psy_ratio();
	        masking_MS[1][1] = new III_psy_ratio();
	        //III_psy_ratio masking[][];
	        var masking;
	        /* pointer to selected maskings */
	        var inbuf = [null, null];
	        var gfc = gfp.internal_flags;
	
	        var tot_ener = new_float_n([2, 4]);
	        var ms_ener_ratio = [.5, .5];
	        var pe = [[0., 0.], [0., 0.]];
	        var pe_MS = [[0., 0.], [0., 0.]];
	
	//float[][] pe_use;
	        var pe_use;
	
	        var ch, gr;
	
	        inbuf[0] = inbuf_l;
	        inbuf[1] = inbuf_r;
	
	        if (gfc.lame_encode_frame_init == 0) {
	            /* first run? */
	            lame_encode_frame_init(gfp, inbuf);
	
	        }
	
	        /********************** padding *****************************/
	        /**
	         * <PRE>
	         * padding method as described in
	         * "MPEG-Layer3 / Bitstream Syntax and Decoding"
	         * by Martin Sieler, Ralph Sperschneider
	         *
	         * note: there is no padding for the very first frame
	         *
	         * Robert Hegemann 2000-06-22
	         * </PRE>
	         */
	        gfc.padding = 0;
	        if ((gfc.slot_lag -= gfc.frac_SpF) < 0) {
	            gfc.slot_lag += gfp.out_samplerate;
	            gfc.padding = 1;
	        }
	
	        /****************************************
	         * Stage 1: psychoacoustic model *
	         ****************************************/
	
	        if (gfc.psymodel != 0) {
	            /*
	             * psychoacoustic model psy model has a 1 granule (576) delay that
	             * we must compensate for (mt 6/99).
	             */
	            var ret;
	            var bufp = [null, null];
	            /* address of beginning of left & right granule */
	            var bufpPos = 0;
	            /* address of beginning of left & right granule */
	            var blocktype = new_int(2);
	
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    bufp[ch] = inbuf[ch];
	                    bufpPos = 576 + gr * 576 - Encoder.FFTOFFSET;
	                }
	                if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
	                    ret = psy.L3psycho_anal_vbr(gfp, bufp, bufpPos, gr,
	                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
	                        tot_ener[gr], blocktype);
	                } else {
	                    ret = psy.L3psycho_anal_ns(gfp, bufp, bufpPos, gr,
	                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
	                        tot_ener[gr], blocktype);
	                }
	                if (ret != 0)
	                    return -4;
	
	                if (gfp.mode == MPEGMode.JOINT_STEREO) {
	                    ms_ener_ratio[gr] = tot_ener[gr][2] + tot_ener[gr][3];
	                    if (ms_ener_ratio[gr] > 0)
	                        ms_ener_ratio[gr] = tot_ener[gr][3] / ms_ener_ratio[gr];
	                }
	
	                /* block type flags */
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    var cod_info = gfc.l3_side.tt[gr][ch];
	                    cod_info.block_type = blocktype[ch];
	                    cod_info.mixed_block_flag = 0;
	                }
	            }
	        } else {
	            /* no psy model */
	            for (gr = 0; gr < gfc.mode_gr; gr++)
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    gfc.l3_side.tt[gr][ch].block_type = Encoder.NORM_TYPE;
	                    gfc.l3_side.tt[gr][ch].mixed_block_flag = 0;
	                    pe_MS[gr][ch] = pe[gr][ch] = 700;
	                }
	        }
	
	        /* auto-adjust of ATH, useful for low volume */
	        adjust_ATH(gfc);
	
	        /****************************************
	         * Stage 2: MDCT *
	         ****************************************/
	
	        /* polyphase filtering / mdct */
	        newMDCT.mdct_sub48(gfc, inbuf[0], inbuf[1]);
	
	        /****************************************
	         * Stage 3: MS/LR decision *
	         ****************************************/
	
	        /* Here will be selected MS or LR coding of the 2 stereo channels */
	        gfc.mode_ext = Encoder.MPG_MD_LR_LR;
	
	        if (gfp.force_ms) {
	            gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	        } else if (gfp.mode == MPEGMode.JOINT_STEREO) {
	            /*
	             * ms_ratio = is scaled, for historical reasons, to look like a
	             * ratio of side_channel / total. 0 = signal is 100% mono .5 = L & R
	             * uncorrelated
	             */
	
	            /**
	             * <PRE>
	             * [0] and [1] are the results for the two granules in MPEG-1,
	             * in MPEG-2 it's only a faked averaging of the same value
	             * _prev is the value of the last granule of the previous frame
	             * _next is the value of the first granule of the next frame
	             * </PRE>
	             */
	
	            var sum_pe_MS = 0.;
	            var sum_pe_LR = 0.;
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    sum_pe_MS += pe_MS[gr][ch];
	                    sum_pe_LR += pe[gr][ch];
	                }
	            }
	
	            /* based on PE: M/S coding would not use much more bits than L/R */
	            if (sum_pe_MS <= 1.00 * sum_pe_LR) {
	
	                var gi0 = gfc.l3_side.tt[0];
	                var gi1 = gfc.l3_side.tt[gfc.mode_gr - 1];
	
	                if (gi0[0].block_type == gi0[1].block_type
	                    && gi1[0].block_type == gi1[1].block_type) {
	
	                    gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	                }
	            }
	        }
	
	        /* bit and noise allocation */
	        if (gfc.mode_ext == MPG_MD_MS_LR) {
	            masking = masking_MS;
	            /* use MS masking */
	            pe_use = pe_MS;
	        } else {
	            masking = masking_LR;
	            /* use LR masking */
	            pe_use = pe;
	        }
	
	        /* copy data for MP3 frame analyzer */
	        if (gfp.analysis && gfc.pinfo != null) {
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    gfc.pinfo.ms_ratio[gr] = gfc.ms_ratio[gr];
	                    gfc.pinfo.ms_ener_ratio[gr] = ms_ener_ratio[gr];
	                    gfc.pinfo.blocktype[gr][ch] = gfc.l3_side.tt[gr][ch].block_type;
	                    gfc.pinfo.pe[gr][ch] = pe_use[gr][ch];
	                    System.arraycopy(gfc.l3_side.tt[gr][ch].xr, 0,
	                        gfc.pinfo.xr[gr][ch], 0, 576);
	                    /*
	                     * in psymodel, LR and MS data was stored in pinfo. switch
	                     * to MS data:
	                     */
	                    if (gfc.mode_ext == MPG_MD_MS_LR) {
	                        gfc.pinfo.ers[gr][ch] = gfc.pinfo.ers[gr][ch + 2];
	                        System.arraycopy(gfc.pinfo.energy[gr][ch + 2], 0,
	                            gfc.pinfo.energy[gr][ch], 0,
	                            gfc.pinfo.energy[gr][ch].length);
	                    }
	                }
	            }
	        }
	
	        /****************************************
	         * Stage 4: quantization loop *
	         ****************************************/
	
	        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr) {
	
	            var i;
	            var f;
	
	            for (i = 0; i < 18; i++)
	                gfc.nsPsy.pefirbuf[i] = gfc.nsPsy.pefirbuf[i + 1];
	
	            f = 0.0;
	            for (gr = 0; gr < gfc.mode_gr; gr++)
	                for (ch = 0; ch < gfc.channels_out; ch++)
	                    f += pe_use[gr][ch];
	            gfc.nsPsy.pefirbuf[18] = f;
	
	            f = gfc.nsPsy.pefirbuf[9];
	            for (i = 0; i < 9; i++)
	                f += (gfc.nsPsy.pefirbuf[i] + gfc.nsPsy.pefirbuf[18 - i])
	                    * Encoder.fircoef[i];
	
	            f = (670 * 5 * gfc.mode_gr * gfc.channels_out) / f;
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    pe_use[gr][ch] *= f;
	                }
	            }
	        }
	        gfc.iteration_loop.iteration_loop(gfp, pe_use, ms_ener_ratio, masking);
	
	        /****************************************
	         * Stage 5: bitstream formatting *
	         ****************************************/
	
	        /* write the frame to the bitstream */
	        bs.format_bitstream(gfp);
	
	        /* copy mp3 bit buffer into array */
	        mp3count = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 1);
	
	        if (gfp.bWriteVbrTag)
	            vbr.addVbrFrame(gfp);
	
	        if (gfp.analysis && gfc.pinfo != null) {
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                var j;
	                for (j = 0; j < FFTOFFSET; j++)
	                    gfc.pinfo.pcmdata[ch][j] = gfc.pinfo.pcmdata[ch][j
	                    + gfp.framesize];
	                for (j = FFTOFFSET; j < 1600; j++) {
	                    gfc.pinfo.pcmdata[ch][j] = inbuf[ch][j - FFTOFFSET];
	                }
	            }
	            qupvt.set_frame_pinfo(gfp, masking);
	        }
	
	        updateStats(gfc);
	
	        return mp3count;
	    }
	}
	
	
	module.exports = Encoder;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(427);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(429);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(432);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(430);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(431);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(428);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(199);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(216);


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// There are three possible states for our login
	// process and we need actions for each of them
	var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
	var LOGIN_REFRESH = exports.LOGIN_REFRESH = 'LOGIN_REFRESH';
	var HAS_LOGGED_IN = exports.HAS_LOGGED_IN = 'HAS_LOGGED_IN';
	
	var REGISTRATION_REQUEST = exports.REGISTRATION_REQUEST = 'REGISTRATION_REQUEST';
	var REGISTRATION_SUCCESS = exports.REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
	var REGISTRATION_FAILURE = exports.REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
	
	var SINGLE_REGISTRATION_REQUEST = exports.SINGLE_REGISTRATION_REQUEST = 'SINGLE_REGISTRATION_REQUEST';
	var SINGLE_REGISTRATION_SUCCESS = exports.SINGLE_REGISTRATION_SUCCESS = 'SINGLE_REGISTRATION_SUCCESS';
	var SINGLE_REGISTRATION_FAILURE = exports.SINGLE_REGISTRATION_FAILURE = 'SINGLE_REGISTRATION_FAILURE';
	
	var SINGLE_FREE_REGISTRATION_REQUEST = exports.SINGLE_FREE_REGISTRATION_REQUEST = 'SINGLE_FREE_REGISTRATION_REQUEST';
	var SINGLE_FREE_REGISTRATION_SUCCESS = exports.SINGLE_FREE_REGISTRATION_SUCCESS = 'SINGLE_FREE_REGISTRATION_SUCCESS';
	var SINGLE_FREE_REGISTRATION_FAILURE = exports.SINGLE_FREE_REGISTRATION_FAILURE = 'SINGLE_FREE_REGISTRATION_FAILURE';
	
	var VALIDATE_TRIAL_TOKEN_REQUEST = exports.VALIDATE_TRIAL_TOKEN_REQUEST = 'VALIDATE_TRIAL_TOKEN_REQUEST';
	var VALIDATE_TRIAL_TOKEN_SUCCESS = exports.VALIDATE_TRIAL_TOKEN_SUCCESS = 'VALIDATE_TRIAL_TOKEN_SUCCESS';
	var VALIDATE_TRIAL_TOKEN_FAILURE = exports.VALIDATE_TRIAL_TOKEN_FAILURE = 'VALIDATE_TRIAL_TOKEN_FAILURE';
	
	var TRIAL_REGISTRATION_REQUEST = exports.TRIAL_REGISTRATION_REQUEST = 'TRIAL_REGISTRATION_REQUEST';
	var TRIAL_REGISTRATION_SUCCESS = exports.TRIAL_REGISTRATION_SUCCESS = 'TRIAL_REGISTRATION_SUCCESS';
	var TRIAL_REGISTRATION_FAILURE = exports.TRIAL_REGISTRATION_FAILURE = 'TRIAL_REGISTRATION_FAILURE';
	
	var LOGOUT_REQUEST = exports.LOGOUT_REQUEST = 'LOGOUT_REQUEST';
	var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
	var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = 'LOGOUT_FAILURE';
	
	var PASSWORD_EMAIL_REQUEST = exports.PASSWORD_EMAIL_REQUEST = 'PASSWORD_EMAIL_REQUEST';
	var PASSWORD_EMAIL_SUCCESS = exports.PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
	var PASSWORD_EMAIL_FAILURE = exports.PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
	var PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
	var PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
	var PASSWORD_RESET_FAILURE = exports.PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
	
	var EXERCISE_REQUEST = exports.EXERCISE_REQUEST = 'EXERCISE_REQUEST';
	var EXERCISE_SUCCESS = exports.EXERCISE_SUCCESS = 'EXERCISE_SUCCESS';
	var EXERCISE_FAILURE = exports.EXERCISE_FAILURE = 'EXERCISE_FAILURE';
	var EXERCISE_CREATE_REQUEST = exports.EXERCISE_CREATE_REQUEST = 'EXERCISE_CREATE_REQUEST';
	var EXERCISE_CREATE_SUCCESS = exports.EXERCISE_CREATE_SUCCESS = 'EXERCISE_CREATE_SUCCESS';
	var EXERCISE_CREATE_FAILURE = exports.EXERCISE_CREATE_FAILURE = 'EXERCISE_CREATE_FAILURE';
	var EXERCISE_UPDATE_REQUEST = exports.EXERCISE_UPDATE_REQUEST = 'EXERCISE_UPDATE_REQUEST';
	var EXERCISE_UPDATE_SUCCESS = exports.EXERCISE_UPDATE_SUCCESS = 'EXERCISE_UPDATE_SUCCESS';
	var EXERCISE_UPDATE_FAILURE = exports.EXERCISE_UPDATE_FAILURE = 'EXERCISE_UPDATE_FAILURE';
	var EXERCISE_DELETE_REQUEST = exports.EXERCISE_DELETE_REQUEST = 'EXERCISE_DELETE_REQUEST';
	var EXERCISE_DELETE_SUCCESS = exports.EXERCISE_DELETE_SUCCESS = 'EXERCISE_DELETE_SUCCESS';
	var EXERCISE_DELETE_FAILURE = exports.EXERCISE_DELETE_FAILURE = 'EXERCISE_DELETE_FAILURE';
	
	var LAUNCH_EXERCISE = exports.LAUNCH_EXERCISE = 'LAUNCH_EXERCISE';
	var CLEAR_EXERCISE = exports.CLEAR_EXERCISE = 'CLEAR_EXERCISE';
	
	var LAUNCH_TEXT = exports.LAUNCH_TEXT = 'LAUNCH_TEXT';
	var SELECT_TEXT = exports.SELECT_TEXT = 'SELECT_TEXT';
	var CLEAR_TEXT = exports.CLEAR_TEXT = 'CLEAR_TEXT';
	var UPDATE_SOURCE = exports.UPDATE_SOURCE = 'UPDATE_SOURCE';
	var UPDATE_TRANSLATION = exports.UPDATE_TRANSLATION = 'UPDATE_TRANSLATION';
	var PREV_SENTENCE = exports.PREV_SENTENCE = 'PREV_SENTENCE';
	var NEXT_SENTENCE = exports.NEXT_SENTENCE = 'NEXT_SENTENCE';
	var SPLICE_SENTENCE = exports.SPLICE_SENTENCE = 'SPLICE_SENTENCE';
	var SET_UTTERANCE_LENGTH = exports.SET_UTTERANCE_LENGTH = 'SET_UTTERANCE_LENGTH';
	var SET_RECORDING = exports.SET_RECORDING = 'SET_RECORDING';
	var ADD_RESULTS = exports.ADD_RESULTS = 'ADD_RESULTS';
	
	var ADD_HISTORY = exports.ADD_HISTORY = 'ADD_HISTORY';
	var HISTORY_REPORT_REQUEST = exports.HISTORY_REPORT_REQUEST = 'HISTORY_REPORT_REQUEST';
	var HISTORY_REPORT_SUCCESS = exports.HISTORY_REPORT_SUCCESS = 'HISTORY_REPORT_SUCCESS';
	var HISTORY_REPORT_FAILURE = exports.HISTORY_REPORT_FAILURE = 'HISTORY_REPORT_FAILURE';
	
	var CHANGE_SETTINGS_REQUEST = exports.CHANGE_SETTINGS_REQUEST = 'CHANGE_SETTINGS_REQUEST';
	var CHANGE_SETTINGS_SUCCESS = exports.CHANGE_SETTINGS_SUCCESS = 'CHANGE_SETTINGS_SUCCESS';
	var CHANGE_SETTINGS_FAILURE = exports.CHANGE_SETTINGS_FAILURE = 'CHANGE_SETTINGS_FAILURE';
	
	var CHANGE_PASSWORD_REQUEST = exports.CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
	var CHANGE_PASSWORD_SUCCESS = exports.CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
	var CHANGE_PASSWORD_FAILURE = exports.CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
	var VALIDATE_TOKEN_REQUEST = exports.VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST';
	var VALIDATE_TOKEN_SUCCESS = exports.VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
	var VALIDATE_TOKEN_FAILURE = exports.VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';
	
	var VALIDATE_EMAIL_REQUEST = exports.VALIDATE_EMAIL_REQUEST = 'VALIDATE_EMAIL_REQUEST';
	var VALIDATE_EMAIL_SUCCESS = exports.VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
	var VALIDATE_EMAIL_FAILURE = exports.VALIDATE_EMAIL_FAILURE = 'VALIDATE_EMAIL_FAILURE';
	
	var JOIN_GROUP_REQUEST = exports.JOIN_GROUP_REQUEST = 'JOIN_GROUP_REQUEST';
	var JOIN_GROUP_SUCCESS = exports.JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
	var JOIN_GROUP_FAILURE = exports.JOIN_GROUP_FAILURE = 'JOIN_GROUP_FAILURE';
	
	var GROUP_REQUEST = exports.GROUP_REQUEST = 'GROUP_REQUEST';
	var GROUP_SUCCESS = exports.GROUP_SUCCESS = 'GROUP_SUCCESS';
	var GROUP_FAILURE = exports.GROUP_FAILURE = 'GROUP_FAILURE';
	var GROUP_UPDATE_REQUEST = exports.GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
	var GROUP_UPDATE_SUCCESS = exports.GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
	var GROUP_UPDATE_FAILURE = exports.GROUP_UPDATE_FAILURE = 'GROUP_UPDATE_FAILURE';
	var GROUP_TOKEN_REFRESH_REQUEST = exports.GROUP_TOKEN_REFRESH_REQUEST = 'GROUP_TOKEN_REFRESH_REQUEST';
	var GROUP_TOKEN_REFRESH_SUCCESS = exports.GROUP_TOKEN_REFRESH_SUCCESS = 'GROUP_TOKEN_REFRESH_SUCCESS';
	var GROUP_TOKEN_REFRESH_FAILURE = exports.GROUP_TOKEN_REFRESH_FAILURE = 'GROUP_TOKEN_REFRESH_FAILURE';
	var GROUP_USERS_REQUEST = exports.GROUP_USERS_REQUEST = 'GROUP_USERS_REQUEST';
	var GROUP_USERS_SUCCESS = exports.GROUP_USERS_SUCCESS = 'GROUP_USERS_SUCCESS';
	var GROUP_USERS_FAILURE = exports.GROUP_USERS_FAILURE = 'GROUP_USERS_FAILURE';
	
	var GROUP_USER_UPDATE_REQUEST = exports.GROUP_USER_UPDATE_REQUEST = 'GROUP_USER_UPDATE_REQUEST';
	var GROUP_USER_UPDATE_SUCCESS = exports.GROUP_USER_UPDATE_SUCCESS = 'GROUP_USER_UPDATE_SUCCESS';
	var GROUP_USER_UPDATE_FAILURE = exports.GROUP_USER_UPDATE_FAILURE = 'GROUP_USER_UPDATE_FAILURE';
	var GROUP_USER_REMOVE_REQUEST = exports.GROUP_USER_REMOVE_REQUEST = 'GROUP_USER_REMOVE_REQUEST';
	var GROUP_USER_REMOVE_SUCCESS = exports.GROUP_USER_REMOVE_SUCCESS = 'GROUP_USER_REMOVE_SUCCESS';
	var GROUP_USER_REMOVE_FAILURE = exports.GROUP_USER_REMOVE_FAILURE = 'GROUP_USER_REMOVE_FAILURE';
	var GROUP_SEND_INVITATION_REQUEST = exports.GROUP_SEND_INVITATION_REQUEST = 'GROUP_SEND_INVITATION_REQUEST';
	var GROUP_SEND_INVITATION_SUCCESS = exports.GROUP_SEND_INVITATION_SUCCESS = 'GROUP_SEND_INVITATION_SUCCESS';
	var GROUP_SEND_INVITATION_FAILURE = exports.GROUP_SEND_INVITATION_FAILURE = 'GROUP_SEND_INVITATION_FAILURE';
	
	// Payment integration
	//
	
	var PLAN_REQUEST = exports.PLAN_REQUEST = 'PLAN_REQUEST';
	var PLAN_SUCCESS = exports.PLAN_SUCCESS = 'PLAN_SUCCESS';
	var PLAN_FAILURE = exports.PLAN_FAILURE = 'PLAN_FAILURE';
	
	var CREATE_SUBSCRIPTION_REQUEST = exports.CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST';
	var CREATE_SUBSCRIPTION_SUCCESS = exports.CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
	var CREATE_SUBSCRIPTION_FAILURE = exports.CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';
	
	var RESUME_SUBSCRIPTION_REQUEST = exports.RESUME_SUBSCRIPTION_REQUEST = 'RESUME_SUBSCRIPTION_REQUEST';
	var RESUME_SUBSCRIPTION_SUCCESS = exports.RESUME_SUBSCRIPTION_SUCCESS = 'RESUME_SUBSCRIPTION_SUCCESS';
	var RESUME_SUBSCRIPTION_FAILURE = exports.RESUME_SUBSCRIPTION_FAILURE = 'RESUME_SUBSCRIPTION_FAILURE';
	
	var SUBSCRIPTIONS_REQUEST = exports.SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST';
	var SUBSCRIPTIONS_SUCCESS = exports.SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTIONS_SUCCESS';
	var SUBSCRIPTIONS_FAILURE = exports.SUBSCRIPTIONS_FAILURE = 'SUBSCRIPTIONS_FAILURE';
	
	var INVOICES_REQUEST = exports.INVOICES_REQUEST = 'INVOICES_REQUEST';
	var INVOICES_SUCCESS = exports.INVOICES_SUCCESS = 'INVOICES_SUCCESS';
	var INVOICES_FAILURE = exports.INVOICES_FAILURE = 'INVOICES_FAILURE';
	
	var UPDATE_CARD_REQUEST = exports.UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST';
	var UPDATE_CARD_SUCCESS = exports.UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS';
	var UPDATE_CARD_FAILURE = exports.UPDATE_CARD_FAILURE = 'UPDATE_CARD_FAILURE';
	
	var CLAIM_COUPON_REQUEST = exports.CLAIM_COUPON_REQUEST = 'CLAIM_COUPON_REQUEST';
	var CLAIM_COUPON_SUCCESS = exports.CLAIM_COUPON_SUCCESS = 'CLAIM_COUPON_SUCCESS';
	var CLAIM_COUPON_FAILURE = exports.CLAIM_COUPON_FAILURE = 'CLAIM_COUPON_FAILURE';
	
	var CANCEL_SUBSCRIPTION_REQUEST = exports.CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
	var CANCEL_SUBSCRIPTION_SUCCESS = exports.CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
	var CANCEL_SUBSCRIPTION_FAILURE = exports.CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE';
	
	var GET_INVOICE_REQUEST = exports.GET_INVOICE_REQUEST = 'GET_INVOICE_REQUEST';
	var GET_INVOICE_SUCCESS = exports.GET_INVOICE_SUCCESS = 'GET_INVOICE_SUCCESS';
	var GET_INVOICE_FAILURE = exports.GET_INVOICE_FAILURE = 'GET_INVOICE_FAILURE';

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(470);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 29 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(435);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(451);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint no-restricted-syntax: "off", guard-for-in: "off" */
	
	exports.default = function (errors) {
	  var errorMessages = [];
	  var validationErrors = [];
	  var stripeErrors = [];
	  var stripeConnectionErrors = [];
	
	  // typeof only detects primitive strings. Strings created as a String object will typeof as objects. The latter check
	  // will catch those.
	  if (!Array.isArray(errors) && (typeof errors === 'string' || (typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) === 'object')) {
	    if (errors === 'Failed to fetch' || errors.message == 'Failed to fetch') {
	      errorMessages.push('Network error - cannot reach the server. Please check your connection and try again.');
	    } else {
	      errorMessages.push(errors);
	    }
	  }
	
	  if (Array.isArray(errors)) {
	    errors.forEach(function (error) {
	      if (typeof error.message === 'string') {
	        if (error.message === 'Failed to fetch') {
	          errorMessages.push('Network error - cannot reach the server. Please check your connection and try again.');
	        } else if (error.code === 'stripe_error') {
	          stripeErrors.push(error.message);
	        } else if (error.code === 'stripe_connection_error') {
	          stripeConnectionErrors.push(error.message);
	        } else {
	          errorMessages.push(error.message);
	        }
	      } else if (_typeof(error.message) === 'object') {
	        for (var message in error.message) {
	          if (typeof error.message[message] === 'string') {
	            if (error.message[message] === 'Failed to fetch') {
	              errorMessages.push('Network error - cannot reach the server. Please try again soon.');
	            } else {
	              errorMessages.push(error.message[message]);
	            }
	          } else if (error.code === 'validation_error' && _typeof(error.message[message]) === 'object') {
	            validationErrors[message] = [];
	
	            for (var detailedMessage in error.message[message]) {
	              validationErrors[message][detailedMessage] = error.message[message][detailedMessage];
	            }
	          } else if (error.code === 'stripe_error' && _typeof(error.message[message]) === 'object') {
	            stripeErrors[message] = [];
	
	            for (var _detailedMessage in error.message[message]) {
	              stripeErrors[message][_detailedMessage] = error.message[message][_detailedMessage];
	            }
	          } else if (error.code === 'stripe_connection_error' && _typeof(error.message[message]) === 'object') {
	            stripeConnectionErrors[message] = [];
	
	            for (var _detailedMessage2 in error.message[message]) {
	              stripeConnectionErrors[message][_detailedMessage2] = error.message[message][_detailedMessage2];
	            }
	          }
	        }
	      }
	    });
	  }
	
	  return {
	    errorMessages: errorMessages,
	    validationErrors: validationErrors,
	    stripeErrors: stripeErrors,
	    stripeConnectionErrors: stripeConnectionErrors
	  };
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(434);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 35 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _request_empty$creden;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_request_empty$creden = {
	  request_empty: 'The HTTP request was empty. If you have a flaky connection, please try again in a moment',
	  credentials_not_found: 'Please check your email or password',
	  admin_login_not_permitted: 'This app is only for regular users - admins please log in from the main site'
	}, _defineProperty(_request_empty$creden, 'request_empty', 'Request was empty - this is probably a bug. Please notify someone.'), _defineProperty(_request_empty$creden, 'validation_error', 'Please correct form input'), _defineProperty(_request_empty$creden, 'update_error', 'Could not save update'), _defineProperty(_request_empty$creden, 'wrong_password', 'Wrong password'), _defineProperty(_request_empty$creden, 'unauthorized_request', 'You are not authorized to do this'), _defineProperty(_request_empty$creden, 'password_email_error', 'Could not send the password email'), _defineProperty(_request_empty$creden, 'password_reset_error', 'Could not reset your password'), _defineProperty(_request_empty$creden, 'password_must_match_confirmation', 'Password and confirmation do not match'), _defineProperty(_request_empty$creden, 'oldpassword_too_short', 'Old password is too short - please check it'), _defineProperty(_request_empty$creden, 'email_does_not_exist_in_database', 'Please check your email'), _defineProperty(_request_empty$creden, 'email_already_exists', 'This email is already registered'), _defineProperty(_request_empty$creden, 'invalid_email_address', 'Please check your email - invalid address'), _defineProperty(_request_empty$creden, 'validation.email_exists', 'This email is not registered here'), _defineProperty(_request_empty$creden, 'stripe_connection_error', 'We are having trouble connecting with our payment processor - please try again'), _request_empty$creden);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(114)('wks');
	var uid = __webpack_require__(83);
	var Symbol = __webpack_require__(45).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(130);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(214);
	var PooledClass = __webpack_require__(54);
	var ReactFeatureFlags = __webpack_require__(220);
	var ReactReconciler = __webpack_require__(68);
	var Transaction = __webpack_require__(96);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(443);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(54);
	
	var emptyFunction = __webpack_require__(26);
	var warning = __webpack_require__(11);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactChildren = __webpack_require__(695);
	var ReactComponent = __webpack_require__(157);
	var ReactPureComponent = __webpack_require__(700);
	var ReactClass = __webpack_require__(696);
	var ReactDOMFactories = __webpack_require__(697);
	var ReactElement = __webpack_require__(70);
	var ReactPropTypes = __webpack_require__(698);
	var ReactVersion = __webpack_require__(704);
	
	var onlyChild = __webpack_require__(257);
	var warning = __webpack_require__(11);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(45);
	var core = __webpack_require__(29);
	var ctx = __webpack_require__(106);
	var hide = __webpack_require__(58);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 45 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(56);
	var IE8_DOM_DEFINE = __webpack_require__(169);
	var toPrimitive = __webpack_require__(116);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 47 */
/***/ function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports['default'] = /*istanbul ignore end*/Diff;
	function Diff() {}
	
	Diff.prototype = { /*istanbul ignore start*/
	  /*istanbul ignore end*/diff: function diff(oldString, newString) {
	    /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    var callback = options.callback;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    this.options = options;
	
	    var self = this;
	
	    function done(value) {
	      if (callback) {
	        setTimeout(function () {
	          callback(undefined, value);
	        }, 0);
	        return true;
	      } else {
	        return value;
	      }
	    }
	
	    // Allow subclasses to massage the input prior to running
	    oldString = this.castInput(oldString);
	    newString = this.castInput(newString);
	
	    oldString = this.removeEmpty(this.tokenize(oldString));
	    newString = this.removeEmpty(this.tokenize(newString));
	
	    var newLen = newString.length,
	        oldLen = oldString.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{ newPos: -1, components: [] }];
	
	    // Seed editLength = 0, i.e. the content starts with the same values
	    var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      // Identity per the equality and tokenizer
	      return done([{ value: this.join(newString), count: newString.length }]);
	    }
	
	    // Main worker method. checks all permutations of a given edit length for acceptance.
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	        var addPath = bestPath[diagonalPath - 1],
	            removePath = bestPath[diagonalPath + 1],
	            _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen,
	            canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        }
	
	        // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath);
	
	        // If we have hit the end of both strings, then we are done
	        if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) {
	          return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    // Performs the length of edit iteration. Is a bit fugly as this has to support the
	    // sync and async mode which is never fun. Loops over execEditLength until a value
	    // is produced.
	    if (callback) {
	      (function exec() {
	        setTimeout(function () {
	          // This should not happen, but we want to be safe.
	          /* istanbul ignore next */
	          if (editLength > maxEditLength) {
	            return callback();
	          }
	
	          if (!execEditLength()) {
	            exec();
	          }
	        }, 0);
	      })();
	    } else {
	      while (editLength <= maxEditLength) {
	        var ret = execEditLength();
	        if (ret) {
	          return ret;
	        }
	      }
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/pushComponent: function pushComponent(components, added, removed) {
	    var last = components[components.length - 1];
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = { count: last.count + 1, added: added, removed: removed };
	    } else {
	      components.push({ count: 1, added: added, removed: removed });
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
	    var newLen = newString.length,
	        oldLen = oldString.length,
	        newPos = basePath.newPos,
	        oldPos = newPos - diagonalPath,
	        commonCount = 0;
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({ count: commonCount });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/equals: function equals(left, right) {
	    return left === right;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/removeEmpty: function removeEmpty(array) {
	    var ret = [];
	    for (var i = 0; i < array.length; i++) {
	      if (array[i]) {
	        ret.push(array[i]);
	      }
	    }
	    return ret;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/castInput: function castInput(value) {
	    return value;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/tokenize: function tokenize(value) {
	    return value.split('');
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/join: function join(chars) {
	    return chars.join('');
	  }
	};
	
	function buildValues(diff, components, newString, oldString, useLongestToken) {
	  var componentPos = 0,
	      componentLen = components.length,
	      newPos = 0,
	      oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	    if (!component.removed) {
	      if (!component.added && useLongestToken) {
	        var value = newString.slice(newPos, newPos + component.count);
	        value = value.map(function (value, i) {
	          var oldValue = oldString[oldPos + i];
	          return oldValue.length > value.length ? oldValue : value;
	        });
	
	        component.value = diff.join(value);
	      } else {
	        component.value = diff.join(newString.slice(newPos, newPos + component.count));
	      }
	      newPos += component.count;
	
	      // Common case
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
	      oldPos += component.count;
	
	      // Reverse add and remove so removes are output first to match common convention
	      // The diffing algorithm is tied to add then remove output and this is the simplest
	      // route to get the desired output with minimal overhead.
	      if (componentPos && components[componentPos - 1].added) {
	        var tmp = components[componentPos - 1];
	        components[componentPos - 1] = components[componentPos];
	        components[componentPos] = tmp;
	      }
	    }
	  }
	
	  // Special case handle for when one terminal is ignored. For this case we merge the
	  // terminal into the prior string and drop the change.
	  var lastComponent = components[componentLen - 1];
	  if (componentLen > 1 && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
	    components[componentLen - 2].value += lastComponent.value;
	    components.pop();
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return { newPos: path.newPos, components: path.components.slice(0) };
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(448);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Broadcasts = __webpack_require__(100);
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) && isLeftClickEvent(event)) {
	        event.preventDefault();
	        _this.handleTransition();
	      }
	    }, _this.handleTransition = function () {
	      var router = _this.context.router;
	      var _this$props = _this.props,
	          to = _this$props.to,
	          replace = _this$props.replace;
	
	      var navigate = replace ? router.replaceWith : router.transitionTo;
	      navigate(to);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _this2 = this;
	
	    var router = this.context.router;
	
	    var _props = this.props,
	        to = _props.to,
	        style = _props.style,
	        activeStyle = _props.activeStyle,
	        className = _props.className,
	        activeClassName = _props.activeClassName,
	        getIsActive = _props.isActive,
	        activeOnlyWhenExact = _props.activeOnlyWhenExact,
	        replace = _props.replace,
	        children = _props.children,
	        rest = _objectWithoutProperties(_props, ['to', 'style', 'activeStyle', 'className', 'activeClassName', 'isActive', 'activeOnlyWhenExact', 'replace', 'children']);
	
	    return _react2.default.createElement(
	      _Broadcasts.LocationSubscriber,
	      null,
	      function (location) {
	        var isActive = getIsActive(location, createLocationDescriptor(to), _this2.props);
	
	        // If children is a function, we are using a Function as Children Component
	        // so useful values will be passed down to the children function.
	        if (typeof children == 'function') {
	          return children({
	            isActive: isActive,
	            location: location,
	            href: router ? router.createHref(to) : to,
	            onClick: _this2.handleClick,
	            transition: _this2.handleTransition
	          });
	        }
	
	        // Maybe we should use <Match> here? Not sure how the custom `isActive`
	        // prop would shake out, also, this check happens a LOT so maybe its good
	        // to optimize here w/ a faster isActive check, so we'd need to benchmark
	        // any attempt at changing to use <Match>
	        return _react2.default.createElement('a', _extends({}, rest, {
	          href: router ? router.createHref(to) : to,
	          onClick: _this2.handleClick,
	          style: isActive ? _extends({}, style, activeStyle) : style,
	          className: isActive ? [className, activeClassName].join(' ').trim() : className,
	          children: children
	        }));
	      }
	    );
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.defaultProps = {
	  replace: false,
	  activeOnlyWhenExact: false,
	  className: '',
	  activeClassName: '',
	  style: {},
	  activeStyle: {},
	  isActive: function isActive(location, to, props) {
	    return pathIsActive(to.pathname, location.pathname, props.activeOnlyWhenExact) && queryIsActive(to.query, location.query);
	  }
	};
	Link.contextTypes = {
	  router: _PropTypes.routerContext.isRequired
	};
	
	
	if (false) {
	  Link.propTypes = {
	    to: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	    replace: _react.PropTypes.bool,
	    activeStyle: _react.PropTypes.object,
	    activeClassName: _react.PropTypes.string,
	    activeOnlyWhenExact: _react.PropTypes.bool,
	    isActive: _react.PropTypes.func,
	    children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
	
	    // props we have to deal with but aren't necessarily
	    // part of the Link API
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    target: _react.PropTypes.string,
	    onClick: _react.PropTypes.func
	  };
	}
	
	// we should probably use LocationUtils.createLocationDescriptor
	var createLocationDescriptor = function createLocationDescriptor(to) {
	  return (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to : { pathname: to };
	};
	
	var pathIsActive = function pathIsActive(to, pathname, activeOnlyWhenExact) {
	  return activeOnlyWhenExact ? pathname === to : pathname.indexOf(to) === 0;
	};
	
	var queryIsActive = function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	};
	
	var isLeftClickEvent = function isLeftClickEvent(event) {
	  return event.button === 0;
	};
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	var deepEqual = function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	};
	
	exports.default = Link;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(57)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 52 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(79);
	
	var _events = __webpack_require__(91);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(132);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(205);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.refs.enhancedButton.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.focusTimeout);
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null,
	        zIndex: 1 }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: 'enhancedButton',
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	} : void 0;
	exports.default = EnhancedButton;

/***/ },
/* 54 */
[723, 12],
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(78);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(46);
	var createDesc = __webpack_require__(75);
	module.exports = __webpack_require__(51) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(170);
	var defined = __webpack_require__(107);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 61 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(452);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(138);
	var setInnerHTML = __webpack_require__(98);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(146);
	var setTextContent = __webpack_require__(232);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var EventPluginRegistry = __webpack_require__(139);
	var EventPluginUtils = __webpack_require__(93);
	var ReactErrorUtils = __webpack_require__(143);
	
	var accumulateInto = __webpack_require__(225);
	var forEachAccumulated = __webpack_require__(226);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(66);
	var EventPluginUtils = __webpack_require__(93);
	
	var accumulateInto = __webpack_require__(225);
	var forEachAccumulated = __webpack_require__(226);
	var warning = __webpack_require__(11);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(564);
	var ReactInstrumentation = __webpack_require__(34);
	
	var warning = __webpack_require__(11);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	var getEventTarget = __webpack_require__(149);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(43);
	
	var warning = __webpack_require__(11);
	var canDefineProperty = __webpack_require__(255);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(253);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 71 */
12,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(270);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(269);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(175);
	var enumBugKeys = __webpack_require__(108);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(107);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(524);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerContext = exports.historyContext = exports.location = exports.history = exports.matchContext = exports.action = undefined;
	
	var _react = __webpack_require__(1);
	
	var action = exports.action = _react.PropTypes.oneOf(['PUSH', 'REPLACE', 'POP']);
	
	var matchContext = exports.matchContext = _react.PropTypes.shape({
	  addMatch: _react.PropTypes.func.isRequired,
	  removeMatch: _react.PropTypes.func.isRequired
	});
	
	var history = exports.history = _react.PropTypes.shape({
	  listen: _react.PropTypes.func.isRequired,
	  listenBefore: _react.PropTypes.func.isRequired,
	  push: _react.PropTypes.func.isRequired,
	  replace: _react.PropTypes.func.isRequired,
	  go: _react.PropTypes.func.isRequired
	});
	
	var location = exports.location = _react.PropTypes.shape({
	  pathname: _react.PropTypes.string.isRequired,
	  search: _react.PropTypes.string.isRequired,
	  hash: _react.PropTypes.string.isRequired,
	  state: _react.PropTypes.any,
	  key: _react.PropTypes.string
	});
	
	var historyContext = exports.historyContext = _react.PropTypes.shape({
	  action: action.isRequired,
	  location: location.isRequired,
	  push: _react.PropTypes.func.isRequired,
	  replace: _react.PropTypes.func.isRequired,
	  go: _react.PropTypes.func.isRequired,
	  goBack: _react.PropTypes.func.isRequired,
	  goForward: _react.PropTypes.func.isRequired,
	  canGo: _react.PropTypes.func,
	  block: _react.PropTypes.func.isRequired
	});
	
	var routerContext = exports.routerContext = _react.PropTypes.shape({
	  transitionTo: _react.PropTypes.func.isRequired,
	  replaceWith: _react.PropTypes.func.isRequired,
	  blockTransitions: _react.PropTypes.func.isRequired,
	  createHref: _react.PropTypes.func.isRequired
	});

/***/ },
/* 82 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 83 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var Encoder = __webpack_require__(21);
	
	var L3Side = {};
	
	
		/**
		 * max scalefactor band, max(SBMAX_l, SBMAX_s*3, (SBMAX_s-3)*3+8)
		 */
	L3Side.SFBMAX = (Encoder.SBMAX_s * 3);
	
	module.exports = L3Side;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var IIISideInfo = __webpack_require__(398);
	var ScaleFac = __webpack_require__(196);
	var NsPsy = __webpack_require__(403);
	var VBRSeekInfo = __webpack_require__(410);
	var III_psy_xmin = __webpack_require__(192);
	var Encoder = __webpack_require__(21);
	var L3Side = __webpack_require__(86);
	
	
	LameInternalFlags.MFSIZE = (3 * 1152 + Encoder.ENCDELAY - Encoder.MDCTDELAY);
	LameInternalFlags.MAX_HEADER_BUF = 256;
	LameInternalFlags.MAX_BITS_PER_CHANNEL = 4095;
	LameInternalFlags.MAX_BITS_PER_GRANULE = 7680;
	LameInternalFlags.BPC = 320;
	
	function LameInternalFlags() {
	    var MAX_HEADER_LEN = 40;
	
	
	    /********************************************************************
	     * internal variables NOT set by calling program, and should not be *
	     * modified by the calling program *
	     ********************************************************************/
	
	    /**
	     * Some remarks to the Class_ID field: The Class ID is an Identifier for a
	     * pointer to this struct. It is very unlikely that a pointer to
	     * lame_global_flags has the same 32 bits in it's structure (large and other
	     * special properties, for instance prime).
	     *
	     * To test that the structure is right and initialized, use: if ( gfc .
	     * Class_ID == LAME_ID ) ... Other remark: If you set a flag to 0 for uninit
	     * data and 1 for init data, the right test should be "if (flag == 1)" and
	     * NOT "if (flag)". Unintended modification of this element will be
	     * otherwise misinterpreted as an init.
	     */
	    this.Class_ID = 0;
	
	    this.lame_encode_frame_init = 0;
	    this.iteration_init_init = 0;
	    this.fill_buffer_resample_init = 0;
	
	    //public float mfbuf[][] = new float[2][MFSIZE];
	    this.mfbuf = new_float_n([2, LameInternalFlags.MFSIZE]);
	
	    /**
	     * granules per frame
	     */
	    this.mode_gr = 0;
	    /**
	     * number of channels in the input data stream (PCM or decoded PCM)
	     */
	    this.channels_in = 0;
	    /**
	     * number of channels in the output data stream (not used for decoding)
	     */
	    this.channels_out = 0;
	    /**
	     * input_samp_rate/output_samp_rate
	     */
	        //public double resample_ratio;
	    this.resample_ratio = 0.;
	
	    this.mf_samples_to_encode = 0;
	    this.mf_size = 0;
	    /**
	     * min bitrate index
	     */
	    this.VBR_min_bitrate = 0;
	    /**
	     * max bitrate index
	     */
	    this.VBR_max_bitrate = 0;
	    this.bitrate_index = 0;
	    this.samplerate_index = 0;
	    this.mode_ext = 0;
	
	    /* lowpass and highpass filter control */
	    /**
	     * normalized frequency bounds of passband
	     */
	    this.lowpass1 = 0.;
	    this.lowpass2 = 0.;
	    /**
	     * normalized frequency bounds of passband
	     */
	    this.highpass1 = 0.;
	    this.highpass2 = 0.;
	
	    /**
	     * 0 = none 1 = ISO AAC model 2 = allow scalefac_select=1
	     */
	    this.noise_shaping = 0;
	
	    /**
	     * 0 = ISO model: amplify all distorted bands<BR>
	     * 1 = amplify within 50% of max (on db scale)<BR>
	     * 2 = amplify only most distorted band<BR>
	     * 3 = method 1 and refine with method 2<BR>
	     */
	    this.noise_shaping_amp = 0;
	    /**
	     * 0 = no substep<BR>
	     * 1 = use substep shaping at last step(VBR only)<BR>
	     * (not implemented yet)<BR>
	     * 2 = use substep inside loop<BR>
	     * 3 = use substep inside loop and last step<BR>
	     */
	    this.substep_shaping = 0;
	
	    /**
	     * 1 = gpsycho. 0 = none
	     */
	    this.psymodel = 0;
	    /**
	     * 0 = stop at over=0, all scalefacs amplified or<BR>
	     * a scalefac has reached max value<BR>
	     * 1 = stop when all scalefacs amplified or a scalefac has reached max value<BR>
	     * 2 = stop when all scalefacs amplified
	     */
	    this.noise_shaping_stop = 0;
	
	    /**
	     * 0 = no, 1 = yes
	     */
	    this.subblock_gain = 0;
	    /**
	     * 0 = no. 1=outside loop 2=inside loop(slow)
	     */
	    this.use_best_huffman = 0;
	
	    /**
	     * 0 = stop early after 0 distortion found. 1 = full search
	     */
	    this.full_outer_loop = 0;
	
	    //public IIISideInfo l3_side = new IIISideInfo();
	    this.l3_side = new IIISideInfo();
	    this.ms_ratio = new_float(2);
	
	    /* used for padding */
	    /**
	     * padding for the current frame?
	     */
	    this.padding = 0;
	    this.frac_SpF = 0;
	    this.slot_lag = 0;
	
	    /**
	     * optional ID3 tags
	     */
	        //public ID3TagSpec tag_spec;
	    this.tag_spec = null;
	    this.nMusicCRC = 0;
	
	    /* variables used by Quantize */
	    //public int OldValue[] = new int[2];
	    this.OldValue = new_int(2);
	    //public int CurrentStep[] = new int[2];
	    this.CurrentStep = new_int(2);
	
	    this.masking_lower = 0.;
	    //public int bv_scf[] = new int[576];
	    this.bv_scf = new_int(576);
	    //public int pseudohalf[] = new int[L3Side.SFBMAX];
	    this.pseudohalf = new_int(L3Side.SFBMAX);
	
	    /**
	     * will be set in lame_init_params
	     */
	    this.sfb21_extra = false;
	
	    /* BPC = maximum number of filter convolution windows to precompute */
	    //public float[][] inbuf_old = new float[2][];
	    this.inbuf_old = new Array(2);
	    //public float[][] blackfilt = new float[2 * BPC + 1][];
	    this.blackfilt = new Array(2 * LameInternalFlags.BPC + 1);
	    //public double itime[] = new double[2];
	    this.itime = new_double(2);
	    this.sideinfo_len = 0;
	
	    /* variables for newmdct.c */
	    //public float sb_sample[][][][] = new float[2][2][18][Encoder.SBLIMIT];
	    this.sb_sample = new_float_n([2, 2, 18, Encoder.SBLIMIT]);
	    this.amp_filter = new_float(32);
	
	    /* variables for BitStream */
	
	    /**
	     * <PRE>
	     * mpeg1: buffer=511 bytes  smallest frame: 96-38(sideinfo)=58
	     * max number of frames in reservoir:  8
	     * mpeg2: buffer=255 bytes.  smallest frame: 24-23bytes=1
	     * with VBR, if you are encoding all silence, it is possible to
	     * have 8kbs/24khz frames with 1byte of data each, which means we need
	     * to buffer up to 255 headers!
	     * </PRE>
	     */
	    /**
	     * also, max_header_buf has to be a power of two
	     */
	    /**
	     * max size of header is 38
	     */
	
	    function Header() {
	        this.write_timing = 0;
	        this.ptr = 0;
	        //public byte buf[] = new byte[MAX_HEADER_LEN];
	        this.buf = new_byte(MAX_HEADER_LEN);
	    }
	
	    this.header = new Array(LameInternalFlags.MAX_HEADER_BUF);
	
	    this.h_ptr = 0;
	    this.w_ptr = 0;
	    this.ancillary_flag = 0;
	
	    /* variables for Reservoir */
	    /**
	     * in bits
	     */
	    this.ResvSize = 0;
	    /**
	     * in bits
	     */
	    this.ResvMax = 0;
	
	    //public ScaleFac scalefac_band = new ScaleFac();
	    this.scalefac_band = new ScaleFac();
	
	    /* daa from PsyModel */
	    /* The static variables "r", "phi_sav", "new", "old" and "oldest" have */
	    /* to be remembered for the unpredictability measure. For "r" and */
	    /* "phi_sav", the first index from the left is the channel select and */
	    /* the second index is the "age" of the data. */
	    this.minval_l = new_float(Encoder.CBANDS);
	    this.minval_s = new_float(Encoder.CBANDS);
	    this.nb_1 = new_float_n([4, Encoder.CBANDS]);
	    this.nb_2 = new_float_n([4, Encoder.CBANDS]);
	    this.nb_s1 = new_float_n([4, Encoder.CBANDS]);
	    this.nb_s2 = new_float_n([4, Encoder.CBANDS]);
	    this.s3_ss = null;
	    this.s3_ll = null;
	    this.decay = 0.;
	
	    //public III_psy_xmin[] thm = new III_psy_xmin[4];
	    //public III_psy_xmin[] en = new III_psy_xmin[4];
	    this.thm = new Array(4);
	    this.en = new Array(4);
	
	    /**
	     * fft and energy calculation
	     */
	    this.tot_ener = new_float(4);
	
	    /* loudness calculation (for adaptive threshold of hearing) */
	    /**
	     * loudness^2 approx. per granule and channel
	     */
	    this.loudness_sq = new_float_n([2, 2]);
	    /**
	     * account for granule delay of L3psycho_anal
	     */
	    this.loudness_sq_save = new_float(2);
	
	    /**
	     * Scale Factor Bands
	     */
	    this.mld_l = new_float(Encoder.SBMAX_l);
	    this.mld_s = new_float(Encoder.SBMAX_s);
	    this.bm_l = new_int(Encoder.SBMAX_l);
	    this.bo_l = new_int(Encoder.SBMAX_l);
	    this.bm_s = new_int(Encoder.SBMAX_s);
	    this.bo_s = new_int(Encoder.SBMAX_s);
	    this.npart_l = 0;
	    this.npart_s = 0;
	
	    this.s3ind = new_int_n([Encoder.CBANDS, 2]);
	    this.s3ind_s = new_int_n([Encoder.CBANDS, 2]);
	
	    this.numlines_s = new_int(Encoder.CBANDS);
	    this.numlines_l = new_int(Encoder.CBANDS);
	    this.rnumlines_l = new_float(Encoder.CBANDS);
	    this.mld_cb_l = new_float(Encoder.CBANDS);
	    this.mld_cb_s = new_float(Encoder.CBANDS);
	    this.numlines_s_num1 = 0;
	    this.numlines_l_num1 = 0;
	
	    /* ratios */
	    this.pe = new_float(4);
	    this.ms_ratio_s_old = 0.;
	    this.ms_ratio_l_old = 0.;
	    this.ms_ener_ratio_old = 0.;
	
	    /**
	     * block type
	     */
	    this.blocktype_old = new_int(2);
	
	    /**
	     * variables used for --nspsytune
	     */
	    this.nsPsy = new NsPsy();
	
	    /**
	     * used for Xing VBR header
	     */
	    this.VBR_seek_table = new VBRSeekInfo();
	
	    /**
	     * all ATH related stuff
	     */
	        //public ATH ATH;
	    this.ATH = null;
	
	    this.PSY = null;
	
	    this.nogap_total = 0;
	    this.nogap_current = 0;
	
	    /* ReplayGain */
	    this.decode_on_the_fly = true;
	    this.findReplayGain = true;
	    this.findPeakSample = true;
	    this.PeakSample = 0.;
	    this.RadioGain = 0;
	    this.AudiophileGain = 0;
	    //public ReplayGain rgdata;
	    this.rgdata = null;
	
	    /**
	     * gain change required for preventing clipping
	     */
	    this.noclipGainChange = 0;
	    /**
	     * user-specified scale factor required for preventing clipping
	     */
	    this.noclipScale = 0.;
	
	    /* simple statistics */
	    this.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
	    /**
	     * norm/start/short/stop/mixed(short)/sum
	     */
	    this.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);
	
	    //public PlottingData pinfo;
	    //public MPGLib.mpstr_tag hip;
	    this.pinfo = null;
	    this.hip = null;
	
	    this.in_buffer_nsamples = 0;
	    //public float[] in_buffer_0;
	    //public float[] in_buffer_1;
	    this.in_buffer_0 = null;
	    this.in_buffer_1 = null;
	
	    //public IIterationLoop iteration_loop;
	    this.iteration_loop = null;
	
	    for (var i = 0; i < this.en.length; i++) {
	        this.en[i] = new III_psy_xmin();
	    }
	    for (var i = 0; i < this.thm.length; i++) {
	        this.thm[i] = new III_psy_xmin();
	    }
	    for (var i = 0; i < this.header.length; i++) {
	        this.header[i] = new Header();
	    }
	
	}
	
	module.exports = LameInternalFlags;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(444);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(130);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDone = function ActionDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
	  );
	};
	ActionDone = (0, _pure2.default)(ActionDone);
	ActionDone.displayName = 'ActionDone';
	ActionDone.muiName = 'SvgIcon';
	
	exports.default = ActionDone;

/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(682);


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactErrorUtils = __webpack_require__(143);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventPluginRegistry = __webpack_require__(139);
	var ReactEventEmitterMixin = __webpack_require__(556);
	var ViewportMetrics = __webpack_require__(145);
	
	var getVendorPrefixedEventName = __webpack_require__(229);
	var isEventSupported = __webpack_require__(150);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(69);
	var ViewportMetrics = __webpack_require__(145);
	
	var getEventModifierState = __webpack_require__(148);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	var DOMNamespaces = __webpack_require__(138);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(146);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(165);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(164);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(78);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(592);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LocationSubscriber = exports.LocationBroadcast = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBroadcast = __webpack_require__(527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationChannel = 'location';
	
	var LocationBroadcast = exports.LocationBroadcast = function LocationBroadcast(props) {
	  return _react2.default.createElement(_reactBroadcast.Broadcast, _extends({}, props, { channel: LocationChannel }));
	};
	
	var LocationSubscriber = exports.LocationSubscriber = function LocationSubscriber(props) {
	  return _react2.default.createElement(_reactBroadcast.Subscriber, _extends({}, props, { channel: LocationChannel }));
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    if (this.context.serverRouter) this.redirect();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    this.redirect();
	  };
	
	  Redirect.prototype.redirect = function redirect() {
	    var router = this.context.router;
	    var _props = this.props,
	        to = _props.to,
	        push = _props.push;
	    // so that folks can unit test w/o hassle
	
	    if (router) {
	      var navigate = push ? router.transitionTo : router.replaceWith;
	      navigate(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _PropTypes.routerContext,
	  serverRouter: _react.PropTypes.object
	};
	
	
	if (false) {
	  Redirect.propTypes = {
	    to: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
	    push: _react.PropTypes.bool
	  };
	}
	
	exports.default = Redirect;

/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'de-DE': 'German',
	  'en-GB': 'English (UK)',
	  'en-US': 'English (US)',
	  'en-IN': 'English (Indian)',
	  'en-AU': 'English (Australian)',
	  'es-ES': 'Spanish',
	  'es-US': 'Spanish (US)',
	  'da-DK': 'Danish',
	  'fi-FI': 'Finnish',
	  'fr-FR': 'French',
	  'fr-BE': 'French (Belgium)',
	  'hi-IN': 'Hindi',
	  'hu-HU': 'Hungarian',
	  'id-ID': 'Indonesian',
	  'in-ID': 'Indonesian',
	  'it-IT': 'Italian',
	  'ja-JP': 'Japanese',
	  'ko-KR': 'Korean',
	  'nl-NL': 'Dutch (Netherlands)',
	  'pl-PL': 'Polish',
	  'pt-PT': 'Portuguese',
	  'pt-BR': 'Portuguese (Brazil)',
	  'ru-RU': 'Russian',
	  'zh-CN': 'Chinese',
	  'zh-HK': 'Chinese (Hong Kong)',
	  'zh-TW': 'Chinese (Taiwan)',
	  'sv-SE': 'Swedish',
	  'tr-TR': 'Turkish',
	  'vi-VN': 'Vietnamese',
	  'nb-NO': 'Norwegian',
	  'th-TH': 'Thai'
	
	};

/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (score) {
	  var tries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var scoreClass = void 0;
	
	  if (tries === 0) return '';
	
	  if (score >= 75) {
	    scoreClass = 'good';
	  } else if (score >= 50 && score < 75) {
	    scoreClass = 'ok';
	  } else if (score >= 25 && score < 50) {
	    scoreClass = 'do-better';
	  } else {
	    scoreClass = 'fail';
	  }
	
	  return scoreClass;
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(277), __esModule: true };

/***/ },
/* 105 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(283);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 107 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 108 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(56);
	var dPs = __webpack_require__(298);
	var enumBugKeys = __webpack_require__(108);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(168)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(289).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 111 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(46).f;
	var has = __webpack_require__(52);
	var TAG = __webpack_require__(36)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(114)('keys');
	var uid = __webpack_require__(83);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(45);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 115 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(59);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(45);
	var core = __webpack_require__(29);
	var LIBRARY = __webpack_require__(109);
	var wksExt = __webpack_require__(118);
	var defineProperty = __webpack_require__(46).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(36);


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.lineDiff = undefined;
	exports. /*istanbul ignore end*/diffLines = diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = diffTrimmedLines;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_params = __webpack_require__(181) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var lineDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/lineDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	lineDiff.tokenize = function (value) {
	  var retLines = [],
	      linesAndNewlines = value.split(/(\n|\r\n)/);
	
	  // Ignore the final empty token that occurs if the string ends with a new line
	  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
	    linesAndNewlines.pop();
	  }
	
	  // Merge the content and line separators into single tokens
	  for (var i = 0; i < linesAndNewlines.length; i++) {
	    var line = linesAndNewlines[i];
	
	    if (i % 2 && !this.options.newlineIsToken) {
	      retLines[retLines.length - 1] += line;
	    } else {
	      if (this.options.ignoreWhitespace) {
	        line = line.trim();
	      }
	      retLines.push(line);
	    }
	  }
	
	  return retLines;
	};
	
	function diffLines(oldStr, newStr, callback) {
	  return lineDiff.diff(oldStr, newStr, callback);
	}
	function diffTrimmedLines(oldStr, newStr, callback) {
	  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
	  return lineDiff.diff(oldStr, newStr, options);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 120 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ },
/* 123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//package mp3;
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var L3Side = __webpack_require__(86);
	
	function GrInfo() {
	    //float xr[] = new float[576];
	    this.xr = new_float(576);
	    //int l3_enc[] = new int[576];
	    this.l3_enc = new_int(576);
	    //int scalefac[] = new int[L3Side.SFBMAX];
	    this.scalefac = new_int(L3Side.SFBMAX);
	    this.xrpow_max = 0.;
	
	    this.part2_3_length = 0;
	    this.big_values = 0;
	    this.count1 = 0;
	    this.global_gain = 0;
	    this.scalefac_compress = 0;
	    this.block_type = 0;
	    this.mixed_block_flag = 0;
	    this.table_select = new_int(3);
	    this.subblock_gain = new_int(3 + 1);
	    this.region0_count = 0;
	    this.region1_count = 0;
	    this.preflag = 0;
	    this.scalefac_scale = 0;
	    this.count1table_select = 0;
	
	    this.part2_length = 0;
	    this.sfb_lmax = 0;
	    this.sfb_smin = 0;
	    this.psy_lmax = 0;
	    this.sfbmax = 0;
	    this.psymax = 0;
	    this.sfbdivide = 0;
	    this.width = new_int(L3Side.SFBMAX);
	    this.window = new_int(L3Side.SFBMAX);
	    this.count1bits = 0;
	    /**
	     * added for LSF
	     */
	    this.sfb_partition_table = null;
	    this.slen = new_int(4);
	
	    this.max_nonzero_coeff = 0;
	
	    var self = this;
	    function clone_int(array) {
	        return new Int32Array(array);
	    }
	    function clone_float(array) {
	        return new Float32Array(array);
	    }
	    this.assign = function (other) {
	        self.xr = clone_float(other.xr); //.slice(0); //clone();
	        self.l3_enc = clone_int(other.l3_enc); //.slice(0); //clone();
	        self.scalefac = clone_int(other.scalefac);//.slice(0); //clone();
	        self.xrpow_max = other.xrpow_max;
	
	        self.part2_3_length = other.part2_3_length;
	        self.big_values = other.big_values;
	        self.count1 = other.count1;
	        self.global_gain = other.global_gain;
	        self.scalefac_compress = other.scalefac_compress;
	        self.block_type = other.block_type;
	        self.mixed_block_flag = other.mixed_block_flag;
	        self.table_select = clone_int(other.table_select);//.slice(0); //clone();
	        self.subblock_gain = clone_int(other.subblock_gain); //.slice(0); //.clone();
	        self.region0_count = other.region0_count;
	        self.region1_count = other.region1_count;
	        self.preflag = other.preflag;
	        self.scalefac_scale = other.scalefac_scale;
	        self.count1table_select = other.count1table_select;
	
	        self.part2_length = other.part2_length;
	        self.sfb_lmax = other.sfb_lmax;
	        self.sfb_smin = other.sfb_smin;
	        self.psy_lmax = other.psy_lmax;
	        self.sfbmax = other.sfbmax;
	        self.psymax = other.psymax;
	        self.sfbdivide = other.sfbdivide;
	        self.width = clone_int(other.width); //.slice(0); //.clone();
	        self.window = clone_int(other.window); //.slice(0); //.clone();
	        self.count1bits = other.count1bits;
	
	        self.sfb_partition_table = other.sfb_partition_table.slice(0); //.clone();
	        self.slen = clone_int(other.slen); //.slice(0); //.clone();
	        self.max_nonzero_coeff = other.max_nonzero_coeff;
	    }
	}
	
	module.exports = GrInfo;


/***/ },
/* 125 */
/***/ function(module, exports) {

	function HuffCodeTab(len, max, tab, hl) {
	    this.xlen = len;
	    this.linmax = max;
	    this.table = tab;
	    this.hlen = hl;
	}
	
	var Tables = {};
	
	
	Tables.t1HB = [
	    1, 1,
	    1, 0
	];
	
	Tables.t2HB = [
	    1, 2, 1,
	    3, 1, 1,
	    3, 2, 0
	];
	
	Tables.t3HB = [
	    3, 2, 1,
	    1, 1, 1,
	    3, 2, 0
	];
	
	Tables.t5HB = [
	    1, 2, 6, 5,
	    3, 1, 4, 4,
	    7, 5, 7, 1,
	    6, 1, 1, 0
	];
	
	Tables.t6HB = [
	    7, 3, 5, 1,
	    6, 2, 3, 2,
	    5, 4, 4, 1,
	    3, 3, 2, 0
	];
	
	Tables.t7HB = [
	    1, 2, 10, 19, 16, 10,
	    3, 3, 7, 10, 5, 3,
	    11, 4, 13, 17, 8, 4,
	    12, 11, 18, 15, 11, 2,
	    7, 6, 9, 14, 3, 1,
	    6, 4, 5, 3, 2, 0
	];
	
	Tables.t8HB = [
	    3, 4, 6, 18, 12, 5,
	    5, 1, 2, 16, 9, 3,
	    7, 3, 5, 14, 7, 3,
	    19, 17, 15, 13, 10, 4,
	    13, 5, 8, 11, 5, 1,
	    12, 4, 4, 1, 1, 0
	];
	
	Tables.t9HB = [
	    7, 5, 9, 14, 15, 7,
	    6, 4, 5, 5, 6, 7,
	    7, 6, 8, 8, 8, 5,
	    15, 6, 9, 10, 5, 1,
	    11, 7, 9, 6, 4, 1,
	    14, 4, 6, 2, 6, 0
	];
	
	Tables.t10HB = [
	    1, 2, 10, 23, 35, 30, 12, 17,
	    3, 3, 8, 12, 18, 21, 12, 7,
	    11, 9, 15, 21, 32, 40, 19, 6,
	    14, 13, 22, 34, 46, 23, 18, 7,
	    20, 19, 33, 47, 27, 22, 9, 3,
	    31, 22, 41, 26, 21, 20, 5, 3,
	    14, 13, 10, 11, 16, 6, 5, 1,
	    9, 8, 7, 8, 4, 4, 2, 0
	];
	
	Tables.t11HB = [
	    3, 4, 10, 24, 34, 33, 21, 15,
	    5, 3, 4, 10, 32, 17, 11, 10,
	    11, 7, 13, 18, 30, 31, 20, 5,
	    25, 11, 19, 59, 27, 18, 12, 5,
	    35, 33, 31, 58, 30, 16, 7, 5,
	    28, 26, 32, 19, 17, 15, 8, 14,
	    14, 12, 9, 13, 14, 9, 4, 1,
	    11, 4, 6, 6, 6, 3, 2, 0
	];
	
	Tables.t12HB = [
	    9, 6, 16, 33, 41, 39, 38, 26,
	    7, 5, 6, 9, 23, 16, 26, 11,
	    17, 7, 11, 14, 21, 30, 10, 7,
	    17, 10, 15, 12, 18, 28, 14, 5,
	    32, 13, 22, 19, 18, 16, 9, 5,
	    40, 17, 31, 29, 17, 13, 4, 2,
	    27, 12, 11, 15, 10, 7, 4, 1,
	    27, 12, 8, 12, 6, 3, 1, 0
	];
	
	Tables.t13HB = [
	    1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19,
	    3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14,
	    15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16,
	    22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14,
	    35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24,
	    58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17,
	    47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15,
	    72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42,
	    43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16,
	    53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11,
	    35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22,
	    53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7,
	    34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5,
	    45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3,
	    48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2,
	    16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1
	];
	
	Tables.t15HB = [
	    7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63,
	    13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36,
	    19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33,
	    29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29,
	    52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27,
	    77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38,
	    125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30,
	    109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25,
	    90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20,
	    71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15,
	    109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9,
	    86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11,
	    118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7,
	    91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3,
	    123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1,
	    71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0
	];
	
	Tables.t16HB = [
	    1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17,
	    3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9,
	    15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16,
	    45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26,
	    75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9,
	    66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16,
	    111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10,
	    98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8,
	    85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7,
	    154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11,
	    139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4,
	    243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6,
	    202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4,
	    747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2,
	    377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0,
	    12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3
	];
	
	Tables.t24HB = [
	    15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88,
	    14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42,
	    47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18,
	    81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16,
	    147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14,
	    263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12,
	    249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10,
	    435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17,
	    427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16,
	    335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11,
	    668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10,
	    652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6,
	    648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4,
	    620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2,
	    1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0,
	    43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3
	];
	
	Tables.t32HB = [
	    1 << 0, 5 << 1, 4 << 1, 5 << 2, 6 << 1, 5 << 2, 4 << 2, 4 << 3,
	    7 << 1, 3 << 2, 6 << 2, 0 << 3, 7 << 2, 2 << 3, 3 << 3, 1 << 4
	];
	
	Tables.t33HB = [
	    15 << 0, 14 << 1, 13 << 1, 12 << 2, 11 << 1, 10 << 2, 9 << 2, 8 << 3,
	    7 << 1, 6 << 2, 5 << 2, 4 << 3, 3 << 2, 2 << 3, 1 << 3, 0 << 4
	];
	
	Tables.t1l = [
	    1, 4,
	    3, 5
	];
	
	Tables.t2l = [
	    1, 4, 7,
	    4, 5, 7,
	    6, 7, 8
	];
	
	Tables.t3l = [
	    2, 3, 7,
	    4, 4, 7,
	    6, 7, 8
	];
	
	Tables.t5l = [
	    1, 4, 7, 8,
	    4, 5, 8, 9,
	    7, 8, 9, 10,
	    8, 8, 9, 10
	];
	
	Tables.t6l = [
	    3, 4, 6, 8,
	    4, 4, 6, 7,
	    5, 6, 7, 8,
	    7, 7, 8, 9
	];
	
	Tables.t7l = [
	    1, 4, 7, 9, 9, 10,
	    4, 6, 8, 9, 9, 10,
	    7, 7, 9, 10, 10, 11,
	    8, 9, 10, 11, 11, 11,
	    8, 9, 10, 11, 11, 12,
	    9, 10, 11, 12, 12, 12
	];
	
	Tables.t8l = [
	    2, 4, 7, 9, 9, 10,
	    4, 4, 6, 10, 10, 10,
	    7, 6, 8, 10, 10, 11,
	    9, 10, 10, 11, 11, 12,
	    9, 9, 10, 11, 12, 12,
	    10, 10, 11, 11, 13, 13
	];
	
	Tables.t9l = [
	    3, 4, 6, 7, 9, 10,
	    4, 5, 6, 7, 8, 10,
	    5, 6, 7, 8, 9, 10,
	    7, 7, 8, 9, 9, 10,
	    8, 8, 9, 9, 10, 11,
	    9, 9, 10, 10, 11, 11
	];
	
	Tables.t10l = [
	    1, 4, 7, 9, 10, 10, 10, 11,
	    4, 6, 8, 9, 10, 11, 10, 10,
	    7, 8, 9, 10, 11, 12, 11, 11,
	    8, 9, 10, 11, 12, 12, 11, 12,
	    9, 10, 11, 12, 12, 12, 12, 12,
	    10, 11, 12, 12, 13, 13, 12, 13,
	    9, 10, 11, 12, 12, 12, 13, 13,
	    10, 10, 11, 12, 12, 13, 13, 13
	];
	
	Tables.t11l = [
	    2, 4, 6, 8, 9, 10, 9, 10,
	    4, 5, 6, 8, 10, 10, 9, 10,
	    6, 7, 8, 9, 10, 11, 10, 10,
	    8, 8, 9, 11, 10, 12, 10, 11,
	    9, 10, 10, 11, 11, 12, 11, 12,
	    9, 10, 11, 12, 12, 13, 12, 13,
	    9, 9, 9, 10, 11, 12, 12, 12,
	    9, 9, 10, 11, 12, 12, 12, 12
	];
	
	Tables.t12l = [
	    4, 4, 6, 8, 9, 10, 10, 10,
	    4, 5, 6, 7, 9, 9, 10, 10,
	    6, 6, 7, 8, 9, 10, 9, 10,
	    7, 7, 8, 8, 9, 10, 10, 10,
	    8, 8, 9, 9, 10, 10, 10, 11,
	    9, 9, 10, 10, 10, 11, 10, 11,
	    9, 9, 9, 10, 10, 11, 11, 12,
	    10, 10, 10, 11, 11, 11, 11, 12
	];
	
	Tables.t13l = [
	    1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14,
	    4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14,
	    7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15,
	    8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15,
	    9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16,
	    10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16,
	    10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16,
	    11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18,
	    10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17,
	    11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17,
	    11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19,
	    12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18,
	    12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18,
	    13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18,
	    14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18,
	    13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18
	];
	
	Tables.t15l = [
	    3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14,
	    5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13,
	    6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13,
	    7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13,
	    8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13,
	    9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14,
	    10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14,
	    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14,
	    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14,
	    10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14,
	    11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14,
	    11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15,
	    12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15,
	    12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15,
	    13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15,
	    13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15
	];
	
	Tables.t16_5l = [
	    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11,
	    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11,
	    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12,
	    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13,
	    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12,
	    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13,
	    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13,
	    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13,
	    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13,
	    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14,
	    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13,
	    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14,
	    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14,
	    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14,
	    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14,
	    11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12
	];
	
	Tables.t16l = [
	    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10,
	    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10,
	    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11,
	    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12,
	    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11,
	    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12,
	    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12,
	    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12,
	    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12,
	    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13,
	    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12,
	    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13,
	    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13,
	    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13,
	    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13,
	    10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10
	];
	
	Tables.t24l = [
	    4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10,
	    5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10,
	    7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9,
	    8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9,
	    9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9,
	    10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9,
	    10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9,
	    11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10,
	    11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10,
	    11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10,
	    12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
	    12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
	    12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10,
	    12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10,
	    13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10,
	    9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6
	];
	
	Tables.t32l = [
	    1 + 0, 4 + 1, 4 + 1, 5 + 2, 4 + 1, 6 + 2, 5 + 2, 6 + 3,
	    4 + 1, 5 + 2, 5 + 2, 6 + 3, 5 + 2, 6 + 3, 6 + 3, 6 + 4
	];
	
	Tables.t33l = [
	    4 + 0, 4 + 1, 4 + 1, 4 + 2, 4 + 1, 4 + 2, 4 + 2, 4 + 3,
	    4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 2, 4 + 3, 4 + 3, 4 + 4
	];
	
	Tables.ht = [
	    /* xlen, linmax, table, hlen */
	    new HuffCodeTab(0, 0, null, null),
	    new HuffCodeTab(2, 0, Tables.t1HB, Tables.t1l),
	    new HuffCodeTab(3, 0, Tables.t2HB, Tables.t2l),
	    new HuffCodeTab(3, 0, Tables.t3HB, Tables.t3l),
	    new HuffCodeTab(0, 0, null, null), /* Apparently not used */
	    new HuffCodeTab(4, 0, Tables.t5HB, Tables.t5l),
	    new HuffCodeTab(4, 0, Tables.t6HB, Tables.t6l),
	    new HuffCodeTab(6, 0, Tables.t7HB, Tables.t7l),
	    new HuffCodeTab(6, 0, Tables.t8HB, Tables.t8l),
	    new HuffCodeTab(6, 0, Tables.t9HB, Tables.t9l),
	    new HuffCodeTab(8, 0, Tables.t10HB, Tables.t10l),
	    new HuffCodeTab(8, 0, Tables.t11HB, Tables.t11l),
	    new HuffCodeTab(8, 0, Tables.t12HB, Tables.t12l),
	    new HuffCodeTab(16, 0, Tables.t13HB, Tables.t13l),
	    new HuffCodeTab(0, 0, null, Tables.t16_5l), /* Apparently not used */
	    new HuffCodeTab(16, 0, Tables.t15HB, Tables.t15l),
	
	    new HuffCodeTab(1, 1, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(2, 3, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(3, 7, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(4, 15, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(6, 63, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(8, 255, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(10, 1023, Tables.t16HB, Tables.t16l),
	    new HuffCodeTab(13, 8191, Tables.t16HB, Tables.t16l),
	
	    new HuffCodeTab(4, 15, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(5, 31, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(6, 63, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(7, 127, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(8, 255, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(9, 511, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(11, 2047, Tables.t24HB, Tables.t24l),
	    new HuffCodeTab(13, 8191, Tables.t24HB, Tables.t24l),
	
	    new HuffCodeTab(0, 0, Tables.t32HB, Tables.t32l),
	    new HuffCodeTab(0, 0, Tables.t33HB, Tables.t33l),
	];
	
	/**
	 * <CODE>
	 *  for (i = 0; i < 16*16; i++) [
	 *      largetbl[i] = ((ht[16].hlen[i]) << 16) + ht[24].hlen[i];
	 *  ]
	 * </CODE>
	 *
	 */
	Tables.largetbl = [
	    0x010004, 0x050005, 0x070007, 0x090008, 0x0a0009, 0x0a000a, 0x0b000a, 0x0b000b,
	    0x0c000b, 0x0c000c, 0x0c000c, 0x0d000c, 0x0d000c, 0x0d000c, 0x0e000d, 0x0a000a,
	    0x040005, 0x060006, 0x080007, 0x090008, 0x0a0009, 0x0b000a, 0x0b000a, 0x0b000b,
	    0x0c000b, 0x0c000b, 0x0c000c, 0x0d000c, 0x0e000c, 0x0d000c, 0x0e000c, 0x0a000a,
	    0x070007, 0x080007, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000b,
	    0x0d000b, 0x0c000b, 0x0d000b, 0x0d000c, 0x0d000c, 0x0e000c, 0x0e000d, 0x0b0009,
	    0x090008, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0c000b,
	    0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0c0009,
	    0x0a0009, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000a, 0x0d000b,
	    0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000d, 0x0b0009,
	    0x0a000a, 0x0a0009, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0e000b,
	    0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0c0009,
	    0x0b000a, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0d000b, 0x0d000b,
	    0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000d, 0x0c0009,
	    0x0b000b, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b,
	    0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x11000d, 0x11000d, 0x0c000a,
	    0x0b000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b,
	    0x0f000b, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000d, 0x10000d, 0x0c000a,
	    0x0c000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b, 0x0f000c,
	    0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0f000d, 0x10000d, 0x0f000d, 0x0d000a,
	    0x0c000c, 0x0d000b, 0x0c000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c,
	    0x0f000c, 0x10000c, 0x10000c, 0x10000d, 0x11000d, 0x11000d, 0x10000d, 0x0c000a,
	    0x0d000c, 0x0d000c, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x10000c,
	    0x10000c, 0x10000c, 0x10000c, 0x10000d, 0x10000d, 0x0f000d, 0x10000d, 0x0d000a,
	    0x0d000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c,
	    0x0f000c, 0x11000c, 0x10000d, 0x10000d, 0x10000d, 0x10000d, 0x12000d, 0x0d000a,
	    0x0f000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000c,
	    0x10000d, 0x12000d, 0x11000d, 0x11000d, 0x11000d, 0x13000d, 0x11000d, 0x0d000a,
	    0x0e000d, 0x0f000c, 0x0d000c, 0x0e000c, 0x10000c, 0x10000c, 0x0f000c, 0x10000d,
	    0x10000d, 0x11000d, 0x12000d, 0x11000d, 0x13000d, 0x11000d, 0x10000d, 0x0d000a,
	    0x0a0009, 0x0a0009, 0x0a0009, 0x0b0009, 0x0b0009, 0x0c0009, 0x0c0009, 0x0c0009,
	    0x0d0009, 0x0d0009, 0x0d0009, 0x0d000a, 0x0d000a, 0x0d000a, 0x0d000a, 0x0a0006
	];
	/**
	 * <CODE>
	 *  for (i = 0; i < 3*3; i++) [
	 *      table23[i] = ((ht[2].hlen[i]) << 16) + ht[3].hlen[i];
	 *  ]
	 * </CODE>
	 *
	 */
	Tables.table23 = [
	    0x010002, 0x040003, 0x070007,
	    0x040004, 0x050004, 0x070007,
	    0x060006, 0x070007, 0x080008
	];
	
	/**
	 * <CODE>
	 *  for (i = 0; i < 4*4; i++) [
	 *       table56[i] = ((ht[5].hlen[i]) << 16) + ht[6].hlen[i];
	 *   ]
	 * </CODE>
	 *
	 */
	Tables.table56 = [
	    0x010003, 0x040004, 0x070006, 0x080008, 0x040004, 0x050004, 0x080006, 0x090007,
	    0x070005, 0x080006, 0x090007, 0x0a0008, 0x080007, 0x080007, 0x090008, 0x0a0009
	];
	
	Tables.bitrate_table = [
	    [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1], /* MPEG 2 */
	    [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], /* MPEG 1 */
	    [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1], /* MPEG 2.5 */
	];
	
	/**
	 * MPEG 2, MPEG 1, MPEG 2.5.
	 */
	Tables.samplerate_table = [
	    [22050, 24000, 16000, -1],
	    [44100, 48000, 32000, -1],
	    [11025, 12000, 8000, -1],
	];
	
	/**
	 * This is the scfsi_band table from 2.4.2.7 of the IS.
	 */
	Tables.scfsi_band = [0, 6, 11, 16, 21];
	
	module.exports = Tables;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(417),
	    getPrototype = __webpack_require__(419),
	    isObjectLike = __webpack_require__(424);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(433);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(441);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(166);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(478);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(202);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var _props = this.props,
	          desktop = _props.desktop,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	
	      var selected = this.isChildSelected(child, this.props);
	      var selectedChildrenStyles = {};
	
	      if (selected) {
	        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
	      }
	
	      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, menuItemStyle, selectedChildrenStyles);
	
	      var isFocused = childIndex === this.state.focusIndex;
	      var focusState = 'none';
	      if (isFocused) {
	        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	      }
	
	      return _react2.default.cloneElement(child, {
	        desktop: desktop,
	        focusState: focusState,
	        onTouchTap: function onTouchTap(event) {
	          _this2.handleMenuItemTouchTap(event, child, index);
	          if (child.props.onTouchTap) child.props.onTouchTap(event);
	        },
	        ref: isFocused ? 'focusedMenuItem' : null,
	        style: mergedChildrenStyles
	      });
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = (0, _toArray3.default)(menuValue),
	            newMenuValue = _menuValue;
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          autoWidth = _props2.autoWidth,
	          children = _props2.children,
	          desktop = _props2.desktop,
	          disableAutoFocus = _props2.disableAutoFocus,
	          initiallyKeyboardFocused = _props2.initiallyKeyboardFocused,
	          listStyle = _props2.listStyle,
	          maxHeight = _props2.maxHeight,
	          multiple = _props2.multiple,
	          onItemTouchTap = _props2.onItemTouchTap,
	          onEscKeyDown = _props2.onEscKeyDown,
	          onMenuItemFocusChange = _props2.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props2.selectedMenuItemStyle,
	          menuItemStyle = _props2.menuItemStyle,
	          style = _props2.style,
	          value = _props2.value,
	          valueLink = _props2.valueLink,
	          width = _props2.width,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	 false ? Menu.propTypes = {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber
	} : void 0;
	exports.default = Menu;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(131);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(504);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(445);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(129);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MenuItem.propTypes = {
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = MenuItem;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(99);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(204);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(416);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(449);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	var _iOSHelpers = __webpack_require__(515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function (event) {
	      event.preventDefault();
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	
	      // The fixed positioning isn't respected on iOS when an input is focused.
	      // We need to compute the position from the top of the page and not the viewport.
	      if ((0, _iOSHelpers.isIOS)() && document.activeElement.tagName === 'INPUT') {
	        a.bottom = (0, _iOSHelpers.getOffsetTop)(el) + a.height;
	      } else {
	        a.bottom = rect.bottom || a.top + a.height;
	      }
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Popover;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(90);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(483);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FocusRipple;

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvStop = function AvStop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
	  );
	};
	AvStop = (0, _pure2.default)(AvStop);
	AvStop.displayName = 'AvStop';
	AvStop.muiName = 'SvgIcon';
	
	exports.default = AvStop;

/***/ },
/* 135 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(521)();
	}


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(64);
	var Danger = __webpack_require__(533);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(34);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(146);
	var setInnerHTML = __webpack_require__(98);
	var setTextContent = __webpack_require__(232);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var React = __webpack_require__(42);
	var ReactPropTypesSecret = __webpack_require__(562);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(43);
	var ReactInstanceMap = __webpack_require__(80);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(38);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 149 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(26);
	var warning = __webpack_require__(11);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var permissions = [];
	var role = '';
	
	exports.default = {
	  setRole: function setRole(userRole) {
	    role = userRole;
	  },
	
	  setPermissions: function setPermissions(newPermissions) {
	    if (Array.isArray(newPermissions)) {
	      permissions = newPermissions;
	    }
	  },
	
	  hasRole: function hasRole(thisRole) {
	    return role === thisRole;
	  },
	
	  can: function can(candothis) {
	    return permissions.includes(candothis);
	  }
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jwtDecode = __webpack_require__(392);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  decode: function decode(token) {
	    try {
	      var decoded = (0, _jwtDecode2.default)(token);
	      return decoded.user;
	    } catch (err) {
	      throw new Error(err);
	    }
	  },
	  verify: function verify(token) {
	    try {
	      var decoded = (0, _jwtDecode2.default)(token);
	      var time = Math.round(new Date().getTime() / 1000);
	
	      return time < decoded.exp;
	    } catch (err) {
	      return false;
	    }
	  }
	}; /* eslint camelcase: "off"*/

/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/* eslint-disable no-restricted-properties */
	
	/** normalize
	 * This lets us translate a value from one scale to another.
	 *
	 * @param {Number} value - Our initial value to translate
	 * @param {Number} min - the current minimum value possible
	 * @param {Number} max - the current maximum value possible
	 * @param {Number} scaleMin - the min value of the scale we're translating to
	 * @param {Number} scaleMax - the max value of the scale we're translating to
	 *
	 * @returns {Number} the value on its new scale
	 */
	var normalize = exports.normalize = function normalize(_ref) {
	  var value = _ref.value,
	      min = _ref.min,
	      max = _ref.max,
	      _ref$scaleMin = _ref.scaleMin,
	      scaleMin = _ref$scaleMin === undefined ? 0 : _ref$scaleMin,
	      _ref$scaleMax = _ref.scaleMax,
	      scaleMax = _ref$scaleMax === undefined ? 1 : _ref$scaleMax;
	
	  // If the `min` and `max` are the same value, it means our dataset is flat.
	  // For now, let's assume that flat data should be aligned to the bottom.
	  if (min === max) {
	    return scaleMin;
	  }
	
	  return scaleMin + (value - min) * (scaleMax - scaleMin) / (max - min);
	};
	
	/** moveTo
	 * the coordinate that lies at a midpoint between 2 lines, based on the radius
	 *
	 * @param {Object} to - Our initial point
	 * @param {Number} to.x - The x value of our initial point
	 * @param {Number} to.y - The y value of our initial point
	 * @param {Object} from - Our final point
	 * @param {Number} from.x - The x value of our final point
	 * @param {Number} from.y - The y value of our final point
	 * @param {Number} radius - The distance away from the final point
	 *
	 * @returns {Object} an object holding the x/y coordinates of the midpoint.
	 */
	var moveTo = exports.moveTo = function moveTo(to, from, radius) {
	  var vector = { x: to.x - from.x, y: to.y - from.y };
	  var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
	  var unitVector = { x: vector.x / length, y: vector.y / length };
	
	  return {
	    x: from.x + unitVector.x * radius,
	    y: from.y + unitVector.y * radius
	  };
	};
	
	/** getDistanceBetween
	 * Simple formula derived from pythagoras to calculate the distance between
	 * 2 points on a plane.
	 *
	 * @param {Object} p1 - Our initial point
	 * @param {Number} p1.x - The x value of our initial point
	 * @param {Number} p1.y - The y value of our initial point
	 * @param {Object} p2 - Our final point
	 * @param {Number} p2.x - The x value of our final point
	 * @param {Number} p2.y - The y value of our final point
	 *
	 * @returns {Number} the distance between the points.
	 */
	var getDistanceBetween = exports.getDistanceBetween = function getDistanceBetween(p1, p2) {
	  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
	};
	
	/** checkForCollinearPoints
	 * Figure out if the midpoint fits perfectly on a line between the two others.
	 *
	 * @param {Object} p1 - Our initial point
	 * @param {Number} p1.x - The x value of our initial point
	 * @param {Number} p1.y - The y value of our initial point
	 * @param {Object} p2 - Our mid-point
	 * @param {Number} p2.x - The x value of our mid-point
	 * @param {Number} p2.y - The y value of our mid-point
	 * @param {Object} p3 - Our final point
	 * @param {Number} p3.x - The x value of our final point
	 * @param {Number} p3.y - The y value of our final point
	
	 * @returns {Boolean} whether or not p2 sits on the line between p1 and p3.
	 */
	var checkForCollinearPoints = exports.checkForCollinearPoints = function checkForCollinearPoints(p1, p2, p3) {
	  return (p1.y - p2.y) * (p1.x - p3.x) === (p1.y - p3.y) * (p1.x - p2.x);
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactNoopUpdateQueue = __webpack_require__(159);
	
	var canDefineProperty = __webpack_require__(255);
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(43);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(261);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(715);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(714);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(713);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(260);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(262);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// Capture environment as module variable to allow testing.
	var compileTimeEnv;
	try {
	  compileTimeEnv = ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ROLLBAR_ACCESS_TOKEN":"8bd15db033ec48a3a60bc809335305ab","REACT_APP_API_URL":"https://pronounce-live-admin.herokuapp.com/api/v1"});
	} catch(error) {
	  compileTimeEnv = {};
	  console.log(
	    '`process.env` is not defined. '+
	    'Compile-time environment will be empty.'
	  );
	}
	// This template tag should be rendered/replaced with the environment in production.
	// Padded to 4KB so that the data can be inserted without offsetting character 
	// indexes of the bundle (avoids breaking source maps).
	var runtimeEnv = '{{REACT_APP_VARS_AS_JSON______________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________}}';
	
	
	// A function returning the runtime environment, so that 
	// JSON parsing & errors occur at runtime instead of load time.
	function loadRuntimeEnv() {
	  var env;
	
	  if (compileTimeEnv.NODE_ENV === 'production') {
	    try {
	      env = JSON.parse(runtimeEnv);
	    } catch(error) {
	      env = {};
	      var overflowsMessage = runtimeEnv.slice(32,33) != null;
	      console.error(
	        'Runtime env vars cannot be parsed. '+
	        'Content is `'+runtimeEnv.slice(0,31)+( overflowsMessage ? '…' : '' )+'`'
	      );
	    }
	
	  } else {
	    env = compileTimeEnv;
	  }
	
	  return env;
	}
	
	module.exports = loadRuntimeEnv;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(265);


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(274), __esModule: true };

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(275), __esModule: true };

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(279), __esModule: true };

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(163);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(163);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	var document = __webpack_require__(45).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(51) && !__webpack_require__(57)(function () {
	  return Object.defineProperty(__webpack_require__(168)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(105);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(109);
	var $export = __webpack_require__(44);
	var redefine = __webpack_require__(177);
	var hide = __webpack_require__(58);
	var has = __webpack_require__(52);
	var Iterators = __webpack_require__(73);
	var $iterCreate = __webpack_require__(293);
	var setToStringTag = __webpack_require__(112);
	var getPrototypeOf = __webpack_require__(174);
	var ITERATOR = __webpack_require__(36)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(82);
	var createDesc = __webpack_require__(75);
	var toIObject = __webpack_require__(60);
	var toPrimitive = __webpack_require__(116);
	var has = __webpack_require__(52);
	var IE8_DOM_DEFINE = __webpack_require__(169);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(175);
	var hiddenKeys = __webpack_require__(108).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(52);
	var toObject = __webpack_require__(76);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(52);
	var toIObject = __webpack_require__(60);
	var arrayIndexOf = __webpack_require__(285)(false);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(44);
	var core = __webpack_require__(29);
	var fails = __webpack_require__(57);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(58);


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(115);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(301)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(171)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 180 */
/***/ function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/parsePatch = parsePatch;
	function parsePatch(uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      list = [],
	      i = 0;
	
	  function parseIndex() {
	    var index = {};
	    list.push(index);
	
	    // Parse diff metadata
	    while (i < diffstr.length) {
	      var line = diffstr[i];
	
	      // File header found, end parsing diff metadata
	      if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) {
	        break;
	      }
	
	      // Diff index
	      var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
	      if (header) {
	        index.index = header[1];
	      }
	
	      i++;
	    }
	
	    // Parse file headers if they are defined. Unified diff requires them, but
	    // there's no technical issues to have an isolated hunk without file header
	    parseFileHeader(index);
	    parseFileHeader(index);
	
	    // Parse hunks
	    index.hunks = [];
	
	    while (i < diffstr.length) {
	      var _line = diffstr[i];
	
	      if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) {
	        break;
	      } else if (/^@@/.test(_line)) {
	        index.hunks.push(parseHunk());
	      } else if (_line && options.strict) {
	        // Ignore unexpected content unless in strict mode
	        throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
	      } else {
	        i++;
	      }
	    }
	  }
	
	  // Parses the --- and +++ headers, if none are found, no lines
	  // are consumed.
	  function parseFileHeader(index) {
	    var headerPattern = /^(---|\+\+\+)\s+([\S ]*)(?:\t(.*?)\s*)?$/;
	    var fileHeader = headerPattern.exec(diffstr[i]);
	    if (fileHeader) {
	      var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
	      index[keyPrefix + 'FileName'] = fileHeader[2];
	      index[keyPrefix + 'Header'] = fileHeader[3];
	
	      i++;
	    }
	  }
	
	  // Parses a hunk
	  // This assumes that we are at the start of a hunk.
	  function parseHunk() {
	    var chunkHeaderIndex = i,
	        chunkHeaderLine = diffstr[i++],
	        chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
	
	    var hunk = {
	      oldStart: +chunkHeader[1],
	      oldLines: +chunkHeader[2] || 1,
	      newStart: +chunkHeader[3],
	      newLines: +chunkHeader[4] || 1,
	      lines: [],
	      linedelimiters: []
	    };
	
	    var addCount = 0,
	        removeCount = 0;
	    for (; i < diffstr.length; i++) {
	      // Lines starting with '---' could be mistaken for the "remove line" operation
	      // But they could be the header for the next file. Therefore prune such cases out.
	      if (diffstr[i].indexOf('--- ') === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf('+++ ') === 0 && diffstr[i + 2].indexOf('@@') === 0) {
	        break;
	      }
	      var operation = diffstr[i][0];
	
	      if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
	        hunk.lines.push(diffstr[i]);
	        hunk.linedelimiters.push(delimiters[i] || '\n');
	
	        if (operation === '+') {
	          addCount++;
	        } else if (operation === '-') {
	          removeCount++;
	        } else if (operation === ' ') {
	          addCount++;
	          removeCount++;
	        }
	      } else {
	        break;
	      }
	    }
	
	    // Handle the empty block count case
	    if (!addCount && hunk.newLines === 1) {
	      hunk.newLines = 0;
	    }
	    if (!removeCount && hunk.oldLines === 1) {
	      hunk.oldLines = 0;
	    }
	
	    // Perform optional sanity checking
	    if (options.strict) {
	      if (addCount !== hunk.newLines) {
	        throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	      if (removeCount !== hunk.oldLines) {
	        throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	    }
	
	    return hunk;
	  }
	
	  while (i < diffstr.length) {
	    parseIndex();
	  }
	
	  return list;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 181 */
/***/ function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/generateOptions = generateOptions;
	function generateOptions(options, defaults) {
	  if (typeof options === 'function') {
	    defaults.callback = options;
	  } else if (options) {
	    for (var name in options) {
	      /* istanbul ignore else */
	      if (options.hasOwnProperty(name)) {
	        defaults[name] = options[name];
	      }
	    }
	  }
	  return defaults;
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL3BhcmFtcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQWdCLGUsR0FBQSxlO0FBQVQsU0FBUyxlQUFULENBQXlCLE9BQXpCLEVBQWtDLFFBQWxDLEVBQTRDO0FBQ2pELE1BQUksT0FBTyxPQUFQLEtBQW1CLFVBQXZCLEVBQW1DO0FBQ2pDLGFBQVMsUUFBVCxHQUFvQixPQUFwQjtBQUNELEdBRkQsTUFFTyxJQUFJLE9BQUosRUFBYTtBQUNsQixTQUFLLElBQUksSUFBVCxJQUFpQixPQUFqQixFQUEwQjs7QUFFeEIsVUFBSSxRQUFRLGNBQVIsQ0FBdUIsSUFBdkIsQ0FBSixFQUFrQztBQUNoQyxpQkFBUyxJQUFULElBQWlCLFFBQVEsSUFBUixDQUFqQjtBQUNEO0FBQ0Y7QUFDRjtBQUNELFNBQU8sUUFBUDtBQUNEIiwiZmlsZSI6InBhcmFtcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBnZW5lcmF0ZU9wdGlvbnMob3B0aW9ucywgZGVmYXVsdHMpIHtcbiAgaWYgKHR5cGVvZiBvcHRpb25zID09PSAnZnVuY3Rpb24nKSB7XG4gICAgZGVmYXVsdHMuY2FsbGJhY2sgPSBvcHRpb25zO1xuICB9IGVsc2UgaWYgKG9wdGlvbnMpIHtcbiAgICBmb3IgKGxldCBuYW1lIGluIG9wdGlvbnMpIHtcbiAgICAgIC8qIGlzdGFuYnVsIGlnbm9yZSBlbHNlICovXG4gICAgICBpZiAob3B0aW9ucy5oYXNPd25Qcm9wZXJ0eShuYW1lKSkge1xuICAgICAgICBkZWZhdWx0c1tuYW1lXSA9IG9wdGlvbnNbbmFtZV07XG4gICAgICB9XG4gICAgfVxuICB9XG4gIHJldHVybiBkZWZhdWx0cztcbn1cbiJdfQ==


/***/ },
/* 182 */
120,
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(26);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(716);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(720);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(387);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Takehiro = __webpack_require__(197);
	var Tables = __webpack_require__(125);
	var Encoder = __webpack_require__(21);
	var LameInternalFlags = __webpack_require__(87);
	
	BitStream.EQ = function (a, b) {
	    return (Math.abs(a) > Math.abs(b)) ? (Math.abs((a) - (b)) <= (Math
	        .abs(a) * 1e-6))
	        : (Math.abs((a) - (b)) <= (Math.abs(b) * 1e-6));
	};
	
	BitStream.NEQ = function (a, b) {
	    return !BitStream.EQ(a, b);
	};
	
	function BitStream() {
	    var self = this;
	    var CRC16_POLYNOMIAL = 0x8005;
	
	    /*
	     * we work with ints, so when doing bit manipulation, we limit ourselves to
	     * MAX_LENGTH-2 just to be on the safe side
	     */
	    var MAX_LENGTH = 32;
	
	    //GainAnalysis ga;
	    //MPGLib mpg;
	    //Version ver;
	    //VBRTag vbr;
	    var ga = null;
	    var mpg = null;
	    var ver = null;
	    var vbr = null;
	
	    //public final void setModules(GainAnalysis ga, MPGLib mpg, Version ver,
	    //	VBRTag vbr) {
	
	    this.setModules = function (_ga, _mpg, _ver, _vbr) {
	        ga = _ga;
	        mpg = _mpg;
	        ver = _ver;
	        vbr = _vbr;
	    };
	
	    /**
	     * Bit stream buffer.
	     */
	    //private byte[] buf;
	    var buf = null;
	    /**
	     * Bit counter of bit stream.
	     */
	    var totbit = 0;
	    /**
	     * Pointer to top byte in buffer.
	     */
	    var bufByteIdx = 0;
	    /**
	     * Pointer to top bit of top byte in buffer.
	     */
	    var bufBitIdx = 0;
	
	    /**
	     * compute bitsperframe and mean_bits for a layer III frame
	     */
	    this.getframebits = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var bit_rate;
	
	        /* get bitrate in kbps [?] */
	        if (gfc.bitrate_index != 0)
	            bit_rate = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
	        else
	            bit_rate = gfp.brate;
	        assert(8 <= bit_rate && bit_rate <= 640);
	
	        /* main encoding routine toggles padding on and off */
	        /* one Layer3 Slot consists of 8 bits */
	        var bytes = 0 | (gfp.version + 1) * 72000 * bit_rate / gfp.out_samplerate + gfc.padding;
	        return 8 * bytes;
	    };
	
	    function putheader_bits(gfc) {
	        System.arraycopy(gfc.header[gfc.w_ptr].buf, 0, buf, bufByteIdx, gfc.sideinfo_len);
	        bufByteIdx += gfc.sideinfo_len;
	        totbit += gfc.sideinfo_len * 8;
	        gfc.w_ptr = (gfc.w_ptr + 1) & (LameInternalFlags.MAX_HEADER_BUF - 1);
	    }
	
	    /**
	     * write j bits into the bit stream
	     */
	    function putbits2(gfc, val, j) {
	        assert(j < MAX_LENGTH - 2);
	
	        while (j > 0) {
	            var k;
	            if (bufBitIdx == 0) {
	                bufBitIdx = 8;
	                bufByteIdx++;
	                assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
	                assert(gfc.header[gfc.w_ptr].write_timing >= totbit);
	                if (gfc.header[gfc.w_ptr].write_timing == totbit) {
	                    putheader_bits(gfc);
	                }
	                buf[bufByteIdx] = 0;
	            }
	
	            k = Math.min(j, bufBitIdx);
	            j -= k;
	
	            bufBitIdx -= k;
	
	            assert(j < MAX_LENGTH);
	            /* 32 too large on 32 bit machines */
	            assert(bufBitIdx < MAX_LENGTH);
	
	            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
	            totbit += k;
	        }
	    }
	
	    /**
	     * write j bits into the bit stream, ignoring frame headers
	     */
	    function putbits_noheaders(gfc, val, j) {
	        assert(j < MAX_LENGTH - 2);
	
	        while (j > 0) {
	            var k;
	            if (bufBitIdx == 0) {
	                bufBitIdx = 8;
	                bufByteIdx++;
	                assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
	                buf[bufByteIdx] = 0;
	            }
	
	            k = Math.min(j, bufBitIdx);
	            j -= k;
	
	            bufBitIdx -= k;
	
	            assert(j < MAX_LENGTH);
	            /* 32 too large on 32 bit machines */
	            assert(bufBitIdx < MAX_LENGTH);
	
	            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
	            totbit += k;
	        }
	    }
	
	    /**
	     * Some combinations of bitrate, Fs, and stereo make it impossible to stuff
	     * out a frame using just main_data, due to the limited number of bits to
	     * indicate main_data_length. In these situations, we put stuffing bits into
	     * the ancillary data...
	     */
	    function drain_into_ancillary(gfp, remainingBits) {
	        var gfc = gfp.internal_flags;
	        var i;
	        assert(remainingBits >= 0);
	
	        if (remainingBits >= 8) {
	            putbits2(gfc, 0x4c, 8);
	            remainingBits -= 8;
	        }
	        if (remainingBits >= 8) {
	            putbits2(gfc, 0x41, 8);
	            remainingBits -= 8;
	        }
	        if (remainingBits >= 8) {
	            putbits2(gfc, 0x4d, 8);
	            remainingBits -= 8;
	        }
	        if (remainingBits >= 8) {
	            putbits2(gfc, 0x45, 8);
	            remainingBits -= 8;
	        }
	
	        if (remainingBits >= 32) {
	            var version = ver.getLameShortVersion();
	            if (remainingBits >= 32)
	                for (i = 0; i < version.length && remainingBits >= 8; ++i) {
	                    remainingBits -= 8;
	                    putbits2(gfc, version.charAt(i), 8);
	                }
	        }
	
	        for (; remainingBits >= 1; remainingBits -= 1) {
	            putbits2(gfc, gfc.ancillary_flag, 1);
	            gfc.ancillary_flag ^= (!gfp.disable_reservoir ? 1 : 0);
	        }
	
	        assert(remainingBits == 0);
	
	    }
	
	    /**
	     * write N bits into the header
	     */
	    function writeheader(gfc, val, j) {
	        var ptr = gfc.header[gfc.h_ptr].ptr;
	
	        while (j > 0) {
	            var k = Math.min(j, 8 - (ptr & 7));
	            j -= k;
	            assert(j < MAX_LENGTH);
	            /* >> 32 too large for 32 bit machines */
	
	            gfc.header[gfc.h_ptr].buf[ptr >> 3] |= ((val >> j)) << (8 - (ptr & 7) - k);
	            ptr += k;
	        }
	        gfc.header[gfc.h_ptr].ptr = ptr;
	    }
	
	    function CRC_update(value, crc) {
	        value <<= 8;
	        for (var i = 0; i < 8; i++) {
	            value <<= 1;
	            crc <<= 1;
	
	            if ((((crc ^ value) & 0x10000) != 0))
	                crc ^= CRC16_POLYNOMIAL;
	        }
	        return crc;
	    }
	
	    this.CRC_writeheader = function (gfc, header) {
	        var crc = 0xffff;
	        /* (jo) init crc16 for error_protection */
	
	        crc = CRC_update(header[2] & 0xff, crc);
	        crc = CRC_update(header[3] & 0xff, crc);
	        for (var i = 6; i < gfc.sideinfo_len; i++) {
	            crc = CRC_update(header[i] & 0xff, crc);
	        }
	
	        header[4] = (byte)(crc >> 8);
	        header[5] = (byte)(crc & 255);
	    };
	
	    function encodeSideInfo2(gfp, bitsPerFrame) {
	        var gfc = gfp.internal_flags;
	        var l3_side;
	        var gr, ch;
	
	        l3_side = gfc.l3_side;
	        gfc.header[gfc.h_ptr].ptr = 0;
	        Arrays.fill(gfc.header[gfc.h_ptr].buf, 0, gfc.sideinfo_len, 0);
	        if (gfp.out_samplerate < 16000)
	            writeheader(gfc, 0xffe, 12);
	        else
	            writeheader(gfc, 0xfff, 12);
	        writeheader(gfc, (gfp.version), 1);
	        writeheader(gfc, 4 - 3, 2);
	        writeheader(gfc, (!gfp.error_protection ? 1 : 0), 1);
	        writeheader(gfc, (gfc.bitrate_index), 4);
	        writeheader(gfc, (gfc.samplerate_index), 2);
	        writeheader(gfc, (gfc.padding), 1);
	        writeheader(gfc, (gfp.extension), 1);
	        writeheader(gfc, (gfp.mode.ordinal()), 2);
	        writeheader(gfc, (gfc.mode_ext), 2);
	        writeheader(gfc, (gfp.copyright), 1);
	        writeheader(gfc, (gfp.original), 1);
	        writeheader(gfc, (gfp.emphasis), 2);
	        if (gfp.error_protection) {
	            writeheader(gfc, 0, 16);
	            /* dummy */
	        }
	
	        if (gfp.version == 1) {
	            /* MPEG1 */
	            assert(l3_side.main_data_begin >= 0);
	            writeheader(gfc, (l3_side.main_data_begin), 9);
	
	            if (gfc.channels_out == 2)
	                writeheader(gfc, l3_side.private_bits, 3);
	            else
	                writeheader(gfc, l3_side.private_bits, 5);
	
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                var band;
	                for (band = 0; band < 4; band++) {
	                    writeheader(gfc, l3_side.scfsi[ch][band], 1);
	                }
	            }
	
	            for (gr = 0; gr < 2; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    var gi = l3_side.tt[gr][ch];
	                    writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
	                    writeheader(gfc, gi.big_values / 2, 9);
	                    writeheader(gfc, gi.global_gain, 8);
	                    writeheader(gfc, gi.scalefac_compress, 4);
	
	                    if (gi.block_type != Encoder.NORM_TYPE) {
	                        writeheader(gfc, 1, 1);
	                        /* window_switching_flag */
	                        writeheader(gfc, gi.block_type, 2);
	                        writeheader(gfc, gi.mixed_block_flag, 1);
	
	                        if (gi.table_select[0] == 14)
	                            gi.table_select[0] = 16;
	                        writeheader(gfc, gi.table_select[0], 5);
	                        if (gi.table_select[1] == 14)
	                            gi.table_select[1] = 16;
	                        writeheader(gfc, gi.table_select[1], 5);
	
	                        writeheader(gfc, gi.subblock_gain[0], 3);
	                        writeheader(gfc, gi.subblock_gain[1], 3);
	                        writeheader(gfc, gi.subblock_gain[2], 3);
	                    } else {
	                        writeheader(gfc, 0, 1);
	                        /* window_switching_flag */
	                        if (gi.table_select[0] == 14)
	                            gi.table_select[0] = 16;
	                        writeheader(gfc, gi.table_select[0], 5);
	                        if (gi.table_select[1] == 14)
	                            gi.table_select[1] = 16;
	                        writeheader(gfc, gi.table_select[1], 5);
	                        if (gi.table_select[2] == 14)
	                            gi.table_select[2] = 16;
	                        writeheader(gfc, gi.table_select[2], 5);
	
	                        assert(0 <= gi.region0_count && gi.region0_count < 16);
	                        assert(0 <= gi.region1_count && gi.region1_count < 8);
	                        writeheader(gfc, gi.region0_count, 4);
	                        writeheader(gfc, gi.region1_count, 3);
	                    }
	                    writeheader(gfc, gi.preflag, 1);
	                    writeheader(gfc, gi.scalefac_scale, 1);
	                    writeheader(gfc, gi.count1table_select, 1);
	                }
	            }
	        } else {
	            /* MPEG2 */
	            assert(l3_side.main_data_begin >= 0);
	            writeheader(gfc, (l3_side.main_data_begin), 8);
	            writeheader(gfc, l3_side.private_bits, gfc.channels_out);
	
	            gr = 0;
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                var gi = l3_side.tt[gr][ch];
	                writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
	                writeheader(gfc, gi.big_values / 2, 9);
	                writeheader(gfc, gi.global_gain, 8);
	                writeheader(gfc, gi.scalefac_compress, 9);
	
	                if (gi.block_type != Encoder.NORM_TYPE) {
	                    writeheader(gfc, 1, 1);
	                    /* window_switching_flag */
	                    writeheader(gfc, gi.block_type, 2);
	                    writeheader(gfc, gi.mixed_block_flag, 1);
	
	                    if (gi.table_select[0] == 14)
	                        gi.table_select[0] = 16;
	                    writeheader(gfc, gi.table_select[0], 5);
	                    if (gi.table_select[1] == 14)
	                        gi.table_select[1] = 16;
	                    writeheader(gfc, gi.table_select[1], 5);
	
	                    writeheader(gfc, gi.subblock_gain[0], 3);
	                    writeheader(gfc, gi.subblock_gain[1], 3);
	                    writeheader(gfc, gi.subblock_gain[2], 3);
	                } else {
	                    writeheader(gfc, 0, 1);
	                    /* window_switching_flag */
	                    if (gi.table_select[0] == 14)
	                        gi.table_select[0] = 16;
	                    writeheader(gfc, gi.table_select[0], 5);
	                    if (gi.table_select[1] == 14)
	                        gi.table_select[1] = 16;
	                    writeheader(gfc, gi.table_select[1], 5);
	                    if (gi.table_select[2] == 14)
	                        gi.table_select[2] = 16;
	                    writeheader(gfc, gi.table_select[2], 5);
	
	                    assert(0 <= gi.region0_count && gi.region0_count < 16);
	                    assert(0 <= gi.region1_count && gi.region1_count < 8);
	                    writeheader(gfc, gi.region0_count, 4);
	                    writeheader(gfc, gi.region1_count, 3);
	                }
	
	                writeheader(gfc, gi.scalefac_scale, 1);
	                writeheader(gfc, gi.count1table_select, 1);
	            }
	        }
	
	        if (gfp.error_protection) {
	            /* (jo) error_protection: add crc16 information to header */
	            CRC_writeheader(gfc, gfc.header[gfc.h_ptr].buf);
	        }
	
	        {
	            var old = gfc.h_ptr;
	            assert(gfc.header[old].ptr == gfc.sideinfo_len * 8);
	
	            gfc.h_ptr = (old + 1) & (LameInternalFlags.MAX_HEADER_BUF - 1);
	            gfc.header[gfc.h_ptr].write_timing = gfc.header[old].write_timing
	                + bitsPerFrame;
	
	            if (gfc.h_ptr == gfc.w_ptr) {
	                /* yikes! we are out of header buffer space */
	                System.err
	                    .println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
	            }
	
	        }
	    }
	
	    function huffman_coder_count1(gfc, gi) {
	        /* Write count1 area */
	        var h = Tables.ht[gi.count1table_select + 32];
	        var i, bits = 0;
	
	        var ix = gi.big_values;
	        var xr = gi.big_values;
	        assert(gi.count1table_select < 2);
	
	        for (i = (gi.count1 - gi.big_values) / 4; i > 0; --i) {
	            var huffbits = 0;
	            var p = 0, v;
	
	            v = gi.l3_enc[ix + 0];
	            if (v != 0) {
	                p += 8;
	                if (gi.xr[xr + 0] < 0)
	                    huffbits++;
	                assert(v <= 1);
	            }
	
	            v = gi.l3_enc[ix + 1];
	            if (v != 0) {
	                p += 4;
	                huffbits *= 2;
	                if (gi.xr[xr + 1] < 0)
	                    huffbits++;
	                assert(v <= 1);
	            }
	
	            v = gi.l3_enc[ix + 2];
	            if (v != 0) {
	                p += 2;
	                huffbits *= 2;
	                if (gi.xr[xr + 2] < 0)
	                    huffbits++;
	                assert(v <= 1);
	            }
	
	            v = gi.l3_enc[ix + 3];
	            if (v != 0) {
	                p++;
	                huffbits *= 2;
	                if (gi.xr[xr + 3] < 0)
	                    huffbits++;
	                assert(v <= 1);
	            }
	
	            ix += 4;
	            xr += 4;
	            putbits2(gfc, huffbits + h.table[p], h.hlen[p]);
	            bits += h.hlen[p];
	        }
	        return bits;
	    }
	
	    /**
	     * Implements the pseudocode of page 98 of the IS
	     */
	    function Huffmancode(gfc, tableindex, start, end, gi) {
	        var h = Tables.ht[tableindex];
	        var bits = 0;
	
	        assert(tableindex < 32);
	        if (0 == tableindex)
	            return bits;
	
	        for (var i = start; i < end; i += 2) {
	            var cbits = 0;
	            var xbits = 0;
	            var linbits = h.xlen;
	            var xlen = h.xlen;
	            var ext = 0;
	            var x1 = gi.l3_enc[i];
	            var x2 = gi.l3_enc[i + 1];
	
	            if (x1 != 0) {
	                if (gi.xr[i] < 0)
	                    ext++;
	                cbits--;
	            }
	
	            if (tableindex > 15) {
	                /* use ESC-words */
	                if (x1 > 14) {
	                    var linbits_x1 = x1 - 15;
	                    assert(linbits_x1 <= h.linmax);
	                    ext |= linbits_x1 << 1;
	                    xbits = linbits;
	                    x1 = 15;
	                }
	
	                if (x2 > 14) {
	                    var linbits_x2 = x2 - 15;
	                    assert(linbits_x2 <= h.linmax);
	                    ext <<= linbits;
	                    ext |= linbits_x2;
	                    xbits += linbits;
	                    x2 = 15;
	                }
	                xlen = 16;
	            }
	
	            if (x2 != 0) {
	                ext <<= 1;
	                if (gi.xr[i + 1] < 0)
	                    ext++;
	                cbits--;
	            }
	
	            assert((x1 | x2) < 16);
	
	            x1 = x1 * xlen + x2;
	            xbits -= cbits;
	            cbits += h.hlen[x1];
	
	            assert(cbits <= MAX_LENGTH);
	            assert(xbits <= MAX_LENGTH);
	
	            putbits2(gfc, h.table[x1], cbits);
	            putbits2(gfc, ext, xbits);
	            bits += cbits + xbits;
	        }
	        return bits;
	    }
	
	    /**
	     * Note the discussion of huffmancodebits() on pages 28 and 29 of the IS, as
	     * well as the definitions of the side information on pages 26 and 27.
	     */
	    function ShortHuffmancodebits(gfc, gi) {
	        var region1Start = 3 * gfc.scalefac_band.s[3];
	        if (region1Start > gi.big_values)
	            region1Start = gi.big_values;
	
	        /* short blocks do not have a region2 */
	        var bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
	        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
	            gi.big_values, gi);
	        return bits;
	    }
	
	    function LongHuffmancodebits(gfc, gi) {
	        var bigvalues, bits;
	        var region1Start, region2Start;
	
	        bigvalues = gi.big_values;
	        assert(0 <= bigvalues && bigvalues <= 576);
	
	        var i = gi.region0_count + 1;
	        assert(0 <= i);
	        assert(i < gfc.scalefac_band.l.length);
	        region1Start = gfc.scalefac_band.l[i];
	        i += gi.region1_count + 1;
	        assert(0 <= i);
	        assert(i < gfc.scalefac_band.l.length);
	        region2Start = gfc.scalefac_band.l[i];
	
	        if (region1Start > bigvalues)
	            region1Start = bigvalues;
	
	        if (region2Start > bigvalues)
	            region2Start = bigvalues;
	
	        bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
	        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
	            region2Start, gi);
	        bits += Huffmancode(gfc, gi.table_select[2], region2Start, bigvalues,
	            gi);
	        return bits;
	    }
	
	    function writeMainData(gfp) {
	        var gr, ch, sfb, data_bits, tot_bits = 0;
	        var gfc = gfp.internal_flags;
	        var l3_side = gfc.l3_side;
	
	        if (gfp.version == 1) {
	            /* MPEG 1 */
	            for (gr = 0; gr < 2; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    var gi = l3_side.tt[gr][ch];
	                    var slen1 = Takehiro.slen1_tab[gi.scalefac_compress];
	                    var slen2 = Takehiro.slen2_tab[gi.scalefac_compress];
	                    data_bits = 0;
	                    for (sfb = 0; sfb < gi.sfbdivide; sfb++) {
	                        if (gi.scalefac[sfb] == -1)
	                            continue;
	                        /* scfsi is used */
	                        putbits2(gfc, gi.scalefac[sfb], slen1);
	                        data_bits += slen1;
	                    }
	                    for (; sfb < gi.sfbmax; sfb++) {
	                        if (gi.scalefac[sfb] == -1)
	                            continue;
	                        /* scfsi is used */
	                        putbits2(gfc, gi.scalefac[sfb], slen2);
	                        data_bits += slen2;
	                    }
	                    assert(data_bits == gi.part2_length);
	
	                    if (gi.block_type == Encoder.SHORT_TYPE) {
	                        data_bits += ShortHuffmancodebits(gfc, gi);
	                    } else {
	                        data_bits += LongHuffmancodebits(gfc, gi);
	                    }
	                    data_bits += huffman_coder_count1(gfc, gi);
	                    /* does bitcount in quantize.c agree with actual bit count? */
	                    assert(data_bits == gi.part2_3_length + gi.part2_length);
	                    tot_bits += data_bits;
	                }
	                /* for ch */
	            }
	            /* for gr */
	        } else {
	            /* MPEG 2 */
	            gr = 0;
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                var gi = l3_side.tt[gr][ch];
	                var i, sfb_partition, scale_bits = 0;
	                assert(gi.sfb_partition_table != null);
	                data_bits = 0;
	                sfb = 0;
	                sfb_partition = 0;
	
	                if (gi.block_type == Encoder.SHORT_TYPE) {
	                    for (; sfb_partition < 4; sfb_partition++) {
	                        var sfbs = gi.sfb_partition_table[sfb_partition] / 3;
	                        var slen = gi.slen[sfb_partition];
	                        for (i = 0; i < sfbs; i++, sfb++) {
	                            putbits2(gfc,
	                                Math.max(gi.scalefac[sfb * 3 + 0], 0), slen);
	                            putbits2(gfc,
	                                Math.max(gi.scalefac[sfb * 3 + 1], 0), slen);
	                            putbits2(gfc,
	                                Math.max(gi.scalefac[sfb * 3 + 2], 0), slen);
	                            scale_bits += 3 * slen;
	                        }
	                    }
	                    data_bits += ShortHuffmancodebits(gfc, gi);
	                } else {
	                    for (; sfb_partition < 4; sfb_partition++) {
	                        var sfbs = gi.sfb_partition_table[sfb_partition];
	                        var slen = gi.slen[sfb_partition];
	                        for (i = 0; i < sfbs; i++, sfb++) {
	                            putbits2(gfc, Math.max(gi.scalefac[sfb], 0), slen);
	                            scale_bits += slen;
	                        }
	                    }
	                    data_bits += LongHuffmancodebits(gfc, gi);
	                }
	                data_bits += huffman_coder_count1(gfc, gi);
	                /* does bitcount in quantize.c agree with actual bit count? */
	                assert(data_bits == gi.part2_3_length);
	                assert(scale_bits == gi.part2_length);
	                tot_bits += scale_bits + data_bits;
	            }
	            /* for ch */
	        }
	        /* for gf */
	        return tot_bits;
	    }
	
	    /* main_data */
	
	    function TotalBytes() {
	        this.total = 0;
	    }
	
	    /*
	     * compute the number of bits required to flush all mp3 frames currently in
	     * the buffer. This should be the same as the reservoir size. Only call this
	     * routine between frames - i.e. only after all headers and data have been
	     * added to the buffer by format_bitstream().
	     *
	     * Also compute total_bits_output = size of mp3 buffer (including frame
	     * headers which may not have yet been send to the mp3 buffer) + number of
	     * bits needed to flush all mp3 frames.
	     *
	     * total_bytes_output is the size of the mp3 output buffer if
	     * lame_encode_flush_nogap() was called right now.
	     */
	    function compute_flushbits(gfp, total_bytes_output) {
	        var gfc = gfp.internal_flags;
	        var flushbits, remaining_headers;
	        var bitsPerFrame;
	        var last_ptr, first_ptr;
	        first_ptr = gfc.w_ptr;
	        /* first header to add to bitstream */
	        last_ptr = gfc.h_ptr - 1;
	        /* last header to add to bitstream */
	        if (last_ptr == -1)
	            last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;
	
	        /* add this many bits to bitstream so we can flush all headers */
	        flushbits = gfc.header[last_ptr].write_timing - totbit;
	        total_bytes_output.total = flushbits;
	
	        if (flushbits >= 0) {
	            /* if flushbits >= 0, some headers have not yet been written */
	            /* reduce flushbits by the size of the headers */
	            remaining_headers = 1 + last_ptr - first_ptr;
	            if (last_ptr < first_ptr)
	                remaining_headers = 1 + last_ptr - first_ptr
	                    + LameInternalFlags.MAX_HEADER_BUF;
	            flushbits -= remaining_headers * 8 * gfc.sideinfo_len;
	        }
	
	        /*
	         * finally, add some bits so that the last frame is complete these bits
	         * are not necessary to decode the last frame, but some decoders will
	         * ignore last frame if these bits are missing
	         */
	        bitsPerFrame = self.getframebits(gfp);
	        flushbits += bitsPerFrame;
	        total_bytes_output.total += bitsPerFrame;
	        /* round up: */
	        if ((total_bytes_output.total % 8) != 0)
	            total_bytes_output.total = 1 + (total_bytes_output.total / 8);
	        else
	            total_bytes_output.total = (total_bytes_output.total / 8);
	        total_bytes_output.total += bufByteIdx + 1;
	
	        if (flushbits < 0) {
	            System.err.println("strange error flushing buffer ... \n");
	        }
	        return flushbits;
	    }
	
	    this.flush_bitstream = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var l3_side;
	        var flushbits;
	        var last_ptr = gfc.h_ptr - 1;
	        /* last header to add to bitstream */
	        if (last_ptr == -1)
	            last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;
	        l3_side = gfc.l3_side;
	
	        if ((flushbits = compute_flushbits(gfp, new TotalBytes())) < 0)
	            return;
	        drain_into_ancillary(gfp, flushbits);
	
	        /* check that the 100% of the last frame has been written to bitstream */
	        assert(gfc.header[last_ptr].write_timing + this.getframebits(gfp) == totbit);
	
	        /*
	         * we have padded out all frames with ancillary data, which is the same
	         * as filling the bitreservoir with ancillary data, so :
	         */
	        gfc.ResvSize = 0;
	        l3_side.main_data_begin = 0;
	
	        /* save the ReplayGain value */
	        if (gfc.findReplayGain) {
	            var RadioGain = ga.GetTitleGain(gfc.rgdata);
	            assert(NEQ(RadioGain, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES));
	            gfc.RadioGain = Math.floor(RadioGain * 10.0 + 0.5) | 0;
	            /* round to nearest */
	        }
	
	        /* find the gain and scale change required for no clipping */
	        if (gfc.findPeakSample) {
	            gfc.noclipGainChange = Math.ceil(Math
	                        .log10(gfc.PeakSample / 32767.0) * 20.0 * 10.0) | 0;
	            /* round up */
	
	            if (gfc.noclipGainChange > 0) {
	                /* clipping occurs */
	                if (EQ(gfp.scale, 1.0) || EQ(gfp.scale, 0.0))
	                    gfc.noclipScale = (Math
	                        .floor((32767.0 / gfc.PeakSample) * 100.0) / 100.0);
	                /* round down */
	                else {
	                    /*
	                     * the user specified his own scaling factor. We could
	                     * suggest the scaling factor of
	                     * (32767.0/gfp.PeakSample)*(gfp.scale) but it's usually
	                     * very inaccurate. So we'd rather not advice him on the
	                     * scaling factor.
	                     */
	                    gfc.noclipScale = -1;
	                }
	            } else
	            /* no clipping */
	                gfc.noclipScale = -1;
	        }
	    };
	
	    this.add_dummy_byte = function (gfp, val, n) {
	        var gfc = gfp.internal_flags;
	        var i;
	
	        while (n-- > 0) {
	            putbits_noheaders(gfc, val, 8);
	
	            for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i)
	                gfc.header[i].write_timing += 8;
	        }
	    };
	
	    /**
	     * This is called after a frame of audio has been quantized and coded. It
	     * will write the encoded audio to the bitstream. Note that from a layer3
	     * encoder's perspective the bit stream is primarily a series of main_data()
	     * blocks, with header and side information inserted at the proper locations
	     * to maintain framing. (See Figure A.7 in the IS).
	     */
	    this.format_bitstream = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var l3_side;
	        l3_side = gfc.l3_side;
	
	        var bitsPerFrame = this.getframebits(gfp);
	        drain_into_ancillary(gfp, l3_side.resvDrain_pre);
	
	        encodeSideInfo2(gfp, bitsPerFrame);
	        var bits = 8 * gfc.sideinfo_len;
	        bits += writeMainData(gfp);
	        drain_into_ancillary(gfp, l3_side.resvDrain_post);
	        bits += l3_side.resvDrain_post;
	
	        l3_side.main_data_begin += (bitsPerFrame - bits) / 8;
	
	        /*
	         * compare number of bits needed to clear all buffered mp3 frames with
	         * what we think the resvsize is:
	         */
	        if (compute_flushbits(gfp, new TotalBytes()) != gfc.ResvSize) {
	            System.err.println("Internal buffer inconsistency. flushbits <> ResvSize");
	        }
	
	        /*
	         * compare main_data_begin for the next frame with what we think the
	         * resvsize is:
	         */
	        if ((l3_side.main_data_begin * 8) != gfc.ResvSize) {
	            System.err.printf("bit reservoir error: \n"
	                + "l3_side.main_data_begin: %d \n"
	                + "Resvoir size:             %d \n"
	                + "resv drain (post)         %d \n"
	                + "resv drain (pre)          %d \n"
	                + "header and sideinfo:      %d \n"
	                + "data bits:                %d \n"
	                + "total bits:               %d (remainder: %d) \n"
	                + "bitsperframe:             %d \n",
	                8 * l3_side.main_data_begin, gfc.ResvSize,
	                l3_side.resvDrain_post, l3_side.resvDrain_pre,
	                8 * gfc.sideinfo_len, bits - l3_side.resvDrain_post - 8
	                * gfc.sideinfo_len, bits, bits % 8, bitsPerFrame);
	
	            System.err.println("This is a fatal error.  It has several possible causes:");
	            System.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations");
	            System.err.println(" 9%%  Your system is overclocked");
	            System.err.println(" 1%%  bug in LAME encoding library");
	
	            gfc.ResvSize = l3_side.main_data_begin * 8;
	        }
	        //;
	        assert(totbit % 8 == 0);
	
	        if (totbit > 1000000000) {
	            /*
	             * to avoid totbit overflow, (at 8h encoding at 128kbs) lets reset
	             * bit counter
	             */
	            var i;
	            for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i)
	                gfc.header[i].write_timing -= totbit;
	            totbit = 0;
	        }
	
	        return 0;
	    };
	
	    /**
	     * <PRE>
	     * copy data out of the internal MP3 bit buffer into a user supplied
	     *       unsigned char buffer.
	     *
	     *       mp3data=0      indicates data in buffer is an id3tags and VBR tags
	     *       mp3data=1      data is real mp3 frame data.
	     * </PRE>
	     */
	    this.copy_buffer = function (gfc, buffer, bufferPos, size, mp3data) {
	        var minimum = bufByteIdx + 1;
	        if (minimum <= 0)
	            return 0;
	        if (size != 0 && minimum > size) {
	            /* buffer is too small */
	            return -1;
	        }
	        System.arraycopy(buf, 0, buffer, bufferPos, minimum);
	        bufByteIdx = -1;
	        bufBitIdx = 0;
	
	        if (mp3data != 0) {
	            var crc = new_int(1);
	            crc[0] = gfc.nMusicCRC;
	            vbr.updateMusicCRC(crc, buffer, bufferPos, minimum);
	            gfc.nMusicCRC = crc[0];
	
	            /**
	             * sum number of bytes belonging to the mp3 stream this info will be
	             * written into the Xing/LAME header for seeking
	             */
	            if (minimum > 0) {
	                gfc.VBR_seek_table.nBytesWritten += minimum;
	            }
	
	            if (gfc.decode_on_the_fly) { /* decode the frame */
	                var pcm_buf = new_float_n([2, 1152]);
	                var mp3_in = minimum;
	                var samples_out = -1;
	                var i;
	
	                /* re-synthesis to pcm. Repeat until we get a samples_out=0 */
	                while (samples_out != 0) {
	
	                    samples_out = mpg.hip_decode1_unclipped(gfc.hip, buffer,
	                        bufferPos, mp3_in, pcm_buf[0], pcm_buf[1]);
	                    /*
	                     * samples_out = 0: need more data to decode samples_out =
	                     * -1: error. Lets assume 0 pcm output samples_out = number
	                     * of samples output
	                     */
	
	                    /*
	                     * set the lenght of the mp3 input buffer to zero, so that
	                     * in the next iteration of the loop we will be querying
	                     * mpglib about buffered data
	                     */
	                    mp3_in = 0;
	
	                    if (samples_out == -1) {
	                        /*
	                         * error decoding. Not fatal, but might screw up the
	                         * ReplayGain tag. What should we do? Ignore for now
	                         */
	                        samples_out = 0;
	                    }
	                    if (samples_out > 0) {
	                        /* process the PCM data */
	
	                        /*
	                         * this should not be possible, and indicates we have
	                         * overflown the pcm_buf buffer
	                         */
	                        assert(samples_out <= 1152);
	
	                        if (gfc.findPeakSample) {
	                            for (i = 0; i < samples_out; i++) {
	                                if (pcm_buf[0][i] > gfc.PeakSample)
	                                    gfc.PeakSample = pcm_buf[0][i];
	                                else if (-pcm_buf[0][i] > gfc.PeakSample)
	                                    gfc.PeakSample = -pcm_buf[0][i];
	                            }
	                            if (gfc.channels_out > 1)
	                                for (i = 0; i < samples_out; i++) {
	                                    if (pcm_buf[1][i] > gfc.PeakSample)
	                                        gfc.PeakSample = pcm_buf[1][i];
	                                    else if (-pcm_buf[1][i] > gfc.PeakSample)
	                                        gfc.PeakSample = -pcm_buf[1][i];
	                                }
	                        }
	
	                        if (gfc.findReplayGain)
	                            if (ga.AnalyzeSamples(gfc.rgdata, pcm_buf[0], 0,
	                                    pcm_buf[1], 0, samples_out,
	                                    gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
	                                return -6;
	
	                    }
	                    /* if (samples_out>0) */
	                }
	                /* while (samples_out!=0) */
	            }
	            /* if (gfc.decode_on_the_fly) */
	
	        }
	        /* if (mp3data) */
	        return minimum;
	    };
	
	    this.init_bit_stream_w = function (gfc) {
	        buf = new_byte(Lame.LAME_MAXMP3BUFFER);
	
	        gfc.h_ptr = gfc.w_ptr = 0;
	        gfc.header[gfc.h_ptr].write_timing = 0;
	        bufByteIdx = -1;
	        bufBitIdx = 0;
	        totbit = 0;
	    };
	
	    // From machine.h
	
	
	}
	
	module.exports = BitStream;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  ReplayGainAnalysis - analyzes input samples and give the recommended dB change
	 *  Copyright (C) 2001 David Robinson and Glen Sawyer
	 *  Improvements and optimizations added by Frank Klemm, and by Marcel Muller 
	 *
	 *  This library is free software; you can redistribute it and/or
	 *  modify it under the terms of the GNU Lesser General Public
	 *  License as published by the Free Software Foundation; either
	 *  version 2.1 of the License, or (at your option) any later version.
	 *
	 *  This library is distributed in the hope that it will be useful,
	 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
	 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	 *  Lesser General Public License for more details.
	 *
	 *  You should have received a copy of the GNU Lesser General Public
	 *  License along with this library; if not, write to the Free Software
	 *  Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
	 *
	 *  concept and filter values by David Robinson (David@Robinson.org)
	 *    -- blame him if you think the idea is flawed
	 *  original coding by Glen Sawyer (mp3gain@hotmail.com)
	 *    -- blame him if you think this runs too slowly, or the coding is otherwise flawed
	 *
	 *  lots of code improvements by Frank Klemm ( http://www.uni-jena.de/~pfk/mpp/ )
	 *    -- credit him for all the _good_ programming ;)
	 *
	 *
	 *  For an explanation of the concepts and the basic algorithms involved, go to:
	 *    http://www.replaygain.org/
	 */
	
	/*
	 *  Here's the deal. Call
	 *
	 *    InitGainAnalysis ( long samplefreq );
	 *
	 *  to initialize everything. Call
	 *
	 *    AnalyzeSamples ( var Float_t*  left_samples,
	 *                     var Float_t*  right_samples,
	 *                     size_t          num_samples,
	 *                     int             num_channels );
	 *
	 *  as many times as you want, with as many or as few samples as you want.
	 *  If mono, pass the sample buffer in through left_samples, leave
	 *  right_samples NULL, and make sure num_channels = 1.
	 *
	 *    GetTitleGain()
	 *
	 *  will return the recommended dB level change for all samples analyzed
	 *  SINCE THE LAST TIME you called GetTitleGain() OR InitGainAnalysis().
	 *
	 *    GetAlbumGain()
	 *
	 *  will return the recommended dB level change for all samples analyzed
	 *  since InitGainAnalysis() was called and finalized with GetTitleGain().
	 *
	 *  Pseudo-code to process an album:
	 *
	 *    Float_t       l_samples [4096];
	 *    Float_t       r_samples [4096];
	 *    size_t        num_samples;
	 *    unsigned int  num_songs;
	 *    unsigned int  i;
	 *
	 *    InitGainAnalysis ( 44100 );
	 *    for ( i = 1; i <= num_songs; i++ ) {
	 *        while ( ( num_samples = getSongSamples ( song[i], left_samples, right_samples ) ) > 0 )
	 *            AnalyzeSamples ( left_samples, right_samples, num_samples, 2 );
	 *        fprintf ("Recommended dB change for song %2d: %+6.2 dB\n", i, GetTitleGain() );
	 *    }
	 *    fprintf ("Recommended dB change for whole album: %+6.2 dB\n", GetAlbumGain() );
	 */
	
	/*
	 *  So here's the main source of potential code confusion:
	 *
	 *  The filters applied to the incoming samples are IIR filters,
	 *  meaning they rely on up to <filter order> number of previous samples
	 *  AND up to <filter order> number of previous filtered samples.
	 *
	 *  I set up the AnalyzeSamples routine to minimize memory usage and interface
	 *  complexity. The speed isn't compromised too much (I don't think), but the
	 *  internal complexity is higher than it should be for such a relatively
	 *  simple routine.
	 *
	 *  Optimization/clarity suggestions are welcome.
	 */
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	/**
	 * Table entries per dB
	 */
	GainAnalysis.STEPS_per_dB = 100.;
	/**
	 * Table entries for 0...MAX_dB (normal max. values are 70...80 dB)
	 */
	GainAnalysis.MAX_dB = 120.;
	GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES = -24601;
	GainAnalysis.GAIN_ANALYSIS_ERROR = 0;
	GainAnalysis.GAIN_ANALYSIS_OK = 1;
	GainAnalysis.INIT_GAIN_ANALYSIS_ERROR = 0;
	GainAnalysis.INIT_GAIN_ANALYSIS_OK = 1;
	
	GainAnalysis.YULE_ORDER = 10;
	GainAnalysis.MAX_ORDER = GainAnalysis.YULE_ORDER;
	
	GainAnalysis.MAX_SAMP_FREQ = 48000;
	GainAnalysis.RMS_WINDOW_TIME_NUMERATOR = 1;
	GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR = 20;
	GainAnalysis.MAX_SAMPLES_PER_WINDOW = ((GainAnalysis.MAX_SAMP_FREQ * GainAnalysis.RMS_WINDOW_TIME_NUMERATOR) / GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR + 1);
	
	function GainAnalysis() {
	    /**
	     * calibration value for 89dB
	     */
	    var PINK_REF = 64.82;
	
	    var YULE_ORDER = GainAnalysis.YULE_ORDER;
	    /**
	     * percentile which is louder than the proposed level
	     */
	    var RMS_PERCENTILE = 0.95;
	    /**
	     * maximum allowed sample frequency [Hz]
	     */
	    var MAX_SAMP_FREQ = GainAnalysis.MAX_SAMP_FREQ;
	    var RMS_WINDOW_TIME_NUMERATOR = GainAnalysis.RMS_WINDOW_TIME_NUMERATOR;
	    /**
	     * numerator / denominator = time slice size [s]
	     */
	    var RMS_WINDOW_TIME_DENOMINATOR = GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR;
	    /**
	     * max. Samples per Time slice
	     */
	    var MAX_SAMPLES_PER_WINDOW = GainAnalysis.MAX_SAMPLES_PER_WINDOW;
	
	
	    var ABYule = [
	        [0.03857599435200, -3.84664617118067, -0.02160367184185,
	            7.81501653005538, -0.00123395316851, -11.34170355132042,
	            -0.00009291677959, 13.05504219327545, -0.01655260341619,
	            -12.28759895145294, 0.02161526843274, 9.48293806319790,
	            -0.02074045215285, -5.87257861775999, 0.00594298065125,
	            2.75465861874613, 0.00306428023191, -0.86984376593551,
	            0.00012025322027, 0.13919314567432, 0.00288463683916],
	        [0.05418656406430, -3.47845948550071, -0.02911007808948,
	            6.36317777566148, -0.00848709379851, -8.54751527471874,
	            -0.00851165645469, 9.47693607801280, -0.00834990904936,
	            -8.81498681370155, 0.02245293253339, 6.85401540936998,
	            -0.02596338512915, -4.39470996079559, 0.01624864962975,
	            2.19611684890774, -0.00240879051584, -0.75104302451432,
	            0.00674613682247, 0.13149317958808, -0.00187763777362],
	        [0.15457299681924, -2.37898834973084, -0.09331049056315,
	            2.84868151156327, -0.06247880153653, -2.64577170229825,
	            0.02163541888798, 2.23697657451713, -0.05588393329856,
	            -1.67148153367602, 0.04781476674921, 1.00595954808547,
	            0.00222312597743, -0.45953458054983, 0.03174092540049,
	            0.16378164858596, -0.01390589421898, -0.05032077717131,
	            0.00651420667831, 0.02347897407020, -0.00881362733839],
	        [0.30296907319327, -1.61273165137247, -0.22613988682123,
	            1.07977492259970, -0.08587323730772, -0.25656257754070,
	            0.03282930172664, -0.16276719120440, -0.00915702933434,
	            -0.22638893773906, -0.02364141202522, 0.39120800788284,
	            -0.00584456039913, -0.22138138954925, 0.06276101321749,
	            0.04500235387352, -0.00000828086748, 0.02005851806501,
	            0.00205861885564, 0.00302439095741, -0.02950134983287],
	        [0.33642304856132, -1.49858979367799, -0.25572241425570,
	            0.87350271418188, -0.11828570177555, 0.12205022308084,
	            0.11921148675203, -0.80774944671438, -0.07834489609479,
	            0.47854794562326, -0.00469977914380, -0.12453458140019,
	            -0.00589500224440, -0.04067510197014, 0.05724228140351,
	            0.08333755284107, 0.00832043980773, -0.04237348025746,
	            -0.01635381384540, 0.02977207319925, -0.01760176568150],
	        [0.44915256608450, -0.62820619233671, -0.14351757464547,
	            0.29661783706366, -0.22784394429749, -0.37256372942400,
	            -0.01419140100551, 0.00213767857124, 0.04078262797139,
	            -0.42029820170918, -0.12398163381748, 0.22199650564824,
	            0.04097565135648, 0.00613424350682, 0.10478503600251,
	            0.06747620744683, -0.01863887810927, 0.05784820375801,
	            -0.03193428438915, 0.03222754072173, 0.00541907748707],
	        [0.56619470757641, -1.04800335126349, -0.75464456939302,
	            0.29156311971249, 0.16242137742230, -0.26806001042947,
	            0.16744243493672, 0.00819999645858, -0.18901604199609,
	            0.45054734505008, 0.30931782841830, -0.33032403314006,
	            -0.27562961986224, 0.06739368333110, 0.00647310677246,
	            -0.04784254229033, 0.08647503780351, 0.01639907836189,
	            -0.03788984554840, 0.01807364323573, -0.00588215443421],
	        [0.58100494960553, -0.51035327095184, -0.53174909058578,
	            -0.31863563325245, -0.14289799034253, -0.20256413484477,
	            0.17520704835522, 0.14728154134330, 0.02377945217615,
	            0.38952639978999, 0.15558449135573, -0.23313271880868,
	            -0.25344790059353, -0.05246019024463, 0.01628462406333,
	            -0.02505961724053, 0.06920467763959, 0.02442357316099,
	            -0.03721611395801, 0.01818801111503, -0.00749618797172],
	        [0.53648789255105, -0.25049871956020, -0.42163034350696,
	            -0.43193942311114, -0.00275953611929, -0.03424681017675,
	            0.04267842219415, -0.04678328784242, -0.10214864179676,
	            0.26408300200955, 0.14590772289388, 0.15113130533216,
	            -0.02459864859345, -0.17556493366449, -0.11202315195388,
	            -0.18823009262115, -0.04060034127000, 0.05477720428674,
	            0.04788665548180, 0.04704409688120, -0.02217936801134]];
	
	    var ABButter = [
	        [0.98621192462708, -1.97223372919527, -1.97242384925416,
	            0.97261396931306, 0.98621192462708],
	        [0.98500175787242, -1.96977855582618, -1.97000351574484,
	            0.97022847566350, 0.98500175787242],
	        [0.97938932735214, -1.95835380975398, -1.95877865470428,
	            0.95920349965459, 0.97938932735214],
	        [0.97531843204928, -1.95002759149878, -1.95063686409857,
	            0.95124613669835, 0.97531843204928],
	        [0.97316523498161, -1.94561023566527, -1.94633046996323,
	            0.94705070426118, 0.97316523498161],
	        [0.96454515552826, -1.92783286977036, -1.92909031105652,
	            0.93034775234268, 0.96454515552826],
	        [0.96009142950541, -1.91858953033784, -1.92018285901082,
	            0.92177618768381, 0.96009142950541],
	        [0.95856916599601, -1.91542108074780, -1.91713833199203,
	            0.91885558323625, 0.95856916599601],
	        [0.94597685600279, -1.88903307939452, -1.89195371200558,
	            0.89487434461664, 0.94597685600279]];
	
	
	    /**
	     * When calling this procedure, make sure that ip[-order] and op[-order]
	     * point to real data
	     */
	    //private void filterYule(final float[] input, int inputPos, float[] output,
	    //int outputPos, int nSamples, final float[] kernel) {
	    function filterYule(input, inputPos, output, outputPos, nSamples, kernel) {
	
	        while ((nSamples--) != 0) {
	            /* 1e-10 is a hack to avoid slowdown because of denormals */
	            output[outputPos] = 1e-10 + input[inputPos + 0] * kernel[0]
	                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
	                * kernel[2] - output[outputPos - 2] * kernel[3]
	                + input[inputPos - 2] * kernel[4] - output[outputPos - 3]
	                * kernel[5] + input[inputPos - 3] * kernel[6]
	                - output[outputPos - 4] * kernel[7] + input[inputPos - 4]
	                * kernel[8] - output[outputPos - 5] * kernel[9]
	                + input[inputPos - 5] * kernel[10] - output[outputPos - 6]
	                * kernel[11] + input[inputPos - 6] * kernel[12]
	                - output[outputPos - 7] * kernel[13] + input[inputPos - 7]
	                * kernel[14] - output[outputPos - 8] * kernel[15]
	                + input[inputPos - 8] * kernel[16] - output[outputPos - 9]
	                * kernel[17] + input[inputPos - 9] * kernel[18]
	                - output[outputPos - 10] * kernel[19]
	                + input[inputPos - 10] * kernel[20];
	            ++outputPos;
	            ++inputPos;
	        }
	    }
	
	//private void filterButter(final float[] input, int inputPos,
	//    float[] output, int outputPos, int nSamples, final float[] kernel) {
	    function filterButter(input, inputPos, output, outputPos, nSamples, kernel) {
	
	        while ((nSamples--) != 0) {
	            output[outputPos] = input[inputPos + 0] * kernel[0]
	                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
	                * kernel[2] - output[outputPos - 2] * kernel[3]
	                + input[inputPos - 2] * kernel[4];
	            ++outputPos;
	            ++inputPos;
	        }
	    }
	
	    /**
	     * @return INIT_GAIN_ANALYSIS_OK if successful, INIT_GAIN_ANALYSIS_ERROR if
	     *         not
	     */
	    function ResetSampleFrequency(rgData, samplefreq) {
	        /* zero out initial values */
	        for (var i = 0; i < MAX_ORDER; i++)
	            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;
	
	        switch (0 | (samplefreq)) {
	            case 48000:
	                rgData.reqindex = 0;
	                break;
	            case 44100:
	                rgData.reqindex = 1;
	                break;
	            case 32000:
	                rgData.reqindex = 2;
	                break;
	            case 24000:
	                rgData.reqindex = 3;
	                break;
	            case 22050:
	                rgData.reqindex = 4;
	                break;
	            case 16000:
	                rgData.reqindex = 5;
	                break;
	            case 12000:
	                rgData.reqindex = 6;
	                break;
	            case 11025:
	                rgData.reqindex = 7;
	                break;
	            case 8000:
	                rgData.reqindex = 8;
	                break;
	            default:
	                return INIT_GAIN_ANALYSIS_ERROR;
	        }
	
	        rgData.sampleWindow = 0 | ((samplefreq * RMS_WINDOW_TIME_NUMERATOR
	            + RMS_WINDOW_TIME_DENOMINATOR - 1) / RMS_WINDOW_TIME_DENOMINATOR);
	
	        rgData.lsum = 0.;
	        rgData.rsum = 0.;
	        rgData.totsamp = 0;
	
	        Arrays.ill(rgData.A, 0);
	
	        return INIT_GAIN_ANALYSIS_OK;
	    }
	
	    this.InitGainAnalysis = function (rgData, samplefreq) {
	        if (ResetSampleFrequency(rgData, samplefreq) != INIT_GAIN_ANALYSIS_OK) {
	            return INIT_GAIN_ANALYSIS_ERROR;
	        }
	
	        rgData.linpre = MAX_ORDER;
	        rgData.rinpre = MAX_ORDER;
	        rgData.lstep = MAX_ORDER;
	        rgData.rstep = MAX_ORDER;
	        rgData.lout = MAX_ORDER;
	        rgData.rout = MAX_ORDER;
	
	        Arrays.fill(rgData.B, 0);
	
	        return INIT_GAIN_ANALYSIS_OK;
	    };
	
	    /**
	     * square
	     */
	    function fsqr(d) {
	        return d * d;
	    }
	
	    this.AnalyzeSamples = function (rgData, left_samples, left_samplesPos, right_samples, right_samplesPos, num_samples,
	                                    num_channels) {
	        var curleft;
	        var curleftBase;
	        var curright;
	        var currightBase;
	        var batchsamples;
	        var cursamples;
	        var cursamplepos;
	
	        if (num_samples == 0)
	            return GAIN_ANALYSIS_OK;
	
	        cursamplepos = 0;
	        batchsamples = num_samples;
	
	        switch (num_channels) {
	            case 1:
	                right_samples = left_samples;
	                right_samplesPos = left_samplesPos;
	                break;
	            case 2:
	                break;
	            default:
	                return GAIN_ANALYSIS_ERROR;
	        }
	
	        if (num_samples < MAX_ORDER) {
	            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
	                MAX_ORDER, num_samples);
	            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
	                MAX_ORDER, num_samples);
	        } else {
	            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
	                MAX_ORDER, MAX_ORDER);
	            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
	                MAX_ORDER, MAX_ORDER);
	        }
	
	        while (batchsamples > 0) {
	            cursamples = batchsamples > rgData.sampleWindow - rgData.totsamp ? rgData.sampleWindow
	            - rgData.totsamp
	                : batchsamples;
	            if (cursamplepos < MAX_ORDER) {
	                curleft = rgData.linpre + cursamplepos;
	                curleftBase = rgData.linprebuf;
	                curright = rgData.rinpre + cursamplepos;
	                currightBase = rgData.rinprebuf;
	                if (cursamples > MAX_ORDER - cursamplepos)
	                    cursamples = MAX_ORDER - cursamplepos;
	            } else {
	                curleft = left_samplesPos + cursamplepos;
	                curleftBase = left_samples;
	                curright = right_samplesPos + cursamplepos;
	                currightBase = right_samples;
	            }
	
	            filterYule(curleftBase, curleft, rgData.lstepbuf, rgData.lstep
	                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
	            filterYule(currightBase, curright, rgData.rstepbuf, rgData.rstep
	                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
	
	            filterButter(rgData.lstepbuf, rgData.lstep + rgData.totsamp,
	                rgData.loutbuf, rgData.lout + rgData.totsamp, cursamples,
	                ABButter[rgData.reqindex]);
	            filterButter(rgData.rstepbuf, rgData.rstep + rgData.totsamp,
	                rgData.routbuf, rgData.rout + rgData.totsamp, cursamples,
	                ABButter[rgData.reqindex]);
	
	            curleft = rgData.lout + rgData.totsamp;
	            /* Get the squared values */
	            curleftBase = rgData.loutbuf;
	            curright = rgData.rout + rgData.totsamp;
	            currightBase = rgData.routbuf;
	
	            var i = cursamples % 8;
	            while ((i--) != 0) {
	                rgData.lsum += fsqr(curleftBase[curleft++]);
	                rgData.rsum += fsqr(currightBase[curright++]);
	            }
	            i = cursamples / 8;
	            while ((i--) != 0) {
	                rgData.lsum += fsqr(curleftBase[curleft + 0])
	                    + fsqr(curleftBase[curleft + 1])
	                    + fsqr(curleftBase[curleft + 2])
	                    + fsqr(curleftBase[curleft + 3])
	                    + fsqr(curleftBase[curleft + 4])
	                    + fsqr(curleftBase[curleft + 5])
	                    + fsqr(curleftBase[curleft + 6])
	                    + fsqr(curleftBase[curleft + 7]);
	                curleft += 8;
	                rgData.rsum += fsqr(currightBase[curright + 0])
	                    + fsqr(currightBase[curright + 1])
	                    + fsqr(currightBase[curright + 2])
	                    + fsqr(currightBase[curright + 3])
	                    + fsqr(currightBase[curright + 4])
	                    + fsqr(currightBase[curright + 5])
	                    + fsqr(currightBase[curright + 6])
	                    + fsqr(currightBase[curright + 7]);
	                curright += 8;
	            }
	
	            batchsamples -= cursamples;
	            cursamplepos += cursamples;
	            rgData.totsamp += cursamples;
	            if (rgData.totsamp == rgData.sampleWindow) {
	                /* Get the Root Mean Square (RMS) for this set of samples */
	                var val = GainAnalysis.STEPS_per_dB
	                    * 10.
	                    * Math.log10((rgData.lsum + rgData.rsum)
	                        / rgData.totsamp * 0.5 + 1.e-37);
	                var ival = (val <= 0) ? 0 : 0 | val;
	                if (ival >= rgData.A.length)
	                    ival = rgData.A.length - 1;
	                rgData.A[ival]++;
	                rgData.lsum = rgData.rsum = 0.;
	
	                System.arraycopy(rgData.loutbuf, rgData.totsamp,
	                    rgData.loutbuf, 0, MAX_ORDER);
	                System.arraycopy(rgData.routbuf, rgData.totsamp,
	                    rgData.routbuf, 0, MAX_ORDER);
	                System.arraycopy(rgData.lstepbuf, rgData.totsamp,
	                    rgData.lstepbuf, 0, MAX_ORDER);
	                System.arraycopy(rgData.rstepbuf, rgData.totsamp,
	                    rgData.rstepbuf, 0, MAX_ORDER);
	                rgData.totsamp = 0;
	            }
	            if (rgData.totsamp > rgData.sampleWindow) {
	                /*
	                 * somehow I really screwed up: Error in programming! Contact
	                 * author about totsamp > sampleWindow
	                 */
	                return GAIN_ANALYSIS_ERROR;
	            }
	        }
	        if (num_samples < MAX_ORDER) {
	            System.arraycopy(rgData.linprebuf, num_samples, rgData.linprebuf,
	                0, MAX_ORDER - num_samples);
	            System.arraycopy(rgData.rinprebuf, num_samples, rgData.rinprebuf,
	                0, MAX_ORDER - num_samples);
	            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
	                MAX_ORDER - num_samples, num_samples);
	            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
	                MAX_ORDER - num_samples, num_samples);
	        } else {
	            System.arraycopy(left_samples, left_samplesPos + num_samples
	                - MAX_ORDER, rgData.linprebuf, 0, MAX_ORDER);
	            System.arraycopy(right_samples, right_samplesPos + num_samples
	                - MAX_ORDER, rgData.rinprebuf, 0, MAX_ORDER);
	        }
	
	        return GAIN_ANALYSIS_OK;
	    };
	
	    function analyzeResult(Array, len) {
	        var i;
	
	        var elems = 0;
	        for (i = 0; i < len; i++)
	            elems += Array[i];
	        if (elems == 0)
	            return GAIN_NOT_ENOUGH_SAMPLES;
	
	        var upper = 0 | Math.ceil(elems * (1. - RMS_PERCENTILE));
	        for (i = len; i-- > 0;) {
	            if ((upper -= Array[i]) <= 0)
	                break;
	        }
	
	        //return (float) ((float) PINK_REF - (float) i / (float) STEPS_per_dB);
	        return (PINK_REF - i / GainAnalysis.STEPS_per_dB);
	    }
	
	    this.GetTitleGain = function (rgData) {
	        var retval = analyzeResult(rgData.A, rgData.A.length);
	
	        for (var i = 0; i < rgData.A.length; i++) {
	            rgData.B[i] += rgData.A[i];
	            rgData.A[i] = 0;
	        }
	
	        for (var i = 0; i < MAX_ORDER; i++)
	            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;
	
	        rgData.totsamp = 0;
	        rgData.lsum = rgData.rsum = 0.;
	        return retval;
	    }
	
	}
	
	module.exports = GainAnalysis;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var Encoder = __webpack_require__(21);
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	function III_psy_xmin() {
	    this.l = new_float(Encoder.SBMAX_l);
	    this.s = new_float_n([Encoder.SBMAX_s, 3]);
	
	    var self = this;
	    this.assign = function (iii_psy_xmin) {
	        System.arraycopy(iii_psy_xmin.l, 0, self.l, 0, Encoder.SBMAX_l);
	        for (var i = 0; i < Encoder.SBMAX_s; i++) {
	            for (var j = 0; j < 3; j++) {
	                self.s[i][j] = iii_psy_xmin.s[i][j];
	            }
	        }
	    }
	}
	
	module.exports = III_psy_xmin;


/***/ },
/* 193 */
/***/ function(module, exports) {

	//package mp3;
	
	/* MPEG modes */
	function MPEGMode(ordinal) {
	    var _ordinal = ordinal;
	    this.ordinal = function () {
	        return _ordinal;
	    }
	}
	
	MPEGMode.STEREO = new MPEGMode(0);
	MPEGMode.JOINT_STEREO = new MPEGMode(1);
	MPEGMode.DUAL_CHANNEL = new MPEGMode(2);
	MPEGMode.MONO = new MPEGMode(3);
	MPEGMode.NOT_SET = new MPEGMode(4);
	
	module.exports = MPEGMode;


/***/ },
/* 194 */
/***/ function(module, exports) {

	function MeanBits(meanBits) {
	    this.bits = meanBits;
	}
	
	module.exports = MeanBits;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *      quantize_pvt source file
	 *
	 *      Copyright (c) 1999-2002 Takehiro Tominaga
	 *      Copyright (c) 2000-2002 Robert Hegemann
	 *      Copyright (c) 2001 Naoki Shibata
	 *      Copyright (c) 2002-2005 Gabriel Bouvigne
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Lesser General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	
	/* $Id: QuantizePVT.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */
	var ScaleFac = __webpack_require__(196);
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	var MeanBits = __webpack_require__(194);
	var LameInternalFlags = __webpack_require__(87);
	
	QuantizePVT.Q_MAX = (256 + 1);
	QuantizePVT.Q_MAX2 = 116;
	QuantizePVT.LARGE_BITS = 100000;
	QuantizePVT.IXMAX_VAL = 8206;
	
	function QuantizePVT() {
	
	    var tak = null;
	    var rv = null;
	    var psy = null;
	
	    this.setModules = function (_tk, _rv, _psy) {
	        tak = _tk;
	        rv = _rv;
	        psy = _psy;
	    };
	
	    function POW20(x) {
	        assert(0 <= (x + QuantizePVT.Q_MAX2) && x < QuantizePVT.Q_MAX);
	        return pow20[x + QuantizePVT.Q_MAX2];
	    }
	
	    this.IPOW20 = function (x) {
	        assert(0 <= x && x < QuantizePVT.Q_MAX);
	        return ipow20[x];
	    }
	
	    /**
	     * smallest such that 1.0+DBL_EPSILON != 1.0
	     */
	    var DBL_EPSILON = 2.2204460492503131e-016;
	
	    /**
	     * ix always <= 8191+15. see count_bits()
	     */
	    var IXMAX_VAL = QuantizePVT.IXMAX_VAL;
	
	    var PRECALC_SIZE = (IXMAX_VAL + 2);
	
	    var Q_MAX = QuantizePVT.Q_MAX;
	
	
	    /**
	     * <CODE>
	     * minimum possible number of
	     * -cod_info.global_gain + ((scalefac[] + (cod_info.preflag ? pretab[sfb] : 0))
	     * << (cod_info.scalefac_scale + 1)) + cod_info.subblock_gain[cod_info.window[sfb]] * 8;
	     *
	     * for long block, 0+((15+3)<<2) = 18*4 = 72
	     * for short block, 0+(15<<2)+7*8 = 15*4+56 = 116
	     * </CODE>
	     */
	    var Q_MAX2 = QuantizePVT.Q_MAX2;
	
	    var LARGE_BITS = QuantizePVT.LARGE_BITS;
	
	
	    /**
	     * Assuming dynamic range=96dB, this value should be 92
	     */
	    var NSATHSCALE = 100;
	
	    /**
	     * The following table is used to implement the scalefactor partitioning for
	     * MPEG2 as described in section 2.4.3.2 of the IS. The indexing corresponds
	     * to the way the tables are presented in the IS:
	     *
	     * [table_number][row_in_table][column of nr_of_sfb]
	     */
	    this.nr_of_sfb_block = [
	        [[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]],
	        [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]],
	        [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]],
	        [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]],
	        [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]],
	        [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];
	
	    /**
	     * Table B.6: layer3 preemphasis
	     */
	    var pretab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1,
	        2, 2, 3, 3, 3, 2, 0];
	    this.pretab = pretab;
	
	    /**
	     * Here are MPEG1 Table B.8 and MPEG2 Table B.1 -- Layer III scalefactor
	     * bands. <BR>
	     * Index into this using a method such as:<BR>
	     * idx = fr_ps.header.sampling_frequency + (fr_ps.header.version * 3)
	     */
	    this.sfBandIndex = [
	        // Table B.2.b: 22.05 kHz
	        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
	                522, 576],
	            [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192]
	            , [0, 0, 0, 0, 0, 0, 0] //  sfb21 pseudo sub bands
	            , [0, 0, 0, 0, 0, 0, 0] //  sfb12 pseudo sub bands
	        ),
	        /* Table B.2.c: 24 kHz */ /* docs: 332. mpg123(broken): 330 */
	        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464,
	                540, 576],
	            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* Table B.2.a: 16 kHz */
	        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
	                522, 576],
	            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* Table B.8.b: 44.1 kHz */
	        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418,
	                576],
	            [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* Table B.8.c: 48 kHz */
	        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384,
	                576],
	            [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* Table B.8.a: 32 kHz */
	        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550,
	                576],
	            [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* MPEG-2.5 11.025 kHz */
	        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
	                522, 576],
	            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
	                402 / 3, 522 / 3, 576 / 3]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* MPEG-2.5 12 kHz */
	        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
	                522, 576],
	            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
	                402 / 3, 522 / 3, 576 / 3]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        ),
	        /* MPEG-2.5 8 kHz */
	        new ScaleFac([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570,
	                572, 574, 576],
	            [0 / 3, 24 / 3, 48 / 3, 72 / 3, 108 / 3, 156 / 3, 216 / 3, 288 / 3, 372 / 3, 480 / 3, 486 / 3,
	                492 / 3, 498 / 3, 576 / 3]
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
	            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
	        )
	    ];
	
	    var pow20 = new_float(Q_MAX + Q_MAX2 + 1);
	    var ipow20 = new_float(Q_MAX);
	    var pow43 = new_float(PRECALC_SIZE);
	
	    var adj43 = new_float(PRECALC_SIZE);
	    this.adj43 = adj43;
	
	    /**
	     * <PRE>
	     * compute the ATH for each scalefactor band cd range: 0..96db
	     *
	     * Input: 3.3kHz signal 32767 amplitude (3.3kHz is where ATH is smallest =
	     * -5db) longblocks: sfb=12 en0/bw=-11db max_en0 = 1.3db shortblocks: sfb=5
	     * -9db 0db
	     *
	     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) longblocks: amp=1
	     * sfb=12 en0/bw=-103 db max_en0 = -92db amp=32767 sfb=12 -12 db -1.4db
	     *
	     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) shortblocks: amp=1
	     * sfb=5 en0/bw= -99 -86 amp=32767 sfb=5 -9 db 4db
	     *
	     *
	     * MAX energy of largest wave at 3.3kHz = 1db AVE energy of largest wave at
	     * 3.3kHz = -11db Let's take AVE: -11db = maximum signal in sfb=12. Dynamic
	     * range of CD: 96db. Therefor energy of smallest audible wave in sfb=12 =
	     * -11 - 96 = -107db = ATH at 3.3kHz.
	     *
	     * ATH formula for this wave: -5db. To adjust to LAME scaling, we need ATH =
	     * ATH_formula - 103 (db) ATH = ATH * 2.5e-10 (ener)
	     * </PRE>
	     */
	    function ATHmdct(gfp, f) {
	        var ath = psy.ATHformula(f, gfp);
	
	        ath -= NSATHSCALE;
	
	        /* modify the MDCT scaling for the ATH and convert to energy */
	        ath = Math.pow(10.0, ath / 10.0 + gfp.ATHlower);
	        return ath;
	    }
	
	    function compute_ath(gfp) {
	        var ATH_l = gfp.internal_flags.ATH.l;
	        var ATH_psfb21 = gfp.internal_flags.ATH.psfb21;
	        var ATH_s = gfp.internal_flags.ATH.s;
	        var ATH_psfb12 = gfp.internal_flags.ATH.psfb12;
	        var gfc = gfp.internal_flags;
	        var samp_freq = gfp.out_samplerate;
	
	        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
	            var start = gfc.scalefac_band.l[sfb];
	            var end = gfc.scalefac_band.l[sfb + 1];
	            ATH_l[sfb] = Float.MAX_VALUE;
	            for (var i = start; i < end; i++) {
	                var freq = i * samp_freq / (2 * 576);
	                var ATH_f = ATHmdct(gfp, freq);
	                /* freq in kHz */
	                ATH_l[sfb] = Math.min(ATH_l[sfb], ATH_f);
	            }
	        }
	
	        for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
	            var start = gfc.scalefac_band.psfb21[sfb];
	            var end = gfc.scalefac_band.psfb21[sfb + 1];
	            ATH_psfb21[sfb] = Float.MAX_VALUE;
	            for (var i = start; i < end; i++) {
	                var freq = i * samp_freq / (2 * 576);
	                var ATH_f = ATHmdct(gfp, freq);
	                /* freq in kHz */
	                ATH_psfb21[sfb] = Math.min(ATH_psfb21[sfb], ATH_f);
	            }
	        }
	
	        for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
	            var start = gfc.scalefac_band.s[sfb];
	            var end = gfc.scalefac_band.s[sfb + 1];
	            ATH_s[sfb] = Float.MAX_VALUE;
	            for (var i = start; i < end; i++) {
	                var freq = i * samp_freq / (2 * 192);
	                var ATH_f = ATHmdct(gfp, freq);
	                /* freq in kHz */
	                ATH_s[sfb] = Math.min(ATH_s[sfb], ATH_f);
	            }
	            ATH_s[sfb] *= (gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb]);
	        }
	
	        for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
	            var start = gfc.scalefac_band.psfb12[sfb];
	            var end = gfc.scalefac_band.psfb12[sfb + 1];
	            ATH_psfb12[sfb] = Float.MAX_VALUE;
	            for (var i = start; i < end; i++) {
	                var freq = i * samp_freq / (2 * 192);
	                var ATH_f = ATHmdct(gfp, freq);
	                /* freq in kHz */
	                ATH_psfb12[sfb] = Math.min(ATH_psfb12[sfb], ATH_f);
	            }
	            /* not sure about the following */
	            ATH_psfb12[sfb] *= (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]);
	        }
	
	        /*
	         * no-ATH mode: reduce ATH to -200 dB
	         */
	        if (gfp.noATH) {
	            for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
	                ATH_l[sfb] = 1E-20;
	            }
	            for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
	                ATH_psfb21[sfb] = 1E-20;
	            }
	            for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
	                ATH_s[sfb] = 1E-20;
	            }
	            for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
	                ATH_psfb12[sfb] = 1E-20;
	            }
	        }
	
	        /*
	         * work in progress, don't rely on it too much
	         */
	        gfc.ATH.floor = 10. * Math.log10(ATHmdct(gfp, -1.));
	    }
	
	    /**
	     * initialization for iteration_loop
	     */
	    this.iteration_init = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var l3_side = gfc.l3_side;
	        var i;
	
	        if (gfc.iteration_init_init == 0) {
	            gfc.iteration_init_init = 1;
	
	            l3_side.main_data_begin = 0;
	            compute_ath(gfp);
	
	            pow43[0] = 0.0;
	            for (i = 1; i < PRECALC_SIZE; i++)
	                pow43[i] = Math.pow(i, 4.0 / 3.0);
	
	            for (i = 0; i < PRECALC_SIZE - 1; i++)
	                adj43[i] = ((i + 1) - Math.pow(
	                    0.5 * (pow43[i] + pow43[i + 1]), 0.75));
	            adj43[i] = 0.5;
	
	            for (i = 0; i < Q_MAX; i++)
	                ipow20[i] = Math.pow(2.0, (i - 210) * -0.1875);
	            for (i = 0; i <= Q_MAX + Q_MAX2; i++)
	                pow20[i] = Math.pow(2.0, (i - 210 - Q_MAX2) * 0.25);
	
	            tak.huffman_init(gfc);
	
	            {
	                var bass, alto, treble, sfb21;
	
	                i = (gfp.exp_nspsytune >> 2) & 63;
	                if (i >= 32)
	                    i -= 64;
	                bass = Math.pow(10, i / 4.0 / 10.0);
	
	                i = (gfp.exp_nspsytune >> 8) & 63;
	                if (i >= 32)
	                    i -= 64;
	                alto = Math.pow(10, i / 4.0 / 10.0);
	
	                i = (gfp.exp_nspsytune >> 14) & 63;
	                if (i >= 32)
	                    i -= 64;
	                treble = Math.pow(10, i / 4.0 / 10.0);
	
	                /*
	                 * to be compatible with Naoki's original code, the next 6 bits
	                 * define only the amount of changing treble for sfb21
	                 */
	                i = (gfp.exp_nspsytune >> 20) & 63;
	                if (i >= 32)
	                    i -= 64;
	                sfb21 = treble * Math.pow(10, i / 4.0 / 10.0);
	                for (i = 0; i < Encoder.SBMAX_l; i++) {
	                    var f;
	                    if (i <= 6)
	                        f = bass;
	                    else if (i <= 13)
	                        f = alto;
	                    else if (i <= 20)
	                        f = treble;
	                    else
	                        f = sfb21;
	
	                    gfc.nsPsy.longfact[i] = f;
	                }
	                for (i = 0; i < Encoder.SBMAX_s; i++) {
	                    var f;
	                    if (i <= 5)
	                        f = bass;
	                    else if (i <= 10)
	                        f = alto;
	                    else if (i <= 11)
	                        f = treble;
	                    else
	                        f = sfb21;
	
	                    gfc.nsPsy.shortfact[i] = f;
	                }
	            }
	        }
	    }
	
	    /**
	     * allocate bits among 2 channels based on PE<BR>
	     * mt 6/99<BR>
	     * bugfixes rh 8/01: often allocated more than the allowed 4095 bits
	     */
	    this.on_pe = function (gfp, pe,
	                           targ_bits, mean_bits, gr, cbr) {
	        var gfc = gfp.internal_flags;
	        var tbits = 0, bits;
	        var add_bits = new_int(2);
	        var ch;
	
	        /* allocate targ_bits for granule */
	        var mb = new MeanBits(tbits);
	        var extra_bits = rv.ResvMaxBits(gfp, mean_bits, mb, cbr);
	        tbits = mb.bits;
	        /* maximum allowed bits for this granule */
	        var max_bits = tbits + extra_bits;
	        if (max_bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
	            // hard limit per granule
	            max_bits = LameInternalFlags.MAX_BITS_PER_GRANULE;
	        }
	        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
	            /******************************************************************
	             * allocate bits for each channel
	             ******************************************************************/
	            targ_bits[ch] = Math.min(LameInternalFlags.MAX_BITS_PER_CHANNEL,
	                tbits / gfc.channels_out);
	
	            add_bits[ch] = 0 | (targ_bits[ch] * pe[gr][ch] / 700.0 - targ_bits[ch]);
	
	            /* at most increase bits by 1.5*average */
	            if (add_bits[ch] > mean_bits * 3 / 4)
	                add_bits[ch] = mean_bits * 3 / 4;
	            if (add_bits[ch] < 0)
	                add_bits[ch] = 0;
	
	            if (add_bits[ch] + targ_bits[ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
	                add_bits[ch] = Math.max(0,
	                    LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[ch]);
	
	            bits += add_bits[ch];
	        }
	        if (bits > extra_bits) {
	            for (ch = 0; ch < gfc.channels_out; ++ch) {
	                add_bits[ch] = extra_bits * add_bits[ch] / bits;
	            }
	        }
	
	        for (ch = 0; ch < gfc.channels_out; ++ch) {
	            targ_bits[ch] += add_bits[ch];
	            extra_bits -= add_bits[ch];
	        }
	
	        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
	            bits += targ_bits[ch];
	        }
	        if (bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
	            var sum = 0;
	            for (ch = 0; ch < gfc.channels_out; ++ch) {
	                targ_bits[ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
	                targ_bits[ch] /= bits;
	                sum += targ_bits[ch];
	            }
	            assert(sum <= LameInternalFlags.MAX_BITS_PER_GRANULE);
	        }
	
	        return max_bits;
	    }
	
	    this.reduce_side = function (targ_bits, ms_ener_ratio, mean_bits, max_bits) {
	        assert(max_bits <= LameInternalFlags.MAX_BITS_PER_GRANULE);
	        assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);
	
	        /*
	         * ms_ener_ratio = 0: allocate 66/33 mid/side fac=.33 ms_ener_ratio =.5:
	         * allocate 50/50 mid/side fac= 0
	         */
	        /* 75/25 split is fac=.5 */
	        var fac = .33 * (.5 - ms_ener_ratio) / .5;
	        if (fac < 0)
	            fac = 0;
	        if (fac > .5)
	            fac = .5;
	
	        /* number of bits to move from side channel to mid channel */
	        /* move_bits = fac*targ_bits[1]; */
	        var move_bits = 0 | (fac * .5 * (targ_bits[0] + targ_bits[1]));
	
	        if (move_bits > LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0]) {
	            move_bits = LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0];
	        }
	        if (move_bits < 0)
	            move_bits = 0;
	
	        if (targ_bits[1] >= 125) {
	            /* dont reduce side channel below 125 bits */
	            if (targ_bits[1] - move_bits > 125) {
	
	                /* if mid channel already has 2x more than average, dont bother */
	                /* mean_bits = bits per granule (for both channels) */
	                if (targ_bits[0] < mean_bits)
	                    targ_bits[0] += move_bits;
	                targ_bits[1] -= move_bits;
	            } else {
	                targ_bits[0] += targ_bits[1] - 125;
	                targ_bits[1] = 125;
	            }
	        }
	
	        move_bits = targ_bits[0] + targ_bits[1];
	        if (move_bits > max_bits) {
	            targ_bits[0] = (max_bits * targ_bits[0]) / move_bits;
	            targ_bits[1] = (max_bits * targ_bits[1]) / move_bits;
	        }
	        assert(targ_bits[0] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
	        assert(targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
	        assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);
	    };
	
	    /**
	     *  Robert Hegemann 2001-04-27:
	     *  this adjusts the ATH, keeping the original noise floor
	     *  affects the higher frequencies more than the lower ones
	     */
	    this.athAdjust = function (a, x, athFloor) {
	        /*
	         * work in progress
	         */
	        var o = 90.30873362;
	        var p = 94.82444863;
	        var u = Util.FAST_LOG10_X(x, 10.0);
	        var v = a * a;
	        var w = 0.0;
	        u -= athFloor;
	        /* undo scaling */
	        if (v > 1E-20)
	            w = 1. + Util.FAST_LOG10_X(v, 10.0 / o);
	        if (w < 0)
	            w = 0.;
	        u *= w;
	        u += athFloor + o - p;
	        /* redo scaling */
	
	        return Math.pow(10., 0.1 * u);
	    };
	
	    /**
	     * Calculate the allowed distortion for each scalefactor band, as determined
	     * by the psychoacoustic model. xmin(sb) = ratio(sb) * en(sb) / bw(sb)
	     *
	     * returns number of sfb's with energy > ATH
	     */
	    this.calc_xmin = function (gfp, ratio, cod_info, pxmin) {
	        var pxminPos = 0;
	        var gfc = gfp.internal_flags;
	        var gsfb, j = 0, ath_over = 0;
	        var ATH = gfc.ATH;
	        var xr = cod_info.xr;
	        var enable_athaa_fix = (gfp.VBR == VbrMode.vbr_mtrh) ? 1 : 0;
	        var masking_lower = gfc.masking_lower;
	
	        if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
	            /* was already done in PSY-Model */
	            masking_lower = 1.0;
	        }
	
	        for (gsfb = 0; gsfb < cod_info.psy_lmax; gsfb++) {
	            var en0, xmin;
	            var rh1, rh2;
	            var width, l;
	
	            if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
	                xmin = athAdjust(ATH.adjust, ATH.l[gsfb], ATH.floor);
	            else
	                xmin = ATH.adjust * ATH.l[gsfb];
	
	            width = cod_info.width[gsfb];
	            rh1 = xmin / width;
	            rh2 = DBL_EPSILON;
	            l = width >> 1;
	            en0 = 0.0;
	            do {
	                var xa, xb;
	                xa = xr[j] * xr[j];
	                en0 += xa;
	                rh2 += (xa < rh1) ? xa : rh1;
	                j++;
	                xb = xr[j] * xr[j];
	                en0 += xb;
	                rh2 += (xb < rh1) ? xb : rh1;
	                j++;
	            } while (--l > 0);
	            if (en0 > xmin)
	                ath_over++;
	
	            if (gsfb == Encoder.SBPSY_l) {
	                var x = xmin * gfc.nsPsy.longfact[gsfb];
	                if (rh2 < x) {
	                    rh2 = x;
	                }
	            }
	            if (enable_athaa_fix != 0) {
	                xmin = rh2;
	            }
	            if (!gfp.ATHonly) {
	                var e = ratio.en.l[gsfb];
	                if (e > 0.0) {
	                    var x;
	                    x = en0 * ratio.thm.l[gsfb] * masking_lower / e;
	                    if (enable_athaa_fix != 0)
	                        x *= gfc.nsPsy.longfact[gsfb];
	                    if (xmin < x)
	                        xmin = x;
	                }
	            }
	            if (enable_athaa_fix != 0)
	                pxmin[pxminPos++] = xmin;
	            else
	                pxmin[pxminPos++] = xmin * gfc.nsPsy.longfact[gsfb];
	        }
	        /* end of long block loop */
	
	        /* use this function to determine the highest non-zero coeff */
	        var max_nonzero = 575;
	        if (cod_info.block_type != Encoder.SHORT_TYPE) {
	            // NORM, START or STOP type, but not SHORT
	            var k = 576;
	            while (k-- != 0 && BitStream.EQ(xr[k], 0)) {
	                max_nonzero = k;
	            }
	        }
	        cod_info.max_nonzero_coeff = max_nonzero;
	
	        for (var sfb = cod_info.sfb_smin; gsfb < cod_info.psymax; sfb++, gsfb += 3) {
	            var width, b;
	            var tmpATH;
	            if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
	                tmpATH = athAdjust(ATH.adjust, ATH.s[sfb], ATH.floor);
	            else
	                tmpATH = ATH.adjust * ATH.s[sfb];
	
	            width = cod_info.width[gsfb];
	            for (b = 0; b < 3; b++) {
	                var en0 = 0.0, xmin;
	                var rh1, rh2;
	                var l = width >> 1;
	
	                rh1 = tmpATH / width;
	                rh2 = DBL_EPSILON;
	                do {
	                    var xa, xb;
	                    xa = xr[j] * xr[j];
	                    en0 += xa;
	                    rh2 += (xa < rh1) ? xa : rh1;
	                    j++;
	                    xb = xr[j] * xr[j];
	                    en0 += xb;
	                    rh2 += (xb < rh1) ? xb : rh1;
	                    j++;
	                } while (--l > 0);
	                if (en0 > tmpATH)
	                    ath_over++;
	                if (sfb == Encoder.SBPSY_s) {
	                    var x = tmpATH * gfc.nsPsy.shortfact[sfb];
	                    if (rh2 < x) {
	                        rh2 = x;
	                    }
	                }
	                if (enable_athaa_fix != 0)
	                    xmin = rh2;
	                else
	                    xmin = tmpATH;
	
	                if (!gfp.ATHonly && !gfp.ATHshort) {
	                    var e = ratio.en.s[sfb][b];
	                    if (e > 0.0) {
	                        var x;
	                        x = en0 * ratio.thm.s[sfb][b] * masking_lower / e;
	                        if (enable_athaa_fix != 0)
	                            x *= gfc.nsPsy.shortfact[sfb];
	                        if (xmin < x)
	                            xmin = x;
	                    }
	                }
	                if (enable_athaa_fix != 0)
	                    pxmin[pxminPos++] = xmin;
	                else
	                    pxmin[pxminPos++] = xmin * gfc.nsPsy.shortfact[sfb];
	            }
	            /* b */
	            if (gfp.useTemporal) {
	                if (pxmin[pxminPos - 3] > pxmin[pxminPos - 3 + 1])
	                    pxmin[pxminPos - 3 + 1] += (pxmin[pxminPos - 3] - pxmin[pxminPos - 3 + 1])
	                        * gfc.decay;
	                if (pxmin[pxminPos - 3 + 1] > pxmin[pxminPos - 3 + 2])
	                    pxmin[pxminPos - 3 + 2] += (pxmin[pxminPos - 3 + 1] - pxmin[pxminPos - 3 + 2])
	                        * gfc.decay;
	            }
	        }
	        /* end of short block sfb loop */
	
	        return ath_over;
	    };
	
	    function StartLine(j) {
	        this.s = j;
	    }
	
	    this.calc_noise_core = function (cod_info, startline, l, step) {
	        var noise = 0;
	        var j = startline.s;
	        var ix = cod_info.l3_enc;
	
	        if (j > cod_info.count1) {
	            while ((l--) != 0) {
	                var temp;
	                temp = cod_info.xr[j];
	                j++;
	                noise += temp * temp;
	                temp = cod_info.xr[j];
	                j++;
	                noise += temp * temp;
	            }
	        } else if (j > cod_info.big_values) {
	            var ix01 = new_float(2);
	            ix01[0] = 0;
	            ix01[1] = step;
	            while ((l--) != 0) {
	                var temp;
	                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
	                j++;
	                noise += temp * temp;
	                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
	                j++;
	                noise += temp * temp;
	            }
	        } else {
	            while ((l--) != 0) {
	                var temp;
	                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
	                j++;
	                noise += temp * temp;
	                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
	                j++;
	                noise += temp * temp;
	            }
	        }
	
	        startline.s = j;
	        return noise;
	    }
	
	    /**
	     * <PRE>
	     * -oo dB  =>  -1.00
	     * - 6 dB  =>  -0.97
	     * - 3 dB  =>  -0.80
	     * - 2 dB  =>  -0.64
	     * - 1 dB  =>  -0.38
	     *   0 dB  =>   0.00
	     * + 1 dB  =>  +0.49
	     * + 2 dB  =>  +1.06
	     * + 3 dB  =>  +1.68
	     * + 6 dB  =>  +3.69
	     * +10 dB  =>  +6.45
	     * </PRE>
	     */
	    this.calc_noise = function (cod_info, l3_xmin, distort, res, prev_noise) {
	        var distortPos = 0;
	        var l3_xminPos = 0;
	        var sfb, l, over = 0;
	        var over_noise_db = 0;
	        /* 0 dB relative to masking */
	        var tot_noise_db = 0;
	        /* -200 dB relative to masking */
	        var max_noise = -20.0;
	        var j = 0;
	        var scalefac = cod_info.scalefac;
	        var scalefacPos = 0;
	
	        res.over_SSD = 0;
	
	        for (sfb = 0; sfb < cod_info.psymax; sfb++) {
	            var s = cod_info.global_gain
	                - (((scalefac[scalefacPos++]) + (cod_info.preflag != 0 ? pretab[sfb]
	                    : 0)) << (cod_info.scalefac_scale + 1))
	                - cod_info.subblock_gain[cod_info.window[sfb]] * 8;
	            var noise = 0.0;
	
	            if (prev_noise != null && (prev_noise.step[sfb] == s)) {
	
	                /* use previously computed values */
	                noise = prev_noise.noise[sfb];
	                j += cod_info.width[sfb];
	                distort[distortPos++] = noise / l3_xmin[l3_xminPos++];
	
	                noise = prev_noise.noise_log[sfb];
	
	            } else {
	                var step = POW20(s);
	                l = cod_info.width[sfb] >> 1;
	
	                if ((j + cod_info.width[sfb]) > cod_info.max_nonzero_coeff) {
	                    var usefullsize;
	                    usefullsize = cod_info.max_nonzero_coeff - j + 1;
	
	                    if (usefullsize > 0)
	                        l = usefullsize >> 1;
	                    else
	                        l = 0;
	                }
	
	                var sl = new StartLine(j);
	                noise = this.calc_noise_core(cod_info, sl, l, step);
	                j = sl.s;
	
	                if (prev_noise != null) {
	                    /* save noise values */
	                    prev_noise.step[sfb] = s;
	                    prev_noise.noise[sfb] = noise;
	                }
	
	                noise = distort[distortPos++] = noise / l3_xmin[l3_xminPos++];
	
	                /* multiplying here is adding in dB, but can overflow */
	                noise = Util.FAST_LOG10(Math.max(noise, 1E-20));
	
	                if (prev_noise != null) {
	                    /* save noise values */
	                    prev_noise.noise_log[sfb] = noise;
	                }
	            }
	
	            if (prev_noise != null) {
	                /* save noise values */
	                prev_noise.global_gain = cod_info.global_gain;
	            }
	
	            tot_noise_db += noise;
	
	            if (noise > 0.0) {
	                var tmp;
	
	                tmp = Math.max(0 | (noise * 10 + .5), 1);
	                res.over_SSD += tmp * tmp;
	
	                over++;
	                /* multiplying here is adding in dB -but can overflow */
	                /* over_noise *= noise; */
	                over_noise_db += noise;
	            }
	            max_noise = Math.max(max_noise, noise);
	
	        }
	
	        res.over_count = over;
	        res.tot_noise = tot_noise_db;
	        res.over_noise = over_noise_db;
	        res.max_noise = max_noise;
	
	        return over;
	    }
	
	    /**
	     * updates plotting data
	     *
	     * Mark Taylor 2000-??-??
	     *
	     * Robert Hegemann: moved noise/distortion calc into it
	     */
	    this.set_pinfo = function (gfp, cod_info, ratio, gr, ch) {
	        var gfc = gfp.internal_flags;
	        var sfb, sfb2;
	        var l;
	        var en0, en1;
	        var ifqstep = (cod_info.scalefac_scale == 0) ? .5 : 1.0;
	        var scalefac = cod_info.scalefac;
	
	        var l3_xmin = new_float(L3Side.SFBMAX);
	        var xfsf = new_float(L3Side.SFBMAX);
	        var noise = new CalcNoiseResult();
	
	        calc_xmin(gfp, ratio, cod_info, l3_xmin);
	        calc_noise(cod_info, l3_xmin, xfsf, noise, null);
	
	        var j = 0;
	        sfb2 = cod_info.sfb_lmax;
	        if (cod_info.block_type != Encoder.SHORT_TYPE
	            && 0 == cod_info.mixed_block_flag)
	            sfb2 = 22;
	        for (sfb = 0; sfb < sfb2; sfb++) {
	            var start = gfc.scalefac_band.l[sfb];
	            var end = gfc.scalefac_band.l[sfb + 1];
	            var bw = end - start;
	            for (en0 = 0.0; j < end; j++)
	                en0 += cod_info.xr[j] * cod_info.xr[j];
	            en0 /= bw;
	            /* convert to MDCT units */
	            /* scaling so it shows up on FFT plot */
	            en1 = 1e15;
	            gfc.pinfo.en[gr][ch][sfb] = en1 * en0;
	            gfc.pinfo.xfsf[gr][ch][sfb] = en1 * l3_xmin[sfb] * xfsf[sfb] / bw;
	
	            if (ratio.en.l[sfb] > 0 && !gfp.ATHonly)
	                en0 = en0 / ratio.en.l[sfb];
	            else
	                en0 = 0.0;
	
	            gfc.pinfo.thr[gr][ch][sfb] = en1
	                * Math.max(en0 * ratio.thm.l[sfb], gfc.ATH.l[sfb]);
	
	            /* there is no scalefactor bands >= SBPSY_l */
	            gfc.pinfo.LAMEsfb[gr][ch][sfb] = 0;
	            if (cod_info.preflag != 0 && sfb >= 11)
	                gfc.pinfo.LAMEsfb[gr][ch][sfb] = -ifqstep * pretab[sfb];
	
	            if (sfb < Encoder.SBPSY_l) {
	                /* scfsi should be decoded by caller side */
	                assert(scalefac[sfb] >= 0);
	                gfc.pinfo.LAMEsfb[gr][ch][sfb] -= ifqstep * scalefac[sfb];
	            }
	        }
	        /* for sfb */
	
	        if (cod_info.block_type == Encoder.SHORT_TYPE) {
	            sfb2 = sfb;
	            for (sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
	                var start = gfc.scalefac_band.s[sfb];
	                var end = gfc.scalefac_band.s[sfb + 1];
	                var bw = end - start;
	                for (var i = 0; i < 3; i++) {
	                    for (en0 = 0.0, l = start; l < end; l++) {
	                        en0 += cod_info.xr[j] * cod_info.xr[j];
	                        j++;
	                    }
	                    en0 = Math.max(en0 / bw, 1e-20);
	                    /* convert to MDCT units */
	                    /* scaling so it shows up on FFT plot */
	                    en1 = 1e15;
	
	                    gfc.pinfo.en_s[gr][ch][3 * sfb + i] = en1 * en0;
	                    gfc.pinfo.xfsf_s[gr][ch][3 * sfb + i] = en1 * l3_xmin[sfb2]
	                        * xfsf[sfb2] / bw;
	                    if (ratio.en.s[sfb][i] > 0)
	                        en0 = en0 / ratio.en.s[sfb][i];
	                    else
	                        en0 = 0.0;
	                    if (gfp.ATHonly || gfp.ATHshort)
	                        en0 = 0;
	
	                    gfc.pinfo.thr_s[gr][ch][3 * sfb + i] = en1
	                        * Math.max(en0 * ratio.thm.s[sfb][i],
	                            gfc.ATH.s[sfb]);
	
	                    /* there is no scalefactor bands >= SBPSY_s */
	                    gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] = -2.0
	                        * cod_info.subblock_gain[i];
	                    if (sfb < Encoder.SBPSY_s) {
	                        gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] -= ifqstep
	                            * scalefac[sfb2];
	                    }
	                    sfb2++;
	                }
	            }
	        }
	        /* block type short */
	        gfc.pinfo.LAMEqss[gr][ch] = cod_info.global_gain;
	        gfc.pinfo.LAMEmainbits[gr][ch] = cod_info.part2_3_length
	            + cod_info.part2_length;
	        gfc.pinfo.LAMEsfbits[gr][ch] = cod_info.part2_length;
	
	        gfc.pinfo.over[gr][ch] = noise.over_count;
	        gfc.pinfo.max_noise[gr][ch] = noise.max_noise * 10.0;
	        gfc.pinfo.over_noise[gr][ch] = noise.over_noise * 10.0;
	        gfc.pinfo.tot_noise[gr][ch] = noise.tot_noise * 10.0;
	        gfc.pinfo.over_SSD[gr][ch] = noise.over_SSD;
	    }
	
	    /**
	     * updates plotting data for a whole frame
	     *
	     * Robert Hegemann 2000-10-21
	     */
	    function set_frame_pinfo(gfp, ratio) {
	        var gfc = gfp.internal_flags;
	
	        gfc.masking_lower = 1.0;
	
	        /*
	         * for every granule and channel patch l3_enc and set info
	         */
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            for (var ch = 0; ch < gfc.channels_out; ch++) {
	                var cod_info = gfc.l3_side.tt[gr][ch];
	                var scalefac_sav = new_int(L3Side.SFBMAX);
	                System.arraycopy(cod_info.scalefac, 0, scalefac_sav, 0,
	                    scalefac_sav.length);
	
	                /*
	                 * reconstruct the scalefactors in case SCFSI was used
	                 */
	                if (gr == 1) {
	                    var sfb;
	                    for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
	                        if (cod_info.scalefac[sfb] < 0) /* scfsi */
	                            cod_info.scalefac[sfb] = gfc.l3_side.tt[0][ch].scalefac[sfb];
	                    }
	                }
	
	                set_pinfo(gfp, cod_info, ratio[gr][ch], gr, ch);
	                System.arraycopy(scalefac_sav, 0, cod_info.scalefac, 0,
	                    scalefac_sav.length);
	            }
	            /* for ch */
	        }
	        /* for gr */
	    }
	
	}
	
	module.exports = QuantizePVT;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//package mp3;
	
	/**
	 * Layer III side information.
	 *
	 * @author Ken
	 *
	 */
	
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	
	function ScaleFac(arrL, arrS, arr21, arr12) {
	
	    this.l = new_int(1 + Encoder.SBMAX_l);
	    this.s = new_int(1 + Encoder.SBMAX_s);
	    this.psfb21 = new_int(1 + Encoder.PSFB21);
	    this.psfb12 = new_int(1 + Encoder.PSFB12);
	    var l = this.l;
	    var s = this.s;
	
	    if (arguments.length == 4) {
	        //public ScaleFac(final int[] arrL, final int[] arrS, final int[] arr21,
	        //    final int[] arr12) {
	        this.arrL = arguments[0];
	        this.arrS = arguments[1];
	        this.arr21 = arguments[2];
	        this.arr12 = arguments[3];
	
	        System.arraycopy(this.arrL, 0, l, 0, Math.min(this.arrL.length, this.l.length));
	        System.arraycopy(this.arrS, 0, s, 0, Math.min(this.arrS.length, this.s.length));
	        System.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length));
	        System.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length));
	    }
	}
	
	module.exports = ScaleFac;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *	MP3 huffman table selecting and bit counting
	 *
	 *	Copyright (c) 1999-2005 Takehiro TOMINAGA
	 *	Copyright (c) 2002-2005 Gabriel Bouvigne
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.	 See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Lesser General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	
	/* $Id: Takehiro.java,v 1.26 2011/05/24 20:48:06 kenchis Exp $ */
	
	//package mp3;
	
	//import java.util.Arrays;
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	var Tables = __webpack_require__(125);
	var GrInfo = __webpack_require__(124);
	var QuantizePVT = __webpack_require__(195);
	
	
	function Takehiro() {
	
	    var qupvt = null;
	    this.qupvt = null;
	
	    this.setModules = function (_qupvt) {
	        this.qupvt = _qupvt;
	        qupvt = _qupvt;
	    }
	
	    function Bits(b) {
	        this.bits = 0 | b;
	    }
	
	    var subdv_table = [[0, 0], /* 0 bands */
	        [0, 0], /* 1 bands */
	        [0, 0], /* 2 bands */
	        [0, 0], /* 3 bands */
	        [0, 0], /* 4 bands */
	        [0, 1], /* 5 bands */
	        [1, 1], /* 6 bands */
	        [1, 1], /* 7 bands */
	        [1, 2], /* 8 bands */
	        [2, 2], /* 9 bands */
	        [2, 3], /* 10 bands */
	        [2, 3], /* 11 bands */
	        [3, 4], /* 12 bands */
	        [3, 4], /* 13 bands */
	        [3, 4], /* 14 bands */
	        [4, 5], /* 15 bands */
	        [4, 5], /* 16 bands */
	        [4, 6], /* 17 bands */
	        [5, 6], /* 18 bands */
	        [5, 6], /* 19 bands */
	        [5, 7], /* 20 bands */
	        [6, 7], /* 21 bands */
	        [6, 7], /* 22 bands */
	    ];
	
	    /**
	     * nonlinear quantization of xr More accurate formula than the ISO formula.
	     * Takes into account the fact that we are quantizing xr . ix, but we want
	     * ix^4/3 to be as close as possible to x^4/3. (taking the nearest int would
	     * mean ix is as close as possible to xr, which is different.)
	     *
	     * From Segher Boessenkool <segher@eastsite.nl> 11/1999
	     *
	     * 09/2000: ASM code removed in favor of IEEE754 hack by Takehiro Tominaga.
	     * If you need the ASM code, check CVS circa Aug 2000.
	     *
	     * 01/2004: Optimizations by Gabriel Bouvigne
	     */
	    function quantize_lines_xrpow_01(l, istep, xr, xrPos, ix, ixPos) {
	        var compareval0 = (1.0 - 0.4054) / istep;
	
	        assert(l > 0);
	        l = l >> 1;
	        while ((l--) != 0) {
	            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
	            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
	        }
	    }
	
	    /**
	     * XRPOW_FTOI is a macro to convert floats to ints.<BR>
	     * if XRPOW_FTOI(x) = nearest_int(x), then QUANTFAC(x)=adj43asm[x]<BR>
	     * ROUNDFAC= -0.0946<BR>
	     *
	     * if XRPOW_FTOI(x) = floor(x), then QUANTFAC(x)=asj43[x]<BR>
	     * ROUNDFAC=0.4054<BR>
	     *
	     * Note: using floor() or 0| is extremely slow. On machines where the
	     * TAKEHIRO_IEEE754_HACK code above does not work, it is worthwile to write
	     * some ASM for XRPOW_FTOI().
	     */
	    function quantize_lines_xrpow(l, istep, xr, xrPos, ix, ixPos) {
	        assert(l > 0);
	
	        l = l >> 1;
	        var remaining = l % 2;
	        l = l >> 1;
	        while (l-- != 0) {
	            var x0, x1, x2, x3;
	            var rx0, rx1, rx2, rx3;
	
	            x0 = xr[xrPos++] * istep;
	            x1 = xr[xrPos++] * istep;
	            rx0 = 0 | x0;
	            x2 = xr[xrPos++] * istep;
	            rx1 = 0 | x1;
	            x3 = xr[xrPos++] * istep;
	            rx2 = 0 | x2;
	            x0 += qupvt.adj43[rx0];
	            rx3 = 0 | x3;
	            x1 += qupvt.adj43[rx1];
	            ix[ixPos++] = 0 | x0;
	            x2 += qupvt.adj43[rx2];
	            ix[ixPos++] = 0 | x1;
	            x3 += qupvt.adj43[rx3];
	            ix[ixPos++] = 0 | x2;
	            ix[ixPos++] = 0 | x3;
	        }
	        if (remaining != 0) {
	            var x0, x1;
	            var rx0, rx1;
	
	            x0 = xr[xrPos++] * istep;
	            x1 = xr[xrPos++] * istep;
	            rx0 = 0 | x0;
	            rx1 = 0 | x1;
	            x0 += qupvt.adj43[rx0];
	            x1 += qupvt.adj43[rx1];
	            ix[ixPos++] = 0 | x0;
	            ix[ixPos++] = 0 | x1;
	        }
	    }
	
	    /**
	     * Quantization function This function will select which lines to quantize
	     * and call the proper quantization function
	     */
	    function quantize_xrpow(xp, pi, istep, codInfo, prevNoise) {
	        /* quantize on xr^(3/4) instead of xr */
	        var sfb;
	        var sfbmax;
	        var j = 0;
	        var prev_data_use;
	        var accumulate = 0;
	        var accumulate01 = 0;
	        var xpPos = 0;
	        var iData = pi;
	        var iDataPos = 0;
	        var acc_iData = iData;
	        var acc_iDataPos = 0;
	        var acc_xp = xp;
	        var acc_xpPos = 0;
	
	        /*
	         * Reusing previously computed data does not seems to work if global
	         * gain is changed. Finding why it behaves this way would allow to use a
	         * cache of previously computed values (let's 10 cached values per sfb)
	         * that would probably provide a noticeable speedup
	         */
	        prev_data_use = (prevNoise != null && (codInfo.global_gain == prevNoise.global_gain));
	
	        if (codInfo.block_type == Encoder.SHORT_TYPE)
	            sfbmax = 38;
	        else
	            sfbmax = 21;
	
	        for (sfb = 0; sfb <= sfbmax; sfb++) {
	            var step = -1;
	
	            if (prev_data_use || codInfo.block_type == Encoder.NORM_TYPE) {
	                step = codInfo.global_gain
	                    - ((codInfo.scalefac[sfb] + (codInfo.preflag != 0 ? qupvt.pretab[sfb]
	                        : 0)) << (codInfo.scalefac_scale + 1))
	                    - codInfo.subblock_gain[codInfo.window[sfb]] * 8;
	            }
	            assert(codInfo.width[sfb] >= 0);
	            if (prev_data_use && (prevNoise.step[sfb] == step)) {
	                /*
	                 * do not recompute this part, but compute accumulated lines
	                 */
	                if (accumulate != 0) {
	                    quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
	                        acc_iData, acc_iDataPos);
	                    accumulate = 0;
	                }
	                if (accumulate01 != 0) {
	                    quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
	                        acc_xpPos, acc_iData, acc_iDataPos);
	                    accumulate01 = 0;
	                }
	            } else { /* should compute this part */
	                var l = codInfo.width[sfb];
	
	                if ((j + codInfo.width[sfb]) > codInfo.max_nonzero_coeff) {
	                    /* do not compute upper zero part */
	                    var usefullsize;
	                    usefullsize = codInfo.max_nonzero_coeff - j + 1;
	                    Arrays.fill(pi, codInfo.max_nonzero_coeff, 576, 0);
	                    l = usefullsize;
	
	                    if (l < 0) {
	                        l = 0;
	                    }
	
	                    /* no need to compute higher sfb values */
	                    sfb = sfbmax + 1;
	                }
	
	                /* accumulate lines to quantize */
	                if (0 == accumulate && 0 == accumulate01) {
	                    acc_iData = iData;
	                    acc_iDataPos = iDataPos;
	                    acc_xp = xp;
	                    acc_xpPos = xpPos;
	                }
	                if (prevNoise != null && prevNoise.sfb_count1 > 0
	                    && sfb >= prevNoise.sfb_count1
	                    && prevNoise.step[sfb] > 0
	                    && step >= prevNoise.step[sfb]) {
	
	                    if (accumulate != 0) {
	                        quantize_lines_xrpow(accumulate, istep, acc_xp,
	                            acc_xpPos, acc_iData, acc_iDataPos);
	                        accumulate = 0;
	                        acc_iData = iData;
	                        acc_iDataPos = iDataPos;
	                        acc_xp = xp;
	                        acc_xpPos = xpPos;
	                    }
	                    accumulate01 += l;
	                } else {
	                    if (accumulate01 != 0) {
	                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
	                            acc_xpPos, acc_iData, acc_iDataPos);
	                        accumulate01 = 0;
	                        acc_iData = iData;
	                        acc_iDataPos = iDataPos;
	                        acc_xp = xp;
	                        acc_xpPos = xpPos;
	                    }
	                    accumulate += l;
	                }
	
	                if (l <= 0) {
	                    /*
	                     * rh: 20040215 may happen due to "prev_data_use"
	                     * optimization
	                     */
	                    if (accumulate01 != 0) {
	                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
	                            acc_xpPos, acc_iData, acc_iDataPos);
	                        accumulate01 = 0;
	                    }
	                    if (accumulate != 0) {
	                        quantize_lines_xrpow(accumulate, istep, acc_xp,
	                            acc_xpPos, acc_iData, acc_iDataPos);
	                        accumulate = 0;
	                    }
	
	                    break;
	                    /* ends for-loop */
	                }
	            }
	            if (sfb <= sfbmax) {
	                iDataPos += codInfo.width[sfb];
	                xpPos += codInfo.width[sfb];
	                j += codInfo.width[sfb];
	            }
	        }
	        if (accumulate != 0) { /* last data part */
	            quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
	                acc_iData, acc_iDataPos);
	            accumulate = 0;
	        }
	        if (accumulate01 != 0) { /* last data part */
	            quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos,
	                acc_iData, acc_iDataPos);
	            accumulate01 = 0;
	        }
	
	    }
	
	    /**
	     * ix_max
	     */
	    function ix_max(ix, ixPos, endPos) {
	        var max1 = 0, max2 = 0;
	
	        do {
	            var x1 = ix[ixPos++];
	            var x2 = ix[ixPos++];
	            if (max1 < x1)
	                max1 = x1;
	
	            if (max2 < x2)
	                max2 = x2;
	        } while (ixPos < endPos);
	        if (max1 < max2)
	            max1 = max2;
	        return max1;
	    }
	
	    function count_bit_ESC(ix, ixPos, end, t1, t2, s) {
	        /* ESC-table is used */
	        var linbits = Tables.ht[t1].xlen * 65536 + Tables.ht[t2].xlen;
	        var sum = 0, sum2;
	
	        do {
	            var x = ix[ixPos++];
	            var y = ix[ixPos++];
	
	            if (x != 0) {
	                if (x > 14) {
	                    x = 15;
	                    sum += linbits;
	                }
	                x *= 16;
	            }
	
	            if (y != 0) {
	                if (y > 14) {
	                    y = 15;
	                    sum += linbits;
	                }
	                x += y;
	            }
	
	            sum += Tables.largetbl[x];
	        } while (ixPos < end);
	
	        sum2 = sum & 0xffff;
	        sum >>= 16;
	
	        if (sum > sum2) {
	            sum = sum2;
	            t1 = t2;
	        }
	
	        s.bits += sum;
	        return t1;
	    }
	
	    function count_bit_noESC(ix, ixPos, end, s) {
	        /* No ESC-words */
	        var sum1 = 0;
	        var hlen1 = Tables.ht[1].hlen;
	
	        do {
	            var x = ix[ixPos + 0] * 2 + ix[ixPos + 1];
	            ixPos += 2;
	            sum1 += hlen1[x];
	        } while (ixPos < end);
	
	        s.bits += sum1;
	        return 1;
	    }
	
	    function count_bit_noESC_from2(ix, ixPos, end, t1, s) {
	        /* No ESC-words */
	        var sum = 0, sum2;
	        var xlen = Tables.ht[t1].xlen;
	        var hlen;
	        if (t1 == 2)
	            hlen = Tables.table23;
	        else
	            hlen = Tables.table56;
	
	        do {
	            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
	            ixPos += 2;
	            sum += hlen[x];
	        } while (ixPos < end);
	
	        sum2 = sum & 0xffff;
	        sum >>= 16;
	
	        if (sum > sum2) {
	            sum = sum2;
	            t1++;
	        }
	
	        s.bits += sum;
	        return t1;
	    }
	
	    function count_bit_noESC_from3(ix, ixPos, end, t1, s) {
	        /* No ESC-words */
	        var sum1 = 0;
	        var sum2 = 0;
	        var sum3 = 0;
	        var xlen = Tables.ht[t1].xlen;
	        var hlen1 = Tables.ht[t1].hlen;
	        var hlen2 = Tables.ht[t1 + 1].hlen;
	        var hlen3 = Tables.ht[t1 + 2].hlen;
	
	        do {
	            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
	            ixPos += 2;
	            sum1 += hlen1[x];
	            sum2 += hlen2[x];
	            sum3 += hlen3[x];
	        } while (ixPos < end);
	        var t = t1;
	        if (sum1 > sum2) {
	            sum1 = sum2;
	            t++;
	        }
	        if (sum1 > sum3) {
	            sum1 = sum3;
	            t = t1 + 2;
	        }
	        s.bits += sum1;
	
	        return t;
	    }
	
	    /*************************************************************************/
	    /* choose table */
	    /*************************************************************************/
	
	    var huf_tbl_noESC = [1, 2, 5, 7, 7, 10, 10, 13, 13,
	        13, 13, 13, 13, 13, 13];
	
	    /**
	     * Choose the Huffman table that will encode ix[begin..end] with the fewest
	     * bits.
	     *
	     * Note: This code contains knowledge about the sizes and characteristics of
	     * the Huffman tables as defined in the IS (Table B.7), and will not work
	     * with any arbitrary tables.
	     */
	    function choose_table(ix, ixPos, endPos, s) {
	        var max = ix_max(ix, ixPos, endPos);
	
	        switch (max) {
	            case 0:
	                return max;
	
	            case 1:
	                return count_bit_noESC(ix, ixPos, endPos, s);
	
	            case 2:
	            case 3:
	                return count_bit_noESC_from2(ix, ixPos, endPos,
	                    huf_tbl_noESC[max - 1], s);
	
	            case 4:
	            case 5:
	            case 6:
	            case 7:
	            case 8:
	            case 9:
	            case 10:
	            case 11:
	            case 12:
	            case 13:
	            case 14:
	            case 15:
	                return count_bit_noESC_from3(ix, ixPos, endPos,
	                    huf_tbl_noESC[max - 1], s);
	
	            default:
	                /* try tables with linbits */
	                if (max > QuantizePVT.IXMAX_VAL) {
	                    s.bits = QuantizePVT.LARGE_BITS;
	                    return -1;
	                }
	                max -= 15;
	                var choice2;
	                for (choice2 = 24; choice2 < 32; choice2++) {
	                    if (Tables.ht[choice2].linmax >= max) {
	                        break;
	                    }
	                }
	                var choice;
	                for (choice = choice2 - 8; choice < 24; choice++) {
	                    if (Tables.ht[choice].linmax >= max) {
	                        break;
	                    }
	                }
	                return count_bit_ESC(ix, ixPos, endPos, choice, choice2, s);
	        }
	    }
	
	    /**
	     * count_bit
	     */
	    this.noquant_count_bits = function (gfc, gi, prev_noise) {
	        var ix = gi.l3_enc;
	        var i = Math.min(576, ((gi.max_nonzero_coeff + 2) >> 1) << 1);
	
	        if (prev_noise != null)
	            prev_noise.sfb_count1 = 0;
	
	        /* Determine count1 region */
	        for (; i > 1; i -= 2)
	            if ((ix[i - 1] | ix[i - 2]) != 0)
	                break;
	        gi.count1 = i;
	
	        /* Determines the number of bits to encode the quadruples. */
	        var a1 = 0;
	        var a2 = 0;
	        for (; i > 3; i -= 4) {
	            var p;
	            /* hack to check if all values <= 1 */
	            //throw "TODO: HACK         if ((((long) ix[i - 1] | (long) ix[i - 2] | (long) ix[i - 3] | (long) ix[i - 4]) & 0xffffffffL) > 1L        "
	            //if (true) {
	            if (((ix[i - 1] | ix[i - 2] | ix[i - 3] | ix[i - 4]) & 0x7fffffff) > 1) {
	                break;
	            }
	            p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
	            a1 += Tables.t32l[p];
	            a2 += Tables.t33l[p];
	        }
	        var bits = a1;
	        gi.count1table_select = 0;
	        if (a1 > a2) {
	            bits = a2;
	            gi.count1table_select = 1;
	        }
	
	        gi.count1bits = bits;
	        gi.big_values = i;
	        if (i == 0)
	            return bits;
	
	        if (gi.block_type == Encoder.SHORT_TYPE) {
	            a1 = 3 * gfc.scalefac_band.s[3];
	            if (a1 > gi.big_values)
	                a1 = gi.big_values;
	            a2 = gi.big_values;
	
	        } else if (gi.block_type == Encoder.NORM_TYPE) {
	            assert(i <= 576);
	            /* bv_scf has 576 entries (0..575) */
	            a1 = gi.region0_count = gfc.bv_scf[i - 2];
	            a2 = gi.region1_count = gfc.bv_scf[i - 1];
	
	            assert(a1 + a2 + 2 < Encoder.SBPSY_l);
	            a2 = gfc.scalefac_band.l[a1 + a2 + 2];
	            a1 = gfc.scalefac_band.l[a1 + 1];
	            if (a2 < i) {
	                var bi = new Bits(bits);
	                gi.table_select[2] = choose_table(ix, a2, i, bi);
	                bits = bi.bits;
	            }
	        } else {
	            gi.region0_count = 7;
	            /* gi.region1_count = SBPSY_l - 7 - 1; */
	            gi.region1_count = Encoder.SBMAX_l - 1 - 7 - 1;
	            a1 = gfc.scalefac_band.l[7 + 1];
	            a2 = i;
	            if (a1 > a2) {
	                a1 = a2;
	            }
	        }
	
	        /* have to allow for the case when bigvalues < region0 < region1 */
	        /* (and region0, region1 are ignored) */
	        a1 = Math.min(a1, i);
	        a2 = Math.min(a2, i);
	
	        assert(a1 >= 0);
	        assert(a2 >= 0);
	
	        /* Count the number of bits necessary to code the bigvalues region. */
	        if (0 < a1) {
	            var bi = new Bits(bits);
	            gi.table_select[0] = choose_table(ix, 0, a1, bi);
	            bits = bi.bits;
	        }
	        if (a1 < a2) {
	            var bi = new Bits(bits);
	            gi.table_select[1] = choose_table(ix, a1, a2, bi);
	            bits = bi.bits;
	        }
	        if (gfc.use_best_huffman == 2) {
	            gi.part2_3_length = bits;
	            best_huffman_divide(gfc, gi);
	            bits = gi.part2_3_length;
	        }
	
	        if (prev_noise != null) {
	            if (gi.block_type == Encoder.NORM_TYPE) {
	                var sfb = 0;
	                while (gfc.scalefac_band.l[sfb] < gi.big_values) {
	                    sfb++;
	                }
	                prev_noise.sfb_count1 = sfb;
	            }
	        }
	
	        return bits;
	    }
	
	    this.count_bits = function (gfc, xr, gi, prev_noise) {
	        var ix = gi.l3_enc;
	
	        /* since quantize_xrpow uses table lookup, we need to check this first: */
	        var w = (QuantizePVT.IXMAX_VAL) / qupvt.IPOW20(gi.global_gain);
	
	        if (gi.xrpow_max > w)
	            return QuantizePVT.LARGE_BITS;
	
	        quantize_xrpow(xr, ix, qupvt.IPOW20(gi.global_gain), gi, prev_noise);
	
	        if ((gfc.substep_shaping & 2) != 0) {
	            var j = 0;
	            /* 0.634521682242439 = 0.5946*2**(.5*0.1875) */
	            var gain = gi.global_gain + gi.scalefac_scale;
	            var roundfac = 0.634521682242439 / qupvt.IPOW20(gain);
	            for (var sfb = 0; sfb < gi.sfbmax; sfb++) {
	                var width = gi.width[sfb];
	                assert(width >= 0);
	                if (0 == gfc.pseudohalf[sfb]) {
	                    j += width;
	                } else {
	                    var k;
	                    for (k = j, j += width; k < j; ++k) {
	                        ix[k] = (xr[k] >= roundfac) ? ix[k] : 0;
	                    }
	                }
	            }
	        }
	        return this.noquant_count_bits(gfc, gi, prev_noise);
	    }
	
	    /**
	     * re-calculate the best scalefac_compress using scfsi the saved bits are
	     * kept in the bit reservoir.
	     */
	    function recalc_divide_init(gfc, cod_info, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
	        var bigv = cod_info.big_values;
	
	        for (var r0 = 0; r0 <= 7 + 15; r0++) {
	            r01_bits[r0] = QuantizePVT.LARGE_BITS;
	        }
	
	        for (var r0 = 0; r0 < 16; r0++) {
	            var a1 = gfc.scalefac_band.l[r0 + 1];
	            if (a1 >= bigv)
	                break;
	            var r0bits = 0;
	            var bi = new Bits(r0bits);
	            var r0t = choose_table(ix, 0, a1, bi);
	            r0bits = bi.bits;
	
	            for (var r1 = 0; r1 < 8; r1++) {
	                var a2 = gfc.scalefac_band.l[r0 + r1 + 2];
	                if (a2 >= bigv)
	                    break;
	                var bits = r0bits;
	                bi = new Bits(bits);
	                var r1t = choose_table(ix, a1, a2, bi);
	                bits = bi.bits;
	                if (r01_bits[r0 + r1] > bits) {
	                    r01_bits[r0 + r1] = bits;
	                    r01_div[r0 + r1] = r0;
	                    r0_tbl[r0 + r1] = r0t;
	                    r1_tbl[r0 + r1] = r1t;
	                }
	            }
	        }
	    }
	
	    function recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
	        var bigv = cod_info2.big_values;
	
	        for (var r2 = 2; r2 < Encoder.SBMAX_l + 1; r2++) {
	            var a2 = gfc.scalefac_band.l[r2];
	            if (a2 >= bigv)
	                break;
	            var bits = r01_bits[r2 - 2] + cod_info2.count1bits;
	            if (gi.part2_3_length <= bits)
	                break;
	
	            var bi = new Bits(bits);
	            var r2t = choose_table(ix, a2, bigv, bi);
	            bits = bi.bits;
	            if (gi.part2_3_length <= bits)
	                continue;
	
	            gi.assign(cod_info2);
	            gi.part2_3_length = bits;
	            gi.region0_count = r01_div[r2 - 2];
	            gi.region1_count = r2 - 2 - r01_div[r2 - 2];
	            gi.table_select[0] = r0_tbl[r2 - 2];
	            gi.table_select[1] = r1_tbl[r2 - 2];
	            gi.table_select[2] = r2t;
	        }
	    }
	
	    this.best_huffman_divide = function (gfc, gi) {
	        var cod_info2 = new GrInfo();
	        var ix = gi.l3_enc;
	        var r01_bits = new_int(7 + 15 + 1);
	        var r01_div = new_int(7 + 15 + 1);
	        var r0_tbl = new_int(7 + 15 + 1);
	        var r1_tbl = new_int(7 + 15 + 1);
	
	        /* SHORT BLOCK stuff fails for MPEG2 */
	        if (gi.block_type == Encoder.SHORT_TYPE && gfc.mode_gr == 1)
	            return;
	
	        cod_info2.assign(gi);
	        if (gi.block_type == Encoder.NORM_TYPE) {
	            recalc_divide_init(gfc, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
	            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
	                r0_tbl, r1_tbl);
	        }
	        var i = cod_info2.big_values;
	        if (i == 0 || (ix[i - 2] | ix[i - 1]) > 1)
	            return;
	
	        i = gi.count1 + 2;
	        if (i > 576)
	            return;
	
	        /* Determines the number of bits to encode the quadruples. */
	        cod_info2.assign(gi);
	        cod_info2.count1 = i;
	        var a1 = 0;
	        var a2 = 0;
	
	        assert(i <= 576);
	
	        for (; i > cod_info2.big_values; i -= 4) {
	            var p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2
	                + ix[i - 1];
	            a1 += Tables.t32l[p];
	            a2 += Tables.t33l[p];
	        }
	        cod_info2.big_values = i;
	
	        cod_info2.count1table_select = 0;
	        if (a1 > a2) {
	            a1 = a2;
	            cod_info2.count1table_select = 1;
	        }
	
	        cod_info2.count1bits = a1;
	
	        if (cod_info2.block_type == Encoder.NORM_TYPE)
	            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
	                r0_tbl, r1_tbl);
	        else {
	            /* Count the number of bits necessary to code the bigvalues region. */
	            cod_info2.part2_3_length = a1;
	            a1 = gfc.scalefac_band.l[7 + 1];
	            if (a1 > i) {
	                a1 = i;
	            }
	            if (a1 > 0) {
	                var bi = new Bits(cod_info2.part2_3_length);
	                cod_info2.table_select[0] = choose_table(ix, 0, a1, bi);
	                cod_info2.part2_3_length = bi.bits;
	            }
	            if (i > a1) {
	                var bi = new Bits(cod_info2.part2_3_length);
	                cod_info2.table_select[1] = choose_table(ix, a1, i, bi);
	                cod_info2.part2_3_length = bi.bits;
	            }
	            if (gi.part2_3_length > cod_info2.part2_3_length)
	                gi.assign(cod_info2);
	        }
	    }
	
	    var slen1_n = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16];
	    var slen2_n = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8];
	    var slen1_tab = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
	    var slen2_tab = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
	    Takehiro.slen1_tab = slen1_tab;
	    Takehiro.slen2_tab = slen2_tab;
	
	    function scfsi_calc(ch, l3_side) {
	        var sfb;
	        var gi = l3_side.tt[1][ch];
	        var g0 = l3_side.tt[0][ch];
	
	        for (var i = 0; i < Tables.scfsi_band.length - 1; i++) {
	            for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
	                if (g0.scalefac[sfb] != gi.scalefac[sfb]
	                    && gi.scalefac[sfb] >= 0)
	                    break;
	            }
	            if (sfb == Tables.scfsi_band[i + 1]) {
	                for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
	                    gi.scalefac[sfb] = -1;
	                }
	                l3_side.scfsi[ch][i] = 1;
	            }
	        }
	        var s1 = 0;
	        var c1 = 0;
	        for (sfb = 0; sfb < 11; sfb++) {
	            if (gi.scalefac[sfb] == -1)
	                continue;
	            c1++;
	            if (s1 < gi.scalefac[sfb])
	                s1 = gi.scalefac[sfb];
	        }
	        var s2 = 0;
	        var c2 = 0;
	        for (; sfb < Encoder.SBPSY_l; sfb++) {
	            if (gi.scalefac[sfb] == -1)
	                continue;
	            c2++;
	            if (s2 < gi.scalefac[sfb])
	                s2 = gi.scalefac[sfb];
	        }
	
	        for (var i = 0; i < 16; i++) {
	            if (s1 < slen1_n[i] && s2 < slen2_n[i]) {
	                var c = slen1_tab[i] * c1 + slen2_tab[i] * c2;
	                if (gi.part2_length > c) {
	                    gi.part2_length = c;
	                    gi.scalefac_compress = i;
	                }
	            }
	        }
	    }
	
	    /**
	     * Find the optimal way to store the scalefactors. Only call this routine
	     * after final scalefactors have been chosen and the channel/granule will
	     * not be re-encoded.
	     */
	    this.best_scalefac_store = function (gfc, gr, ch, l3_side) {
	        /* use scalefac_scale if we can */
	        var gi = l3_side.tt[gr][ch];
	        var sfb, i, j, l;
	        var recalc = 0;
	
	        /*
	         * remove scalefacs from bands with ix=0. This idea comes from the AAC
	         * ISO docs. added mt 3/00
	         */
	        /* check if l3_enc=0 */
	        j = 0;
	        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
	            var width = gi.width[sfb];
	            assert(width >= 0);
	            j += width;
	            for (l = -width; l < 0; l++) {
	                if (gi.l3_enc[l + j] != 0)
	                    break;
	            }
	            if (l == 0)
	                gi.scalefac[sfb] = recalc = -2;
	            /* anything goes. */
	            /*
	             * only best_scalefac_store and calc_scfsi know--and only they
	             * should know--about the magic number -2.
	             */
	        }
	
	        if (0 == gi.scalefac_scale && 0 == gi.preflag) {
	            var s = 0;
	            for (sfb = 0; sfb < gi.sfbmax; sfb++)
	                if (gi.scalefac[sfb] > 0)
	                    s |= gi.scalefac[sfb];
	
	            if (0 == (s & 1) && s != 0) {
	                for (sfb = 0; sfb < gi.sfbmax; sfb++)
	                    if (gi.scalefac[sfb] > 0)
	                        gi.scalefac[sfb] >>= 1;
	
	                gi.scalefac_scale = recalc = 1;
	            }
	        }
	
	        if (0 == gi.preflag && gi.block_type != Encoder.SHORT_TYPE
	            && gfc.mode_gr == 2) {
	            for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
	                if (gi.scalefac[sfb] < qupvt.pretab[sfb]
	                    && gi.scalefac[sfb] != -2)
	                    break;
	            if (sfb == Encoder.SBPSY_l) {
	                for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
	                    if (gi.scalefac[sfb] > 0)
	                        gi.scalefac[sfb] -= qupvt.pretab[sfb];
	
	                gi.preflag = recalc = 1;
	            }
	        }
	
	        for (i = 0; i < 4; i++)
	            l3_side.scfsi[ch][i] = 0;
	
	        if (gfc.mode_gr == 2 && gr == 1
	            && l3_side.tt[0][ch].block_type != Encoder.SHORT_TYPE
	            && l3_side.tt[1][ch].block_type != Encoder.SHORT_TYPE) {
	            scfsi_calc(ch, l3_side);
	            recalc = 0;
	        }
	        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
	            if (gi.scalefac[sfb] == -2) {
	                gi.scalefac[sfb] = 0;
	                /* if anything goes, then 0 is a good choice */
	            }
	        }
	        if (recalc != 0) {
	            if (gfc.mode_gr == 2) {
	                this.scale_bitcount(gi);
	            } else {
	                this.scale_bitcount_lsf(gfc, gi);
	            }
	        }
	    }
	
	    function all_scalefactors_not_negative(scalefac, n) {
	        for (var i = 0; i < n; ++i) {
	            if (scalefac[i] < 0)
	                return false;
	        }
	        return true;
	    }
	
	    /**
	     * number of bits used to encode scalefacs.
	     *
	     * 18*slen1_tab[i] + 18*slen2_tab[i]
	     */
	    var scale_short = [0, 18, 36, 54, 54, 36, 54, 72,
	        54, 72, 90, 72, 90, 108, 108, 126];
	
	    /**
	     * number of bits used to encode scalefacs.
	     *
	     * 17*slen1_tab[i] + 18*slen2_tab[i]
	     */
	    var scale_mixed = [0, 18, 36, 54, 51, 35, 53, 71,
	        52, 70, 88, 69, 87, 105, 104, 122];
	
	    /**
	     * number of bits used to encode scalefacs.
	     *
	     * 11*slen1_tab[i] + 10*slen2_tab[i]
	     */
	    var scale_long = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42,
	        52, 43, 53, 63, 64, 74];
	
	    /**
	     * Also calculates the number of bits necessary to code the scalefactors.
	     */
	    this.scale_bitcount = function (cod_info) {
	        var k, sfb, max_slen1 = 0, max_slen2 = 0;
	
	        /* maximum values */
	        var tab;
	        var scalefac = cod_info.scalefac;
	
	        assert(all_scalefactors_not_negative(scalefac, cod_info.sfbmax));
	
	        if (cod_info.block_type == Encoder.SHORT_TYPE) {
	            tab = scale_short;
	            if (cod_info.mixed_block_flag != 0)
	                tab = scale_mixed;
	        } else { /* block_type == 1,2,or 3 */
	            tab = scale_long;
	            if (0 == cod_info.preflag) {
	                for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
	                    if (scalefac[sfb] < qupvt.pretab[sfb])
	                        break;
	
	                if (sfb == Encoder.SBPSY_l) {
	                    cod_info.preflag = 1;
	                    for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
	                        scalefac[sfb] -= qupvt.pretab[sfb];
	                }
	            }
	        }
	
	        for (sfb = 0; sfb < cod_info.sfbdivide; sfb++)
	            if (max_slen1 < scalefac[sfb])
	                max_slen1 = scalefac[sfb];
	
	        for (; sfb < cod_info.sfbmax; sfb++)
	            if (max_slen2 < scalefac[sfb])
	                max_slen2 = scalefac[sfb];
	
	        /*
	         * from Takehiro TOMINAGA <tominaga@isoternet.org> 10/99 loop over *all*
	         * posible values of scalefac_compress to find the one which uses the
	         * smallest number of bits. ISO would stop at first valid index
	         */
	        cod_info.part2_length = QuantizePVT.LARGE_BITS;
	        for (k = 0; k < 16; k++) {
	            if (max_slen1 < slen1_n[k] && max_slen2 < slen2_n[k]
	                && cod_info.part2_length > tab[k]) {
	                cod_info.part2_length = tab[k];
	                cod_info.scalefac_compress = k;
	            }
	        }
	        return cod_info.part2_length == QuantizePVT.LARGE_BITS;
	    }
	
	    /**
	     * table of largest scalefactor values for MPEG2
	     */
	    var max_range_sfac_tab = [[15, 15, 7, 7],
	        [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0],
	        [7, 7, 7, 0], [3, 3, 0, 0]];
	
	    /**
	     * Also counts the number of bits to encode the scalefacs but for MPEG 2
	     * Lower sampling frequencies (24, 22.05 and 16 kHz.)
	     *
	     * This is reverse-engineered from section 2.4.3.2 of the MPEG2 IS,
	     * "Audio Decoding Layer III"
	     */
	    this.scale_bitcount_lsf = function (gfc, cod_info) {
	        var table_number, row_in_table, partition, nr_sfb, window;
	        var over;
	        var i, sfb;
	        var max_sfac = new_int(4);
	//var partition_table;
	        var scalefac = cod_info.scalefac;
	
	        /*
	         * Set partition table. Note that should try to use table one, but do
	         * not yet...
	         */
	        if (cod_info.preflag != 0)
	            table_number = 2;
	        else
	            table_number = 0;
	
	        for (i = 0; i < 4; i++)
	            max_sfac[i] = 0;
	
	        if (cod_info.block_type == Encoder.SHORT_TYPE) {
	            row_in_table = 1;
	            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	            for (sfb = 0, partition = 0; partition < 4; partition++) {
	                nr_sfb = partition_table[partition] / 3;
	                for (i = 0; i < nr_sfb; i++, sfb++)
	                    for (window = 0; window < 3; window++)
	                        if (scalefac[sfb * 3 + window] > max_sfac[partition])
	                            max_sfac[partition] = scalefac[sfb * 3 + window];
	            }
	        } else {
	            row_in_table = 0;
	            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	            for (sfb = 0, partition = 0; partition < 4; partition++) {
	                nr_sfb = partition_table[partition];
	                for (i = 0; i < nr_sfb; i++, sfb++)
	                    if (scalefac[sfb] > max_sfac[partition])
	                        max_sfac[partition] = scalefac[sfb];
	            }
	        }
	
	        for (over = false, partition = 0; partition < 4; partition++) {
	            if (max_sfac[partition] > max_range_sfac_tab[table_number][partition])
	                over = true;
	        }
	        if (!over) {
	            var slen1, slen2, slen3, slen4;
	
	            cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
	            for (partition = 0; partition < 4; partition++)
	                cod_info.slen[partition] = log2tab[max_sfac[partition]];
	
	            /* set scalefac_compress */
	            slen1 = cod_info.slen[0];
	            slen2 = cod_info.slen[1];
	            slen3 = cod_info.slen[2];
	            slen4 = cod_info.slen[3];
	
	            switch (table_number) {
	                case 0:
	                    cod_info.scalefac_compress = (((slen1 * 5) + slen2) << 4)
	                        + (slen3 << 2) + slen4;
	                    break;
	
	                case 1:
	                    cod_info.scalefac_compress = 400 + (((slen1 * 5) + slen2) << 2)
	                        + slen3;
	                    break;
	
	                case 2:
	                    cod_info.scalefac_compress = 500 + (slen1 * 3) + slen2;
	                    break;
	
	                default:
	                    System.err.printf("intensity stereo not implemented yet\n");
	                    break;
	            }
	        }
	        if (!over) {
	            assert(cod_info.sfb_partition_table != null);
	            cod_info.part2_length = 0;
	            for (partition = 0; partition < 4; partition++)
	                cod_info.part2_length += cod_info.slen[partition]
	                    * cod_info.sfb_partition_table[partition];
	        }
	        return over;
	    }
	
	    /*
	     * Since no bands have been over-amplified, we can set scalefac_compress and
	     * slen[] for the formatter
	     */
	    var log2tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4,
	        4, 4, 4, 4];
	
	    this.huffman_init = function (gfc) {
	        for (var i = 2; i <= 576; i += 2) {
	            var scfb_anz = 0, bv_index;
	            while (gfc.scalefac_band.l[++scfb_anz] < i)
	                ;
	
	            bv_index = subdv_table[scfb_anz][0]; // .region0_count
	            while (gfc.scalefac_band.l[bv_index + 1] > i)
	                bv_index--;
	
	            if (bv_index < 0) {
	                /*
	                 * this is an indication that everything is going to be encoded
	                 * as region0: bigvalues < region0 < region1 so lets set
	                 * region0, region1 to some value larger than bigvalues
	                 */
	                bv_index = subdv_table[scfb_anz][0]; // .region0_count
	            }
	
	            gfc.bv_scf[i - 2] = bv_index;
	
	            bv_index = subdv_table[scfb_anz][1]; // .region1_count
	            while (gfc.scalefac_band.l[bv_index + gfc.bv_scf[i - 2] + 2] > i)
	                bv_index--;
	
	            if (bv_index < 0) {
	                bv_index = subdv_table[scfb_anz][1]; // .region1_count
	            }
	
	            gfc.bv_scf[i - 1] = bv_index;
	        }
	    }
	}
	
	module.exports = Takehiro;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(423);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(503);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(502);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	 false ? CardExpandable.propTypes = {
	  closeIcon: _react.PropTypes.node,
	  expanded: _react.PropTypes.bool,
	  onExpanding: _react.PropTypes.func.isRequired,
	  openIcon: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardExpandable;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(436);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(442);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subheader = __webpack_require__(462);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = List;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(492);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	 false ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	exports.default = StepLabel;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(23);
	
	var _dom = __webpack_require__(210);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = RenderToLayer;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(167);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(166);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(92);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(210);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(476);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TouchRipple;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _getMuiTheme = __webpack_require__(207);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	} : void 0;
	exports.default = MuiThemeProvider;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(167);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(415);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _lightBaseTheme = __webpack_require__(486);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(489);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(512);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(513);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(516);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(706);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(488);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ },
/* 210 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(264);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(693);

/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(54);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(65);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(34);
	
	var quoteAttributeValueForBrowser = __webpack_require__(589);
	var warning = __webpack_require__(11);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDefaultInjection = __webpack_require__(554);
	var ReactMount = __webpack_require__(223);
	var ReactReconciler = __webpack_require__(68);
	var ReactUpdates = __webpack_require__(38);
	var ReactVersion = __webpack_require__(567);
	
	var findDOMNode = __webpack_require__(583);
	var getHostComponentFromComposite = __webpack_require__(227);
	var renderSubtreeIntoContainer = __webpack_require__(590);
	var warning = __webpack_require__(11);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(141);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(38);
	
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 219 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(549);
	
	var containsNode = __webpack_require__(347);
	var focusNode = __webpack_require__(184);
	var getActiveElement = __webpack_require__(185);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMLazyTree = __webpack_require__(64);
	var DOMProperty = __webpack_require__(65);
	var React = __webpack_require__(42);
	var ReactBrowserEventEmitter = __webpack_require__(94);
	var ReactCurrentOwner = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMContainerInfo = __webpack_require__(543);
	var ReactDOMFeatureFlags = __webpack_require__(545);
	var ReactFeatureFlags = __webpack_require__(220);
	var ReactInstanceMap = __webpack_require__(80);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactMarkupChecksum = __webpack_require__(559);
	var ReactReconciler = __webpack_require__(68);
	var ReactUpdateQueue = __webpack_require__(144);
	var ReactUpdates = __webpack_require__(38);
	
	var emptyObject = __webpack_require__(77);
	var instantiateReactComponent = __webpack_require__(230);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(98);
	var shouldUpdateReactComponent = __webpack_require__(151);
	var warning = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var React = __webpack_require__(42);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(224);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var ReactCompositeComponent = __webpack_require__(541);
	var ReactEmptyComponent = __webpack_require__(219);
	var ReactHostComponent = __webpack_require__(221);
	
	var getNextDebugID = __webpack_require__(587);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(97);
	var setInnerHTML = __webpack_require__(98);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(43);
	var REACT_ELEMENT_TYPE = __webpack_require__(555);
	
	var getIteratorFn = __webpack_require__(586);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(140);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(362);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(237);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _storeShape = __webpack_require__(238);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _storeShape2.default, _contextTypes[subscriptionKey] = _react.PropTypes.instanceOf(_Subscription2.default), _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _react.PropTypes.instanceOf(_Subscription2.default), _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + WrappedComponent));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = _this.props[storeKey] || _this.context[storeKey];
	        _this.parentSub = props[subscriptionKey] || context[subscriptionKey];
	
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or ' + ('props of "' + displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        // make sure `getState` is properly bound in order to avoid breaking
	        // custom store implementations that rely on the store's context
	        _this.getState = _this.store.getState.bind(_this.store);
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[subscriptionKey] = this.subscription || this.parentSub, _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        // these are just to guard against extra memory leakage if a parent element doesn't
	        // dereference this instance properly, such as an async callback that never finishes
	        this.subscription = null;
	        this.store = null;
	        this.parentSub = null;
	        this.selector.run = function () {};
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var dispatch = this.store.dispatch;
	        var getState = this.getState;
	
	        var sourceSelector = selectorFactory(dispatch, selectorFactoryOptions);
	
	        // wrap the selector in an object that tracks its results between runs
	        var selector = this.selector = {
	          shouldComponentUpdate: true,
	          props: sourceSelector(getState(), this.props),
	          run: function runComponentSelector(props) {
	            try {
	              var nextProps = sourceSelector(getState(), props);
	              if (selector.error || nextProps !== selector.props) {
	                selector.shouldComponentUpdate = true;
	                selector.props = nextProps;
	                selector.error = null;
	              }
	            } catch (error) {
	              selector.shouldComponentUpdate = true;
	              selector.error = error;
	            }
	          }
	        };
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        var _this2 = this;
	
	        if (shouldHandleStateChanges) {
	          (function () {
	            var subscription = _this2.subscription = new _Subscription2.default(_this2.store, _this2.parentSub);
	            var dummyState = {};
	
	            subscription.onStateChange = function onStateChange() {
	              this.selector.run(this.props);
	
	              if (!this.selector.shouldComponentUpdate) {
	                subscription.notifyNestedSubs();
	              } else {
	                this.componentDidUpdate = function componentDidUpdate() {
	                  this.componentDidUpdate = undefined;
	                  subscription.notifyNestedSubs();
	                };
	
	                this.setState(dummyState);
	              }
	            }.bind(_this2);
	          })();
	        }
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(239);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(593);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(234);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(594);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 237 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      // this.onStateChange is set by connectAdvanced.initSubscription()
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(153);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatchProvider = __webpack_require__(241);
	
	var _MatchProvider2 = _interopRequireDefault(_MatchProvider);
	
	var _matchPattern = __webpack_require__(607);
	
	var _matchPattern2 = _interopRequireDefault(_matchPattern);
	
	var _Broadcasts = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterMatch = function (_React$Component) {
	  _inherits(RegisterMatch, _React$Component);
	
	  function RegisterMatch() {
	    _classCallCheck(this, RegisterMatch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RegisterMatch.prototype.registerMatch = function registerMatch() {
	    var matchContext = this.context.match;
	    var match = this.props.match;
	
	
	    if (match && matchContext) {
	      matchContext.addMatch(match);
	    }
	  };
	
	  RegisterMatch.prototype.componentWillMount = function componentWillMount() {
	    if (this.context.serverRouter) {
	      this.registerMatch();
	    }
	  };
	
	  RegisterMatch.prototype.componentDidMount = function componentDidMount() {
	    if (!this.context.serverRouter) {
	      this.registerMatch();
	    }
	  };
	
	  RegisterMatch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var match = this.context.match;
	
	
	    if (match) {
	      if (prevProps.match && !this.props.match) {
	        match.removeMatch(prevProps.match);
	      } else if (!prevProps.match && this.props.match) {
	        match.addMatch(this.props.match);
	      }
	    }
	  };
	
	  RegisterMatch.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.match) {
	      this.context.match.removeMatch(this.props.match);
	    }
	  };
	
	  RegisterMatch.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return RegisterMatch;
	}(_react2.default.Component);
	
	RegisterMatch.contextTypes = {
	  match: _react.PropTypes.object,
	  serverRouter: _react.PropTypes.object
	};
	
	
	if (false) {
	  RegisterMatch.propTypes = {
	    children: _react.PropTypes.node.isRequired,
	    match: _react.PropTypes.any
	  };
	}
	
	var Match = function (_React$Component2) {
	  _inherits(Match, _React$Component2);
	
	  function Match() {
	    _classCallCheck(this, Match);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Match.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      _Broadcasts.LocationSubscriber,
	      null,
	      function (location) {
	        var _props = _this3.props,
	            children = _props.children,
	            render = _props.render,
	            Component = _props.component,
	            pattern = _props.pattern,
	            exactly = _props.exactly;
	        var matchContext = _this3.context.match;
	
	        var parent = matchContext && matchContext.parent;
	        var match = (0, _matchPattern2.default)(pattern, location, exactly, parent);
	        var props = _extends({}, match, { location: location, pattern: pattern });
	        return _react2.default.createElement(
	          RegisterMatch,
	          { match: match },
	          _react2.default.createElement(
	            _MatchProvider2.default,
	            { match: match },
	            children ? children(_extends({ matched: !!match }, props)) : match ? render ? render(props) : _react2.default.createElement(Component, props) : null
	          )
	        );
	      }
	    );
	  };
	
	  return Match;
	}(_react2.default.Component);
	
	Match.defaultProps = {
	  exactly: false
	};
	Match.contextTypes = {
	  match: _react.PropTypes.object
	};
	
	
	if (false) {
	  Match.propTypes = {
	    pattern: _react.PropTypes.string,
	    exactly: _react.PropTypes.bool,
	
	    children: _react.PropTypes.func,
	    render: _react.PropTypes.func,
	    component: _react.PropTypes.func
	  };
	}
	
	exports.default = Match;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MatchProvider = function (_React$Component) {
	  _inherits(MatchProvider, _React$Component);
	
	  function MatchProvider(props) {
	    _classCallCheck(this, MatchProvider);
	
	    // **IMPORTANT** we must mutate matches, never reassign, in order for
	    // server rendering to work w/ the two-pass render approach for Miss
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addMatch = function (match) {
	      _this.matches.push(match);
	    };
	
	    _this.removeMatch = function (match) {
	      _this.matches.splice(_this.matches.indexOf(match), 1);
	    };
	
	    _this.matches = [];
	    _this.subscribers = [];
	    _this.hasMatches = null; // use null for initial value
	    _this.serverRouterIndex = null;
	    return _this;
	  }
	
	  MatchProvider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      match: {
	        addMatch: this.addMatch,
	        removeMatch: this.removeMatch,
	        matches: this.matches,
	        parent: this.props.match,
	        serverRouterIndex: this.serverRouterIndex,
	        subscribe: function subscribe(fn) {
	          _this2.subscribers.push(fn);
	          return function () {
	            _this2.subscribers.splice(_this2.subscribers.indexOf(fn), 1);
	          };
	        }
	      }
	    };
	  };
	
	  MatchProvider.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.notifySubscribers();
	  };
	
	  MatchProvider.prototype.componentWillMount = function componentWillMount() {
	    var serverRouter = this.context.serverRouter;
	
	    if (serverRouter) {
	      this.serverRouterIndex = serverRouter.registerMatchContext(this.matches);
	    }
	  };
	
	  MatchProvider.prototype.componentDidMount = function componentDidMount() {
	    // React's contract is that cDM of descendants is called before cDM of
	    // ancestors, so here we can safely check if we found a match
	    this.notifySubscribers();
	  };
	
	  MatchProvider.prototype.notifySubscribers = function notifySubscribers() {
	    var _this3 = this;
	
	    if (this.subscribers.length) {
	      this.hasMatches = this.matches.length !== 0;
	      this.subscribers.forEach(function (fn) {
	        return fn(_this3.hasMatches);
	      });
	    }
	  };
	
	  MatchProvider.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return MatchProvider;
	}(_react2.default.Component);
	
	MatchProvider.childContextTypes = {
	  match: _PropTypes.matchContext.isRequired
	};
	MatchProvider.contextTypes = {
	  serverRouter: _react.PropTypes.object
	};
	
	
	if (false) {
	  MatchProvider.propTypes = {
	    match: _react.PropTypes.any,
	    children: _react.PropTypes.node
	  };
	}
	
	exports.default = MatchProvider;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Checkbox = __webpack_require__(127);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateExerciseForm = function (_Component) {
	  _inherits(CreateExerciseForm, _Component);
	
	  function CreateExerciseForm(props) {
	    _classCallCheck(this, CreateExerciseForm);
	
	    var _this = _possibleConstructorReturn(this, (CreateExerciseForm.__proto__ || Object.getPrototypeOf(CreateExerciseForm)).call(this, props));
	
	    _this.handleSave = function (e) {
	      e.preventDefault();
	      var editMode = _this.props.exercise !== null;
	
	      if (editMode) {
	        _this.props.updateExercise(_this.props.exercise.id, { name: _this.state.name,
	          language: _this.state.language,
	          text: _this.state.text,
	          saveToGroup: _this.state.saveToGroup,
	          mode: _this.state.mode
	        });
	      } else {
	        _this.props.saveExercise(_this.state.name, _this.state.language, _this.state.text, _this.state.mode, _this.state.saveToGroup);
	      }
	    };
	
	    _this.handleLanguageChange = function (event, index, language) {
	      event.preventDefault();_this.setState({ language: language });
	    };
	
	    _this.handleName = function (event) {
	      event.preventDefault();_this.setState({ name: event.target.value });
	    };
	
	    _this.handleText = function (event) {
	      event.preventDefault();_this.setState({ text: event.target.value });
	    };
	
	    _this.handleMode = function (event, index, mode) {
	      event.preventDefault();_this.setState({ mode: mode });
	    };
	
	    var text = props.text ? props.text.texts.map(function (singleText) {
	      return singleText.source;
	    }).join(' ') : '';
	    var saveToGroup = _this.props.forceGroupSave || _this.props.exercise !== null && _this.props.exercise.group_id !== null;
	
	    _this.state = {
	      name: props.exercise && props.exercise.name || '',
	      language: props.language || 'en-GB',
	      mode: props.mode || 'normal',
	      text: text,
	      saveToGroup: saveToGroup
	    };
	    return _this;
	  }
	
	  _createClass(CreateExerciseForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var editMode = this.props.exercise !== null;
	      var disabled = this.state.name.length === 0 || this.state.text.length === 0 || this.props.isWaiting.EXERCISE_CREATE || this.props.isWaiting.EXERCISE_UPDATE;
	
	      var stats = {
	        length: this.state.text.length,
	        words: this.state.text.length === 0 ? this.state.text.split(' ').length - 1 : this.state.text.split(' ').length
	      };
	
	      var labelText = editMode ? 'Update exercise' : 'Save new exercise';
	      var createLabel = this.props.isWaiting.EXERCISE_CREATE || this.props.isWaiting.EXERCISE_UPDATE ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : labelText;
	      var type = void 0;
	
	      if (editMode) {
	        type = this.props.exercise.group_id !== null ? 'This is a group exercise.' : 'This is your personal exercise.';
	      }
	
	      var saveToGroup = this.props.canSaveToGroup && _react2.default.createElement(_Checkbox2.default, {
	        disabled: this.props.forceGroupSave || editMode && this.props.exercise.group_id !== null,
	        label: 'Save as a group exercise (visible to all in group)',
	        checked: this.state.saveToGroup,
	        onCheck: function onCheck() {
	          return _this2.setState({ saveToGroup: !_this2.state.saveToGroup });
	        }
	      });
	      return _react2.default.createElement(
	        'form',
	        null,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          type
	        ),
	        saveToGroup,
	        _react2.default.createElement(_TextField2.default, { onChange: this.handleName, errorText: this.props.nameErrorMessage, type: 'text', name: 'name', floatingLabelText: 'Exercise name', value: this.state.name }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _SelectField2.default,
	          {
	            floatingLabelText: 'Language',
	            value: this.state.language,
	            onChange: this.handleLanguageChange
	          },
	          _react2.default.createElement(_MenuItem2.default, { value: 'en-GB', primaryText: 'English (UK)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'en-US', primaryText: 'English (US)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'en-IN', primaryText: 'English (Indian)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'de-DE', primaryText: 'German' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'es-ES', primaryText: 'Spanish' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'es-US', primaryText: 'Spanish (US)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'fr-FR', primaryText: 'French' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'hi-IN', primaryText: 'Hindi' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'id-ID', primaryText: 'Indonesian' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'it-IT', primaryText: 'Italian' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'ja-JP', primaryText: 'Japanese' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'ko-KR', primaryText: 'Korean' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'nl-NL', primaryText: 'Dutch' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'pl-PL', primaryText: 'Polish' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'pt-BR', primaryText: 'Portuguese (Brazil)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'ru-RU', primaryText: 'Russian' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'zh-CN', primaryText: 'Chinese' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'zh-TW', primaryText: 'Chinese (Taiwan)' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'zh-HK', primaryText: 'Chinese (Hong Kong)' })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _SelectField2.default,
	          {
	            floatingLabelText: 'Mode',
	            value: this.state.mode,
	            onChange: this.handleMode
	          },
	          _react2.default.createElement(_MenuItem2.default, { value: 'normal', primaryText: 'Normal' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'flipped', primaryText: 'Flipped' })
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('textarea', { className: 'pronounce-exercise-text', value: this.state.text, onChange: this.handleText }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          stats.length,
	          ' characters - ',
	          stats.words,
	          ' words'
	        ),
	        this.props.textErrorMessage,
	        _react2.default.createElement(_FlatButton2.default, { type: 'submit', disabled: disabled, onClick: this.handleSave, label: createLabel })
	      );
	    }
	  }]);
	
	  return CreateExerciseForm;
	}(_react.Component);
	
	exports.default = CreateExerciseForm;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Gauge = function Gauge(props) {
	  var color = void 0;
	  if (props.score >= 75) {
	    color = '#008000';
	  } else if (props.score >= 50 && props.score < 75) {
	    color = '#ffff00';
	  } else if (props.score >= 25 && props.score < 50) {
	    color = '#ffa500';
	  } else {
	    color = '#ff0000';
	  }
	  var transform = {
	    transform: 'rotate(' + props.score * 1.8 + 'deg)',
	    background: color
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { id: 'gauge' },
	      _react2.default.createElement('div', { id: 'meter', style: transform }),
	      _react2.default.createElement(
	        'div',
	        { className: 'scoreBox' },
	        _react2.default.createElement(
	          'div',
	          { className: 'score' },
	          parseInt(props.score, 10) || 0
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'scale' },
	      _react2.default.createElement(
	        'div',
	        { className: 'start' },
	        '0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'end' },
	        '100'
	      )
	    )
	  );
	};
	
	exports.default = Gauge;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Slider = __webpack_require__(454);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _MuiThemeProvider = __webpack_require__(206);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(207);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	__webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var muiTheme = (0, _getMuiTheme2.default)({
	  slider: {
	    selectionColor: '#d52b1e',
	    handleFillColor: '#d52b1e'
	  }
	});
	
	var RateSlider = function RateSlider(props) {
	  return _react2.default.createElement(
	    _MuiThemeProvider2.default,
	    { muiTheme: muiTheme },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: { marginLeft: 100 - (1 - props.rate) * 150, marginBottom: -20, marginTop: 10, width: 30, height: 30, display: 'flex', justifyContent: 'center', zIndex: 100, alignItems: 'center', borderRadius: 10, backgroundColor: '#d52b1e' }, className: 'slider-current' },
	        'x' + props.rate
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'sliderBox' },
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-range' },
	          '0.5'
	        ),
	        _react2.default.createElement(_Slider2.default, {
	          className: 'slider',
	          disabled: !props.isStopped(),
	          min: 0.5,
	          max: 1.5,
	          axis: 'x',
	          value: props.rate,
	          disableFocusRipple: true,
	          onChange: function onChange(e, value) {
	            return props.setRate(value);
	          },
	          step: 0.1
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-range' },
	          '1.5'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slider-header' },
	        'Playback rate'
	      )
	    )
	  );
	};
	
	exports.default = RateSlider;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _audio = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Requirements = function (_Component) {
	  _inherits(Requirements, _Component);
	
	  function Requirements(props) {
	    _classCallCheck(this, Requirements);
	
	    var _this = _possibleConstructorReturn(this, (Requirements.__proto__ || Object.getPrototypeOf(Requirements)).call(this, props));
	
	    _this.updateVoices = function () {
	      _this.setState({ voices: (0, _audio.getVoices)() });
	    };
	
	    _this.state = {
	      voices: []
	    };
	    return _this;
	  }
	
	  _createClass(Requirements, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateVoices();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // getVoices on speechSynthesis will return an empty array if called too early.
	      // This hooks into SpeechSynthesis' onchange event for voices.
	      (0, _audio.onvoiceschanged)(this.updateVoices);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && navigator.userAgent.toLowerCase().indexOf('edge') === -1 && navigator.userAgent.toLowerCase().indexOf('opr') === -1;
	
	      if (!isChrome) {
	        return _react2.default.createElement(
	          'div',
	          { key: 'requirements' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Pronounce Live runs on the Google Chrome browser.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please check this page with Chrome to see supported languages.'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'requirements' },
	        _react2.default.createElement(
	          'p',
	          { className: 'requirement' },
	          'Pronounce Live runs on the Google Chrome browser.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'requirement' },
	          'View below which languages are supported by your browser.'
	        ),
	        _react2.default.createElement(
	          'select',
	          { className: 'requirement' },
	          this.state.voices.map(function (voice, index) {
	            return _react2.default.createElement(
	              'option',
	              { key: index },
	              voice.languageName
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Requirements;
	}(_react.Component);
	
	exports.default = Requirements;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var server = ("https://pronounce-live-admin.herokuapp.com/api/v1") || 'https://pladmin.sanako.com/api/v1';
	//const server = process.env.REACT_APP_API_URL || 'https://pronouncelive.dev/api/v1';
	
	
	exports.default = server;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CALL_API = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // middleware/api.js
	
	
	var _actions = __webpack_require__(20);
	
	var _getjwtdata = __webpack_require__(155);
	
	var _getjwtdata2 = _interopRequireDefault(_getjwtdata);
	
	var _config = __webpack_require__(246);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function callApi(endpoint, method) {
	  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var authenticated = arguments[3];
	  var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'text';
	  var dispatch = arguments[5];
	
	  var remember = false;
	  var token = localStorage.getItem('token');
	
	  if (token) {
	    remember = true;
	  } else {
	    token = sessionStorage.getItem('token');
	  }
	
	  var accept = type === 'text' ? 'application/json' : 'application/pdf';
	
	  var config = {
	    method: method,
	    headers: {
	      Accept: accept,
	      'Content-Type': 'application/json'
	    }
	  };
	
	  if (authenticated) {
	    if (token) {
	      config.headers.Authorization = 'Bearer ' + token;
	    } else {
	      dispatch((0, _actions.receiveLogout)());
	    }
	  }
	
	  if (body) {
	    config.body = JSON.stringify(body);
	  }
	
	  return fetch(_config2.default + endpoint, config).then(function (response) {
	    if (type === 'blob') {
	      return response.blob().then(function (payload) {
	        return {
	          payload: payload,
	          response: response
	        };
	      });
	    }
	    // text() reads a Response stream to completion as text
	    return response.text().then(function (payload) {
	      return {
	        payload: payload,
	        response: response
	      };
	    });
	  }).then(function (_ref) {
	    var payload = _ref.payload,
	        response = _ref.response;
	
	    console.log(payload);
	    if (authenticated) {
	      if (response.headers.get('Authorization') === null) {
	        dispatch((0, _actions.receiveLogout)());
	        return Promise.reject('No valid token refresh');
	      }
	
	      var jwtToken = response.headers.get('Authorization').replace('Bearer ', '');
	      var validToken = _getjwtdata2.default.verify(jwtToken);
	      if (validToken) {
	        if (remember) {
	          localStorage.setItem('token', jwtToken);
	        } else {
	          sessionStorage.setItem('token', jwtToken);
	        }
	
	        dispatch((0, _actions.refreshLogin)(jwtToken));
	      } else {
	        dispatch((0, _actions.receiveLogout)());
	        return Promise.reject('No valid token refresh');
	      }
	    }
	    console.log(response);
	    // Sometimes we might get an authorized response from unauthorized requests -
	    // these are very special cases like registration or subscription. But it
	    // makes live easier to still store the token from these responses.
	    if (response.headers.get('Authorization') !== null) {
	      var _jwtToken = response.headers.get('Authorization').replace('Bearer ', '');
	      var _validToken = _getjwtdata2.default.verify(_jwtToken);
	      if (_validToken) {
	        if (remember) {
	          localStorage.setItem('token', _jwtToken);
	        } else {
	          sessionStorage.setItem('token', _jwtToken);
	        }
	
	        dispatch((0, _actions.refreshLogin)(_jwtToken));
	      }
	    }
	
	    if (!response.ok) {
	      console.log('Rejectin promise');
	      console.log(JSON.parse(payload));
	      return Promise.reject(JSON.parse(payload));
	    }
	
	    if (type === 'text') {
	      var truePayload = JSON.parse(payload);
	      if (_typeof(truePayload.data) === 'object') {
	        return truePayload.data;
	      }
	      return truePayload;
	    }
	    return payload;
	  }).catch(function (err) {
	    return Promise.reject(err);
	  });
	}
	
	var CALL_API = exports.CALL_API = 'Call API';
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      var callAPI = action[CALL_API];
	
	      // So the middleware doesn't get applied to every single action
	      if (typeof callAPI === 'undefined') {
	        return next(action);
	      }
	
	      var endpoint = callAPI.endpoint,
	          method = callAPI.method,
	          body = callAPI.body,
	          type = callAPI.type,
	          types = callAPI.types,
	          authenticated = callAPI.authenticated;
	
	      var _types = _slicedToArray(types, 3),
	          requestType = _types[0],
	          successType = _types[1],
	          errorType = _types[2];
	
	      store.dispatch({
	        type: requestType
	      });
	
	      return callApi(endpoint, method, body, authenticated, type, store.dispatch, requestType).then(function (response) {
	        return next({
	          response: response,
	          authenticated: authenticated,
	          type: successType
	        });
	      }, function (error) {
	        return next({
	          errors: error.errors,
	          type: errorType
	        });
	      });
	    };
	  };
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _languagenames = __webpack_require__(102);
	
	var _languagenames2 = _interopRequireDefault(_languagenames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var synth = window.speechSynthesis || {};
	var timerID = null;
	
	var cancelSpeak = function cancelSpeak() {
	  if (timerID !== null) {
	    window.clearTimeout(timerID);
	    synth.cancel();
	  }
	};
	
	var speak = function speak(text, lang, voice, isAndroid) {
	  var onstart = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	  var onend = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	  var onerror = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	  var rate = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1.0;
	
	  console.log('speaking');
	  console.log(lang);
	  console.log(voice);
	  console.log(rate);
	  cancelSpeak();
	
	  // If the sentence is too long (200-300 characters with rate of 1),
	  // Chrome speechSynthesis just freezes and doesn't trigger the onend
	  // event. This timeout is a safeguard against that - a better solution
	  // would be to prevent long sentences in the first place.
	  timerID = window.setTimeout(function () {
	    if (window.speechSynthesis.speaking) {
	      cancelSpeak();
	      return;
	    }
	  }, 30000);
	
	  var utterance = new SpeechSynthesisUtterance(text);
	  utterance.lang = lang;
	
	  utterance.onstart = onstart;
	  utterance.onend = onend;
	  utterance.onerror = onerror;
	
	  // utterance.onboundary = () => { console.log('TTS - onboundary event.'); };
	  // utterance.onmark = () => { console.log('TTS - onmark event.'); };
	  // utterance.onpause = () => { console.log('TTS - onpause event.'); };
	  // utterance.onresume = () => { console.log('TTS - onresume event.'); };
	
	  utterance.voice = voice.voice;
	  utterance.rate = rate;
	  synth.speak(utterance);
	};
	
	var Speak = {
	  speak: speak,
	  cancel: cancelSpeak
	};
	
	var addVoices = function addVoices(voices) {
	  var newVoices = [].concat(_toConsumableArray(voices));
	
	  var indianEnglish = newVoices.filter(function (voice) {
	    return voice.lang === 'en-IN';
	  });
	  var hindi = newVoices.filter(function (voice) {
	    return voice.lang === 'hi-IN';
	  });
	
	  if (hindi.length === 1 && indianEnglish.length === 0) {
	    var fakeHindi = {
	      lang: 'en-IN',
	      ttsLang: 'hi-IN',
	      languageName: 'English (Indian)',
	      voice: hindi[0].voice
	    };
	
	    newVoices.push(fakeHindi);
	  }
	
	  return newVoices;
	};
	
	/* The list of SpeechSynthesisVoices returned by SpeechSynthesis needs
	to be cleaned up for the user interface (and for localization in the future).
	* First, it might include a native voice without a language that we don't
	* want to display.
	* Secondly, the lang attribute on SpeechSynthesisVoices is different on Android
	* (and maybe on other devices too).
	* We want the lang in BCP 47 format: subtag hyphen subtag, en-GB.
	* Even in English we'd want to display the list of languages and voices in
	* a more readable format, so adding a human
	* readable language and locale next to the lang tag helps with that.
	*
	 */
	var getVoices = function getVoices() {
	  if (typeof synth.getVoices !== 'function') {
	    return [];
	  }
	
	  var voices = synth.getVoices();
	  console.log(voices);
	  var uiVoices = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = voices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var voice = _step.value;
	
	      if (voice.lang.length >= 5) {
	        var lang = voice.lang.substr(0, 5).replace('_', '-');
	        var ttsLang = voice.lang.substr(0, 5).replace('_', '-');
	
	        var uiVoice = {
	          lang: lang,
	          ttsLang: ttsLang,
	          languageName: _languagenames2.default[lang] || lang,
	          voice: voice
	        };
	
	        uiVoices.push(uiVoice);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  uiVoices = addVoices(uiVoices);
	
	  return uiVoices;
	};
	
	var onvoiceschanged = function onvoiceschanged(func) {
	  synth.onvoiceschanged = func;
	};
	
	module.exports = {
	  Speak: Speak,
	  getVoices: getVoices,
	  onvoiceschanged: onvoiceschanged
	};

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  'name': 'Afghanistan',
	  'country_code': 'AF',
	  'currency': 'USD'
	}, {
	  'name': 'Albania',
	  'country_code': 'AL',
	  'currency': 'EUR'
	}, {
	  'name': 'Algeria',
	  'country_code': 'DZ',
	  'currency': 'USD'
	}, {
	  'name': 'American Samoa',
	  'country_code': 'DS',
	  'currency': 'USD'
	}, {
	  'name': 'Andorra',
	  'country_code': 'AD',
	  'currency': 'EUR'
	}, {
	  'name': 'Angola',
	  'country_code': 'AO',
	  'currency': 'USD'
	}, {
	  'name': 'Anguilla',
	  'country_code': 'AI',
	  'currency': 'USD'
	}, {
	  'name': 'Antarctica',
	  'country_code': 'AQ',
	  'currency': 'USD'
	}, {
	  'name': 'Antigua and/or Barbuda',
	  'country_code': 'AG',
	  'currency': 'USD'
	}, {
	  'name': 'Argentina',
	  'country_code': 'AR',
	  'currency': 'USD'
	}, {
	  'name': 'Armenia',
	  'country_code': 'AM',
	  'currency': 'USD'
	}, {
	  'name': 'Aruba',
	  'country_code': 'AW',
	  'currency': 'USD'
	}, {
	  'name': 'Australia',
	  'country_code': 'AU',
	  'currency': 'USD'
	}, {
	  'name': 'Austria',
	  'country_code': 'AT',
	  'currency': 'EUR'
	}, {
	  'name': 'Azerbaijan',
	  'country_code': 'AZ',
	  'currency': 'USD'
	}, {
	  'name': 'Bahamas',
	  'country_code': 'BS',
	  'currency': 'USD'
	}, {
	  'name': 'Bahrain',
	  'country_code': 'BH',
	  'currency': 'USD'
	}, {
	  'name': 'Bangladesh',
	  'country_code': 'BD',
	  'currency': 'USD'
	}, {
	  'name': 'Barbados',
	  'country_code': 'BB',
	  'currency': 'USD'
	}, {
	  'name': 'Belarus',
	  'country_code': 'BY',
	  'currency': 'USD'
	}, {
	  'name': 'Belgium',
	  'country_code': 'BE',
	  'currency': 'EUR'
	}, {
	  'name': 'Belize',
	  'country_code': 'BZ',
	  'currency': 'USD'
	}, {
	  'name': 'Benin',
	  'country_code': 'BJ',
	  'currency': 'USD'
	}, {
	  'name': 'Bermuda',
	  'country_code': 'BM',
	  'currency': 'USD'
	}, {
	  'name': 'Bhutan',
	  'country_code': 'BT',
	  'currency': 'USD'
	}, {
	  'name': 'Bolivia',
	  'country_code': 'BO',
	  'currency': 'USD'
	}, {
	  'name': 'Bosnia and Herzegovina',
	  'country_code': 'BA',
	  'currency': 'EUR'
	}, {
	  'name': 'Botswana',
	  'country_code': 'BW',
	  'currency': 'USD'
	}, {
	  'name': 'Bouvet Island',
	  'country_code': 'BV',
	  'currency': 'USD'
	}, {
	  'name': 'Brazil',
	  'country_code': 'BR',
	  'currency': 'USD'
	}, {
	  'name': 'British lndian Ocean Territory',
	  'country_code': 'IO',
	  'currency': 'USD'
	}, {
	  'name': 'Brunei Darussalam',
	  'country_code': 'BN',
	  'currency': 'USD'
	}, {
	  'name': 'Bulgaria',
	  'country_code': 'BG',
	  'currency': 'EUR'
	}, {
	  'name': 'Burkina Faso',
	  'country_code': 'BF',
	  'currency': 'USD'
	}, {
	  'name': 'Burundi',
	  'country_code': 'BI',
	  'currency': 'USD'
	}, {
	  'name': 'Cambodia',
	  'country_code': 'KH',
	  'currency': 'USD'
	}, {
	  'name': 'Cameroon',
	  'country_code': 'CM',
	  'currency': 'USD'
	}, {
	  'name': 'Canada',
	  'country_code': 'CA',
	  'currency': 'USD'
	}, {
	  'name': 'Cape Verde',
	  'country_code': 'CV',
	  'currency': 'USD'
	}, {
	  'name': 'Cayman Islands',
	  'country_code': 'KY',
	  'currency': 'USD'
	}, {
	  'name': 'Central African Republic',
	  'country_code': 'CF',
	  'currency': 'USD'
	}, {
	  'name': 'Chad',
	  'country_code': 'TD',
	  'currency': 'USD'
	}, {
	  'name': 'Chile',
	  'country_code': 'CL',
	  'currency': 'USD'
	}, {
	  'name': 'China',
	  'country_code': 'CN',
	  'currency': 'USD'
	}, {
	  'name': 'Christmas Island',
	  'country_code': 'CX',
	  'currency': 'USD'
	}, {
	  'name': 'Cocos (Keeling) Islands',
	  'country_code': 'CC',
	  'currency': 'USD'
	}, {
	  'name': 'Colombia',
	  'country_code': 'CO',
	  'currency': 'USD'
	}, {
	  'name': 'Comoros',
	  'country_code': 'KM',
	  'currency': 'USD'
	}, {
	  'name': 'Congo',
	  'country_code': 'CG',
	  'currency': 'USD'
	}, {
	  'name': 'Cook Islands',
	  'country_code': 'CK',
	  'currency': 'USD'
	}, {
	  'name': 'Costa Rica',
	  'country_code': 'CR',
	  'currency': 'USD'
	}, {
	  'name': 'Croatia (Hrvatska)',
	  'country_code': 'HR',
	  'currency': 'EUR'
	}, {
	  'name': 'Cuba',
	  'country_code': 'CU',
	  'currency': 'USD'
	}, {
	  'name': 'Cyprus',
	  'country_code': 'CY',
	  'currency': 'EUR'
	}, {
	  'name': 'Czech Republic',
	  'country_code': 'CZ',
	  'currency': 'EUR'
	}, {
	  'name': 'Denmark',
	  'country_code': 'DK',
	  'currency': 'EUR'
	}, {
	  'name': 'Djibouti',
	  'country_code': 'DJ',
	  'currency': 'USD'
	}, {
	  'name': 'Dominica',
	  'country_code': 'DM',
	  'currency': 'USD'
	}, {
	  'name': 'Dominican Republic',
	  'country_code': 'DO',
	  'currency': 'USD'
	}, {
	  'name': 'East Timor',
	  'country_code': 'TP',
	  'currency': 'USD'
	}, {
	  'name': 'Ecuador',
	  'country_code': 'EC',
	  'currency': 'USD'
	}, {
	  'name': 'Egypt',
	  'country_code': 'EG',
	  'currency': 'USD'
	}, {
	  'name': 'El Salvador',
	  'country_code': 'SV',
	  'currency': 'USD'
	}, {
	  'name': 'Equatorial Guinea',
	  'country_code': 'GQ',
	  'currency': 'USD'
	}, {
	  'name': 'Eritrea',
	  'country_code': 'ER',
	  'currency': 'USD'
	}, {
	  'name': 'Estonia',
	  'country_code': 'EE',
	  'currency': 'EUR'
	}, {
	  'name': 'Ethiopia',
	  'country_code': 'ET',
	  'currency': 'USD'
	}, {
	  'name': 'Falkland Islands (Malvinas)',
	  'country_code': 'FK',
	  'currency': 'GBP'
	}, {
	  'name': 'Faroe Islands',
	  'country_code': 'FO',
	  'currency': 'EUR'
	}, {
	  'name': 'Fiji',
	  'country_code': 'FJ',
	  'currency': 'USD'
	}, {
	  'name': 'Finland',
	  'country_code': 'FI',
	  'currency': 'EUR'
	}, {
	  'name': 'France',
	  'country_code': 'FR',
	  'currency': 'EUR'
	}, {
	  'name': 'France, Metropolitan',
	  'country_code': 'FX',
	  'currency': 'EUR'
	}, {
	  'name': 'French Guiana',
	  'country_code': 'GF',
	  'currency': 'USD'
	}, {
	  'name': 'French Polynesia',
	  'country_code': 'PF',
	  'currency': 'USD'
	}, {
	  'name': 'French Southern Territories',
	  'country_code': 'TF',
	  'currency': 'USD'
	}, {
	  'name': 'Gabon',
	  'country_code': 'GA',
	  'currency': 'USD'
	}, {
	  'name': 'Gambia',
	  'country_code': 'GM',
	  'currency': 'USD'
	}, {
	  'name': 'Georgia',
	  'country_code': 'GE',
	  'currency': 'USD'
	}, {
	  'name': 'Germany',
	  'country_code': 'DE',
	  'currency': 'EUR'
	}, {
	  'name': 'Ghana',
	  'country_code': 'GH',
	  'currency': 'USD'
	}, {
	  'name': 'Gibraltar',
	  'country_code': 'GI',
	  'currency': 'GBP'
	}, {
	  'name': 'Greece',
	  'country_code': 'GR',
	  'currency': 'EUR'
	}, {
	  'name': 'Greenland',
	  'country_code': 'GL',
	  'currency': 'EUR'
	}, {
	  'name': 'Grenada',
	  'country_code': 'GD',
	  'currency': 'USD'
	}, {
	  'name': 'Guadeloupe',
	  'country_code': 'GP',
	  'currency': 'USD'
	}, {
	  'name': 'Guam',
	  'country_code': 'GU',
	  'currency': 'USD'
	}, {
	  'name': 'Guatemala',
	  'country_code': 'GT',
	  'currency': 'USD'
	}, {
	  'name': 'Guinea',
	  'country_code': 'GN',
	  'currency': 'USD'
	}, {
	  'name': 'Guinea-Bissau',
	  'country_code': 'GW',
	  'currency': 'USD'
	}, {
	  'name': 'Guyana',
	  'country_code': 'GY',
	  'currency': 'USD'
	}, {
	  'name': 'Haiti',
	  'country_code': 'HT',
	  'currency': 'USD'
	}, {
	  'name': 'Heard and Mc Donald Islands',
	  'country_code': 'HM',
	  'currency': 'USD'
	}, {
	  'name': 'Honduras',
	  'country_code': 'HN',
	  'currency': 'USD'
	}, {
	  'name': 'Hong Kong',
	  'country_code': 'HK',
	  'currency': 'USD'
	}, {
	  'name': 'Hungary',
	  'country_code': 'HU',
	  'currency': 'EUR'
	}, {
	  'name': 'Iceland',
	  'country_code': 'IS',
	  'currency': 'EUR'
	}, {
	  'name': 'India',
	  'country_code': 'IN',
	  'currency': 'USD'
	}, {
	  'name': 'Indonesia',
	  'country_code': 'ID',
	  'currency': 'USD'
	}, {
	  'name': 'Iran (Islamic Republic of)',
	  'country_code': 'IR',
	  'currency': 'USD'
	}, {
	  'name': 'Iraq',
	  'country_code': 'IQ',
	  'currency': 'USD'
	}, {
	  'name': 'Ireland',
	  'country_code': 'IE',
	  'currency': 'EUR'
	}, {
	  'name': 'Israel',
	  'country_code': 'IL',
	  'currency': 'USD'
	}, {
	  'name': 'Italy',
	  'country_code': 'IT',
	  'currency': 'EUR'
	}, {
	  'name': 'Ivory Coast',
	  'country_code': 'CI',
	  'currency': 'USD'
	}, {
	  'name': 'Jamaica',
	  'country_code': 'JM',
	  'currency': 'USD'
	}, {
	  'name': 'Japan',
	  'country_code': 'JP',
	  'currency': 'USD'
	}, {
	  'name': 'Jordan',
	  'country_code': 'JO',
	  'currency': 'USD'
	}, {
	  'name': 'Kazakhstan',
	  'country_code': 'KZ',
	  'currency': 'USD'
	}, {
	  'name': 'Kenya',
	  'country_code': 'KE',
	  'currency': 'USD'
	}, {
	  'name': 'Kiribati',
	  'country_code': 'KI',
	  'currency': 'USD'
	}, {
	  'name': 'Korea, Democratic People\'s Republic of',
	  'country_code': 'KP',
	  'currency': 'USD'
	}, {
	  'name': 'Korea, Republic of',
	  'country_code': 'KR',
	  'currency': 'USD'
	}, {
	  'name': 'Kosovo',
	  'country_code': 'XK',
	  'currency': 'EUR'
	}, {
	  'name': 'Kuwait',
	  'country_code': 'KW',
	  'currency': 'USD'
	}, {
	  'name': 'Kyrgyzstan',
	  'country_code': 'KG',
	  'currency': 'USD'
	}, {
	  'name': 'Lao People\'s Democratic Republic',
	  'country_code': 'LA',
	  'currency': 'USD'
	}, {
	  'name': 'Latvia',
	  'country_code': 'LV',
	  'currency': 'EUR'
	}, {
	  'name': 'Lebanon',
	  'country_code': 'LB',
	  'currency': 'USD'
	}, {
	  'name': 'Lesotho',
	  'country_code': 'LS',
	  'currency': 'USD'
	}, {
	  'name': 'Liberia',
	  'country_code': 'LR',
	  'currency': 'USD'
	}, {
	  'name': 'Libyan Arab Jamahiriya',
	  'country_code': 'LY',
	  'currency': 'USD'
	}, {
	  'name': 'Liechtenstein',
	  'country_code': 'LI',
	  'currency': 'EUR'
	}, {
	  'name': 'Lithuania',
	  'country_code': 'LT',
	  'currency': 'USD'
	}, {
	  'name': 'Luxembourg',
	  'country_code': 'LU',
	  'currency': 'EUR'
	}, {
	  'name': 'Macau',
	  'country_code': 'MO',
	  'currency': 'USD'
	}, {
	  'name': 'Macedonia',
	  'country_code': 'MK',
	  'currency': 'USD'
	}, {
	  'name': 'Madagascar',
	  'country_code': 'MG',
	  'currency': 'USD'
	}, {
	  'name': 'Malawi',
	  'country_code': 'MW',
	  'currency': 'USD'
	}, {
	  'name': 'Malaysia',
	  'country_code': 'MY',
	  'currency': 'USD'
	}, {
	  'name': 'Maldives',
	  'country_code': 'MV',
	  'currency': 'USD'
	}, {
	  'name': 'Mali',
	  'country_code': 'ML',
	  'currency': 'USD'
	}, {
	  'name': 'Malta',
	  'country_code': 'MT',
	  'currency': 'EUR'
	}, {
	  'name': 'Marshall Islands',
	  'country_code': 'MH',
	  'currency': 'USD'
	}, {
	  'name': 'Martinique',
	  'country_code': 'MQ',
	  'currency': 'USD'
	}, {
	  'name': 'Mauritania',
	  'country_code': 'MR',
	  'currency': 'USD'
	}, {
	  'name': 'Mauritius',
	  'country_code': 'MU',
	  'currency': 'USD'
	}, {
	  'name': 'Mayotte',
	  'country_code': 'TY',
	  'currency': 'USD'
	}, {
	  'name': 'Mexico',
	  'country_code': 'MX',
	  'currency': 'USD'
	}, {
	  'name': 'Micronesia, Federated States of',
	  'country_code': 'FM',
	  'currency': 'USD'
	}, {
	  'name': 'Moldova, Republic of',
	  'country_code': 'MD',
	  'currency': 'USD'
	}, {
	  'name': 'Monaco',
	  'country_code': 'MC',
	  'currency': 'EUR'
	}, {
	  'name': 'Mongolia',
	  'country_code': 'MN',
	  'currency': 'USD'
	}, {
	  'name': 'Montenegro',
	  'country_code': 'ME',
	  'currency': 'EUR'
	}, {
	  'name': 'Montserrat',
	  'country_code': 'MS',
	  'currency': 'USD'
	}, {
	  'name': 'Morocco',
	  'country_code': 'MA',
	  'currency': 'USD'
	}, {
	  'name': 'Mozambique',
	  'country_code': 'MZ',
	  'currency': 'USD'
	}, {
	  'name': 'Myanmar',
	  'country_code': 'MM',
	  'currency': 'USD'
	}, {
	  'name': 'Namibia',
	  'country_code': 'NA',
	  'currency': 'USD'
	}, {
	  'name': 'Nauru',
	  'country_code': 'NR',
	  'currency': 'USD'
	}, {
	  'name': 'Nepal',
	  'country_code': 'NP',
	  'currency': 'USD'
	}, {
	  'name': 'Netherlands',
	  'country_code': 'NL',
	  'currency': 'EUR'
	}, {
	  'name': 'Netherlands Antilles',
	  'country_code': 'AN',
	  'currency': 'USD'
	}, {
	  'name': 'New Caledonia',
	  'country_code': 'NC',
	  'currency': 'USD'
	}, {
	  'name': 'New Zealand',
	  'country_code': 'NZ',
	  'currency': 'USD'
	}, {
	  'name': 'Nicaragua',
	  'country_code': 'NI',
	  'currency': 'USD'
	}, {
	  'name': 'Niger',
	  'country_code': 'NE',
	  'currency': 'USD'
	}, {
	  'name': 'Nigeria',
	  'country_code': 'NG',
	  'currency': 'USD'
	}, {
	  'name': 'Niue',
	  'country_code': 'NU',
	  'currency': 'USD'
	}, {
	  'name': 'Norfork Island',
	  'country_code': 'NF',
	  'currency': 'USD'
	}, {
	  'name': 'Northern Mariana Islands',
	  'country_code': 'MP',
	  'currency': 'USD'
	}, {
	  'name': 'Norway',
	  'country_code': 'NO',
	  'currency': 'EUR'
	}, {
	  'name': 'Oman',
	  'country_code': 'OM',
	  'currency': 'USD'
	}, {
	  'name': 'Pakistan',
	  'country_code': 'PK',
	  'currency': 'USD'
	}, {
	  'name': 'Palau',
	  'country_code': 'PW',
	  'currency': 'USD'
	}, {
	  'name': 'Panama',
	  'country_code': 'PA',
	  'currency': 'USD'
	}, {
	  'name': 'Papua New Guinea',
	  'country_code': 'PG',
	  'currency': 'USD'
	}, {
	  'name': 'Paraguay',
	  'country_code': 'PY',
	  'currency': 'USD'
	}, {
	  'name': 'Peru',
	  'country_code': 'PE',
	  'currency': 'USD'
	}, {
	  'name': 'Philippines',
	  'country_code': 'PH',
	  'currency': 'USD'
	}, {
	  'name': 'Pitcairn',
	  'country_code': 'PN',
	  'currency': 'USD'
	}, {
	  'name': 'Poland',
	  'country_code': 'PL',
	  'currency': 'EUR'
	}, {
	  'name': 'Portugal',
	  'country_code': 'PT',
	  'currency': 'EUR'
	}, {
	  'name': 'Puerto Rico',
	  'country_code': 'PR',
	  'currency': 'USD'
	}, {
	  'name': 'Qatar',
	  'country_code': 'QR',
	  'currency': 'USD'
	}, {
	  'name': 'Reunion',
	  'country_code': 'RE',
	  'currency': 'USD'
	}, {
	  'name': 'Romania',
	  'country_code': 'RO',
	  'currency': 'EUR'
	}, {
	  'name': 'Russian Federation',
	  'country_code': 'RU',
	  'currency': 'USD'
	}, {
	  'name': 'Rwanda',
	  'country_code': 'RW',
	  'currency': 'USD'
	}, {
	  'name': 'Saint Kitts and Nevis',
	  'country_code': 'KN',
	  'currency': 'USD'
	}, {
	  'name': 'Saint Lucia',
	  'country_code': 'LC',
	  'currency': 'USD'
	}, {
	  'name': 'Saint Vincent and the Grenadines',
	  'country_code': 'VC',
	  'currency': 'USD'
	}, {
	  'name': 'Samoa',
	  'country_code': 'WS',
	  'currency': 'USD'
	}, {
	  'name': 'San Marino',
	  'country_code': 'SM',
	  'currency': 'USD'
	}, {
	  'name': 'Sao Tome and Principe',
	  'country_code': 'ST',
	  'currency': 'USD'
	}, {
	  'name': 'Saudi Arabia',
	  'country_code': 'SA',
	  'currency': 'USD'
	}, {
	  'name': 'Senegal',
	  'country_code': 'SN',
	  'currency': 'USD'
	}, {
	  'name': 'Serbia',
	  'country_code': 'RS',
	  'currency': 'EUR'
	}, {
	  'name': 'Seychelles',
	  'country_code': 'SC',
	  'currency': 'USD'
	}, {
	  'name': 'Sierra Leone',
	  'country_code': 'SL',
	  'currency': 'USD'
	}, {
	  'name': 'Singapore',
	  'country_code': 'SG',
	  'currency': 'USD'
	}, {
	  'name': 'Slovakia',
	  'country_code': 'SK',
	  'currency': 'EUR'
	}, {
	  'name': 'Slovenia',
	  'country_code': 'SI',
	  'currency': 'EUR'
	}, {
	  'name': 'Solomon Islands',
	  'country_code': 'SB',
	  'currency': 'USD'
	}, {
	  'name': 'Somalia',
	  'country_code': 'SO',
	  'currency': 'USD'
	}, {
	  'name': 'South Africa',
	  'country_code': 'ZA',
	  'currency': 'USD'
	}, {
	  'name': 'South Georgia South Sandwich Islands',
	  'country_code': 'GS',
	  'currency': 'GBP'
	}, {
	  'name': 'Spain',
	  'country_code': 'ES',
	  'currency': 'EUR'
	}, {
	  'name': 'Sri Lanka',
	  'country_code': 'LK',
	  'currency': 'USD'
	}, {
	  'name': 'St. Helena',
	  'country_code': 'SH',
	  'currency': 'GBP'
	}, {
	  'name': 'St. Pierre and Miquelon',
	  'country_code': 'PM',
	  'currency': 'USD'
	}, {
	  'name': 'Sudan',
	  'country_code': 'SD',
	  'currency': 'USD'
	}, {
	  'name': 'Suriname',
	  'country_code': 'SR',
	  'currency': 'USD'
	}, {
	  'name': 'Svalbarn and Jan Mayen Islands',
	  'country_code': 'SJ',
	  'currency': 'EUR'
	}, {
	  'name': 'Swaziland',
	  'country_code': 'SZ',
	  'currency': 'USD'
	}, {
	  'name': 'Sweden',
	  'country_code': 'SE',
	  'currency': 'EUR'
	}, {
	  'name': 'Switzerland',
	  'country_code': 'CH',
	  'currency': 'EUR'
	}, {
	  'name': 'Syrian Arab Republic',
	  'country_code': 'SY',
	  'currency': 'USD'
	}, {
	  'name': 'Taiwan',
	  'country_code': 'TW',
	  'currency': 'USD'
	}, {
	  'name': 'Tajikistan',
	  'country_code': 'TJ',
	  'currency': 'USD'
	}, {
	  'name': 'Tanzania, United Republic of',
	  'country_code': 'TZ',
	  'currency': 'USD'
	}, {
	  'name': 'Thailand',
	  'country_code': 'TH',
	  'currency': 'USD'
	}, {
	  'name': 'Togo',
	  'country_code': 'TG',
	  'currency': 'USD'
	}, {
	  'name': 'Tokelau',
	  'country_code': 'TK',
	  'currency': 'USD'
	}, {
	  'name': 'Tonga',
	  'country_code': 'TO',
	  'currency': 'USD'
	}, {
	  'name': 'Trinidad and Tobago',
	  'country_code': 'TT',
	  'currency': 'USD'
	}, {
	  'name': 'Tunisia',
	  'country_code': 'TN',
	  'currency': 'USD'
	}, {
	  'name': 'Turkey',
	  'country_code': 'TR',
	  'currency': 'EUR'
	}, {
	  'name': 'Turkmenistan',
	  'country_code': 'TM',
	  'currency': 'USD'
	}, {
	  'name': 'Turks and Caicos Islands',
	  'country_code': 'TC',
	  'currency': 'USD'
	}, {
	  'name': 'Tuvalu',
	  'country_code': 'TV',
	  'currency': 'USD'
	}, {
	  'name': 'Uganda',
	  'country_code': 'UG',
	  'currency': 'USD'
	}, {
	  'name': 'Ukraine',
	  'country_code': 'UA',
	  'currency': 'USD'
	}, {
	  'name': 'United Arab Emirates',
	  'country_code': 'AE',
	  'currency': 'USD'
	}, {
	  'name': 'United Kingdom',
	  'country_code': 'GB',
	  'currency': 'GBP'
	}, {
	  'name': 'United States',
	  'country_code': 'US',
	  'currency': 'USD'
	}, {
	  'name': 'United States minor outlying islands',
	  'country_code': 'UM',
	  'currency': 'USD'
	}, {
	  'name': 'Uruguay',
	  'country_code': 'UY',
	  'currency': 'USD'
	}, {
	  'name': 'Uzbekistan',
	  'country_code': 'UZ',
	  'currency': 'USD'
	}, {
	  'name': 'Vanuatu',
	  'country_code': 'VU',
	  'currency': 'USD'
	}, {
	  'name': 'Vatican City State',
	  'country_code': 'VA',
	  'currency': 'EUR'
	}, {
	  'name': 'Venezuela',
	  'country_code': 'VE',
	  'currency': 'USD'
	}, {
	  'name': 'Vietnam',
	  'country_code': 'VN',
	  'currency': 'USD'
	}, {
	  'name': 'Virgin Islands (British)',
	  'country_code': 'VG',
	  'currency': 'USD'
	}, {
	  'name': 'Virgin Islands (U.S.)',
	  'country_code': 'VI',
	  'currency': 'USD'
	}, {
	  'name': 'Wallis and Futuna Islands',
	  'country_code': 'WF',
	  'currency': 'USD'
	}, {
	  'name': 'Western Sahara',
	  'country_code': 'EH',
	  'currency': 'USD'
	}, {
	  'name': 'Yemen',
	  'country_code': 'YE',
	  'currency': 'USD'
	}, {
	  'name': 'Yugoslavia',
	  'country_code': 'YU',
	  'currency': 'EUR'
	}, {
	  'name': 'Zaire',
	  'country_code': 'ZR',
	  'currency': 'USD'
	}, {
	  'name': 'Zambia',
	  'country_code': 'ZM',
	  'currency': 'USD'
	}, {
	  'name': 'Zimbabwe',
	  'country_code': 'ZW',
	  'currency': 'USD'
	}];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _levenshtein = __webpack_require__(414);
	
	var _levenshtein2 = _interopRequireDefault(_levenshtein);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jsdiff = __webpack_require__(325);
	
	function sanitizeInput(string) {
	  var sanitized = string.trim().toLowerCase();
	  sanitized = sanitized.replace(/[｡。！？'‘’“”";:,./?\\-]/g, '');
	  return sanitized;
	}
	
	var scoring = {
	  getTotalScore: function getTotalScore() {
	    var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var transcript = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var confidence = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    var originalSanitized = sanitizeInput(original);
	    var transcriptSanitized = sanitizeInput(transcript);
	
	    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
	      return 0;
	    }
	
	    var l = new _levenshtein2.default(originalSanitized, transcriptSanitized);
	    var score = 100 - l.distance / originalSanitized.length * 100;
	    score *= confidence;
	    score = score.toFixed(2);
	
	    if (score < 0) {
	      score = 0;
	    }
	    return score;
	  },
	  getTotalScoreAsia: function getTotalScoreAsia() {
	    var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var transcript = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var right = 0;
	    var score = 0;
	
	    var originalSanitized = sanitizeInput(original);
	    var transcriptSanitized = sanitizeInput(transcript);
	
	    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
	      return [0];
	    }
	    var diff = jsdiff.diffChars(originalSanitized, transcriptSanitized);
	
	    var originalWords = originalSanitized.split('');
	
	    diff.forEach(function (part) {
	      if (!part.added && !part.removed) {
	        right += part.count;
	      }
	    });
	
	    score = right / (originalWords.length * 100) - (transcript.length - originalWords.length);
	
	    return score;
	  },
	  getScoreByWord: function getScoreByWord() {
	    var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var transcript = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var score = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var confidence = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    var originalSanitized = sanitizeInput(original);
	    var transcriptSanitized = sanitizeInput(transcript);
	
	    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
	      return [0];
	    }
	    var lev = [];
	    var scoredWords = [];
	    var diff = jsdiff.diffWordsWithSpace(originalSanitized, transcriptSanitized);
	    var originalWords = originalSanitized.split(' ');
	    var pos = 0;
	    diff.forEach(function (part, j) {
	      var prev = {};
	      var newWordWords = part.value.split(' ');
	      newWordWords = newWordWords.filter(function (v) {
	        return v !== '';
	      });
	      if (!part.removed) {
	        if (part.added) {
	          if (j > 0) {
	            prev = diff[j - 1];
	          } else {
	            prev.removed = false;
	          }
	          for (var i = 0; i < newWordWords.length; i++) {
	            if (prev.removed) {
	              originalWords = prev.value.split(' ');
	              originalWords = originalWords.filter(function (v) {
	                return v !== '';
	              });
	              if (typeof originalWords[i] !== 'undefined') {
	                lev[i] = new _levenshtein2.default(originalWords[pos], newWordWords[i]);
	                var scoreTemp = 100 - lev[i].distance / originalWords[i].length * 100;
	                scoreTemp *= confidence;
	                scoredWords.push(scoreTemp);
	              } else {
	                scoredWords.push(0);
	              }
	            } else {
	              scoredWords.push(0);
	            }
	          }
	        } else {
	          for (var _i = 0; _i < newWordWords.length; _i++) {
	            scoredWords.push(100 * confidence);
	          }
	        }
	      }
	    });
	    for (var i = 0; i < scoredWords.length; i++) {
	      if (scoredWords[i] < 0) {
	        scoredWords[i] = 0;
	      }
	    }
	    return scoredWords;
	  },
	  getScoreByWordAsia: function getScoreByWordAsia() {
	    var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var transcript = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var originalSanitized = sanitizeInput(original);
	    var transcriptSanitized = sanitizeInput(transcript);
	
	    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
	      return [0];
	    }
	
	    var scoredWords = [];
	    var diff = jsdiff.diffChars(originalSanitized, transcriptSanitized);
	
	    diff.forEach(function (part) {
	      var newWordWords = part.value.split('');
	      newWordWords = newWordWords.filter(function (v) {
	        return v !== '';
	      });
	      if (!part.removed) {
	        if (part.added) {
	          for (var i = 0; i < newWordWords.length; i++) {
	            scoredWords.push(0);
	          }
	        } else {
	          for (var _i2 = 0; _i2 < newWordWords.length; _i2++) {
	            scoredWords.push(100);
	          }
	        }
	      }
	    });
	    for (var i = 0; i < scoredWords.length; i++) {
	      if (scoredWords[i] < 0) {
	        scoredWords[i] = 0;
	      }
	    }
	    return scoredWords;
	  }
	};
	
	module.exports = scoring;

/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**********************
	 * This simple module exists to
	 * 1) abstract the storing of objects into localStorage
	 * 2) later harmonize the storing mechanism between this and the React Native app, so that redux components
	 * can be used between them without modification
	 */
	
	function prepare(data) {
	  return JSON.stringify(data);
	}
	
	function reverse(data) {
	  return JSON.parse(data);
	}
	
	exports.default = function () {
	
	  function set(id, data) {
	
	    localStorage.setItem('p-' + id, prepare(data));
	  }
	
	  function get(id) {
	    if (!localStorage.getItem('p-' + id)) {
	      return {};
	    } else {
	      return reverse(localStorage.getItem('p-' + id));
	    }
	  }
	
	  return { set: set, get: get };
	}();

/***/ },
/* 252 */
140,
/* 253 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactElement = __webpack_require__(70);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(43);
	var REACT_ELEMENT_TYPE = __webpack_require__(253);
	
	var getIteratorFn = __webpack_require__(256);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(252);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ },
/* 260 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(718);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 264 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(266);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 266 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(276), __esModule: true };

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(280), __esModule: true };

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(281), __esModule: true };

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(282), __esModule: true };

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(104);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(721)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 273 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(179);
	__webpack_require__(304);
	module.exports = __webpack_require__(29).Array.from;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(306);
	module.exports = __webpack_require__(29).Object.assign;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(307);
	var $Object = __webpack_require__(29).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(308);
	var $Object = __webpack_require__(29).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(309);
	module.exports = __webpack_require__(29).Object.getPrototypeOf;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(310);
	module.exports = __webpack_require__(29).Object.keys;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(311);
	module.exports = __webpack_require__(29).Object.setPrototypeOf;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(313);
	__webpack_require__(312);
	__webpack_require__(314);
	__webpack_require__(315);
	module.exports = __webpack_require__(29).Symbol;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(179);
	__webpack_require__(316);
	module.exports = __webpack_require__(118).f('iterator');


/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(60);
	var toLength = __webpack_require__(178);
	var toAbsoluteIndex = __webpack_require__(302);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(105);
	var TAG = __webpack_require__(36)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(46);
	var createDesc = __webpack_require__(75);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(74);
	var gOPS = __webpack_require__(111);
	var pIE = __webpack_require__(82);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(45).document;
	module.exports = document && document.documentElement;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(73);
	var ITERATOR = __webpack_require__(36)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(105);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(56);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(110);
	var descriptor = __webpack_require__(75);
	var setToStringTag = __webpack_require__(112);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(58)(IteratorPrototype, __webpack_require__(36)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(36)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(83)('meta');
	var isObject = __webpack_require__(59);
	var has = __webpack_require__(52);
	var setDesc = __webpack_require__(46).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(57)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(74);
	var gOPS = __webpack_require__(111);
	var pIE = __webpack_require__(82);
	var toObject = __webpack_require__(76);
	var IObject = __webpack_require__(170);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(57)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(46);
	var anObject = __webpack_require__(56);
	var getKeys = __webpack_require__(74);
	
	module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(60);
	var gOPN = __webpack_require__(173).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(59);
	var anObject = __webpack_require__(56);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(106)(Function.call, __webpack_require__(172).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(115);
	var defined = __webpack_require__(107);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(115);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(286);
	var ITERATOR = __webpack_require__(36)('iterator');
	var Iterators = __webpack_require__(73);
	module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(106);
	var $export = __webpack_require__(44);
	var toObject = __webpack_require__(76);
	var call = __webpack_require__(292);
	var isArrayIter = __webpack_require__(290);
	var toLength = __webpack_require__(178);
	var createProperty = __webpack_require__(287);
	var getIterFn = __webpack_require__(303);
	
	$export($export.S + $export.F * !__webpack_require__(294)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(284);
	var step = __webpack_require__(295);
	var Iterators = __webpack_require__(73);
	var toIObject = __webpack_require__(60);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(171)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(44);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(297) });


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(44);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(110) });


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(44);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(46).f });


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(76);
	var $getPrototypeOf = __webpack_require__(174);
	
	__webpack_require__(176)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(76);
	var $keys = __webpack_require__(74);
	
	__webpack_require__(176)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(44);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(300).set });


/***/ },
/* 312 */
/***/ function(module, exports) {



/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(45);
	var has = __webpack_require__(52);
	var DESCRIPTORS = __webpack_require__(51);
	var $export = __webpack_require__(44);
	var redefine = __webpack_require__(177);
	var META = __webpack_require__(296).KEY;
	var $fails = __webpack_require__(57);
	var shared = __webpack_require__(114);
	var setToStringTag = __webpack_require__(112);
	var uid = __webpack_require__(83);
	var wks = __webpack_require__(36);
	var wksExt = __webpack_require__(118);
	var wksDefine = __webpack_require__(117);
	var enumKeys = __webpack_require__(288);
	var isArray = __webpack_require__(291);
	var anObject = __webpack_require__(56);
	var isObject = __webpack_require__(59);
	var toIObject = __webpack_require__(60);
	var toPrimitive = __webpack_require__(116);
	var createDesc = __webpack_require__(75);
	var _create = __webpack_require__(110);
	var gOPNExt = __webpack_require__(299);
	var $GOPD = __webpack_require__(172);
	var $DP = __webpack_require__(46);
	var $keys = __webpack_require__(74);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(173).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(82).f = $propertyIsEnumerable;
	  __webpack_require__(111).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(109)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(58)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(117)('asyncIterator');


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(117)('observable');


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(305);
	var global = __webpack_require__(45);
	var hide = __webpack_require__(58);
	var Iterators = __webpack_require__(73);
	var TO_STRING_TAG = __webpack_require__(36)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 317 */
/***/ function(module, exports) {

	/*istanbul ignore start*/"use strict";
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToDMP = convertChangesToDMP;
	// See: http://code.google.com/p/google-diff-match-patch/wiki/API
	function convertChangesToDMP(changes) {
	  var ret = [],
	      change = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      operation = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	  for (var i = 0; i < changes.length; i++) {
	    change = changes[i];
	    if (change.added) {
	      operation = 1;
	    } else if (change.removed) {
	      operation = -1;
	    } else {
	      operation = 0;
	    }
	
	    ret.push([operation, change.value]);
	  }
	  return ret;
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb252ZXJ0L2RtcC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQ2dCLG1CLEdBQUEsbUI7O0FBQVQsU0FBUyxtQkFBVCxDQUE2QixPQUE3QixFQUFzQztBQUMzQyxNQUFJLE1BQU0sRUFBVjtBQUFBLE1BQ0ksUyx5QkFBQSxNLHdCQURKO0FBQUEsTUFFSSxZLHlCQUFBLE0sd0JBRko7QUFHQSxPQUFLLElBQUksSUFBSSxDQUFiLEVBQWdCLElBQUksUUFBUSxNQUE1QixFQUFvQyxHQUFwQyxFQUF5QztBQUN2QyxhQUFTLFFBQVEsQ0FBUixDQUFUO0FBQ0EsUUFBSSxPQUFPLEtBQVgsRUFBa0I7QUFDaEIsa0JBQVksQ0FBWjtBQUNELEtBRkQsTUFFTyxJQUFJLE9BQU8sT0FBWCxFQUFvQjtBQUN6QixrQkFBWSxDQUFDLENBQWI7QUFDRCxLQUZNLE1BRUE7QUFDTCxrQkFBWSxDQUFaO0FBQ0Q7O0FBRUQsUUFBSSxJQUFKLENBQVMsQ0FBQyxTQUFELEVBQVksT0FBTyxLQUFuQixDQUFUO0FBQ0Q7QUFDRCxTQUFPLEdBQVA7QUFDRCIsImZpbGUiOiJkbXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTZWU6IGh0dHA6Ly9jb2RlLmdvb2dsZS5jb20vcC9nb29nbGUtZGlmZi1tYXRjaC1wYXRjaC93aWtpL0FQSVxuZXhwb3J0IGZ1bmN0aW9uIGNvbnZlcnRDaGFuZ2VzVG9ETVAoY2hhbmdlcykge1xuICBsZXQgcmV0ID0gW10sXG4gICAgICBjaGFuZ2UsXG4gICAgICBvcGVyYXRpb247XG4gIGZvciAobGV0IGkgPSAwOyBpIDwgY2hhbmdlcy5sZW5ndGg7IGkrKykge1xuICAgIGNoYW5nZSA9IGNoYW5nZXNbaV07XG4gICAgaWYgKGNoYW5nZS5hZGRlZCkge1xuICAgICAgb3BlcmF0aW9uID0gMTtcbiAgICB9IGVsc2UgaWYgKGNoYW5nZS5yZW1vdmVkKSB7XG4gICAgICBvcGVyYXRpb24gPSAtMTtcbiAgICB9IGVsc2Uge1xuICAgICAgb3BlcmF0aW9uID0gMDtcbiAgICB9XG5cbiAgICByZXQucHVzaChbb3BlcmF0aW9uLCBjaGFuZ2UudmFsdWVdKTtcbiAgfVxuICByZXR1cm4gcmV0O1xufVxuIl19


/***/ },
/* 318 */
/***/ function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToXML = convertChangesToXML;
	function convertChangesToXML(changes) {
	  var ret = [];
	  for (var i = 0; i < changes.length; i++) {
	    var change = changes[i];
	    if (change.added) {
	      ret.push('<ins>');
	    } else if (change.removed) {
	      ret.push('<del>');
	    }
	
	    ret.push(escapeHTML(change.value));
	
	    if (change.added) {
	      ret.push('</ins>');
	    } else if (change.removed) {
	      ret.push('</del>');
	    }
	  }
	  return ret.join('');
	}
	
	function escapeHTML(s) {
	  var n = s;
	  n = n.replace(/&/g, '&amp;');
	  n = n.replace(/</g, '&lt;');
	  n = n.replace(/>/g, '&gt;');
	  n = n.replace(/"/g, '&quot;');
	
	  return n;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.arrayDiff = undefined;
	exports. /*istanbul ignore end*/diffArrays = diffArrays;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var arrayDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/arrayDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	arrayDiff.tokenize = arrayDiff.join = function (value) {
	  return value.slice();
	};
	
	function diffArrays(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2FycmF5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Z0NBT2dCLFUsR0FBQSxVOztBQVBoQixJLHlCQUFBLHlCLHdCQUFBOzs7Ozs7O3VCQUVPLElBQU0sWSx5QkFBQSxRLHdCQUFBLFlBQVksSSx5QkFBQSxtQix3QkFBbEI7QUFDUCxVQUFVLFFBQVYsR0FBcUIsVUFBVSxJQUFWLEdBQWlCLFVBQVMsS0FBVCxFQUFnQjtBQUNwRCxTQUFPLE1BQU0sS0FBTixFQUFQO0FBQ0QsQ0FGRDs7QUFJTyxTQUFTLFVBQVQsQ0FBb0IsTUFBcEIsRUFBNEIsTUFBNUIsRUFBb0MsUUFBcEMsRUFBOEM7QUFBRSxTQUFPLFVBQVUsSUFBVixDQUFlLE1BQWYsRUFBdUIsTUFBdkIsRUFBK0IsUUFBL0IsQ0FBUDtBQUFrRCIsImZpbGUiOiJhcnJheS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBjb25zdCBhcnJheURpZmYgPSBuZXcgRGlmZigpO1xuYXJyYXlEaWZmLnRva2VuaXplID0gYXJyYXlEaWZmLmpvaW4gPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc2xpY2UoKTtcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBkaWZmQXJyYXlzKG9sZEFyciwgbmV3QXJyLCBjYWxsYmFjaykgeyByZXR1cm4gYXJyYXlEaWZmLmRpZmYob2xkQXJyLCBuZXdBcnIsIGNhbGxiYWNrKTsgfVxuIl19


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.characterDiff = undefined;
	exports. /*istanbul ignore end*/diffChars = diffChars;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var characterDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/characterDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	function diffChars(oldStr, newStr, callback) {
	  return characterDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2NoYXJhY3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQUdnQixTLEdBQUEsUzs7QUFIaEIsSSx5QkFBQSx5Qix3QkFBQTs7Ozs7Ozt1QkFFTyxJQUFNLGdCLHlCQUFBLFEsd0JBQUEsZ0JBQWdCLEkseUJBQUEsbUIsd0JBQXRCO0FBQ0EsU0FBUyxTQUFULENBQW1CLE1BQW5CLEVBQTJCLE1BQTNCLEVBQW1DLFFBQW5DLEVBQTZDO0FBQUUsU0FBTyxjQUFjLElBQWQsQ0FBbUIsTUFBbkIsRUFBMkIsTUFBM0IsRUFBbUMsUUFBbkMsQ0FBUDtBQUFzRCIsImZpbGUiOiJjaGFyYWN0ZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRGlmZiBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgY29uc3QgY2hhcmFjdGVyRGlmZiA9IG5ldyBEaWZmKCk7XG5leHBvcnQgZnVuY3Rpb24gZGlmZkNoYXJzKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjaykgeyByZXR1cm4gY2hhcmFjdGVyRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.cssDiff = undefined;
	exports. /*istanbul ignore end*/diffCss = diffCss;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var cssDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/cssDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	cssDiff.tokenize = function (value) {
	  return value.split(/([{}:;,]|\s+)/);
	};
	
	function diffCss(oldStr, newStr, callback) {
	  return cssDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2Nzcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQU9nQixPLEdBQUEsTzs7QUFQaEIsSSx5QkFBQSx5Qix3QkFBQTs7Ozs7Ozt1QkFFTyxJQUFNLFUseUJBQUEsUSx3QkFBQSxVQUFVLEkseUJBQUEsbUIsd0JBQWhCO0FBQ1AsUUFBUSxRQUFSLEdBQW1CLFVBQVMsS0FBVCxFQUFnQjtBQUNqQyxTQUFPLE1BQU0sS0FBTixDQUFZLGVBQVosQ0FBUDtBQUNELENBRkQ7O0FBSU8sU0FBUyxPQUFULENBQWlCLE1BQWpCLEVBQXlCLE1BQXpCLEVBQWlDLFFBQWpDLEVBQTJDO0FBQUUsU0FBTyxRQUFRLElBQVIsQ0FBYSxNQUFiLEVBQXFCLE1BQXJCLEVBQTZCLFFBQTdCLENBQVA7QUFBZ0QiLCJmaWxlIjoiY3NzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERpZmYgZnJvbSAnLi9iYXNlJztcblxuZXhwb3J0IGNvbnN0IGNzc0RpZmYgPSBuZXcgRGlmZigpO1xuY3NzRGlmZi50b2tlbml6ZSA9IGZ1bmN0aW9uKHZhbHVlKSB7XG4gIHJldHVybiB2YWx1ZS5zcGxpdCgvKFt7fTo7LF18XFxzKykvKTtcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBkaWZmQ3NzKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjaykgeyByZXR1cm4gY3NzRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.jsonDiff = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports. /*istanbul ignore end*/diffJson = diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = canonicalize;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_line = __webpack_require__(119) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/
	
	var objectPrototypeToString = Object.prototype.toString;
	
	var jsonDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/jsonDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	// Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
	// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
	jsonDiff.useLongestToken = true;
	
	jsonDiff.tokenize = /*istanbul ignore start*/_line.lineDiff. /*istanbul ignore end*/tokenize;
	jsonDiff.castInput = function (value) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/undefinedReplacement = this.options.undefinedReplacement;
	
	
	  return typeof value === 'string' ? value : JSON.stringify(canonicalize(value), function (k, v) {
	    if (typeof v === 'undefined') {
	      return undefinedReplacement;
	    }
	
	    return v;
	  }, '  ');
	};
	jsonDiff.equals = function (left, right) {
	  return (/*istanbul ignore start*/_base2['default']. /*istanbul ignore end*/prototype.equals(left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'))
	  );
	};
	
	function diffJson(oldObj, newObj, options) {
	  return jsonDiff.diff(oldObj, newObj, options);
	}
	
	// This function handles the presence of circular references by bailing out when encountering an
	// object that is already on the "stack" of items being processed.
	function canonicalize(obj, stack, replacementStack) {
	  stack = stack || [];
	  replacementStack = replacementStack || [];
	
	  var i = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  for (i = 0; i < stack.length; i += 1) {
	    if (stack[i] === obj) {
	      return replacementStack[i];
	    }
	  }
	
	  var canonicalizedObj = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  if ('[object Array]' === objectPrototypeToString.call(obj)) {
	    stack.push(obj);
	    canonicalizedObj = new Array(obj.length);
	    replacementStack.push(canonicalizedObj);
	    for (i = 0; i < obj.length; i += 1) {
	      canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack);
	    }
	    stack.pop();
	    replacementStack.pop();
	    return canonicalizedObj;
	  }
	
	  if (obj && obj.toJSON) {
	    obj = obj.toJSON();
	  }
	
	  if ( /*istanbul ignore start*/(typeof /*istanbul ignore end*/obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
	    stack.push(obj);
	    canonicalizedObj = {};
	    replacementStack.push(canonicalizedObj);
	    var sortedKeys = [],
	        key = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	    for (key in obj) {
	      /* istanbul ignore else */
	      if (obj.hasOwnProperty(key)) {
	        sortedKeys.push(key);
	      }
	    }
	    sortedKeys.sort();
	    for (i = 0; i < sortedKeys.length; i += 1) {
	      key = sortedKeys[i];
	      canonicalizedObj[key] = canonicalize(obj[key], stack, replacementStack);
	    }
	    stack.pop();
	    replacementStack.pop();
	  } else {
	    canonicalizedObj = obj;
	  }
	  return canonicalizedObj;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.sentenceDiff = undefined;
	exports. /*istanbul ignore end*/diffSentences = diffSentences;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var sentenceDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/sentenceDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	sentenceDiff.tokenize = function (value) {
	  return value.split(/(\S.+?[.!?])(?=\s+|$)/);
	};
	
	function diffSentences(oldStr, newStr, callback) {
	  return sentenceDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL3NlbnRlbmNlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Z0NBUWdCLGEsR0FBQSxhOztBQVJoQixJLHlCQUFBLHlCLHdCQUFBOzs7Ozs7O3VCQUdPLElBQU0sZSx5QkFBQSxRLHdCQUFBLGVBQWUsSSx5QkFBQSxtQix3QkFBckI7QUFDUCxhQUFhLFFBQWIsR0FBd0IsVUFBUyxLQUFULEVBQWdCO0FBQ3RDLFNBQU8sTUFBTSxLQUFOLENBQVksdUJBQVosQ0FBUDtBQUNELENBRkQ7O0FBSU8sU0FBUyxhQUFULENBQXVCLE1BQXZCLEVBQStCLE1BQS9CLEVBQXVDLFFBQXZDLEVBQWlEO0FBQUUsU0FBTyxhQUFhLElBQWIsQ0FBa0IsTUFBbEIsRUFBMEIsTUFBMUIsRUFBa0MsUUFBbEMsQ0FBUDtBQUFxRCIsImZpbGUiOiJzZW50ZW5jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cblxuZXhwb3J0IGNvbnN0IHNlbnRlbmNlRGlmZiA9IG5ldyBEaWZmKCk7XG5zZW50ZW5jZURpZmYudG9rZW5pemUgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc3BsaXQoLyhcXFMuKz9bLiE/XSkoPz1cXHMrfCQpLyk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZlNlbnRlbmNlcyhvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spIHsgcmV0dXJuIHNlbnRlbmNlRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.wordDiff = undefined;
	exports. /*istanbul ignore end*/diffWords = diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = diffWordsWithSpace;
	
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_params = __webpack_require__(181) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/
	
	// Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
	//
	// Ranges and exceptions:
	// Latin-1 Supplement, 0080–00FF
	//  - U+00D7  × Multiplication sign
	//  - U+00F7  ÷ Division sign
	// Latin Extended-A, 0100–017F
	// Latin Extended-B, 0180–024F
	// IPA Extensions, 0250–02AF
	// Spacing Modifier Letters, 02B0–02FF
	//  - U+02C7  ˇ &#711;  Caron
	//  - U+02D8  ˘ &#728;  Breve
	//  - U+02D9  ˙ &#729;  Dot Above
	//  - U+02DA  ˚ &#730;  Ring Above
	//  - U+02DB  ˛ &#731;  Ogonek
	//  - U+02DC  ˜ &#732;  Small Tilde
	//  - U+02DD  ˝ &#733;  Double Acute Accent
	// Latin Extended Additional, 1E00–1EFF
	var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
	
	var reWhitespace = /\S/;
	
	var wordDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/wordDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	wordDiff.equals = function (left, right) {
	  return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
	};
	wordDiff.tokenize = function (value) {
	  var tokens = value.split(/(\s+|\b)/);
	
	  // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
	  for (var i = 0; i < tokens.length - 1; i++) {
	    // If we have an empty string in the next field and we have only word chars before and after, merge
	    if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
	      tokens[i] += tokens[i + 2];
	      tokens.splice(i + 1, 2);
	      i--;
	    }
	  }
	
	  return tokens;
	};
	
	function diffWords(oldStr, newStr, callback) {
	  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
	  return wordDiff.diff(oldStr, newStr, options);
	}
	function diffWordsWithSpace(oldStr, newStr, callback) {
	  return wordDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.canonicalize = exports.convertChangesToXML = exports.convertChangesToDMP = exports.parsePatch = exports.applyPatches = exports.applyPatch = exports.createPatch = exports.createTwoFilesPatch = exports.structuredPatch = exports.diffArrays = exports.diffJson = exports.diffCss = exports.diffSentences = exports.diffTrimmedLines = exports.diffLines = exports.diffWordsWithSpace = exports.diffWords = exports.diffChars = exports.Diff = undefined;
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_base = __webpack_require__(47) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_character = __webpack_require__(320) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_word = __webpack_require__(324) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_line = __webpack_require__(119) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_sentence = __webpack_require__(323) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_css = __webpack_require__(321) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_json = __webpack_require__(322) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_array = __webpack_require__(319) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_apply = __webpack_require__(326) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_parse = __webpack_require__(180) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_create = __webpack_require__(327) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_dmp = __webpack_require__(317) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_xml = __webpack_require__(318) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports. /*istanbul ignore end*/Diff = _base2['default'];
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffChars = _character.diffChars;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWords = _word.diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = _word.diffWordsWithSpace;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffLines = _line.diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = _line.diffTrimmedLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffSentences = _sentence.diffSentences;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffCss = _css.diffCss;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffJson = _json.diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffArrays = _array.diffArrays;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/structuredPatch = _create.structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = _create.createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = _create.createPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatch = _apply.applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = _apply.applyPatches;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/parsePatch = _parse.parsePatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToDMP = _dmp.convertChangesToDMP;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToXML = _xml.convertChangesToXML;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = _json.canonicalize; /* See LICENSE file for terms of use */
	
	/*
	 * Text diff implementation.
	 *
	 * This library supports the following APIS:
	 * JsDiff.diffChars: Character by character diff
	 * JsDiff.diffWords: Word (as defined by \b regex) diff which ignores whitespace
	 * JsDiff.diffLines: Line based diff
	 *
	 * JsDiff.diffCss: Diff targeted at CSS content
	 *
	 * These methods are based on the implementation proposed in
	 * "An O(ND) Difference Algorithm and its Variations" (Myers, 1986).
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
	 */
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQWdCQSxJLHlCQUFBLDhCLHdCQUFBOzs7Ozs7QUFDQSxJLHlCQUFBLHdDLHdCQUFBOztBQUNBLEkseUJBQUEsOEIsd0JBQUE7O0FBQ0EsSSx5QkFBQSw4Qix3QkFBQTs7QUFDQSxJLHlCQUFBLHNDLHdCQUFBOztBQUVBLEkseUJBQUEsNEIsd0JBQUE7O0FBQ0EsSSx5QkFBQSw4Qix3QkFBQTs7QUFFQSxJLHlCQUFBLGdDLHdCQUFBOztBQUVBLEkseUJBQUEsaUMsd0JBQUE7O0FBQ0EsSSx5QkFBQSxpQyx3QkFBQTs7QUFDQSxJLHlCQUFBLG1DLHdCQUFBOztBQUVBLEkseUJBQUEsK0Isd0JBQUE7O0FBQ0EsSSx5QkFBQSwrQix3QkFBQTs7Ozs7Z0NBR0UsSTt5REFFQSxTO3lEQUNBLFM7eURBQ0Esa0I7eURBQ0EsUzt5REFDQSxnQjt5REFDQSxhO3lEQUVBLE87eURBQ0EsUTt5REFFQSxVO3lEQUVBLGU7eURBQ0EsbUI7eURBQ0EsVzt5REFDQSxVO3lEQUNBLFk7eURBQ0EsVTt5REFDQSxtQjt5REFDQSxtQjt5REFDQSxZIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogU2VlIExJQ0VOU0UgZmlsZSBmb3IgdGVybXMgb2YgdXNlICovXG5cbi8qXG4gKiBUZXh0IGRpZmYgaW1wbGVtZW50YXRpb24uXG4gKlxuICogVGhpcyBsaWJyYXJ5IHN1cHBvcnRzIHRoZSBmb2xsb3dpbmcgQVBJUzpcbiAqIEpzRGlmZi5kaWZmQ2hhcnM6IENoYXJhY3RlciBieSBjaGFyYWN0ZXIgZGlmZlxuICogSnNEaWZmLmRpZmZXb3JkczogV29yZCAoYXMgZGVmaW5lZCBieSBcXGIgcmVnZXgpIGRpZmYgd2hpY2ggaWdub3JlcyB3aGl0ZXNwYWNlXG4gKiBKc0RpZmYuZGlmZkxpbmVzOiBMaW5lIGJhc2VkIGRpZmZcbiAqXG4gKiBKc0RpZmYuZGlmZkNzczogRGlmZiB0YXJnZXRlZCBhdCBDU1MgY29udGVudFxuICpcbiAqIFRoZXNlIG1ldGhvZHMgYXJlIGJhc2VkIG9uIHRoZSBpbXBsZW1lbnRhdGlvbiBwcm9wb3NlZCBpblxuICogXCJBbiBPKE5EKSBEaWZmZXJlbmNlIEFsZ29yaXRobSBhbmQgaXRzIFZhcmlhdGlvbnNcIiAoTXllcnMsIDE5ODYpLlxuICogaHR0cDovL2NpdGVzZWVyeC5pc3QucHN1LmVkdS92aWV3ZG9jL3N1bW1hcnk/ZG9pPTEwLjEuMS40LjY5MjdcbiAqL1xuaW1wb3J0IERpZmYgZnJvbSAnLi9kaWZmL2Jhc2UnO1xuaW1wb3J0IHtkaWZmQ2hhcnN9IGZyb20gJy4vZGlmZi9jaGFyYWN0ZXInO1xuaW1wb3J0IHtkaWZmV29yZHMsIGRpZmZXb3Jkc1dpdGhTcGFjZX0gZnJvbSAnLi9kaWZmL3dvcmQnO1xuaW1wb3J0IHtkaWZmTGluZXMsIGRpZmZUcmltbWVkTGluZXN9IGZyb20gJy4vZGlmZi9saW5lJztcbmltcG9ydCB7ZGlmZlNlbnRlbmNlc30gZnJvbSAnLi9kaWZmL3NlbnRlbmNlJztcblxuaW1wb3J0IHtkaWZmQ3NzfSBmcm9tICcuL2RpZmYvY3NzJztcbmltcG9ydCB7ZGlmZkpzb24sIGNhbm9uaWNhbGl6ZX0gZnJvbSAnLi9kaWZmL2pzb24nO1xuXG5pbXBvcnQge2RpZmZBcnJheXN9IGZyb20gJy4vZGlmZi9hcnJheSc7XG5cbmltcG9ydCB7YXBwbHlQYXRjaCwgYXBwbHlQYXRjaGVzfSBmcm9tICcuL3BhdGNoL2FwcGx5JztcbmltcG9ydCB7cGFyc2VQYXRjaH0gZnJvbSAnLi9wYXRjaC9wYXJzZSc7XG5pbXBvcnQge3N0cnVjdHVyZWRQYXRjaCwgY3JlYXRlVHdvRmlsZXNQYXRjaCwgY3JlYXRlUGF0Y2h9IGZyb20gJy4vcGF0Y2gvY3JlYXRlJztcblxuaW1wb3J0IHtjb252ZXJ0Q2hhbmdlc1RvRE1QfSBmcm9tICcuL2NvbnZlcnQvZG1wJztcbmltcG9ydCB7Y29udmVydENoYW5nZXNUb1hNTH0gZnJvbSAnLi9jb252ZXJ0L3htbCc7XG5cbmV4cG9ydCB7XG4gIERpZmYsXG5cbiAgZGlmZkNoYXJzLFxuICBkaWZmV29yZHMsXG4gIGRpZmZXb3Jkc1dpdGhTcGFjZSxcbiAgZGlmZkxpbmVzLFxuICBkaWZmVHJpbW1lZExpbmVzLFxuICBkaWZmU2VudGVuY2VzLFxuXG4gIGRpZmZDc3MsXG4gIGRpZmZKc29uLFxuXG4gIGRpZmZBcnJheXMsXG5cbiAgc3RydWN0dXJlZFBhdGNoLFxuICBjcmVhdGVUd29GaWxlc1BhdGNoLFxuICBjcmVhdGVQYXRjaCxcbiAgYXBwbHlQYXRjaCxcbiAgYXBwbHlQYXRjaGVzLFxuICBwYXJzZVBhdGNoLFxuICBjb252ZXJ0Q2hhbmdlc1RvRE1QLFxuICBjb252ZXJ0Q2hhbmdlc1RvWE1MLFxuICBjYW5vbmljYWxpemVcbn07XG4iXX0=


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/applyPatch = applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = applyPatches;
	
	var /*istanbul ignore start*/_parse = __webpack_require__(180) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_distanceIterator = __webpack_require__(328) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _distanceIterator2 = _interopRequireDefault(_distanceIterator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/function applyPatch(source, uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }
	
	  if (Array.isArray(uniDiff)) {
	    if (uniDiff.length > 1) {
	      throw new Error('applyPatch only works with a single input.');
	    }
	
	    uniDiff = uniDiff[0];
	  }
	
	  // Apply the diff to the input
	  var lines = source.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      hunks = uniDiff.hunks,
	      compareLine = options.compareLine || function (lineNumber, line, operation, patchContent) /*istanbul ignore start*/{
	    return (/*istanbul ignore end*/line === patchContent
	    );
	  },
	      errorCount = 0,
	      fuzzFactor = options.fuzzFactor || 0,
	      minLine = 0,
	      offset = 0,
	      removeEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      addEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  /**
	   * Checks if the hunk exactly fits on the provided location
	   */
	  function hunkFits(hunk, toPos) {
	    for (var j = 0; j < hunk.lines.length; j++) {
	      var line = hunk.lines[j],
	          operation = line[0],
	          content = line.substr(1);
	
	      if (operation === ' ' || operation === '-') {
	        // Context sanity check
	        if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
	          errorCount++;
	
	          if (errorCount > fuzzFactor) {
	            return false;
	          }
	        }
	        toPos++;
	      }
	    }
	
	    return true;
	  }
	
	  // Search best fit offsets for each hunk based on the previous ones
	  for (var i = 0; i < hunks.length; i++) {
	    var hunk = hunks[i],
	        maxLine = lines.length - hunk.oldLines,
	        localOffset = 0,
	        toPos = offset + hunk.oldStart - 1;
	
	    var iterator = /*istanbul ignore start*/(0, _distanceIterator2['default']) /*istanbul ignore end*/(toPos, minLine, maxLine);
	
	    for (; localOffset !== undefined; localOffset = iterator()) {
	      if (hunkFits(hunk, toPos + localOffset)) {
	        hunk.offset = offset += localOffset;
	        break;
	      }
	    }
	
	    if (localOffset === undefined) {
	      return false;
	    }
	
	    // Set lower text limit to end of the current hunk, so next ones don't try
	    // to fit over already patched text
	    minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
	  }
	
	  // Apply patch hunks
	  for (var _i = 0; _i < hunks.length; _i++) {
	    var _hunk = hunks[_i],
	        _toPos = _hunk.offset + _hunk.newStart - 1;
	    if (_hunk.newLines == 0) {
	      _toPos++;
	    }
	
	    for (var j = 0; j < _hunk.lines.length; j++) {
	      var line = _hunk.lines[j],
	          operation = line[0],
	          content = line.substr(1),
	          delimiter = _hunk.linedelimiters[j];
	
	      if (operation === ' ') {
	        _toPos++;
	      } else if (operation === '-') {
	        lines.splice(_toPos, 1);
	        delimiters.splice(_toPos, 1);
	        /* istanbul ignore else */
	      } else if (operation === '+') {
	          lines.splice(_toPos, 0, content);
	          delimiters.splice(_toPos, 0, delimiter);
	          _toPos++;
	        } else if (operation === '\\') {
	          var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
	          if (previousOperation === '+') {
	            removeEOFNL = true;
	          } else if (previousOperation === '-') {
	            addEOFNL = true;
	          }
	        }
	    }
	  }
	
	  // Handle EOFNL insertion/removal
	  if (removeEOFNL) {
	    while (!lines[lines.length - 1]) {
	      lines.pop();
	      delimiters.pop();
	    }
	  } else if (addEOFNL) {
	    lines.push('');
	    delimiters.push('\n');
	  }
	  for (var _k = 0; _k < lines.length - 1; _k++) {
	    lines[_k] = lines[_k] + delimiters[_k];
	  }
	  return lines.join('');
	}
	
	// Wrapper that supports multiple file patches via callbacks.
	function applyPatches(uniDiff, options) {
	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }
	
	  var currentIndex = 0;
	  function processIndex() {
	    var index = uniDiff[currentIndex++];
	    if (!index) {
	      return options.complete();
	    }
	
	    options.loadFile(index, function (err, data) {
	      if (err) {
	        return options.complete(err);
	      }
	
	      var updatedContent = applyPatch(data, index, options);
	      options.patched(index, updatedContent, function (err) {
	        if (err) {
	          return options.complete(err);
	        }
	
	        processIndex();
	      });
	    });
	  }
	  processIndex();
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/structuredPatch = structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = createPatch;
	
	var /*istanbul ignore start*/_line = __webpack_require__(119) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*istanbul ignore end*/function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  if (!options) {
	    options = {};
	  }
	  if (typeof options.context === 'undefined') {
	    options.context = 4;
	  }
	
	  var diff = /*istanbul ignore start*/(0, _line.diffLines) /*istanbul ignore end*/(oldStr, newStr, options);
	  diff.push({ value: '', lines: [] }); // Append an empty value to make cleanup easier
	
	  function contextLines(lines) {
	    return lines.map(function (entry) {
	      return ' ' + entry;
	    });
	  }
	
	  var hunks = [];
	  var oldRangeStart = 0,
	      newRangeStart = 0,
	      curRange = [],
	      oldLine = 1,
	      newLine = 1;
	  /*istanbul ignore start*/
	  var _loop = function _loop( /*istanbul ignore end*/i) {
	    var current = diff[i],
	        lines = current.lines || current.value.replace(/\n$/, '').split('\n');
	    current.lines = lines;
	
	    if (current.added || current.removed) {
	      /*istanbul ignore start*/
	      var _curRange;
	
	      /*istanbul ignore end*/
	      // If we have previous context, start with that
	      if (!oldRangeStart) {
	        var prev = diff[i - 1];
	        oldRangeStart = oldLine;
	        newRangeStart = newLine;
	
	        if (prev) {
	          curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
	          oldRangeStart -= curRange.length;
	          newRangeStart -= curRange.length;
	        }
	      }
	
	      // Output our changes
	      /*istanbul ignore start*/(_curRange = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/lines.map(function (entry) {
	        return (current.added ? '+' : '-') + entry;
	      })));
	
	      // Track the updated file position
	      if (current.added) {
	        newLine += lines.length;
	      } else {
	        oldLine += lines.length;
	      }
	    } else {
	      // Identical context lines. Track line changes
	      if (oldRangeStart) {
	        // Close out any changes that have been output (or join overlapping)
	        if (lines.length <= options.context * 2 && i < diff.length - 2) {
	          /*istanbul ignore start*/
	          var _curRange2;
	
	          /*istanbul ignore end*/
	          // Overlapping
	          /*istanbul ignore start*/(_curRange2 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange2 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines)));
	        } else {
	          /*istanbul ignore start*/
	          var _curRange3;
	
	          /*istanbul ignore end*/
	          // end the range and output
	          var contextSize = Math.min(lines.length, options.context);
	          /*istanbul ignore start*/(_curRange3 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange3 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines.slice(0, contextSize))));
	
	          var hunk = {
	            oldStart: oldRangeStart,
	            oldLines: oldLine - oldRangeStart + contextSize,
	            newStart: newRangeStart,
	            newLines: newLine - newRangeStart + contextSize,
	            lines: curRange
	          };
	          if (i >= diff.length - 2 && lines.length <= options.context) {
	            // EOF is inside this hunk
	            var oldEOFNewline = /\n$/.test(oldStr);
	            var newEOFNewline = /\n$/.test(newStr);
	            if (lines.length == 0 && !oldEOFNewline) {
	              // special case: old has no eol and no trailing context; no-nl can end up before adds
	              curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
	            } else if (!oldEOFNewline || !newEOFNewline) {
	              curRange.push('\\ No newline at end of file');
	            }
	          }
	          hunks.push(hunk);
	
	          oldRangeStart = 0;
	          newRangeStart = 0;
	          curRange = [];
	        }
	      }
	      oldLine += lines.length;
	      newLine += lines.length;
	    }
	  };
	
	  for (var i = 0; i < diff.length; i++) {
	    /*istanbul ignore start*/
	    _loop( /*istanbul ignore end*/i);
	  }
	
	  return {
	    oldFileName: oldFileName, newFileName: newFileName,
	    oldHeader: oldHeader, newHeader: newHeader,
	    hunks: hunks
	  };
	}
	
	function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  var diff = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
	
	  var ret = [];
	  if (oldFileName == newFileName) {
	    ret.push('Index: ' + oldFileName);
	  }
	  ret.push('===================================================================');
	  ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
	  ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));
	
	  for (var i = 0; i < diff.hunks.length; i++) {
	    var hunk = diff.hunks[i];
	    ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
	    ret.push.apply(ret, hunk.lines);
	  }
	
	  return ret.join('\n') + '\n';
	}
	
	function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
	  return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 328 */
/***/ function(module, exports) {

	/*istanbul ignore start*/"use strict";
	
	exports.__esModule = true;
	
	exports["default"] = /*istanbul ignore end*/function (start, minLine, maxLine) {
	  var wantForward = true,
	      backwardExhausted = false,
	      forwardExhausted = false,
	      localOffset = 1;
	
	  return function iterator() {
	    if (wantForward && !forwardExhausted) {
	      if (backwardExhausted) {
	        localOffset++;
	      } else {
	        wantForward = false;
	      }
	
	      // Check if trying to fit beyond text length, and if not, check it fits
	      // after offset location (or desired location on first iteration)
	      if (start + localOffset <= maxLine) {
	        return localOffset;
	      }
	
	      forwardExhausted = true;
	    }
	
	    if (!backwardExhausted) {
	      if (!forwardExhausted) {
	        wantForward = true;
	      }
	
	      // Check if trying to fit before text beginning, and if not, check it fits
	      // before offset location
	      if (minLine <= start - localOffset) {
	        return -localOffset++;
	      }
	
	      backwardExhausted = true;
	      return iterator();
	    }
	
	    // We tried to fit hunk before text beginning and beyond text lenght, then
	    // hunk can't fit on the text. Return undefined
	  };
	};
	//# sourceMappingURL=data:application/json;base64,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


/***/ },
/* 329 */
120,
/* 330 */
120,
/* 331 */
120,
/* 332 */
120,
/* 333 */
120,
/* 334 */
120,
/* 335 */
120,
/* 336 */
120,
/* 337 */
120,
/* 338 */
120,
/* 339 */
120,
/* 340 */
120,
/* 341 */
120,
/* 342 */
120,
/* 343 */
120,
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 345 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(345);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(355);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var createArrayFromMixed = __webpack_require__(348);
	var getMarkupWrap = __webpack_require__(350);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 351 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(352);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(354);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 356 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 357 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;return b.open("HEAD",a,!1),b.send(),200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});
	
	//# sourceMappingURL=FileSaver.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 359 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(186);
	
	var _PathUtils = __webpack_require__(121);
	
	var _createTransitionManager = __webpack_require__(361);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(384);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(385);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(386);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(122);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(189);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(374);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(370);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(364);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(373);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(368);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(365);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(371);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(369);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(372);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(366);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(367);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(187);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(388);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(39);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 374 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(84);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(123);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(84);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 378 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(84);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(123);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(84);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(187);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(122);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(123);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(188);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(188);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(122);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(189);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(381);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(375);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(376);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(377);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(382);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(380);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(383);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(378);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(379);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(272);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ },
/* 388 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ },
/* 389 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var WORKER_ENABLED = !!(global === global.window && global.URL && global.Blob && global.Worker);
	
	function InlineWorker(func, self) {
	  var _this = this;
	  var functionBody;
	
	  self = self || {};
	
	  if (WORKER_ENABLED) {
	    functionBody = func.toString().trim().match(
	      /^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/
	    )[1];
	
	    return new global.Worker(global.URL.createObjectURL(
	      new global.Blob([ functionBody ], { type: "text/javascript" })
	    ));
	  }
	
	  function postMessage(data) {
	    setTimeout(function() {
	      _this.onmessage({ data: data });
	    }, 0);
	  }
	
	  this.self = self;
	  this.self.postMessage = postMessage;
	
	  setTimeout(func.bind(self, self), 0);
	}
	
	InlineWorker.prototype.postMessage = function postMessage(data) {
	  var _this = this;
	
	  setTimeout(function() {
	    _this.self.onmessage({ data: data });
	  }, 0);
	};
	
	module.exports = InlineWorker;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(390);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(391);
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new Error('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  return JSON.parse(base64_url_decode(token.split('.')[pos]));
	};


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	
	/**
	 * ATH related stuff, if something new ATH related has to be added, please plug
	 * it here into the ATH.
	 */
	function ATH() {
	    /**
	     * Method for the auto adjustment.
	     */
	    this.useAdjust = 0;
	    /**
	     * factor for tuning the (sample power) point below which adaptive threshold
	     * of hearing adjustment occurs
	     */
	    this.aaSensitivityP = 0.;
	    /**
	     * Lowering based on peak volume, 1 = no lowering.
	     */
	    this.adjust = 0.;
	    /**
	     * Limit for dynamic ATH adjust.
	     */
	    this.adjustLimit = 0.;
	    /**
	     * Determined to lower x dB each second.
	     */
	    this.decay = 0.;
	    /**
	     * Lowest ATH value.
	     */
	    this.floor = 0.;
	    /**
	     * ATH for sfbs in long blocks.
	     */
	    this.l = new_float(Encoder.SBMAX_l);
	    /**
	     * ATH for sfbs in short blocks.
	     */
	    this.s = new_float(Encoder.SBMAX_s);
	    /**
	     * ATH for partitioned sfb21 in long blocks.
	     */
	    this.psfb21 = new_float(Encoder.PSFB21);
	    /**
	     * ATH for partitioned sfb12 in short blocks.
	     */
	    this.psfb12 = new_float(Encoder.PSFB12);
	    /**
	     * ATH for long block convolution bands.
	     */
	    this.cb_l = new_float(Encoder.CBANDS);
	    /**
	     * ATH for short block convolution bands.
	     */
	    this.cb_s = new_float(Encoder.CBANDS);
	    /**
	     * Equal loudness weights (based on ATH).
	     */
	    this.eql_w = new_float(Encoder.BLKSIZE / 2);
	}
	
	module.exports = ATH;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var MeanBits = __webpack_require__(194);
	var Encoder = __webpack_require__(21);
	var L3Side = __webpack_require__(86);
	var LameInternalFlags = __webpack_require__(87);
	
	function CBRNewIterationLoop(_quantize)  {
	    var quantize = _quantize;
	    this.quantize = quantize;
		this.iteration_loop = function(gfp, pe, ms_ener_ratio, ratio) {
			var gfc = gfp.internal_flags;
	        var l3_xmin = new_float(L3Side.SFBMAX);
			var xrpow = new_float(576);
			var targ_bits = new_int(2);
			var mean_bits = 0, max_bits;
			var l3_side = gfc.l3_side;
	
			var mb = new MeanBits(mean_bits);
			this.quantize.rv.ResvFrameBegin(gfp, mb);
			mean_bits = mb.bits;
	
			/* quantize! */
			for (var gr = 0; gr < gfc.mode_gr; gr++) {
	
				/*
				 * calculate needed bits
				 */
				max_bits = this.quantize.qupvt.on_pe(gfp, pe, targ_bits, mean_bits,
						gr, gr);
	
				if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
					this.quantize.ms_convert(gfc.l3_side, gr);
					this.quantize.qupvt.reduce_side(targ_bits, ms_ener_ratio[gr],
							mean_bits, max_bits);
				}
	
				for (var ch = 0; ch < gfc.channels_out; ch++) {
					var adjust, masking_lower_db;
					var cod_info = l3_side.tt[gr][ch];
	
					if (cod_info.block_type != Encoder.SHORT_TYPE) {
						// NORM, START or STOP type
						adjust = 0;
						masking_lower_db = gfc.PSY.mask_adjust - adjust;
					} else {
						adjust = 0;
						masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
					}
					gfc.masking_lower =  Math.pow(10.0,
							masking_lower_db * 0.1);
	
					/*
					 * init_outer_loop sets up cod_info, scalefac and xrpow
					 */
					this.quantize.init_outer_loop(gfc, cod_info);
					if (this.quantize.init_xrpow(gfc, cod_info, xrpow)) {
						/*
						 * xr contains energy we will have to encode calculate the
						 * masking abilities find some good quantization in
						 * outer_loop
						 */
						this.quantize.qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
								l3_xmin);
						this.quantize.outer_loop(gfp, cod_info, l3_xmin, xrpow, ch,
								targ_bits[ch]);
					}
	
					this.quantize.iteration_finish_one(gfc, gr, ch);
					assert (cod_info.part2_3_length <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
					assert (cod_info.part2_3_length <= targ_bits[ch]);
				} /* for ch */
			} /* for gr */
	
			this.quantize.rv.ResvFrameEnd(gfc, mean_bits);
		}
	}
	module.exports = CBRNewIterationLoop;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var new_float = common.new_float;
	var new_int = common.new_int;
	var assert = common.assert;
	
	function CalcNoiseData() {
	    this.global_gain = 0;
	    this.sfb_count1 = 0;
	    this.step = new_int(39);
	    this.noise = new_float(39);
	    this.noise_log = new_float(39);
	}
	
	module.exports = CalcNoiseData;


/***/ },
/* 396 */
/***/ function(module, exports) {

	//package mp3;
	
	function CalcNoiseResult() {
	    /**
	     * sum of quantization noise > masking
	     */
	    this.over_noise = 0.;
	    /**
	     * sum of all quantization noise
	     */
	    this.tot_noise = 0.;
	    /**
	     * max quantization noise
	     */
	    this.max_noise = 0.;
	    /**
	     * number of quantization noise > masking
	     */
	    this.over_count = 0;
	    /**
	     * SSD-like cost of distorted bands
	     */
	    this.over_SSD = 0;
	    this.bits = 0;
	}
	
	module.exports = CalcNoiseResult;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	
	function FFT() {
	
	    var window = new_float(Encoder.BLKSIZE);
	    var window_s = new_float(Encoder.BLKSIZE_s / 2);
	
	    var costab = [
	        9.238795325112867e-01, 3.826834323650898e-01,
	        9.951847266721969e-01, 9.801714032956060e-02,
	        9.996988186962042e-01, 2.454122852291229e-02,
	        9.999811752826011e-01, 6.135884649154475e-03
	    ];
	
	    function fht(fz, fzPos, n) {
	        var tri = 0;
	        var k4;
	        var fi;
	        var gi;
	
	        n <<= 1;
	        /* to get BLKSIZE, because of 3DNow! ASM routine */
	        var fn = fzPos + n;
	        k4 = 4;
	        do {
	            var s1, c1;
	            var i, k1, k2, k3, kx;
	            kx = k4 >> 1;
	            k1 = k4;
	            k2 = k4 << 1;
	            k3 = k2 + k1;
	            k4 = k2 << 1;
	            fi = fzPos;
	            gi = fi + kx;
	            do {
	                var f0, f1, f2, f3;
	                f1 = fz[fi + 0] - fz[fi + k1];
	                f0 = fz[fi + 0] + fz[fi + k1];
	                f3 = fz[fi + k2] - fz[fi + k3];
	                f2 = fz[fi + k2] + fz[fi + k3];
	                fz[fi + k2] = f0 - f2;
	                fz[fi + 0] = f0 + f2;
	                fz[fi + k3] = f1 - f3;
	                fz[fi + k1] = f1 + f3;
	                f1 = fz[gi + 0] - fz[gi + k1];
	                f0 = fz[gi + 0] + fz[gi + k1];
	                f3 = (Util.SQRT2 * fz[gi + k3]);
	                f2 = (Util.SQRT2 * fz[gi + k2]);
	                fz[gi + k2] = f0 - f2;
	                fz[gi + 0] = f0 + f2;
	                fz[gi + k3] = f1 - f3;
	                fz[gi + k1] = f1 + f3;
	                gi += k4;
	                fi += k4;
	            } while (fi < fn);
	            c1 = costab[tri + 0];
	            s1 = costab[tri + 1];
	            for (i = 1; i < kx; i++) {
	                var c2, s2;
	                c2 = 1 - (2 * s1) * s1;
	                s2 = (2 * s1) * c1;
	                fi = fzPos + i;
	                gi = fzPos + k1 - i;
	                do {
	                    var a, b, g0, f0, f1, g1, f2, g2, f3, g3;
	                    b = s2 * fz[fi + k1] - c2 * fz[gi + k1];
	                    a = c2 * fz[fi + k1] + s2 * fz[gi + k1];
	                    f1 = fz[fi + 0] - a;
	                    f0 = fz[fi + 0] + a;
	                    g1 = fz[gi + 0] - b;
	                    g0 = fz[gi + 0] + b;
	                    b = s2 * fz[fi + k3] - c2 * fz[gi + k3];
	                    a = c2 * fz[fi + k3] + s2 * fz[gi + k3];
	                    f3 = fz[fi + k2] - a;
	                    f2 = fz[fi + k2] + a;
	                    g3 = fz[gi + k2] - b;
	                    g2 = fz[gi + k2] + b;
	                    b = s1 * f2 - c1 * g3;
	                    a = c1 * f2 + s1 * g3;
	                    fz[fi + k2] = f0 - a;
	                    fz[fi + 0] = f0 + a;
	                    fz[gi + k3] = g1 - b;
	                    fz[gi + k1] = g1 + b;
	                    b = c1 * g2 - s1 * f3;
	                    a = s1 * g2 + c1 * f3;
	                    fz[gi + k2] = g0 - a;
	                    fz[gi + 0] = g0 + a;
	                    fz[fi + k3] = f1 - b;
	                    fz[fi + k1] = f1 + b;
	                    gi += k4;
	                    fi += k4;
	                } while (fi < fn);
	                c2 = c1;
	                c1 = c2 * costab[tri + 0] - s1 * costab[tri + 1];
	                s1 = c2 * costab[tri + 1] + s1 * costab[tri + 0];
	            }
	            tri += 2;
	        } while (k4 < n);
	    }
	
	    var rv_tbl = [0x00, 0x80, 0x40,
	        0xc0, 0x20, 0xa0, 0x60, 0xe0, 0x10,
	        0x90, 0x50, 0xd0, 0x30, 0xb0, 0x70,
	        0xf0, 0x08, 0x88, 0x48, 0xc8, 0x28,
	        0xa8, 0x68, 0xe8, 0x18, 0x98, 0x58,
	        0xd8, 0x38, 0xb8, 0x78, 0xf8, 0x04,
	        0x84, 0x44, 0xc4, 0x24, 0xa4, 0x64,
	        0xe4, 0x14, 0x94, 0x54, 0xd4, 0x34,
	        0xb4, 0x74, 0xf4, 0x0c, 0x8c, 0x4c,
	        0xcc, 0x2c, 0xac, 0x6c, 0xec, 0x1c,
	        0x9c, 0x5c, 0xdc, 0x3c, 0xbc, 0x7c,
	        0xfc, 0x02, 0x82, 0x42, 0xc2, 0x22,
	        0xa2, 0x62, 0xe2, 0x12, 0x92, 0x52,
	        0xd2, 0x32, 0xb2, 0x72, 0xf2, 0x0a,
	        0x8a, 0x4a, 0xca, 0x2a, 0xaa, 0x6a,
	        0xea, 0x1a, 0x9a, 0x5a, 0xda, 0x3a,
	        0xba, 0x7a, 0xfa, 0x06, 0x86, 0x46,
	        0xc6, 0x26, 0xa6, 0x66, 0xe6, 0x16,
	        0x96, 0x56, 0xd6, 0x36, 0xb6, 0x76,
	        0xf6, 0x0e, 0x8e, 0x4e, 0xce, 0x2e,
	        0xae, 0x6e, 0xee, 0x1e, 0x9e, 0x5e,
	        0xde, 0x3e, 0xbe, 0x7e, 0xfe];
	
	    this.fft_short = function (gfc, x_real, chn, buffer, bufPos) {
	        for (var b = 0; b < 3; b++) {
	            var x = Encoder.BLKSIZE_s / 2;
	            var k = 0xffff & ((576 / 3) * (b + 1));
	            var j = Encoder.BLKSIZE_s / 8 - 1;
	            do {
	                var f0, f1, f2, f3, w;
	                var i = rv_tbl[j << 2] & 0xff;
	
	                f0 = window_s[i] * buffer[chn][bufPos + i + k];
	                w = window_s[0x7f - i] * buffer[chn][bufPos + i + k + 0x80];
	                f1 = f0 - w;
	                f0 = f0 + w;
	                f2 = window_s[i + 0x40] * buffer[chn][bufPos + i + k + 0x40];
	                w = window_s[0x3f - i] * buffer[chn][bufPos + i + k + 0xc0];
	                f3 = f2 - w;
	                f2 = f2 + w;
	
	                x -= 4;
	                x_real[b][x + 0] = f0 + f2;
	                x_real[b][x + 2] = f0 - f2;
	                x_real[b][x + 1] = f1 + f3;
	                x_real[b][x + 3] = f1 - f3;
	
	                f0 = window_s[i + 0x01] * buffer[chn][bufPos + i + k + 0x01];
	                w = window_s[0x7e - i] * buffer[chn][bufPos + i + k + 0x81];
	                f1 = f0 - w;
	                f0 = f0 + w;
	                f2 = window_s[i + 0x41] * buffer[chn][bufPos + i + k + 0x41];
	                w = window_s[0x3e - i] * buffer[chn][bufPos + i + k + 0xc1];
	                f3 = f2 - w;
	                f2 = f2 + w;
	
	                x_real[b][x + Encoder.BLKSIZE_s / 2 + 0] = f0 + f2;
	                x_real[b][x + Encoder.BLKSIZE_s / 2 + 2] = f0 - f2;
	                x_real[b][x + Encoder.BLKSIZE_s / 2 + 1] = f1 + f3;
	                x_real[b][x + Encoder.BLKSIZE_s / 2 + 3] = f1 - f3;
	            } while (--j >= 0);
	
	            fht(x_real[b], x, Encoder.BLKSIZE_s / 2);
	            /* BLKSIZE_s/2 because of 3DNow! ASM routine */
	            /* BLKSIZE/2 because of 3DNow! ASM routine */
	        }
	    }
	
	    this.fft_long = function (gfc, y, chn, buffer, bufPos) {
	        var jj = Encoder.BLKSIZE / 8 - 1;
	        var x = Encoder.BLKSIZE / 2;
	
	        do {
	            var f0, f1, f2, f3, w;
	            var i = rv_tbl[jj] & 0xff;
	            f0 = window[i] * buffer[chn][bufPos + i];
	            w = window[i + 0x200] * buffer[chn][bufPos + i + 0x200];
	            f1 = f0 - w;
	            f0 = f0 + w;
	            f2 = window[i + 0x100] * buffer[chn][bufPos + i + 0x100];
	            w = window[i + 0x300] * buffer[chn][bufPos + i + 0x300];
	            f3 = f2 - w;
	            f2 = f2 + w;
	
	            x -= 4;
	            y[x + 0] = f0 + f2;
	            y[x + 2] = f0 - f2;
	            y[x + 1] = f1 + f3;
	            y[x + 3] = f1 - f3;
	
	            f0 = window[i + 0x001] * buffer[chn][bufPos + i + 0x001];
	            w = window[i + 0x201] * buffer[chn][bufPos + i + 0x201];
	            f1 = f0 - w;
	            f0 = f0 + w;
	            f2 = window[i + 0x101] * buffer[chn][bufPos + i + 0x101];
	            w = window[i + 0x301] * buffer[chn][bufPos + i + 0x301];
	            f3 = f2 - w;
	            f2 = f2 + w;
	
	            y[x + Encoder.BLKSIZE / 2 + 0] = f0 + f2;
	            y[x + Encoder.BLKSIZE / 2 + 2] = f0 - f2;
	            y[x + Encoder.BLKSIZE / 2 + 1] = f1 + f3;
	            y[x + Encoder.BLKSIZE / 2 + 3] = f1 - f3;
	        } while (--jj >= 0);
	
	        fht(y, x, Encoder.BLKSIZE / 2);
	        /* BLKSIZE/2 because of 3DNow! ASM routine */
	    }
	
	    this.init_fft = function (gfc) {
	        /* The type of window used here will make no real difference, but */
	        /*
	         * in the interest of merging nspsytune stuff - switch to blackman
	         * window
	         */
	        for (var i = 0; i < Encoder.BLKSIZE; i++)
	            /* blackman window */
	            window[i] = (0.42 - 0.5 * Math.cos(2 * Math.PI * (i + .5)
	                / Encoder.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (i + .5)
	                / Encoder.BLKSIZE));
	
	        for (var i = 0; i < Encoder.BLKSIZE_s / 2; i++)
	            window_s[i] = (0.5 * (1.0 - Math.cos(2.0 * Math.PI
	                * (i + 0.5) / Encoder.BLKSIZE_s)));
	
	    }
	
	}
	
	module.exports = FFT;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var GrInfo = __webpack_require__(124);
	
	function IIISideInfo() {
	    this.tt = [[null, null], [null, null]];
	    this.main_data_begin = 0;
	    this.private_bits = 0;
	    this.resvDrain_pre = 0;
	    this.resvDrain_post = 0;
	    this.scfsi = [new_int(4), new_int(4)];
	
	    for (var gr = 0; gr < 2; gr++) {
	        for (var ch = 0; ch < 2; ch++) {
	            this.tt[gr][ch] = new GrInfo();
	        }
	    }
	}
	
	module.exports = IIISideInfo;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//package mp3;
	
	var III_psy_xmin = __webpack_require__(192);
	
	function III_psy_ratio() {
		this.thm = new III_psy_xmin();
		this.en = new III_psy_xmin();
	}
	
	module.exports = III_psy_ratio;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var new_short_n = common.new_short_n;
	var assert = common.assert;
	
	var PsyModel = __webpack_require__(405);
	var LameGlobalFlags = __webpack_require__(401);
	var LameInternalFlags = __webpack_require__(87);
	var ATH = __webpack_require__(393);
	var ReplayGain = __webpack_require__(407);
	var CBRNewIterationLoop = __webpack_require__(394);
	var BitStream = __webpack_require__(190);
	var Tables = __webpack_require__(125);
	var Encoder = __webpack_require__(21);
	
	function Lame() {
	    var self = this;
	    var LAME_MAXALBUMART = (128 * 1024);
	
	    Lame.V9 = 410;
	    Lame.V8 = 420;
	    Lame.V7 = 430;
	    Lame.V6 = 440;
	    Lame.V5 = 450;
	    Lame.V4 = 460;
	    Lame.V3 = 470;
	    Lame.V2 = 480;
	    Lame.V1 = 490;
	    Lame.V0 = 500;
	
	    /* still there for compatibility */
	
	    Lame.R3MIX = 1000;
	    Lame.STANDARD = 1001;
	    Lame.EXTREME = 1002;
	    Lame.INSANE = 1003;
	    Lame.STANDARD_FAST = 1004;
	    Lame.EXTREME_FAST = 1005;
	    Lame.MEDIUM = 1006;
	    Lame.MEDIUM_FAST = 1007;
	
	    /**
	     * maximum size of mp3buffer needed if you encode at most 1152 samples for
	     * each call to lame_encode_buffer. see lame_encode_buffer() below
	     * (LAME_MAXMP3BUFFER is now obsolete)
	     */
	    var LAME_MAXMP3BUFFER = (16384 + LAME_MAXALBUMART);
	    Lame.LAME_MAXMP3BUFFER = LAME_MAXMP3BUFFER;
	
	    var ga;
	    var bs;
	    var p;
	    var qupvt;
	    var qu;
	    var psy = new PsyModel();
	    var vbr;
	    var ver;
	    var id3;
	    var mpglib;
	    this.enc = new Encoder();
	
	    this.setModules = function (_ga, _bs, _p, _qupvt, _qu, _vbr, _ver, _id3, _mpglib) {
	        ga = _ga;
	        bs = _bs;
	        p = _p;
	        qupvt = _qupvt;
	        qu = _qu;
	        vbr = _vbr;
	        ver = _ver;
	        id3 = _id3;
	        mpglib = _mpglib;
	        this.enc.setModules(bs, psy, qupvt, vbr);
	    }
	
	    /**
	     * PSY Model related stuff
	     */
	    function PSY() {
	        /**
	         * The dbQ stuff.
	         */
	        this.mask_adjust = 0.;
	        /**
	         * The dbQ stuff.
	         */
	        this.mask_adjust_short = 0.;
	        /* at transition from one scalefactor band to next */
	        /**
	         * Band weight long scalefactor bands.
	         */
	        this.bo_l_weight = new_float(Encoder.SBMAX_l);
	        /**
	         * Band weight short scalefactor bands.
	         */
	        this.bo_s_weight = new_float(Encoder.SBMAX_s);
	    }
	
	    function LowPassHighPass() {
	        this.lowerlimit = 0.;
	    }
	
	    function BandPass(bitrate, lPass) {
	        this.lowpass = lPass;
	    }
	
	    var LAME_ID = 0xFFF88E3B;
	
	    function lame_init_old(gfp) {
	        var gfc;
	
	        gfp.class_id = LAME_ID;
	
	        gfc = gfp.internal_flags = new LameInternalFlags();
	
	        /* Global flags. set defaults here for non-zero values */
	        /* see lame.h for description */
	        /*
	         * set integer values to -1 to mean that LAME will compute the best
	         * value, UNLESS the calling program as set it (and the value is no
	         * longer -1)
	         */
	
	        gfp.mode = MPEGMode.NOT_SET;
	        gfp.original = 1;
	        gfp.in_samplerate = 44100;
	        gfp.num_channels = 2;
	        gfp.num_samples = -1;
	
	        gfp.bWriteVbrTag = true;
	        gfp.quality = -1;
	        gfp.short_blocks = null;
	        gfc.subblock_gain = -1;
	
	        gfp.lowpassfreq = 0;
	        gfp.highpassfreq = 0;
	        gfp.lowpasswidth = -1;
	        gfp.highpasswidth = -1;
	
	        gfp.VBR = VbrMode.vbr_off;
	        gfp.VBR_q = 4;
	        gfp.ATHcurve = -1;
	        gfp.VBR_mean_bitrate_kbps = 128;
	        gfp.VBR_min_bitrate_kbps = 0;
	        gfp.VBR_max_bitrate_kbps = 0;
	        gfp.VBR_hard_min = 0;
	        gfc.VBR_min_bitrate = 1;
	        /* not 0 ????? */
	        gfc.VBR_max_bitrate = 13;
	        /* not 14 ????? */
	
	        gfp.quant_comp = -1;
	        gfp.quant_comp_short = -1;
	
	        gfp.msfix = -1;
	
	        gfc.resample_ratio = 1;
	
	        gfc.OldValue[0] = 180;
	        gfc.OldValue[1] = 180;
	        gfc.CurrentStep[0] = 4;
	        gfc.CurrentStep[1] = 4;
	        gfc.masking_lower = 1;
	        gfc.nsPsy.attackthre = -1;
	        gfc.nsPsy.attackthre_s = -1;
	
	        gfp.scale = -1;
	
	        gfp.athaa_type = -1;
	        gfp.ATHtype = -1;
	        /* default = -1 = set in lame_init_params */
	        gfp.athaa_loudapprox = -1;
	        /* 1 = flat loudness approx. (total energy) */
	        /* 2 = equal loudness curve */
	        gfp.athaa_sensitivity = 0.0;
	        /* no offset */
	        gfp.useTemporal = null;
	        gfp.interChRatio = -1;
	
	        /*
	         * The reason for int mf_samples_to_encode = ENCDELAY + POSTDELAY;
	         * ENCDELAY = internal encoder delay. And then we have to add
	         * POSTDELAY=288 because of the 50% MDCT overlap. A 576 MDCT granule
	         * decodes to 1152 samples. To synthesize the 576 samples centered under
	         * this granule we need the previous granule for the first 288 samples
	         * (no problem), and the next granule for the next 288 samples (not
	         * possible if this is last granule). So we need to pad with 288 samples
	         * to make sure we can encode the 576 samples we are interested in.
	         */
	        gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
	        gfp.encoder_padding = 0;
	        gfc.mf_size = Encoder.ENCDELAY - Encoder.MDCTDELAY;
	        /*
	         * we pad input with this many 0's
	         */
	
	        gfp.findReplayGain = false;
	        gfp.decode_on_the_fly = false;
	
	        gfc.decode_on_the_fly = false;
	        gfc.findReplayGain = false;
	        gfc.findPeakSample = false;
	
	        gfc.RadioGain = 0;
	        gfc.AudiophileGain = 0;
	        gfc.noclipGainChange = 0;
	        gfc.noclipScale = -1.0;
	
	        gfp.preset = 0;
	
	        gfp.write_id3tag_automatic = true;
	        return 0;
	    }
	
	    this.lame_init = function () {
	        var gfp = new LameGlobalFlags();
	
	        var ret = lame_init_old(gfp);
	        if (ret != 0) {
	            return null;
	        }
	
	        gfp.lame_allocated_gfp = 1;
	        return gfp;
	    }
	
	    function filter_coef(x) {
	        if (x > 1.0)
	            return 0.0;
	        if (x <= 0.0)
	            return 1.0;
	
	        return Math.cos(Math.PI / 2 * x);
	    }
	
	    this.nearestBitrateFullIndex = function (bitrate) {
	        /* borrowed from DM abr presets */
	
	        var full_bitrate_table = [8, 16, 24, 32, 40, 48, 56, 64, 80,
	            96, 112, 128, 160, 192, 224, 256, 320];
	
	        var lower_range = 0, lower_range_kbps = 0, upper_range = 0, upper_range_kbps = 0;
	
	        /* We assume specified bitrate will be 320kbps */
	        upper_range_kbps = full_bitrate_table[16];
	        upper_range = 16;
	        lower_range_kbps = full_bitrate_table[16];
	        lower_range = 16;
	
	        /*
	         * Determine which significant bitrates the value specified falls
	         * between, if loop ends without breaking then we were correct above
	         * that the value was 320
	         */
	        for (var b = 0; b < 16; b++) {
	            if ((Math.max(bitrate, full_bitrate_table[b + 1])) != bitrate) {
	                upper_range_kbps = full_bitrate_table[b + 1];
	                upper_range = b + 1;
	                lower_range_kbps = full_bitrate_table[b];
	                lower_range = (b);
	                break;
	                /* We found upper range */
	            }
	        }
	
	        /* Determine which range the value specified is closer to */
	        if ((upper_range_kbps - bitrate) > (bitrate - lower_range_kbps)) {
	            return lower_range;
	        }
	        return upper_range;
	    }
	
	    function optimum_samplefreq(lowpassfreq, input_samplefreq) {
	        /*
	         * Rules:
	         *
	         * - if possible, sfb21 should NOT be used
	         */
	        var suggested_samplefreq = 44100;
	
	        if (input_samplefreq >= 48000)
	            suggested_samplefreq = 48000;
	        else if (input_samplefreq >= 44100)
	            suggested_samplefreq = 44100;
	        else if (input_samplefreq >= 32000)
	            suggested_samplefreq = 32000;
	        else if (input_samplefreq >= 24000)
	            suggested_samplefreq = 24000;
	        else if (input_samplefreq >= 22050)
	            suggested_samplefreq = 22050;
	        else if (input_samplefreq >= 16000)
	            suggested_samplefreq = 16000;
	        else if (input_samplefreq >= 12000)
	            suggested_samplefreq = 12000;
	        else if (input_samplefreq >= 11025)
	            suggested_samplefreq = 11025;
	        else if (input_samplefreq >= 8000)
	            suggested_samplefreq = 8000;
	
	        if (lowpassfreq == -1)
	            return suggested_samplefreq;
	
	        if (lowpassfreq <= 15960)
	            suggested_samplefreq = 44100;
	        if (lowpassfreq <= 15250)
	            suggested_samplefreq = 32000;
	        if (lowpassfreq <= 11220)
	            suggested_samplefreq = 24000;
	        if (lowpassfreq <= 9970)
	            suggested_samplefreq = 22050;
	        if (lowpassfreq <= 7230)
	            suggested_samplefreq = 16000;
	        if (lowpassfreq <= 5420)
	            suggested_samplefreq = 12000;
	        if (lowpassfreq <= 4510)
	            suggested_samplefreq = 11025;
	        if (lowpassfreq <= 3970)
	            suggested_samplefreq = 8000;
	
	        if (input_samplefreq < suggested_samplefreq) {
	            /*
	             * choose a valid MPEG sample frequency above the input sample
	             * frequency to avoid SFB21/12 bitrate bloat rh 061115
	             */
	            if (input_samplefreq > 44100) {
	                return 48000;
	            }
	            if (input_samplefreq > 32000) {
	                return 44100;
	            }
	            if (input_samplefreq > 24000) {
	                return 32000;
	            }
	            if (input_samplefreq > 22050) {
	                return 24000;
	            }
	            if (input_samplefreq > 16000) {
	                return 22050;
	            }
	            if (input_samplefreq > 12000) {
	                return 16000;
	            }
	            if (input_samplefreq > 11025) {
	                return 12000;
	            }
	            if (input_samplefreq > 8000) {
	                return 11025;
	            }
	            return 8000;
	        }
	        return suggested_samplefreq;
	    }
	
	    /**
	     * convert samp freq in Hz to index
	     */
	    function SmpFrqIndex(sample_freq, gpf) {
	        switch (sample_freq) {
	            case 44100:
	                gpf.version = 1;
	                return 0;
	            case 48000:
	                gpf.version = 1;
	                return 1;
	            case 32000:
	                gpf.version = 1;
	                return 2;
	            case 22050:
	                gpf.version = 0;
	                return 0;
	            case 24000:
	                gpf.version = 0;
	                return 1;
	            case 16000:
	                gpf.version = 0;
	                return 2;
	            case 11025:
	                gpf.version = 0;
	                return 0;
	            case 12000:
	                gpf.version = 0;
	                return 1;
	            case 8000:
	                gpf.version = 0;
	                return 2;
	            default:
	                gpf.version = 0;
	                return -1;
	        }
	    }
	
	    /**
	     * @param bRate
	     *            legal rates from 8 to 320
	     */
	    function FindNearestBitrate(bRate, version, samplerate) {
	        /* MPEG-1 or MPEG-2 LSF */
	        if (samplerate < 16000)
	            version = 2;
	
	        var bitrate = Tables.bitrate_table[version][1];
	
	        for (var i = 2; i <= 14; i++) {
	            if (Tables.bitrate_table[version][i] > 0) {
	                if (Math.abs(Tables.bitrate_table[version][i] - bRate) < Math
	                        .abs(bitrate - bRate))
	                    bitrate = Tables.bitrate_table[version][i];
	            }
	        }
	        return bitrate;
	    }
	
	    /**
	     * @param bRate
	     *            legal rates from 32 to 448 kbps
	     * @param version
	     *            MPEG-1 or MPEG-2/2.5 LSF
	     */
	    function BitrateIndex(bRate, version, samplerate) {
	        /* convert bitrate in kbps to index */
	        if (samplerate < 16000)
	            version = 2;
	        for (var i = 0; i <= 14; i++) {
	            if (Tables.bitrate_table[version][i] > 0) {
	                if (Tables.bitrate_table[version][i] == bRate) {
	                    return i;
	                }
	            }
	        }
	        return -1;
	    }
	
	    function optimum_bandwidth(lh, bitrate) {
	        /**
	         * <PRE>
	         *  Input:
	         *      bitrate     total bitrate in kbps
	         *
	         *   Output:
	         *      lowerlimit: best lowpass frequency limit for input filter in Hz
	         *      upperlimit: best highpass frequency limit for input filter in Hz
	         * </PRE>
	         */
	        var freq_map = [new BandPass(8, 2000),
	            new BandPass(16, 3700), new BandPass(24, 3900),
	            new BandPass(32, 5500), new BandPass(40, 7000),
	            new BandPass(48, 7500), new BandPass(56, 10000),
	            new BandPass(64, 11000), new BandPass(80, 13500),
	            new BandPass(96, 15100), new BandPass(112, 15600),
	            new BandPass(128, 17000), new BandPass(160, 17500),
	            new BandPass(192, 18600), new BandPass(224, 19400),
	            new BandPass(256, 19700), new BandPass(320, 20500)];
	
	        var table_index = self.nearestBitrateFullIndex(bitrate);
	        lh.lowerlimit = freq_map[table_index].lowpass;
	    }
	
	    function lame_init_params_ppflt(gfp) {
	        var gfc = gfp.internal_flags;
	        /***************************************************************/
	        /* compute info needed for polyphase filter (filter type==0, default) */
	        /***************************************************************/
	
	        var lowpass_band = 32;
	        var highpass_band = -1;
	
	        if (gfc.lowpass1 > 0) {
	            var minband = 999;
	            for (var band = 0; band <= 31; band++) {
	                var freq = (band / 31.0);
	                /* this band and above will be zeroed: */
	                if (freq >= gfc.lowpass2) {
	                    lowpass_band = Math.min(lowpass_band, band);
	                }
	                if (gfc.lowpass1 < freq && freq < gfc.lowpass2) {
	                    minband = Math.min(minband, band);
	                }
	            }
	
	            /*
	             * compute the *actual* transition band implemented by the polyphase
	             * filter
	             */
	            if (minband == 999) {
	                gfc.lowpass1 = (lowpass_band - .75) / 31.0;
	            } else {
	                gfc.lowpass1 = (minband - .75) / 31.0;
	            }
	            gfc.lowpass2 = lowpass_band / 31.0;
	        }
	
	        /*
	         * make sure highpass filter is within 90% of what the effective
	         * highpass frequency will be
	         */
	        if (gfc.highpass2 > 0) {
	            if (gfc.highpass2 < .9 * (.75 / 31.0)) {
	                gfc.highpass1 = 0;
	                gfc.highpass2 = 0;
	                System.err.println("Warning: highpass filter disabled.  "
	                    + "highpass frequency too small\n");
	            }
	        }
	
	        if (gfc.highpass2 > 0) {
	            var maxband = -1;
	            for (var band = 0; band <= 31; band++) {
	                var freq = band / 31.0;
	                /* this band and below will be zereod */
	                if (freq <= gfc.highpass1) {
	                    highpass_band = Math.max(highpass_band, band);
	                }
	                if (gfc.highpass1 < freq && freq < gfc.highpass2) {
	                    maxband = Math.max(maxband, band);
	                }
	            }
	            /*
	             * compute the *actual* transition band implemented by the polyphase
	             * filter
	             */
	            gfc.highpass1 = highpass_band / 31.0;
	            if (maxband == -1) {
	                gfc.highpass2 = (highpass_band + .75) / 31.0;
	            } else {
	                gfc.highpass2 = (maxband + .75) / 31.0;
	            }
	        }
	
	        for (var band = 0; band < 32; band++) {
	            var fc1, fc2;
	            var freq = band / 31.0;
	            if (gfc.highpass2 > gfc.highpass1) {
	                fc1 = filter_coef((gfc.highpass2 - freq)
	                    / (gfc.highpass2 - gfc.highpass1 + 1e-20));
	            } else {
	                fc1 = 1.0;
	            }
	            if (gfc.lowpass2 > gfc.lowpass1) {
	                fc2 = filter_coef((freq - gfc.lowpass1)
	                    / (gfc.lowpass2 - gfc.lowpass1 + 1e-20));
	            } else {
	                fc2 = 1.0;
	            }
	            gfc.amp_filter[band] = (fc1 * fc2);
	        }
	    }
	
	    function lame_init_qval(gfp) {
	        var gfc = gfp.internal_flags;
	
	        switch (gfp.quality) {
	            default:
	            case 9: /* no psymodel, no noise shaping */
	                gfc.psymodel = 0;
	                gfc.noise_shaping = 0;
	                gfc.noise_shaping_amp = 0;
	                gfc.noise_shaping_stop = 0;
	                gfc.use_best_huffman = 0;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 8:
	                gfp.quality = 7;
	            //$FALL-THROUGH$
	            case 7:
	                /*
	                 * use psymodel (for short block and m/s switching), but no noise
	                 * shapping
	                 */
	                gfc.psymodel = 1;
	                gfc.noise_shaping = 0;
	                gfc.noise_shaping_amp = 0;
	                gfc.noise_shaping_stop = 0;
	                gfc.use_best_huffman = 0;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 6:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                gfc.noise_shaping_amp = 0;
	                gfc.noise_shaping_stop = 0;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 0;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 5:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                gfc.noise_shaping_amp = 0;
	                gfc.noise_shaping_stop = 0;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 0;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 4:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                gfc.noise_shaping_amp = 0;
	                gfc.noise_shaping_stop = 0;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 1;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 3:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                gfc.noise_shaping_amp = 1;
	                gfc.noise_shaping_stop = 1;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 1;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 2:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                if (gfc.substep_shaping == 0)
	                    gfc.substep_shaping = 2;
	                gfc.noise_shaping_amp = 1;
	                gfc.noise_shaping_stop = 1;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 1;
	                /* inner loop */
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 1:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                if (gfc.substep_shaping == 0)
	                    gfc.substep_shaping = 2;
	                gfc.noise_shaping_amp = 2;
	                gfc.noise_shaping_stop = 1;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 1;
	                gfc.full_outer_loop = 0;
	                break;
	
	            case 0:
	                gfc.psymodel = 1;
	                if (gfc.noise_shaping == 0)
	                    gfc.noise_shaping = 1;
	                if (gfc.substep_shaping == 0)
	                    gfc.substep_shaping = 2;
	                gfc.noise_shaping_amp = 2;
	                gfc.noise_shaping_stop = 1;
	                if (gfc.subblock_gain == -1)
	                    gfc.subblock_gain = 1;
	                gfc.use_best_huffman = 1;
	                /*
	                 * type 2 disabled because of it slowness, in favor of full outer
	                 * loop search
	                 */
	                gfc.full_outer_loop = 0;
	                /*
	                 * full outer loop search disabled because of audible distortions it
	                 * may generate rh 060629
	                 */
	                break;
	        }
	
	    }
	
	    function lame_init_bitstream(gfp) {
	        var gfc = gfp.internal_flags;
	        gfp.frameNum = 0;
	
	        if (gfp.write_id3tag_automatic) {
	            id3.id3tag_write_v2(gfp);
	        }
	        /* initialize histogram data optionally used by frontend */
	
	        gfc.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
	        gfc.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);
	
	        gfc.PeakSample = 0.0;
	
	        /* Write initial VBR Header to bitstream and init VBR data */
	        if (gfp.bWriteVbrTag)
	            vbr.InitVbrTag(gfp);
	    }
	
	    /********************************************************************
	     * initialize internal params based on data in gf (globalflags struct filled
	     * in by calling program)
	     *
	     * OUTLINE:
	     *
	     * We first have some complex code to determine bitrate, output samplerate
	     * and mode. It is complicated by the fact that we allow the user to set
	     * some or all of these parameters, and need to determine best possible
	     * values for the rest of them:
	     *
	     * 1. set some CPU related flags 2. check if we are mono.mono, stereo.mono
	     * or stereo.stereo 3. compute bitrate and output samplerate: user may have
	     * set compression ratio user may have set a bitrate user may have set a
	     * output samplerate 4. set some options which depend on output samplerate
	     * 5. compute the actual compression ratio 6. set mode based on compression
	     * ratio
	     *
	     * The remaining code is much simpler - it just sets options based on the
	     * mode & compression ratio:
	     *
	     * set allow_diff_short based on mode select lowpass filter based on
	     * compression ratio & mode set the bitrate index, and min/max bitrates for
	     * VBR modes disable VBR tag if it is not appropriate initialize the
	     * bitstream initialize scalefac_band data set sideinfo_len (based on
	     * channels, CRC, out_samplerate) write an id3v2 tag into the bitstream
	     * write VBR tag into the bitstream set mpeg1/2 flag estimate the number of
	     * frames (based on a lot of data)
	     *
	     * now we set more flags: nspsytune: see code VBR modes see code CBR/ABR see
	     * code
	     *
	     * Finally, we set the algorithm flags based on the gfp.quality value
	     * lame_init_qval(gfp);
	     *
	     ********************************************************************/
	    this.lame_init_params = function (gfp) {
	        var gfc = gfp.internal_flags;
	
	        gfc.Class_ID = 0;
	        if (gfc.ATH == null)
	            gfc.ATH = new ATH();
	        if (gfc.PSY == null)
	            gfc.PSY = new PSY();
	        if (gfc.rgdata == null)
	            gfc.rgdata = new ReplayGain();
	
	        gfc.channels_in = gfp.num_channels;
	        if (gfc.channels_in == 1)
	            gfp.mode = MPEGMode.MONO;
	        gfc.channels_out = (gfp.mode == MPEGMode.MONO) ? 1 : 2;
	        gfc.mode_ext = Encoder.MPG_MD_MS_LR;
	        if (gfp.mode == MPEGMode.MONO)
	            gfp.force_ms = false;
	        /*
	         * don't allow forced mid/side stereo for mono output
	         */
	
	        if (gfp.VBR == VbrMode.vbr_off && gfp.VBR_mean_bitrate_kbps != 128
	            && gfp.brate == 0)
	            gfp.brate = gfp.VBR_mean_bitrate_kbps;
	
	        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_mtrh
	            || gfp.VBR == VbrMode.vbr_mt) {
	            /* these modes can handle free format condition */
	        } else {
	            gfp.free_format = false;
	            /* mode can't be mixed with free format */
	        }
	
	        if (gfp.VBR == VbrMode.vbr_off && gfp.brate == 0) {
	            /* no bitrate or compression ratio specified, use 11.025 */
	            if (BitStream.EQ(gfp.compression_ratio, 0))
	                gfp.compression_ratio = 11.025;
	            /*
	             * rate to compress a CD down to exactly 128000 bps
	             */
	        }
	
	        /* find bitrate if user specify a compression ratio */
	        if (gfp.VBR == VbrMode.vbr_off && gfp.compression_ratio > 0) {
	
	            if (gfp.out_samplerate == 0)
	                gfp.out_samplerate = map2MP3Frequency((int)(0.97 * gfp.in_samplerate));
	            /*
	             * round up with a margin of 3 %
	             */
	
	            /*
	             * choose a bitrate for the output samplerate which achieves
	             * specified compression ratio
	             */
	            gfp.brate = 0 | (gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.compression_ratio));
	
	            /* we need the version for the bitrate table look up */
	            gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
	
	            if (!gfp.free_format) /*
	             * for non Free Format find the nearest allowed
	             * bitrate
	             */
	                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
	                    gfp.out_samplerate);
	        }
	
	        if (gfp.out_samplerate != 0) {
	            if (gfp.out_samplerate < 16000) {
	                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
	                    8);
	                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
	                    64);
	            } else if (gfp.out_samplerate < 32000) {
	                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
	                    8);
	                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
	                    160);
	            } else {
	                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
	                    32);
	                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
	                    320);
	            }
	        }
	
	        /****************************************************************/
	        /* if a filter has not been enabled, see if we should add one: */
	        /****************************************************************/
	        if (gfp.lowpassfreq == 0) {
	            var lowpass = 16000.;
	
	            switch (gfp.VBR) {
	                case VbrMode.vbr_off:
	                {
	                    var lh = new LowPassHighPass();
	                    optimum_bandwidth(lh, gfp.brate);
	                    lowpass = lh.lowerlimit;
	                    break;
	                }
	                case VbrMode.vbr_abr:
	                {
	                    var lh = new LowPassHighPass();
	                    optimum_bandwidth(lh, gfp.VBR_mean_bitrate_kbps);
	                    lowpass = lh.lowerlimit;
	                    break;
	                }
	                case VbrMode.vbr_rh:
	                {
	                    var x = [19500, 19000, 18600, 18000, 17500, 16000,
	                        15600, 14900, 12500, 10000, 3950];
	                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
	                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
	                        lowpass = linear_int(a, b, m);
	                    } else {
	                        lowpass = 19500;
	                    }
	                    break;
	                }
	                default:
	                {
	                    var x = [19500, 19000, 18500, 18000, 17500, 16500,
	                        15500, 14500, 12500, 9500, 3950];
	                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
	                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
	                        lowpass = linear_int(a, b, m);
	                    } else {
	                        lowpass = 19500;
	                    }
	                }
	            }
	            if (gfp.mode == MPEGMode.MONO
	                && (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr))
	                lowpass *= 1.5;
	
	            gfp.lowpassfreq = lowpass | 0;
	        }
	
	        if (gfp.out_samplerate == 0) {
	            if (2 * gfp.lowpassfreq > gfp.in_samplerate) {
	                gfp.lowpassfreq = gfp.in_samplerate / 2;
	            }
	            gfp.out_samplerate = optimum_samplefreq(gfp.lowpassfreq | 0,
	                gfp.in_samplerate);
	        }
	
	        gfp.lowpassfreq = Math.min(20500, gfp.lowpassfreq);
	        gfp.lowpassfreq = Math.min(gfp.out_samplerate / 2, gfp.lowpassfreq);
	
	        if (gfp.VBR == VbrMode.vbr_off) {
	            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
	                / (1.e3 * gfp.brate);
	        }
	        if (gfp.VBR == VbrMode.vbr_abr) {
	            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
	                / (1.e3 * gfp.VBR_mean_bitrate_kbps);
	        }
	
	        /*
	         * do not compute ReplayGain values and do not find the peak sample if
	         * we can't store them
	         */
	        if (!gfp.bWriteVbrTag) {
	            gfp.findReplayGain = false;
	            gfp.decode_on_the_fly = false;
	            gfc.findPeakSample = false;
	        }
	        gfc.findReplayGain = gfp.findReplayGain;
	        gfc.decode_on_the_fly = gfp.decode_on_the_fly;
	
	        if (gfc.decode_on_the_fly)
	            gfc.findPeakSample = true;
	
	        if (gfc.findReplayGain) {
	            if (ga.InitGainAnalysis(gfc.rgdata, gfp.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) {
	                gfp.internal_flags = null;
	                return -6;
	            }
	        }
	
	        if (gfc.decode_on_the_fly && !gfp.decode_only) {
	            if (gfc.hip != null) {
	                mpglib.hip_decode_exit(gfc.hip);
	            }
	            gfc.hip = mpglib.hip_decode_init();
	        }
	
	        gfc.mode_gr = gfp.out_samplerate <= 24000 ? 1 : 2;
	        /*
	         * Number of granules per frame
	         */
	        gfp.framesize = 576 * gfc.mode_gr;
	        gfp.encoder_delay = Encoder.ENCDELAY;
	
	        gfc.resample_ratio = gfp.in_samplerate / gfp.out_samplerate;
	
	        /**
	         * <PRE>
	         *  sample freq       bitrate     compression ratio
	         *     [kHz]      [kbps/channel]   for 16 bit input
	         *     44.1            56               12.6
	         *     44.1            64               11.025
	         *     44.1            80                8.82
	         *     22.05           24               14.7
	         *     22.05           32               11.025
	         *     22.05           40                8.82
	         *     16              16               16.0
	         *     16              24               10.667
	         * </PRE>
	         */
	        /**
	         * <PRE>
	         *  For VBR, take a guess at the compression_ratio.
	         *  For example:
	         *
	         *    VBR_q    compression     like
	         *     -        4.4         320 kbps/44 kHz
	         *   0...1      5.5         256 kbps/44 kHz
	         *     2        7.3         192 kbps/44 kHz
	         *     4        8.8         160 kbps/44 kHz
	         *     6       11           128 kbps/44 kHz
	         *     9       14.7          96 kbps
	         *
	         *  for lower bitrates, downsample with --resample
	         * </PRE>
	         */
	        switch (gfp.VBR) {
	            case VbrMode.vbr_mt:
	            case VbrMode.vbr_rh:
	            case VbrMode.vbr_mtrh:
	            {
	                /* numbers are a bit strange, but they determine the lowpass value */
	                var cmp = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14,
	                    15, 16.5];
	                gfp.compression_ratio = cmp[gfp.VBR_q];
	            }
	                break;
	            case VbrMode.vbr_abr:
	                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
	                    / (1.e3 * gfp.VBR_mean_bitrate_kbps);
	                break;
	            default:
	                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
	                    / (1.e3 * gfp.brate);
	                break;
	        }
	
	        /*
	         * mode = -1 (not set by user) or mode = MONO (because of only 1 input
	         * channel). If mode has not been set, then select J-STEREO
	         */
	        if (gfp.mode == MPEGMode.NOT_SET) {
	            gfp.mode = MPEGMode.JOINT_STEREO;
	        }
	
	        /* apply user driven high pass filter */
	        if (gfp.highpassfreq > 0) {
	            gfc.highpass1 = 2. * gfp.highpassfreq;
	
	            if (gfp.highpasswidth >= 0)
	                gfc.highpass2 = 2. * (gfp.highpassfreq + gfp.highpasswidth);
	            else
	            /* 0% above on default */
	                gfc.highpass2 = (1 + 0.00) * 2. * gfp.highpassfreq;
	
	            gfc.highpass1 /= gfp.out_samplerate;
	            gfc.highpass2 /= gfp.out_samplerate;
	        } else {
	            gfc.highpass1 = 0;
	            gfc.highpass2 = 0;
	        }
	        /* apply user driven low pass filter */
	        if (gfp.lowpassfreq > 0) {
	            gfc.lowpass2 = 2. * gfp.lowpassfreq;
	            if (gfp.lowpasswidth >= 0) {
	                gfc.lowpass1 = 2. * (gfp.lowpassfreq - gfp.lowpasswidth);
	                if (gfc.lowpass1 < 0) /* has to be >= 0 */
	                    gfc.lowpass1 = 0;
	            } else { /* 0% below on default */
	                gfc.lowpass1 = (1 - 0.00) * 2. * gfp.lowpassfreq;
	            }
	            gfc.lowpass1 /= gfp.out_samplerate;
	            gfc.lowpass2 /= gfp.out_samplerate;
	        } else {
	            gfc.lowpass1 = 0;
	            gfc.lowpass2 = 0;
	        }
	
	        /**********************************************************************/
	        /* compute info needed for polyphase filter (filter type==0, default) */
	        /**********************************************************************/
	        lame_init_params_ppflt(gfp);
	        /*******************************************************
	         * samplerate and bitrate index
	         *******************************************************/
	        gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
	        if (gfc.samplerate_index < 0) {
	            gfp.internal_flags = null;
	            return -1;
	        }
	
	        if (gfp.VBR == VbrMode.vbr_off) {
	            if (gfp.free_format) {
	                gfc.bitrate_index = 0;
	            } else {
	                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
	                    gfp.out_samplerate);
	                gfc.bitrate_index = BitrateIndex(gfp.brate, gfp.version,
	                    gfp.out_samplerate);
	                if (gfc.bitrate_index <= 0) {
	                    gfp.internal_flags = null;
	                    return -1;
	                }
	            }
	        } else {
	            gfc.bitrate_index = 1;
	        }
	
	        /* for CBR, we will write an "info" tag. */
	
	        if (gfp.analysis)
	            gfp.bWriteVbrTag = false;
	
	        /* some file options not allowed if output is: not specified or stdout */
	        if (gfc.pinfo != null)
	            gfp.bWriteVbrTag = false;
	        /* disable Xing VBR tag */
	
	        bs.init_bit_stream_w(gfc);
	
	        var j = gfc.samplerate_index + (3 * gfp.version) + 6
	            * (gfp.out_samplerate < 16000 ? 1 : 0);
	        for (var i = 0; i < Encoder.SBMAX_l + 1; i++)
	            gfc.scalefac_band.l[i] = qupvt.sfBandIndex[j].l[i];
	
	        for (var i = 0; i < Encoder.PSFB21 + 1; i++) {
	            var size = (gfc.scalefac_band.l[22] - gfc.scalefac_band.l[21])
	                / Encoder.PSFB21;
	            var start = gfc.scalefac_band.l[21] + i * size;
	            gfc.scalefac_band.psfb21[i] = start;
	        }
	        gfc.scalefac_band.psfb21[Encoder.PSFB21] = 576;
	
	        for (var i = 0; i < Encoder.SBMAX_s + 1; i++)
	            gfc.scalefac_band.s[i] = qupvt.sfBandIndex[j].s[i];
	
	        for (var i = 0; i < Encoder.PSFB12 + 1; i++) {
	            var size = (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
	                / Encoder.PSFB12;
	            var start = gfc.scalefac_band.s[12] + i * size;
	            gfc.scalefac_band.psfb12[i] = start;
	        }
	        gfc.scalefac_band.psfb12[Encoder.PSFB12] = 192;
	        /* determine the mean bitrate for main data */
	        if (gfp.version == 1) /* MPEG 1 */
	            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 17 : 4 + 32;
	        else
	        /* MPEG 2 */
	            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 9 : 4 + 17;
	
	        if (gfp.error_protection)
	            gfc.sideinfo_len += 2;
	
	        lame_init_bitstream(gfp);
	
	        gfc.Class_ID = LAME_ID;
	
	        {
	            var k;
	
	            for (k = 0; k < 19; k++)
	                gfc.nsPsy.pefirbuf[k] = 700 * gfc.mode_gr * gfc.channels_out;
	
	            if (gfp.ATHtype == -1)
	                gfp.ATHtype = 4;
	        }
	        assert(gfp.VBR_q <= 9);
	        assert(gfp.VBR_q >= 0);
	
	        switch (gfp.VBR) {
	
	            case VbrMode.vbr_mt:
	                gfp.VBR = VbrMode.vbr_mtrh;
	            //$FALL-THROUGH$
	            case VbrMode.vbr_mtrh:
	            {
	                if (gfp.useTemporal == null) {
	                    gfp.useTemporal = false;
	                    /* off by default for this VBR mode */
	                }
	
	                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);
	                /**
	                 * <PRE>
	                 *   The newer VBR code supports only a limited
	                 *     subset of quality levels:
	                 *     9-5=5 are the same, uses x^3/4 quantization
	                 *   4-0=0 are the same  5 plus best huffman divide code
	                 * </PRE>
	                 */
	                if (gfp.quality < 0)
	                    gfp.quality = LAME_DEFAULT_QUALITY;
	                if (gfp.quality < 5)
	                    gfp.quality = 0;
	                if (gfp.quality > 5)
	                    gfp.quality = 5;
	
	                gfc.PSY.mask_adjust = gfp.maskingadjust;
	                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
	
	                /*
	                 * sfb21 extra only with MPEG-1 at higher sampling rates
	                 */
	                if (gfp.experimentalY)
	                    gfc.sfb21_extra = false;
	                else
	                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);
	
	                gfc.iteration_loop = new VBRNewIterationLoop(qu);
	                break;
	
	            }
	            case VbrMode.vbr_rh:
	            {
	
	                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);
	
	                gfc.PSY.mask_adjust = gfp.maskingadjust;
	                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
	
	                /*
	                 * sfb21 extra only with MPEG-1 at higher sampling rates
	                 */
	                if (gfp.experimentalY)
	                    gfc.sfb21_extra = false;
	                else
	                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);
	
	                /*
	                 * VBR needs at least the output of GPSYCHO, so we have to garantee
	                 * that by setting a minimum quality level, actually level 6 does
	                 * it. down to level 6
	                 */
	                if (gfp.quality > 6)
	                    gfp.quality = 6;
	
	                if (gfp.quality < 0)
	                    gfp.quality = LAME_DEFAULT_QUALITY;
	
	                gfc.iteration_loop = new VBROldIterationLoop(qu);
	                break;
	            }
	
	            default: /* cbr/abr */
	            {
	                var vbrmode;
	
	                /*
	                 * no sfb21 extra with CBR code
	                 */
	                gfc.sfb21_extra = false;
	
	                if (gfp.quality < 0)
	                    gfp.quality = LAME_DEFAULT_QUALITY;
	
	                vbrmode = gfp.VBR;
	                if (vbrmode == VbrMode.vbr_off)
	                    gfp.VBR_mean_bitrate_kbps = gfp.brate;
	                /* second, set parameters depending on bitrate */
	                p.apply_preset(gfp, gfp.VBR_mean_bitrate_kbps, 0);
	                gfp.VBR = vbrmode;
	
	                gfc.PSY.mask_adjust = gfp.maskingadjust;
	                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;
	
	                if (vbrmode == VbrMode.vbr_off) {
	                    gfc.iteration_loop = new CBRNewIterationLoop(qu);
	                } else {
	                    gfc.iteration_loop = new ABRIterationLoop(qu);
	                }
	                break;
	            }
	        }
	        assert(gfp.scale >= 0);
	        /* initialize default values common for all modes */
	
	        if (gfp.VBR != VbrMode.vbr_off) { /* choose a min/max bitrate for VBR */
	            /* if the user didn't specify VBR_max_bitrate: */
	            gfc.VBR_min_bitrate = 1;
	            /*
	             * default: allow 8 kbps (MPEG-2) or 32 kbps (MPEG-1)
	             */
	            gfc.VBR_max_bitrate = 14;
	            /*
	             * default: allow 160 kbps (MPEG-2) or 320 kbps (MPEG-1)
	             */
	            if (gfp.out_samplerate < 16000)
	                gfc.VBR_max_bitrate = 8;
	            /* default: allow 64 kbps (MPEG-2.5) */
	            if (gfp.VBR_min_bitrate_kbps != 0) {
	                gfp.VBR_min_bitrate_kbps = FindNearestBitrate(
	                    gfp.VBR_min_bitrate_kbps, gfp.version,
	                    gfp.out_samplerate);
	                gfc.VBR_min_bitrate = BitrateIndex(gfp.VBR_min_bitrate_kbps,
	                    gfp.version, gfp.out_samplerate);
	                if (gfc.VBR_min_bitrate < 0)
	                    return -1;
	            }
	            if (gfp.VBR_max_bitrate_kbps != 0) {
	                gfp.VBR_max_bitrate_kbps = FindNearestBitrate(
	                    gfp.VBR_max_bitrate_kbps, gfp.version,
	                    gfp.out_samplerate);
	                gfc.VBR_max_bitrate = BitrateIndex(gfp.VBR_max_bitrate_kbps,
	                    gfp.version, gfp.out_samplerate);
	                if (gfc.VBR_max_bitrate < 0)
	                    return -1;
	            }
	            gfp.VBR_min_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate];
	            gfp.VBR_max_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate];
	            gfp.VBR_mean_bitrate_kbps = Math.min(
	                Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate],
	                gfp.VBR_mean_bitrate_kbps);
	            gfp.VBR_mean_bitrate_kbps = Math.max(
	                Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate],
	                gfp.VBR_mean_bitrate_kbps);
	        }
	
	        /* just another daily changing developer switch */
	        if (gfp.tune) {
	            gfc.PSY.mask_adjust += gfp.tune_value_a;
	            gfc.PSY.mask_adjust_short += gfp.tune_value_a;
	        }
	
	        /* initialize internal qval settings */
	        lame_init_qval(gfp);
	        assert(gfp.scale >= 0);
	        /*
	         * automatic ATH adjustment on
	         */
	        if (gfp.athaa_type < 0)
	            gfc.ATH.useAdjust = 3;
	        else
	            gfc.ATH.useAdjust = gfp.athaa_type;
	
	        /* initialize internal adaptive ATH settings -jd */
	        gfc.ATH.aaSensitivityP = Math.pow(10.0, gfp.athaa_sensitivity
	            / -10.0);
	
	        if (gfp.short_blocks == null) {
	            gfp.short_blocks = ShortBlock.short_block_allowed;
	        }
	
	        /*
	         * Note Jan/2003: Many hardware decoders cannot handle short blocks in
	         * regular stereo mode unless they are coupled (same type in both
	         * channels) it is a rare event (1 frame per min. or so) that LAME would
	         * use uncoupled short blocks, so lets turn them off until we decide how
	         * to handle this. No other encoders allow uncoupled short blocks, even
	         * though it is in the standard.
	         */
	        /*
	         * rh 20040217: coupling makes no sense for mono and dual-mono streams
	         */
	        if (gfp.short_blocks == ShortBlock.short_block_allowed
	            && (gfp.mode == MPEGMode.JOINT_STEREO || gfp.mode == MPEGMode.STEREO)) {
	            gfp.short_blocks = ShortBlock.short_block_coupled;
	        }
	
	        if (gfp.quant_comp < 0)
	            gfp.quant_comp = 1;
	        if (gfp.quant_comp_short < 0)
	            gfp.quant_comp_short = 0;
	
	        if (gfp.msfix < 0)
	            gfp.msfix = 0;
	
	        /* select psychoacoustic model */
	        gfp.exp_nspsytune = gfp.exp_nspsytune | 1;
	
	        if (gfp.internal_flags.nsPsy.attackthre < 0)
	            gfp.internal_flags.nsPsy.attackthre = PsyModel.NSATTACKTHRE;
	        if (gfp.internal_flags.nsPsy.attackthre_s < 0)
	            gfp.internal_flags.nsPsy.attackthre_s = PsyModel.NSATTACKTHRE_S;
	
	        assert(gfp.scale >= 0);
	
	        if (gfp.scale < 0)
	            gfp.scale = 1;
	
	        if (gfp.ATHtype < 0)
	            gfp.ATHtype = 4;
	
	        if (gfp.ATHcurve < 0)
	            gfp.ATHcurve = 4;
	
	        if (gfp.athaa_loudapprox < 0)
	            gfp.athaa_loudapprox = 2;
	
	        if (gfp.interChRatio < 0)
	            gfp.interChRatio = 0;
	
	        if (gfp.useTemporal == null)
	            gfp.useTemporal = true;
	        /* on by default */
	
	        /*
	         * padding method as described in
	         * "MPEG-Layer3 / Bitstream Syntax and Decoding" by Martin Sieler, Ralph
	         * Sperschneider
	         *
	         * note: there is no padding for the very first frame
	         *
	         * Robert Hegemann 2000-06-22
	         */
	        gfc.slot_lag = gfc.frac_SpF = 0;
	        if (gfp.VBR == VbrMode.vbr_off)
	            gfc.slot_lag = gfc.frac_SpF = (((gfp.version + 1) * 72000 * gfp.brate) % gfp.out_samplerate) | 0;
	
	        qupvt.iteration_init(gfp);
	        psy.psymodel_init(gfp);
	        assert(gfp.scale >= 0);
	        return 0;
	    }
	
	    function update_inbuffer_size(gfc, nsamples) {
	        if (gfc.in_buffer_0 == null || gfc.in_buffer_nsamples < nsamples) {
	            gfc.in_buffer_0 = new_float(nsamples);
	            gfc.in_buffer_1 = new_float(nsamples);
	            gfc.in_buffer_nsamples = nsamples;
	        }
	    }
	
	    this.lame_encode_flush = function (gfp, mp3buffer, mp3bufferPos, mp3buffer_size) {
	        var gfc = gfp.internal_flags;
	        var buffer = new_short_n([2, 1152]);
	        var imp3 = 0, mp3count, mp3buffer_size_remaining;
	
	        /*
	         * we always add POSTDELAY=288 padding to make sure granule with real
	         * data can be complety decoded (because of 50% overlap with next
	         * granule
	         */
	        var end_padding;
	        var frames_left;
	        var samples_to_encode = gfc.mf_samples_to_encode - Encoder.POSTDELAY;
	        var mf_needed = calcNeeded(gfp);
	
	        /* Was flush already called? */
	        if (gfc.mf_samples_to_encode < 1) {
	            return 0;
	        }
	        mp3count = 0;
	
	        if (gfp.in_samplerate != gfp.out_samplerate) {
	            /*
	             * delay due to resampling; needs to be fixed, if resampling code
	             * gets changed
	             */
	            samples_to_encode += 16. * gfp.out_samplerate / gfp.in_samplerate;
	        }
	        end_padding = gfp.framesize - (samples_to_encode % gfp.framesize);
	        if (end_padding < 576)
	            end_padding += gfp.framesize;
	        gfp.encoder_padding = end_padding;
	
	        frames_left = (samples_to_encode + end_padding) / gfp.framesize;
	
	        /*
	         * send in a frame of 0 padding until all internal sample buffers are
	         * flushed
	         */
	        while (frames_left > 0 && imp3 >= 0) {
	            var bunch = mf_needed - gfc.mf_size;
	            var frame_num = gfp.frameNum;
	
	            bunch *= gfp.in_samplerate;
	            bunch /= gfp.out_samplerate;
	            if (bunch > 1152)
	                bunch = 1152;
	            if (bunch < 1)
	                bunch = 1;
	
	            mp3buffer_size_remaining = mp3buffer_size - mp3count;
	
	            /* if user specifed buffer size = 0, dont check size */
	            if (mp3buffer_size == 0)
	                mp3buffer_size_remaining = 0;
	
	            imp3 = this.lame_encode_buffer(gfp, buffer[0], buffer[1], bunch,
	                mp3buffer, mp3bufferPos, mp3buffer_size_remaining);
	
	            mp3bufferPos += imp3;
	            mp3count += imp3;
	            frames_left -= (frame_num != gfp.frameNum) ? 1 : 0;
	        }
	        /*
	         * Set gfc.mf_samples_to_encode to 0, so we may detect and break loops
	         * calling it more than once in a row.
	         */
	        gfc.mf_samples_to_encode = 0;
	
	        if (imp3 < 0) {
	            /* some type of fatal error */
	            return imp3;
	        }
	
	        mp3buffer_size_remaining = mp3buffer_size - mp3count;
	        /* if user specifed buffer size = 0, dont check size */
	        if (mp3buffer_size == 0)
	            mp3buffer_size_remaining = 0;
	
	        /* mp3 related stuff. bit buffer might still contain some mp3 data */
	        bs.flush_bitstream(gfp);
	        imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
	            mp3buffer_size_remaining, 1);
	        if (imp3 < 0) {
	            /* some type of fatal error */
	            return imp3;
	        }
	        mp3bufferPos += imp3;
	        mp3count += imp3;
	        mp3buffer_size_remaining = mp3buffer_size - mp3count;
	        /* if user specifed buffer size = 0, dont check size */
	        if (mp3buffer_size == 0)
	            mp3buffer_size_remaining = 0;
	
	        if (gfp.write_id3tag_automatic) {
	            /* write a id3 tag to the bitstream */
	            id3.id3tag_write_v1(gfp);
	
	            imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
	                mp3buffer_size_remaining, 0);
	
	            if (imp3 < 0) {
	                return imp3;
	            }
	            mp3count += imp3;
	        }
	        return mp3count;
	    };
	
	    this.lame_encode_buffer = function (gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
	        var gfc = gfp.internal_flags;
	        var in_buffer = [null, null];
	
	        if (gfc.Class_ID != LAME_ID)
	            return -3;
	
	        if (nsamples == 0)
	            return 0;
	
	        update_inbuffer_size(gfc, nsamples);
	
	        in_buffer[0] = gfc.in_buffer_0;
	        in_buffer[1] = gfc.in_buffer_1;
	
	        /* make a copy of input buffer, changing type to sample_t */
	        for (var i = 0; i < nsamples; i++) {
	            in_buffer[0][i] = buffer_l[i];
	            if (gfc.channels_in > 1)
	                in_buffer[1][i] = buffer_r[i];
	        }
	
	        return lame_encode_buffer_sample(gfp, in_buffer[0], in_buffer[1],
	            nsamples, mp3buf, mp3bufPos, mp3buf_size);
	    }
	
	    function calcNeeded(gfp) {
	        var mf_needed = Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET;
	        /*
	         * amount needed for FFT
	         */
	        mf_needed = Math.max(mf_needed, 512 + gfp.framesize - 32);
	        assert(LameInternalFlags.MFSIZE >= mf_needed);
	
	        return mf_needed;
	    }
	
	    function lame_encode_buffer_sample(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
	        var gfc = gfp.internal_flags;
	        var mp3size = 0, ret, i, ch, mf_needed;
	        var mp3out;
	        var mfbuf = [null, null];
	        var in_buffer = [null, null];
	
	        if (gfc.Class_ID != LAME_ID)
	            return -3;
	
	        if (nsamples == 0)
	            return 0;
	
	        /* copy out any tags that may have been written into bitstream */
	        mp3out = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 0);
	        if (mp3out < 0)
	            return mp3out;
	        /* not enough buffer space */
	        mp3bufPos += mp3out;
	        mp3size += mp3out;
	
	        in_buffer[0] = buffer_l;
	        in_buffer[1] = buffer_r;
	
	        /* Apply user defined re-scaling */
	
	        /* user selected scaling of the samples */
	        if (BitStream.NEQ(gfp.scale, 0) && BitStream.NEQ(gfp.scale, 1.0)) {
	            for (i = 0; i < nsamples; ++i) {
	                in_buffer[0][i] *= gfp.scale;
	                if (gfc.channels_out == 2)
	                    in_buffer[1][i] *= gfp.scale;
	            }
	        }
	
	        /* user selected scaling of the channel 0 (left) samples */
	        if (BitStream.NEQ(gfp.scale_left, 0)
	            && BitStream.NEQ(gfp.scale_left, 1.0)) {
	            for (i = 0; i < nsamples; ++i) {
	                in_buffer[0][i] *= gfp.scale_left;
	            }
	        }
	
	        /* user selected scaling of the channel 1 (right) samples */
	        if (BitStream.NEQ(gfp.scale_right, 0)
	            && BitStream.NEQ(gfp.scale_right, 1.0)) {
	            for (i = 0; i < nsamples; ++i) {
	                in_buffer[1][i] *= gfp.scale_right;
	            }
	        }
	
	        /* Downsample to Mono if 2 channels in and 1 channel out */
	        if (gfp.num_channels == 2 && gfc.channels_out == 1) {
	            for (i = 0; i < nsamples; ++i) {
	                in_buffer[0][i] = 0.5 * ( in_buffer[0][i] + in_buffer[1][i]);
	                in_buffer[1][i] = 0.0;
	            }
	        }
	
	        mf_needed = calcNeeded(gfp);
	
	        mfbuf[0] = gfc.mfbuf[0];
	        mfbuf[1] = gfc.mfbuf[1];
	
	        var in_bufferPos = 0;
	        while (nsamples > 0) {
	            var in_buffer_ptr = [null, null];
	            var n_in = 0;
	            /* number of input samples processed with fill_buffer */
	            var n_out = 0;
	            /* number of samples output with fill_buffer */
	            /* n_in <> n_out if we are resampling */
	
	            in_buffer_ptr[0] = in_buffer[0];
	            in_buffer_ptr[1] = in_buffer[1];
	            /* copy in new samples into mfbuf, with resampling */
	            var inOut = new InOut();
	            fill_buffer(gfp, mfbuf, in_buffer_ptr, in_bufferPos, nsamples,
	                inOut);
	            n_in = inOut.n_in;
	            n_out = inOut.n_out;
	
	            /* compute ReplayGain of resampled input if requested */
	            if (gfc.findReplayGain && !gfc.decode_on_the_fly)
	                if (ga.AnalyzeSamples(gfc.rgdata, mfbuf[0], gfc.mf_size,
	                        mfbuf[1], gfc.mf_size, n_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
	                    return -6;
	
	            /* update in_buffer counters */
	            nsamples -= n_in;
	            in_bufferPos += n_in;
	            if (gfc.channels_out == 2)
	                ;// in_bufferPos += n_in;
	
	            /* update mfbuf[] counters */
	            gfc.mf_size += n_out;
	            assert(gfc.mf_size <= LameInternalFlags.MFSIZE);
	
	            /*
	             * lame_encode_flush may have set gfc.mf_sample_to_encode to 0 so we
	             * have to reinitialize it here when that happened.
	             */
	            if (gfc.mf_samples_to_encode < 1) {
	                gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
	            }
	            gfc.mf_samples_to_encode += n_out;
	
	            if (gfc.mf_size >= mf_needed) {
	                /* encode the frame. */
	                /* mp3buf = pointer to current location in buffer */
	                /* mp3buf_size = size of original mp3 output buffer */
	                /* = 0 if we should not worry about the */
	                /* buffer size because calling program is */
	                /* to lazy to compute it */
	                /* mp3size = size of data written to buffer so far */
	                /* mp3buf_size-mp3size = amount of space avalable */
	
	                var buf_size = mp3buf_size - mp3size;
	                if (mp3buf_size == 0)
	                    buf_size = 0;
	
	                ret = lame_encode_frame(gfp, mfbuf[0], mfbuf[1], mp3buf,
	                    mp3bufPos, buf_size);
	
	                if (ret < 0)
	                    return ret;
	                mp3bufPos += ret;
	                mp3size += ret;
	
	                /* shift out old samples */
	                gfc.mf_size -= gfp.framesize;
	                gfc.mf_samples_to_encode -= gfp.framesize;
	                for (ch = 0; ch < gfc.channels_out; ch++)
	                    for (i = 0; i < gfc.mf_size; i++)
	                        mfbuf[ch][i] = mfbuf[ch][i + gfp.framesize];
	            }
	        }
	        assert(nsamples == 0);
	
	        return mp3size;
	    }
	
	    function lame_encode_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
	        var ret = self.enc.lame_encode_mp3_frame(gfp, inbuf_l, inbuf_r, mp3buf,
	            mp3bufPos, mp3buf_size);
	        gfp.frameNum++;
	        return ret;
	    }
	
	    function InOut() {
	        this.n_in = 0;
	        this.n_out = 0;
	    }
	
	
	    function NumUsed() {
	        this.num_used = 0;
	    }
	
	    /**
	     * Greatest common divisor.
	     * <p>
	     * Joint work of Euclid and M. Hendry
	     */
	    function gcd(i, j) {
	        return j != 0 ? gcd(j, i % j) : i;
	    }
	
	    /**
	     * Resampling via FIR filter, blackman window.
	     */
	    function blackman(x, fcn, l) {
	        /*
	         * This algorithm from: SIGNAL PROCESSING ALGORITHMS IN FORTRAN AND C
	         * S.D. Stearns and R.A. David, Prentice-Hall, 1992
	         */
	        var wcn = (Math.PI * fcn);
	
	        x /= l;
	        if (x < 0)
	            x = 0;
	        if (x > 1)
	            x = 1;
	        var x2 = x - .5;
	
	        var bkwn = 0.42 - 0.5 * Math.cos(2 * x * Math.PI) + 0.08 * Math.cos(4 * x * Math.PI);
	        if (Math.abs(x2) < 1e-9)
	            return (wcn / Math.PI);
	        else
	            return (bkwn * Math.sin(l * wcn * x2) / (Math.PI * l * x2));
	    }
	
	    function fill_buffer_resample(gfp, outbuf, outbufPos, desired_len, inbuf, in_bufferPos, len, num_used, ch) {
	        var gfc = gfp.internal_flags;
	        var i, j = 0, k;
	        /* number of convolution functions to pre-compute */
	        var bpc = gfp.out_samplerate
	            / gcd(gfp.out_samplerate, gfp.in_samplerate);
	        if (bpc > LameInternalFlags.BPC)
	            bpc = LameInternalFlags.BPC;
	
	        var intratio = (Math.abs(gfc.resample_ratio
	            - Math.floor(.5 + gfc.resample_ratio)) < .0001) ? 1 : 0;
	        var fcn = 1.00 / gfc.resample_ratio;
	        if (fcn > 1.00)
	            fcn = 1.00;
	        var filter_l = 31;
	        if (0 == filter_l % 2)
	            --filter_l;
	        /* must be odd */
	        filter_l += intratio;
	        /* unless resample_ratio=int, it must be even */
	
	        var BLACKSIZE = filter_l + 1;
	        /* size of data needed for FIR */
	
	        if (gfc.fill_buffer_resample_init == 0) {
	            gfc.inbuf_old[0] = new_float(BLACKSIZE);
	            gfc.inbuf_old[1] = new_float(BLACKSIZE);
	            for (i = 0; i <= 2 * bpc; ++i)
	                gfc.blackfilt[i] = new_float(BLACKSIZE);
	
	            gfc.itime[0] = 0;
	            gfc.itime[1] = 0;
	
	            /* precompute blackman filter coefficients */
	            for (j = 0; j <= 2 * bpc; j++) {
	                var sum = 0.;
	                var offset = (j - bpc) / (2. * bpc);
	                for (i = 0; i <= filter_l; i++)
	                    sum += gfc.blackfilt[j][i] = blackman(i - offset, fcn,
	                        filter_l);
	                for (i = 0; i <= filter_l; i++)
	                    gfc.blackfilt[j][i] /= sum;
	            }
	            gfc.fill_buffer_resample_init = 1;
	        }
	
	        var inbuf_old = gfc.inbuf_old[ch];
	
	        /* time of j'th element in inbuf = itime + j/ifreq; */
	        /* time of k'th element in outbuf = j/ofreq */
	        for (k = 0; k < desired_len; k++) {
	            var time0;
	            var joff;
	
	            time0 = k * gfc.resample_ratio;
	            /* time of k'th output sample */
	            j = 0 | Math.floor(time0 - gfc.itime[ch]);
	
	            /* check if we need more input data */
	            if ((filter_l + j - filter_l / 2) >= len)
	                break;
	
	            /* blackman filter. by default, window centered at j+.5(filter_l%2) */
	            /* but we want a window centered at time0. */
	            var offset = (time0 - gfc.itime[ch] - (j + .5 * (filter_l % 2)));
	            assert(Math.abs(offset) <= .501);
	
	            /* find the closest precomputed window for this offset: */
	            joff = 0 | Math.floor((offset * 2 * bpc) + bpc + .5);
	            var xvalue = 0.;
	            for (i = 0; i <= filter_l; ++i) {
	                var j2 = i + j - filter_l / 2;
	                var y;
	                assert(j2 < len);
	                assert(j2 + BLACKSIZE >= 0);
	                y = (j2 < 0) ? inbuf_old[BLACKSIZE + j2] : inbuf[in_bufferPos
	                + j2];
	                xvalue += y * gfc.blackfilt[joff][i];
	            }
	            outbuf[outbufPos + k] = xvalue;
	        }
	
	        /* k = number of samples added to outbuf */
	        /* last k sample used data from [j-filter_l/2,j+filter_l-filter_l/2] */
	
	        /* how many samples of input data were used: */
	        num_used.num_used = Math.min(len, filter_l + j - filter_l / 2);
	
	        /*
	         * adjust our input time counter. Incriment by the number of samples
	         * used, then normalize so that next output sample is at time 0, next
	         * input buffer is at time itime[ch]
	         */
	        gfc.itime[ch] += num_used.num_used - k * gfc.resample_ratio;
	
	        /* save the last BLACKSIZE samples into the inbuf_old buffer */
	        if (num_used.num_used >= BLACKSIZE) {
	            for (i = 0; i < BLACKSIZE; i++)
	                inbuf_old[i] = inbuf[in_bufferPos + num_used.num_used + i
	                - BLACKSIZE];
	        } else {
	            /* shift in num_used.num_used samples into inbuf_old */
	            var n_shift = BLACKSIZE - num_used.num_used;
	            /*
	             * number of samples to
	             * shift
	             */
	
	            /*
	             * shift n_shift samples by num_used.num_used, to make room for the
	             * num_used new samples
	             */
	            for (i = 0; i < n_shift; ++i)
	                inbuf_old[i] = inbuf_old[i + num_used.num_used];
	
	            /* shift in the num_used.num_used samples */
	            for (j = 0; i < BLACKSIZE; ++i, ++j)
	                inbuf_old[i] = inbuf[in_bufferPos + j];
	
	            assert(j == num_used.num_used);
	        }
	        return k;
	        /* return the number samples created at the new samplerate */
	    }
	
	    function fill_buffer(gfp, mfbuf, in_buffer, in_bufferPos, nsamples, io) {
	        var gfc = gfp.internal_flags;
	
	        /* copy in new samples into mfbuf, with resampling if necessary */
	        if ((gfc.resample_ratio < .9999) || (gfc.resample_ratio > 1.0001)) {
	            for (var ch = 0; ch < gfc.channels_out; ch++) {
	                var numUsed = new NumUsed();
	                io.n_out = fill_buffer_resample(gfp, mfbuf[ch], gfc.mf_size,
	                    gfp.framesize, in_buffer[ch], in_bufferPos, nsamples,
	                    numUsed, ch);
	                io.n_in = numUsed.num_used;
	            }
	        } else {
	            io.n_out = Math.min(gfp.framesize, nsamples);
	            io.n_in = io.n_out;
	            for (var i = 0; i < io.n_out; ++i) {
	                mfbuf[0][gfc.mf_size + i] = in_buffer[0][in_bufferPos + i];
	                if (gfc.channels_out == 2)
	                    mfbuf[1][gfc.mf_size + i] = in_buffer[1][in_bufferPos + i];
	            }
	        }
	    }
	
	}
	
	module.exports = Lame;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var MPEGMode = __webpack_require__(193);
	
	function LameGlobalFlags() {
	
	    this.class_id = 0;
	
	    /* input description */
	
	    /**
	     * number of samples. default=-1
	     */
	    this.num_samples = 0;
	    /**
	     * input number of channels. default=2
	     */
	    this.num_channels = 0;
	    /**
	     * input_samp_rate in Hz. default=44.1 kHz
	     */
	    this.in_samplerate = 0;
	    /**
	     * output_samp_rate. default: LAME picks best value at least not used for
	     * MP3 decoding: Remember 44.1 kHz MP3s and AC97
	     */
	    this.out_samplerate = 0;
	    /**
	     * scale input by this amount before encoding at least not used for MP3
	     * decoding
	     */
	    this.scale = 0.;
	    /**
	     * scale input of channel 0 (left) by this amount before encoding
	     */
	    this.scale_left = 0.;
	    /**
	     * scale input of channel 1 (right) by this amount before encoding
	     */
	    this.scale_right = 0.;
	
	    /* general control params */
	    /**
	     * collect data for a MP3 frame analyzer?
	     */
	    this.analysis = false;
	    /**
	     * add Xing VBR tag?
	     */
	    this.bWriteVbrTag = false;
	
	    /**
	     * use lame/mpglib to convert mp3 to wav
	     */
	    this.decode_only = false;
	    /**
	     * quality setting 0=best, 9=worst default=5
	     */
	    this.quality = 0;
	    /**
	     * see enum default = LAME picks best value
	     */
	    this.mode = MPEGMode.STEREO;
	    /**
	     * force M/S mode. requires mode=1
	     */
	    this.force_ms = false;
	    /**
	     * use free format? default=0
	     */
	    this.free_format = false;
	    /**
	     * find the RG value? default=0
	     */
	    this.findReplayGain = false;
	    /**
	     * decode on the fly? default=0
	     */
	    this.decode_on_the_fly = false;
	    /**
	     * 1 (default) writes ID3 tags, 0 not
	     */
	    this.write_id3tag_automatic = false;
	
	    /*
	     * set either brate>0 or compression_ratio>0, LAME will compute the value of
	     * the variable not set. Default is compression_ratio = 11.025
	     */
	    /**
	     * bitrate
	     */
	    this.brate = 0;
	    /**
	     * sizeof(wav file)/sizeof(mp3 file)
	     */
	    this.compression_ratio = 0.;
	
	    /* frame params */
	    /**
	     * mark as copyright. default=0
	     */
	    this.copyright = 0;
	    /**
	     * mark as original. default=1
	     */
	    this.original = 0;
	    /**
	     * the MP3 'private extension' bit. Meaningless
	     */
	    this.extension = 0;
	    /**
	     * Input PCM is emphased PCM (for instance from one of the rarely emphased
	     * CDs), it is STRONGLY not recommended to use this, because psycho does not
	     * take it into account, and last but not least many decoders don't care
	     * about these bits
	     */
	    this.emphasis = 0;
	    /**
	     * use 2 bytes per frame for a CRC checksum. default=0
	     */
	    this.error_protection = 0;
	    /**
	     * enforce ISO spec as much as possible
	     */
	    this.strict_ISO = false;
	
	    /**
	     * use bit reservoir?
	     */
	    this.disable_reservoir = false;
	
	    /* quantization/noise shaping */
	    this.quant_comp = 0;
	    this.quant_comp_short = 0;
	    this.experimentalY = false;
	    this.experimentalZ = 0;
	    this.exp_nspsytune = 0;
	
	    this.preset = 0;
	
	    /* VBR control */
	    this.VBR = null;
	    /**
	     * Range [0,...,1[
	     */
	    this.VBR_q_frac = 0.;
	    /**
	     * Range [0,...,9]
	     */
	    this.VBR_q = 0;
	    this.VBR_mean_bitrate_kbps = 0;
	    this.VBR_min_bitrate_kbps = 0;
	    this.VBR_max_bitrate_kbps = 0;
	    /**
	     * strictly enforce VBR_min_bitrate normaly, it will be violated for analog
	     * silence
	     */
	    this.VBR_hard_min = 0;
	
	    /* resampling and filtering */
	
	    /**
	     * freq in Hz. 0=lame choses. -1=no filter
	     */
	    this.lowpassfreq = 0;
	    /**
	     * freq in Hz. 0=lame choses. -1=no filter
	     */
	    this.highpassfreq = 0;
	    /**
	     * freq width of filter, in Hz (default=15%)
	     */
	    this.lowpasswidth = 0;
	    /**
	     * freq width of filter, in Hz (default=15%)
	     */
	    this.highpasswidth = 0;
	
	    /*
	     * psycho acoustics and other arguments which you should not change unless
	     * you know what you are doing
	     */
	
	    this.maskingadjust = 0.;
	    this.maskingadjust_short = 0.;
	    /**
	     * only use ATH
	     */
	    this.ATHonly = false;
	    /**
	     * only use ATH for short blocks
	     */
	    this.ATHshort = false;
	    /**
	     * disable ATH
	     */
	    this.noATH = false;
	    /**
	     * select ATH formula
	     */
	    this.ATHtype = 0;
	    /**
	     * change ATH formula 4 shape
	     */
	    this.ATHcurve = 0.;
	    /**
	     * lower ATH by this many db
	     */
	    this.ATHlower = 0.;
	    /**
	     * select ATH auto-adjust scheme
	     */
	    this.athaa_type = 0;
	    /**
	     * select ATH auto-adjust loudness calc
	     */
	    this.athaa_loudapprox = 0;
	    /**
	     * dB, tune active region of auto-level
	     */
	    this.athaa_sensitivity = 0.;
	    this.short_blocks = null;
	    /**
	     * use temporal masking effect
	     */
	    this.useTemporal = false;
	    this.interChRatio = 0.;
	    /**
	     * Naoki's adjustment of Mid/Side maskings
	     */
	    this.msfix = 0.;
	
	    /**
	     * 0 off, 1 on
	     */
	    this.tune = false;
	    /**
	     * used to pass values for debugging and stuff
	     */
	    this.tune_value_a = 0.;
	
	    /************************************************************************/
	    /* internal variables, do not set... */
	    /* provided because they may be of use to calling application */
	    /************************************************************************/
	
	    /**
	     * 0=MPEG-2/2.5 1=MPEG-1
	     */
	    this.version = 0;
	    this.encoder_delay = 0;
	    /**
	     * number of samples of padding appended to input
	     */
	    this.encoder_padding = 0;
	    this.framesize = 0;
	    /**
	     * number of frames encoded
	     */
	    this.frameNum = 0;
	    /**
	     * is this struct owned by calling program or lame?
	     */
	    this.lame_allocated_gfp = 0;
	    /**************************************************************************/
	    /* more internal variables are stored in this structure: */
	    /**************************************************************************/
	    this.internal_flags = null;
	}
	
	module.exports = LameGlobalFlags;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *      MP3 window subband -> subband filtering -> mdct routine
	 *
	 *      Copyright (c) 1999-2000 Takehiro Tominaga
	 *
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Library General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	/*
	 *         Special Thanks to Patrick De Smet for your advices.
	 */
	
	/* $Id: NewMDCT.java,v 1.11 2011/05/24 20:48:06 kenchis Exp $ */
	
	//package mp3;
	
	//import java.util.Arrays;
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	
	
	function NewMDCT() {
	
		var enwindow = [
				-4.77e-07 * 0.740951125354959 / 2.384e-06,
				1.03951e-04 * 0.740951125354959 / 2.384e-06,
				9.53674e-04 * 0.740951125354959 / 2.384e-06,
				2.841473e-03 * 0.740951125354959 / 2.384e-06,
				3.5758972e-02 * 0.740951125354959 / 2.384e-06,
				3.401756e-03 * 0.740951125354959 / 2.384e-06,
				9.83715e-04 * 0.740951125354959 / 2.384e-06,
				9.9182e-05 * 0.740951125354959 / 2.384e-06, /* 15 */
				1.2398e-05 * 0.740951125354959 / 2.384e-06,
				1.91212e-04 * 0.740951125354959 / 2.384e-06,
				2.283096e-03 * 0.740951125354959 / 2.384e-06,
				1.6994476e-02 * 0.740951125354959 / 2.384e-06,
				-1.8756866e-02 * 0.740951125354959 / 2.384e-06,
				-2.630711e-03 * 0.740951125354959 / 2.384e-06,
				-2.47478e-04 * 0.740951125354959 / 2.384e-06,
				-1.4782e-05 * 0.740951125354959 / 2.384e-06,
				9.063471690191471e-01, 1.960342806591213e-01,
	
				-4.77e-07 * 0.773010453362737 / 2.384e-06,
				1.05858e-04 * 0.773010453362737 / 2.384e-06,
				9.30786e-04 * 0.773010453362737 / 2.384e-06,
				2.521515e-03 * 0.773010453362737 / 2.384e-06,
				3.5694122e-02 * 0.773010453362737 / 2.384e-06,
				3.643036e-03 * 0.773010453362737 / 2.384e-06,
				9.91821e-04 * 0.773010453362737 / 2.384e-06,
				9.6321e-05 * 0.773010453362737 / 2.384e-06, /* 14 */
				1.1444e-05 * 0.773010453362737 / 2.384e-06,
				1.65462e-04 * 0.773010453362737 / 2.384e-06,
				2.110004e-03 * 0.773010453362737 / 2.384e-06,
				1.6112804e-02 * 0.773010453362737 / 2.384e-06,
				-1.9634247e-02 * 0.773010453362737 / 2.384e-06,
				-2.803326e-03 * 0.773010453362737 / 2.384e-06,
				-2.77042e-04 * 0.773010453362737 / 2.384e-06,
				-1.6689e-05 * 0.773010453362737 / 2.384e-06,
				8.206787908286602e-01, 3.901806440322567e-01,
	
				-4.77e-07 * 0.803207531480645 / 2.384e-06,
				1.07288e-04 * 0.803207531480645 / 2.384e-06,
				9.02653e-04 * 0.803207531480645 / 2.384e-06,
				2.174854e-03 * 0.803207531480645 / 2.384e-06,
				3.5586357e-02 * 0.803207531480645 / 2.384e-06,
				3.858566e-03 * 0.803207531480645 / 2.384e-06,
				9.95159e-04 * 0.803207531480645 / 2.384e-06,
				9.3460e-05 * 0.803207531480645 / 2.384e-06, /* 13 */
				1.0014e-05 * 0.803207531480645 / 2.384e-06,
				1.40190e-04 * 0.803207531480645 / 2.384e-06,
				1.937389e-03 * 0.803207531480645 / 2.384e-06,
				1.5233517e-02 * 0.803207531480645 / 2.384e-06,
				-2.0506859e-02 * 0.803207531480645 / 2.384e-06,
				-2.974033e-03 * 0.803207531480645 / 2.384e-06,
				-3.07560e-04 * 0.803207531480645 / 2.384e-06,
				-1.8120e-05 * 0.803207531480645 / 2.384e-06,
				7.416505462720353e-01, 5.805693545089249e-01,
	
				-4.77e-07 * 0.831469612302545 / 2.384e-06,
				1.08242e-04 * 0.831469612302545 / 2.384e-06,
				8.68797e-04 * 0.831469612302545 / 2.384e-06,
				1.800537e-03 * 0.831469612302545 / 2.384e-06,
				3.5435200e-02 * 0.831469612302545 / 2.384e-06,
				4.049301e-03 * 0.831469612302545 / 2.384e-06,
				9.94205e-04 * 0.831469612302545 / 2.384e-06,
				9.0599e-05 * 0.831469612302545 / 2.384e-06, /* 12 */
				9.060e-06 * 0.831469612302545 / 2.384e-06,
				1.16348e-04 * 0.831469612302545 / 2.384e-06,
				1.766682e-03 * 0.831469612302545 / 2.384e-06,
				1.4358521e-02 * 0.831469612302545 / 2.384e-06,
				-2.1372318e-02 * 0.831469612302545 / 2.384e-06,
				-3.14188e-03 * 0.831469612302545 / 2.384e-06,
				-3.39031e-04 * 0.831469612302545 / 2.384e-06,
				-1.9550e-05 * 0.831469612302545 / 2.384e-06,
				6.681786379192989e-01, 7.653668647301797e-01,
	
				-4.77e-07 * 0.857728610000272 / 2.384e-06,
				1.08719e-04 * 0.857728610000272 / 2.384e-06,
				8.29220e-04 * 0.857728610000272 / 2.384e-06,
				1.399517e-03 * 0.857728610000272 / 2.384e-06,
				3.5242081e-02 * 0.857728610000272 / 2.384e-06,
				4.215240e-03 * 0.857728610000272 / 2.384e-06,
				9.89437e-04 * 0.857728610000272 / 2.384e-06,
				8.7261e-05 * 0.857728610000272 / 2.384e-06, /* 11 */
				8.106e-06 * 0.857728610000272 / 2.384e-06,
				9.3937e-05 * 0.857728610000272 / 2.384e-06,
				1.597881e-03 * 0.857728610000272 / 2.384e-06,
				1.3489246e-02 * 0.857728610000272 / 2.384e-06,
				-2.2228718e-02 * 0.857728610000272 / 2.384e-06,
				-3.306866e-03 * 0.857728610000272 / 2.384e-06,
				-3.71456e-04 * 0.857728610000272 / 2.384e-06,
				-2.1458e-05 * 0.857728610000272 / 2.384e-06,
				5.993769336819237e-01, 9.427934736519954e-01,
	
				-4.77e-07 * 0.881921264348355 / 2.384e-06,
				1.08719e-04 * 0.881921264348355 / 2.384e-06,
				7.8392e-04 * 0.881921264348355 / 2.384e-06,
				9.71317e-04 * 0.881921264348355 / 2.384e-06,
				3.5007000e-02 * 0.881921264348355 / 2.384e-06,
				4.357815e-03 * 0.881921264348355 / 2.384e-06,
				9.80854e-04 * 0.881921264348355 / 2.384e-06,
				8.3923e-05 * 0.881921264348355 / 2.384e-06, /* 10 */
				7.629e-06 * 0.881921264348355 / 2.384e-06,
				7.2956e-05 * 0.881921264348355 / 2.384e-06,
				1.432419e-03 * 0.881921264348355 / 2.384e-06,
				1.2627602e-02 * 0.881921264348355 / 2.384e-06,
				-2.3074150e-02 * 0.881921264348355 / 2.384e-06,
				-3.467083e-03 * 0.881921264348355 / 2.384e-06,
				-4.04358e-04 * 0.881921264348355 / 2.384e-06,
				-2.3365e-05 * 0.881921264348355 / 2.384e-06,
				5.345111359507916e-01, 1.111140466039205e+00,
	
				-9.54e-07 * 0.903989293123443 / 2.384e-06,
				1.08242e-04 * 0.903989293123443 / 2.384e-06,
				7.31945e-04 * 0.903989293123443 / 2.384e-06,
				5.15938e-04 * 0.903989293123443 / 2.384e-06,
				3.4730434e-02 * 0.903989293123443 / 2.384e-06,
				4.477024e-03 * 0.903989293123443 / 2.384e-06,
				9.68933e-04 * 0.903989293123443 / 2.384e-06,
				8.0585e-05 * 0.903989293123443 / 2.384e-06, /* 9 */
				6.676e-06 * 0.903989293123443 / 2.384e-06,
				5.2929e-05 * 0.903989293123443 / 2.384e-06,
				1.269817e-03 * 0.903989293123443 / 2.384e-06,
				1.1775017e-02 * 0.903989293123443 / 2.384e-06,
				-2.3907185e-02 * 0.903989293123443 / 2.384e-06,
				-3.622532e-03 * 0.903989293123443 / 2.384e-06,
				-4.38213e-04 * 0.903989293123443 / 2.384e-06,
				-2.5272e-05 * 0.903989293123443 / 2.384e-06,
				4.729647758913199e-01, 1.268786568327291e+00,
	
				-9.54e-07 * 0.92387953251128675613 / 2.384e-06,
				1.06812e-04 * 0.92387953251128675613 / 2.384e-06,
				6.74248e-04 * 0.92387953251128675613 / 2.384e-06,
				3.3379e-05 * 0.92387953251128675613 / 2.384e-06,
				3.4412861e-02 * 0.92387953251128675613 / 2.384e-06,
				4.573822e-03 * 0.92387953251128675613 / 2.384e-06,
				9.54151e-04 * 0.92387953251128675613 / 2.384e-06,
				7.6771e-05 * 0.92387953251128675613 / 2.384e-06,
				6.199e-06 * 0.92387953251128675613 / 2.384e-06,
				3.4332e-05 * 0.92387953251128675613 / 2.384e-06,
				1.111031e-03 * 0.92387953251128675613 / 2.384e-06,
				1.0933399e-02 * 0.92387953251128675613 / 2.384e-06,
				-2.4725437e-02 * 0.92387953251128675613 / 2.384e-06,
				-3.771782e-03 * 0.92387953251128675613 / 2.384e-06,
				-4.72546e-04 * 0.92387953251128675613 / 2.384e-06,
				-2.7657e-05 * 0.92387953251128675613 / 2.384e-06,
				4.1421356237309504879e-01, /* tan(PI/8) */
				1.414213562373095e+00,
	
				-9.54e-07 * 0.941544065183021 / 2.384e-06,
				1.05381e-04 * 0.941544065183021 / 2.384e-06,
				6.10352e-04 * 0.941544065183021 / 2.384e-06,
				-4.75883e-04 * 0.941544065183021 / 2.384e-06,
				3.4055710e-02 * 0.941544065183021 / 2.384e-06,
				4.649162e-03 * 0.941544065183021 / 2.384e-06,
				9.35555e-04 * 0.941544065183021 / 2.384e-06,
				7.3433e-05 * 0.941544065183021 / 2.384e-06, /* 7 */
				5.245e-06 * 0.941544065183021 / 2.384e-06,
				1.7166e-05 * 0.941544065183021 / 2.384e-06,
				9.56535e-04 * 0.941544065183021 / 2.384e-06,
				1.0103703e-02 * 0.941544065183021 / 2.384e-06,
				-2.5527000e-02 * 0.941544065183021 / 2.384e-06,
				-3.914356e-03 * 0.941544065183021 / 2.384e-06,
				-5.07355e-04 * 0.941544065183021 / 2.384e-06,
				-3.0041e-05 * 0.941544065183021 / 2.384e-06,
				3.578057213145241e-01, 1.546020906725474e+00,
	
				-9.54e-07 * 0.956940335732209 / 2.384e-06,
				1.02520e-04 * 0.956940335732209 / 2.384e-06,
				5.39303e-04 * 0.956940335732209 / 2.384e-06,
				-1.011848e-03 * 0.956940335732209 / 2.384e-06,
				3.3659935e-02 * 0.956940335732209 / 2.384e-06,
				4.703045e-03 * 0.956940335732209 / 2.384e-06,
				9.15051e-04 * 0.956940335732209 / 2.384e-06,
				7.0095e-05 * 0.956940335732209 / 2.384e-06, /* 6 */
				4.768e-06 * 0.956940335732209 / 2.384e-06,
				9.54e-07 * 0.956940335732209 / 2.384e-06,
				8.06808e-04 * 0.956940335732209 / 2.384e-06,
				9.287834e-03 * 0.956940335732209 / 2.384e-06,
				-2.6310921e-02 * 0.956940335732209 / 2.384e-06,
				-4.048824e-03 * 0.956940335732209 / 2.384e-06,
				-5.42164e-04 * 0.956940335732209 / 2.384e-06,
				-3.2425e-05 * 0.956940335732209 / 2.384e-06,
				3.033466836073424e-01, 1.662939224605090e+00,
	
				-1.431e-06 * 0.970031253194544 / 2.384e-06,
				9.9182e-05 * 0.970031253194544 / 2.384e-06,
				4.62532e-04 * 0.970031253194544 / 2.384e-06,
				-1.573563e-03 * 0.970031253194544 / 2.384e-06,
				3.3225536e-02 * 0.970031253194544 / 2.384e-06,
				4.737377e-03 * 0.970031253194544 / 2.384e-06,
				8.91685e-04 * 0.970031253194544 / 2.384e-06,
				6.6280e-05 * 0.970031253194544 / 2.384e-06, /* 5 */
				4.292e-06 * 0.970031253194544 / 2.384e-06,
				-1.3828e-05 * 0.970031253194544 / 2.384e-06,
				6.61850e-04 * 0.970031253194544 / 2.384e-06,
				8.487225e-03 * 0.970031253194544 / 2.384e-06,
				-2.7073860e-02 * 0.970031253194544 / 2.384e-06,
				-4.174709e-03 * 0.970031253194544 / 2.384e-06,
				-5.76973e-04 * 0.970031253194544 / 2.384e-06,
				-3.4809e-05 * 0.970031253194544 / 2.384e-06,
				2.504869601913055e-01, 1.763842528696710e+00,
	
				-1.431e-06 * 0.98078528040323 / 2.384e-06,
				9.5367e-05 * 0.98078528040323 / 2.384e-06,
				3.78609e-04 * 0.98078528040323 / 2.384e-06,
				-2.161503e-03 * 0.98078528040323 / 2.384e-06,
				3.2754898e-02 * 0.98078528040323 / 2.384e-06,
				4.752159e-03 * 0.98078528040323 / 2.384e-06,
				8.66413e-04 * 0.98078528040323 / 2.384e-06,
				6.2943e-05 * 0.98078528040323 / 2.384e-06, /* 4 */
				3.815e-06 * 0.98078528040323 / 2.384e-06,
				-2.718e-05 * 0.98078528040323 / 2.384e-06,
				5.22137e-04 * 0.98078528040323 / 2.384e-06,
				7.703304e-03 * 0.98078528040323 / 2.384e-06,
				-2.7815342e-02 * 0.98078528040323 / 2.384e-06,
				-4.290581e-03 * 0.98078528040323 / 2.384e-06,
				-6.11782e-04 * 0.98078528040323 / 2.384e-06,
				-3.7670e-05 * 0.98078528040323 / 2.384e-06,
				1.989123673796580e-01, 1.847759065022573e+00,
	
				-1.907e-06 * 0.989176509964781 / 2.384e-06,
				9.0122e-05 * 0.989176509964781 / 2.384e-06,
				2.88486e-04 * 0.989176509964781 / 2.384e-06,
				-2.774239e-03 * 0.989176509964781 / 2.384e-06,
				3.2248020e-02 * 0.989176509964781 / 2.384e-06,
				4.748821e-03 * 0.989176509964781 / 2.384e-06,
				8.38757e-04 * 0.989176509964781 / 2.384e-06,
				5.9605e-05 * 0.989176509964781 / 2.384e-06, /* 3 */
				3.338e-06 * 0.989176509964781 / 2.384e-06,
				-3.9577e-05 * 0.989176509964781 / 2.384e-06,
				3.88145e-04 * 0.989176509964781 / 2.384e-06,
				6.937027e-03 * 0.989176509964781 / 2.384e-06,
				-2.8532982e-02 * 0.989176509964781 / 2.384e-06,
				-4.395962e-03 * 0.989176509964781 / 2.384e-06,
				-6.46591e-04 * 0.989176509964781 / 2.384e-06,
				-4.0531e-05 * 0.989176509964781 / 2.384e-06,
				1.483359875383474e-01, 1.913880671464418e+00,
	
				-1.907e-06 * 0.995184726672197 / 2.384e-06,
				8.4400e-05 * 0.995184726672197 / 2.384e-06,
				1.91689e-04 * 0.995184726672197 / 2.384e-06,
				-3.411293e-03 * 0.995184726672197 / 2.384e-06,
				3.1706810e-02 * 0.995184726672197 / 2.384e-06,
				4.728317e-03 * 0.995184726672197 / 2.384e-06,
				8.09669e-04 * 0.995184726672197 / 2.384e-06,
				5.579e-05 * 0.995184726672197 / 2.384e-06,
				3.338e-06 * 0.995184726672197 / 2.384e-06,
				-5.0545e-05 * 0.995184726672197 / 2.384e-06,
				2.59876e-04 * 0.995184726672197 / 2.384e-06,
				6.189346e-03 * 0.995184726672197 / 2.384e-06,
				-2.9224873e-02 * 0.995184726672197 / 2.384e-06,
				-4.489899e-03 * 0.995184726672197 / 2.384e-06,
				-6.80923e-04 * 0.995184726672197 / 2.384e-06,
				-4.3392e-05 * 0.995184726672197 / 2.384e-06,
				9.849140335716425e-02, 1.961570560806461e+00,
	
				-2.384e-06 * 0.998795456205172 / 2.384e-06,
				7.7724e-05 * 0.998795456205172 / 2.384e-06,
				8.8215e-05 * 0.998795456205172 / 2.384e-06,
				-4.072189e-03 * 0.998795456205172 / 2.384e-06,
				3.1132698e-02 * 0.998795456205172 / 2.384e-06,
				4.691124e-03 * 0.998795456205172 / 2.384e-06,
				7.79152e-04 * 0.998795456205172 / 2.384e-06,
				5.2929e-05 * 0.998795456205172 / 2.384e-06,
				2.861e-06 * 0.998795456205172 / 2.384e-06,
				-6.0558e-05 * 0.998795456205172 / 2.384e-06,
				1.37329e-04 * 0.998795456205172 / 2.384e-06,
				5.462170e-03 * 0.998795456205172 / 2.384e-06,
				-2.9890060e-02 * 0.998795456205172 / 2.384e-06,
				-4.570484e-03 * 0.998795456205172 / 2.384e-06,
				-7.14302e-04 * 0.998795456205172 / 2.384e-06,
				-4.6253e-05 * 0.998795456205172 / 2.384e-06,
				4.912684976946725e-02, 1.990369453344394e+00,
	
				3.5780907e-02 * Util.SQRT2 * 0.5 / 2.384e-06,
				1.7876148e-02 * Util.SQRT2 * 0.5 / 2.384e-06,
				3.134727e-03 * Util.SQRT2 * 0.5 / 2.384e-06,
				2.457142e-03 * Util.SQRT2 * 0.5 / 2.384e-06,
				9.71317e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
				2.18868e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
				1.01566e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
				1.3828e-05 * Util.SQRT2 * 0.5 / 2.384e-06,
	
				3.0526638e-02 / 2.384e-06, 4.638195e-03 / 2.384e-06,
				7.47204e-04 / 2.384e-06, 4.9591e-05 / 2.384e-06,
				4.756451e-03 / 2.384e-06, 2.1458e-05 / 2.384e-06,
				-6.9618e-05 / 2.384e-06, /* 2.384e-06/2.384e-06 */
		];
	
		var NS = 12;
		var NL = 36;
	
		var win = [
		    [
		     2.382191739347913e-13,
		     6.423305872147834e-13,
		     9.400849094049688e-13,
		     1.122435026096556e-12,
		     1.183840321267481e-12,
		     1.122435026096556e-12,
		     9.400849094049690e-13,
		     6.423305872147839e-13,
		     2.382191739347918e-13,
	
		     5.456116108943412e-12,
		     4.878985199565852e-12,
		     4.240448995017367e-12,
		     3.559909094758252e-12,
		     2.858043359288075e-12,
		     2.156177623817898e-12,
		     1.475637723558783e-12,
		     8.371015190102974e-13,
		     2.599706096327376e-13,
	
		     -5.456116108943412e-12,
		     -4.878985199565852e-12,
		     -4.240448995017367e-12,
		     -3.559909094758252e-12,
		     -2.858043359288076e-12,
		     -2.156177623817898e-12,
		     -1.475637723558783e-12,
		     -8.371015190102975e-13,
		     -2.599706096327376e-13,
	
		     -2.382191739347923e-13,
		     -6.423305872147843e-13,
		     -9.400849094049696e-13,
		     -1.122435026096556e-12,
		     -1.183840321267481e-12,
		     -1.122435026096556e-12,
		     -9.400849094049694e-13,
		     -6.423305872147840e-13,
		     -2.382191739347918e-13,
		     ],
		    [
		     2.382191739347913e-13,
		     6.423305872147834e-13,
		     9.400849094049688e-13,
		     1.122435026096556e-12,
		     1.183840321267481e-12,
		     1.122435026096556e-12,
		     9.400849094049688e-13,
		     6.423305872147841e-13,
		     2.382191739347918e-13,
	
		     5.456116108943413e-12,
		     4.878985199565852e-12,
		     4.240448995017367e-12,
		     3.559909094758253e-12,
		     2.858043359288075e-12,
		     2.156177623817898e-12,
		     1.475637723558782e-12,
		     8.371015190102975e-13,
		     2.599706096327376e-13,
	
		     -5.461314069809755e-12,
		     -4.921085770524055e-12,
		     -4.343405037091838e-12,
		     -3.732668368707687e-12,
		     -3.093523840190885e-12,
		     -2.430835727329465e-12,
		     -1.734679010007751e-12,
		     -9.748253656609281e-13,
		     -2.797435120168326e-13,
	
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     -2.283748241799531e-13,
		     -4.037858874020686e-13,
		     -2.146547464825323e-13,
		     ],
		    [
		     1.316524975873958e-01, /* win[SHORT_TYPE] */
		     4.142135623730950e-01,
		     7.673269879789602e-01,
	
		     1.091308501069271e+00, /* tantab_l */
		     1.303225372841206e+00,
		     1.569685577117490e+00,
		     1.920982126971166e+00,
		     2.414213562373094e+00,
		     3.171594802363212e+00,
		     4.510708503662055e+00,
		     7.595754112725146e+00,
		     2.290376554843115e+01,
	
		     0.98480775301220802032, /* cx */
		     0.64278760968653936292,
		     0.34202014332566882393,
		     0.93969262078590842791,
		     -0.17364817766693030343,
		     -0.76604444311897790243,
		     0.86602540378443870761,
		     0.500000000000000e+00,
	
		     -5.144957554275265e-01, /* ca */
		     -4.717319685649723e-01,
		     -3.133774542039019e-01,
		     -1.819131996109812e-01,
		     -9.457419252642064e-02,
		     -4.096558288530405e-02,
		     -1.419856857247115e-02,
		     -3.699974673760037e-03,
	
		     8.574929257125442e-01, /* cs */
		     8.817419973177052e-01,
		     9.496286491027329e-01,
		     9.833145924917901e-01,
		     9.955178160675857e-01,
		     9.991605581781475e-01,
		     9.998991952444470e-01,
		     9.999931550702802e-01,
		     ],
		    [
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     0.000000000000000e+00,
		     2.283748241799531e-13,
		     4.037858874020686e-13,
		     2.146547464825323e-13,
	
		     5.461314069809755e-12,
		     4.921085770524055e-12,
		     4.343405037091838e-12,
		     3.732668368707687e-12,
		     3.093523840190885e-12,
		     2.430835727329466e-12,
		     1.734679010007751e-12,
		     9.748253656609281e-13,
		     2.797435120168326e-13,
	
		     -5.456116108943413e-12,
		     -4.878985199565852e-12,
		     -4.240448995017367e-12,
		     -3.559909094758253e-12,
		     -2.858043359288075e-12,
		     -2.156177623817898e-12,
		     -1.475637723558782e-12,
		     -8.371015190102975e-13,
		     -2.599706096327376e-13,
	
		     -2.382191739347913e-13,
		     -6.423305872147834e-13,
		     -9.400849094049688e-13,
		     -1.122435026096556e-12,
		     -1.183840321267481e-12,
		     -1.122435026096556e-12,
		     -9.400849094049688e-13,
		     -6.423305872147841e-13,
		     -2.382191739347918e-13,
		     ]
		];
	
		var tantab_l = win[Encoder.SHORT_TYPE];
		var cx = win[Encoder.SHORT_TYPE];
		var ca = win[Encoder.SHORT_TYPE];
		var cs = win[Encoder.SHORT_TYPE];
	
		/**
		 * new IDCT routine written by Takehiro TOMINAGA
		 *
		 * PURPOSE: Overlapping window on PCM samples<BR>
		 *
		 * SEMANTICS:<BR>
		 * 32 16-bit pcm samples are scaled to fractional 2's complement and
		 * concatenated to the end of the window buffer #x#. The updated window
		 * buffer #x# is then windowed by the analysis window #c# to produce the
		 * windowed sample #z#
		 */
		var order = [
		    0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29,
		    2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31
		];
	
		/**
		 * returns sum_j=0^31 a[j]*cos(PI*j*(k+1/2)/32), 0<=k<32
		 */
		function window_subband(x1, x1Pos, a) {
			var wp = 10;
	
			var x2 = x1Pos + 238 - 14 - 286;
	
			for (var i = -15; i < 0; i++) {
				var w, s, t;
	
				w = enwindow[wp + -10];
				s = x1[x2 + -224] * w;
				t = x1[x1Pos + 224] * w;
				w = enwindow[wp + -9];
				s += x1[x2 + -160] * w;
				t += x1[x1Pos + 160] * w;
				w = enwindow[wp + -8];
				s += x1[x2 + -96] * w;
				t += x1[x1Pos + 96] * w;
				w = enwindow[wp + -7];
				s += x1[x2 + -32] * w;
				t += x1[x1Pos + 32] * w;
				w = enwindow[wp + -6];
				s += x1[x2 + 32] * w;
				t += x1[x1Pos + -32] * w;
				w = enwindow[wp + -5];
				s += x1[x2 + 96] * w;
				t += x1[x1Pos + -96] * w;
				w = enwindow[wp + -4];
				s += x1[x2 + 160] * w;
				t += x1[x1Pos + -160] * w;
				w = enwindow[wp + -3];
				s += x1[x2 + 224] * w;
				t += x1[x1Pos + -224] * w;
	
				w = enwindow[wp + -2];
				s += x1[x1Pos + -256] * w;
				t -= x1[x2 + 256] * w;
				w = enwindow[wp + -1];
				s += x1[x1Pos + -192] * w;
				t -= x1[x2 + 192] * w;
				w = enwindow[wp + 0];
				s += x1[x1Pos + -128] * w;
				t -= x1[x2 + 128] * w;
				w = enwindow[wp + 1];
				s += x1[x1Pos + -64] * w;
				t -= x1[x2 + 64] * w;
				w = enwindow[wp + 2];
				s += x1[x1Pos + 0] * w;
				t -= x1[x2 + 0] * w;
				w = enwindow[wp + 3];
				s += x1[x1Pos + 64] * w;
				t -= x1[x2 + -64] * w;
				w = enwindow[wp + 4];
				s += x1[x1Pos + 128] * w;
				t -= x1[x2 + -128] * w;
				w = enwindow[wp + 5];
				s += x1[x1Pos + 192] * w;
				t -= x1[x2 + -192] * w;
	
				/*
				 * this multiplyer could be removed, but it needs more 256 FLOAT
				 * data. thinking about the data cache performance, I think we
				 * should not use such a huge table. tt 2000/Oct/25
				 */
				s *= enwindow[wp + 6];
				w = t - s;
				a[30 + i * 2] = t + s;
				a[31 + i * 2] = enwindow[wp + 7] * w;
				wp += 18;
				x1Pos--;
				x2++;
			}
			{
				var s, t, u, v;
				t = x1[x1Pos + -16] * enwindow[wp + -10];
				s = x1[x1Pos + -32] * enwindow[wp + -2];
				t += (x1[x1Pos + -48] - x1[x1Pos + 16]) * enwindow[wp + -9];
				s += x1[x1Pos + -96] * enwindow[wp + -1];
				t += (x1[x1Pos + -80] + x1[x1Pos + 48]) * enwindow[wp + -8];
				s += x1[x1Pos + -160] * enwindow[wp + 0];
				t += (x1[x1Pos + -112] - x1[x1Pos + 80]) * enwindow[wp + -7];
				s += x1[x1Pos + -224] * enwindow[wp + 1];
				t += (x1[x1Pos + -144] + x1[x1Pos + 112]) * enwindow[wp + -6];
				s -= x1[x1Pos + 32] * enwindow[wp + 2];
				t += (x1[x1Pos + -176] - x1[x1Pos + 144]) * enwindow[wp + -5];
				s -= x1[x1Pos + 96] * enwindow[wp + 3];
				t += (x1[x1Pos + -208] + x1[x1Pos + 176]) * enwindow[wp + -4];
				s -= x1[x1Pos + 160] * enwindow[wp + 4];
				t += (x1[x1Pos + -240] - x1[x1Pos + 208]) * enwindow[wp + -3];
				s -= x1[x1Pos + 224];
	
				u = s - t;
				v = s + t;
	
				t = a[14];
				s = a[15] - t;
	
				a[31] = v + t; /* A0 */
				a[30] = u + s; /* A1 */
				a[15] = u - s; /* A2 */
				a[14] = v - t; /* A3 */
			}
			{
				var xr;
				xr = a[28] - a[0];
				a[0] += a[28];
				a[28] = xr * enwindow[wp + -2 * 18 + 7];
				xr = a[29] - a[1];
				a[1] += a[29];
				a[29] = xr * enwindow[wp + -2 * 18 + 7];
	
				xr = a[26] - a[2];
				a[2] += a[26];
				a[26] = xr * enwindow[wp + -4 * 18 + 7];
				xr = a[27] - a[3];
				a[3] += a[27];
				a[27] = xr * enwindow[wp + -4 * 18 + 7];
	
				xr = a[24] - a[4];
				a[4] += a[24];
				a[24] = xr * enwindow[wp + -6 * 18 + 7];
				xr = a[25] - a[5];
				a[5] += a[25];
				a[25] = xr * enwindow[wp + -6 * 18 + 7];
	
				xr = a[22] - a[6];
				a[6] += a[22];
				a[22] = xr * Util.SQRT2;
				xr = a[23] - a[7];
				a[7] += a[23];
				a[23] = xr * Util.SQRT2 - a[7];
				a[7] -= a[6];
				a[22] -= a[7];
				a[23] -= a[22];
	
				xr = a[6];
				a[6] = a[31] - xr;
				a[31] = a[31] + xr;
				xr = a[7];
				a[7] = a[30] - xr;
				a[30] = a[30] + xr;
				xr = a[22];
				a[22] = a[15] - xr;
				a[15] = a[15] + xr;
				xr = a[23];
				a[23] = a[14] - xr;
				a[14] = a[14] + xr;
	
				xr = a[20] - a[8];
				a[8] += a[20];
				a[20] = xr * enwindow[wp + -10 * 18 + 7];
				xr = a[21] - a[9];
				a[9] += a[21];
				a[21] = xr * enwindow[wp + -10 * 18 + 7];
	
				xr = a[18] - a[10];
				a[10] += a[18];
				a[18] = xr * enwindow[wp + -12 * 18 + 7];
				xr = a[19] - a[11];
				a[11] += a[19];
				a[19] = xr * enwindow[wp + -12 * 18 + 7];
	
				xr = a[16] - a[12];
				a[12] += a[16];
				a[16] = xr * enwindow[wp + -14 * 18 + 7];
				xr = a[17] - a[13];
				a[13] += a[17];
				a[17] = xr * enwindow[wp + -14 * 18 + 7];
	
				xr = -a[20] + a[24];
				a[20] += a[24];
				a[24] = xr * enwindow[wp + -12 * 18 + 7];
				xr = -a[21] + a[25];
				a[21] += a[25];
				a[25] = xr * enwindow[wp + -12 * 18 + 7];
	
				xr = a[4] - a[8];
				a[4] += a[8];
				a[8] = xr * enwindow[wp + -12 * 18 + 7];
				xr = a[5] - a[9];
				a[5] += a[9];
				a[9] = xr * enwindow[wp + -12 * 18 + 7];
	
				xr = a[0] - a[12];
				a[0] += a[12];
				a[12] = xr * enwindow[wp + -4 * 18 + 7];
				xr = a[1] - a[13];
				a[1] += a[13];
				a[13] = xr * enwindow[wp + -4 * 18 + 7];
				xr = a[16] - a[28];
				a[16] += a[28];
				a[28] = xr * enwindow[wp + -4 * 18 + 7];
				xr = -a[17] + a[29];
				a[17] += a[29];
				a[29] = xr * enwindow[wp + -4 * 18 + 7];
	
				xr = Util.SQRT2 * (a[2] - a[10]);
				a[2] += a[10];
				a[10] = xr;
				xr = Util.SQRT2 * (a[3] - a[11]);
				a[3] += a[11];
				a[11] = xr;
				xr = Util.SQRT2 * (-a[18] + a[26]);
				a[18] += a[26];
				a[26] = xr - a[18];
				xr = Util.SQRT2 * (-a[19] + a[27]);
				a[19] += a[27];
				a[27] = xr - a[19];
	
				xr = a[2];
				a[19] -= a[3];
				a[3] -= xr;
				a[2] = a[31] - xr;
				a[31] += xr;
				xr = a[3];
				a[11] -= a[19];
				a[18] -= xr;
				a[3] = a[30] - xr;
				a[30] += xr;
				xr = a[18];
				a[27] -= a[11];
				a[19] -= xr;
				a[18] = a[15] - xr;
				a[15] += xr;
	
				xr = a[19];
				a[10] -= xr;
				a[19] = a[14] - xr;
				a[14] += xr;
				xr = a[10];
				a[11] -= xr;
				a[10] = a[23] - xr;
				a[23] += xr;
				xr = a[11];
				a[26] -= xr;
				a[11] = a[22] - xr;
				a[22] += xr;
				xr = a[26];
				a[27] -= xr;
				a[26] = a[7] - xr;
				a[7] += xr;
	
				xr = a[27];
				a[27] = a[6] - xr;
				a[6] += xr;
	
				xr = Util.SQRT2 * (a[0] - a[4]);
				a[0] += a[4];
				a[4] = xr;
				xr = Util.SQRT2 * (a[1] - a[5]);
				a[1] += a[5];
				a[5] = xr;
				xr = Util.SQRT2 * (a[16] - a[20]);
				a[16] += a[20];
				a[20] = xr;
				xr = Util.SQRT2 * (a[17] - a[21]);
				a[17] += a[21];
				a[21] = xr;
	
				xr = -Util.SQRT2 * (a[8] - a[12]);
				a[8] += a[12];
				a[12] = xr - a[8];
				xr = -Util.SQRT2 * (a[9] - a[13]);
				a[9] += a[13];
				a[13] = xr - a[9];
				xr = -Util.SQRT2 * (a[25] - a[29]);
				a[25] += a[29];
				a[29] = xr - a[25];
				xr = -Util.SQRT2 * (a[24] + a[28]);
				a[24] -= a[28];
				a[28] = xr - a[24];
	
				xr = a[24] - a[16];
				a[24] = xr;
				xr = a[20] - xr;
				a[20] = xr;
				xr = a[28] - xr;
				a[28] = xr;
	
				xr = a[25] - a[17];
				a[25] = xr;
				xr = a[21] - xr;
				a[21] = xr;
				xr = a[29] - xr;
				a[29] = xr;
	
				xr = a[17] - a[1];
				a[17] = xr;
				xr = a[9] - xr;
				a[9] = xr;
				xr = a[25] - xr;
				a[25] = xr;
				xr = a[5] - xr;
				a[5] = xr;
				xr = a[21] - xr;
				a[21] = xr;
				xr = a[13] - xr;
				a[13] = xr;
				xr = a[29] - xr;
				a[29] = xr;
	
				xr = a[1] - a[0];
				a[1] = xr;
				xr = a[16] - xr;
				a[16] = xr;
				xr = a[17] - xr;
				a[17] = xr;
				xr = a[8] - xr;
				a[8] = xr;
				xr = a[9] - xr;
				a[9] = xr;
				xr = a[24] - xr;
				a[24] = xr;
				xr = a[25] - xr;
				a[25] = xr;
				xr = a[4] - xr;
				a[4] = xr;
				xr = a[5] - xr;
				a[5] = xr;
				xr = a[20] - xr;
				a[20] = xr;
				xr = a[21] - xr;
				a[21] = xr;
				xr = a[12] - xr;
				a[12] = xr;
				xr = a[13] - xr;
				a[13] = xr;
				xr = a[28] - xr;
				a[28] = xr;
				xr = a[29] - xr;
				a[29] = xr;
	
				xr = a[0];
				a[0] += a[31];
				a[31] -= xr;
				xr = a[1];
				a[1] += a[30];
				a[30] -= xr;
				xr = a[16];
				a[16] += a[15];
				a[15] -= xr;
				xr = a[17];
				a[17] += a[14];
				a[14] -= xr;
				xr = a[8];
				a[8] += a[23];
				a[23] -= xr;
				xr = a[9];
				a[9] += a[22];
				a[22] -= xr;
				xr = a[24];
				a[24] += a[7];
				a[7] -= xr;
				xr = a[25];
				a[25] += a[6];
				a[6] -= xr;
				xr = a[4];
				a[4] += a[27];
				a[27] -= xr;
				xr = a[5];
				a[5] += a[26];
				a[26] -= xr;
				xr = a[20];
				a[20] += a[11];
				a[11] -= xr;
				xr = a[21];
				a[21] += a[10];
				a[10] -= xr;
				xr = a[12];
				a[12] += a[19];
				a[19] -= xr;
				xr = a[13];
				a[13] += a[18];
				a[18] -= xr;
				xr = a[28];
				a[28] += a[3];
				a[3] -= xr;
				xr = a[29];
				a[29] += a[2];
				a[2] -= xr;
			}
		}
	
		/**
		 * Function: Calculation of the MDCT In the case of long blocks (type 0,1,3)
		 * there are 36 coefficents in the time domain and 18 in the frequency
		 * domain.<BR>
		 * In the case of short blocks (type 2) there are 3 transformations with
		 * short length. This leads to 12 coefficents in the time and 6 in the
		 * frequency domain. In this case the results are stored side by side in the
		 * vector out[].
		 *
		 * New layer3
		 */
		function mdct_short(inout, inoutPos) {
			for (var l = 0; l < 3; l++) {
				var tc0, tc1, tc2, ts0, ts1, ts2;
	
				ts0 = inout[inoutPos + 2 * 3] * win[Encoder.SHORT_TYPE][0]
						- inout[inoutPos + 5 * 3];
				tc0 = inout[inoutPos + 0 * 3] * win[Encoder.SHORT_TYPE][2]
						- inout[inoutPos + 3 * 3];
				tc1 = ts0 + tc0;
				tc2 = ts0 - tc0;
	
				ts0 = inout[inoutPos + 5 * 3] * win[Encoder.SHORT_TYPE][0]
						+ inout[inoutPos + 2 * 3];
				tc0 = inout[inoutPos + 3 * 3] * win[Encoder.SHORT_TYPE][2]
						+ inout[inoutPos + 0 * 3];
				ts1 = ts0 + tc0;
				ts2 = -ts0 + tc0;
	
				tc0 = (inout[inoutPos + 1 * 3] * win[Encoder.SHORT_TYPE][1] - inout[inoutPos + 4 * 3]) * 2.069978111953089e-11;
				/*
				 * tritab_s [ 1 ]
				 */
				ts0 = (inout[inoutPos + 4 * 3] * win[Encoder.SHORT_TYPE][1] + inout[inoutPos + 1 * 3]) * 2.069978111953089e-11;
				/*
				 * tritab_s [ 1 ]
				 */
				inout[inoutPos + 3 * 0] = tc1 * 1.907525191737280e-11 + tc0;
				/*
				 * tritab_s[ 2 ]
				 */
				inout[inoutPos + 3 * 5] = -ts1 * 1.907525191737280e-11 + ts0;
				/*
				 * tritab_s[0 ]
				 */
				tc2 = tc2 * 0.86602540378443870761 * 1.907525191737281e-11;
				/*
				 * tritab_s[ 2]
				 */
				ts1 = ts1 * 0.5 * 1.907525191737281e-11 + ts0;
				inout[inoutPos + 3 * 1] = tc2 - ts1;
				inout[inoutPos + 3 * 2] = tc2 + ts1;
	
				tc1 = tc1 * 0.5 * 1.907525191737281e-11 - tc0;
				ts2 = ts2 * 0.86602540378443870761 * 1.907525191737281e-11;
				/*
				 * tritab_s[ 0]
				 */
				inout[inoutPos + 3 * 3] = tc1 + ts2;
				inout[inoutPos + 3 * 4] = tc1 - ts2;
	
				inoutPos++;
			}
		}
	
		function mdct_long(out, outPos, _in) {
			var ct, st;
			{
				var tc1, tc2, tc3, tc4, ts5, ts6, ts7, ts8;
				/* 1,2, 5,6, 9,10, 13,14, 17 */
				tc1 = _in[17] - _in[9];
				tc3 = _in[15] - _in[11];
				tc4 = _in[14] - _in[12];
				ts5 = _in[0] + _in[8];
				ts6 = _in[1] + _in[7];
				ts7 = _in[2] + _in[6];
				ts8 = _in[3] + _in[5];
	
				out[outPos + 17] = (ts5 + ts7 - ts8) - (ts6 - _in[4]);
				st = (ts5 + ts7 - ts8) * cx[12 + 7] + (ts6 - _in[4]);
				ct = (tc1 - tc3 - tc4) * cx[12 + 6];
				out[outPos + 5] = ct + st;
				out[outPos + 6] = ct - st;
	
				tc2 = (_in[16] - _in[10]) * cx[12 + 6];
				ts6 = ts6 * cx[12 + 7] + _in[4];
				ct = tc1 * cx[12 + 0] + tc2 + tc3 * cx[12 + 1] + tc4 * cx[12 + 2];
				st = -ts5 * cx[12 + 4] + ts6 - ts7 * cx[12 + 5] + ts8 * cx[12 + 3];
				out[outPos + 1] = ct + st;
				out[outPos + 2] = ct - st;
	
				ct = tc1 * cx[12 + 1] - tc2 - tc3 * cx[12 + 2] + tc4 * cx[12 + 0];
				st = -ts5 * cx[12 + 5] + ts6 - ts7 * cx[12 + 3] + ts8 * cx[12 + 4];
				out[outPos + 9] = ct + st;
				out[outPos + 10] = ct - st;
	
				ct = tc1 * cx[12 + 2] - tc2 + tc3 * cx[12 + 0] - tc4 * cx[12 + 1];
				st = ts5 * cx[12 + 3] - ts6 + ts7 * cx[12 + 4] - ts8 * cx[12 + 5];
				out[outPos + 13] = ct + st;
				out[outPos + 14] = ct - st;
			}
			{
				var ts1, ts2, ts3, ts4, tc5, tc6, tc7, tc8;
	
				ts1 = _in[8] - _in[0];
				ts3 = _in[6] - _in[2];
				ts4 = _in[5] - _in[3];
				tc5 = _in[17] + _in[9];
				tc6 = _in[16] + _in[10];
				tc7 = _in[15] + _in[11];
				tc8 = _in[14] + _in[12];
	
				out[outPos + 0] = (tc5 + tc7 + tc8) + (tc6 + _in[13]);
				ct = (tc5 + tc7 + tc8) * cx[12 + 7] - (tc6 + _in[13]);
				st = (ts1 - ts3 + ts4) * cx[12 + 6];
				out[outPos + 11] = ct + st;
				out[outPos + 12] = ct - st;
	
				ts2 = (_in[7] - _in[1]) * cx[12 + 6];
				tc6 = _in[13] - tc6 * cx[12 + 7];
				ct = tc5 * cx[12 + 3] - tc6 + tc7 * cx[12 + 4] + tc8 * cx[12 + 5];
				st = ts1 * cx[12 + 2] + ts2 + ts3 * cx[12 + 0] + ts4 * cx[12 + 1];
				out[outPos + 3] = ct + st;
				out[outPos + 4] = ct - st;
	
				ct = -tc5 * cx[12 + 5] + tc6 - tc7 * cx[12 + 3] - tc8 * cx[12 + 4];
				st = ts1 * cx[12 + 1] + ts2 - ts3 * cx[12 + 2] - ts4 * cx[12 + 0];
				out[outPos + 7] = ct + st;
				out[outPos + 8] = ct - st;
	
				ct = -tc5 * cx[12 + 4] + tc6 - tc7 * cx[12 + 5] - tc8 * cx[12 + 3];
				st = ts1 * cx[12 + 0] - ts2 + ts3 * cx[12 + 1] - ts4 * cx[12 + 2];
				out[outPos + 15] = ct + st;
				out[outPos + 16] = ct - st;
			}
		}
	
		this.mdct_sub48 = function(gfc, w0, w1) {
			var wk = w0;
			var wkPos = 286;
			/* thinking cache performance, ch->gr loop is better than gr->ch loop */
			for (var ch = 0; ch < gfc.channels_out; ch++) {
				for (var gr = 0; gr < gfc.mode_gr; gr++) {
					var band;
					var gi = (gfc.l3_side.tt[gr][ch]);
					var mdct_enc = gi.xr;
					var mdct_encPos = 0;
					var samp = gfc.sb_sample[ch][1 - gr];
					var sampPos = 0;
	
					for (var k = 0; k < 18 / 2; k++) {
						window_subband(wk, wkPos, samp[sampPos]);
						window_subband(wk, wkPos + 32, samp[sampPos + 1]);
						sampPos += 2;
						wkPos += 64;
						/*
						 * Compensate for inversion in the analysis filter
						 */
						for (band = 1; band < 32; band += 2) {
							samp[sampPos - 1][band] *= -1;
						}
					}
	
					/*
					 * Perform imdct of 18 previous subband samples + 18 current
					 * subband samples
					 */
					for (band = 0; band < 32; band++, mdct_encPos += 18) {
						var type = gi.block_type;
						var band0 = gfc.sb_sample[ch][gr];
						var band1 = gfc.sb_sample[ch][1 - gr];
						if (gi.mixed_block_flag != 0 && band < 2)
							type = 0;
						if (gfc.amp_filter[band] < 1e-12) {
							Arrays.fill(mdct_enc, mdct_encPos + 0,
									mdct_encPos + 18, 0);
						} else {
							if (gfc.amp_filter[band] < 1.0) {
								for (var k = 0; k < 18; k++)
									band1[k][order[band]] *= gfc.amp_filter[band];
							}
							if (type == Encoder.SHORT_TYPE) {
								for (var k = -NS / 4; k < 0; k++) {
									var w = win[Encoder.SHORT_TYPE][k + 3];
									mdct_enc[mdct_encPos + k * 3 + 9] = band0[9 + k][order[band]]
											* w - band0[8 - k][order[band]];
									mdct_enc[mdct_encPos + k * 3 + 18] = band0[14 - k][order[band]]
											* w + band0[15 + k][order[band]];
									mdct_enc[mdct_encPos + k * 3 + 10] = band0[15 + k][order[band]]
											* w - band0[14 - k][order[band]];
									mdct_enc[mdct_encPos + k * 3 + 19] = band1[2 - k][order[band]]
											* w + band1[3 + k][order[band]];
									mdct_enc[mdct_encPos + k * 3 + 11] = band1[3 + k][order[band]]
											* w - band1[2 - k][order[band]];
									mdct_enc[mdct_encPos + k * 3 + 20] = band1[8 - k][order[band]]
											* w + band1[9 + k][order[band]];
								}
								mdct_short(mdct_enc, mdct_encPos);
							} else {
								var work = new_float(18);
								for (var k = -NL / 4; k < 0; k++) {
									var a, b;
									a = win[type][k + 27]
											* band1[k + 9][order[band]]
											+ win[type][k + 36]
											* band1[8 - k][order[band]];
									b = win[type][k + 9]
											* band0[k + 9][order[band]]
											- win[type][k + 18]
											* band0[8 - k][order[band]];
									work[k + 9] = a - b * tantab_l[3 + k + 9];
									work[k + 18] = a * tantab_l[3 + k + 9] + b;
								}
	
								mdct_long(mdct_enc, mdct_encPos, work);
							}
						}
						/*
						 * Perform aliasing reduction butterfly
						 */
						if (type != Encoder.SHORT_TYPE && band != 0) {
							for (var k = 7; k >= 0; --k) {
								var bu, bd;
								bu = mdct_enc[mdct_encPos + k] * ca[20 + k]
										+ mdct_enc[mdct_encPos + -1 - k]
										* cs[28 + k];
								bd = mdct_enc[mdct_encPos + k] * cs[28 + k]
										- mdct_enc[mdct_encPos + -1 - k]
										* ca[20 + k];
	
								mdct_enc[mdct_encPos + -1 - k] = bu;
								mdct_enc[mdct_encPos + k] = bd;
							}
						}
					}
				}
				wk = w1;
				wkPos = 286;
				if (gfc.mode_gr == 1) {
					for (var i = 0; i < 18; i++) {
						System.arraycopy(gfc.sb_sample[ch][1][i], 0,
								gfc.sb_sample[ch][0][i], 0, 32);
					}
				}
			}
		}
	}
	
	module.exports = NewMDCT;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var Encoder = __webpack_require__(21);
	
	//package mp3;
	
	/**
	 * Variables used for --nspsytune
	 *
	 * @author Ken
	 *
	 */
	function NsPsy() {
	    this.last_en_subshort = new_float_n([4, 9]);
	    this.lastAttacks = new_int(4);
	    this.pefirbuf = new_float(19);
	    this.longfact = new_float(Encoder.SBMAX_l);
	    this.shortfact = new_float(Encoder.SBMAX_s);
	
	    /**
	     * short block tuning
	     */
	    this.attackthre = 0.;
	    this.attackthre_s = 0.;
	}
	
	module.exports = NsPsy;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	function Presets() {
	    function VBRPresets(qual, comp, compS,
	                        y, shThreshold, shThresholdS,
	                        adj, adjShort, lower,
	                        curve, sens, inter,
	                        joint, mod, fix) {
	        this.vbr_q = qual;
	        this.quant_comp = comp;
	        this.quant_comp_s = compS;
	        this.expY = y;
	        this.st_lrm = shThreshold;
	        this.st_s = shThresholdS;
	        this.masking_adj = adj;
	        this.masking_adj_short = adjShort;
	        this.ath_lower = lower;
	        this.ath_curve = curve;
	        this.ath_sensitivity = sens;
	        this.interch = inter;
	        this.safejoint = joint;
	        this.sfb21mod = mod;
	        this.msfix = fix;
	    }
	
	    function ABRPresets(kbps, comp, compS,
	                        joint, fix, shThreshold,
	                        shThresholdS, bass, sc,
	                        mask, lower, curve,
	                        interCh, sfScale) {
	        this.quant_comp = comp;
	        this.quant_comp_s = compS;
	        this.safejoint = joint;
	        this.nsmsfix = fix;
	        this.st_lrm = shThreshold;
	        this.st_s = shThresholdS;
	        this.nsbass = bass;
	        this.scale = sc;
	        this.masking_adj = mask;
	        this.ath_lower = lower;
	        this.ath_curve = curve;
	        this.interch = interCh;
	        this.sfscale = sfScale;
	    }
	
	    var lame;
	
	    this.setModules = function (_lame) {
	        lame = _lame;
	    };
	
	    /**
	     * <PRE>
	     * Switch mappings for VBR mode VBR_RH
	     *             vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
	     * </PRE>
	     */
	    var vbr_old_switch_map = [
	        new VBRPresets(0, 9, 9, 0, 5.20, 125.0, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, 0.97),
	        new VBRPresets(1, 9, 9, 0, 5.30, 125.0, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
	        new VBRPresets(2, 9, 9, 0, 5.60, 125.0, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
	        new VBRPresets(3, 9, 9, 1, 5.80, 130.0, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
	        new VBRPresets(4, 9, 9, 1, 6.00, 135.0, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
	        new VBRPresets(5, 9, 9, 1, 6.40, 140.0, 0.5, 0.4, -7.5, 4, -12, 0.0002, 0, 0, 1.95),
	        new VBRPresets(6, 9, 9, 1, 6.60, 145.0, 0.67, 0.65, -14.7, 6.5, -19, 0.0004, 0, 0, 2.30),
	        new VBRPresets(7, 9, 9, 1, 6.60, 145.0, 0.8, 0.75, -19.7, 8, -22, 0.0006, 0, 0, 2.70),
	        new VBRPresets(8, 9, 9, 1, 6.60, 145.0, 1.2, 1.15, -27.5, 10, -23, 0.0007, 0, 0, 0),
	        new VBRPresets(9, 9, 9, 1, 6.60, 145.0, 1.6, 1.6, -36, 11, -25, 0.0008, 0, 0, 0),
	        new VBRPresets(10, 9, 9, 1, 6.60, 145.0, 2.0, 2.0, -36, 12, -25, 0.0008, 0, 0, 0)
	    ];
	
	    /**
	     * <PRE>
	     *                 vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
	     * </PRE>
	     */
	    var vbr_psy_switch_map = [
	        new VBRPresets(0, 9, 9, 0, 4.20, 25.0, -7.0, -4.0, 7.5, 1, 0, 0, 2, 26, 0.97),
	        new VBRPresets(1, 9, 9, 0, 4.20, 25.0, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
	        new VBRPresets(2, 9, 9, 0, 4.20, 25.0, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
	        new VBRPresets(3, 9, 9, 1, 4.20, 25.0, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
	        new VBRPresets(4, 9, 9, 1, 4.20, 25.0, -2.2, 0.1, 0, 3.5, -8, 0, 2, 0, 1.79),
	        new VBRPresets(5, 9, 9, 1, 4.20, 25.0, -1.0, 1.65, -7.7, 4, -12, 0.0002, 0, 0, 1.95),
	        new VBRPresets(6, 9, 9, 1, 4.20, 25.0, -0.0, 2.47, -7.7, 6.5, -19, 0.0004, 0, 0, 2),
	        new VBRPresets(7, 9, 9, 1, 4.20, 25.0, 0.5, 2.0, -14.5, 8, -22, 0.0006, 0, 0, 2),
	        new VBRPresets(8, 9, 9, 1, 4.20, 25.0, 1.0, 2.4, -22.0, 10, -23, 0.0007, 0, 0, 2),
	        new VBRPresets(9, 9, 9, 1, 4.20, 25.0, 1.5, 2.95, -30.0, 11, -25, 0.0008, 0, 0, 2),
	        new VBRPresets(10, 9, 9, 1, 4.20, 25.0, 2.0, 2.95, -36.0, 12, -30, 0.0008, 0, 0, 2)
	    ];
	
	    function apply_vbr_preset(gfp, a, enforce) {
	        var vbr_preset = gfp.VBR == VbrMode.vbr_rh ? vbr_old_switch_map
	            : vbr_psy_switch_map;
	
	        var x = gfp.VBR_q_frac;
	        var p = vbr_preset[a];
	        var q = vbr_preset[a + 1];
	        var set = p;
	
	        // NOOP(vbr_q);
	        // NOOP(quant_comp);
	        // NOOP(quant_comp_s);
	        // NOOP(expY);
	        p.st_lrm = p.st_lrm + x * (q.st_lrm - p.st_lrm);
	        // LERP(st_lrm);
	        p.st_s = p.st_s + x * (q.st_s - p.st_s);
	        // LERP(st_s);
	        p.masking_adj = p.masking_adj + x * (q.masking_adj - p.masking_adj);
	        // LERP(masking_adj);
	        p.masking_adj_short = p.masking_adj_short + x
	            * (q.masking_adj_short - p.masking_adj_short);
	        // LERP(masking_adj_short);
	        p.ath_lower = p.ath_lower + x * (q.ath_lower - p.ath_lower);
	        // LERP(ath_lower);
	        p.ath_curve = p.ath_curve + x * (q.ath_curve - p.ath_curve);
	        // LERP(ath_curve);
	        p.ath_sensitivity = p.ath_sensitivity + x
	            * (q.ath_sensitivity - p.ath_sensitivity);
	        // LERP(ath_sensitivity);
	        p.interch = p.interch + x * (q.interch - p.interch);
	        // LERP(interch);
	        // NOOP(safejoint);
	        // NOOP(sfb21mod);
	        p.msfix = p.msfix + x * (q.msfix - p.msfix);
	        // LERP(msfix);
	
	        lame_set_VBR_q(gfp, set.vbr_q);
	
	        if (enforce != 0)
	            gfp.quant_comp = set.quant_comp;
	        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
	            gfp.quant_comp = set.quant_comp;
	        // SET_OPTION(quant_comp, set.quant_comp, -1);
	        if (enforce != 0)
	            gfp.quant_comp_short = set.quant_comp_s;
	        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
	            gfp.quant_comp_short = set.quant_comp_s;
	        // SET_OPTION(quant_comp_short, set.quant_comp_s, -1);
	        if (set.expY != 0) {
	            gfp.experimentalY = set.expY != 0;
	        }
	        if (enforce != 0)
	            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
	        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
	            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
	        // SET_OPTION(short_threshold_lrm, set.st_lrm, -1);
	        if (enforce != 0)
	            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
	        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
	            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
	        // SET_OPTION(short_threshold_s, set.st_s, -1);
	        if (enforce != 0)
	            gfp.maskingadjust = set.masking_adj;
	        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
	            gfp.maskingadjust = set.masking_adj;
	        // SET_OPTION(maskingadjust, set.masking_adj, 0);
	        if (enforce != 0)
	            gfp.maskingadjust_short = set.masking_adj_short;
	        else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
	            gfp.maskingadjust_short = set.masking_adj_short;
	        // SET_OPTION(maskingadjust_short, set.masking_adj_short, 0);
	        if (enforce != 0)
	            gfp.ATHlower = -set.ath_lower / 10.0;
	        else if (!(Math.abs((-gfp.ATHlower * 10.0) - 0) > 0))
	            gfp.ATHlower = -set.ath_lower / 10.0;
	        // SET_OPTION(ATHlower, set.ath_lower, 0);
	        if (enforce != 0)
	            gfp.ATHcurve = set.ath_curve;
	        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
	            gfp.ATHcurve = set.ath_curve;
	        // SET_OPTION(ATHcurve, set.ath_curve, -1);
	        if (enforce != 0)
	            gfp.athaa_sensitivity = set.ath_sensitivity;
	        else if (!(Math.abs(gfp.athaa_sensitivity - -1) > 0))
	            gfp.athaa_sensitivity = set.ath_sensitivity;
	        // SET_OPTION(athaa_sensitivity, set.ath_sensitivity, 0);
	        if (set.interch > 0) {
	            if (enforce != 0)
	                gfp.interChRatio = set.interch;
	            else if (!(Math.abs(gfp.interChRatio - -1) > 0))
	                gfp.interChRatio = set.interch;
	            // SET_OPTION(interChRatio, set.interch, -1);
	        }
	
	        /* parameters for which there is no proper set/get interface */
	        if (set.safejoint > 0) {
	            gfp.exp_nspsytune = gfp.exp_nspsytune | set.safejoint;
	        }
	        if (set.sfb21mod > 0) {
	            gfp.exp_nspsytune = gfp.exp_nspsytune | (set.sfb21mod << 20);
	        }
	        if (enforce != 0)
	            gfp.msfix = set.msfix;
	        else if (!(Math.abs(gfp.msfix - -1) > 0))
	            gfp.msfix = set.msfix;
	        // SET_OPTION(msfix, set.msfix, -1);
	
	        if (enforce == 0) {
	            gfp.VBR_q = a;
	            gfp.VBR_q_frac = x;
	        }
	    }
	
	    /**
	     * <PRE>
	     *  Switch mappings for ABR mode
	     *
	     *              kbps  quant q_s safejoint nsmsfix st_lrm  st_s  ns-bass scale   msk ath_lwr ath_curve  interch , sfscale
	     * </PRE>
	     */
	    var abr_switch_map = [
	        new ABRPresets(8, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -30.0, 11, 0.0012, 1), /*   8, impossible to use in stereo */
	        new ABRPresets(16, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -25.0, 11, 0.0010, 1), /*  16 */
	        new ABRPresets(24, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -20.0, 11, 0.0010, 1), /*  24 */
	        new ABRPresets(32, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -15.0, 11, 0.0010, 1), /*  32 */
	        new ABRPresets(40, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  40 */
	        new ABRPresets(48, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  48 */
	        new ABRPresets(56, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -6.0, 11, 0.0008, 1), /*  56 */
	        new ABRPresets(64, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -2.0, 11, 0.0008, 1), /*  64 */
	        new ABRPresets(80, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, .0, 8, 0.0007, 1), /*  80 */
	        new ABRPresets(96, 9, 9, 0, 2.50, 6.60, 145, 0, 0.95, 0, 1.0, 5.5, 0.0006, 1), /*  96 */
	        new ABRPresets(112, 9, 9, 0, 2.25, 6.60, 145, 0, 0.95, 0, 2.0, 4.5, 0.0005, 1), /* 112 */
	        new ABRPresets(128, 9, 9, 0, 1.95, 6.40, 140, 0, 0.95, 0, 3.0, 4, 0.0002, 1), /* 128 */
	        new ABRPresets(160, 9, 9, 1, 1.79, 6.00, 135, 0, 0.95, -2, 5.0, 3.5, 0, 1), /* 160 */
	        new ABRPresets(192, 9, 9, 1, 1.49, 5.60, 125, 0, 0.97, -4, 7.0, 3, 0, 0), /* 192 */
	        new ABRPresets(224, 9, 9, 1, 1.25, 5.20, 125, 0, 0.98, -6, 9.0, 2, 0, 0), /* 224 */
	        new ABRPresets(256, 9, 9, 1, 0.97, 5.20, 125, 0, 1.00, -8, 10.0, 1, 0, 0), /* 256 */
	        new ABRPresets(320, 9, 9, 1, 0.90, 5.20, 125, 0, 1.00, -10, 12.0, 0, 0, 0)  /* 320 */
	    ];
	
	    function apply_abr_preset(gfp, preset, enforce) {
	        /* Variables for the ABR stuff */
	        var actual_bitrate = preset;
	
	        var r = lame.nearestBitrateFullIndex(preset);
	
	        gfp.VBR = VbrMode.vbr_abr;
	        gfp.VBR_mean_bitrate_kbps = actual_bitrate;
	        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
	        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
	        gfp.brate = gfp.VBR_mean_bitrate_kbps;
	        if (gfp.VBR_mean_bitrate_kbps > 320) {
	            gfp.disable_reservoir = true;
	        }
	
	        /* parameters for which there is no proper set/get interface */
	        if (abr_switch_map[r].safejoint > 0)
	            gfp.exp_nspsytune = gfp.exp_nspsytune | 2;
	        /* safejoint */
	
	        if (abr_switch_map[r].sfscale > 0) {
	            gfp.internal_flags.noise_shaping = 2;
	        }
	        /* ns-bass tweaks */
	        if (Math.abs(abr_switch_map[r].nsbass) > 0) {
	            var k = (int)(abr_switch_map[r].nsbass * 4);
	            if (k < 0)
	                k += 64;
	            gfp.exp_nspsytune = gfp.exp_nspsytune | (k << 2);
	        }
	
	        if (enforce != 0)
	            gfp.quant_comp = abr_switch_map[r].quant_comp;
	        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
	            gfp.quant_comp = abr_switch_map[r].quant_comp;
	        // SET_OPTION(quant_comp, abr_switch_map[r].quant_comp, -1);
	        if (enforce != 0)
	            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
	        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
	            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
	        // SET_OPTION(quant_comp_short, abr_switch_map[r].quant_comp_s, -1);
	
	        if (enforce != 0)
	            gfp.msfix = abr_switch_map[r].nsmsfix;
	        else if (!(Math.abs(gfp.msfix - -1) > 0))
	            gfp.msfix = abr_switch_map[r].nsmsfix;
	        // SET_OPTION(msfix, abr_switch_map[r].nsmsfix, -1);
	
	        if (enforce != 0)
	            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
	        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
	            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
	        // SET_OPTION(short_threshold_lrm, abr_switch_map[r].st_lrm, -1);
	        if (enforce != 0)
	            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
	        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
	            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
	        // SET_OPTION(short_threshold_s, abr_switch_map[r].st_s, -1);
	
	        /*
	         * ABR seems to have big problems with clipping, especially at low
	         * bitrates
	         */
	        /*
	         * so we compensate for that here by using a scale value depending on
	         * bitrate
	         */
	        if (enforce != 0)
	            gfp.scale = abr_switch_map[r].scale;
	        else if (!(Math.abs(gfp.scale - -1) > 0))
	            gfp.scale = abr_switch_map[r].scale;
	        // SET_OPTION(scale, abr_switch_map[r].scale, -1);
	
	        if (enforce != 0)
	            gfp.maskingadjust = abr_switch_map[r].masking_adj;
	        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
	            gfp.maskingadjust = abr_switch_map[r].masking_adj;
	        // SET_OPTION(maskingadjust, abr_switch_map[r].masking_adj, 0);
	        if (abr_switch_map[r].masking_adj > 0) {
	            if (enforce != 0)
	                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
	            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
	                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
	            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
	            // .9, 0);
	        } else {
	            if (enforce != 0)
	                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
	            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
	                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
	            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
	            // 1.1, 0);
	        }
	
	        if (enforce != 0)
	            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
	        else if (!(Math.abs((-gfp.ATHlower * 10.) - 0) > 0))
	            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
	        // SET_OPTION(ATHlower, abr_switch_map[r].ath_lower, 0);
	        if (enforce != 0)
	            gfp.ATHcurve = abr_switch_map[r].ath_curve;
	        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
	            gfp.ATHcurve = abr_switch_map[r].ath_curve;
	        // SET_OPTION(ATHcurve, abr_switch_map[r].ath_curve, -1);
	
	        if (enforce != 0)
	            gfp.interChRatio = abr_switch_map[r].interch;
	        else if (!(Math.abs(gfp.interChRatio - -1) > 0))
	            gfp.interChRatio = abr_switch_map[r].interch;
	        // SET_OPTION(interChRatio, abr_switch_map[r].interch, -1);
	
	        return preset;
	    }
	
	    this.apply_preset = function(gfp, preset, enforce) {
	        /* translate legacy presets */
	        switch (preset) {
	            case Lame.R3MIX:
	            {
	                preset = Lame.V3;
	                gfp.VBR = VbrMode.vbr_mtrh;
	                break;
	            }
	            case Lame.MEDIUM:
	            {
	                preset = Lame.V4;
	                gfp.VBR = VbrMode.vbr_rh;
	                break;
	            }
	            case Lame.MEDIUM_FAST:
	            {
	                preset = Lame.V4;
	                gfp.VBR = VbrMode.vbr_mtrh;
	                break;
	            }
	            case Lame.STANDARD:
	            {
	                preset = Lame.V2;
	                gfp.VBR = VbrMode.vbr_rh;
	                break;
	            }
	            case Lame.STANDARD_FAST:
	            {
	                preset = Lame.V2;
	                gfp.VBR = VbrMode.vbr_mtrh;
	                break;
	            }
	            case Lame.EXTREME:
	            {
	                preset = Lame.V0;
	                gfp.VBR = VbrMode.vbr_rh;
	                break;
	            }
	            case Lame.EXTREME_FAST:
	            {
	                preset = Lame.V0;
	                gfp.VBR = VbrMode.vbr_mtrh;
	                break;
	            }
	            case Lame.INSANE:
	            {
	                preset = 320;
	                gfp.preset = preset;
	                apply_abr_preset(gfp, preset, enforce);
	                gfp.VBR = VbrMode.vbr_off;
	                return preset;
	            }
	        }
	
	        gfp.preset = preset;
	        {
	            switch (preset) {
	                case Lame.V9:
	                    apply_vbr_preset(gfp, 9, enforce);
	                    return preset;
	                case Lame.V8:
	                    apply_vbr_preset(gfp, 8, enforce);
	                    return preset;
	                case Lame.V7:
	                    apply_vbr_preset(gfp, 7, enforce);
	                    return preset;
	                case Lame.V6:
	                    apply_vbr_preset(gfp, 6, enforce);
	                    return preset;
	                case Lame.V5:
	                    apply_vbr_preset(gfp, 5, enforce);
	                    return preset;
	                case Lame.V4:
	                    apply_vbr_preset(gfp, 4, enforce);
	                    return preset;
	                case Lame.V3:
	                    apply_vbr_preset(gfp, 3, enforce);
	                    return preset;
	                case Lame.V2:
	                    apply_vbr_preset(gfp, 2, enforce);
	                    return preset;
	                case Lame.V1:
	                    apply_vbr_preset(gfp, 1, enforce);
	                    return preset;
	                case Lame.V0:
	                    apply_vbr_preset(gfp, 0, enforce);
	                    return preset;
	                default:
	                    break;
	            }
	        }
	        if (8 <= preset && preset <= 320) {
	            return apply_abr_preset(gfp, preset, enforce);
	        }
	
	        /* no corresponding preset found */
	        gfp.preset = 0;
	        return preset;
	    }
	
	    // Rest from getset.c:
	
	    /**
	     * VBR quality level.<BR>
	     * 0 = highest<BR>
	     * 9 = lowest
	     */
	    function lame_set_VBR_q(gfp, VBR_q) {
	        var ret = 0;
	
	        if (0 > VBR_q) {
	            /* Unknown VBR quality level! */
	            ret = -1;
	            VBR_q = 0;
	        }
	        if (9 < VBR_q) {
	            ret = -1;
	            VBR_q = 9;
	        }
	
	        gfp.VBR_q = VBR_q;
	        gfp.VBR_q_frac = 0;
	        return ret;
	    }
	
	}
	
	module.exports = Presets;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *      psymodel.c
	 *
	 *      Copyright (c) 1999-2000 Mark Taylor
	 *      Copyright (c) 2001-2002 Naoki Shibata
	 *      Copyright (c) 2000-2003 Takehiro Tominaga
	 *      Copyright (c) 2000-2008 Robert Hegemann
	 *      Copyright (c) 2000-2005 Gabriel Bouvigne
	 *      Copyright (c) 2000-2005 Alexander Leidinger
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Lesser General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	
	/* $Id: PsyModel.java,v 1.27 2011/05/24 20:48:06 kenchis Exp $ */
	
	
	/*
	 PSYCHO ACOUSTICS
	
	
	 This routine computes the psycho acoustics, delayed by one granule.
	
	 Input: buffer of PCM data (1024 samples).
	
	 This window should be centered over the 576 sample granule window.
	 The routine will compute the psycho acoustics for
	 this granule, but return the psycho acoustics computed
	 for the *previous* granule.  This is because the block
	 type of the previous granule can only be determined
	 after we have computed the psycho acoustics for the following
	 granule.
	
	 Output:  maskings and energies for each scalefactor band.
	 block type, PE, and some correlation measures.
	 The PE is used by CBR modes to determine if extra bits
	 from the bit reservoir should be used.  The correlation
	 measures are used to determine mid/side or regular stereo.
	 */
	/*
	 Notation:
	
	 barks:  a non-linear frequency scale.  Mapping from frequency to
	 barks is given by freq2bark()
	
	 scalefactor bands: The spectrum (frequencies) are broken into
	 SBMAX "scalefactor bands".  Thes bands
	 are determined by the MPEG ISO spec.  In
	 the noise shaping/quantization code, we allocate
	 bits among the partition bands to achieve the
	 best possible quality
	
	 partition bands:   The spectrum is also broken into about
	 64 "partition bands".  Each partition
	 band is about .34 barks wide.  There are about 2-5
	 partition bands for each scalefactor band.
	
	 LAME computes all psycho acoustic information for each partition
	 band.  Then at the end of the computations, this information
	 is mapped to scalefactor bands.  The energy in each scalefactor
	 band is taken as the sum of the energy in all partition bands
	 which overlap the scalefactor band.  The maskings can be computed
	 in the same way (and thus represent the average masking in that band)
	 or by taking the minmum value multiplied by the number of
	 partition bands used (which represents a minimum masking in that band).
	 */
	/*
	 The general outline is as follows:
	
	 1. compute the energy in each partition band
	 2. compute the tonality in each partition band
	 3. compute the strength of each partion band "masker"
	 4. compute the masking (via the spreading function applied to each masker)
	 5. Modifications for mid/side masking.
	
	 Each partition band is considiered a "masker".  The strength
	 of the i'th masker in band j is given by:
	
	 s3(bark(i)-bark(j))*strength(i)
	
	 The strength of the masker is a function of the energy and tonality.
	 The more tonal, the less masking.  LAME uses a simple linear formula
	 (controlled by NMT and TMN) which says the strength is given by the
	 energy divided by a linear function of the tonality.
	 */
	/*
	 s3() is the "spreading function".  It is given by a formula
	 determined via listening tests.
	
	 The total masking in the j'th partition band is the sum over
	 all maskings i.  It is thus given by the convolution of
	 the strength with s3(), the "spreading function."
	
	 masking(j) = sum_over_i  s3(i-j)*strength(i)  = s3 o strength
	
	 where "o" = convolution operator.  s3 is given by a formula determined
	 via listening tests.  It is normalized so that s3 o 1 = 1.
	
	 Note: instead of a simple convolution, LAME also has the
	 option of using "additive masking"
	
	 The most critical part is step 2, computing the tonality of each
	 partition band.  LAME has two tonality estimators.  The first
	 is based on the ISO spec, and measures how predictiable the
	 signal is over time.  The more predictable, the more tonal.
	 The second measure is based on looking at the spectrum of
	 a single granule.  The more peaky the spectrum, the more
	 tonal.  By most indications, the latter approach is better.
	
	 Finally, in step 5, the maskings for the mid and side
	 channel are possibly increased.  Under certain circumstances,
	 noise in the mid & side channels is assumed to also
	 be masked by strong maskers in the L or R channels.
	
	
	 Other data computed by the psy-model:
	
	 ms_ratio        side-channel / mid-channel masking ratio (for previous granule)
	 ms_ratio_next   side-channel / mid-channel masking ratio for this granule
	
	 percep_entropy[2]     L and R values (prev granule) of PE - A measure of how
	 much pre-echo is in the previous granule
	 percep_entropy_MS[2]  mid and side channel values (prev granule) of percep_entropy
	 energy[4]             L,R,M,S energy in each channel, prev granule
	 blocktype_d[2]        block type to use for previous granule
	 */
	//package mp3;
	
	//import java.util.Arrays;
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var FFT = __webpack_require__(397);
	var Encoder = __webpack_require__(21);
	
	function PsyModel() {
	
	    var fft = new FFT();
	
	    var LOG10 = 2.30258509299404568402;
	
	    var rpelev = 2;
	    var rpelev2 = 16;
	    var rpelev_s = 2;
	    var rpelev2_s = 16;
	
	    /* size of each partition band, in barks: */
	    var DELBARK = .34;
	
	    /* tuned for output level (sensitive to energy scale) */
	    var VO_SCALE = (1. / (14752 * 14752) / (Encoder.BLKSIZE / 2));
	
	    var temporalmask_sustain_sec = 0.01;
	
	    var NS_PREECHO_ATT0 = 0.8;
	    var NS_PREECHO_ATT1 = 0.6;
	    var NS_PREECHO_ATT2 = 0.3;
	
	    var NS_MSFIX = 3.5;
	
	    var NSATTACKTHRE = 4.4;
	    var NSATTACKTHRE_S = 25;
	
	    var NSFIRLEN = 21;
	
	    /* size of each partition band, in barks: */
	    var LN_TO_LOG10 = 0.2302585093;
	
	    function NON_LINEAR_SCALE_ENERGY(x) {
	        return x;
	    }
	
	    /**
	     * <PRE>
	     *       L3psycho_anal.  Compute psycho acoustics.
	     *
	     *       Data returned to the calling program must be delayed by one
	     *       granule.
	     *
	     *       This is done in two places.
	     *       If we do not need to know the blocktype, the copying
	     *       can be done here at the top of the program: we copy the data for
	     *       the last granule (computed during the last call) before it is
	     *       overwritten with the new data.  It looks like this:
	     *
	     *       0. static psymodel_data
	     *       1. calling_program_data = psymodel_data
	     *       2. compute psymodel_data
	     *
	     *       For data which needs to know the blocktype, the copying must be
	     *       done at the end of this loop, and the old values must be saved:
	     *
	     *       0. static psymodel_data_old
	     *       1. compute psymodel_data
	     *       2. compute possible block type of this granule
	     *       3. compute final block type of previous granule based on #2.
	     *       4. calling_program_data = psymodel_data_old
	     *       5. psymodel_data_old = psymodel_data
	     *     psycho_loudness_approx
	     *       jd - 2001 mar 12
	     *    in:  energy   - BLKSIZE/2 elements of frequency magnitudes ^ 2
	     *         gfp      - uses out_samplerate, ATHtype (also needed for ATHformula)
	     *    returns: loudness^2 approximation, a positive value roughly tuned for a value
	     *             of 1.0 for signals near clipping.
	     *    notes:   When calibrated, feeding this function binary white noise at sample
	     *             values +32767 or -32768 should return values that approach 3.
	     *             ATHformula is used to approximate an equal loudness curve.
	     *    future:  Data indicates that the shape of the equal loudness curve varies
	     *             with intensity.  This function might be improved by using an equal
	     *             loudness curve shaped for typical playback levels (instead of the
	     *             ATH, that is shaped for the threshold).  A flexible realization might
	     *             simply bend the existing ATH curve to achieve the desired shape.
	     *             However, the potential gain may not be enough to justify an effort.
	     * </PRE>
	     */
	    function psycho_loudness_approx(energy, gfc) {
	        var loudness_power = 0.0;
	        /* apply weights to power in freq. bands */
	        for (var i = 0; i < Encoder.BLKSIZE / 2; ++i)
	            loudness_power += energy[i] * gfc.ATH.eql_w[i];
	        loudness_power *= VO_SCALE;
	
	        return loudness_power;
	    }
	
	    function compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, wsamp_lPos, wsamp_s, wsamp_sPos, gr_out, chn, buffer, bufPos) {
	        var gfc = gfp.internal_flags;
	        if (chn < 2) {
	            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
	            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
	        }
	        /* FFT data for mid and side channel is derived from L & R */
	        else if (chn == 2) {
	            for (var j = Encoder.BLKSIZE - 1; j >= 0; --j) {
	                var l = wsamp_l[wsamp_lPos + 0][j];
	                var r = wsamp_l[wsamp_lPos + 1][j];
	                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
	                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
	            }
	            for (var b = 2; b >= 0; --b) {
	                for (var j = Encoder.BLKSIZE_s - 1; j >= 0; --j) {
	                    var l = wsamp_s[wsamp_sPos + 0][b][j];
	                    var r = wsamp_s[wsamp_sPos + 1][b][j];
	                    wsamp_s[wsamp_sPos + 0][b][j] = (l + r) * Util.SQRT2 * 0.5;
	                    wsamp_s[wsamp_sPos + 1][b][j] = (l - r) * Util.SQRT2 * 0.5;
	                }
	            }
	        }
	
	        /*********************************************************************
	         * compute energies
	         *********************************************************************/
	        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
	        fftenergy[0] *= fftenergy[0];
	
	        for (var j = Encoder.BLKSIZE / 2 - 1; j >= 0; --j) {
	            var re = (wsamp_l[wsamp_lPos + 0])[Encoder.BLKSIZE / 2 - j];
	            var im = (wsamp_l[wsamp_lPos + 0])[Encoder.BLKSIZE / 2 + j];
	            fftenergy[Encoder.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
	                * re + im * im) * 0.5);
	        }
	        for (var b = 2; b >= 0; --b) {
	            fftenergy_s[b][0] = (wsamp_s[wsamp_sPos + 0])[b][0];
	            fftenergy_s[b][0] *= fftenergy_s[b][0];
	            for (var j = Encoder.BLKSIZE_s / 2 - 1; j >= 0; --j) {
	                var re = (wsamp_s[wsamp_sPos + 0])[b][Encoder.BLKSIZE_s
	                / 2 - j];
	                var im = (wsamp_s[wsamp_sPos + 0])[b][Encoder.BLKSIZE_s
	                / 2 + j];
	                fftenergy_s[b][Encoder.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
	                    * re + im * im) * 0.5);
	            }
	        }
	        /* total energy */
	        {
	            var totalenergy = 0.0;
	            for (var j = 11; j < Encoder.HBLKSIZE; j++)
	                totalenergy += fftenergy[j];
	
	            gfc.tot_ener[chn] = totalenergy;
	        }
	
	        if (gfp.analysis) {
	            for (var j = 0; j < Encoder.HBLKSIZE; j++) {
	                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
	                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
	            }
	            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
	        }
	
	        /*********************************************************************
	         * compute loudness approximation (used for ATH auto-level adjustment)
	         *********************************************************************/
	        if (gfp.athaa_loudapprox == 2 && chn < 2) {
	            // no loudness for mid/side ch
	            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
	            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
	        }
	    }
	
	    /* mask_add optimization */
	    /* init the limit values used to avoid computing log in mask_add when it is not necessary */
	
	    /**
	     * <PRE>
	     *  For example, with i = 10*log10(m2/m1)/10*16         (= log10(m2/m1)*16)
	     *
	     * abs(i)>8 is equivalent (as i is an integer) to
	     * abs(i)>=9
	     * i>=9 || i<=-9
	     * equivalent to (as i is the biggest integer smaller than log10(m2/m1)*16
	     * or the smallest integer bigger than log10(m2/m1)*16 depending on the sign of log10(m2/m1)*16)
	     * log10(m2/m1)>=9/16 || log10(m2/m1)<=-9/16
	     * exp10 is strictly increasing thus this is equivalent to
	     * m2/m1 >= 10^(9/16) || m2/m1<=10^(-9/16) which are comparisons to constants
	     * </PRE>
	     */
	
	    /**
	     * as in if(i>8)
	     */
	    var I1LIMIT = 8;
	    /**
	     * as in if(i>24) . changed 23
	     */
	    var I2LIMIT = 23;
	    /**
	     * as in if(m<15)
	     */
	    var MLIMIT = 15;
	
	    var ma_max_i1;
	    var ma_max_i2;
	    var ma_max_m;
	
	    /**
	     * This is the masking table:<BR>
	     * According to tonality, values are going from 0dB (TMN) to 9.3dB (NMT).<BR>
	     * After additive masking computation, 8dB are added, so final values are
	     * going from 8dB to 17.3dB
	     *
	     * pow(10, -0.0..-0.6)
	     */
	    var tab = [1.0, 0.79433, 0.63096, 0.63096,
	        0.63096, 0.63096, 0.63096, 0.25119, 0.11749];
	
	    function init_mask_add_max_values() {
	        ma_max_i1 = Math.pow(10, (I1LIMIT + 1) / 16.0);
	        ma_max_i2 = Math.pow(10, (I2LIMIT + 1) / 16.0);
	        ma_max_m = Math.pow(10, (MLIMIT) / 10.0);
	    }
	
	    var table1 = [3.3246 * 3.3246,
	        3.23837 * 3.23837, 3.15437 * 3.15437, 3.00412 * 3.00412,
	        2.86103 * 2.86103, 2.65407 * 2.65407, 2.46209 * 2.46209,
	        2.284 * 2.284, 2.11879 * 2.11879, 1.96552 * 1.96552,
	        1.82335 * 1.82335, 1.69146 * 1.69146, 1.56911 * 1.56911,
	        1.46658 * 1.46658, 1.37074 * 1.37074, 1.31036 * 1.31036,
	        1.25264 * 1.25264, 1.20648 * 1.20648, 1.16203 * 1.16203,
	        1.12765 * 1.12765, 1.09428 * 1.09428, 1.0659 * 1.0659,
	        1.03826 * 1.03826, 1.01895 * 1.01895, 1];
	
	    var table2 = [1.33352 * 1.33352,
	        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
	        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
	        1.22321 * 1.22321, 1.14758 * 1.14758, 1];
	
	    var table3 = [2.35364 * 2.35364,
	        2.29259 * 2.29259, 2.23313 * 2.23313, 2.12675 * 2.12675,
	        2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303,
	        1.61695 * 1.61695, 1.49999 * 1.49999, 1.39148 * 1.39148,
	        1.29083 * 1.29083, 1.19746 * 1.19746, 1.11084 * 1.11084,
	        1.03826 * 1.03826];
	
	    /**
	     * addition of simultaneous masking Naoki Shibata 2000/7
	     */
	    function mask_add(m1, m2, kk, b, gfc, shortblock) {
	        var ratio;
	
	        if (m2 > m1) {
	            if (m2 < (m1 * ma_max_i2))
	                ratio = m2 / m1;
	            else
	                return (m1 + m2);
	        } else {
	            if (m1 >= (m2 * ma_max_i2))
	                return (m1 + m2);
	            ratio = m1 / m2;
	        }
	
	        /* Should always be true, just checking */
	        assert(m1 >= 0);
	        assert(m2 >= 0);
	
	        m1 += m2;
	        //if (((long)(b + 3) & 0xffffffff) <= 3 + 3) {
	        if ((b + 3) <= 3 + 3) {
	            /* approximately, 1 bark = 3 partitions */
	            /* 65% of the cases */
	            /* originally 'if(i > 8)' */
	            if (ratio >= ma_max_i1) {
	                /* 43% of the total */
	                return m1;
	            }
	
	            /* 22% of the total */
	            var i = 0 | (Util.FAST_LOG10_X(ratio, 16.0));
	            return m1 * table2[i];
	        }
	
	        /**
	         * <PRE>
	         * m<15 equ log10((m1+m2)/gfc.ATH.cb[k])<1.5
	         * equ (m1+m2)/gfc.ATH.cb[k]<10^1.5
	         * equ (m1+m2)<10^1.5 * gfc.ATH.cb[k]
	         * </PRE>
	         */
	        var i = 0 | Util.FAST_LOG10_X(ratio, 16.0);
	        if (shortblock != 0) {
	            m2 = gfc.ATH.cb_s[kk] * gfc.ATH.adjust;
	        } else {
	            m2 = gfc.ATH.cb_l[kk] * gfc.ATH.adjust;
	        }
	        assert(m2 >= 0);
	        if (m1 < ma_max_m * m2) {
	            /* 3% of the total */
	            /* Originally if (m > 0) { */
	            if (m1 > m2) {
	                var f, r;
	
	                f = 1.0;
	                if (i <= 13)
	                    f = table3[i];
	
	                r = Util.FAST_LOG10_X(m1 / m2, 10.0 / 15.0);
	                return m1 * ((table1[i] - f) * r + f);
	            }
	
	            if (i > 13)
	                return m1;
	
	            return m1 * table3[i];
	        }
	
	        /* 10% of total */
	        return m1 * table1[i];
	    }
	
	    var table2_ = [1.33352 * 1.33352,
	        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
	        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
	        1.22321 * 1.22321, 1.14758 * 1.14758, 1];
	
	    /**
	     * addition of simultaneous masking Naoki Shibata 2000/7
	     */
	    function vbrpsy_mask_add(m1, m2, b) {
	        var ratio;
	
	        if (m1 < 0) {
	            m1 = 0;
	        }
	        if (m2 < 0) {
	            m2 = 0;
	        }
	        if (m1 <= 0) {
	            return m2;
	        }
	        if (m2 <= 0) {
	            return m1;
	        }
	        if (m2 > m1) {
	            ratio = m2 / m1;
	        } else {
	            ratio = m1 / m2;
	        }
	        if (-2 <= b && b <= 2) {
	            /* approximately, 1 bark = 3 partitions */
	            /* originally 'if(i > 8)' */
	            if (ratio >= ma_max_i1) {
	                return m1 + m2;
	            } else {
	                var i = 0 | (Util.FAST_LOG10_X(ratio, 16.0));
	                return (m1 + m2) * table2_[i];
	            }
	        }
	        if (ratio < ma_max_i2) {
	            return m1 + m2;
	        }
	        if (m1 < m2) {
	            m1 = m2;
	        }
	        return m1;
	    }
	
	    /**
	     * compute interchannel masking effects
	     */
	    function calc_interchannel_masking(gfp, ratio) {
	        var gfc = gfp.internal_flags;
	        if (gfc.channels_out > 1) {
	            for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
	                var l = gfc.thm[0].l[sb];
	                var r = gfc.thm[1].l[sb];
	                gfc.thm[0].l[sb] += r * ratio;
	                gfc.thm[1].l[sb] += l * ratio;
	            }
	            for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
	                for (var sblock = 0; sblock < 3; sblock++) {
	                    var l = gfc.thm[0].s[sb][sblock];
	                    var r = gfc.thm[1].s[sb][sblock];
	                    gfc.thm[0].s[sb][sblock] += r * ratio;
	                    gfc.thm[1].s[sb][sblock] += l * ratio;
	                }
	            }
	        }
	    }
	
	    /**
	     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
	     */
	    function msfix1(gfc) {
	        for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
	            /* use this fix if L & R masking differs by 2db or less */
	            /* if db = 10*log10(x2/x1) < 2 */
	            /* if (x2 < 1.58*x1) { */
	            if (gfc.thm[0].l[sb] > 1.58 * gfc.thm[1].l[sb]
	                || gfc.thm[1].l[sb] > 1.58 * gfc.thm[0].l[sb])
	                continue;
	            var mld = gfc.mld_l[sb] * gfc.en[3].l[sb];
	            var rmid = Math.max(gfc.thm[2].l[sb],
	                Math.min(gfc.thm[3].l[sb], mld));
	
	            mld = gfc.mld_l[sb] * gfc.en[2].l[sb];
	            var rside = Math.max(gfc.thm[3].l[sb],
	                Math.min(gfc.thm[2].l[sb], mld));
	            gfc.thm[2].l[sb] = rmid;
	            gfc.thm[3].l[sb] = rside;
	        }
	
	        for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
	            for (var sblock = 0; sblock < 3; sblock++) {
	                if (gfc.thm[0].s[sb][sblock] > 1.58 * gfc.thm[1].s[sb][sblock]
	                    || gfc.thm[1].s[sb][sblock] > 1.58 * gfc.thm[0].s[sb][sblock])
	                    continue;
	                var mld = gfc.mld_s[sb] * gfc.en[3].s[sb][sblock];
	                var rmid = Math.max(gfc.thm[2].s[sb][sblock],
	                    Math.min(gfc.thm[3].s[sb][sblock], mld));
	
	                mld = gfc.mld_s[sb] * gfc.en[2].s[sb][sblock];
	                var rside = Math.max(gfc.thm[3].s[sb][sblock],
	                    Math.min(gfc.thm[2].s[sb][sblock], mld));
	
	                gfc.thm[2].s[sb][sblock] = rmid;
	                gfc.thm[3].s[sb][sblock] = rside;
	            }
	        }
	    }
	
	    /**
	     * Adjust M/S maskings if user set "msfix"
	     *
	     * Naoki Shibata 2000
	     */
	    function ns_msfix(gfc, msfix, athadjust) {
	        var msfix2 = msfix;
	        var athlower = Math.pow(10, athadjust);
	
	        msfix *= 2.0;
	        msfix2 *= 2.0;
	        for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
	            var thmLR, thmM, thmS, ath;
	            ath = (gfc.ATH.cb_l[gfc.bm_l[sb]]) * athlower;
	            thmLR = Math.min(Math.max(gfc.thm[0].l[sb], ath),
	                Math.max(gfc.thm[1].l[sb], ath));
	            thmM = Math.max(gfc.thm[2].l[sb], ath);
	            thmS = Math.max(gfc.thm[3].l[sb], ath);
	            if (thmLR * msfix < thmM + thmS) {
	                var f = thmLR * msfix2 / (thmM + thmS);
	                thmM *= f;
	                thmS *= f;
	                assert(thmM + thmS > 0);
	            }
	            gfc.thm[2].l[sb] = Math.min(thmM, gfc.thm[2].l[sb]);
	            gfc.thm[3].l[sb] = Math.min(thmS, gfc.thm[3].l[sb]);
	        }
	
	        athlower *= ( Encoder.BLKSIZE_s / Encoder.BLKSIZE);
	        for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
	            for (var sblock = 0; sblock < 3; sblock++) {
	                var thmLR, thmM, thmS, ath;
	                ath = (gfc.ATH.cb_s[gfc.bm_s[sb]]) * athlower;
	                thmLR = Math.min(Math.max(gfc.thm[0].s[sb][sblock], ath),
	                    Math.max(gfc.thm[1].s[sb][sblock], ath));
	                thmM = Math.max(gfc.thm[2].s[sb][sblock], ath);
	                thmS = Math.max(gfc.thm[3].s[sb][sblock], ath);
	
	                if (thmLR * msfix < thmM + thmS) {
	                    var f = thmLR * msfix / (thmM + thmS);
	                    thmM *= f;
	                    thmS *= f;
	                    assert(thmM + thmS > 0);
	                }
	                gfc.thm[2].s[sb][sblock] = Math.min(gfc.thm[2].s[sb][sblock],
	                    thmM);
	                gfc.thm[3].s[sb][sblock] = Math.min(gfc.thm[3].s[sb][sblock],
	                    thmS);
	            }
	        }
	    }
	
	    /**
	     * short block threshold calculation (part 2)
	     *
	     * partition band bo_s[sfb] is at the transition from scalefactor band sfb
	     * to the next one sfb+1; enn and thmm have to be split between them
	     */
	    function convert_partition2scalefac_s(gfc, eb, thr, chn, sblock) {
	        var sb, b;
	        var enn = 0.0;
	        var thmm = 0.0;
	        for (sb = b = 0; sb < Encoder.SBMAX_s; ++b, ++sb) {
	            var bo_s_sb = gfc.bo_s[sb];
	            var npart_s = gfc.npart_s;
	            var b_lim = bo_s_sb < npart_s ? bo_s_sb : npart_s;
	            while (b < b_lim) {
	                assert(eb[b] >= 0);
	                // iff failed, it may indicate some index error elsewhere
	                assert(thr[b] >= 0);
	                enn += eb[b];
	                thmm += thr[b];
	                b++;
	            }
	            gfc.en[chn].s[sb][sblock] = enn;
	            gfc.thm[chn].s[sb][sblock] = thmm;
	
	            if (b >= npart_s) {
	                ++sb;
	                break;
	            }
	            assert(eb[b] >= 0);
	            // iff failed, it may indicate some index error elsewhere
	            assert(thr[b] >= 0);
	            {
	                /* at transition sfb . sfb+1 */
	                var w_curr = gfc.PSY.bo_s_weight[sb];
	                var w_next = 1.0 - w_curr;
	                enn = w_curr * eb[b];
	                thmm = w_curr * thr[b];
	                gfc.en[chn].s[sb][sblock] += enn;
	                gfc.thm[chn].s[sb][sblock] += thmm;
	                enn = w_next * eb[b];
	                thmm = w_next * thr[b];
	            }
	        }
	        /* zero initialize the rest */
	        for (; sb < Encoder.SBMAX_s; ++sb) {
	            gfc.en[chn].s[sb][sblock] = 0;
	            gfc.thm[chn].s[sb][sblock] = 0;
	        }
	    }
	
	    /**
	     * longblock threshold calculation (part 2)
	     */
	    function convert_partition2scalefac_l(gfc, eb, thr, chn) {
	        var sb, b;
	        var enn = 0.0;
	        var thmm = 0.0;
	        for (sb = b = 0; sb < Encoder.SBMAX_l; ++b, ++sb) {
	            var bo_l_sb = gfc.bo_l[sb];
	            var npart_l = gfc.npart_l;
	            var b_lim = bo_l_sb < npart_l ? bo_l_sb : npart_l;
	            while (b < b_lim) {
	                assert(eb[b] >= 0);
	                // iff failed, it may indicate some index error elsewhere
	                assert(thr[b] >= 0);
	                enn += eb[b];
	                thmm += thr[b];
	                b++;
	            }
	            gfc.en[chn].l[sb] = enn;
	            gfc.thm[chn].l[sb] = thmm;
	
	            if (b >= npart_l) {
	                ++sb;
	                break;
	            }
	            assert(eb[b] >= 0);
	            assert(thr[b] >= 0);
	            {
	                /* at transition sfb . sfb+1 */
	                var w_curr = gfc.PSY.bo_l_weight[sb];
	                var w_next = 1.0 - w_curr;
	                enn = w_curr * eb[b];
	                thmm = w_curr * thr[b];
	                gfc.en[chn].l[sb] += enn;
	                gfc.thm[chn].l[sb] += thmm;
	                enn = w_next * eb[b];
	                thmm = w_next * thr[b];
	            }
	        }
	        /* zero initialize the rest */
	        for (; sb < Encoder.SBMAX_l; ++sb) {
	            gfc.en[chn].l[sb] = 0;
	            gfc.thm[chn].l[sb] = 0;
	        }
	    }
	
	    function compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
	        var gfc = gfp.internal_flags;
	        var j, b;
	
	        for (b = j = 0; b < gfc.npart_s; ++b) {
	            var ebb = 0, m = 0;
	            var n = gfc.numlines_s[b];
	            for (var i = 0; i < n; ++i, ++j) {
	                var el = fftenergy_s[sblock][j];
	                ebb += el;
	                if (m < el)
	                    m = el;
	            }
	            eb[b] = ebb;
	        }
	        assert(b == gfc.npart_s);
	        assert(j == 129);
	        for (j = b = 0; b < gfc.npart_s; b++) {
	            var kk = gfc.s3ind_s[b][0];
	            var ecb = gfc.s3_ss[j++] * eb[kk];
	            ++kk;
	            while (kk <= gfc.s3ind_s[b][1]) {
	                ecb += gfc.s3_ss[j] * eb[kk];
	                ++j;
	                ++kk;
	            }
	
	            { /* limit calculated threshold by previous granule */
	                var x = rpelev_s * gfc.nb_s1[chn][b];
	                thr[b] = Math.min(ecb, x);
	            }
	            if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE) {
	                /* limit calculated threshold by even older granule */
	                var x = rpelev2_s * gfc.nb_s2[chn][b];
	                var y = thr[b];
	                thr[b] = Math.min(x, y);
	            }
	
	            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
	            gfc.nb_s1[chn][b] = ecb;
	            assert(thr[b] >= 0);
	        }
	        for (; b <= Encoder.CBANDS; ++b) {
	            eb[b] = 0;
	            thr[b] = 0;
	        }
	    }
	
	    function block_type_set(gfp, uselongblock, blocktype_d, blocktype) {
	        var gfc = gfp.internal_flags;
	
	        if (gfp.short_blocks == ShortBlock.short_block_coupled
	                /* force both channels to use the same block type */
	                /* this is necessary if the frame is to be encoded in ms_stereo. */
	                /* But even without ms_stereo, FhG does this */
	            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
	            uselongblock[0] = uselongblock[1] = 0;
	
	        /*
	         * update the blocktype of the previous granule, since it depends on
	         * what happend in this granule
	         */
	        for (var chn = 0; chn < gfc.channels_out; chn++) {
	            blocktype[chn] = Encoder.NORM_TYPE;
	            /* disable short blocks */
	            if (gfp.short_blocks == ShortBlock.short_block_dispensed)
	                uselongblock[chn] = 1;
	            if (gfp.short_blocks == ShortBlock.short_block_forced)
	                uselongblock[chn] = 0;
	
	            if (uselongblock[chn] != 0) {
	                /* no attack : use long blocks */
	                assert(gfc.blocktype_old[chn] != Encoder.START_TYPE);
	                if (gfc.blocktype_old[chn] == Encoder.SHORT_TYPE)
	                    blocktype[chn] = Encoder.STOP_TYPE;
	            } else {
	                /* attack : use short blocks */
	                blocktype[chn] = Encoder.SHORT_TYPE;
	                if (gfc.blocktype_old[chn] == Encoder.NORM_TYPE) {
	                    gfc.blocktype_old[chn] = Encoder.START_TYPE;
	                }
	                if (gfc.blocktype_old[chn] == Encoder.STOP_TYPE)
	                    gfc.blocktype_old[chn] = Encoder.SHORT_TYPE;
	            }
	
	            blocktype_d[chn] = gfc.blocktype_old[chn];
	            // value returned to calling program
	            gfc.blocktype_old[chn] = blocktype[chn];
	            // save for next call to l3psy_anal
	        }
	    }
	
	    function NS_INTERP(x, y, r) {
	        /* was pow((x),(r))*pow((y),1-(r)) */
	        if (r >= 1.0) {
	            /* 99.7% of the time */
	            return x;
	        }
	        if (r <= 0.0)
	            return y;
	        if (y > 0.0) {
	            /* rest of the time */
	            return (Math.pow(x / y, r) * y);
	        }
	        /* never happens */
	        return 0.0;
	    }
	
	    /**
	     * these values are tuned only for 44.1kHz...
	     */
	    var regcoef_s = [11.8, 13.6, 17.2, 32, 46.5,
	        51.3, 57.5, 67.1, 71.5, 84.6, 97.6, 130,
	        /* 255.8 */
	    ];
	
	    function pecalc_s(mr, masking_lower) {
	        var pe_s = 1236.28 / 4;
	        for (var sb = 0; sb < Encoder.SBMAX_s - 1; sb++) {
	            for (var sblock = 0; sblock < 3; sblock++) {
	                var thm = mr.thm.s[sb][sblock];
	                assert(sb < regcoef_s.length);
	                if (thm > 0.0) {
	                    var x = thm * masking_lower;
	                    var en = mr.en.s[sb][sblock];
	                    if (en > x) {
	                        if (en > x * 1e10) {
	                            pe_s += regcoef_s[sb] * (10.0 * LOG10);
	                        } else {
	                            assert(x > 0);
	                            pe_s += regcoef_s[sb] * Util.FAST_LOG10(en / x);
	                        }
	                    }
	                }
	            }
	        }
	
	        return pe_s;
	    }
	
	    /**
	     * these values are tuned only for 44.1kHz...
	     */
	    var regcoef_l = [6.8, 5.8, 5.8, 6.4, 6.5, 9.9,
	        12.1, 14.4, 15, 18.9, 21.6, 26.9, 34.2, 40.2, 46.8, 56.5,
	        60.7, 73.9, 85.7, 93.4, 126.1,
	        /* 241.3 */
	    ];
	
	    function pecalc_l(mr, masking_lower) {
	        var pe_l = 1124.23 / 4;
	        for (var sb = 0; sb < Encoder.SBMAX_l - 1; sb++) {
	            var thm = mr.thm.l[sb];
	            assert(sb < regcoef_l.length);
	            if (thm > 0.0) {
	                var x = thm * masking_lower;
	                var en = mr.en.l[sb];
	                if (en > x) {
	                    if (en > x * 1e10) {
	                        pe_l += regcoef_l[sb] * (10.0 * LOG10);
	                    } else {
	                        assert(x > 0);
	                        pe_l += regcoef_l[sb] * Util.FAST_LOG10(en / x);
	                    }
	                }
	            }
	        }
	        return pe_l;
	    }
	
	    function calc_energy(gfc, fftenergy, eb, max, avg) {
	        var b, j;
	
	        for (b = j = 0; b < gfc.npart_l; ++b) {
	            var ebb = 0, m = 0;
	            var i;
	            for (i = 0; i < gfc.numlines_l[b]; ++i, ++j) {
	                var el = fftenergy[j];
	                assert(el >= 0);
	                ebb += el;
	                if (m < el)
	                    m = el;
	            }
	            eb[b] = ebb;
	            max[b] = m;
	            avg[b] = ebb * gfc.rnumlines_l[b];
	            assert(gfc.rnumlines_l[b] >= 0);
	            assert(ebb >= 0);
	            assert(eb[b] >= 0);
	            assert(max[b] >= 0);
	            assert(avg[b] >= 0);
	        }
	    }
	
	    function calc_mask_index_l(gfc, max, avg, mask_idx) {
	        var last_tab_entry = tab.length - 1;
	        var b = 0;
	        var a = avg[b] + avg[b + 1];
	        assert(a >= 0);
	        if (a > 0.0) {
	            var m = max[b];
	            if (m < max[b + 1])
	                m = max[b + 1];
	            assert((gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
	            a = 20.0 * (m * 2.0 - a)
	                / (a * (gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
	            var k = 0 | a;
	            if (k > last_tab_entry)
	                k = last_tab_entry;
	            mask_idx[b] = k;
	        } else {
	            mask_idx[b] = 0;
	        }
	
	        for (b = 1; b < gfc.npart_l - 1; b++) {
	            a = avg[b - 1] + avg[b] + avg[b + 1];
	            assert(a >= 0);
	            if (a > 0.0) {
	                var m = max[b - 1];
	                if (m < max[b])
	                    m = max[b];
	                if (m < max[b + 1])
	                    m = max[b + 1];
	                assert((gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
	                a = 20.0
	                    * (m * 3.0 - a)
	                    / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b]
	                    + gfc.numlines_l[b + 1] - 1));
	                var k = 0 | a;
	                if (k > last_tab_entry)
	                    k = last_tab_entry;
	                mask_idx[b] = k;
	            } else {
	                mask_idx[b] = 0;
	            }
	        }
	        assert(b > 0);
	        assert(b == gfc.npart_l - 1);
	
	        a = avg[b - 1] + avg[b];
	        assert(a >= 0);
	        if (a > 0.0) {
	            var m = max[b - 1];
	            if (m < max[b])
	                m = max[b];
	            assert((gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1) > 0);
	            a = 20.0 * (m * 2.0 - a)
	                / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1));
	            var k = 0 | a;
	            if (k > last_tab_entry)
	                k = last_tab_entry;
	            mask_idx[b] = k;
	        } else {
	            mask_idx[b] = 0;
	        }
	        assert(b == (gfc.npart_l - 1));
	    }
	
	    var fircoef = [
	        -8.65163e-18 * 2, -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
	        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2, 0.0931738 * 2,
	        -5.52212e-17 * 2, -0.313819 * 2
	    ];
	
	    this.L3psycho_anal_ns = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
	        /*
	         * to get a good cache performance, one has to think about the sequence,
	         * in which the variables are used.
	         */
	        var gfc = gfp.internal_flags;
	
	        /* fft and energy calculation */
	        var wsamp_L = new_float_n([2, Encoder.BLKSIZE]);
	        var wsamp_S = new_float_n([2, 3, Encoder.BLKSIZE_s]);
	
	        /* convolution */
	        var eb_l = new_float(Encoder.CBANDS + 1);
	        var eb_s = new_float(Encoder.CBANDS + 1);
	        var thr = new_float(Encoder.CBANDS + 2);
	
	        /* block type */
	        var blocktype = new_int(2), uselongblock = new_int(2);
	
	        /* usual variables like loop indices, etc.. */
	        var numchn, chn;
	        var b, i, j, k;
	        var sb, sblock;
	
	        /* variables used for --nspsytune */
	        var ns_hpfsmpl = new_float_n([2, 576]);
	        var pcfact;
	        var mask_idx_l = new_int(Encoder.CBANDS + 2), mask_idx_s = new_int(Encoder.CBANDS + 2);
	
	        Arrays.fill(mask_idx_s, 0);
	
	        numchn = gfc.channels_out;
	        /* chn=2 and 3 = Mid and Side channels */
	        if (gfp.mode == MPEGMode.JOINT_STEREO)
	            numchn = 4;
	
	        if (gfp.VBR == VbrMode.vbr_off)
	            pcfact = gfc.ResvMax == 0 ? 0 : ( gfc.ResvSize)
	            / gfc.ResvMax * 0.5;
	        else if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh
	            || gfp.VBR == VbrMode.vbr_mt) {
	            pcfact = 0.6;
	        } else
	            pcfact = 1.0;
	
	        /**********************************************************************
	         * Apply HPF of fs/4 to the input signal. This is used for attack
	         * detection / handling.
	         **********************************************************************/
	        /* Don't copy the input buffer into a temporary buffer */
	        /* unroll the loop 2 times */
	        for (chn = 0; chn < gfc.channels_out; chn++) {
	            /* apply high pass filter of fs/4 */
	            var firbuf = buffer[chn];
	            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
	            assert(fircoef.length == ((NSFIRLEN - 1) / 2));
	            for (i = 0; i < 576; i++) {
	                var sum1, sum2;
	                sum1 = firbuf[firbufPos + i + 10];
	                sum2 = 0.0;
	                for (j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
	                    sum1 += fircoef[j]
	                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
	                        + NSFIRLEN - j]);
	                    sum2 += fircoef[j + 1]
	                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
	                        + i + NSFIRLEN - j - 1]);
	                }
	                ns_hpfsmpl[chn][i] = sum1 + sum2;
	            }
	            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
	            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
	            if (numchn > 2) {
	                /* MS maskings */
	                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
	                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
	                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
	            }
	        }
	
	        for (chn = 0; chn < numchn; chn++) {
	            var wsamp_l;
	            var wsamp_s;
	            var en_subshort = new_float(12);
	            var en_short = [0, 0, 0, 0];
	            var attack_intensity = new_float(12);
	            var ns_uselongblock = 1;
	            var attackThreshold;
	            var max = new_float(Encoder.CBANDS), avg = new_float(Encoder.CBANDS);
	            var ns_attacks = [0, 0, 0, 0];
	            var fftenergy = new_float(Encoder.HBLKSIZE);
	            var fftenergy_s = new_float_n([3, Encoder.HBLKSIZE_s]);
	
	            /*
	             * rh 20040301: the following loops do access one off the limits so
	             * I increase the array dimensions by one and initialize the
	             * accessed values to zero
	             */
	            assert(gfc.npart_s <= Encoder.CBANDS);
	            assert(gfc.npart_l <= Encoder.CBANDS);
	
	            /***************************************************************
	             * determine the block type (window type)
	             ***************************************************************/
	            /* calculate energies of each sub-shortblocks */
	            for (i = 0; i < 3; i++) {
	                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
	                assert(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
	                attack_intensity[i] = en_subshort[i]
	                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
	                en_short[0] += en_subshort[i];
	            }
	
	            if (chn == 2) {
	                for (i = 0; i < 576; i++) {
	                    var l, r;
	                    l = ns_hpfsmpl[0][i];
	                    r = ns_hpfsmpl[1][i];
	                    ns_hpfsmpl[0][i] = l + r;
	                    ns_hpfsmpl[1][i] = l - r;
	                }
	            }
	            {
	                var pf = ns_hpfsmpl[chn & 1];
	                var pfPos = 0;
	                for (i = 0; i < 9; i++) {
	                    var pfe = pfPos + 576 / 9;
	                    var p = 1.;
	                    for (; pfPos < pfe; pfPos++)
	                        if (p < Math.abs(pf[pfPos]))
	                            p = Math.abs(pf[pfPos]);
	
	                    gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
	                    en_short[1 + i / 3] += p;
	                    if (p > en_subshort[i + 3 - 2]) {
	                        assert(en_subshort[i + 3 - 2] > 0);
	                        p = p / en_subshort[i + 3 - 2];
	                    } else if (en_subshort[i + 3 - 2] > p * 10.0) {
	                        assert(p > 0);
	                        p = en_subshort[i + 3 - 2] / (p * 10.0);
	                    } else
	                        p = 0.0;
	                    attack_intensity[i + 3] = p;
	                }
	            }
	
	            if (gfp.analysis) {
	                var x = attack_intensity[0];
	                for (i = 1; i < 12; i++)
	                    if (x < attack_intensity[i])
	                        x = attack_intensity[i];
	                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
	                gfc.pinfo.ers_save[chn] = x;
	            }
	
	            /* compare energies between sub-shortblocks */
	            attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
	                : gfc.nsPsy.attackthre;
	            for (i = 0; i < 12; i++)
	                if (0 == ns_attacks[i / 3]
	                    && attack_intensity[i] > attackThreshold)
	                    ns_attacks[i / 3] = (i % 3) + 1;
	
	            /*
	             * should have energy change between short blocks, in order to avoid
	             * periodic signals
	             */
	            for (i = 1; i < 4; i++) {
	                var ratio;
	                if (en_short[i - 1] > en_short[i]) {
	                    assert(en_short[i] > 0);
	                    ratio = en_short[i - 1] / en_short[i];
	                } else {
	                    assert(en_short[i - 1] > 0);
	                    ratio = en_short[i] / en_short[i - 1];
	                }
	                if (ratio < 1.7) {
	                    ns_attacks[i] = 0;
	                    if (i == 1)
	                        ns_attacks[0] = 0;
	                }
	            }
	
	            if (ns_attacks[0] != 0 && gfc.nsPsy.lastAttacks[chn] != 0)
	                ns_attacks[0] = 0;
	
	            if (gfc.nsPsy.lastAttacks[chn] == 3
	                || (ns_attacks[0] + ns_attacks[1] + ns_attacks[2] + ns_attacks[3]) != 0) {
	                ns_uselongblock = 0;
	
	                if (ns_attacks[1] != 0 && ns_attacks[0] != 0)
	                    ns_attacks[1] = 0;
	                if (ns_attacks[2] != 0 && ns_attacks[1] != 0)
	                    ns_attacks[2] = 0;
	                if (ns_attacks[3] != 0 && ns_attacks[2] != 0)
	                    ns_attacks[3] = 0;
	            }
	
	            if (chn < 2) {
	                uselongblock[chn] = ns_uselongblock;
	            } else {
	                if (ns_uselongblock == 0) {
	                    uselongblock[0] = uselongblock[1] = 0;
	                }
	            }
	
	            /*
	             * there is a one granule delay. Copy maskings computed last call
	             * into masking_ratio to return to calling program.
	             */
	            energy[chn] = gfc.tot_ener[chn];
	
	            /*********************************************************************
	             * compute FFTs
	             *********************************************************************/
	            wsamp_s = wsamp_S;
	            wsamp_l = wsamp_L;
	            compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, (chn & 1),
	                wsamp_s, (chn & 1), gr_out, chn, buffer, bufPos);
	
	            /*********************************************************************
	             * Calculate the energy and the tonality of each partition.
	             *********************************************************************/
	            calc_energy(gfc, fftenergy, eb_l, max, avg);
	            calc_mask_index_l(gfc, max, avg, mask_idx_l);
	            /* compute masking thresholds for short blocks */
	            for (sblock = 0; sblock < 3; sblock++) {
	                var enn, thmm;
	                compute_masking_s(gfp, fftenergy_s, eb_s, thr, chn, sblock);
	                convert_partition2scalefac_s(gfc, eb_s, thr, chn, sblock);
	                /**** short block pre-echo control ****/
	                for (sb = 0; sb < Encoder.SBMAX_s; sb++) {
	                    thmm = gfc.thm[chn].s[sb][sblock];
	
	                    thmm *= NS_PREECHO_ATT0;
	                    if (ns_attacks[sblock] >= 2 || ns_attacks[sblock + 1] == 1) {
	                        var idx = (sblock != 0) ? sblock - 1 : 2;
	                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                            NS_PREECHO_ATT1 * pcfact);
	                        thmm = Math.min(thmm, p);
	                    }
	
	                    if (ns_attacks[sblock] == 1) {
	                        var idx = (sblock != 0) ? sblock - 1 : 2;
	                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                            NS_PREECHO_ATT2 * pcfact);
	                        thmm = Math.min(thmm, p);
	                    } else if ((sblock != 0 && ns_attacks[sblock - 1] == 3)
	                        || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
	                        var idx = (sblock != 2) ? sblock + 1 : 0;
	                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                            NS_PREECHO_ATT2 * pcfact);
	                        thmm = Math.min(thmm, p);
	                    }
	
	                    /* pulse like signal detection for fatboy.wav and so on */
	                    enn = en_subshort[sblock * 3 + 3]
	                        + en_subshort[sblock * 3 + 4]
	                        + en_subshort[sblock * 3 + 5];
	                    if (en_subshort[sblock * 3 + 5] * 6 < enn) {
	                        thmm *= 0.5;
	                        if (en_subshort[sblock * 3 + 4] * 6 < enn)
	                            thmm *= 0.5;
	                    }
	
	                    gfc.thm[chn].s[sb][sblock] = thmm;
	                }
	            }
	            gfc.nsPsy.lastAttacks[chn] = ns_attacks[2];
	
	            /*********************************************************************
	             * convolve the partitioned energy and unpredictability with the
	             * spreading function, s3_l[b][k]
	             ********************************************************************/
	            k = 0;
	            {
	                for (b = 0; b < gfc.npart_l; b++) {
	                    /*
	                     * convolve the partitioned energy with the spreading
	                     * function
	                     */
	                    var kk = gfc.s3ind[b][0];
	                    var eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
	                    var ecb = gfc.s3_ll[k++] * eb2;
	                    while (++kk <= gfc.s3ind[b][1]) {
	                        eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
	                        ecb = mask_add(ecb, gfc.s3_ll[k++] * eb2, kk, kk - b,
	                            gfc, 0);
	                    }
	                    ecb *= 0.158489319246111;
	                    /* pow(10,-0.8) */
	
	                    /**** long block pre-echo control ****/
	                    /**
	                     * <PRE>
	                     * dont use long block pre-echo control if previous granule was
	                     * a short block.  This is to avoid the situation:
	                     * frame0:  quiet (very low masking)
	                     * frame1:  surge  (triggers short blocks)
	                     * frame2:  regular frame.  looks like pre-echo when compared to
	                     *          frame0, but all pre-echo was in frame1.
	                     * </PRE>
	                     */
	                    /*
	                     * chn=0,1 L and R channels
	                     *
	                     * chn=2,3 S and M channels.
	                     */
	
	                    if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE)
	                        thr[b] = ecb;
	                    else
	                        thr[b] = NS_INTERP(
	                            Math.min(ecb, Math.min(rpelev
	                                * gfc.nb_1[chn][b], rpelev2
	                                * gfc.nb_2[chn][b])), ecb, pcfact);
	
	                    gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
	                    gfc.nb_1[chn][b] = ecb;
	                }
	            }
	            for (; b <= Encoder.CBANDS; ++b) {
	                eb_l[b] = 0;
	                thr[b] = 0;
	            }
	            /* compute masking thresholds for long blocks */
	            convert_partition2scalefac_l(gfc, eb_l, thr, chn);
	        }
	        /* end loop over chn */
	
	        if (gfp.mode == MPEGMode.STEREO || gfp.mode == MPEGMode.JOINT_STEREO) {
	            if (gfp.interChRatio > 0.0) {
	                calc_interchannel_masking(gfp, gfp.interChRatio);
	            }
	        }
	
	        if (gfp.mode == MPEGMode.JOINT_STEREO) {
	            var msfix;
	            msfix1(gfc);
	            msfix = gfp.msfix;
	            if (Math.abs(msfix) > 0.0)
	                ns_msfix(gfc, msfix, gfp.ATHlower * gfc.ATH.adjust);
	        }
	
	        /***************************************************************
	         * determine final block type
	         ***************************************************************/
	        block_type_set(gfp, uselongblock, blocktype_d, blocktype);
	
	        /*********************************************************************
	         * compute the value of PE to return ... no delay and advance
	         *********************************************************************/
	        for (chn = 0; chn < numchn; chn++) {
	            var ppe;
	            var ppePos = 0;
	            var type;
	            var mr;
	
	            if (chn > 1) {
	                ppe = percep_MS_entropy;
	                ppePos = -2;
	                type = Encoder.NORM_TYPE;
	                if (blocktype_d[0] == Encoder.SHORT_TYPE
	                    || blocktype_d[1] == Encoder.SHORT_TYPE)
	                    type = Encoder.SHORT_TYPE;
	                mr = masking_MS_ratio[gr_out][chn - 2];
	            } else {
	                ppe = percep_entropy;
	                ppePos = 0;
	                type = blocktype_d[chn];
	                mr = masking_ratio[gr_out][chn];
	            }
	
	            if (type == Encoder.SHORT_TYPE)
	                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
	            else
	                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
	
	            if (gfp.analysis)
	                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
	
	        }
	        return 0;
	    }
	
	    function vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out, fftenergy, wsamp_l, wsamp_lPos) {
	        var gfc = gfp.internal_flags;
	        if (chn < 2) {
	            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
	        } else if (chn == 2) {
	            /* FFT data for mid and side channel is derived from L & R */
	            for (var j = Encoder.BLKSIZE - 1; j >= 0; --j) {
	                var l = wsamp_l[wsamp_lPos + 0][j];
	                var r = wsamp_l[wsamp_lPos + 1][j];
	                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
	                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
	            }
	        }
	
	        /*********************************************************************
	         * compute energies
	         *********************************************************************/
	        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
	        fftenergy[0] *= fftenergy[0];
	
	        for (var j = Encoder.BLKSIZE / 2 - 1; j >= 0; --j) {
	            var re = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 - j];
	            var im = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 + j];
	            fftenergy[Encoder.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
	                * re + im * im) * 0.5);
	        }
	        /* total energy */
	        {
	            var totalenergy = 0.0;
	            for (var j = 11; j < Encoder.HBLKSIZE; j++)
	                totalenergy += fftenergy[j];
	
	            gfc.tot_ener[chn] = totalenergy;
	        }
	
	        if (gfp.analysis) {
	            for (var j = 0; j < Encoder.HBLKSIZE; j++) {
	                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
	                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
	            }
	            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
	        }
	    }
	
	    function vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock, fftenergy_s, wsamp_s, wsamp_sPos) {
	        var gfc = gfp.internal_flags;
	
	        if (sblock == 0 && chn < 2) {
	            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
	        }
	        if (chn == 2) {
	            /* FFT data for mid and side channel is derived from L & R */
	            for (var j = Encoder.BLKSIZE_s - 1; j >= 0; --j) {
	                var l = wsamp_s[wsamp_sPos + 0][sblock][j];
	                var r = wsamp_s[wsamp_sPos + 1][sblock][j];
	                wsamp_s[wsamp_sPos + 0][sblock][j] = (l + r) * Util.SQRT2 * 0.5;
	                wsamp_s[wsamp_sPos + 1][sblock][j] = (l - r) * Util.SQRT2 * 0.5;
	            }
	        }
	
	        /*********************************************************************
	         * compute energies
	         *********************************************************************/
	        fftenergy_s[sblock][0] = wsamp_s[wsamp_sPos + 0][sblock][0];
	        fftenergy_s[sblock][0] *= fftenergy_s[sblock][0];
	        for (var j = Encoder.BLKSIZE_s / 2 - 1; j >= 0; --j) {
	            var re = wsamp_s[wsamp_sPos + 0][sblock][Encoder.BLKSIZE_s / 2 - j];
	            var im = wsamp_s[wsamp_sPos + 0][sblock][Encoder.BLKSIZE_s / 2 + j];
	            fftenergy_s[sblock][Encoder.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
	                * re + im * im) * 0.5);
	        }
	    }
	
	    /**
	     * compute loudness approximation (used for ATH auto-level adjustment)
	     */
	    function vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn, fftenergy) {
	        var gfc = gfp.internal_flags;
	        if (gfp.athaa_loudapprox == 2 && chn < 2) {
	            // no loudness for mid/side ch
	            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
	            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
	        }
	    }
	
	    var fircoef_ = [-8.65163e-18 * 2,
	        -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
	        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2,
	        0.0931738 * 2, -5.52212e-17 * 2, -0.313819 * 2];
	
	    /**
	     * Apply HPF of fs/4 to the input signal. This is used for attack detection
	     * / handling.
	     */
	    function vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, energy, sub_short_factor, ns_attacks, uselongblock) {
	        var ns_hpfsmpl = new_float_n([2, 576]);
	        var gfc = gfp.internal_flags;
	        var n_chn_out = gfc.channels_out;
	        /* chn=2 and 3 = Mid and Side channels */
	        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4 : n_chn_out;
	        /* Don't copy the input buffer into a temporary buffer */
	        /* unroll the loop 2 times */
	        for (var chn = 0; chn < n_chn_out; chn++) {
	            /* apply high pass filter of fs/4 */
	            firbuf = buffer[chn];
	            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
	            assert(fircoef_.length == ((NSFIRLEN - 1) / 2));
	            for (var i = 0; i < 576; i++) {
	                var sum1, sum2;
	                sum1 = firbuf[firbufPos + i + 10];
	                sum2 = 0.0;
	                for (var j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
	                    sum1 += fircoef_[j]
	                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
	                        + NSFIRLEN - j]);
	                    sum2 += fircoef_[j + 1]
	                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
	                        + i + NSFIRLEN - j - 1]);
	                }
	                ns_hpfsmpl[chn][i] = sum1 + sum2;
	            }
	            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
	            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
	            if (n_chn_psy > 2) {
	                /* MS maskings */
	                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
	                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
	                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
	            }
	        }
	        for (var chn = 0; chn < n_chn_psy; chn++) {
	            var attack_intensity = new_float(12);
	            var en_subshort = new_float(12);
	            var en_short = [0, 0, 0, 0];
	            var pf = ns_hpfsmpl[chn & 1];
	            var pfPos = 0;
	            var attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
	                : gfc.nsPsy.attackthre;
	            var ns_uselongblock = 1;
	
	            if (chn == 2) {
	                for (var i = 0, j = 576; j > 0; ++i, --j) {
	                    var l = ns_hpfsmpl[0][i];
	                    var r = ns_hpfsmpl[1][i];
	                    ns_hpfsmpl[0][i] = l + r;
	                    ns_hpfsmpl[1][i] = l - r;
	                }
	            }
	            /***************************************************************
	             * determine the block type (window type)
	             ***************************************************************/
	            /* calculate energies of each sub-shortblocks */
	            for (var i = 0; i < 3; i++) {
	                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
	                assert(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
	                attack_intensity[i] = en_subshort[i]
	                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
	                en_short[0] += en_subshort[i];
	            }
	
	            for (var i = 0; i < 9; i++) {
	                var pfe = pfPos + 576 / 9;
	                var p = 1.;
	                for (; pfPos < pfe; pfPos++)
	                    if (p < Math.abs(pf[pfPos]))
	                        p = Math.abs(pf[pfPos]);
	
	                gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
	                en_short[1 + i / 3] += p;
	                if (p > en_subshort[i + 3 - 2]) {
	                    assert(en_subshort[i + 3 - 2] > 0);
	                    p = p / en_subshort[i + 3 - 2];
	                } else if (en_subshort[i + 3 - 2] > p * 10.0) {
	                    assert(p > 0);
	                    p = en_subshort[i + 3 - 2] / (p * 10.0);
	                } else {
	                    p = 0.0;
	                }
	                attack_intensity[i + 3] = p;
	            }
	            /* pulse like signal detection for fatboy.wav and so on */
	            for (var i = 0; i < 3; ++i) {
	                var enn = en_subshort[i * 3 + 3]
	                    + en_subshort[i * 3 + 4] + en_subshort[i * 3 + 5];
	                var factor = 1.;
	                if (en_subshort[i * 3 + 5] * 6 < enn) {
	                    factor *= 0.5;
	                    if (en_subshort[i * 3 + 4] * 6 < enn) {
	                        factor *= 0.5;
	                    }
	                }
	                sub_short_factor[chn][i] = factor;
	            }
	
	            if (gfp.analysis) {
	                var x = attack_intensity[0];
	                for (var i = 1; i < 12; i++) {
	                    if (x < attack_intensity[i]) {
	                        x = attack_intensity[i];
	                    }
	                }
	                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
	                gfc.pinfo.ers_save[chn] = x;
	            }
	
	            /* compare energies between sub-shortblocks */
	            for (var i = 0; i < 12; i++) {
	                if (0 == ns_attacks[chn][i / 3]
	                    && attack_intensity[i] > attackThreshold) {
	                    ns_attacks[chn][i / 3] = (i % 3) + 1;
	                }
	            }
	
	            /*
	             * should have energy change between short blocks, in order to avoid
	             * periodic signals
	             */
	            /* Good samples to show the effect are Trumpet test songs */
	            /*
	             * GB: tuned (1) to avoid too many short blocks for test sample
	             * TRUMPET
	             */
	            /*
	             * RH: tuned (2) to let enough short blocks through for test sample
	             * FSOL and SNAPS
	             */
	            for (var i = 1; i < 4; i++) {
	                var u = en_short[i - 1];
	                var v = en_short[i];
	                var m = Math.max(u, v);
	                if (m < 40000) { /* (2) */
	                    if (u < 1.7 * v && v < 1.7 * u) { /* (1) */
	                        if (i == 1 && ns_attacks[chn][0] <= ns_attacks[chn][i]) {
	                            ns_attacks[chn][0] = 0;
	                        }
	                        ns_attacks[chn][i] = 0;
	                    }
	                }
	            }
	
	            if (ns_attacks[chn][0] <= gfc.nsPsy.lastAttacks[chn]) {
	                ns_attacks[chn][0] = 0;
	            }
	
	            if (gfc.nsPsy.lastAttacks[chn] == 3
	                || (ns_attacks[chn][0] + ns_attacks[chn][1]
	                + ns_attacks[chn][2] + ns_attacks[chn][3]) != 0) {
	                ns_uselongblock = 0;
	
	                if (ns_attacks[chn][1] != 0 && ns_attacks[chn][0] != 0) {
	                    ns_attacks[chn][1] = 0;
	                }
	                if (ns_attacks[chn][2] != 0 && ns_attacks[chn][1] != 0) {
	                    ns_attacks[chn][2] = 0;
	                }
	                if (ns_attacks[chn][3] != 0 && ns_attacks[chn][2] != 0) {
	                    ns_attacks[chn][3] = 0;
	                }
	            }
	            if (chn < 2) {
	                uselongblock[chn] = ns_uselongblock;
	            } else {
	                if (ns_uselongblock == 0) {
	                    uselongblock[0] = uselongblock[1] = 0;
	                }
	            }
	
	            /*
	             * there is a one granule delay. Copy maskings computed last call
	             * into masking_ratio to return to calling program.
	             */
	            energy[chn] = gfc.tot_ener[chn];
	        }
	    }
	
	    function vbrpsy_skip_masking_s(gfc, chn, sblock) {
	        if (sblock == 0) {
	            for (var b = 0; b < gfc.npart_s; b++) {
	                gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
	                gfc.nb_s1[chn][b] = 0;
	            }
	        }
	    }
	
	    function vbrpsy_skip_masking_l(gfc, chn) {
	        for (var b = 0; b < gfc.npart_l; b++) {
	            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
	            gfc.nb_1[chn][b] = 0;
	        }
	    }
	
	    function psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx) {
	        var last_tab_entry = tab.length - 1;
	        var b = 0;
	        var a = avg[b] + avg[b + 1];
	        assert(a >= 0);
	        if (a > 0.0) {
	            var m = max[b];
	            if (m < max[b + 1])
	                m = max[b + 1];
	            assert((gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
	            a = 20.0 * (m * 2.0 - a)
	                / (a * (gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1));
	            var k = 0 | a;
	            if (k > last_tab_entry)
	                k = last_tab_entry;
	            mask_idx[b] = k;
	        } else {
	            mask_idx[b] = 0;
	        }
	
	        for (b = 1; b < gfc.npart_s - 1; b++) {
	            a = avg[b - 1] + avg[b] + avg[b + 1];
	            assert(b + 1 < gfc.npart_s);
	            assert(a >= 0);
	            if (a > 0.0) {
	                var m = max[b - 1];
	                if (m < max[b])
	                    m = max[b];
	                if (m < max[b + 1])
	                    m = max[b + 1];
	                assert((gfc.numlines_s[b - 1] + gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
	                a = 20.0
	                    * (m * 3.0 - a)
	                    / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b]
	                    + gfc.numlines_s[b + 1] - 1));
	                var k = 0 | a;
	                if (k > last_tab_entry)
	                    k = last_tab_entry;
	                mask_idx[b] = k;
	            } else {
	                mask_idx[b] = 0;
	            }
	        }
	        assert(b > 0);
	        assert(b == gfc.npart_s - 1);
	
	        a = avg[b - 1] + avg[b];
	        assert(a >= 0);
	        if (a > 0.0) {
	            var m = max[b - 1];
	            if (m < max[b])
	                m = max[b];
	            assert((gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1) > 0);
	            a = 20.0 * (m * 2.0 - a)
	                / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1));
	            var k = 0 | a;
	            if (k > last_tab_entry)
	                k = last_tab_entry;
	            mask_idx[b] = k;
	        } else {
	            mask_idx[b] = 0;
	        }
	        assert(b == (gfc.npart_s - 1));
	    }
	
	    function vbrpsy_compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
	        var gfc = gfp.internal_flags;
	        var max = new float[Encoder.CBANDS], avg = new_float(Encoder.CBANDS);
	        var i, j, b;
	        var mask_idx_s = new int[Encoder.CBANDS];
	
	        for (b = j = 0; b < gfc.npart_s; ++b) {
	            var ebb = 0, m = 0;
	            var n = gfc.numlines_s[b];
	            for (i = 0; i < n; ++i, ++j) {
	                var el = fftenergy_s[sblock][j];
	                ebb += el;
	                if (m < el)
	                    m = el;
	            }
	            eb[b] = ebb;
	            assert(ebb >= 0);
	            max[b] = m;
	            assert(n > 0);
	            avg[b] = ebb / n;
	            assert(avg[b] >= 0);
	        }
	        assert(b == gfc.npart_s);
	        assert(j == 129);
	        for (; b < Encoder.CBANDS; ++b) {
	            max[b] = 0;
	            avg[b] = 0;
	        }
	        psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx_s);
	        for (j = b = 0; b < gfc.npart_s; b++) {
	            var kk = gfc.s3ind_s[b][0];
	            var last = gfc.s3ind_s[b][1];
	            var dd, dd_n;
	            var x, ecb, avg_mask;
	            dd = mask_idx_s[kk];
	            dd_n = 1;
	            ecb = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
	            ++j;
	            ++kk;
	            while (kk <= last) {
	                dd += mask_idx_s[kk];
	                dd_n += 1;
	                x = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
	                ecb = vbrpsy_mask_add(ecb, x, kk - b);
	                ++j;
	                ++kk;
	            }
	            dd = (1 + 2 * dd) / (2 * dd_n);
	            avg_mask = tab[dd] * 0.5;
	            ecb *= avg_mask;
	            thr[b] = ecb;
	            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
	            gfc.nb_s1[chn][b] = ecb;
	            {
	                /*
	                 * if THR exceeds EB, the quantization routines will take the
	                 * difference from other bands. in case of strong tonal samples
	                 * (tonaltest.wav) this leads to heavy distortions. that's why
	                 * we limit THR here.
	                 */
	                x = max[b];
	                x *= gfc.minval_s[b];
	                x *= avg_mask;
	                if (thr[b] > x) {
	                    thr[b] = x;
	                }
	            }
	            if (gfc.masking_lower > 1) {
	                thr[b] *= gfc.masking_lower;
	            }
	            if (thr[b] > eb[b]) {
	                thr[b] = eb[b];
	            }
	            if (gfc.masking_lower < 1) {
	                thr[b] *= gfc.masking_lower;
	            }
	
	            assert(thr[b] >= 0);
	        }
	        for (; b < Encoder.CBANDS; ++b) {
	            eb[b] = 0;
	            thr[b] = 0;
	        }
	    }
	
	    function vbrpsy_compute_masking_l(gfc, fftenergy, eb_l, thr, chn) {
	        var max = new_float(Encoder.CBANDS), avg = new_float(Encoder.CBANDS);
	        var mask_idx_l = new_int(Encoder.CBANDS + 2);
	        var b;
	
	        /*********************************************************************
	         * Calculate the energy and the tonality of each partition.
	         *********************************************************************/
	        calc_energy(gfc, fftenergy, eb_l, max, avg);
	        calc_mask_index_l(gfc, max, avg, mask_idx_l);
	
	        /*********************************************************************
	         * convolve the partitioned energy and unpredictability with the
	         * spreading function, s3_l[b][k]
	         ********************************************************************/
	        var k = 0;
	        for (b = 0; b < gfc.npart_l; b++) {
	            var x, ecb, avg_mask, t;
	            /* convolve the partitioned energy with the spreading function */
	            var kk = gfc.s3ind[b][0];
	            var last = gfc.s3ind[b][1];
	            var dd = 0, dd_n = 0;
	            dd = mask_idx_l[kk];
	            dd_n += 1;
	            ecb = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
	            ++k;
	            ++kk;
	            while (kk <= last) {
	                dd += mask_idx_l[kk];
	                dd_n += 1;
	                x = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
	                t = vbrpsy_mask_add(ecb, x, kk - b);
	                ecb = t;
	                ++k;
	                ++kk;
	            }
	            dd = (1 + 2 * dd) / (2 * dd_n);
	            avg_mask = tab[dd] * 0.5;
	            ecb *= avg_mask;
	
	            /**** long block pre-echo control ****/
	            /**
	             * <PRE>
	             * dont use long block pre-echo control if previous granule was
	             * a short block.  This is to avoid the situation:
	             * frame0:  quiet (very low masking)
	             * frame1:  surge  (triggers short blocks)
	             * frame2:  regular frame.  looks like pre-echo when compared to
	             *          frame0, but all pre-echo was in frame1.
	             * </PRE>
	             */
	            /*
	             * chn=0,1 L and R channels chn=2,3 S and M channels.
	             */
	            if (gfc.blocktype_old[chn & 0x01] == Encoder.SHORT_TYPE) {
	                var ecb_limit = rpelev * gfc.nb_1[chn][b];
	                if (ecb_limit > 0) {
	                    thr[b] = Math.min(ecb, ecb_limit);
	                } else {
	                    /**
	                     * <PRE>
	                     * Robert 071209:
	                     * Because we don't calculate long block psy when we know a granule
	                     * should be of short blocks, we don't have any clue how the granule
	                     * before would have looked like as a long block. So we have to guess
	                     * a little bit for this END_TYPE block.
	                     * Most of the time we get away with this sloppyness. (fingers crossed :)
	                     * The speed increase is worth it.
	                     * </PRE>
	                     */
	                    thr[b] = Math.min(ecb, eb_l[b] * NS_PREECHO_ATT2);
	                }
	            } else {
	                var ecb_limit_2 = rpelev2 * gfc.nb_2[chn][b];
	                var ecb_limit_1 = rpelev * gfc.nb_1[chn][b];
	                var ecb_limit;
	                if (ecb_limit_2 <= 0) {
	                    ecb_limit_2 = ecb;
	                }
	                if (ecb_limit_1 <= 0) {
	                    ecb_limit_1 = ecb;
	                }
	                if (gfc.blocktype_old[chn & 0x01] == Encoder.NORM_TYPE) {
	                    ecb_limit = Math.min(ecb_limit_1, ecb_limit_2);
	                } else {
	                    ecb_limit = ecb_limit_1;
	                }
	                thr[b] = Math.min(ecb, ecb_limit);
	            }
	            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
	            gfc.nb_1[chn][b] = ecb;
	            {
	                /*
	                 * if THR exceeds EB, the quantization routines will take the
	                 * difference from other bands. in case of strong tonal samples
	                 * (tonaltest.wav) this leads to heavy distortions. that's why
	                 * we limit THR here.
	                 */
	                x = max[b];
	                x *= gfc.minval_l[b];
	                x *= avg_mask;
	                if (thr[b] > x) {
	                    thr[b] = x;
	                }
	            }
	            if (gfc.masking_lower > 1) {
	                thr[b] *= gfc.masking_lower;
	            }
	            if (thr[b] > eb_l[b]) {
	                thr[b] = eb_l[b];
	            }
	            if (gfc.masking_lower < 1) {
	                thr[b] *= gfc.masking_lower;
	            }
	            assert(thr[b] >= 0);
	        }
	        for (; b < Encoder.CBANDS; ++b) {
	            eb_l[b] = 0;
	            thr[b] = 0;
	        }
	    }
	
	    function vbrpsy_compute_block_type(gfp, uselongblock) {
	        var gfc = gfp.internal_flags;
	
	        if (gfp.short_blocks == ShortBlock.short_block_coupled
	                /* force both channels to use the same block type */
	                /* this is necessary if the frame is to be encoded in ms_stereo. */
	                /* But even without ms_stereo, FhG does this */
	            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
	            uselongblock[0] = uselongblock[1] = 0;
	
	        for (var chn = 0; chn < gfc.channels_out; chn++) {
	            /* disable short blocks */
	            if (gfp.short_blocks == ShortBlock.short_block_dispensed) {
	                uselongblock[chn] = 1;
	            }
	            if (gfp.short_blocks == ShortBlock.short_block_forced) {
	                uselongblock[chn] = 0;
	            }
	        }
	    }
	
	    function vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d) {
	        var gfc = gfp.internal_flags;
	
	        /*
	         * update the blocktype of the previous granule, since it depends on
	         * what happend in this granule
	         */
	        for (var chn = 0; chn < gfc.channels_out; chn++) {
	            var blocktype = Encoder.NORM_TYPE;
	            /* disable short blocks */
	
	            if (uselongblock[chn] != 0) {
	                /* no attack : use long blocks */
	                assert(gfc.blocktype_old[chn] != Encoder.START_TYPE);
	                if (gfc.blocktype_old[chn] == Encoder.SHORT_TYPE)
	                    blocktype = Encoder.STOP_TYPE;
	            } else {
	                /* attack : use short blocks */
	                blocktype = Encoder.SHORT_TYPE;
	                if (gfc.blocktype_old[chn] == Encoder.NORM_TYPE) {
	                    gfc.blocktype_old[chn] = Encoder.START_TYPE;
	                }
	                if (gfc.blocktype_old[chn] == Encoder.STOP_TYPE)
	                    gfc.blocktype_old[chn] = Encoder.SHORT_TYPE;
	            }
	
	            blocktype_d[chn] = gfc.blocktype_old[chn];
	            // value returned to calling program
	            gfc.blocktype_old[chn] = blocktype;
	            // save for next call to l3psy_anal
	        }
	    }
	
	    /**
	     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
	     */
	    function vbrpsy_compute_MS_thresholds(eb, thr, cb_mld, ath_cb, athadjust, msfix, n) {
	        var msfix2 = msfix * 2;
	        var athlower = msfix > 0 ? Math.pow(10, athadjust) : 1;
	        var rside, rmid;
	        for (var b = 0; b < n; ++b) {
	            var ebM = eb[2][b];
	            var ebS = eb[3][b];
	            var thmL = thr[0][b];
	            var thmR = thr[1][b];
	            var thmM = thr[2][b];
	            var thmS = thr[3][b];
	
	            /* use this fix if L & R masking differs by 2db or less */
	            if (thmL <= 1.58 * thmR && thmR <= 1.58 * thmL) {
	                var mld_m = cb_mld[b] * ebS;
	                var mld_s = cb_mld[b] * ebM;
	                rmid = Math.max(thmM, Math.min(thmS, mld_m));
	                rside = Math.max(thmS, Math.min(thmM, mld_s));
	            } else {
	                rmid = thmM;
	                rside = thmS;
	            }
	            if (msfix > 0) {
	                /***************************************************************/
	                /* Adjust M/S maskings if user set "msfix" */
	                /***************************************************************/
	                /* Naoki Shibata 2000 */
	                var thmLR, thmMS;
	                var ath = ath_cb[b] * athlower;
	                thmLR = Math.min(Math.max(thmL, ath), Math.max(thmR, ath));
	                thmM = Math.max(rmid, ath);
	                thmS = Math.max(rside, ath);
	                thmMS = thmM + thmS;
	                if (thmMS > 0 && (thmLR * msfix2) < thmMS) {
	                    var f = thmLR * msfix2 / thmMS;
	                    thmM *= f;
	                    thmS *= f;
	                    assert(thmMS > 0);
	                }
	                rmid = Math.min(thmM, rmid);
	                rside = Math.min(thmS, rside);
	            }
	            if (rmid > ebM) {
	                rmid = ebM;
	            }
	            if (rside > ebS) {
	                rside = ebS;
	            }
	            thr[2][b] = rmid;
	            thr[3][b] = rside;
	        }
	    }
	
	    this.L3psycho_anal_vbr = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
	        var gfc = gfp.internal_flags;
	
	        /* fft and energy calculation */
	        var wsamp_l;
	        var wsamp_s;
	        var fftenergy = new_float(Encoder.HBLKSIZE);
	        var fftenergy_s = new_float_n([3, Encoder.HBLKSIZE_s]);
	        var wsamp_L = new_float_n([2, Encoder.BLKSIZE]);
	        var wsamp_S = new_float_n([2, 3, Encoder.BLKSIZE_s]);
	        var eb = new_float_n([4, Encoder.CBANDS]), thr = new_float_n([4, Encoder.CBANDS]);
	        var sub_short_factor = new_float_n([4, 3]);
	        var pcfact = 0.6;
	
	        /* block type */
	        var ns_attacks = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0],
	            [0, 0, 0, 0]];
	        var uselongblock = new_int(2);
	
	        /* usual variables like loop indices, etc.. */
	
	        /* chn=2 and 3 = Mid and Side channels */
	        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4
	            : gfc.channels_out;
	
	        vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio,
	            masking_MS_ratio, energy, sub_short_factor, ns_attacks,
	            uselongblock);
	
	        vbrpsy_compute_block_type(gfp, uselongblock);
	
	        /* LONG BLOCK CASE */
	        {
	            for (var chn = 0; chn < n_chn_psy; chn++) {
	                var ch01 = chn & 0x01;
	                wsamp_l = wsamp_L;
	                vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out,
	                    fftenergy, wsamp_l, ch01);
	
	                vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn,
	                    fftenergy);
	
	                if (uselongblock[ch01] != 0) {
	                    vbrpsy_compute_masking_l(gfc, fftenergy, eb[chn], thr[chn],
	                        chn);
	                } else {
	                    vbrpsy_skip_masking_l(gfc, chn);
	                }
	            }
	            if ((uselongblock[0] + uselongblock[1]) == 2) {
	                /* M/S channel */
	                if (gfp.mode == MPEGMode.JOINT_STEREO) {
	                    vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_l,
	                        gfc.ATH.cb_l, gfp.ATHlower * gfc.ATH.adjust,
	                        gfp.msfix, gfc.npart_l);
	                }
	            }
	            /* TODO: apply adaptive ATH masking here ?? */
	            for (var chn = 0; chn < n_chn_psy; chn++) {
	                var ch01 = chn & 0x01;
	                if (uselongblock[ch01] != 0) {
	                    convert_partition2scalefac_l(gfc, eb[chn], thr[chn], chn);
	                }
	            }
	        }
	
	        /* SHORT BLOCKS CASE */
	        {
	            for (var sblock = 0; sblock < 3; sblock++) {
	                for (var chn = 0; chn < n_chn_psy; ++chn) {
	                    var ch01 = chn & 0x01;
	
	                    if (uselongblock[ch01] != 0) {
	                        vbrpsy_skip_masking_s(gfc, chn, sblock);
	                    } else {
	                        /* compute masking thresholds for short blocks */
	                        wsamp_s = wsamp_S;
	                        vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock,
	                            fftenergy_s, wsamp_s, ch01);
	                        vbrpsy_compute_masking_s(gfp, fftenergy_s, eb[chn],
	                            thr[chn], chn, sblock);
	                    }
	                }
	                if ((uselongblock[0] + uselongblock[1]) == 0) {
	                    /* M/S channel */
	                    if (gfp.mode == MPEGMode.JOINT_STEREO) {
	                        vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_s,
	                            gfc.ATH.cb_s, gfp.ATHlower * gfc.ATH.adjust,
	                            gfp.msfix, gfc.npart_s);
	                    }
	                    /* L/R channel */
	                }
	                /* TODO: apply adaptive ATH masking here ?? */
	                for (var chn = 0; chn < n_chn_psy; ++chn) {
	                    var ch01 = chn & 0x01;
	                    if (0 == uselongblock[ch01]) {
	                        convert_partition2scalefac_s(gfc, eb[chn], thr[chn],
	                            chn, sblock);
	                    }
	                }
	            }
	
	            /**** short block pre-echo control ****/
	            for (var chn = 0; chn < n_chn_psy; chn++) {
	                var ch01 = chn & 0x01;
	
	                if (uselongblock[ch01] != 0) {
	                    continue;
	                }
	                for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
	                    var new_thmm = new_float(3);
	                    for (var sblock = 0; sblock < 3; sblock++) {
	                        var thmm = gfc.thm[chn].s[sb][sblock];
	                        thmm *= NS_PREECHO_ATT0;
	
	                        if (ns_attacks[chn][sblock] >= 2
	                            || ns_attacks[chn][sblock + 1] == 1) {
	                            var idx = (sblock != 0) ? sblock - 1 : 2;
	                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                                NS_PREECHO_ATT1 * pcfact);
	                            thmm = Math.min(thmm, p);
	                        } else if (ns_attacks[chn][sblock] == 1) {
	                            var idx = (sblock != 0) ? sblock - 1 : 2;
	                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                                NS_PREECHO_ATT2 * pcfact);
	                            thmm = Math.min(thmm, p);
	                        } else if ((sblock != 0 && ns_attacks[chn][sblock - 1] == 3)
	                            || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
	                            var idx = (sblock != 2) ? sblock + 1 : 0;
	                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
	                                NS_PREECHO_ATT2 * pcfact);
	                            thmm = Math.min(thmm, p);
	                        }
	
	                        /* pulse like signal detection for fatboy.wav and so on */
	                        thmm *= sub_short_factor[chn][sblock];
	
	                        new_thmm[sblock] = thmm;
	                    }
	                    for (var sblock = 0; sblock < 3; sblock++) {
	                        gfc.thm[chn].s[sb][sblock] = new_thmm[sblock];
	                    }
	                }
	            }
	        }
	        for (var chn = 0; chn < n_chn_psy; chn++) {
	            gfc.nsPsy.lastAttacks[chn] = ns_attacks[chn][2];
	        }
	
	        /***************************************************************
	         * determine final block type
	         ***************************************************************/
	        vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d);
	
	        /*********************************************************************
	         * compute the value of PE to return ... no delay and advance
	         *********************************************************************/
	        for (var chn = 0; chn < n_chn_psy; chn++) {
	            var ppe;
	            var ppePos;
	            var type;
	            var mr;
	
	            if (chn > 1) {
	                ppe = percep_MS_entropy;
	                ppePos = -2;
	                type = Encoder.NORM_TYPE;
	                if (blocktype_d[0] == Encoder.SHORT_TYPE
	                    || blocktype_d[1] == Encoder.SHORT_TYPE)
	                    type = Encoder.SHORT_TYPE;
	                mr = masking_MS_ratio[gr_out][chn - 2];
	            } else {
	                ppe = percep_entropy;
	                ppePos = 0;
	                type = blocktype_d[chn];
	                mr = masking_ratio[gr_out][chn];
	            }
	
	            if (type == Encoder.SHORT_TYPE) {
	                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
	            } else {
	                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
	            }
	
	            if (gfp.analysis) {
	                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
	            }
	        }
	        return 0;
	    }
	
	    function s3_func_x(bark, hf_slope) {
	        var tempx = bark, tempy;
	
	        if (tempx >= 0) {
	            tempy = -tempx * 27;
	        } else {
	            tempy = tempx * hf_slope;
	        }
	        if (tempy <= -72.0) {
	            return 0;
	        }
	        return Math.exp(tempy * LN_TO_LOG10);
	    }
	
	    function norm_s3_func_x(hf_slope) {
	        var lim_a = 0, lim_b = 0;
	        {
	            var x = 0, l, h;
	            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x -= 1)
	                ;
	            l = x;
	            h = 0;
	            while (Math.abs(h - l) > 1e-12) {
	                x = (h + l) / 2;
	                if (s3_func_x(x, hf_slope) > 0) {
	                    h = x;
	                } else {
	                    l = x;
	                }
	            }
	            lim_a = l;
	        }
	        {
	            var x = 0, l, h;
	            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x += 1)
	                ;
	            l = 0;
	            h = x;
	            while (Math.abs(h - l) > 1e-12) {
	                x = (h + l) / 2;
	                if (s3_func_x(x, hf_slope) > 0) {
	                    l = x;
	                } else {
	                    h = x;
	                }
	            }
	            lim_b = h;
	        }
	        {
	            var sum = 0;
	            var m = 1000;
	            var i;
	            for (i = 0; i <= m; ++i) {
	                var x = lim_a + i * (lim_b - lim_a) / m;
	                var y = s3_func_x(x, hf_slope);
	                sum += y;
	            }
	            {
	                var norm = (m + 1) / (sum * (lim_b - lim_a));
	                /* printf( "norm = %lf\n",norm); */
	                return norm;
	            }
	        }
	    }
	
	    /**
	     *   The spreading function.  Values returned in units of energy
	     */
	    function s3_func(bark) {
	        var tempx, x, tempy, temp;
	        tempx = bark;
	        if (tempx >= 0)
	            tempx *= 3;
	        else
	            tempx *= 1.5;
	
	        if (tempx >= 0.5 && tempx <= 2.5) {
	            temp = tempx - 0.5;
	            x = 8.0 * (temp * temp - 2.0 * temp);
	        } else
	            x = 0.0;
	        tempx += 0.474;
	        tempy = 15.811389 + 7.5 * tempx - 17.5
	            * Math.sqrt(1.0 + tempx * tempx);
	
	        if (tempy <= -60.0)
	            return 0.0;
	
	        tempx = Math.exp((x + tempy) * LN_TO_LOG10);
	
	        /**
	         * <PRE>
	         * Normalization.  The spreading function should be normalized so that:
	         * +inf
	         * /
	         * |  s3 [ bark ]  d(bark)   =  1
	         * /
	         * -inf
	         * </PRE>
	         */
	        tempx /= .6609193;
	        return tempx;
	    }
	
	    /**
	     * see for example "Zwicker: Psychoakustik, 1982; ISBN 3-540-11401-7
	     */
	    function freq2bark(freq) {
	        /* input: freq in hz output: barks */
	        if (freq < 0)
	            freq = 0;
	        freq = freq * 0.001;
	        return 13.0 * Math.atan(.76 * freq) + 3.5
	            * Math.atan(freq * freq / (7.5 * 7.5));
	    }
	
	    function init_numline(numlines, bo, bm, bval, bval_width, mld, bo_w, sfreq, blksize, scalepos, deltafreq, sbmax) {
	        var b_frq = new_float(Encoder.CBANDS + 1);
	        var sample_freq_frac = sfreq / (sbmax > 15 ? 2 * 576 : 2 * 192);
	        var partition = new_int(Encoder.HBLKSIZE);
	        var i;
	        sfreq /= blksize;
	        var j = 0;
	        var ni = 0;
	        /* compute numlines, the number of spectral lines in each partition band */
	        /* each partition band should be about DELBARK wide. */
	        for (i = 0; i < Encoder.CBANDS; i++) {
	            var bark1;
	            var j2;
	            bark1 = freq2bark(sfreq * j);
	
	            b_frq[i] = sfreq * j;
	
	            for (j2 = j; freq2bark(sfreq * j2) - bark1 < DELBARK
	            && j2 <= blksize / 2; j2++)
	                ;
	
	            numlines[i] = j2 - j;
	            ni = i + 1;
	
	            while (j < j2) {
	                assert(j < Encoder.HBLKSIZE);
	                partition[j++] = i;
	            }
	            if (j > blksize / 2) {
	                j = blksize / 2;
	                ++i;
	                break;
	            }
	        }
	        assert(i < Encoder.CBANDS);
	        b_frq[i] = sfreq * j;
	
	        for (var sfb = 0; sfb < sbmax; sfb++) {
	            var i1, i2, start, end;
	            var arg;
	            start = scalepos[sfb];
	            end = scalepos[sfb + 1];
	
	            i1 = 0 | Math.floor(.5 + deltafreq * (start - .5));
	            if (i1 < 0)
	                i1 = 0;
	            i2 = 0 | Math.floor(.5 + deltafreq * (end - .5));
	
	            if (i2 > blksize / 2)
	                i2 = blksize / 2;
	
	            bm[sfb] = (partition[i1] + partition[i2]) / 2;
	            bo[sfb] = partition[i2];
	            var f_tmp = sample_freq_frac * end;
	            /*
	             * calculate how much of this band belongs to current scalefactor
	             * band
	             */
	            bo_w[sfb] = (f_tmp - b_frq[bo[sfb]])
	                / (b_frq[bo[sfb] + 1] - b_frq[bo[sfb]]);
	            if (bo_w[sfb] < 0) {
	                bo_w[sfb] = 0;
	            } else {
	                if (bo_w[sfb] > 1) {
	                    bo_w[sfb] = 1;
	                }
	            }
	            /* setup stereo demasking thresholds */
	            /* formula reverse enginerred from plot in paper */
	            arg = freq2bark(sfreq * scalepos[sfb] * deltafreq);
	            arg = ( Math.min(arg, 15.5) / 15.5);
	
	            mld[sfb] = Math.pow(10.0,
	                1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
	        }
	
	        /* compute bark values of each critical band */
	        j = 0;
	        for (var k = 0; k < ni; k++) {
	            var w = numlines[k];
	            var bark1, bark2;
	
	            bark1 = freq2bark(sfreq * (j));
	            bark2 = freq2bark(sfreq * (j + w - 1));
	            bval[k] = .5 * (bark1 + bark2);
	
	            bark1 = freq2bark(sfreq * (j - .5));
	            bark2 = freq2bark(sfreq * (j + w - .5));
	            bval_width[k] = bark2 - bark1;
	            j += w;
	        }
	
	        return ni;
	    }
	
	    function init_s3_values(s3ind, npart, bval, bval_width, norm, use_old_s3) {
	        var s3 = new_float_n([Encoder.CBANDS, Encoder.CBANDS]);
	        /*
	         * The s3 array is not linear in the bark scale.
	         *
	         * bval[x] should be used to get the bark value.
	         */
	        var j;
	        var numberOfNoneZero = 0;
	
	        /**
	         * <PRE>
	         * s[i][j], the value of the spreading function,
	         * centered at band j (masker), for band i (maskee)
	         *
	         * i.e.: sum over j to spread into signal barkval=i
	         * NOTE: i and j are used opposite as in the ISO docs
	         * </PRE>
	         */
	        if (use_old_s3) {
	            for (var i = 0; i < npart; i++) {
	                for (j = 0; j < npart; j++) {
	                    var v = s3_func(bval[i] - bval[j]) * bval_width[j];
	                    s3[i][j] = v * norm[i];
	                }
	            }
	        } else {
	            for (j = 0; j < npart; j++) {
	                var hf_slope = 15 + Math.min(21 / bval[j], 12);
	                var s3_x_norm = norm_s3_func_x(hf_slope);
	                for (var i = 0; i < npart; i++) {
	                    var v = s3_x_norm
	                        * s3_func_x(bval[i] - bval[j], hf_slope)
	                        * bval_width[j];
	                    s3[i][j] = v * norm[i];
	                }
	            }
	        }
	        for (var i = 0; i < npart; i++) {
	            for (j = 0; j < npart; j++) {
	                if (s3[i][j] > 0.0)
	                    break;
	            }
	            s3ind[i][0] = j;
	
	            for (j = npart - 1; j > 0; j--) {
	                if (s3[i][j] > 0.0)
	                    break;
	            }
	            s3ind[i][1] = j;
	            numberOfNoneZero += (s3ind[i][1] - s3ind[i][0] + 1);
	        }
	
	        var p = new_float(numberOfNoneZero);
	        var k = 0;
	        for (var i = 0; i < npart; i++)
	            for (j = s3ind[i][0]; j <= s3ind[i][1]; j++)
	                p[k++] = s3[i][j];
	
	        return p;
	    }
	
	    function stereo_demask(f) {
	        /* setup stereo demasking thresholds */
	        /* formula reverse enginerred from plot in paper */
	        var arg = freq2bark(f);
	        arg = (Math.min(arg, 15.5) / 15.5);
	
	        return Math.pow(10.0,
	            1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
	    }
	
	    /**
	     * NOTE: the bitrate reduction from the inter-channel masking effect is low
	     * compared to the chance of getting annyoing artefacts. L3psycho_anal_vbr
	     * does not use this feature. (Robert 071216)
	     */
	    this.psymodel_init = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var i;
	        var useOldS3 = true;
	        var bvl_a = 13, bvl_b = 24;
	        var snr_l_a = 0, snr_l_b = 0;
	        var snr_s_a = -8.25, snr_s_b = -4.5;
	        var bval = new_float(Encoder.CBANDS);
	        var bval_width = new_float(Encoder.CBANDS);
	        var norm = new_float(Encoder.CBANDS);
	        var sfreq = gfp.out_samplerate;
	
	        switch (gfp.experimentalZ) {
	            default:
	            case 0:
	                useOldS3 = true;
	                break;
	            case 1:
	                useOldS3 = (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) ? false
	                    : true;
	                break;
	            case 2:
	                useOldS3 = false;
	                break;
	            case 3:
	                bvl_a = 8;
	                snr_l_a = -1.75;
	                snr_l_b = -0.0125;
	                snr_s_a = -8.25;
	                snr_s_b = -2.25;
	                break;
	        }
	        gfc.ms_ener_ratio_old = .25;
	        gfc.blocktype_old[0] = gfc.blocktype_old[1] = Encoder.NORM_TYPE;
	        // the vbr header is long blocks
	
	        for (i = 0; i < 4; ++i) {
	            for (var j = 0; j < Encoder.CBANDS; ++j) {
	                gfc.nb_1[i][j] = 1e20;
	                gfc.nb_2[i][j] = 1e20;
	                gfc.nb_s1[i][j] = gfc.nb_s2[i][j] = 1.0;
	            }
	            for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
	                gfc.en[i].l[sb] = 1e20;
	                gfc.thm[i].l[sb] = 1e20;
	            }
	            for (var j = 0; j < 3; ++j) {
	                for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
	                    gfc.en[i].s[sb][j] = 1e20;
	                    gfc.thm[i].s[sb][j] = 1e20;
	                }
	                gfc.nsPsy.lastAttacks[i] = 0;
	            }
	            for (var j = 0; j < 9; j++)
	                gfc.nsPsy.last_en_subshort[i][j] = 10.;
	        }
	
	        /* init. for loudness approx. -jd 2001 mar 27 */
	        gfc.loudness_sq_save[0] = gfc.loudness_sq_save[1] = 0.0;
	
	        /*************************************************************************
	         * now compute the psychoacoustic model specific constants
	         ************************************************************************/
	        /* compute numlines, bo, bm, bval, bval_width, mld */
	
	        gfc.npart_l = init_numline(gfc.numlines_l, gfc.bo_l, gfc.bm_l, bval,
	            bval_width, gfc.mld_l, gfc.PSY.bo_l_weight, sfreq,
	            Encoder.BLKSIZE, gfc.scalefac_band.l, Encoder.BLKSIZE
	            / (2.0 * 576), Encoder.SBMAX_l);
	        assert(gfc.npart_l < Encoder.CBANDS);
	        /* compute the spreading function */
	        for (i = 0; i < gfc.npart_l; i++) {
	            var snr = snr_l_a;
	            if (bval[i] >= bvl_a) {
	                snr = snr_l_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_l_a
	                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
	            }
	            norm[i] = Math.pow(10.0, snr / 10.0);
	            if (gfc.numlines_l[i] > 0) {
	                gfc.rnumlines_l[i] = 1.0 / gfc.numlines_l[i];
	            } else {
	                gfc.rnumlines_l[i] = 0;
	            }
	        }
	        gfc.s3_ll = init_s3_values(gfc.s3ind, gfc.npart_l, bval, bval_width,
	            norm, useOldS3);
	
	        /* compute long block specific values, ATH and MINVAL */
	        var j = 0;
	        for (i = 0; i < gfc.npart_l; i++) {
	            var x;
	
	            /* ATH */
	            x = Float.MAX_VALUE;
	            for (var k = 0; k < gfc.numlines_l[i]; k++, j++) {
	                var freq = sfreq * j / (1000.0 * Encoder.BLKSIZE);
	                var level;
	                /*
	                 * ATH below 100 Hz constant, not further climbing
	                 */
	                level = this.ATHformula(freq * 1000, gfp) - 20;
	                // scale to FFT units; returned value is in dB
	                level = Math.pow(10., 0.1 * level);
	                // convert from dB . energy
	                level *= gfc.numlines_l[i];
	                if (x > level)
	                    x = level;
	            }
	            gfc.ATH.cb_l[i] = x;
	
	            /*
	             * MINVAL. For low freq, the strength of the masking is limited by
	             * minval this is an ISO MPEG1 thing, dont know if it is really
	             * needed
	             */
	            /*
	             * FIXME: it does work to reduce low-freq problems in S53-Wind-Sax
	             * and lead-voice samples, but introduces some 3 kbps bit bloat too.
	             * TODO: Further refinement of the shape of this hack.
	             */
	            x = -20 + bval[i] * 20 / 10;
	            if (x > 6) {
	                x = 100;
	            }
	            if (x < -15) {
	                x = -15;
	            }
	            x -= 8.;
	            gfc.minval_l[i] = (Math.pow(10.0, x / 10.) * gfc.numlines_l[i]);
	        }
	
	        /************************************************************************
	         * do the same things for short blocks
	         ************************************************************************/
	        gfc.npart_s = init_numline(gfc.numlines_s, gfc.bo_s, gfc.bm_s, bval,
	            bval_width, gfc.mld_s, gfc.PSY.bo_s_weight, sfreq,
	            Encoder.BLKSIZE_s, gfc.scalefac_band.s, Encoder.BLKSIZE_s
	            / (2.0 * 192), Encoder.SBMAX_s);
	        assert(gfc.npart_s < Encoder.CBANDS);
	
	        /* SNR formula. short block is normalized by SNR. is it still right ? */
	        j = 0;
	        for (i = 0; i < gfc.npart_s; i++) {
	            var x;
	            var snr = snr_s_a;
	            if (bval[i] >= bvl_a) {
	                snr = snr_s_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_s_a
	                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
	            }
	            norm[i] = Math.pow(10.0, snr / 10.0);
	
	            /* ATH */
	            x = Float.MAX_VALUE;
	            for (var k = 0; k < gfc.numlines_s[i]; k++, j++) {
	                var freq = sfreq * j / (1000.0 * Encoder.BLKSIZE_s);
	                var level;
	                /* freq = Min(.1,freq); */
	                /*
	                 * ATH below 100 Hz constant, not
	                 * further climbing
	                 */
	                level = this.ATHformula(freq * 1000, gfp) - 20;
	                // scale to FFT units; returned value is in dB
	                level = Math.pow(10., 0.1 * level);
	                // convert from dB . energy
	                level *= gfc.numlines_s[i];
	                if (x > level)
	                    x = level;
	            }
	            gfc.ATH.cb_s[i] = x;
	
	            /*
	             * MINVAL. For low freq, the strength of the masking is limited by
	             * minval this is an ISO MPEG1 thing, dont know if it is really
	             * needed
	             */
	            x = (-7.0 + bval[i] * 7.0 / 12.0);
	            if (bval[i] > 12) {
	                x *= 1 + Math.log(1 + x) * 3.1;
	            }
	            if (bval[i] < 12) {
	                x *= 1 + Math.log(1 - x) * 2.3;
	            }
	            if (x < -15) {
	                x = -15;
	            }
	            x -= 8;
	            gfc.minval_s[i] = Math.pow(10.0, x / 10)
	                * gfc.numlines_s[i];
	        }
	
	        gfc.s3_ss = init_s3_values(gfc.s3ind_s, gfc.npart_s, bval, bval_width,
	            norm, useOldS3);
	
	        init_mask_add_max_values();
	        fft.init_fft(gfc);
	
	        /* setup temporal masking */
	        gfc.decay = Math.exp(-1.0 * LOG10
	            / (temporalmask_sustain_sec * sfreq / 192.0));
	
	        {
	            var msfix;
	            msfix = NS_MSFIX;
	            if ((gfp.exp_nspsytune & 2) != 0)
	                msfix = 1.0;
	            if (Math.abs(gfp.msfix) > 0.0)
	                msfix = gfp.msfix;
	            gfp.msfix = msfix;
	
	            /*
	             * spread only from npart_l bands. Normally, we use the spreading
	             * function to convolve from npart_l down to npart_l bands
	             */
	            for (var b = 0; b < gfc.npart_l; b++)
	                if (gfc.s3ind[b][1] > gfc.npart_l - 1)
	                    gfc.s3ind[b][1] = gfc.npart_l - 1;
	        }
	
	        /*
	         * prepare for ATH auto adjustment: we want to decrease the ATH by 12 dB
	         * per second
	         */
	        var frame_duration = (576. * gfc.mode_gr / sfreq);
	        gfc.ATH.decay = Math.pow(10., -12. / 10. * frame_duration);
	        gfc.ATH.adjust = 0.01;
	        /* minimum, for leading low loudness */
	        gfc.ATH.adjustLimit = 1.0;
	        /* on lead, allow adjust up to maximum */
	
	        assert(gfc.bo_l[Encoder.SBMAX_l - 1] <= gfc.npart_l);
	        assert(gfc.bo_s[Encoder.SBMAX_s - 1] <= gfc.npart_s);
	
	        if (gfp.ATHtype != -1) {
	            /* compute equal loudness weights (eql_w) */
	            var freq;
	            var freq_inc = gfp.out_samplerate
	                / (Encoder.BLKSIZE);
	            var eql_balance = 0.0;
	            freq = 0.0;
	            for (i = 0; i < Encoder.BLKSIZE / 2; ++i) {
	                /* convert ATH dB to relative power (not dB) */
	                /* to determine eql_w */
	                freq += freq_inc;
	                gfc.ATH.eql_w[i] = 1. / Math.pow(10, this.ATHformula(freq, gfp) / 10);
	                eql_balance += gfc.ATH.eql_w[i];
	            }
	            eql_balance = 1.0 / eql_balance;
	            for (i = Encoder.BLKSIZE / 2; --i >= 0;) { /* scale weights */
	                gfc.ATH.eql_w[i] *= eql_balance;
	            }
	        }
	        {
	            for (var b = j = 0; b < gfc.npart_s; ++b) {
	                for (i = 0; i < gfc.numlines_s[b]; ++i) {
	                    ++j;
	                }
	            }
	            assert(j == 129);
	            for (var b = j = 0; b < gfc.npart_l; ++b) {
	                for (i = 0; i < gfc.numlines_l[b]; ++i) {
	                    ++j;
	                }
	            }
	            assert(j == 513);
	        }
	        j = 0;
	        for (i = 0; i < gfc.npart_l; i++) {
	            var freq = sfreq * (j + gfc.numlines_l[i] / 2) / (1.0 * Encoder.BLKSIZE);
	            gfc.mld_cb_l[i] = stereo_demask(freq);
	            j += gfc.numlines_l[i];
	        }
	        for (; i < Encoder.CBANDS; ++i) {
	            gfc.mld_cb_l[i] = 1;
	        }
	        j = 0;
	        for (i = 0; i < gfc.npart_s; i++) {
	            var freq = sfreq * (j + gfc.numlines_s[i] / 2) / (1.0 * Encoder.BLKSIZE_s);
	            gfc.mld_cb_s[i] = stereo_demask(freq);
	            j += gfc.numlines_s[i];
	        }
	        for (; i < Encoder.CBANDS; ++i) {
	            gfc.mld_cb_s[i] = 1;
	        }
	        return 0;
	    }
	
	    /**
	     * Those ATH formulas are returning their minimum value for input = -1
	     */
	    function ATHformula_GB(f, value) {
	        /**
	         * <PRE>
	         *  from Painter & Spanias
	         *           modified by Gabriel Bouvigne to better fit the reality
	         *           ath =    3.640 * pow(f,-0.8)
	         *           - 6.800 * exp(-0.6*pow(f-3.4,2.0))
	         *           + 6.000 * exp(-0.15*pow(f-8.7,2.0))
	         *           + 0.6* 0.001 * pow(f,4.0);
	         *
	         *
	         *           In the past LAME was using the Painter &Spanias formula.
	         *           But we had some recurrent problems with HF content.
	         *           We measured real ATH values, and found the older formula
	         *           to be inaccurate in the higher part. So we made this new
	         *           formula and this solved most of HF problematic test cases.
	         *           The tradeoff is that in VBR mode it increases a lot the
	         *           bitrate.
	         * </PRE>
	         */
	
	        /*
	         * This curve can be adjusted according to the VBR scale: it adjusts
	         * from something close to Painter & Spanias on V9 up to Bouvigne's
	         * formula for V0. This way the VBR bitrate is more balanced according
	         * to the -V value.
	         */
	
	        // the following Hack allows to ask for the lowest value
	        if (f < -.3)
	            f = 3410;
	
	        // convert to khz
	        f /= 1000;
	        f = Math.max(0.1, f);
	        var ath = 3.640 * Math.pow(f, -0.8) - 6.800
	            * Math.exp(-0.6 * Math.pow(f - 3.4, 2.0)) + 6.000
	            * Math.exp(-0.15 * Math.pow(f - 8.7, 2.0))
	            + (0.6 + 0.04 * value) * 0.001 * Math.pow(f, 4.0);
	        return ath;
	    }
	
	    this.ATHformula = function (f, gfp) {
	        var ath;
	        switch (gfp.ATHtype) {
	            case 0:
	                ath = ATHformula_GB(f, 9);
	                break;
	            case 1:
	                // over sensitive, should probably be removed
	                ath = ATHformula_GB(f, -1);
	                break;
	            case 2:
	                ath = ATHformula_GB(f, 0);
	                break;
	            case 3:
	                // modification of GB formula by Roel
	                ath = ATHformula_GB(f, 1) + 6;
	                break;
	            case 4:
	                ath = ATHformula_GB(f, gfp.ATHcurve);
	                break;
	            default:
	                ath = ATHformula_GB(f, 0);
	                break;
	        }
	        return ath;
	    }
	
	}
	
	module.exports = PsyModel;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * MP3 quantization
	 *
	 *      Copyright (c) 1999-2000 Mark Taylor
	 *      Copyright (c) 1999-2003 Takehiro Tominaga
	 *      Copyright (c) 2000-2007 Robert Hegemann
	 *      Copyright (c) 2001-2005 Gabriel Bouvigne
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.     See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Lesser General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	
	/* $Id: Quantize.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */
	
	//package mp3;
	
	//import java.util.Arrays;
	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var VBRQuantize = __webpack_require__(409);
	var CalcNoiseResult = __webpack_require__(396);
	var CalcNoiseData = __webpack_require__(395);
	var Encoder = __webpack_require__(21);
	var GrInfo = __webpack_require__(124);
	var L3Side = __webpack_require__(86);
	
	function Quantize() {
	    var bs;
	    this.rv = null;
	    var rv;
	    this.qupvt = null;
	    var qupvt;
	
	    var vbr = new VBRQuantize();
	    var tk;
	
	    this.setModules = function (_bs, _rv, _qupvt, _tk) {
	        bs = _bs;
	        rv = _rv;
	        this.rv = _rv;
	        qupvt = _qupvt;
	        this.qupvt = _qupvt;
	        tk = _tk;
	        vbr.setModules(qupvt, tk);
	    }
	
	    /**
	     * convert from L/R <. Mid/Side
	     */
	    this.ms_convert = function (l3_side, gr) {
	        for (var i = 0; i < 576; ++i) {
	            var l = l3_side.tt[gr][0].xr[i];
	            var r = l3_side.tt[gr][1].xr[i];
	            l3_side.tt[gr][0].xr[i] = (l + r) * (Util.SQRT2 * 0.5);
	            l3_side.tt[gr][1].xr[i] = (l - r) * (Util.SQRT2 * 0.5);
	        }
	    };
	
	    /**
	     * mt 6/99
	     *
	     * initializes cod_info, scalefac and xrpow
	     *
	     * returns 0 if all energies in xr are zero, else 1
	     */
	    function init_xrpow_core(cod_info, xrpow, upper, sum) {
	        sum = 0;
	        for (var i = 0; i <= upper; ++i) {
	            var tmp = Math.abs(cod_info.xr[i]);
	            sum += tmp;
	            xrpow[i] = Math.sqrt(tmp * Math.sqrt(tmp));
	
	            if (xrpow[i] > cod_info.xrpow_max)
	                cod_info.xrpow_max = xrpow[i];
	        }
	        return sum;
	    }
	
	    this.init_xrpow = function (gfc, cod_info, xrpow) {
	        var sum = 0;
	        var upper = 0 | cod_info.max_nonzero_coeff;
	
	        assert(xrpow != null);
	        cod_info.xrpow_max = 0;
	
	        /*
	         * check if there is some energy we have to quantize and calculate xrpow
	         * matching our fresh scalefactors
	         */
	        assert(0 <= upper && upper <= 575);
	
	        Arrays.fill(xrpow, upper, 576, 0);
	
	        sum = init_xrpow_core(cod_info, xrpow, upper, sum);
	
	        /*
	         * return 1 if we have something to quantize, else 0
	         */
	        if (sum > 1E-20) {
	            var j = 0;
	            if ((gfc.substep_shaping & 2) != 0)
	                j = 1;
	
	            for (var i = 0; i < cod_info.psymax; i++)
	                gfc.pseudohalf[i] = j;
	
	            return true;
	        }
	
	        Arrays.fill(cod_info.l3_enc, 0, 576, 0);
	        return false;
	    }
	
	    /**
	     * Gabriel Bouvigne feb/apr 2003<BR>
	     * Analog silence detection in partitionned sfb21 or sfb12 for short blocks
	     *
	     * From top to bottom of sfb, changes to 0 coeffs which are below ath. It
	     * stops on the first coeff higher than ath.
	     */
	    function psfb21_analogsilence(gfc, cod_info) {
	        var ath = gfc.ATH;
	        var xr = cod_info.xr;
	
	        if (cod_info.block_type != Encoder.SHORT_TYPE) {
	            /* NORM, START or STOP type, but not SHORT blocks */
	            var stop = false;
	            for (var gsfb = Encoder.PSFB21 - 1; gsfb >= 0 && !stop; gsfb--) {
	                var start = gfc.scalefac_band.psfb21[gsfb];
	                var end = gfc.scalefac_band.psfb21[gsfb + 1];
	                var ath21 = qupvt.athAdjust(ath.adjust, ath.psfb21[gsfb],
	                    ath.floor);
	
	                if (gfc.nsPsy.longfact[21] > 1e-12)
	                    ath21 *= gfc.nsPsy.longfact[21];
	
	                for (var j = end - 1; j >= start; j--) {
	                    if (Math.abs(xr[j]) < ath21)
	                        xr[j] = 0;
	                    else {
	                        stop = true;
	                        break;
	                    }
	                }
	            }
	        } else {
	            /* note: short blocks coeffs are reordered */
	            for (var block = 0; block < 3; block++) {
	                var stop = false;
	                for (var gsfb = Encoder.PSFB12 - 1; gsfb >= 0 && !stop; gsfb--) {
	                    var start = gfc.scalefac_band.s[12]
	                        * 3
	                        + (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
	                        * block
	                        + (gfc.scalefac_band.psfb12[gsfb] - gfc.scalefac_band.psfb12[0]);
	                    var end = start
	                        + (gfc.scalefac_band.psfb12[gsfb + 1] - gfc.scalefac_band.psfb12[gsfb]);
	                    var ath12 = qupvt.athAdjust(ath.adjust, ath.psfb12[gsfb],
	                        ath.floor);
	
	                    if (gfc.nsPsy.shortfact[12] > 1e-12)
	                        ath12 *= gfc.nsPsy.shortfact[12];
	
	                    for (var j = end - 1; j >= start; j--) {
	                        if (Math.abs(xr[j]) < ath12)
	                            xr[j] = 0;
	                        else {
	                            stop = true;
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	
	    }
	
	    this.init_outer_loop = function (gfc, cod_info) {
	        /*
	         * initialize fresh cod_info
	         */
	        cod_info.part2_3_length = 0;
	        cod_info.big_values = 0;
	        cod_info.count1 = 0;
	        cod_info.global_gain = 210;
	        cod_info.scalefac_compress = 0;
	        /* mixed_block_flag, block_type was set in psymodel.c */
	        cod_info.table_select[0] = 0;
	        cod_info.table_select[1] = 0;
	        cod_info.table_select[2] = 0;
	        cod_info.subblock_gain[0] = 0;
	        cod_info.subblock_gain[1] = 0;
	        cod_info.subblock_gain[2] = 0;
	        cod_info.subblock_gain[3] = 0;
	        /* this one is always 0 */
	        cod_info.region0_count = 0;
	        cod_info.region1_count = 0;
	        cod_info.preflag = 0;
	        cod_info.scalefac_scale = 0;
	        cod_info.count1table_select = 0;
	        cod_info.part2_length = 0;
	        cod_info.sfb_lmax = Encoder.SBPSY_l;
	        cod_info.sfb_smin = Encoder.SBPSY_s;
	        cod_info.psy_lmax = gfc.sfb21_extra ? Encoder.SBMAX_l : Encoder.SBPSY_l;
	        cod_info.psymax = cod_info.psy_lmax;
	        cod_info.sfbmax = cod_info.sfb_lmax;
	        cod_info.sfbdivide = 11;
	        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
	            cod_info.width[sfb] = gfc.scalefac_band.l[sfb + 1]
	                - gfc.scalefac_band.l[sfb];
	            /* which is always 0. */
	            cod_info.window[sfb] = 3;
	        }
	        if (cod_info.block_type == Encoder.SHORT_TYPE) {
	            var ixwork = new_float(576);
	
	            cod_info.sfb_smin = 0;
	            cod_info.sfb_lmax = 0;
	            if (cod_info.mixed_block_flag != 0) {
	                /*
	                 * MPEG-1: sfbs 0-7 long block, 3-12 short blocks MPEG-2(.5):
	                 * sfbs 0-5 long block, 3-12 short blocks
	                 */
	                cod_info.sfb_smin = 3;
	                cod_info.sfb_lmax = gfc.mode_gr * 2 + 4;
	            }
	            cod_info.psymax = cod_info.sfb_lmax
	                + 3
	                * ((gfc.sfb21_extra ? Encoder.SBMAX_s : Encoder.SBPSY_s) - cod_info.sfb_smin);
	            cod_info.sfbmax = cod_info.sfb_lmax + 3
	                * (Encoder.SBPSY_s - cod_info.sfb_smin);
	            cod_info.sfbdivide = cod_info.sfbmax - 18;
	            cod_info.psy_lmax = cod_info.sfb_lmax;
	            /* re-order the short blocks, for more efficient encoding below */
	            /* By Takehiro TOMINAGA */
	            /*
	             * Within each scalefactor band, data is given for successive time
	             * windows, beginning with window 0 and ending with window 2. Within
	             * each window, the quantized values are then arranged in order of
	             * increasing frequency...
	             */
	            var ix = gfc.scalefac_band.l[cod_info.sfb_lmax];
	            System.arraycopy(cod_info.xr, 0, ixwork, 0, 576);
	            for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
	                var start = gfc.scalefac_band.s[sfb];
	                var end = gfc.scalefac_band.s[sfb + 1];
	                for (var window = 0; window < 3; window++) {
	                    for (var l = start; l < end; l++) {
	                        cod_info.xr[ix++] = ixwork[3 * l + window];
	                    }
	                }
	            }
	
	            var j = cod_info.sfb_lmax;
	            for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
	                cod_info.width[j] = cod_info.width[j + 1] = cod_info.width[j + 2] = gfc.scalefac_band.s[sfb + 1]
	                    - gfc.scalefac_band.s[sfb];
	                cod_info.window[j] = 0;
	                cod_info.window[j + 1] = 1;
	                cod_info.window[j + 2] = 2;
	                j += 3;
	            }
	        }
	
	        cod_info.count1bits = 0;
	        cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[0][0];
	        cod_info.slen[0] = 0;
	        cod_info.slen[1] = 0;
	        cod_info.slen[2] = 0;
	        cod_info.slen[3] = 0;
	
	        cod_info.max_nonzero_coeff = 575;
	
	        /*
	         * fresh scalefactors are all zero
	         */
	        Arrays.fill(cod_info.scalefac, 0);
	
	        psfb21_analogsilence(gfc, cod_info);
	    };
	
	    function BinSearchDirection(ordinal) {
	        this.ordinal = ordinal;
	    }
	
	    BinSearchDirection.BINSEARCH_NONE = new BinSearchDirection(0);
	    BinSearchDirection.BINSEARCH_UP = new BinSearchDirection(1);
	    BinSearchDirection.BINSEARCH_DOWN = new BinSearchDirection(2);
	
	    /**
	     * author/date??
	     *
	     * binary step size search used by outer_loop to get a quantizer step size
	     * to start with
	     */
	    function bin_search_StepSize(gfc, cod_info, desired_rate, ch, xrpow) {
	        var nBits;
	        var CurrentStep = gfc.CurrentStep[ch];
	        var flagGoneOver = false;
	        var start = gfc.OldValue[ch];
	        var Direction = BinSearchDirection.BINSEARCH_NONE;
	        cod_info.global_gain = start;
	        desired_rate -= cod_info.part2_length;
	
	        assert(CurrentStep != 0);
	        for (; ;) {
	            var step;
	            nBits = tk.count_bits(gfc, xrpow, cod_info, null);
	
	            if (CurrentStep == 1 || nBits == desired_rate)
	                break;
	            /* nothing to adjust anymore */
	
	            if (nBits > desired_rate) {
	                /* increase Quantize_StepSize */
	                if (Direction == BinSearchDirection.BINSEARCH_DOWN)
	                    flagGoneOver = true;
	
	                if (flagGoneOver)
	                    CurrentStep /= 2;
	                Direction = BinSearchDirection.BINSEARCH_UP;
	                step = CurrentStep;
	            } else {
	                /* decrease Quantize_StepSize */
	                if (Direction == BinSearchDirection.BINSEARCH_UP)
	                    flagGoneOver = true;
	
	                if (flagGoneOver)
	                    CurrentStep /= 2;
	                Direction = BinSearchDirection.BINSEARCH_DOWN;
	                step = -CurrentStep;
	            }
	            cod_info.global_gain += step;
	            if (cod_info.global_gain < 0) {
	                cod_info.global_gain = 0;
	                flagGoneOver = true;
	            }
	            if (cod_info.global_gain > 255) {
	                cod_info.global_gain = 255;
	                flagGoneOver = true;
	            }
	        }
	
	        assert(cod_info.global_gain >= 0);
	        assert(cod_info.global_gain < 256);
	
	        while (nBits > desired_rate && cod_info.global_gain < 255) {
	            cod_info.global_gain++;
	            nBits = tk.count_bits(gfc, xrpow, cod_info, null);
	        }
	        gfc.CurrentStep[ch] = (start - cod_info.global_gain >= 4) ? 4 : 2;
	        gfc.OldValue[ch] = cod_info.global_gain;
	        cod_info.part2_3_length = nBits;
	        return nBits;
	    }
	
	    this.trancate_smallspectrums = function (gfc, gi, l3_xmin, work) {
	        var distort = new_float(L3Side.SFBMAX);
	
	        if ((0 == (gfc.substep_shaping & 4) && gi.block_type == Encoder.SHORT_TYPE)
	            || (gfc.substep_shaping & 0x80) != 0)
	            return;
	        qupvt.calc_noise(gi, l3_xmin, distort, new CalcNoiseResult(), null);
	        for (var j = 0; j < 576; j++) {
	            var xr = 0.0;
	            if (gi.l3_enc[j] != 0)
	                xr = Math.abs(gi.xr[j]);
	            work[j] = xr;
	        }
	
	        var j = 0;
	        var sfb = 8;
	        if (gi.block_type == Encoder.SHORT_TYPE)
	            sfb = 6;
	        do {
	            var allowedNoise, trancateThreshold;
	            var nsame, start;
	
	            var width = gi.width[sfb];
	            j += width;
	            if (distort[sfb] >= 1.0)
	                continue;
	
	            Arrays.sort(work, j - width, width);
	            if (BitStream.EQ(work[j - 1], 0.0))
	                continue;
	            /* all zero sfb */
	
	            allowedNoise = (1.0 - distort[sfb]) * l3_xmin[sfb];
	            trancateThreshold = 0.0;
	            start = 0;
	            do {
	                var noise;
	                for (nsame = 1; start + nsame < width; nsame++)
	                    if (BitStream.NEQ(work[start + j - width], work[start + j
	                        + nsame - width]))
	                        break;
	
	                noise = work[start + j - width] * work[start + j - width]
	                    * nsame;
	                if (allowedNoise < noise) {
	                    if (start != 0)
	                        trancateThreshold = work[start + j - width - 1];
	                    break;
	                }
	                allowedNoise -= noise;
	                start += nsame;
	            } while (start < width);
	            if (BitStream.EQ(trancateThreshold, 0.0))
	                continue;
	
	            do {
	                if (Math.abs(gi.xr[j - width]) <= trancateThreshold)
	                    gi.l3_enc[j - width] = 0;
	            } while (--width > 0);
	        } while (++sfb < gi.psymax);
	
	        gi.part2_3_length = tk.noquant_count_bits(gfc, gi, null);
	    };
	
	    /**
	     * author/date??
	     *
	     * Function: Returns zero if there is a scalefac which has not been
	     * amplified. Otherwise it returns one.
	     */
	    function loop_break(cod_info) {
	        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++)
	            if (cod_info.scalefac[sfb]
	                + cod_info.subblock_gain[cod_info.window[sfb]] == 0)
	                return false;
	
	        return true;
	    }
	
	    /* mt 5/99: Function: Improved calc_noise for a single channel */
	
	    function penalties(noise) {
	        return Util.FAST_LOG10((0.368 + 0.632 * noise * noise * noise));
	    }
	
	    /**
	     * author/date??
	     *
	     * several different codes to decide which quantization is better
	     */
	    function get_klemm_noise(distort, gi) {
	        var klemm_noise = 1E-37;
	        for (var sfb = 0; sfb < gi.psymax; sfb++)
	            klemm_noise += penalties(distort[sfb]);
	
	        return Math.max(1e-20, klemm_noise);
	    }
	
	    function quant_compare(quant_comp, best, calc, gi, distort) {
	        /**
	         * noise is given in decibels (dB) relative to masking thesholds.<BR>
	         *
	         * over_noise: ??? (the previous comment is fully wrong)<BR>
	         * tot_noise: ??? (the previous comment is fully wrong)<BR>
	         * max_noise: max quantization noise
	         */
	        var better;
	
	        switch (quant_comp) {
	            default:
	            case 9:
	            {
	                if (best.over_count > 0) {
	                    /* there are distorted sfb */
	                    better = calc.over_SSD <= best.over_SSD;
	                    if (calc.over_SSD == best.over_SSD)
	                        better = calc.bits < best.bits;
	                } else {
	                    /* no distorted sfb */
	                    better = ((calc.max_noise < 0) && ((calc.max_noise * 10 + calc.bits) <= (best.max_noise * 10 + best.bits)));
	                }
	                break;
	            }
	
	            case 0:
	                better = calc.over_count < best.over_count
	                    || (calc.over_count == best.over_count && calc.over_noise < best.over_noise)
	                    || (calc.over_count == best.over_count
	                    && BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
	                break;
	
	            case 8:
	                calc.max_noise = get_klemm_noise(distort, gi);
	            //$FALL-THROUGH$
	            case 1:
	                better = calc.max_noise < best.max_noise;
	                break;
	            case 2:
	                better = calc.tot_noise < best.tot_noise;
	                break;
	            case 3:
	                better = (calc.tot_noise < best.tot_noise)
	                    && (calc.max_noise < best.max_noise);
	                break;
	            case 4:
	                better = (calc.max_noise <= 0.0 && best.max_noise > 0.2)
	                    || (calc.max_noise <= 0.0 && best.max_noise < 0.0
	                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise)
	                    || (calc.max_noise <= 0.0 && best.max_noise > 0.0
	                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise
	                    + best.over_noise)
	                    || (calc.max_noise > 0.0 && best.max_noise > -0.05
	                    && best.max_noise > calc.max_noise - 0.1 && calc.tot_noise
	                    + calc.over_noise < best.tot_noise
	                    + best.over_noise)
	                    || (calc.max_noise > 0.0 && best.max_noise > -0.1
	                    && best.max_noise > calc.max_noise - 0.15 && calc.tot_noise
	                    + calc.over_noise + calc.over_noise < best.tot_noise
	                    + best.over_noise + best.over_noise);
	                break;
	            case 5:
	                better = calc.over_noise < best.over_noise
	                    || (BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
	                break;
	            case 6:
	                better = calc.over_noise < best.over_noise
	                    || (BitStream.EQ(calc.over_noise, best.over_noise) && (calc.max_noise < best.max_noise || (BitStream
	                        .EQ(calc.max_noise, best.max_noise) && calc.tot_noise <= best.tot_noise)));
	                break;
	            case 7:
	                better = calc.over_count < best.over_count
	                    || calc.over_noise < best.over_noise;
	                break;
	        }
	
	        if (best.over_count == 0) {
	            /*
	             * If no distorted bands, only use this quantization if it is
	             * better, and if it uses less bits. Unfortunately, part2_3_length
	             * is sometimes a poor estimator of the final size at low bitrates.
	             */
	            better = better && calc.bits < best.bits;
	        }
	
	        return better;
	    }
	
	    /**
	     * author/date??
	     *
	     * <PRE>
	     *  Amplify the scalefactor bands that violate the masking threshold.
	     *  See ISO 11172-3 Section C.1.5.4.3.5
	     *
	     *  distort[] = noise/masking
	     *  distort[] > 1   ==> noise is not masked
	     *  distort[] < 1   ==> noise is masked
	     *  max_dist = maximum value of distort[]
	     *
	     *  Three algorithms:
	     *  noise_shaping_amp
	     *        0             Amplify all bands with distort[]>1.
	     *
	     *        1             Amplify all bands with distort[] >= max_dist^(.5);
	     *                     ( 50% in the db scale)
	     *
	     *        2             Amplify first band with distort[] >= max_dist;
	     *
	     *
	     *  For algorithms 0 and 1, if max_dist < 1, then amplify all bands
	     *  with distort[] >= .95*max_dist.  This is to make sure we always
	     *  amplify at least one band.
	     * </PRE>
	     */
	    function amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine) {
	        var gfc = gfp.internal_flags;
	        var ifqstep34;
	
	        if (cod_info.scalefac_scale == 0) {
	            ifqstep34 = 1.29683955465100964055;
	            /* 2**(.75*.5) */
	        } else {
	            ifqstep34 = 1.68179283050742922612;
	            /* 2**(.75*1) */
	        }
	
	        /* compute maximum value of distort[] */
	        var trigger = 0;
	        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
	            if (trigger < distort[sfb])
	                trigger = distort[sfb];
	        }
	
	        var noise_shaping_amp = gfc.noise_shaping_amp;
	        if (noise_shaping_amp == 3) {
	            if (bRefine)
	                noise_shaping_amp = 2;
	            else
	                noise_shaping_amp = 1;
	        }
	        switch (noise_shaping_amp) {
	            case 2:
	                /* amplify exactly 1 band */
	                break;
	
	            case 1:
	                /* amplify bands within 50% of max (on db scale) */
	                if (trigger > 1.0)
	                    trigger = Math.pow(trigger, .5);
	                else
	                    trigger *= .95;
	                break;
	
	            case 0:
	            default:
	                /* ISO algorithm. amplify all bands with distort>1 */
	                if (trigger > 1.0)
	                    trigger = 1.0;
	                else
	                    trigger *= .95;
	                break;
	        }
	
	        var j = 0;
	        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
	            var width = cod_info.width[sfb];
	            var l;
	            j += width;
	            if (distort[sfb] < trigger)
	                continue;
	
	            if ((gfc.substep_shaping & 2) != 0) {
	                gfc.pseudohalf[sfb] = (0 == gfc.pseudohalf[sfb]) ? 1 : 0;
	                if (0 == gfc.pseudohalf[sfb] && gfc.noise_shaping_amp == 2)
	                    return;
	            }
	            cod_info.scalefac[sfb]++;
	            for (l = -width; l < 0; l++) {
	                xrpow[j + l] *= ifqstep34;
	                if (xrpow[j + l] > cod_info.xrpow_max)
	                    cod_info.xrpow_max = xrpow[j + l];
	            }
	
	            if (gfc.noise_shaping_amp == 2)
	                return;
	        }
	    }
	
	    /**
	     * Takehiro Tominaga 2000-xx-xx
	     *
	     * turns on scalefac scale and adjusts scalefactors
	     */
	    function inc_scalefac_scale(cod_info, xrpow) {
	        var ifqstep34 = 1.29683955465100964055;
	
	        var j = 0;
	        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
	            var width = cod_info.width[sfb];
	            var s = cod_info.scalefac[sfb];
	            if (cod_info.preflag != 0)
	                s += qupvt.pretab[sfb];
	            j += width;
	            if ((s & 1) != 0) {
	                s++;
	                for (var l = -width; l < 0; l++) {
	                    xrpow[j + l] *= ifqstep34;
	                    if (xrpow[j + l] > cod_info.xrpow_max)
	                        cod_info.xrpow_max = xrpow[j + l];
	                }
	            }
	            cod_info.scalefac[sfb] = s >> 1;
	        }
	        cod_info.preflag = 0;
	        cod_info.scalefac_scale = 1;
	    }
	
	    /**
	     * Takehiro Tominaga 2000-xx-xx
	     *
	     * increases the subblock gain and adjusts scalefactors
	     */
	    function inc_subblock_gain(gfc, cod_info, xrpow) {
	        var sfb;
	        var scalefac = cod_info.scalefac;
	
	        /* subbloc_gain can't do anything in the long block region */
	        for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
	            if (scalefac[sfb] >= 16)
	                return true;
	        }
	
	        for (var window = 0; window < 3; window++) {
	            var s1 = 0;
	            var s2 = 0;
	
	            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbdivide; sfb += 3) {
	                if (s1 < scalefac[sfb])
	                    s1 = scalefac[sfb];
	            }
	            for (; sfb < cod_info.sfbmax; sfb += 3) {
	                if (s2 < scalefac[sfb])
	                    s2 = scalefac[sfb];
	            }
	
	            if (s1 < 16 && s2 < 8)
	                continue;
	
	            if (cod_info.subblock_gain[window] >= 7)
	                return true;
	
	            /*
	             * even though there is no scalefactor for sfb12 subblock gain
	             * affects upper frequencies too, that's why we have to go up to
	             * SBMAX_s
	             */
	            cod_info.subblock_gain[window]++;
	            var j = gfc.scalefac_band.l[cod_info.sfb_lmax];
	            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbmax; sfb += 3) {
	                var amp;
	                var width = cod_info.width[sfb];
	                var s = scalefac[sfb];
	                assert(s >= 0);
	                s = s - (4 >> cod_info.scalefac_scale);
	                if (s >= 0) {
	                    scalefac[sfb] = s;
	                    j += width * 3;
	                    continue;
	                }
	
	                scalefac[sfb] = 0;
	                {
	                    var gain = 210 + (s << (cod_info.scalefac_scale + 1));
	                    amp = qupvt.IPOW20(gain);
	                }
	                j += width * (window + 1);
	                for (var l = -width; l < 0; l++) {
	                    xrpow[j + l] *= amp;
	                    if (xrpow[j + l] > cod_info.xrpow_max)
	                        cod_info.xrpow_max = xrpow[j + l];
	                }
	                j += width * (3 - window - 1);
	            }
	
	            {
	                var amp = qupvt.IPOW20(202);
	                j += cod_info.width[sfb] * (window + 1);
	                for (var l = -cod_info.width[sfb]; l < 0; l++) {
	                    xrpow[j + l] *= amp;
	                    if (xrpow[j + l] > cod_info.xrpow_max)
	                        cod_info.xrpow_max = xrpow[j + l];
	                }
	            }
	        }
	        return false;
	    }
	
	    /**
	     * <PRE>
	     *  Takehiro Tominaga /date??
	     *  Robert Hegemann 2000-09-06: made a function of it
	     *
	     *  amplifies scalefactor bands,
	     *   - if all are already amplified returns 0
	     *   - if some bands are amplified too much:
	     *      * try to increase scalefac_scale
	     *      * if already scalefac_scale was set
	     *          try on short blocks to increase subblock gain
	     * </PRE>
	     */
	    function balance_noise(gfp, cod_info, distort, xrpow, bRefine) {
	        var gfc = gfp.internal_flags;
	
	        amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine);
	
	        /*
	         * check to make sure we have not amplified too much loop_break returns
	         * 0 if there is an unamplified scalefac scale_bitcount returns 0 if no
	         * scalefactors are too large
	         */
	
	        var status = loop_break(cod_info);
	
	        if (status)
	            return false;
	        /* all bands amplified */
	
	        /*
	         * not all scalefactors have been amplified. so these scalefacs are
	         * possibly valid. encode them:
	         */
	        if (gfc.mode_gr == 2)
	            status = tk.scale_bitcount(cod_info);
	        else
	            status = tk.scale_bitcount_lsf(gfc, cod_info);
	
	        if (!status)
	            return true;
	        /* amplified some bands not exceeding limits */
	
	        /*
	         * some scalefactors are too large. lets try setting scalefac_scale=1
	         */
	        if (gfc.noise_shaping > 1) {
	            Arrays.fill(gfc.pseudohalf, 0);
	            if (0 == cod_info.scalefac_scale) {
	                inc_scalefac_scale(cod_info, xrpow);
	                status = false;
	            } else {
	                if (cod_info.block_type == Encoder.SHORT_TYPE
	                    && gfc.subblock_gain > 0) {
	                    status = (inc_subblock_gain(gfc, cod_info, xrpow) || loop_break(cod_info));
	                }
	            }
	        }
	
	        if (!status) {
	            if (gfc.mode_gr == 2)
	                status = tk.scale_bitcount(cod_info);
	            else
	                status = tk.scale_bitcount_lsf(gfc, cod_info);
	        }
	        return !status;
	    }
	
	    /**
	     * <PRE>
	     *  Function: The outer iteration loop controls the masking conditions
	     *  of all scalefactorbands. It computes the best scalefac and
	     *  global gain. This module calls the inner iteration loop
	     *
	     *  mt 5/99 completely rewritten to allow for bit reservoir control,
	     *  mid/side channels with L/R or mid/side masking thresholds,
	     *  and chooses best quantization instead of last quantization when
	     *  no distortion free quantization can be found.
	     *
	     *  added VBR support mt 5/99
	     *
	     *  some code shuffle rh 9/00
	     * </PRE>
	     *
	     * @param l3_xmin
	     *            allowed distortion
	     * @param xrpow
	     *            coloured magnitudes of spectral
	     * @param targ_bits
	     *            maximum allowed bits
	     */
	    this.outer_loop = function (gfp, cod_info, l3_xmin, xrpow, ch, targ_bits) {
	        var gfc = gfp.internal_flags;
	        var cod_info_w = new GrInfo();
	        var save_xrpow = new_float(576);
	        var distort = new_float(L3Side.SFBMAX);
	        var best_noise_info = new CalcNoiseResult();
	        var better;
	        var prev_noise = new CalcNoiseData();
	        var best_part2_3_length = 9999999;
	        var bEndOfSearch = false;
	        var bRefine = false;
	        var best_ggain_pass1 = 0;
	
	        bin_search_StepSize(gfc, cod_info, targ_bits, ch, xrpow);
	
	        if (0 == gfc.noise_shaping)
	        /* fast mode, no noise shaping, we are ready */
	            return 100;
	        /* default noise_info.over_count */
	
	        /* compute the distortion in this quantization */
	        /* coefficients and thresholds both l/r (or both mid/side) */
	        qupvt.calc_noise(cod_info, l3_xmin, distort, best_noise_info,
	            prev_noise);
	        best_noise_info.bits = cod_info.part2_3_length;
	
	        cod_info_w.assign(cod_info);
	        var age = 0;
	        System.arraycopy(xrpow, 0, save_xrpow, 0, 576);
	
	        while (!bEndOfSearch) {
	            /* BEGIN MAIN LOOP */
	            do {
	                var noise_info = new CalcNoiseResult();
	                var search_limit;
	                var maxggain = 255;
	
	                /*
	                 * When quantization with no distorted bands is found, allow up
	                 * to X new unsuccesful tries in serial. This gives us more
	                 * possibilities for different quant_compare modes. Much more
	                 * than 3 makes not a big difference, it is only slower.
	                 */
	
	                if ((gfc.substep_shaping & 2) != 0) {
	                    search_limit = 20;
	                } else {
	                    search_limit = 3;
	                }
	
	                /*
	                 * Check if the last scalefactor band is distorted. in VBR mode
	                 * we can't get rid of the distortion, so quit now and VBR mode
	                 * will try again with more bits. (makes a 10% speed increase,
	                 * the files I tested were binary identical, 2000/05/20 Robert
	                 * Hegemann) distort[] > 1 means noise > allowed noise
	                 */
	                if (gfc.sfb21_extra) {
	                    if (distort[cod_info_w.sfbmax] > 1.0)
	                        break;
	                    if (cod_info_w.block_type == Encoder.SHORT_TYPE
	                        && (distort[cod_info_w.sfbmax + 1] > 1.0 || distort[cod_info_w.sfbmax + 2] > 1.0))
	                        break;
	                }
	
	                /* try a new scalefactor conbination on cod_info_w */
	                if (!balance_noise(gfp, cod_info_w, distort, xrpow, bRefine))
	                    break;
	                if (cod_info_w.scalefac_scale != 0)
	                    maxggain = 254;
	
	                /*
	                 * inner_loop starts with the initial quantization step computed
	                 * above and slowly increases until the bits < huff_bits. Thus
	                 * it is important not to start with too large of an inital
	                 * quantization step. Too small is ok, but inner_loop will take
	                 * longer
	                 */
	                var huff_bits = targ_bits - cod_info_w.part2_length;
	                if (huff_bits <= 0)
	                    break;
	
	                /*
	                 * increase quantizer stepsize until needed bits are below
	                 * maximum
	                 */
	                while ((cod_info_w.part2_3_length = tk.count_bits(gfc, xrpow,
	                    cod_info_w, prev_noise)) > huff_bits
	                && cod_info_w.global_gain <= maxggain)
	                    cod_info_w.global_gain++;
	
	                if (cod_info_w.global_gain > maxggain)
	                    break;
	
	                if (best_noise_info.over_count == 0) {
	
	                    while ((cod_info_w.part2_3_length = tk.count_bits(gfc,
	                        xrpow, cod_info_w, prev_noise)) > best_part2_3_length
	                    && cod_info_w.global_gain <= maxggain)
	                        cod_info_w.global_gain++;
	
	                    if (cod_info_w.global_gain > maxggain)
	                        break;
	                }
	
	                /* compute the distortion in this quantization */
	                qupvt.calc_noise(cod_info_w, l3_xmin, distort, noise_info,
	                    prev_noise);
	                noise_info.bits = cod_info_w.part2_3_length;
	
	                /*
	                 * check if this quantization is better than our saved
	                 * quantization
	                 */
	                if (cod_info.block_type != Encoder.SHORT_TYPE) {
	                    // NORM, START or STOP type
	                    better = gfp.quant_comp;
	                } else
	                    better = gfp.quant_comp_short;
	
	                better = quant_compare(better, best_noise_info, noise_info,
	                    cod_info_w, distort) ? 1 : 0;
	
	                /* save data so we can restore this quantization later */
	                if (better != 0) {
	                    best_part2_3_length = cod_info.part2_3_length;
	                    best_noise_info = noise_info;
	                    cod_info.assign(cod_info_w);
	                    age = 0;
	                    /* save data so we can restore this quantization later */
	                    /* store for later reuse */
	                    System.arraycopy(xrpow, 0, save_xrpow, 0, 576);
	                } else {
	                    /* early stop? */
	                    if (gfc.full_outer_loop == 0) {
	                        if (++age > search_limit
	                            && best_noise_info.over_count == 0)
	                            break;
	                        if ((gfc.noise_shaping_amp == 3) && bRefine && age > 30)
	                            break;
	                        if ((gfc.noise_shaping_amp == 3)
	                            && bRefine
	                            && (cod_info_w.global_gain - best_ggain_pass1) > 15)
	                            break;
	                    }
	                }
	            } while ((cod_info_w.global_gain + cod_info_w.scalefac_scale) < 255);
	
	            if (gfc.noise_shaping_amp == 3) {
	                if (!bRefine) {
	                    /* refine search */
	                    cod_info_w.assign(cod_info);
	                    System.arraycopy(save_xrpow, 0, xrpow, 0, 576);
	                    age = 0;
	                    best_ggain_pass1 = cod_info_w.global_gain;
	
	                    bRefine = true;
	                } else {
	                    /* search already refined, stop */
	                    bEndOfSearch = true;
	                }
	
	            } else {
	                bEndOfSearch = true;
	            }
	        }
	
	        assert((cod_info.global_gain + cod_info.scalefac_scale) <= 255);
	        /*
	         * finish up
	         */
	        if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
	        /* restore for reuse on next try */
	            System.arraycopy(save_xrpow, 0, xrpow, 0, 576);
	        /*
	         * do the 'substep shaping'
	         */
	        else if ((gfc.substep_shaping & 1) != 0)
	            trancate_smallspectrums(gfc, cod_info, l3_xmin, xrpow);
	
	        return best_noise_info.over_count;
	    }
	
	    /**
	     * Robert Hegemann 2000-09-06
	     *
	     * update reservoir status after FINAL quantization/bitrate
	     */
	    this.iteration_finish_one = function (gfc, gr, ch) {
	        var l3_side = gfc.l3_side;
	        var cod_info = l3_side.tt[gr][ch];
	
	        /*
	         * try some better scalefac storage
	         */
	        tk.best_scalefac_store(gfc, gr, ch, l3_side);
	
	        /*
	         * best huffman_divide may save some bits too
	         */
	        if (gfc.use_best_huffman == 1)
	            tk.best_huffman_divide(gfc, cod_info);
	
	        /*
	         * update reservoir status after FINAL quantization/bitrate
	         */
	        rv.ResvAdjust(gfc, cod_info);
	    };
	
	    /**
	     *
	     * 2000-09-04 Robert Hegemann
	     *
	     * @param l3_xmin
	     *            allowed distortion of the scalefactor
	     * @param xrpow
	     *            coloured magnitudes of spectral values
	     */
	    this.VBR_encode_granule = function (gfp, cod_info, l3_xmin, xrpow, ch, min_bits, max_bits) {
	        var gfc = gfp.internal_flags;
	        var bst_cod_info = new GrInfo();
	        var bst_xrpow = new_float(576);
	        var Max_bits = max_bits;
	        var real_bits = max_bits + 1;
	        var this_bits = (max_bits + min_bits) / 2;
	        var dbits, over, found = 0;
	        var sfb21_extra = gfc.sfb21_extra;
	
	        assert(Max_bits <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
	        Arrays.fill(bst_cod_info.l3_enc, 0);
	
	        /*
	         * search within round about 40 bits of optimal
	         */
	        do {
	            assert(this_bits >= min_bits);
	            assert(this_bits <= max_bits);
	            assert(min_bits <= max_bits);
	
	            if (this_bits > Max_bits - 42)
	                gfc.sfb21_extra = false;
	            else
	                gfc.sfb21_extra = sfb21_extra;
	
	            over = outer_loop(gfp, cod_info, l3_xmin, xrpow, ch, this_bits);
	
	            /*
	             * is quantization as good as we are looking for ? in this case: is
	             * no scalefactor band distorted?
	             */
	            if (over <= 0) {
	                found = 1;
	                /*
	                 * now we know it can be done with "real_bits" and maybe we can
	                 * skip some iterations
	                 */
	                real_bits = cod_info.part2_3_length;
	
	                /*
	                 * store best quantization so far
	                 */
	                bst_cod_info.assign(cod_info);
	                System.arraycopy(xrpow, 0, bst_xrpow, 0, 576);
	
	                /*
	                 * try with fewer bits
	                 */
	                max_bits = real_bits - 32;
	                dbits = max_bits - min_bits;
	                this_bits = (max_bits + min_bits) / 2;
	            } else {
	                /*
	                 * try with more bits
	                 */
	                min_bits = this_bits + 32;
	                dbits = max_bits - min_bits;
	                this_bits = (max_bits + min_bits) / 2;
	
	                if (found != 0) {
	                    found = 2;
	                    /*
	                     * start again with best quantization so far
	                     */
	                    cod_info.assign(bst_cod_info);
	                    System.arraycopy(bst_xrpow, 0, xrpow, 0, 576);
	                }
	            }
	        } while (dbits > 12);
	
	        gfc.sfb21_extra = sfb21_extra;
	
	        /*
	         * found=0 => nothing found, use last one found=1 => we just found the
	         * best and left the loop found=2 => we restored a good one and have now
	         * l3_enc to restore too
	         */
	        if (found == 2) {
	            System.arraycopy(bst_cod_info.l3_enc, 0, cod_info.l3_enc, 0, 576);
	        }
	        assert(cod_info.part2_3_length <= Max_bits);
	    }
	
	    /**
	     * Robert Hegemann 2000-09-05
	     *
	     * calculates * how many bits are available for analog silent granules * how
	     * many bits to use for the lowest allowed bitrate * how many bits each
	     * bitrate would provide
	     */
	    this.get_framebits = function (gfp, frameBits) {
	        var gfc = gfp.internal_flags;
	
	        /*
	         * always use at least this many bits per granule per channel unless we
	         * detect analog silence, see below
	         */
	        gfc.bitrate_index = gfc.VBR_min_bitrate;
	        var bitsPerFrame = bs.getframebits(gfp);
	
	        /*
	         * bits for analog silence
	         */
	        gfc.bitrate_index = 1;
	        bitsPerFrame = bs.getframebits(gfp);
	
	        for (var i = 1; i <= gfc.VBR_max_bitrate; i++) {
	            gfc.bitrate_index = i;
	            var mb = new MeanBits(bitsPerFrame);
	            frameBits[i] = rv.ResvFrameBegin(gfp, mb);
	            bitsPerFrame = mb.bits;
	        }
	    };
	
	    /* RH: this one needs to be overhauled sometime */
	
	    /**
	     * <PRE>
	     *  2000-09-04 Robert Hegemann
	     *
	     *  * converts LR to MS coding when necessary
	     *  * calculates allowed/adjusted quantization noise amounts
	     *  * detects analog silent frames
	     *
	     *  some remarks:
	     *  - lower masking depending on Quality setting
	     *  - quality control together with adjusted ATH MDCT scaling
	     *    on lower quality setting allocate more noise from
	     *    ATH masking, and on higher quality setting allocate
	     *    less noise from ATH masking.
	     *  - experiments show that going more than 2dB over GPSYCHO's
	     *    limits ends up in very annoying artefacts
	     * </PRE>
	     */
	    this.VBR_old_prepare = function (gfp, pe, ms_ener_ratio, ratio, l3_xmin, frameBits, min_bits,
	                                     max_bits, bands) {
	        var gfc = gfp.internal_flags;
	
	        var masking_lower_db, adjust = 0.0;
	        var analog_silence = 1;
	        var bits = 0;
	
	        gfc.bitrate_index = gfc.VBR_max_bitrate;
	        var avg = rv.ResvFrameBegin(gfp, new MeanBits(0)) / gfc.mode_gr;
	
	        get_framebits(gfp, frameBits);
	
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            var mxb = qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
	            if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
	                ms_convert(gfc.l3_side, gr);
	                qupvt.reduce_side(max_bits[gr], ms_ener_ratio[gr], avg, mxb);
	            }
	            for (var ch = 0; ch < gfc.channels_out; ++ch) {
	                var cod_info = gfc.l3_side.tt[gr][ch];
	
	                if (cod_info.block_type != Encoder.SHORT_TYPE) {
	                    // NORM, START or STOP type
	                    adjust = 1.28 / (1 + Math
	                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.05;
	                    masking_lower_db = gfc.PSY.mask_adjust - adjust;
	                } else {
	                    adjust = 2.56 / (1 + Math
	                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.14;
	                    masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
	                }
	                gfc.masking_lower = Math.pow(10.0,
	                    masking_lower_db * 0.1);
	
	                init_outer_loop(gfc, cod_info);
	                bands[gr][ch] = qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
	                    l3_xmin[gr][ch]);
	                if (bands[gr][ch] != 0)
	                    analog_silence = 0;
	
	                min_bits[gr][ch] = 126;
	
	                bits += max_bits[gr][ch];
	            }
	        }
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            for (var ch = 0; ch < gfc.channels_out; ch++) {
	                if (bits > frameBits[gfc.VBR_max_bitrate]) {
	                    max_bits[gr][ch] *= frameBits[gfc.VBR_max_bitrate];
	                    max_bits[gr][ch] /= bits;
	                }
	                if (min_bits[gr][ch] > max_bits[gr][ch])
	                    min_bits[gr][ch] = max_bits[gr][ch];
	
	            }
	            /* for ch */
	        }
	        /* for gr */
	
	        return analog_silence;
	    };
	
	    this.bitpressure_strategy = function (gfc, l3_xmin, min_bits, max_bits) {
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            for (var ch = 0; ch < gfc.channels_out; ch++) {
	                var gi = gfc.l3_side.tt[gr][ch];
	                var pxmin = l3_xmin[gr][ch];
	                var pxminPos = 0;
	                for (var sfb = 0; sfb < gi.psy_lmax; sfb++)
	                    pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
	                        / Encoder.SBMAX_l / Encoder.SBMAX_l;
	
	                if (gi.block_type == Encoder.SHORT_TYPE) {
	                    for (var sfb = gi.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
	                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
	                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
	                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
	                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
	                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
	                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
	                    }
	                }
	                max_bits[gr][ch] = 0 | Math.max(min_bits[gr][ch],
	                        0.9 * max_bits[gr][ch]);
	            }
	        }
	    };
	
	    this.VBR_new_prepare = function (gfp, pe, ratio, l3_xmin, frameBits, max_bits) {
	        var gfc = gfp.internal_flags;
	
	        var analog_silence = 1;
	        var avg = 0, bits = 0;
	        var maximum_framebits;
	
	        if (!gfp.free_format) {
	            gfc.bitrate_index = gfc.VBR_max_bitrate;
	
	            var mb = new MeanBits(avg);
	            rv.ResvFrameBegin(gfp, mb);
	            avg = mb.bits;
	
	            get_framebits(gfp, frameBits);
	            maximum_framebits = frameBits[gfc.VBR_max_bitrate];
	        } else {
	            gfc.bitrate_index = 0;
	            var mb = new MeanBits(avg);
	            maximum_framebits = rv.ResvFrameBegin(gfp, mb);
	            avg = mb.bits;
	            frameBits[0] = maximum_framebits;
	        }
	
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
	            if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
	                ms_convert(gfc.l3_side, gr);
	            }
	            for (var ch = 0; ch < gfc.channels_out; ++ch) {
	                var cod_info = gfc.l3_side.tt[gr][ch];
	
	                gfc.masking_lower = Math.pow(10.0,
	                    gfc.PSY.mask_adjust * 0.1);
	
	                init_outer_loop(gfc, cod_info);
	                if (0 != qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
	                        l3_xmin[gr][ch]))
	                    analog_silence = 0;
	
	                bits += max_bits[gr][ch];
	            }
	        }
	        for (var gr = 0; gr < gfc.mode_gr; gr++) {
	            for (var ch = 0; ch < gfc.channels_out; ch++) {
	                if (bits > maximum_framebits) {
	                    max_bits[gr][ch] *= maximum_framebits;
	                    max_bits[gr][ch] /= bits;
	                }
	
	            }
	            /* for ch */
	        }
	        /* for gr */
	
	        return analog_silence;
	    };
	
	    /**
	     * calculates target bits for ABR encoding
	     *
	     * mt 2000/05/31
	     */
	    this.calc_target_bits = function (gfp, pe, ms_ener_ratio, targ_bits, analog_silence_bits, max_frame_bits) {
	        var gfc = gfp.internal_flags;
	        var l3_side = gfc.l3_side;
	        var res_factor;
	        var gr, ch, totbits, mean_bits = 0;
	
	        gfc.bitrate_index = gfc.VBR_max_bitrate;
	        var mb = new MeanBits(mean_bits);
	        max_frame_bits[0] = rv.ResvFrameBegin(gfp, mb);
	        mean_bits = mb.bits;
	
	        gfc.bitrate_index = 1;
	        mean_bits = bs.getframebits(gfp) - gfc.sideinfo_len * 8;
	        analog_silence_bits[0] = mean_bits / (gfc.mode_gr * gfc.channels_out);
	
	        mean_bits = gfp.VBR_mean_bitrate_kbps * gfp.framesize * 1000;
	        if ((gfc.substep_shaping & 1) != 0)
	            mean_bits *= 1.09;
	        mean_bits /= gfp.out_samplerate;
	        mean_bits -= gfc.sideinfo_len * 8;
	        mean_bits /= (gfc.mode_gr * gfc.channels_out);
	
	        /**
	         * <PRE>
	         *           res_factor is the percentage of the target bitrate that should
	         *           be used on average.  the remaining bits are added to the
	         *           bitreservoir and used for difficult to encode frames.
	         *
	         *           Since we are tracking the average bitrate, we should adjust
	         *           res_factor "on the fly", increasing it if the average bitrate
	         *           is greater than the requested bitrate, and decreasing it
	         *           otherwise.  Reasonable ranges are from .9 to 1.0
	         *
	         *           Until we get the above suggestion working, we use the following
	         *           tuning:
	         *           compression ratio    res_factor
	         *           5.5  (256kbps)         1.0      no need for bitreservoir
	         *           11   (128kbps)         .93      7% held for reservoir
	         *
	         *           with linear interpolation for other values.
	         * </PRE>
	         */
	        res_factor = .93 + .07 * (11.0 - gfp.compression_ratio)
	            / (11.0 - 5.5);
	        if (res_factor < .90)
	            res_factor = .90;
	        if (res_factor > 1.00)
	            res_factor = 1.00;
	
	        for (gr = 0; gr < gfc.mode_gr; gr++) {
	            var sum = 0;
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                targ_bits[gr][ch] = (int)(res_factor * mean_bits);
	
	                if (pe[gr][ch] > 700) {
	                    var add_bits = (int)((pe[gr][ch] - 700) / 1.4);
	
	                    var cod_info = l3_side.tt[gr][ch];
	                    targ_bits[gr][ch] = (int)(res_factor * mean_bits);
	
	                    /* short blocks use a little extra, no matter what the pe */
	                    if (cod_info.block_type == Encoder.SHORT_TYPE) {
	                        if (add_bits < mean_bits / 2)
	                            add_bits = mean_bits / 2;
	                    }
	                    /* at most increase bits by 1.5*average */
	                    if (add_bits > mean_bits * 3 / 2)
	                        add_bits = mean_bits * 3 / 2;
	                    else if (add_bits < 0)
	                        add_bits = 0;
	
	                    targ_bits[gr][ch] += add_bits;
	                }
	                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL) {
	                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
	                }
	                sum += targ_bits[gr][ch];
	            }
	            /* for ch */
	            if (sum > LameInternalFlags.MAX_BITS_PER_GRANULE) {
	                for (ch = 0; ch < gfc.channels_out; ++ch) {
	                    targ_bits[gr][ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
	                    targ_bits[gr][ch] /= sum;
	                }
	            }
	        }
	        /* for gr */
	
	        if (gfc.mode_ext == Encoder.MPG_MD_MS_LR)
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                qupvt.reduce_side(targ_bits[gr], ms_ener_ratio[gr], mean_bits
	                    * gfc.channels_out,
	                    LameInternalFlags.MAX_BITS_PER_GRANULE);
	            }
	
	        /*
	         * sum target bits
	         */
	        totbits = 0;
	        for (gr = 0; gr < gfc.mode_gr; gr++) {
	            for (ch = 0; ch < gfc.channels_out; ch++) {
	                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
	                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
	                totbits += targ_bits[gr][ch];
	            }
	        }
	
	        /*
	         * repartion target bits if needed
	         */
	        if (totbits > max_frame_bits[0]) {
	            for (gr = 0; gr < gfc.mode_gr; gr++) {
	                for (ch = 0; ch < gfc.channels_out; ch++) {
	                    targ_bits[gr][ch] *= max_frame_bits[0];
	                    targ_bits[gr][ch] /= totbits;
	                }
	            }
	        }
	    }
	
	}
	
	module.exports = Quantize;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	var GainAnalysis = __webpack_require__(191);
	
	function ReplayGain() {
	    this.linprebuf = new_float(GainAnalysis.MAX_ORDER * 2);
	    /**
	     * left input samples, with pre-buffer
	     */
	    this.linpre = 0;
	    this.lstepbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
	    /**
	     * left "first step" (i.e. post first filter) samples
	     */
	    this.lstep = 0;
	    this.loutbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
	    /**
	     * left "out" (i.e. post second filter) samples
	     */
	    this.lout = 0;
	    this.rinprebuf = new_float(GainAnalysis.MAX_ORDER * 2);
	    /**
	     * right input samples ...
	     */
	    this.rinpre = 0;
	    this.rstepbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
	    this.rstep = 0;
	    this.routbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
	    this.rout = 0;
	    /**
	     * number of samples required to reach number of milliseconds required
	     * for RMS window
	     */
	    this.sampleWindow = 0;
	    this.totsamp = 0;
	    this.lsum = 0.;
	    this.rsum = 0.;
	    this.freqindex = 0;
	    this.first = 0;
	    this.A = new_int(0 | (GainAnalysis.STEPS_per_dB * GainAnalysis.MAX_dB));
	    this.B = new_int(0 | (GainAnalysis.STEPS_per_dB * GainAnalysis.MAX_dB));
	
	}
	
	module.exports = ReplayGain;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *      bit reservoir source file
	 *
	 *      Copyright (c) 1999-2000 Mark Taylor
	 *
	 * This library is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU Lesser General Public
	 * License as published by the Free Software Foundation; either
	 * version 2 of the License, or (at your option) any later version.
	 *
	 * This library is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	 * Library General Public License for more details.
	 *
	 * You should have received a copy of the GNU Lesser General Public
	 * License along with this library; if not, write to the
	 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
	 * Boston, MA 02111-1307, USA.
	 */
	
	/* $Id: Reservoir.java,v 1.9 2011/05/24 20:48:06 kenchis Exp $ */
	
	//package mp3;
	
	/**
	 * ResvFrameBegin:<BR>
	 * Called (repeatedly) at the beginning of a frame. Updates the maximum size of
	 * the reservoir, and checks to make sure main_data_begin was set properly by
	 * the formatter<BR>
	 * Background information:
	 * 
	 * This is the original text from the ISO standard. Because of sooo many bugs
	 * and irritations correcting comments are added in brackets []. A '^W' means
	 * you should remove the last word.
	 * 
	 * <PRE>
	 *  1. The following rule can be used to calculate the maximum
	 *     number of bits used for one granule [^W frame]:<BR>
	 *     At the highest possible bitrate of Layer III (320 kbps
	 *     per stereo signal [^W^W^W], 48 kHz) the frames must be of
	 *     [^W^W^W are designed to have] constant length, i.e.
	 *     one buffer [^W^W the frame] length is:<BR>
	 * 
	 *         320 kbps * 1152/48 kHz = 7680 bit = 960 byte
	 * 
	 *     This value is used as the maximum buffer per channel [^W^W] at
	 *     lower bitrates [than 320 kbps]. At 64 kbps mono or 128 kbps
	 *     stereo the main granule length is 64 kbps * 576/48 kHz = 768 bit
	 *     [per granule and channel] at 48 kHz sampling frequency.
	 *     This means that there is a maximum deviation (short time buffer
	 *     [= reservoir]) of 7680 - 2*2*768 = 4608 bits is allowed at 64 kbps.
	 *     The actual deviation is equal to the number of bytes [with the
	 *     meaning of octets] denoted by the main_data_end offset pointer.
	 *     The actual maximum deviation is (2^9-1)*8 bit = 4088 bits
	 *     [for MPEG-1 and (2^8-1)*8 bit for MPEG-2, both are hard limits].
	 *     ... The xchange of buffer bits between the left and right channel
	 *     is allowed without restrictions [exception: dual channel].
	 *     Because of the [constructed] constraint on the buffer size
	 *     main_data_end is always set to 0 in the case of bit_rate_index==14,
	 *     i.e. data rate 320 kbps per stereo signal [^W^W^W]. In this case
	 *     all data are allocated between adjacent header [^W sync] words
	 *     [, i.e. there is no buffering at all].
	 * </PRE>
	 */
	
	var common = __webpack_require__(17);
	var assert = common.assert;
	
	function Reservoir() {
		var bs;
	
		this.setModules  = function(_bs) {
			bs = _bs;
		}
	
		this.ResvFrameBegin = function(gfp, mean_bits) {
			var gfc = gfp.internal_flags;
			var maxmp3buf;
			var l3_side = gfc.l3_side;
	
			var frameLength = bs.getframebits(gfp);
			mean_bits.bits = (frameLength - gfc.sideinfo_len * 8) / gfc.mode_gr;
	
			/**
			 * <PRE>
			 *  Meaning of the variables:
			 *      resvLimit: (0, 8, ..., 8*255 (MPEG-2), 8*511 (MPEG-1))
			 *          Number of bits can be stored in previous frame(s) due to
			 *          counter size constaints
			 *      maxmp3buf: ( ??? ... 8*1951 (MPEG-1 and 2), 8*2047 (MPEG-2.5))
			 *          Number of bits allowed to encode one frame (you can take 8*511 bit
			 *          from the bit reservoir and at most 8*1440 bit from the current
			 *          frame (320 kbps, 32 kHz), so 8*1951 bit is the largest possible
			 *          value for MPEG-1 and -2)
			 * 
			 *          maximum allowed granule/channel size times 4 = 8*2047 bits.,
			 *          so this is the absolute maximum supported by the format.
			 * 
			 * 
			 *      fullFrameBits:  maximum number of bits available for encoding
			 *                      the current frame.
			 * 
			 *      mean_bits:      target number of bits per granule.
			 * 
			 *      frameLength:
			 * 
			 *      gfc.ResvMax:   maximum allowed reservoir
			 * 
			 *      gfc.ResvSize:  current reservoir size
			 * 
			 *      l3_side.resvDrain_pre:
			 *         ancillary data to be added to previous frame:
			 *         (only usefull in VBR modes if it is possible to have
			 *         maxmp3buf < fullFrameBits)).  Currently disabled,
			 *         see #define NEW_DRAIN
			 *         2010-02-13: RH now enabled, it seems to be needed for CBR too,
			 *                     as there exists one example, where the FhG decoder
			 *                     can't decode a -b320 CBR file anymore.
			 * 
			 *      l3_side.resvDrain_post:
			 *         ancillary data to be added to this frame:
			 * 
			 * </PRE>
			 */
	
			/* main_data_begin has 9 bits in MPEG-1, 8 bits MPEG-2 */
			var resvLimit = (8 * 256) * gfc.mode_gr - 8;
	
			/*
			 * maximum allowed frame size. dont use more than this number of bits,
			 * even if the frame has the space for them:
			 */
			if (gfp.brate > 320) {
				/* in freeformat the buffer is constant */
				maxmp3buf = 8 * ((int) ((gfp.brate * 1000)
						/ (gfp.out_samplerate / 1152) / 8 + .5));
			} else {
				/*
				 * all mp3 decoders should have enough buffer to handle this value:
				 * size of a 320kbps 32kHz frame
				 */
				maxmp3buf = 8 * 1440;
	
				/*
				 * Bouvigne suggests this more lax interpretation of the ISO doc
				 * instead of using 8*960.
				 */
	
				if (gfp.strict_ISO) {
					maxmp3buf = 8 * ((int) (320000 / (gfp.out_samplerate / 1152) / 8 + .5));
				}
			}
	
			gfc.ResvMax = maxmp3buf - frameLength;
			if (gfc.ResvMax > resvLimit)
				gfc.ResvMax = resvLimit;
			if (gfc.ResvMax < 0 || gfp.disable_reservoir)
				gfc.ResvMax = 0;
	
			var fullFrameBits = mean_bits.bits * gfc.mode_gr
					+ Math.min(gfc.ResvSize, gfc.ResvMax);
	
			if (fullFrameBits > maxmp3buf)
				fullFrameBits = maxmp3buf;
	
			assert (0 == gfc.ResvMax % 8);
			assert (gfc.ResvMax >= 0);
	
			l3_side.resvDrain_pre = 0;
	
			// frame analyzer code
			if (gfc.pinfo != null) {
				/*
				 * expected bits per channel per granule [is this also right for
				 * mono/stereo, MPEG-1/2 ?]
				 */
				gfc.pinfo.mean_bits = mean_bits.bits / 2;
				gfc.pinfo.resvsize = gfc.ResvSize;
			}
	
			return fullFrameBits;
		}
	
		/**
		 * returns targ_bits: target number of bits to use for 1 granule<BR>
		 * extra_bits: amount extra available from reservoir<BR>
		 * Mark Taylor 4/99
		 */
		this.ResvMaxBits = function(gfp, mean_bits, targ_bits, cbr) {
			var gfc = gfp.internal_flags;
			var add_bits;
	        var ResvSize = gfc.ResvSize, ResvMax = gfc.ResvMax;
	
			/* compensate the saved bits used in the 1st granule */
			if (cbr != 0)
				ResvSize += mean_bits;
	
			if ((gfc.substep_shaping & 1) != 0)
				ResvMax *= 0.9;
	
			targ_bits.bits = mean_bits;
	
			/* extra bits if the reservoir is almost full */
			if (ResvSize * 10 > ResvMax * 9) {
				add_bits = ResvSize - (ResvMax * 9) / 10;
				targ_bits.bits += add_bits;
				gfc.substep_shaping |= 0x80;
			} else {
				add_bits = 0;
				gfc.substep_shaping &= 0x7f;
				/*
				 * build up reservoir. this builds the reservoir a little slower
				 * than FhG. It could simple be mean_bits/15, but this was rigged to
				 * always produce 100 (the old value) at 128kbs
				 */
				if (!gfp.disable_reservoir && 0 == (gfc.substep_shaping & 1))
					targ_bits.bits -= .1 * mean_bits;
			}
	
			/* amount from the reservoir we are allowed to use. ISO says 6/10 */
			var extra_bits = (ResvSize < (gfc.ResvMax * 6) / 10 ? ResvSize
					: (gfc.ResvMax * 6) / 10);
			extra_bits -= add_bits;
	
			if (extra_bits < 0)
				extra_bits = 0;
			return extra_bits;
		}
	
		/**
		 * Called after a granule's bit allocation. Readjusts the size of the
		 * reservoir to reflect the granule's usage.
		 */
		this.ResvAdjust = function(gfc, gi) {
			gfc.ResvSize -= gi.part2_3_length + gi.part2_length;
		}
	
		/**
		 * Called after all granules in a frame have been allocated. Makes sure that
		 * the reservoir size is within limits, possibly by adding stuffing bits.
		 */
		this.ResvFrameEnd = function(gfc, mean_bits) {
			var over_bits;
			var l3_side = gfc.l3_side;
	
			gfc.ResvSize += mean_bits * gfc.mode_gr;
			var stuffingBits = 0;
			l3_side.resvDrain_post = 0;
			l3_side.resvDrain_pre = 0;
	
			/* we must be byte aligned */
			if ((over_bits = gfc.ResvSize % 8) != 0)
				stuffingBits += over_bits;
	
			over_bits = (gfc.ResvSize - stuffingBits) - gfc.ResvMax;
			if (over_bits > 0) {
				assert (0 == over_bits % 8);
				assert (over_bits >= 0);
				stuffingBits += over_bits;
			}
	
			/*
			 * NOTE: enabling the NEW_DRAIN code fixes some problems with FhG
			 * decoder shipped with MS Windows operating systems. Using this, it is
			 * even possible to use Gabriel's lax buffer consideration again, which
			 * assumes, any decoder should have a buffer large enough for a 320 kbps
			 * frame at 32 kHz sample rate.
			 * 
			 * old drain code: lame -b320 BlackBird.wav --. does not play with
			 * GraphEdit.exe using FhG decoder V1.5 Build 50
			 * 
			 * new drain code: lame -b320 BlackBird.wav --. plays fine with
			 * GraphEdit.exe using FhG decoder V1.5 Build 50
			 * 
			 * Robert Hegemann, 2010-02-13.
			 */
			/*
			 * drain as many bits as possible into previous frame ancillary data In
			 * particular, in VBR mode ResvMax may have changed, and we have to make
			 * sure main_data_begin does not create a reservoir bigger than ResvMax
			 * mt 4/00
			 */
			{
				var mdb_bytes = Math.min(l3_side.main_data_begin * 8, stuffingBits) / 8;
				l3_side.resvDrain_pre += 8 * mdb_bytes;
				stuffingBits -= 8 * mdb_bytes;
				gfc.ResvSize -= 8 * mdb_bytes;
				l3_side.main_data_begin -= mdb_bytes;
			}
			/* drain the rest into this frames ancillary data */
			l3_side.resvDrain_post += stuffingBits;
			gfc.ResvSize -= stuffingBits;
		}
	}
	
	module.exports = Reservoir;


/***/ },
/* 409 */
/***/ function(module, exports) {

	function VBRQuantize() {
	    var qupvt;
	    var tak;
	
	    this.setModules = function (_qupvt, _tk) {
	        qupvt = _qupvt;
	        tak = _tk;
	    }
	    //TODO
	
	}
	
	module.exports = VBRQuantize;


/***/ },
/* 410 */
/***/ function(module, exports) {

	//package mp3;
	
	function VBRSeekInfo() {
	    /**
	     * What we have seen so far.
	     */
	    this.sum = 0;
	    /**
	     * How many frames we have seen in this chunk.
	     */
	    this.seen = 0;
	    /**
	     * How many frames we want to collect into one chunk.
	     */
	    this.want = 0;
	    /**
	     * Actual position in our bag.
	     */
	    this.pos = 0;
	    /**
	     * Size of our bag.
	     */
	    this.size = 0;
	    /**
	     * Pointer to our bag.
	     */
	    this.bag = null;
	    this.nVbrNumFrames = 0;
	    this.nBytesWritten = 0;
	    /* VBR tag data */
	    this.TotalFrameSize = 0;
	}
	
	module.exports = VBRSeekInfo;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	/**
	 * A Vbr header may be present in the ancillary data field of the first frame of
	 * an mp3 bitstream<BR>
	 * The Vbr header (optionally) contains
	 * <UL>
	 * <LI>frames total number of audio frames in the bitstream
	 * <LI>bytes total number of bytes in the bitstream
	 * <LI>toc table of contents
	 * </UL>
	 *
	 * toc (table of contents) gives seek points for random access.<BR>
	 * The ith entry determines the seek point for i-percent duration.<BR>
	 * seek point in bytes = (toc[i]/256.0) * total_bitstream_bytes<BR>
	 * e.g. half duration seek point = (toc[50]/256.0) * total_bitstream_bytes
	 */
	VBRTag.NUMTOCENTRIES = 100;
	VBRTag.MAXFRAMESIZE = 2880;
	
	function VBRTag() {
	
	    var lame;
	    var bs;
	    var v;
	
	    this.setModules = function (_lame, _bs, _v) {
	        lame = _lame;
	        bs = _bs;
	        v = _v;
	    };
	
	    var FRAMES_FLAG = 0x0001;
	    var BYTES_FLAG = 0x0002;
	    var TOC_FLAG = 0x0004;
	    var VBR_SCALE_FLAG = 0x0008;
	
	    var NUMTOCENTRIES = VBRTag.NUMTOCENTRIES;
	
	    /**
	     * (0xB40) the max freeformat 640 32kHz framesize.
	     */
	    var MAXFRAMESIZE = VBRTag.MAXFRAMESIZE;
	
	    /**
	     * <PRE>
	     *    4 bytes for Header Tag
	     *    4 bytes for Header Flags
	     *  100 bytes for entry (toc)
	     *    4 bytes for frame size
	     *    4 bytes for stream size
	     *    4 bytes for VBR scale. a VBR quality indicator: 0=best 100=worst
	     *   20 bytes for LAME tag.  for example, "LAME3.12 (beta 6)"
	     * ___________
	     *  140 bytes
	     * </PRE>
	     */
	    var VBRHEADERSIZE = (NUMTOCENTRIES + 4 + 4 + 4 + 4 + 4);
	
	    var LAMEHEADERSIZE = (VBRHEADERSIZE + 9 + 1 + 1 + 8
	    + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2);
	
	    /**
	     * The size of the Xing header MPEG-1, bit rate in kbps.
	     */
	    var XING_BITRATE1 = 128;
	    /**
	     * The size of the Xing header MPEG-2, bit rate in kbps.
	     */
	    var XING_BITRATE2 = 64;
	    /**
	     * The size of the Xing header MPEG-2.5, bit rate in kbps.
	     */
	    var XING_BITRATE25 = 32;
	
	    /**
	     * ISO-8859-1 charset for byte to string operations.
	     */
	    var ISO_8859_1 = null; //Charset.forName("ISO-8859-1");
	
	    /**
	     * VBR header magic string.
	     */
	    var VBRTag0 = "Xing";
	    /**
	     * VBR header magic string (VBR == VBRMode.vbr_off).
	     */
	    var VBRTag1 = "Info";
	
	    /**
	     * Lookup table for fast CRC-16 computation. Uses the polynomial
	     * x^16+x^15+x^2+1
	     */
	    var crc16Lookup = [0x0000, 0xC0C1, 0xC181, 0x0140,
	        0xC301, 0x03C0, 0x0280, 0xC241, 0xC601, 0x06C0, 0x0780, 0xC741,
	        0x0500, 0xC5C1, 0xC481, 0x0440, 0xCC01, 0x0CC0, 0x0D80, 0xCD41,
	        0x0F00, 0xCFC1, 0xCE81, 0x0E40, 0x0A00, 0xCAC1, 0xCB81, 0x0B40,
	        0xC901, 0x09C0, 0x0880, 0xC841, 0xD801, 0x18C0, 0x1980, 0xD941,
	        0x1B00, 0xDBC1, 0xDA81, 0x1A40, 0x1E00, 0xDEC1, 0xDF81, 0x1F40,
	        0xDD01, 0x1DC0, 0x1C80, 0xDC41, 0x1400, 0xD4C1, 0xD581, 0x1540,
	        0xD701, 0x17C0, 0x1680, 0xD641, 0xD201, 0x12C0, 0x1380, 0xD341,
	        0x1100, 0xD1C1, 0xD081, 0x1040, 0xF001, 0x30C0, 0x3180, 0xF141,
	        0x3300, 0xF3C1, 0xF281, 0x3240, 0x3600, 0xF6C1, 0xF781, 0x3740,
	        0xF501, 0x35C0, 0x3480, 0xF441, 0x3C00, 0xFCC1, 0xFD81, 0x3D40,
	        0xFF01, 0x3FC0, 0x3E80, 0xFE41, 0xFA01, 0x3AC0, 0x3B80, 0xFB41,
	        0x3900, 0xF9C1, 0xF881, 0x3840, 0x2800, 0xE8C1, 0xE981, 0x2940,
	        0xEB01, 0x2BC0, 0x2A80, 0xEA41, 0xEE01, 0x2EC0, 0x2F80, 0xEF41,
	        0x2D00, 0xEDC1, 0xEC81, 0x2C40, 0xE401, 0x24C0, 0x2580, 0xE541,
	        0x2700, 0xE7C1, 0xE681, 0x2640, 0x2200, 0xE2C1, 0xE381, 0x2340,
	        0xE101, 0x21C0, 0x2080, 0xE041, 0xA001, 0x60C0, 0x6180, 0xA141,
	        0x6300, 0xA3C1, 0xA281, 0x6240, 0x6600, 0xA6C1, 0xA781, 0x6740,
	        0xA501, 0x65C0, 0x6480, 0xA441, 0x6C00, 0xACC1, 0xAD81, 0x6D40,
	        0xAF01, 0x6FC0, 0x6E80, 0xAE41, 0xAA01, 0x6AC0, 0x6B80, 0xAB41,
	        0x6900, 0xA9C1, 0xA881, 0x6840, 0x7800, 0xB8C1, 0xB981, 0x7940,
	        0xBB01, 0x7BC0, 0x7A80, 0xBA41, 0xBE01, 0x7EC0, 0x7F80, 0xBF41,
	        0x7D00, 0xBDC1, 0xBC81, 0x7C40, 0xB401, 0x74C0, 0x7580, 0xB541,
	        0x7700, 0xB7C1, 0xB681, 0x7640, 0x7200, 0xB2C1, 0xB381, 0x7340,
	        0xB101, 0x71C0, 0x7080, 0xB041, 0x5000, 0x90C1, 0x9181, 0x5140,
	        0x9301, 0x53C0, 0x5280, 0x9241, 0x9601, 0x56C0, 0x5780, 0x9741,
	        0x5500, 0x95C1, 0x9481, 0x5440, 0x9C01, 0x5CC0, 0x5D80, 0x9D41,
	        0x5F00, 0x9FC1, 0x9E81, 0x5E40, 0x5A00, 0x9AC1, 0x9B81, 0x5B40,
	        0x9901, 0x59C0, 0x5880, 0x9841, 0x8801, 0x48C0, 0x4980, 0x8941,
	        0x4B00, 0x8BC1, 0x8A81, 0x4A40, 0x4E00, 0x8EC1, 0x8F81, 0x4F40,
	        0x8D01, 0x4DC0, 0x4C80, 0x8C41, 0x4400, 0x84C1, 0x8581, 0x4540,
	        0x8701, 0x47C0, 0x4680, 0x8641, 0x8201, 0x42C0, 0x4380, 0x8341,
	        0x4100, 0x81C1, 0x8081, 0x4040];
	
	    /***********************************************************************
	     * Robert Hegemann 2001-01-17
	     ***********************************************************************/
	
	    function addVbr(v, bitrate) {
	        v.nVbrNumFrames++;
	        v.sum += bitrate;
	        v.seen++;
	
	        if (v.seen < v.want) {
	            return;
	        }
	
	        if (v.pos < v.size) {
	            v.bag[v.pos] = v.sum;
	            v.pos++;
	            v.seen = 0;
	        }
	        if (v.pos == v.size) {
	            for (var i = 1; i < v.size; i += 2) {
	                v.bag[i / 2] = v.bag[i];
	            }
	            v.want *= 2;
	            v.pos /= 2;
	        }
	    }
	
	    function xingSeekTable(v, t) {
	        if (v.pos <= 0)
	            return;
	
	        for (var i = 1; i < NUMTOCENTRIES; ++i) {
	            var j = i / NUMTOCENTRIES, act, sum;
	            var indx = 0 | (Math.floor(j * v.pos));
	            if (indx > v.pos - 1)
	                indx = v.pos - 1;
	            act = v.bag[indx];
	            sum = v.sum;
	            var seek_point = 0 | (256. * act / sum);
	            if (seek_point > 255)
	                seek_point = 255;
	            t[i] = 0xff & seek_point;
	        }
	    }
	
	    /**
	     * Add VBR entry, used to fill the VBR TOC entries.
	     *
	     * @param gfp
	     *            global flags
	     */
	    this.addVbrFrame = function (gfp) {
	        var gfc = gfp.internal_flags;
	        var kbps = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
	        assert(gfc.VBR_seek_table.bag != null);
	        addVbr(gfc.VBR_seek_table, kbps);
	    }
	
	    /**
	     * Read big endian integer (4-bytes) from header.
	     *
	     * @param buf
	     *            header containing the integer
	     * @param bufPos
	     *            offset into the header
	     * @return extracted integer
	     */
	    function extractInteger(buf, bufPos) {
	        var x = buf[bufPos + 0] & 0xff;
	        x <<= 8;
	        x |= buf[bufPos + 1] & 0xff;
	        x <<= 8;
	        x |= buf[bufPos + 2] & 0xff;
	        x <<= 8;
	        x |= buf[bufPos + 3] & 0xff;
	        return x;
	    }
	
	    /**
	     * Write big endian integer (4-bytes) in the header.
	     *
	     * @param buf
	     *            header to write the integer into
	     * @param bufPos
	     *            offset into the header
	     * @param value
	     *            integer value to write
	     */
	    function createInteger(buf, bufPos, value) {
	        buf[bufPos + 0] = 0xff & ((value >> 24) & 0xff);
	        buf[bufPos + 1] = 0xff & ((value >> 16) & 0xff);
	        buf[bufPos + 2] = 0xff & ((value >> 8) & 0xff);
	        buf[bufPos + 3] = 0xff & (value & 0xff);
	    }
	
	    /**
	     * Write big endian short (2-bytes) in the header.
	     *
	     * @param buf
	     *            header to write the integer into
	     * @param bufPos
	     *            offset into the header
	     * @param value
	     *            integer value to write
	     */
	    function createShort(buf, bufPos, value) {
	        buf[bufPos + 0] = 0xff & ((value >> 8) & 0xff);
	        buf[bufPos + 1] = 0xff & (value & 0xff);
	    }
	
	    /**
	     * Check for magic strings (Xing/Info).
	     *
	     * @param buf
	     *            header to check
	     * @param bufPos
	     *            header offset to check
	     * @return magic string found
	     */
	    function isVbrTag(buf, bufPos) {
	        return new String(buf, bufPos, VBRTag0.length(), ISO_8859_1)
	                .equals(VBRTag0)
	            || new String(buf, bufPos, VBRTag1.length(), ISO_8859_1)
	                .equals(VBRTag1);
	    }
	
	    function shiftInBitsValue(x, n, v) {
	        return 0xff & ((x << n) | (v & ~(-1 << n)));
	    }
	
	    /**
	     * Construct the MP3 header using the settings of the global flags.
	     *
	     * <img src="1000px-Mp3filestructure.svg.png">
	     *
	     * @param gfp
	     *            global flags
	     * @param buffer
	     *            header
	     */
	    function setLameTagFrameHeader(gfp, buffer) {
	        var gfc = gfp.internal_flags;
	
	        // MP3 Sync Word
	        buffer[0] = shiftInBitsValue(buffer[0], 8, 0xff);
	
	        buffer[1] = shiftInBitsValue(buffer[1], 3, 7);
	        buffer[1] = shiftInBitsValue(buffer[1], 1,
	            (gfp.out_samplerate < 16000) ? 0 : 1);
	        // Version
	        buffer[1] = shiftInBitsValue(buffer[1], 1, gfp.version);
	        // 01 == Layer 3
	        buffer[1] = shiftInBitsValue(buffer[1], 2, 4 - 3);
	        // Error protection
	        buffer[1] = shiftInBitsValue(buffer[1], 1, (!gfp.error_protection) ? 1
	            : 0);
	
	        // Bit rate
	        buffer[2] = shiftInBitsValue(buffer[2], 4, gfc.bitrate_index);
	        // Frequency
	        buffer[2] = shiftInBitsValue(buffer[2], 2, gfc.samplerate_index);
	        // Pad. Bit
	        buffer[2] = shiftInBitsValue(buffer[2], 1, 0);
	        // Priv. Bit
	        buffer[2] = shiftInBitsValue(buffer[2], 1, gfp.extension);
	
	        // Mode
	        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.mode.ordinal());
	        // Mode extension (Used with Joint Stereo)
	        buffer[3] = shiftInBitsValue(buffer[3], 2, gfc.mode_ext);
	        // Copy
	        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.copyright);
	        // Original
	        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.original);
	        // Emphasis
	        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.emphasis);
	
	        /* the default VBR header. 48 kbps layer III, no padding, no crc */
	        /* but sampling freq, mode and copyright/copy protection taken */
	        /* from first valid frame */
	        buffer[0] = 0xff;
	        var abyte = 0xff & (buffer[1] & 0xf1);
	        var bitrate;
	        if (1 == gfp.version) {
	            bitrate = XING_BITRATE1;
	        } else {
	            if (gfp.out_samplerate < 16000)
	                bitrate = XING_BITRATE25;
	            else
	                bitrate = XING_BITRATE2;
	        }
	
	        if (gfp.VBR == VbrMode.vbr_off)
	            bitrate = gfp.brate;
	
	        var bbyte;
	        if (gfp.free_format)
	            bbyte = 0x00;
	        else
	            bbyte = 0xff & (16 * lame.BitrateIndex(bitrate, gfp.version,
	                    gfp.out_samplerate));
	
	        /*
	         * Use as much of the info from the real frames in the Xing header:
	         * samplerate, channels, crc, etc...
	         */
	        if (gfp.version == 1) {
	            /* MPEG1 */
	            buffer[1] = 0xff & (abyte | 0x0a);
	            /* was 0x0b; */
	            abyte = 0xff & (buffer[2] & 0x0d);
	            /* AF keep also private bit */
	            buffer[2] = 0xff & (bbyte | abyte);
	            /* 64kbs MPEG1 frame */
	        } else {
	            /* MPEG2 */
	            buffer[1] = 0xff & (abyte | 0x02);
	            /* was 0x03; */
	            abyte = 0xff & (buffer[2] & 0x0d);
	            /* AF keep also private bit */
	            buffer[2] = 0xff & (bbyte | abyte);
	            /* 64kbs MPEG2 frame */
	        }
	    }
	
	    /**
	     * Get VBR tag information
	     *
	     * @param buf
	     *            header to analyze
	     * @param bufPos
	     *            offset into the header
	     * @return VBR tag data
	     */
	    this.getVbrTag = function (buf) {
	        var pTagData = new VBRTagData();
	        var bufPos = 0;
	
	        /* get Vbr header data */
	        pTagData.flags = 0;
	
	        /* get selected MPEG header data */
	        var hId = (buf[bufPos + 1] >> 3) & 1;
	        var hSrIndex = (buf[bufPos + 2] >> 2) & 3;
	        var hMode = (buf[bufPos + 3] >> 6) & 3;
	        var hBitrate = ((buf[bufPos + 2] >> 4) & 0xf);
	        hBitrate = Tables.bitrate_table[hId][hBitrate];
	
	        /* check for FFE syncword */
	        if ((buf[bufPos + 1] >> 4) == 0xE)
	            pTagData.samprate = Tables.samplerate_table[2][hSrIndex];
	        else
	            pTagData.samprate = Tables.samplerate_table[hId][hSrIndex];
	
	        /* determine offset of header */
	        if (hId != 0) {
	            /* mpeg1 */
	            if (hMode != 3)
	                bufPos += (32 + 4);
	            else
	                bufPos += (17 + 4);
	        } else {
	            /* mpeg2 */
	            if (hMode != 3)
	                bufPos += (17 + 4);
	            else
	                bufPos += (9 + 4);
	        }
	
	        if (!isVbrTag(buf, bufPos))
	            return null;
	
	        bufPos += 4;
	
	        pTagData.hId = hId;
	
	        /* get flags */
	        var head_flags = pTagData.flags = extractInteger(buf, bufPos);
	        bufPos += 4;
	
	        if ((head_flags & FRAMES_FLAG) != 0) {
	            pTagData.frames = extractInteger(buf, bufPos);
	            bufPos += 4;
	        }
	
	        if ((head_flags & BYTES_FLAG) != 0) {
	            pTagData.bytes = extractInteger(buf, bufPos);
	            bufPos += 4;
	        }
	
	        if ((head_flags & TOC_FLAG) != 0) {
	            if (pTagData.toc != null) {
	                for (var i = 0; i < NUMTOCENTRIES; i++)
	                    pTagData.toc[i] = buf[bufPos + i];
	            }
	            bufPos += NUMTOCENTRIES;
	        }
	
	        pTagData.vbrScale = -1;
	
	        if ((head_flags & VBR_SCALE_FLAG) != 0) {
	            pTagData.vbrScale = extractInteger(buf, bufPos);
	            bufPos += 4;
	        }
	
	        pTagData.headersize = ((hId + 1) * 72000 * hBitrate)
	            / pTagData.samprate;
	
	        bufPos += 21;
	        var encDelay = buf[bufPos + 0] << 4;
	        encDelay += buf[bufPos + 1] >> 4;
	        var encPadding = (buf[bufPos + 1] & 0x0F) << 8;
	        encPadding += buf[bufPos + 2] & 0xff;
	        /* check for reasonable values (this may be an old Xing header, */
	        /* not a INFO tag) */
	        if (encDelay < 0 || encDelay > 3000)
	            encDelay = -1;
	        if (encPadding < 0 || encPadding > 3000)
	            encPadding = -1;
	
	        pTagData.encDelay = encDelay;
	        pTagData.encPadding = encPadding;
	
	        /* success */
	        return pTagData;
	    }
	
	    /**
	     * Initializes the header
	     *
	     * @param gfp
	     *            global flags
	     */
	    this.InitVbrTag = function (gfp) {
	        var gfc = gfp.internal_flags;
	
	        /**
	         * <PRE>
	         * Xing VBR pretends to be a 48kbs layer III frame.  (at 44.1kHz).
	         * (at 48kHz they use 56kbs since 48kbs frame not big enough for
	         * table of contents)
	         * let's always embed Xing header inside a 64kbs layer III frame.
	         * this gives us enough room for a LAME version string too.
	         * size determined by sampling frequency (MPEG1)
	         * 32kHz:    216 bytes@48kbs    288bytes@ 64kbs
	         * 44.1kHz:  156 bytes          208bytes@64kbs     (+1 if padding = 1)
	         * 48kHz:    144 bytes          192
	         *
	         * MPEG 2 values are the same since the framesize and samplerate
	         * are each reduced by a factor of 2.
	         * </PRE>
	         */
	        var kbps_header;
	        if (1 == gfp.version) {
	            kbps_header = XING_BITRATE1;
	        } else {
	            if (gfp.out_samplerate < 16000)
	                kbps_header = XING_BITRATE25;
	            else
	                kbps_header = XING_BITRATE2;
	        }
	
	        if (gfp.VBR == VbrMode.vbr_off)
	            kbps_header = gfp.brate;
	
	        // make sure LAME Header fits into Frame
	        var totalFrameSize = ((gfp.version + 1) * 72000 * kbps_header)
	            / gfp.out_samplerate;
	        var headerSize = (gfc.sideinfo_len + LAMEHEADERSIZE);
	        gfc.VBR_seek_table.TotalFrameSize = totalFrameSize;
	        if (totalFrameSize < headerSize || totalFrameSize > MAXFRAMESIZE) {
	            /* disable tag, it wont fit */
	            gfp.bWriteVbrTag = false;
	            return;
	        }
	
	        gfc.VBR_seek_table.nVbrNumFrames = 0;
	        gfc.VBR_seek_table.nBytesWritten = 0;
	        gfc.VBR_seek_table.sum = 0;
	
	        gfc.VBR_seek_table.seen = 0;
	        gfc.VBR_seek_table.want = 1;
	        gfc.VBR_seek_table.pos = 0;
	
	        if (gfc.VBR_seek_table.bag == null) {
	            gfc.VBR_seek_table.bag = new int[400];
	            gfc.VBR_seek_table.size = 400;
	        }
	
	        // write dummy VBR tag of all 0's into bitstream
	        var buffer = new_byte(MAXFRAMESIZE);
	
	        setLameTagFrameHeader(gfp, buffer);
	        var n = gfc.VBR_seek_table.TotalFrameSize;
	        for (var i = 0; i < n; ++i) {
	            bs.add_dummy_byte(gfp, buffer[i] & 0xff, 1);
	        }
	    }
	
	    /**
	     * Fast CRC-16 computation (uses table crc16Lookup).
	     *
	     * @param value
	     * @param crc
	     * @return
	     */
	    function crcUpdateLookup(value, crc) {
	        var tmp = crc ^ value;
	        crc = (crc >> 8) ^ crc16Lookup[tmp & 0xff];
	        return crc;
	    }
	
	    this.updateMusicCRC = function (crc, buffer, bufferPos, size) {
	        for (var i = 0; i < size; ++i)
	            crc[0] = crcUpdateLookup(buffer[bufferPos + i], crc[0]);
	    }
	
	    /**
	     * Write LAME info: mini version + info on various switches used (Jonathan
	     * Dee 2001/08/31).
	     *
	     * @param gfp
	     *            global flags
	     * @param musicLength
	     *            music length
	     * @param streamBuffer
	     *            pointer to output buffer
	     * @param streamBufferPos
	     *            offset into the output buffer
	     * @param crc
	     *            computation of CRC-16 of Lame Tag so far (starting at frame
	     *            sync)
	     * @return number of bytes written to the stream
	     */
	    function putLameVBR(gfp, musicLength, streamBuffer, streamBufferPos, crc) {
	        var gfc = gfp.internal_flags;
	        var bytesWritten = 0;
	
	        /* encoder delay */
	        var encDelay = gfp.encoder_delay;
	        /* encoder padding */
	        var encPadding = gfp.encoder_padding;
	
	        /* recall: gfp.VBR_q is for example set by the switch -V */
	        /* gfp.quality by -q, -h, -f, etc */
	        var quality = (100 - 10 * gfp.VBR_q - gfp.quality);
	
	        var version = v.getLameVeryShortVersion();
	        var vbr;
	        var revision = 0x00;
	        var revMethod;
	        // numbering different in vbr_mode vs. Lame tag
	        var vbrTypeTranslator = [1, 5, 3, 2, 4, 0, 3];
	        var lowpass = 0 | (((gfp.lowpassfreq / 100.0) + .5) > 255 ? 255
	                : (gfp.lowpassfreq / 100.0) + .5);
	        var peakSignalAmplitude = 0;
	        var radioReplayGain = 0;
	        var audiophileReplayGain = 0;
	        var noiseShaping = gfp.internal_flags.noise_shaping;
	        var stereoMode = 0;
	        var nonOptimal = 0;
	        var sourceFreq = 0;
	        var misc = 0;
	        var musicCRC = 0;
	
	        // psy model type: Gpsycho or NsPsytune
	        var expNPsyTune = (gfp.exp_nspsytune & 1) != 0;
	        var safeJoint = (gfp.exp_nspsytune & 2) != 0;
	        var noGapMore = false;
	        var noGapPrevious = false;
	        var noGapCount = gfp.internal_flags.nogap_total;
	        var noGapCurr = gfp.internal_flags.nogap_current;
	
	        // 4 bits
	        var athType = gfp.ATHtype;
	        var flags = 0;
	
	        // vbr modes
	        var abrBitrate;
	        switch (gfp.VBR) {
	            case vbr_abr:
	                abrBitrate = gfp.VBR_mean_bitrate_kbps;
	                break;
	            case vbr_off:
	                abrBitrate = gfp.brate;
	                break;
	            default:
	                abrBitrate = gfp.VBR_min_bitrate_kbps;
	        }
	
	        // revision and vbr method
	        if (gfp.VBR.ordinal() < vbrTypeTranslator.length)
	            vbr = vbrTypeTranslator[gfp.VBR.ordinal()];
	        else
	            vbr = 0x00; // unknown
	
	        revMethod = 0x10 * revision + vbr;
	
	        // ReplayGain
	        if (gfc.findReplayGain) {
	            if (gfc.RadioGain > 0x1FE)
	                gfc.RadioGain = 0x1FE;
	            if (gfc.RadioGain < -0x1FE)
	                gfc.RadioGain = -0x1FE;
	
	            // set name code
	            radioReplayGain = 0x2000;
	            // set originator code to `determined automatically'
	            radioReplayGain |= 0xC00;
	
	            if (gfc.RadioGain >= 0) {
	                // set gain adjustment
	                radioReplayGain |= gfc.RadioGain;
	            } else {
	                // set the sign bit
	                radioReplayGain |= 0x200;
	                // set gain adjustment
	                radioReplayGain |= -gfc.RadioGain;
	            }
	        }
	
	        // peak sample
	        if (gfc.findPeakSample)
	            peakSignalAmplitude = Math
	                .abs(0 | ((( gfc.PeakSample) / 32767.0) * Math.pow(2, 23) + .5));
	
	        // nogap
	        if (noGapCount != -1) {
	            if (noGapCurr > 0)
	                noGapPrevious = true;
	
	            if (noGapCurr < noGapCount - 1)
	                noGapMore = true;
	        }
	
	        // flags
	        flags = athType + ((expNPsyTune ? 1 : 0) << 4)
	            + ((safeJoint ? 1 : 0) << 5) + ((noGapMore ? 1 : 0) << 6)
	            + ((noGapPrevious ? 1 : 0) << 7);
	
	        if (quality < 0)
	            quality = 0;
	
	        // stereo mode field (Intensity stereo is not implemented)
	        switch (gfp.mode) {
	            case MONO:
	                stereoMode = 0;
	                break;
	            case STEREO:
	                stereoMode = 1;
	                break;
	            case DUAL_CHANNEL:
	                stereoMode = 2;
	                break;
	            case JOINT_STEREO:
	                if (gfp.force_ms)
	                    stereoMode = 4;
	                else
	                    stereoMode = 3;
	                break;
	            case NOT_SET:
	            //$FALL-THROUGH$
	            default:
	                stereoMode = 7;
	                break;
	        }
	
	        if (gfp.in_samplerate <= 32000)
	            sourceFreq = 0x00;
	        else if (gfp.in_samplerate == 48000)
	            sourceFreq = 0x02;
	        else if (gfp.in_samplerate > 48000)
	            sourceFreq = 0x03;
	        else {
	            // default is 44100Hz
	            sourceFreq = 0x01;
	        }
	
	        // Check if the user overrided the default LAME behavior with some
	        // nasty options
	        if (gfp.short_blocks == ShortBlock.short_block_forced
	            || gfp.short_blocks == ShortBlock.short_block_dispensed
	            || ((gfp.lowpassfreq == -1) && (gfp.highpassfreq == -1)) || /* "-k" */
	            (gfp.scale_left < gfp.scale_right)
	            || (gfp.scale_left > gfp.scale_right)
	            || (gfp.disable_reservoir && gfp.brate < 320) || gfp.noATH
	            || gfp.ATHonly || (athType == 0) || gfp.in_samplerate <= 32000)
	            nonOptimal = 1;
	
	        misc = noiseShaping + (stereoMode << 2) + (nonOptimal << 5)
	            + (sourceFreq << 6);
	
	        musicCRC = gfc.nMusicCRC;
	
	        // Write all this information into the stream
	
	        createInteger(streamBuffer, streamBufferPos + bytesWritten, quality);
	        bytesWritten += 4;
	
	        for (var j = 0; j < 9; j++) {
	            streamBuffer[streamBufferPos + bytesWritten + j] = 0xff & version .charAt(j);
	        }
	        bytesWritten += 9;
	
	        streamBuffer[streamBufferPos + bytesWritten] = 0xff & revMethod;
	        bytesWritten++;
	
	        streamBuffer[streamBufferPos + bytesWritten] = 0xff & lowpass;
	        bytesWritten++;
	
	        createInteger(streamBuffer, streamBufferPos + bytesWritten,
	            peakSignalAmplitude);
	        bytesWritten += 4;
	
	        createShort(streamBuffer, streamBufferPos + bytesWritten,
	            radioReplayGain);
	        bytesWritten += 2;
	
	        createShort(streamBuffer, streamBufferPos + bytesWritten,
	            audiophileReplayGain);
	        bytesWritten += 2;
	
	        streamBuffer[streamBufferPos + bytesWritten] = 0xff & flags;
	        bytesWritten++;
	
	        if (abrBitrate >= 255)
	            streamBuffer[streamBufferPos + bytesWritten] = 0xFF;
	        else
	            streamBuffer[streamBufferPos + bytesWritten] = 0xff & abrBitrate;
	        bytesWritten++;
	
	        streamBuffer[streamBufferPos + bytesWritten] = 0xff & (encDelay >> 4);
	        streamBuffer[streamBufferPos + bytesWritten + 1] = 0xff & ((encDelay << 4) + (encPadding >> 8));
	        streamBuffer[streamBufferPos + bytesWritten + 2] = 0xff & encPadding;
	
	        bytesWritten += 3;
	
	        streamBuffer[streamBufferPos + bytesWritten] = 0xff & misc;
	        bytesWritten++;
	
	        // unused in rev0
	        streamBuffer[streamBufferPos + bytesWritten++] = 0;
	
	        createShort(streamBuffer, streamBufferPos + bytesWritten, gfp.preset);
	        bytesWritten += 2;
	
	        createInteger(streamBuffer, streamBufferPos + bytesWritten, musicLength);
	        bytesWritten += 4;
	
	        createShort(streamBuffer, streamBufferPos + bytesWritten, musicCRC);
	        bytesWritten += 2;
	
	        // Calculate tag CRC.... must be done here, since it includes previous
	        // information
	
	        for (var i = 0; i < bytesWritten; i++)
	            crc = crcUpdateLookup(streamBuffer[streamBufferPos + i], crc);
	
	        createShort(streamBuffer, streamBufferPos + bytesWritten, crc);
	        bytesWritten += 2;
	
	        return bytesWritten;
	    }
	
	    function skipId3v2(fpStream) {
	        // seek to the beginning of the stream
	        fpStream.seek(0);
	        // read 10 bytes in case there's an ID3 version 2 header here
	        var id3v2Header = new_byte(10);
	        fpStream.readFully(id3v2Header);
	        /* does the stream begin with the ID3 version 2 file identifier? */
	        var id3v2TagSize;
	        if (!new String(id3v2Header, "ISO-8859-1").startsWith("ID3")) {
	            /*
	             * the tag size (minus the 10-byte header) is encoded into four
	             * bytes where the most significant bit is clear in each byte
	             */
	            id3v2TagSize = (((id3v2Header[6] & 0x7f) << 21)
	                | ((id3v2Header[7] & 0x7f) << 14)
	                | ((id3v2Header[8] & 0x7f) << 7) | (id3v2Header[9] & 0x7f))
	                + id3v2Header.length;
	        } else {
	            /* no ID3 version 2 tag in this stream */
	            id3v2TagSize = 0;
	        }
	        return id3v2TagSize;
	    }
	
	    this.getLameTagFrame = function (gfp, buffer) {
	        var gfc = gfp.internal_flags;
	
	        if (!gfp.bWriteVbrTag) {
	            return 0;
	        }
	        if (gfc.Class_ID != Lame.LAME_ID) {
	            return 0;
	        }
	        if (gfc.VBR_seek_table.pos <= 0) {
	            return 0;
	        }
	        if (buffer.length < gfc.VBR_seek_table.TotalFrameSize) {
	            return gfc.VBR_seek_table.TotalFrameSize;
	        }
	
	        Arrays.fill(buffer, 0, gfc.VBR_seek_table.TotalFrameSize, 0);
	
	        // 4 bytes frame header
	        setLameTagFrameHeader(gfp, buffer);
	
	        // Create TOC entries
	        var toc = new_byte(NUMTOCENTRIES);
	
	        if (gfp.free_format) {
	            for (var i = 1; i < NUMTOCENTRIES; ++i)
	                toc[i] = 0xff & (255 * i / 100);
	        } else {
	            xingSeekTable(gfc.VBR_seek_table, toc);
	        }
	
	        // Start writing the tag after the zero frame
	        var streamIndex = gfc.sideinfo_len;
	        /**
	         * Note: Xing header specifies that Xing data goes in the ancillary data
	         * with NO ERROR PROTECTION. If error protecton in enabled, the Xing
	         * data still starts at the same offset, and now it is in sideinfo data
	         * block, and thus will not decode correctly by non-Xing tag aware
	         * players
	         */
	        if (gfp.error_protection)
	            streamIndex -= 2;
	
	        // Put Vbr tag
	        if (gfp.VBR == VbrMode.vbr_off) {
	            buffer[streamIndex++] = 0xff & VBRTag1.charAt(0);
	            buffer[streamIndex++] = 0xff & VBRTag1.charAt(1);
	            buffer[streamIndex++] = 0xff & VBRTag1.charAt(2);
	            buffer[streamIndex++] = 0xff & VBRTag1.charAt(3);
	
	        } else {
	            buffer[streamIndex++] = 0xff & VBRTag0.charAt(0);
	            buffer[streamIndex++] = 0xff & VBRTag0.charAt(1);
	            buffer[streamIndex++] = 0xff & VBRTag0.charAt(2);
	            buffer[streamIndex++] = 0xff & VBRTag0.charAt(3);
	        }
	
	        // Put header flags
	        createInteger(buffer, streamIndex, FRAMES_FLAG + BYTES_FLAG + TOC_FLAG
	            + VBR_SCALE_FLAG);
	        streamIndex += 4;
	
	        // Put Total Number of frames
	        createInteger(buffer, streamIndex, gfc.VBR_seek_table.nVbrNumFrames);
	        streamIndex += 4;
	
	        // Put total audio stream size, including Xing/LAME Header
	        var streamSize = (gfc.VBR_seek_table.nBytesWritten + gfc.VBR_seek_table.TotalFrameSize);
	        createInteger(buffer, streamIndex, 0 | streamSize);
	        streamIndex += 4;
	
	        /* Put TOC */
	        System.arraycopy(toc, 0, buffer, streamIndex, toc.length);
	        streamIndex += toc.length;
	
	        if (gfp.error_protection) {
	            // (jo) error_protection: add crc16 information to header
	            bs.CRC_writeheader(gfc, buffer);
	        }
	
	        // work out CRC so far: initially crc = 0
	        var crc = 0x00;
	        for (var i = 0; i < streamIndex; i++)
	            crc = crcUpdateLookup(buffer[i], crc);
	        // Put LAME VBR info
	        streamIndex += putLameVBR(gfp, streamSize, buffer, streamIndex, crc);
	
	        return gfc.VBR_seek_table.TotalFrameSize;
	    }
	
	    /**
	     * Write final VBR tag to the file.
	     *
	     * @param gfp
	     *            global flags
	     * @param stream
	     *            stream to add the VBR tag to
	     * @return 0 (OK), -1 else
	     * @throws IOException
	     *             I/O error
	     */
	    this.putVbrTag = function (gfp, stream) {
	        var gfc = gfp.internal_flags;
	
	        if (gfc.VBR_seek_table.pos <= 0)
	            return -1;
	
	        // Seek to end of file
	        stream.seek(stream.length());
	
	        // Get file size, abort if file has zero length.
	        if (stream.length() == 0)
	            return -1;
	
	        // The VBR tag may NOT be located at the beginning of the stream. If an
	        // ID3 version 2 tag was added, then it must be skipped to write the VBR
	        // tag data.
	        var id3v2TagSize = skipId3v2(stream);
	
	        // Seek to the beginning of the stream
	        stream.seek(id3v2TagSize);
	
	        var buffer = new_byte(MAXFRAMESIZE);
	        var bytes = getLameTagFrame(gfp, buffer);
	        if (bytes > buffer.length) {
	            return -1;
	        }
	
	        if (bytes < 1) {
	            return 0;
	        }
	
	        // Put it all to disk again
	        stream.write(buffer, 0, bytes);
	        // success
	        return 0;
	    }
	
	}
	
	module.exports = VBRTag;


/***/ },
/* 412 */
/***/ function(module, exports) {

	function Version() {
	
	    /**
	     * URL for the LAME website.
	     */
	    var LAME_URL = "http://www.mp3dev.org/";
	
	    /**
	     * Major version number.
	     */
	    var LAME_MAJOR_VERSION = 3;
	    /**
	     * Minor version number.
	     */
	    var LAME_MINOR_VERSION = 98;
	    /**
	     * Patch level.
	     */
	    var LAME_PATCH_VERSION = 4;
	
	    /**
	     * Major version number.
	     */
	    var PSY_MAJOR_VERSION = 0;
	    /**
	     * Minor version number.
	     */
	    var PSY_MINOR_VERSION = 93;
	
	    /**
	     * A string which describes the version of LAME.
	     *
	     * @return string which describes the version of LAME
	     */
	    this.getLameVersion = function () {
	        // primary to write screen reports
	        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
	    }
	
	    /**
	     * The short version of the LAME version string.
	     *
	     * @return short version of the LAME version string
	     */
	    this.getLameShortVersion = function () {
	        // Adding date and time to version string makes it harder for output
	        // validation
	        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
	    }
	
	    /**
	     * The shortest version of the LAME version string.
	     *
	     * @return shortest version of the LAME version string
	     */
	    this.getLameVeryShortVersion = function () {
	        // Adding date and time to version string makes it harder for output
	        return ("LAME" + LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "r");
	    }
	
	    /**
	     * String which describes the version of GPSYCHO
	     *
	     * @return string which describes the version of GPSYCHO
	     */
	    this.getPsyVersion = function () {
	        return (PSY_MAJOR_VERSION + "." + PSY_MINOR_VERSION);
	    }
	
	    /**
	     * String which is a URL for the LAME website.
	     *
	     * @return string which is a URL for the LAME website
	     */
	    this.getLameUrl = function () {
	        return LAME_URL;
	    }
	
	    /**
	     * Quite useless for a java version, however we are compatible ;-)
	     *
	     * @return "32bits"
	     */
	    this.getLameOsBitness = function () {
	        return "32bits";
	    }
	
	}
	
	module.exports = Version;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var common = __webpack_require__(17);
	var System = common.System;
	var VbrMode = common.VbrMode;
	var Float = common.Float;
	var ShortBlock = common.ShortBlock;
	var Util = common.Util;
	var Arrays = common.Arrays;
	var new_array_n = common.new_array_n;
	var new_byte = common.new_byte;
	var new_double = common.new_double;
	var new_float = common.new_float;
	var new_float_n = common.new_float_n;
	var new_int = common.new_int;
	var new_int_n = common.new_int_n;
	var assert = common.assert;
	
	Lame = __webpack_require__(400);
	Presets = __webpack_require__(404);
	GainAnalysis = __webpack_require__(191);
	QuantizePVT = __webpack_require__(195);
	Quantize = __webpack_require__(406);
	Takehiro = __webpack_require__(197);
	Reservoir = __webpack_require__(408);
	MPEGMode = __webpack_require__(193);
	BitStream = __webpack_require__(190);
	var Encoder = __webpack_require__(21);
	var Version = __webpack_require__(412);
	var VBRTag = __webpack_require__(411);
	
	function GetAudio() {
	    var parse;
	    var mpg;
	
	    this.setModules = function (parse2, mpg2) {
	        parse = parse2;
	        mpg = mpg2;
	    }
	}
	
	
	function Parse() {
	    var ver;
	    var id3;
	    var pre;
	
	    this.setModules = function (ver2, id32, pre2) {
	        ver = ver2;
	        id3 = id32;
	        pre = pre2;
	    }
	}
	
	function MPGLib() {
	}
	
	function ID3Tag() {
	    var bits;
	    var ver;
	
	    this.setModules = function (_bits, _ver) {
	        bits = _bits;
	        ver = _ver;
	    }
	}
	
	function Mp3Encoder(channels, samplerate, kbps) {
	    if (arguments.length != 3) {
	        console.error('WARN: Mp3Encoder(channels, samplerate, kbps) not specified');
	        channels = 1;
	        samplerate = 44100;
	        kbps = 128;
	    }
	    var lame = new Lame();
	    var gaud = new GetAudio();
	    var ga = new GainAnalysis();
	    var bs = new BitStream();
	    var p = new Presets();
	    var qupvt = new QuantizePVT();
	    var qu = new Quantize();
	    var vbr = new VBRTag();
	    var ver = new Version();
	    var id3 = new ID3Tag();
	    var rv = new Reservoir();
	    var tak = new Takehiro();
	    var parse = new Parse();
	    var mpg = new MPGLib();
	
	    lame.setModules(ga, bs, p, qupvt, qu, vbr, ver, id3, mpg);
	    bs.setModules(ga, mpg, ver, vbr);
	    id3.setModules(bs, ver);
	    p.setModules(lame);
	    qu.setModules(bs, rv, qupvt, tak);
	    qupvt.setModules(tak, rv, lame.enc.psy);
	    rv.setModules(bs);
	    tak.setModules(qupvt);
	    vbr.setModules(lame, bs, ver);
	    gaud.setModules(parse, mpg);
	    parse.setModules(ver, id3, p);
	
	    var gfp = lame.lame_init();
	
	    gfp.num_channels = channels;
	    gfp.in_samplerate = samplerate;
	    gfp.brate = kbps;
	    gfp.mode = MPEGMode.STEREO;
	    gfp.quality = 3;
	    gfp.bWriteVbrTag = false;
	    gfp.disable_reservoir = true;
	    gfp.write_id3tag_automatic = false;
	
	    var retcode = lame.lame_init_params(gfp);
	    assert(0 == retcode);
	    var maxSamples = 1152;
	    var mp3buf_size = 0 | (1.25 * maxSamples + 7200);
	    var mp3buf = new_byte(mp3buf_size);
	
	    this.encodeBuffer = function (left, right) {
	        if (channels == 1) {
	            right = left;
	        }
	        assert(left.length == right.length);
	        if (left.length > maxSamples) {
	            maxSamples = left.length;
	            mp3buf_size = 0 | (1.25 * maxSamples + 7200);
	            mp3buf = new_byte(mp3buf_size);
	        }
	
	        var _sz = lame.lame_encode_buffer(gfp, left, right, left.length, mp3buf, 0, mp3buf_size);
	        return new Int8Array(mp3buf.subarray(0, _sz));
	    };
	
	    this.flush = function () {
	        var _sz = lame.lame_encode_flush(gfp, mp3buf, 0, mp3buf_size);
	        return new Int8Array(mp3buf.subarray(0, _sz));
	    };
	}
	
	function WavHeader() {
	    this.dataOffset = 0;
	    this.dataLen = 0;
	    this.channels = 0;
	    this.sampleRate = 0;
	}
	
	function fourccToInt(fourcc) {
	    return fourcc.charCodeAt(0) << 24 | fourcc.charCodeAt(1) << 16 | fourcc.charCodeAt(2) << 8 | fourcc.charCodeAt(3);
	}
	
	WavHeader.RIFF = fourccToInt("RIFF");
	WavHeader.WAVE = fourccToInt("WAVE");
	WavHeader.fmt_ = fourccToInt("fmt ");
	WavHeader.data = fourccToInt("data");
	
	WavHeader.readHeader = function (dataView) {
	    var w = new WavHeader();
	
	    var header = dataView.getUint32(0, false);
	    if (WavHeader.RIFF != header) {
	        return;
	    }
	    var fileLen = dataView.getUint32(4, true);
	    if (WavHeader.WAVE != dataView.getUint32(8, false)) {
	        return;
	    }
	    if (WavHeader.fmt_ != dataView.getUint32(12, false)) {
	        return;
	    }
	    var fmtLen = dataView.getUint32(16, true);
	    var pos = 16 + 4;
	    switch (fmtLen) {
	        case 16:
	        case 18:
	            w.channels = dataView.getUint16(pos + 2, true);
	            w.sampleRate = dataView.getUint32(pos + 4, true);
	            break;
	        default:
	            throw 'extended fmt chunk not implemented';
	    }
	    pos += fmtLen;
	    var data = WavHeader.data;
	    var len = 0;
	    while (data != header) {
	        header = dataView.getUint32(pos, false);
	        len = dataView.getUint32(pos + 4, true);
	        if (data == header) {
	            break;
	        }
	        pos += (len + 8);
	    }
	    w.dataLen = len;
	    w.dataOffset = pos + 8;
	    return w;
	};
	
	module.exports.Mp3Encoder = Mp3Encoder;
	module.exports.WavHeader = WavHeader;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory){
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return factory(root);
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module == 'object' && module && module.exports) {
	    module.exports = factory(root);
	  } else {
	    root.Levenshtein = factory(root);
	  }
	}(this, function(root){
	
	  function forEach( array, fn ) { var i, length
	    i = -1
	    length = array.length
	    while ( ++i < length )
	      fn( array[ i ], i, array )
	  }
	
	  function map( array, fn ) { var result
	    result = Array( array.length )
	    forEach( array, function ( val, i, array ) {
	      result[i] = fn( val, i, array )
	    })
	    return result
	  }
	
	  function reduce( array, fn, accumulator ) {
	    forEach( array, function( val, i, array ) {
	      accumulator = fn( val, i, array )
	    })
	    return accumulator
	  }
	
	  // Levenshtein distance
	  function Levenshtein( str_m, str_n ) { var previous, current, matrix
	    // Constructor
	    matrix = this._matrix = []
	
	    // Sanity checks
	    if ( str_m == str_n )
	      return this.distance = 0
	    else if ( str_m == '' )
	      return this.distance = str_n.length
	    else if ( str_n == '' )
	      return this.distance = str_m.length
	    else {
	      // Danger Will Robinson
	      previous = [ 0 ]
	      forEach( str_m, function( v, i ) { i++, previous[ i ] = i } )
	
	      matrix[0] = previous
	      forEach( str_n, function( n_val, n_idx ) {
	        current = [ ++n_idx ]
	        forEach( str_m, function( m_val, m_idx ) {
	          m_idx++
	          if ( str_m.charAt( m_idx - 1 ) == str_n.charAt( n_idx - 1 ) )
	            current[ m_idx ] = previous[ m_idx - 1 ]
	          else
	            current[ m_idx ] = Math.min
	              ( previous[ m_idx ]     + 1   // Deletion
	              , current[  m_idx - 1 ] + 1   // Insertion
	              , previous[ m_idx - 1 ] + 1   // Subtraction
	              )
	        })
	        previous = current
	        matrix[ matrix.length ] = previous
	      })
	
	      return this.distance = current[ current.length - 1 ]
	    }
	  }
	
	  Levenshtein.prototype.toString = Levenshtein.prototype.inspect = function inspect ( no_print ) { var matrix, max, buff, sep, rows
	    matrix = this.getMatrix()
	    max = reduce( matrix,function( m, o ) {
	      return Math.max( m, reduce( o, Math.max, 0 ) )
	    }, 0 )
	    buff = Array( ( max + '' ).length ).join( ' ' )
	
	    sep = []
	    while ( sep.length < (matrix[0] && matrix[0].length || 0) )
	      sep[ sep.length ] = Array( buff.length + 1 ).join( '-' )
	    sep = sep.join( '-+' ) + '-'
	
	    rows = map( matrix, function( row ) { var cells
	      cells = map( row, function( cell ) {
	        return ( buff + cell ).slice( - buff.length )
	      })
	      return cells.join( ' |' ) + ' '
	    })
	
	    return rows.join( "\n" + sep + "\n" )
	  }
	
	  Levenshtein.prototype.getMatrix = function () {
	    return this._matrix.slice()
	  }
	
	  Levenshtein.prototype.valueOf = function() {
	    return this.distance
	  }
	
	  return Levenshtein
	
	}));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(263)(module)))

/***/ },
/* 416 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(198),
	    getRawTag = __webpack_require__(420),
	    objectToString = __webpack_require__(421);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 418 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(422);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 421 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 422 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(418);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _react.PropTypes.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Avatar;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(425);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(199);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	 false ? Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _react.PropTypes.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _react.PropTypes.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Card;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardActions;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(426);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _react.PropTypes.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardHeader;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardMedia;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardText;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardTitle;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedSwitch = __webpack_require__(479);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(510);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(511);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Checkbox;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(90);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _react.PropTypes.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = CircularProgress;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(99);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(482);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(204);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(92);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title,
	          style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	} : void 0;
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	 false ? Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Dialog;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	 false ? Divider.propTypes = {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Divider;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(208);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(129);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(477);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(131);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(450);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(91);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anchorOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      event.persist();
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onChange) {
	          _this.props.onChange(event, index, child.props.value);
	        }
	
	        _this.close(_events2.default.isKeyboard(event));
	      });
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          className = _props.className,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'children', 'className', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      _react2.default.Children.forEach(children, function (child) {
	        if (child && value === child.props.value) {
	          // This will need to be improved (in case primaryText is a node)
	          displayValue = child.props.label || child.props.primaryText;
	        }
	      });
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              tabIndex: this.props.disabled ? -1 : undefined,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DropDownMenu.propTypes = {
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _react.PropTypes.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} payload The `value` prop of the clicked menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = DropDownMenu;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(437);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(130);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(79);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(440);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          hoverColor = _props.hoverColor,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButton;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButtonLabel;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(201);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(79);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = FloatingActionButton;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FontIcon;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(201);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(485);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _react.PropTypes.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	} : void 0;
	exports.default = IconButton;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(91);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(129);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(131);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        (function () {
	          var isKeyboard = _events2.default.isKeyboard(event);
	          _this.timerCloseId = setTimeout(function () {
	            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	          }, _this.props.touchTapCloseDelay);
	        })();
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onTouchTap = _props.onTouchTap,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _react.PropTypes.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _react.PropTypes.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = IconMenu;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(507);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(508);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(446);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      var button = this.refs.enhancedButton;
	
	      if (button) {
	        var buttonEl = _reactDom2.default.findDOMNode(button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onTouchTap = _props3.onTouchTap,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: 'span'
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: 'enhancedButton',
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ListItem;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(202);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	 false ? NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = NestedList;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Paper;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationDefault.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationDefault;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(49);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationVertical;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _childUtils = __webpack_require__(79);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	  var borderRadius = 2;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = RaisedButton;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(438);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          {
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false
	};
	SelectField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item.
	   * @param {any} payload The `value` prop of the selected menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = SelectField;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(271);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(132);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _deprecatedPropType = __webpack_require__(514);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme$sli = context.muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[axis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[axis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[axis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[axis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[axis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = parseFloat(newValue.toFixed(5));
	
	        if (newValue > max) {
	          newValue = max;
	        } else if (newValue < min) {
	          newValue = min;
	        }
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(_this2.props.axis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[_this2.props.axis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[_this2.props.axis]] - _this2.getTrackOffset();
	        }
	
	        if (!_this2.props.disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var positionMax = this.track[mainAxisClientProperty[this.props.axis]];
	      if (position < 0) {
	        position = 0;
	      } else if (position > positionMax) {
	        position = positionMax;
	      }
	
	      var _props2 = this.props,
	          step = _props2.step,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = void 0;
	      value = position / positionMax * (max - min);
	      value = Math.round(value / step) * step + min;
	      value = parseFloat(value.toFixed(5));
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          axis = _props3.axis,
	          description = _props3.description,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          error = _props3.error,
	          max = _props3.max,
	          min = _props3.min,
	          name = _props3.name,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          onDragStart = _props3.onDragStart,
	          onDragStop = _props3.onDragStop,
	          onFocus = _props3.onFocus,
	          required = _props3.required,
	          sliderStyle = _props3.sliderStyle,
	          step = _props3.step,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : void 0;
	exports.default = Slider;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(453);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Step;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(203);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = StepButton;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	 false ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(480);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = StepContent;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(457);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node),
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _react.PropTypes.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Stepper;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = undefined;
	
	var _Step2 = __webpack_require__(455);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(456);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(458);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(203);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(459);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	 false ? Subheader.propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Subheader;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(461);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	} : void 0;
	exports.default = SvgIcon;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? InkBar.propTypes = {
	  color: _react.PropTypes.string,
	  left: _react.PropTypes.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  width: _react.PropTypes.string.isRequired
	} : void 0;
	exports.default = InkBar;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(53);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tab.propTypes = {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  index: _react.PropTypes.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _react.PropTypes.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _react.PropTypes.string
	} : void 0;
	exports.default = Tab;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	 false ? TabTemplate.propTypes = {
	  children: _react.PropTypes.node,
	  selected: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = TabTemplate;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(466);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(464);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _react.PropTypes.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _react.PropTypes.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _react.PropTypes.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = Tabs;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(465);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(467);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(99);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.syncHeightWithShadow(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      if (this.props.rowsMax >= this.props.rows) {
	        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = EnhancedTextarea;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(469);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(471);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(472);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(473);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null;
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value) });
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = TextField;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	 false ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	 false ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	 false ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	 false ? AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	} : void 0;
	exports.default = AutoLockScrolling;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? BeforeAfterWrapper.propTypes = {
	  afterElementType: _react.PropTypes.string,
	  afterStyle: _react.PropTypes.object,
	  beforeElementType: _react.PropTypes.string,
	  beforeStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  elementType: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = BeforeAfterWrapper;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(55);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(90);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	} : void 0;
	exports.default = CircleRipple;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BeforeAfterWrapper = __webpack_require__(475);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	 false ? ClearFix.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = ClearFix;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(91);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	 false ? ClickAwayListener.propTypes = {
	  children: _react.PropTypes.element,
	  onClickAway: _react.PropTypes.func
	} : void 0;
	exports.default = ClickAwayListener;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(99);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(61);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(132);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(205);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(48);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasToggledProp = nextProps.hasOwnProperty('toggled');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasToggledProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.toggled || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedSwitch.propTypes = {
	  checked: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  defaultChecked: _react.PropTypes.bool,
	  disableFocusRipple: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  iconStyle: _react.PropTypes.object,
	  inputStyle: _react.PropTypes.object,
	  inputType: _react.PropTypes.string.isRequired,
	  label: _react.PropTypes.node,
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  labelStyle: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onParentShouldUpdate: _react.PropTypes.func,
	  onSwitch: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  rippleColor: _react.PropTypes.string,
	  rippleStyle: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  switchElement: _react.PropTypes.element.isRequired,
	  switched: _react.PropTypes.bool.isRequired,
	  thumbStyle: _react.PropTypes.object,
	  trackStyle: _react.PropTypes.object,
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = EnhancedSwitch;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(92);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(481);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransition;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransitionChild;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(474);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	} : void 0;
	exports.default = Overlay;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(92);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(484);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleIn;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(90);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleInChild;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(3);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(13);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: 2,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	} : void 0;
	exports.default = Tooltip;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(133);
	
	var _colorManipulator = __webpack_require__(63);
	
	var _spacing = __webpack_require__(487);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 487 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 489 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountCircle = function ActionAccountCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
	  );
	};
	ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
	ActionAccountCircle.displayName = 'ActionAccountCircle';
	ActionAccountCircle.muiName = 'SvgIcon';
	
	exports.default = ActionAccountCircle;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignment = function ActionAssignment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
	  );
	};
	ActionAssignment = (0, _pure2.default)(ActionAssignment);
	ActionAssignment.displayName = 'ActionAssignment';
	ActionAssignment.muiName = 'SvgIcon';
	
	exports.default = ActionAssignment;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDelete = function ActionDelete(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDelete = (0, _pure2.default)(ActionDelete);
	ActionDelete.displayName = 'ActionDelete';
	ActionDelete.muiName = 'SvgIcon';
	
	exports.default = ActionDelete;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelp = function ActionHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	ActionHelp = (0, _pure2.default)(ActionHelp);
	ActionHelp.displayName = 'ActionHelp';
	ActionHelp.muiName = 'SvgIcon';
	
	exports.default = ActionHelp;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionList = function ActionList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
	  );
	};
	ActionList = (0, _pure2.default)(ActionList);
	ActionList.displayName = 'ActionList';
	ActionList.muiName = 'SvgIcon';
	
	exports.default = ActionList;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInNew = function ActionOpenInNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
	ActionOpenInNew.displayName = 'ActionOpenInNew';
	ActionOpenInNew.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInNew;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettings = function ActionSettings(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
	  );
	};
	ActionSettings = (0, _pure2.default)(ActionSettings);
	ActionSettings.displayName = 'ActionSettings';
	ActionSettings.muiName = 'SvgIcon';
	
	exports.default = ActionSettings;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertErrorOutline = function AlertErrorOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
	AlertErrorOutline.displayName = 'AlertErrorOutline';
	AlertErrorOutline.muiName = 'SvgIcon';
	
	exports.default = AlertErrorOutline;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMic = function AvMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMic = (0, _pure2.default)(AvMic);
	AvMic.displayName = 'AvMic';
	AvMic.muiName = 'SvgIcon';
	
	exports.default = AvMic;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayArrow = function AvPlayArrow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
	  );
	};
	AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
	AvPlayArrow.displayName = 'AvPlayArrow';
	AvPlayArrow.muiName = 'SvgIcon';
	
	exports.default = AvPlayArrow;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeUp = function AvVolumeUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
	  );
	};
	AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
	AvVolumeUp.displayName = 'AvVolumeUp';
	AvVolumeUp.muiName = 'SvgIcon';
	
	exports.default = AvVolumeUp;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPoll = function SocialPoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	SocialPoll = (0, _pure2.default)(SocialPoll);
	SocialPoll.displayName = 'SocialPoll';
	SocialPoll.muiName = 'SvgIcon';
	
	exports.default = SocialPoll;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(15);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(14);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(72);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = _inlineStylePrefixer2.default.prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(363);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	       false ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 515 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Returns a number of pixels from the top of the screen for given dom element.
	*
	* @param {object} dom element
	* @returns {number} A position from the top of the screen in pixels
	*/
	var getOffsetTop = exports.getOffsetTop = function getOffsetTop(elem) {
	  var yPos = elem.offsetTop;
	  var tempEl = elem.offsetParent;
	
	  while (tempEl != null) {
	    yPos += tempEl.offsetTop;
	    tempEl = tempEl.offsetParent;
	  }
	
	  return yPos;
	};
	
	var isIOS = exports.isIOS = function isIOS() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
	  );
	};

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(165);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(518)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(211);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(211);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(26);
	var invariant = __webpack_require__(10);
	var ReactPropTypesSecret = __webpack_require__(522);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 522 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(717);
	var objectAssign = __webpack_require__(16);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(26);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createBroadcast = function createBroadcast(initialValue) {
	  var listeners = [];
	  var currentValue = initialValue;
	
	  return {
	    publish: function publish(value) {
	      currentValue = value;
	      listeners.forEach(function (listener) {
	        return listener(currentValue);
	      });
	    },
	    subscribe: function subscribe(listener) {
	      listeners.push(listener);
	
	      // Publish to this subscriber once immediately.
	      listener(currentValue);
	
	      return function () {
	        return listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	      };
	    }
	  };
	};
	
	/**
	 * A <Broadcast> provides a generic way for descendants to "subscribe"
	 * to some value that changes over time, bypassing any intermediate
	 * shouldComponentUpdate's in the hierarchy. It puts all subscription
	 * functions on context.broadcasts, keyed by "channel".
	 *
	 * To use it, a subscriber must opt-in to context.broadcasts. See the
	 * <Subscriber> component for a reference implementation.
	 */
	
	var Broadcast = function (_React$Component) {
	  _inherits(Broadcast, _React$Component);
	
	  function Broadcast() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Broadcast);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Broadcast.prototype.getBroadcastsContext = function getBroadcastsContext() {
	    var _extends2;
	
	    var channel = this.props.channel;
	    var broadcasts = this.context.broadcasts;
	
	
	    return _extends({}, broadcasts, (_extends2 = {}, _extends2[channel] = this.broadcast.subscribe, _extends2));
	  };
	
	  Broadcast.prototype.getChildContext = function getChildContext() {
	    return {
	      broadcasts: this.getBroadcastsContext()
	    };
	  };
	
	  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    !(this.props.channel === nextProps.channel) ?  false ? (0, _invariant2.default)(false, 'You cannot change <Broadcast channel>') : (0, _invariant2.default)(false) : void 0;
	
	    if (this.props.value !== nextProps.value) this.broadcast.publish(nextProps.value);
	  };
	
	  Broadcast.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Broadcast;
	}(_react2.default.Component);
	
	Broadcast.contextTypes = {
	  broadcasts: _react.PropTypes.object
	};
	Broadcast.childContextTypes = {
	  broadcasts: _react.PropTypes.object.isRequired
	};
	
	
	if (false) {
	  Broadcast.propTypes = {
	    channel: _react.PropTypes.string.isRequired,
	    children: _react.PropTypes.node.isRequired,
	    value: _react.PropTypes.any
	  };
	}
	
	exports.default = Broadcast;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A <Subscriber> pulls the value for a channel off of context.broadcasts
	 * and passes it to its children function.
	 */
	var Subscriber = function (_React$Component) {
	  _inherits(Subscriber, _React$Component);
	
	  function Subscriber() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Subscriber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Subscriber.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var channel = this.props.channel;
	
	
	    if (this.context.broadcasts) {
	      var subscribe = this.context.broadcasts[channel];
	
	      !(typeof subscribe === 'function') ?  false ? (0, _invariant2.default)(false, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', channel, channel) : (0, _invariant2.default)(false) : void 0;
	
	      this.unsubscribe = subscribe(function (value) {
	        // This function will be called once immediately.
	        _this2.setState({ value: value });
	      });
	    }
	  };
	
	  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribe) this.unsubscribe();
	  };
	
	  Subscriber.prototype.render = function render() {
	    return this.props.children(this.state.value);
	  };
	
	  return Subscriber;
	}(_react2.default.Component);
	
	Subscriber.contextTypes = {
	  broadcasts: _react2.default.PropTypes.object
	};
	
	
	if (false) {
	  Subscriber.propTypes = {
	    channel: _react.PropTypes.string.isRequired,
	    children: _react.PropTypes.func.isRequired
	  };
	}
	
	exports.default = Subscriber;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Subscriber = exports.Broadcast = undefined;
	
	var _Broadcast2 = __webpack_require__(525);
	
	var _Broadcast3 = _interopRequireDefault(_Broadcast2);
	
	var _Subscriber2 = __webpack_require__(526);
	
	var _Subscriber3 = _interopRequireDefault(_Subscriber2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Broadcast = _Broadcast3.default;
	exports.Subscriber = _Subscriber3.default;

/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var focusNode = __webpack_require__(184);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(67);
	var ExecutionEnvironment = __webpack_require__(24);
	var FallbackCompositionState = __webpack_require__(537);
	var SyntheticCompositionEvent = __webpack_require__(573);
	var SyntheticInputEvent = __webpack_require__(576);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(213);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactInstrumentation = __webpack_require__(34);
	
	var camelizeStyleName = __webpack_require__(346);
	var dangerousStyleValue = __webpack_require__(582);
	var hyphenateStyleName = __webpack_require__(353);
	var memoizeStringOnly = __webpack_require__(357);
	var warning = __webpack_require__(11);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(66);
	var EventPropagators = __webpack_require__(67);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(38);
	var SyntheticEvent = __webpack_require__(41);
	
	var getEventTarget = __webpack_require__(149);
	var isEventSupported = __webpack_require__(150);
	var isTextInputElement = __webpack_require__(231);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMLazyTree = __webpack_require__(64);
	var ExecutionEnvironment = __webpack_require__(24);
	
	var createNodesFromMarkup = __webpack_require__(349);
	var emptyFunction = __webpack_require__(26);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 534 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticMouseEvent = __webpack_require__(95);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 536 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(54);
	
	var getTextContentAccessor = __webpack_require__(228);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(65);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(68);
	
	var instantiateReactComponent = __webpack_require__(230);
	var KeyEscapeUtils = __webpack_require__(140);
	var shouldUpdateReactComponent = __webpack_require__(151);
	var traverseAllChildren = __webpack_require__(233);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ROLLBAR_ACCESS_TOKEN":"8bd15db033ec48a3a60bc809335305ab","REACT_APP_API_URL":"https://pronounce-live-admin.herokuapp.com/api/v1"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(158);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(137);
	var ReactDOMIDOperations = __webpack_require__(546);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var React = __webpack_require__(42);
	var ReactComponentEnvironment = __webpack_require__(142);
	var ReactCurrentOwner = __webpack_require__(43);
	var ReactErrorUtils = __webpack_require__(143);
	var ReactInstanceMap = __webpack_require__(80);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactNodeTypes = __webpack_require__(224);
	var ReactReconciler = __webpack_require__(68);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(78);
	var shouldUpdateReactComponent = __webpack_require__(151);
	var warning = __webpack_require__(11);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var AutoFocusUtils = __webpack_require__(529);
	var CSSPropertyOperations = __webpack_require__(531);
	var DOMLazyTree = __webpack_require__(64);
	var DOMNamespaces = __webpack_require__(138);
	var DOMProperty = __webpack_require__(65);
	var DOMPropertyOperations = __webpack_require__(215);
	var EventPluginHub = __webpack_require__(66);
	var EventPluginRegistry = __webpack_require__(139);
	var ReactBrowserEventEmitter = __webpack_require__(94);
	var ReactDOMComponentFlags = __webpack_require__(217);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMInput = __webpack_require__(547);
	var ReactDOMOption = __webpack_require__(548);
	var ReactDOMSelect = __webpack_require__(218);
	var ReactDOMTextarea = __webpack_require__(551);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactMultiChild = __webpack_require__(560);
	var ReactServerRenderingTransaction = __webpack_require__(565);
	
	var emptyFunction = __webpack_require__(26);
	var escapeTextContentForBrowser = __webpack_require__(97);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(150);
	var shallowEqual = __webpack_require__(78);
	var validateDOMNesting = __webpack_require__(152);
	var warning = __webpack_require__(11);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(152);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 545 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var DOMPropertyOperations = __webpack_require__(215);
	var LinkedValueUtils = __webpack_require__(141);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(38);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var React = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMSelect = __webpack_require__(218);
	
	var warning = __webpack_require__(11);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var getNodeForCharacterOffset = __webpack_require__(588);
	var getTextContentAccessor = __webpack_require__(228);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var DOMChildrenOperations = __webpack_require__(137);
	var DOMLazyTree = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var escapeTextContentForBrowser = __webpack_require__(97);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(152);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(141);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(38);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactUpdates = __webpack_require__(38);
	var Transaction = __webpack_require__(96);
	
	var emptyFunction = __webpack_require__(26);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(528);
	var BeforeInputEventPlugin = __webpack_require__(530);
	var ChangeEventPlugin = __webpack_require__(532);
	var DefaultEventPluginOrder = __webpack_require__(534);
	var EnterLeaveEventPlugin = __webpack_require__(535);
	var HTMLDOMPropertyConfig = __webpack_require__(538);
	var ReactComponentBrowserEnvironment = __webpack_require__(540);
	var ReactDOMComponent = __webpack_require__(542);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMEmptyComponent = __webpack_require__(544);
	var ReactDOMTreeTraversal = __webpack_require__(552);
	var ReactDOMTextComponent = __webpack_require__(550);
	var ReactDefaultBatchingStrategy = __webpack_require__(553);
	var ReactEventListener = __webpack_require__(557);
	var ReactInjection = __webpack_require__(558);
	var ReactReconcileTransaction = __webpack_require__(563);
	var SVGDOMPropertyConfig = __webpack_require__(568);
	var SelectEventPlugin = __webpack_require__(569);
	var SimpleEventPlugin = __webpack_require__(570);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 555 */
253,
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(66);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventListener = __webpack_require__(183);
	var ExecutionEnvironment = __webpack_require__(24);
	var PooledClass = __webpack_require__(54);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(38);
	
	var getEventTarget = __webpack_require__(149);
	var getUnboundedScrollPosition = __webpack_require__(351);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(65);
	var EventPluginHub = __webpack_require__(66);
	var EventPluginUtils = __webpack_require__(93);
	var ReactComponentEnvironment = __webpack_require__(142);
	var ReactEmptyComponent = __webpack_require__(219);
	var ReactBrowserEventEmitter = __webpack_require__(94);
	var ReactHostComponent = __webpack_require__(221);
	var ReactUpdates = __webpack_require__(38);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(581);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactComponentEnvironment = __webpack_require__(142);
	var ReactInstanceMap = __webpack_require__(80);
	var ReactInstrumentation = __webpack_require__(34);
	
	var ReactCurrentOwner = __webpack_require__(43);
	var ReactReconciler = __webpack_require__(68);
	var ReactChildReconciler = __webpack_require__(539);
	
	var emptyFunction = __webpack_require__(26);
	var flattenChildren = __webpack_require__(584);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 562 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(214);
	var PooledClass = __webpack_require__(54);
	var ReactBrowserEventEmitter = __webpack_require__(94);
	var ReactInputSelection = __webpack_require__(222);
	var ReactInstrumentation = __webpack_require__(34);
	var Transaction = __webpack_require__(96);
	var ReactUpdateQueue = __webpack_require__(144);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(561);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(54);
	var Transaction = __webpack_require__(96);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactServerUpdateQueue = __webpack_require__(566);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(144);
	
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 567 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 568 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(67);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInputSelection = __webpack_require__(222);
	var SyntheticEvent = __webpack_require__(41);
	
	var getActiveElement = __webpack_require__(185);
	var isTextInputElement = __webpack_require__(231);
	var shallowEqual = __webpack_require__(78);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var EventListener = __webpack_require__(183);
	var EventPropagators = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticAnimationEvent = __webpack_require__(571);
	var SyntheticClipboardEvent = __webpack_require__(572);
	var SyntheticEvent = __webpack_require__(41);
	var SyntheticFocusEvent = __webpack_require__(575);
	var SyntheticKeyboardEvent = __webpack_require__(577);
	var SyntheticMouseEvent = __webpack_require__(95);
	var SyntheticDragEvent = __webpack_require__(574);
	var SyntheticTouchEvent = __webpack_require__(578);
	var SyntheticTransitionEvent = __webpack_require__(579);
	var SyntheticUIEvent = __webpack_require__(69);
	var SyntheticWheelEvent = __webpack_require__(580);
	
	var emptyFunction = __webpack_require__(26);
	var getEventCharCode = __webpack_require__(147);
	var invariant = __webpack_require__(10);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(95);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(69);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(69);
	
	var getEventCharCode = __webpack_require__(147);
	var getEventKey = __webpack_require__(585);
	var getEventModifierState = __webpack_require__(148);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(69);
	
	var getEventModifierState = __webpack_require__(148);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(41);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(95);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 581 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(213);
	var warning = __webpack_require__(11);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstanceMap = __webpack_require__(80);
	
	var getHostComponentFromComposite = __webpack_require__(227);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(140);
	var traverseAllChildren = __webpack_require__(233);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ROLLBAR_ACCESS_TOKEN":"8bd15db033ec48a3a60bc809335305ab","REACT_APP_API_URL":"https://pronounce-live-admin.herokuapp.com/api/v1"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(158);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(147);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 586 */
256,
/* 587 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 588 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(97);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(223);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(104);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(591);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(237);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _storeShape = __webpack_require__(238);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(153);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2.default.isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2.default.isRequired,
	  storeSubscription: _react.PropTypes.instanceOf(_Subscription2.default)
	};
	Provider.displayName = 'Provider';

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(234);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(600);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(595);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(596);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(597);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(598);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(160);
	
	var _wrapMapToProps = __webpack_require__(235);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(235);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(239);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(599);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(153);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 600 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function shallowEqual(a, b) {
	  if (a === b) return true;
	
	  var countA = 0;
	  var countB = 0;
	
	  for (var key in a) {
	    if (hasOwn.call(a, key) && a[key] !== b[key]) return false;
	    countA++;
	  }
	
	  for (var _key in b) {
	    if (hasOwn.call(b, _key)) countB++;
	  }
	
	  return countA === countB;
	}

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createBrowserHistory = __webpack_require__(360);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _StaticRouter = __webpack_require__(606);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	var _History = __webpack_require__(602);
	
	var _History2 = _interopRequireDefault(_History);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BrowserRouter = function BrowserRouter(_ref) {
	  var basename = _ref.basename,
	      forceRefresh = _ref.forceRefresh,
	      getUserConfirmation = _ref.getUserConfirmation,
	      keyLength = _ref.keyLength,
	      routerProps = _objectWithoutProperties(_ref, ['basename', 'forceRefresh', 'getUserConfirmation', 'keyLength']);
	
	  return _react2.default.createElement(
	    _History2.default,
	    {
	      createHistory: _createBrowserHistory2.default,
	      historyOptions: {
	        basename: basename,
	        forceRefresh: forceRefresh,
	        getUserConfirmation: getUserConfirmation,
	        keyLength: keyLength
	      }
	    },
	    function (_ref2) {
	      var history = _ref2.history,
	          action = _ref2.action,
	          location = _ref2.location;
	      return _react2.default.createElement(_StaticRouter2.default, _extends({
	        action: action,
	        location: location,
	        basename: basename,
	        onPush: history.push,
	        onReplace: history.replace,
	        blockTransitions: history.block
	      }, routerProps));
	    }
	  );
	};
	
	if (false) {
	  BrowserRouter.propTypes = {
	    basename: _react.PropTypes.string,
	    forceRefresh: _react.PropTypes.bool,
	    getUserConfirmation: _react.PropTypes.func,
	    keyLength: _react.PropTypes.number,
	    children: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.node])
	  };
	}
	
	exports.default = BrowserRouter;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The common public API for all *History components.
	 */
	var History = function (_React$Component) {
	  _inherits(History, _React$Component);
	
	  function History() {
	    _classCallCheck(this, History);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  History.prototype.getChildContext = function getChildContext() {
	    return {
	      history: this.history
	    };
	  };
	
	  History.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        createHistory = _props.createHistory,
	        historyOptions = _props.historyOptions;
	
	    this.history = createHistory(historyOptions);
	    this.unlisten = this.history.listen(function () {
	      return _this2.forceUpdate();
	    });
	  };
	
	  History.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  History.prototype.render = function render() {
	    var history = this.history;
	    var location = history.location,
	        action = history.action;
	
	
	    return this.props.children({
	      history: history,
	      location: location,
	      action: action
	    });
	  };
	
	  return History;
	}(_react2.default.Component);
	
	History.childContextTypes = {
	  history: _PropTypes.historyContext.isRequired
	};
	
	
	if (false) {
	  History.propTypes = {
	    children: _react.PropTypes.func.isRequired,
	    createHistory: _react.PropTypes.func.isRequired,
	    historyOptions: _react.PropTypes.object
	  };
	}
	
	exports.default = History;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createRouterPath = exports.createRouterLocation = exports.locationsAreEqual = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _LocationUtils = __webpack_require__(186);
	
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(121);
	
	var createRouterLocation = exports.createRouterLocation = function createRouterLocation(input, parseQueryString, stringifyQuery) {
	  if (typeof input === 'string') {
	    var location = (0, _PathUtils.parsePath)(input);
	    location.query = location.search !== '' ? parseQueryString(location.search) : null;
	    return location;
	  } else {
	    // got a location descriptor
	    return {
	      pathname: input.pathname || '',
	      search: input.search || (input.query ? '?' + stringifyQuery(input.query) : ''),
	      hash: input.hash || '',
	      state: input.state || null,
	      query: input.query || (input.search ? parseQueryString(input.search) : null),
	      key: input.key
	    };
	  }
	};
	
	var createRouterPath = exports.createRouterPath = function createRouterPath(input, stringifyQuery) {
	  return typeof input === 'string' ? input : (0, _PathUtils.createPath)(_extends({}, input, {
	    search: input.search || (input.query ? '?' + stringifyQuery(input.query) : '')
	  }));
	};

/***/ },
/* 604 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Simple cache - NEW cached items are added to cachedKeys array. When cache is
	// full, oldest key is removed from array and item is removed from cache
	
	var DEFAULT_OPTIONS = {
	  limit: 200
	};
	
	var MatcherCache = function () {
	  function MatcherCache() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, MatcherCache);
	
	    this.cache = {};
	    this.cachedKeys = [];
	
	    var mergedOptions = _extends({}, DEFAULT_OPTIONS, options);
	    this.options = mergedOptions;
	  }
	
	  MatcherCache.prototype.set = function set(key, value) {
	    // If this key is not cached add key to cachedKeys array
	    if (this.cache[key] === undefined) {
	      this.cachedKeys.push(key);
	    }
	    this.cache[key] = value;
	    this.checkCacheLimit();
	  };
	
	  MatcherCache.prototype.get = function get(key) {
	    return this.cache[key];
	  };
	
	  MatcherCache.prototype.checkCacheLimit = function checkCacheLimit() {
	    // Clear a cache item if we are over limit
	    if (this.cachedKeys.length > this.options.limit) {
	      var keyToUncache = this.cachedKeys.shift();
	      delete this.cache[keyToUncache];
	    }
	  };
	
	  return MatcherCache;
	}();
	
	exports.default = MatcherCache;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Broadcasts = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Miss = function (_React$Component) {
	  _inherits(Miss, _React$Component);
	
	  function Miss(props, context) {
	    _classCallCheck(this, Miss);
	
	    // ignore if rendered out of context (probably for unit tests)
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    if (context.match && !context.serverRouter) {
	      _this.unsubscribe = _this.context.match.subscribe(function (matchesFound) {
	        _this.setState({
	          noMatchesInContext: !matchesFound
	        });
	      });
	    }
	
	    if (context.serverRouter) {
	      context.serverRouter.registerMissPresence(context.match.serverRouterIndex);
	    }
	
	    _this.state = {
	      noMatchesInContext: false
	    };
	    return _this;
	  }
	
	  Miss.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	    }
	  };
	
	  Miss.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _Broadcasts.LocationSubscriber,
	      null,
	      function (location) {
	        var _props = _this2.props,
	            render = _props.render,
	            Component = _props.component;
	        var noMatchesInContext = _this2.state.noMatchesInContext;
	        var _context = _this2.context,
	            serverRouter = _context.serverRouter,
	            match = _context.match;
	
	        var noMatchesOnServerContext = serverRouter && serverRouter.missedAtIndex(match.serverRouterIndex);
	        if (noMatchesInContext || noMatchesOnServerContext) {
	          return render ? render({ location: location }) : _react2.default.createElement(Component, { location: location });
	        } else {
	          return null;
	        }
	      }
	    );
	  };
	
	  return Miss;
	}(_react2.default.Component);
	
	Miss.contextTypes = {
	  match: _react.PropTypes.object,
	  serverRouter: _react.PropTypes.object
	};
	
	
	if (false) {
	  Miss.propTypes = {
	    children: _react.PropTypes.node,
	    render: _react.PropTypes.func,
	    component: _react.PropTypes.func
	  };
	}
	
	exports.default = Miss;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(523);
	
	var _MatchProvider = __webpack_require__(241);
	
	var _MatchProvider2 = _interopRequireDefault(_MatchProvider);
	
	var _Broadcasts = __webpack_require__(100);
	
	var _LocationUtils = __webpack_require__(603);
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyQuery = function stringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.transitionTo = function (location) {
	      _this.props.onPush(_this.createLocation(location));
	    }, _this.replaceWith = function (location) {
	      _this.props.onReplace(_this.createLocation(location));
	    }, _this.blockTransitions = function (prompt) {
	      return _this.props.blockTransitions(prompt);
	    }, _this.createHref = function (to) {
	      var path = (0, _LocationUtils.createRouterPath)(to, _this.props.stringifyQuery);
	
	      if (_this.props.basename) if (path === '/') path = _this.props.basename;else if (path.length >= 2 && path.charAt(0) === '/' && path.charAt(1) === '?') path = _this.props.basename + path.substring(1);else path = _this.props.basename + path;
	
	      return _this.props.createHref(path);
	    }, _this.state = {
	      location: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.createLocation = function createLocation(location) {
	    var _props = this.props,
	        parseQueryString = _props.parseQueryString,
	        stringifyQuery = _props.stringifyQuery;
	
	    return (0, _LocationUtils.createRouterLocation)(location, parseQueryString, stringifyQuery);
	  };
	
	  StaticRouter.prototype.getRouterContext = function getRouterContext() {
	    return {
	      transitionTo: this.transitionTo,
	      replaceWith: this.replaceWith,
	      blockTransitions: this.blockTransitions,
	      createHref: this.createHref
	    };
	  };
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: this.getRouterContext()
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    this.setState({
	      location: this.createLocation(this.props.location)
	    });
	  };
	
	  StaticRouter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextLocation = this.createLocation(nextProps.location);
	
	    if (!(0, _LocationUtils.locationsAreEqual)(this.state.location, nextLocation)) this.setState({ location: nextLocation });
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var location = this.state.location;
	    var _props2 = this.props,
	        action = _props2.action,
	        children = _props2.children;
	
	
	    return _react2.default.createElement(
	      _Broadcasts.LocationBroadcast,
	      { value: location },
	      _react2.default.createElement(
	        _MatchProvider2.default,
	        null,
	        typeof children === 'function' ? children({ action: action, location: location, router: this.getRouterContext() }) : _react2.default.Children.only(children)
	      )
	    );
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.defaultProps = {
	  stringifyQuery: stringifyQuery,
	  parseQueryString: _queryString.parse,
	  createHref: function createHref(path) {
	    return path;
	  }
	};
	StaticRouter.childContextTypes = {
	  router: _PropTypes.routerContext.isRequired
	};
	
	
	if (false) {
	  StaticRouter.propTypes = {
	    children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
	
	    action: _PropTypes.action.isRequired,
	    location: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]).isRequired,
	
	    onPush: _react.PropTypes.func.isRequired,
	    onReplace: _react.PropTypes.func.isRequired,
	    blockTransitions: _react.PropTypes.func,
	
	    stringifyQuery: _react.PropTypes.func.isRequired,
	    parseQueryString: _react.PropTypes.func.isRequired,
	    createHref: _react.PropTypes.func.isRequired, // TODO: Clarify why this is useful
	
	    basename: _react.PropTypes.string // TODO: Feels like we should be able to remove this
	  };
	}
	
	exports.default = StaticRouter;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(517);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	var _MatcherCache = __webpack_require__(604);
	
	var _MatcherCache2 = _interopRequireDefault(_MatcherCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// cache[exactly][pattern] contains getMatcher(pattern, exactly)
	var cache = {
	  true: new _MatcherCache2.default(),
	  false: new _MatcherCache2.default()
	};
	
	var getMatcher = function getMatcher(pattern, exactly) {
	  var exactlyStr = exactly ? 'true' : 'false';
	  var matcher = cache[exactlyStr].get(pattern);
	
	  if (!matcher) {
	    var keys = [];
	    var regex = (0, _pathToRegexp2.default)(pattern, keys, { end: exactly, strict: true });
	    matcher = { keys: keys, regex: regex };
	    cache[exactlyStr].set(pattern, matcher);
	  }
	
	  return matcher;
	};
	
	var parseParams = function parseParams(pattern, match, keys) {
	  return match.slice(1).filter(function (value) {
	    return value !== undefined;
	  }).reduce(function (params, value, index) {
	    params[keys[index].name] = decodeURIComponent(value);
	    return params;
	  }, {});
	};
	
	var matchPattern = function matchPattern(pattern, location, matchExactly, parent) {
	  var specialCase = !matchExactly && pattern === '/';
	
	  if (specialCase) {
	    return {
	      params: null,
	      isExact: location.pathname === '/',
	      pathname: '/'
	    };
	  } else {
	    if (parent && pattern.charAt(0) !== '/') {
	      pattern = parent.pathname + (parent.pathname.charAt(parent.pathname.length - 1) !== '/' ? '/' : '') + pattern;
	    }
	
	    var matcher = getMatcher(pattern, matchExactly);
	    var match = matcher.regex.exec(location.pathname);
	
	    if (match) {
	      var params = parseParams(pattern, match, matcher.keys);
	      var pathname = match[0];
	      var isExact = pathname === location.pathname;
	
	      return { params: params, isExact: isExact, pathname: pathname };
	    } else {
	      return null;
	    }
	  }
	};
	
	exports.default = matchPattern;

/***/ },
/* 608 */
/***/ function(module, exports) {

	
	// A dictionary mapping script URLs to a dictionary mapping
	// component key to component for all components that are waiting
	// for the script to load.
	var scriptObservers = {};
	
	// A dictionary mapping script URL to a boolean value indicating if the script
	// has already been loaded.
	var loadedScripts = {};
	
	// A dictionary mapping script URL to a boolean value indicating if the script
	// has failed to load.
	var erroredScripts = {};
	
	// A counter used to generate a unique id for each component that uses
	// ScriptLoaderMixin.
	var idCount = 0;
	
	var ReactScriptLoader = {
		componentDidMount: function(key, component, scriptURL) {
			if (typeof component.onScriptLoaded !== 'function') {
				throw new Error('ScriptLoader: Component class must implement onScriptLoaded()');
			}
			if (typeof component.onScriptError !== 'function') {
				throw new Error('ScriptLoader: Component class must implement onScriptError()');
			}
			if (loadedScripts[scriptURL]) {
				component.onScriptLoaded();
				return;
			}
			if (erroredScripts[scriptURL]) {
				component.onScriptError();
				return;
			}
	
			// If the script is loading, add the component to the script's observers
			// and return. Otherwise, initialize the script's observers with the component
			// and start loading the script.
			if (scriptObservers[scriptURL]) {
				scriptObservers[scriptURL][key] = component;
				return;
			}
	
			var observers = {};
			observers[key] = component;
			scriptObservers[scriptURL] = observers;
	
			var script = document.createElement('script');
			script.src = scriptURL;
	
			var callObserverFuncAndRemoveObserver = function(func) {
				var observers = scriptObservers[scriptURL];
				for (var key in observers) {
					observer = observers[key];
					var removeObserver = func(observer);
					if (removeObserver) {
						delete scriptObservers[scriptURL][key];
					}
				}
				//delete scriptObservers[scriptURL];
			}
			script.onload = function() {
				loadedScripts[scriptURL] = true;
				callObserverFuncAndRemoveObserver(function(observer) {
					if (observer.deferOnScriptLoaded && observer.deferOnScriptLoaded()) {
						return false;
					}
					observer.onScriptLoaded();
					return true;
				});
			};
			script.onerror = function(event) {
				erroredScripts[scriptURL] = true;
				callObserverFuncAndRemoveObserver(function(observer) {
					observer.onScriptError();
					return true;
				});
			};
			document.body.appendChild(script);
		},
		componentWillUnmount: function(key, scriptURL) {
			// If the component is waiting for the script to load, remove the
			// component from the script's observers before unmounting the component.
			var observers = scriptObservers[scriptURL];
			if (observers) {
				delete observers[key];
			}
		},
		triggerOnScriptLoaded: function(scriptURL) {
			if (!loadedScripts[scriptURL]) {
				throw new Error('Error: only call this function after the script has in fact loaded.');
			}
			var observers = scriptObservers[scriptURL];
			for (var key in observers) {
				var observer = observers[key];
				observer.onScriptLoaded();
			}
			delete scriptObservers[scriptURL];
		}
	};
	
	var ReactScriptLoaderMixin = {
		componentDidMount: function() {
			if (typeof this.getScriptURL !== 'function') {
				throw new Error("ScriptLoaderMixin: Component class must implement getScriptURL().")
			}
			ReactScriptLoader.componentDidMount(this.__getScriptLoaderID(), this, this.getScriptURL());
		},
		componentWillUnmount: function() {
			ReactScriptLoader.componentWillUnmount(this.__getScriptLoaderID(), this.getScriptURL());
		},
		__getScriptLoaderID: function() {
			return 'id' + idCount++;
		},
	};
	
	exports.ReactScriptLoaderMixin = ReactScriptLoaderMixin;
	exports.ReactScriptLoader = ReactScriptLoader;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(520).enable();
	  window.Promise = __webpack_require__(519);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(722);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(16);


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    _Card.Card,
	    { className: 'unregistered' },
	    _react2.default.createElement(_Card.CardHeader, { title: 'About Pronounce Live' }),
	    _react2.default.createElement(
	      _Card.CardText,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sanako Pronounce Live is a true online solution for pronunciation practice, no installations or downloads are needed.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pronounce Live requires the Google Chrome browser.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'About Sanako Corporation'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sanako is the global leader in developing language teaching software and services for the educational sector. We have worked closely with our customers for over 50 years towards a single goal: to enable better comprehension, speaking and communication skills for language learners.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sanako Corporation is a global organization employing professionals on four continents. Our headquarters is located in Finland. Our network of partners worldwide ensures we are always close to our customers.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Personal users'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you have any questions, please check our ',
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.sanako.com/help/pronounce-live-faq/' },
	          'FAQ'
	        ),
	        ' first.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If the FAQ doesn\'t answer your question, you can contact us at ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:pronouncelive@sanako.com' },
	          'pronouncelive@sanako.com'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Institutions'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Pronounce Live is available for institutions also. You can contact us for more information at:'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:pronouncelive@sanako.com' },
	          'pronouncelive@sanako.com'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our reseller network around the world is ready to serve you. You can find the complete list of Sanako resellers at:'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.sanako.com/resellers/' },
	          'http://www.sanako.com/resellers/'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Don\u2019t hesitate to contact us if you cannot find a reseller or you want us to find the most suitable partner for you.'
	      )
	    )
	  );
	};
	
	exports.default = About;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Match = __webpack_require__(240);
	
	var _Match2 = _interopRequireDefault(_Match);
	
	var _AccountMain = __webpack_require__(612);
	
	var _AccountMain2 = _interopRequireDefault(_AccountMain);
	
	var _AccountSubscription = __webpack_require__(613);
	
	var _AccountSubscription2 = _interopRequireDefault(_AccountSubscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Account = function Account(props) {
	  if (!props.auth.isAuthenticated) {
	    return _react2.default.createElement('span', null);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Match2.default, { exactly: true, pattern: '/account/subscription', render: function render(componentProps) {
	        return _react2.default.createElement(_AccountSubscription2.default, Object.assign({}, componentProps, props));
	      } }),
	    _react2.default.createElement(_Match2.default, { exactly: true, pattern: '/account', render: function render(componentProps) {
	        return _react2.default.createElement(_AccountMain2.default, Object.assign({}, componentProps, props));
	      } })
	  );
	};
	
	exports.default = Account;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _actions = __webpack_require__(20);
	
	var _countries = __webpack_require__(249);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _timezones = __webpack_require__(663);
	
	var _timezones2 = _interopRequireDefault(_timezones);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var AccountMain = function (_Component) {
	  _inherits(AccountMain, _Component);
	
	  function AccountMain(props) {
	    _classCallCheck(this, AccountMain);
	
	    var _this = _possibleConstructorReturn(this, (AccountMain.__proto__ || Object.getPrototypeOf(AccountMain)).call(this));
	
	    _this.openDialog = function (type) {
	      _this.setState({
	        dialogOpen: true,
	        type: type
	      });
	    };
	
	    _this.closeDialog = function () {
	      _this.setState({
	        dialogOpen: false,
	        type: null
	      });
	    };
	
	    _this.handleInput = function () {
	      var data = {
	        name: _this.nameInput.getValue(),
	        email: _this.emailInput.getValue()
	      };
	      _this.setState(Object.assign({}, data));
	    };
	
	    _this.handleCountry = function (event, index, value) {
	      return _this.setState({ countryCode: value });
	    };
	
	    _this.handleTimezone = function (event, index, value) {
	      return _this.setState({ timezone: value });
	    };
	
	    _this.handlePasswordInput = function () {
	      var data = {
	        oldpassword: _this.oldPasswordInput.getValue(),
	        newpassword: _this.newPasswordInput.getValue(),
	        newpasswordverify: _this.newPasswordConfirmationInput.getValue()
	      };
	      _this.setState(Object.assign({}, data));
	    };
	
	    _this.renderCountries = function () {
	      return _countries2.default.map(function (country, index) {
	        return _react2.default.createElement(_MenuItem2.default, { key: index, value: country.country_code, primaryText: country.name });
	      });
	    };
	
	    _this.renderTimezones = function () {
	      return _timezones2.default.map(function (tz, index) {
	        return _react2.default.createElement(_MenuItem2.default, { key: index, value: tz.name, primaryText: tz.name + ' (' + tz.timezone + ')' });
	      });
	    };
	
	    _this.renderDialog = function () {
	
	      if (!_this.state.dialogOpen || _this.state.type === null) {
	        return _react2.default.createElement('span', { key: 'emptydialog' });
	      }
	
	      var title = void 0;
	      var text = void 0;
	
	      var okButton = _react2.default.createElement(_FlatButton2.default, {
	        label: 'OK',
	        primary: true,
	        keyboardFocused: true,
	        onTouchTap: function onTouchTap() {
	          return _this.closeDialog();
	        }
	      });
	
	      var actions = [okButton];
	
	      if (_this.state.type === 'password-change-success') {
	        title = 'Password changed!';
	        text = 'Your password was changed successfully.';
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          title: title,
	          actions: actions,
	          modal: false,
	          open: _this.state.dialogOpen,
	          onTouchTap: function onTouchTap() {
	            return _this.setState({ dialogOpen: false, type: '' });
	          }
	        },
	        text
	      );
	    };
	
	    _this.state = {
	      name: props.auth.user.name,
	      email: props.auth.user.email,
	      countryCode: props.auth.user.countryCode,
	      timezone: props.auth.user.timezone,
	      oldpassword: '',
	      newpassword: '',
	      newpasswordverify: '',
	      dialogOpen: false,
	      dialogType: null
	    };
	    return _this;
	  }
	
	  _createClass(AccountMain, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.auth.isFetchingPassword && !nextProps.auth.isFetchingPassword && nextProps.auth.errors.length === 0) {
	        this.openDialog('password-change-success');
	      }
	    }
	  }, {
	    key: 'handleInfoChange',
	    value: function handleInfoChange(event) {
	      event.preventDefault();
	      var name = this.state.name.trim();
	      var email = this.state.email.trim();
	      var country_id = this.state.countryCode;
	      var timezone = this.state.timezone;
	      this.props.dispatch((0, _actions.changeSettings)({ name: name, email: email, country_id: country_id, timezone: timezone }));
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(event) {
	      event.preventDefault();
	      var oldpassword = this.state.oldpassword.trim();
	      var newpassword = this.state.newpassword.trim();
	      var newpasswordConfirmation = this.state.newpasswordverify.trim();
	      var data = { oldpassword: oldpassword, newpassword: newpassword, newpassword_confirmation: newpasswordConfirmation };
	      this.props.dispatch((0, _actions.changePassword)(data));
	    }
	  }, {
	    key: 'renderAccountSettings',
	    value: function renderAccountSettings() {
	      var _this2 = this;
	
	      var _getErrors = (0, _geterrors2.default)(this.props.auth.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	
	      var validSettings = this.state.name.length > 0 && this.state.email.match(emailRegexp);
	
	      var disabled = !validSettings || this.props.isWaiting.CHANGE_SETTINGS;
	
	      var groupName = void 0;
	
	      if (this.props.auth.user && this.props.auth.user.group) {
	        groupName = this.props.auth.user.group.name;
	      }
	
	      return _react2.default.createElement(
	        _Card.Card,
	        { className: 'card-wide' },
	        _react2.default.createElement(_Card.CardHeader, { title: 'Account settings' }),
	        _react2.default.createElement(
	          _Card.CardText,
	          null,
	          groupName && _react2.default.createElement(
	            'p',
	            null,
	            'You belong to the group ',
	            groupName,
	            '.'
	          ),
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement(_TextField2.default, {
	              className: 'input-long',
	              onChange: this.handleInput,
	              errorText: nameErrorMessage,
	              ref: function ref(input) {
	                _this2.nameInput = input;
	              },
	              type: 'text',
	              name: 'name',
	              value: this.state.name,
	              floatingLabelText: 'Name'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_TextField2.default, {
	              className: 'input-long',
	              onChange: this.handleInput,
	              ref: function ref(input) {
	                _this2.emailInput = input;
	              },
	              errorText: emailErrorMessage,
	              type: 'text',
	              name: 'email',
	              value: this.state.email,
	              floatingLabelText: 'Email'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _SelectField2.default,
	              {
	                floatingLabelText: 'Country',
	                value: this.state.countryCode,
	                onChange: this.handleCountry
	              },
	              this.renderCountries()
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _SelectField2.default,
	              {
	                floatingLabelText: 'Timezone',
	                value: this.state.timezone || null,
	                onChange: this.handleTimezone
	              },
	              this.renderTimezones()
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlatButton2.default, { disabled: disabled, onClick: function onClick(event) {
	                return _this2.handleInfoChange(event);
	              }, type: 'submit', label: 'Save changes' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPasswordSettings',
	    value: function renderPasswordSettings() {
	      var _this3 = this;
	
	      var _getErrors2 = (0, _geterrors2.default)(this.props.auth.errors),
	          errorMessages = _getErrors2.errorMessages,
	          validationErrors = _getErrors2.validationErrors;
	
	      var oldPasswordErrorMessage = _apierrors2.default[validationErrors.oldpassword] || validationErrors.oldpassword;
	      var newPasswordErrorMessage = _apierrors2.default[validationErrors.newpassword] || validationErrors.newpassword;
	
	      var validSettings = this.state.oldpassword.length > 5 && this.state.newpassword.length > 5 && this.state.newpasswordverify.length > 5;
	
	      var disabled = !validSettings || this.props.isWaiting.CHANGE_PASSWORD;
	
	      var style = {
	        margin: 'auto'
	      };
	
	      return _react2.default.createElement(
	        _Card.Card,
	        { style: style },
	        _react2.default.createElement(_Card.CardHeader, { title: 'Change password' }),
	        _react2.default.createElement(
	          _Card.CardText,
	          null,
	          _react2.default.createElement(
	            'form',
	            { onChange: this.handlePasswordInput },
	            _react2.default.createElement(_TextField2.default, {
	              className: 'input-long',
	              ref: function ref(input) {
	                _this3.oldPasswordInput = input;
	              },
	              errorText: oldPasswordErrorMessage,
	              type: 'password',
	              name: 'oldpassword',
	              floatingLabelText: 'Current password'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_TextField2.default, {
	              className: 'input-long',
	              ref: function ref(input) {
	                _this3.newPasswordInput = input;
	              },
	              errorText: newPasswordErrorMessage,
	              type: 'password',
	              name: 'newpassword',
	              floatingLabelText: 'New password'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_TextField2.default, {
	              className: 'input-long',
	              ref: function ref(input) {
	                _this3.newPasswordConfirmationInput = input;
	              },
	              type: 'password',
	              name: 'newpasswordverify',
	              floatingLabelText: 'Confirm new password'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_FlatButton2.default, { disabled: disabled, onClick: function onClick(event) {
	                return _this3.handlePasswordChange(event);
	              }, type: 'submit', label: 'Save password' })
	          )
	        ),
	        _react2.default.createElement(
	          _Card.CardText,
	          null,
	          errorMessages.map(function (error, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i },
	              _react2.default.createElement(
	                'strong',
	                null,
	                error
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderAccountSettings(),
	        _react2.default.createElement('br', null),
	        this.renderPasswordSettings(),
	        this.renderDialog()
	      );
	    }
	  }]);
	
	  return AccountMain;
	}(_react.Component);
	
	exports.default = AccountMain;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Card = __webpack_require__(22);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _done = __webpack_require__(89);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	__webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global StripeCheckout */
	
	
	var AccountSubscription = function (_Component) {
	  _inherits(AccountSubscription, _Component);
	
	  function AccountSubscription(props) {
	    _classCallCheck(this, AccountSubscription);
	
	    var _this = _possibleConstructorReturn(this, (AccountSubscription.__proto__ || Object.getPrototypeOf(AccountSubscription)).call(this, props));
	
	    _this.handler = null;
	    _this.updatedHandler = null;
	
	    _this.handleCoupon = function () {
	      return _this.setState({ coupon: _this.couponInput.getValue() });
	    };
	
	    _this.claimCoupon = function () {
	      if (_this.state.coupon === null) {
	        return;
	      }
	
	      _this.props.dispatch((0, _actions.claimCoupon)(_this.state.coupon));
	    };
	
	    _this.openDialog = function (type) {
	      console.log("open dialog");
	      _this.setState({
	        infoDialogOpen: true,
	        type: type
	      });
	    };
	
	    _this.closeDialog = function () {
	      _this.setState({
	        infoDialogOpen: false,
	        type: null
	      });
	    };
	
	    _this.showSubscriptionForm = function () {
	      if (_this.props.subscriptions.hasFetchedPlan) {
	        var plan = _this.props.subscriptions.plan;
	
	        console.log("show sub form");
	        _this.handler.open({
	          name: "Pronounce Live",
	          description: "Six month subscription to Pronounce Live",
	          billingAddress: true,
	          amount: plan.price,
	          currency: plan.currency,
	          panelLabel: "Subscribe for {{amount}}"
	        });
	      }
	    };
	
	    _this.showUpdateCreditCardForm = function () {
	      console.log("show cc form");
	      _this.updateHandler.open({
	        name: "Pronounce Live",
	        description: "Update your credit card details.",
	        billingAddress: true
	      });
	    };
	
	    _this.resumeSubscription = function () {
	      //this.props.dispatch(resumeSubscription());
	    };
	
	    _this.renderInvoiceRow = function (invoice, index) {
	      return _react2.default.createElement(
	        "div",
	        { key: "invoice-" + index },
	        _react2.default.createElement(
	          "strong",
	          null,
	          invoice.date
	        ),
	        " ",
	        invoice.total / 100,
	        " ",
	        invoice.currency,
	        " ",
	        invoice.total === 0 && _react2.default.createElement(
	          "span",
	          null,
	          "(This marks the beginning of your subscription during your trial period)"
	        )
	      );
	    };
	
	    _this.renderDialog = function () {
	      if (!_this.state.infoDialogOpen || _this.state.type === null) {
	        return _react2.default.createElement("span", { key: "emptydialog" });
	      }
	
	      var actions = void 0;
	      var title = void 0;
	      var text = void 0;
	
	      var okButton = _react2.default.createElement(_FlatButton2.default, {
	        label: "OK",
	        primary: true,
	        keyboardFocused: true,
	        onTouchTap: function onTouchTap() {
	          return _this.closeDialog();
	        }
	      });
	
	      if (_this.state.type === "resume") {
	        actions = [_react2.default.createElement(_FlatButton2.default, {
	          label: "No, close this window",
	          primary: true,
	          keyboardFocused: true,
	          onTouchTap: function onTouchTap() {
	            return _this.closeDialog();
	          }
	        }), _react2.default.createElement(_FlatButton2.default, {
	          label: "Yes, Resume Subscription",
	          primary: true,
	          onTouchTap: function onTouchTap() {
	            _this.resumeSubscription();
	            _this.closeDialog();
	          }
	        })];
	
	        title = "Do you want to resume your subscription?";
	        text = "Resuming will continue your subscription when the next billing period begins, and your card will be charged then.";
	      }
	
	      if (_this.state.type === "cancel") {
	        actions = [_react2.default.createElement(_FlatButton2.default, {
	          label: "No, close this window",
	          primary: true,
	          keyboardFocused: true,
	          onTouchTap: function onTouchTap() {
	            return _this.closeDialog();
	          }
	        }), _react2.default.createElement(_FlatButton2.default, {
	          label: "Yes, Cancel Subscription",
	          primary: true,
	          onTouchTap: function onTouchTap() {
	            _this.cancelSubscription();
	            _this.closeDialog();
	          }
	        })];
	
	        title = "Do you want to cancel your subscription?";
	        text = "Cancelling your subscription means that you will not be charged when the next billing period begins. You can still use Pronounce Live until the end of this billing period.";
	      }
	
	      if (_this.state.type === "create-subscription-success") {
	        actions = [okButton];
	        title = "Subscription started!";
	        text = _react2.default.createElement(
	          "span",
	          null,
	          "Success! You now have a Pronouce Live subscription for the next six months. The subscription will be automatically renewed unless you cancel before that. Hope you have fun with Pronounce Live! You can access Pronounce Live by clicking on the wave icon on the upper left, or by ",
	          _react2.default.createElement(
	            _Link2.default,
	            { to: "/" },
	            "clicking here"
	          ),
	          "."
	        );
	      }
	
	      if (_this.state.type === "create-subscription-failure") {
	        actions = [okButton];
	        title = "Could not create a subscription :(";
	        text = "Unfortunately our server could not create a new subscription. Please try again in a moment.";
	      }
	
	      if (_this.state.type === "cancel-subscription-success") {
	        actions = [okButton];
	        title = "Subscription canceled";
	        text = "Your subscription to Pronounce Live has been cancelled. You can still use Pronounce Live until the end of this billing period. We hope you will enjoy the remainder of your subscription.";
	      }
	
	      if (_this.state.type === "cancel-subscription-failure") {
	        actions = [okButton];
	        title = "Could not cancel a subscription :(";
	        text = "Unfortunately our server could not cancel your subscription. Please try again in a moment or contact our support.";
	      }
	
	      if (_this.state.type === "resume-subscription-success") {
	        actions = [okButton];
	        title = "Subscription resumed!";
	        text = "Your subscription to Pronounce Live has been resumed! Your subscription will continue automatically at the end of this billing period.";
	      }
	
	      if (_this.state.type === "resume-subscription-failure") {
	        actions = [okButton];
	        title = "Could not resume your subscription :(";
	        text = "Unfortunately our server could not resume your subscription. Please try again in a moment or contact our support.";
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          title: title,
	          actions: actions,
	          modal: false,
	          open: _this.state.infoDialogOpen,
	          onTouchTap: function onTouchTap() {
	            return _this.setState({ infoDialogOpen: false, type: "" });
	          }
	        },
	        text
	      );
	    };
	
	    _this.state = {
	      coupon: null,
	      infoDialogOpen: false,
	      type: null,
	      stripeLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(AccountSubscription, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.props.dispatch((0, _actions.getPlan)());
	
	      this.props.dispatch((0, _actions.getSubscriptions)());
	      this.props.dispatch((0, _actions.getInvoices)());
	
	      if (typeof StripeCheckout === "undefined") {
	        this.setState({ stripeLoaded: false });
	      } else {
	        this.setState({ stripeLoaded: true });
	        //The state of the state will be updated in one batch *after* this function,
	        // so stripeLoaded cannot be used inside it to check if the configuration can be run.
	        // Easiest solution is this, putting it all inside one control flow.
	        this.handler = StripeCheckout.configure({
	          key: "pk_live_6LlznC5Y0ufn2B1gHP8oQRWT",
	          image: "/images/stripe-logo-red.png",
	          locale: "auto",
	          zipCode: true,
	          currency: "EUR",
	          panelLabel: "Subscribe for {{amount}}",
	          email: this.props.auth.user.email,
	          allowRememberMe: false,
	          token: function token(_token) {
	            if (_this2.props.subscriptions.hasFetchedPlan) {
	              _token.localPlanId = _this2.props.subscriptions.plan.id;
	              _this2.props.dispatch((0, _actions.createSubscription)(_token));
	            }
	          }
	        });
	
	        this.updateHandler = StripeCheckout.configure({
	          key: "pk_live_6LlznC5Y0ufn2B1gHP8oQRWT",
	          image: "/images/stripe-logo-red.png",
	          locale: "auto",
	          zipCode: true,
	          panelLabel: "Update credit card",
	          email: this.props.auth.user.email,
	          allowRememberMe: false,
	          token: function token(_token2) {
	            console.log("updating card");
	            console.log(_token2);
	            _this2.props.dispatch((0, _actions.updateCreditCard)(_token2));
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      console.log(this.props);
	      console.log(nextProps);
	      if (this.props.subscriptions.isCreatingSubscription && !nextProps.subscriptions.isCreatingSubscription && nextProps.subscriptions.didSucceed) {
	        this.openDialog("create-subscription-success");
	      } else if (this.props.subscriptions.isCreatingSubscription && !nextProps.subscriptions.isCreatingSubscription && !nextProps.subscriptions.didSucceed && nextProps.subscriptions.errors.length > 0) {
	        this.openDialog("create-subscription-failure");
	      }
	
	      if (this.props.subscriptions.isCancellingSubscription && !nextProps.subscriptions.isCancellingSubscription && nextProps.subscriptions.errors.length === 0) {
	        this.openDialog("cancel-subscription-success");
	      } else if (this.props.subscriptions.isCancellingSubscription && !nextProps.subscriptions.isCancellingSubscription && nextProps.subscriptions.errors.length > 0) {
	        this.openDialog("cancel-subscription-failure");
	      }
	
	      /*
	      if (this.props.subscriptions.isResumingSubscription && !nextProps.subscriptions.isResumingSubscription && nextProps.subscriptions.errors.length === 0) {
	        this.openDialog('resume-subscription-success');
	      } else if (this.props.subscriptions.isResumingSubscription && !nextProps.subscriptions.isResumingSubscription && nextProps.subscriptions.errors.length > 0) {
	        this.openDialog('resume-subscription-failure');
	      } */
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.stripeLoaded) {
	        this.handler.close();
	        this.updateHandler.close();
	      }
	    }
	  }, {
	    key: "cancelSubscription",
	    value: function cancelSubscription() {
	      this.props.dispatch((0, _actions.cancelSubscription)());
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          auth = _props.auth,
	          subscriptions = _props.subscriptions,
	          invoices = _props.invoices;
	
	
	      if (!this.props.auth.isAuthenticated) {
	        return _react2.default.createElement("span", null);
	      }
	
	      var _getErrors = (0, _geterrors2.default)(subscriptions.errors),
	          errorMessages = _getErrors.errorMessages,
	          validationErrors = _getErrors.validationErrors,
	          stripeErrors = _getErrors.stripeErrors,
	          stripeConnectionErrors = _getErrors.stripeConnectionErrors;
	
	      console.log(stripeErrors);
	
	      var disabled = this.state.stripeLoaded === false || !subscriptions.hasFetchedPlan || subscriptions.isFetching;
	
	      var busyLabel = "";
	
	      if (subscriptions.isFetching) {
	        if (subscriptions.isCreatingSubscription) {
	          busyLabel = "Creating your subscription";
	        }
	
	        if (subscriptions.isCancellingSubscription) {
	          busyLabel = "Cancelling your subscription";
	        }
	
	        if (subscriptions.isResumingSubscription) {
	          busyLabel = "Resuming your subscription";
	        }
	
	        if (subscriptions.isUpdatingCard) {
	          busyLabel = "Updating your card";
	        }
	      }
	
	      var subscriptionInfo = "";
	      var subscriptionBtnLabel = "Fetching plan...";
	
	      var symbols = {
	        EUR: "€",
	        USD: "$",
	        GBP: "£"
	      };
	
	      if (this.props.subscriptions.hasFetchedPlan) {
	        var price = this.props.subscriptions.plan.price / 100;
	        var curSymbol = symbols[this.props.subscriptions.plan.currency];
	        subscriptionInfo = "Subscription available for 6 months / " + price + " " + curSymbol + ".";
	        subscriptionBtnLabel = "Get 6 months for " + price + " " + curSymbol;
	      }
	
	      var btnStyle = {
	        color: "#fff"
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: "subscription-wrapper" },
	        _react2.default.createElement(
	          _Card.Card,
	          { className: "card-wide" },
	          _react2.default.createElement(_Card.CardHeader, { title: "Subscription" }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            errorMessages.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "pronounce-error error-form" },
	              errorMessages.map(function (error, index) {
	                return _react2.default.createElement(
	                  "div",
	                  { key: index },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    error
	                  )
	                );
	              })
	            ),
	            stripeErrors.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "pronounce-error error-form" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "There was an error with our payment processor. Please try again in a moment. Administration has been notified."
	              ),
	              errorMessages.map(function (error, index) {
	                return _react2.default.createElement(
	                  "div",
	                  { key: index },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    error
	                  )
	                );
	              })
	            ),
	            stripeConnectionErrors.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "pronounce-error error-form" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "There was an error connecting to our payment processor. Please try again in a moment. Administration has been notified."
	              ),
	              errorMessages.map(function (error, index) {
	                return _react2.default.createElement(
	                  "div",
	                  { key: index },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    error
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "subscription-info" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you have any questions or issues with your trial or subscriptions, please",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    target: "_blank",
	                    href: "http://www.sanako.com/help/pronounce-live-faq/"
	                  },
	                  "check our FAQ"
	                ),
	                "."
	              )
	            ),
	            subscriptions.info.subscribed && !subscriptions.info.cancelled && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(_done2.default, null),
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Your subscription is active!"
	                )
	              ),
	              !subscriptions.info.onTrial && subscriptions.info.billingCycleStart && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Your current billing period started",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    subscriptions.info.billingCycleStart
	                  ),
	                  "."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "It will end on",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    subscriptions.info.billingCycleEnd
	                  ),
	                  "."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Your subscription will be automatically cancelled when this billing cycle ends.",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "You can still use Pronounce Live until the end of this billing period."
	                )
	              ),
	              !subscriptions.info.onTrial && !subscriptions.info.billingCycleStart && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Your subscription will be automatically cancelled when this billing cycle ends.",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "You can still use Pronounce Live until the end of this billing period."
	                )
	              ),
	              subscriptions.info.onTrial && auth.user.hasActiveSubscription && _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "You are still on your trial period until",
	                  " ",
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    subscriptions.info.trialEndsAt
	                  ),
	                  " (",
	                  subscriptions.info.untilTrialEnds,
	                  ")."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "This means your actual subscription will begin then. You can cancel before that and your credit card will not be charged."
	                )
	              ),
	              _react2.default.createElement(_FlatButton2.default, {
	                backgroundColor: "rgb(49, 192, 76)",
	                style: btnStyle,
	                disabled: disabled,
	                onTouchTap: function onTouchTap() {
	                  return _this3.openDialog("cancel");
	                },
	                type: "submit",
	                label: "Cancel subscription"
	              })
	            ),
	            subscriptions.info.onGracePeriod && !subscriptions.info.onTrial && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "You have cancelled your subscription."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You can still use Pronounce until the remainder of this billing period, whichs ends on",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  subscriptions.info.billingCycleEnd
	                ),
	                "."
	              ),
	              _react2.default.createElement(_FlatButton2.default, {
	                backgroundColor: "rgb(49, 192, 76)",
	                style: btnStyle,
	                disabled: disabled,
	                onTouchTap: function onTouchTap() {
	                  return _this3.openDialog("resume");
	                },
	                label: "Resume your subscription"
	              })
	            ),
	            subscriptions.info.onGracePeriod && subscriptions.info.onTrial && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "You have cancelled your subscription."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You can still use Pronounce until the remainder of your trial period, which ends",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  subscriptions.info.trialEndsAt
	                ),
	                " (",
	                subscriptions.info.untilTrialEnds,
	                ")."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you resume your subscription, it will be charged automatically after your trial period ends, and you can continue to use Pronounce Live seamlessly."
	              ),
	              _react2.default.createElement(_FlatButton2.default, {
	                backgroundColor: "rgb(49, 192, 76)",
	                style: btnStyle,
	                disabled: disabled,
	                onTouchTap: function onTouchTap() {
	                  return _this3.openDialog("resume");
	                },
	                label: "Resume your subscription"
	              })
	            ),
	            subscriptions.hasFetched && !auth.user.hasActiveSubscription && !subscriptions.info.onGenericTrial && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Your subscription is not currently active. You do not have access to Pronounce Live at the moment."
	                )
	              )
	            ),
	            subscriptions.isFetching && _react2.default.createElement(
	              "div",
	              { className: "account-success-overlay" },
	              _react2.default.createElement(_CircularProgress2.default, null),
	              " ",
	              busyLabel,
	              "..."
	            ),
	            (!subscriptions.info.subscribed || subscriptions.info.cancelled && !subscriptions.info.onGracePeriod) && subscriptions.info.onGenericTrial && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "You are on your trial period which ends",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  subscriptions.info.trialEndsAt
	                ),
	                " (",
	                subscriptions.info.untilTrialEnds,
	                ")."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "To use Pronounce Live after that you need a subscription."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                subscriptionInfo,
	                " Your subscription will start when the trial ends, and you can cancel your subscription at anytime before that."
	              ),
	              _react2.default.createElement(_FlatButton2.default, {
	                backgroundColor: "rgb(49, 192, 76)",
	                style: btnStyle,
	                disabled: disabled,
	                onTouchTap: function onTouchTap() {
	                  return _this3.showSubscriptionForm();
	                },
	                label: subscriptionBtnLabel
	              })
	            ),
	            !this.state.stripeLoaded && _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Unfortunately our payment processor server is unreachable at the moment, so account activities like subscribing and updating your card are suspended at the moment. We are very sorry - please try again in a moment."
	              )
	            )
	          )
	        ),
	        subscriptions.info.subscribed && _react2.default.createElement(
	          _Card.Card,
	          { className: "card-wide" },
	          _react2.default.createElement(_Card.CardHeader, { title: "Stored payment method" }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            subscriptions.hasFetched && subscriptions.info.card.brand && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "p",
	                null,
	                "Your current card on file is a",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  subscriptions.info.card.brand
	                ),
	                " ending in",
	                " ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  subscriptions.info.card.last_four
	                ),
	                "."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Please keep your card information up to date."
	              )
	            ),
	            _react2.default.createElement(_FlatButton2.default, {
	              backgroundColor: "rgb(49, 192, 76)",
	              style: btnStyle,
	              disabled: disabled,
	              onTouchTap: function onTouchTap() {
	                return _this3.showUpdateCreditCardForm();
	              },
	              label: "Update Credit Card"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Card.Card,
	          { className: "card-wide" },
	          _react2.default.createElement(_Card.CardHeader, { title: "Payment history" }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            invoices.invoices.map(function (invoice, index) {
	              return _this3.renderInvoiceRow(invoice, index);
	            }),
	            invoices.invoices.length === 0 && _react2.default.createElement(
	              "p",
	              null,
	              "You do not have any invoices yet."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Card.Card,
	          { className: "card-wide" },
	          _react2.default.createElement(_Card.CardHeader, { title: "Subscription event history" }),
	          _react2.default.createElement(_Card.CardText, null)
	        ),
	        this.renderDialog()
	      );
	    }
	  }]);
	
	  return AccountSubscription;
	}(_react.Component);
	
	exports.default = AccountSubscription;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(236);
	
	var _BrowserRouter = __webpack_require__(601);
	
	var _BrowserRouter2 = _interopRequireDefault(_BrowserRouter);
	
	var _Match = __webpack_require__(240);
	
	var _Match2 = _interopRequireDefault(_Match);
	
	var _Miss = __webpack_require__(605);
	
	var _Miss2 = _interopRequireDefault(_Miss);
	
	var _Redirect = __webpack_require__(101);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _Header = __webpack_require__(623);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(616);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FrontPage = __webpack_require__(618);
	
	var _FrontPage2 = _interopRequireDefault(_FrontPage);
	
	var _GroupSettings = __webpack_require__(620);
	
	var _GroupSettings2 = _interopRequireDefault(_GroupSettings);
	
	var _GroupExercises = __webpack_require__(619);
	
	var _GroupExercises2 = _interopRequireDefault(_GroupExercises);
	
	var _GuestLayout = __webpack_require__(622);
	
	var _GuestLayout2 = _interopRequireDefault(_GuestLayout);
	
	var _ForgotPassword = __webpack_require__(617);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _ResetPassword = __webpack_require__(643);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _Register = __webpack_require__(641);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _TrialTokenRegistration = __webpack_require__(652);
	
	var _TrialTokenRegistration2 = _interopRequireDefault(_TrialTokenRegistration);
	
	var _Pronounce = __webpack_require__(638);
	
	var _Pronounce2 = _interopRequireDefault(_Pronounce);
	
	var _NoAuthorization = __webpack_require__(632);
	
	var _NoAuthorization2 = _interopRequireDefault(_NoAuthorization);
	
	var _JoinGroup = __webpack_require__(624);
	
	var _JoinGroup2 = _interopRequireDefault(_JoinGroup);
	
	var _Account = __webpack_require__(611);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _About = __webpack_require__(610);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Privacy = __webpack_require__(637);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _Terms = __webpack_require__(650);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _Welcome = __webpack_require__(653);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _LandingPage = __webpack_require__(625);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	var _actions = __webpack_require__(20);
	
	__webpack_require__(343);
	
	var _device = __webpack_require__(655);
	
	var _device2 = _interopRequireDefault(_device);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals document */
	/* eslint react/jsx-filename-extension: "off" */
	
	var justPronounce = false;
	var standAlone = false;
	
	// Expose a small global config object - this is used just for Google
	// Analytics at the moment. Modifying it does nothing.
	window.pronounceConfig = {
	  lang: "en-GB"
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this.mediaQueryChanged = function () {
	      var deviceConfig = Object.assign({}, _this.state.deviceConfig);
	      deviceConfig.isTablet = _this.queryTablet.matches;
	      deviceConfig.isPhone = _this.queryPhone.matches;
	
	      _this.setState({ deviceConfig: deviceConfig });
	    };
	
	    _this.openWelcome = function () {
	      return _this.setState({ openWelcomeScreen: true });
	    };
	
	    _this.closeWelcome = function () {
	      return _this.setState({ openWelcomeScreen: false });
	    };
	
	    var dev = (0, _device2.default)();
	
	    _this.state = {
	      deviceConfig: {
	        type: dev.type,
	        environment: dev.environment
	      },
	      openWelcomeScreen: false,
	      openIntroductoryExercise: false
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      // uses matchMedia API to detect changes in width for responsive layouts.
	      this.queryTablet = window.matchMedia("(max-width: 768px)");
	      this.queryPhone = window.matchMedia("(max-width: 480px)");
	
	      this.queryTablet.addListener(this.mediaQueryChanged);
	      this.queryPhone.addListener(this.mediaQueryChanged);
	
	      var deviceConfig = Object.assign({}, this.state.deviceConfig);
	      deviceConfig.isTablet = this.queryTablet.matches;
	      deviceConfig.isPhone = this.queryPhone.matches;
	
	      this.setState({ deviceConfig: deviceConfig });
	
	      //Check for access here, in case the user has stored their logins with the Remember button
	      if (this.props.auth.isAuthenticated) {
	        this.props.dispatch((0, _actions.getSubscriptions)());
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevAuth = prevProps.auth.isAuthenticated;
	      var auth = this.props.auth.isAuthenticated;
	
	      // Start logging time spent in the app
	      if (!prevProps.auth.isAuthenticated && this.props.auth.isAuthenticated) {
	        localStorage.setItem("pronounce-time-spent", performance.now());
	
	        //If the user is NOT using Remember me, check for access here
	        this.props.dispatch((0, _actions.getSubscriptions)());
	        if (!this.props.auth.localData.hasLoggedIn) {
	          //Disabled until storing user prefs locally per user is sorted out
	          this.setState({
	            openWelcomeScreen: true,
	            openIntroductoryExercise: true
	          });
	          this.props.dispatch((0, _actions.setFirstLogin)());
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.queryTablet.removeListener(this.mediaQueryChanged);
	      this.queryPhone.removeListener(this.mediaQueryChanged);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var dispatch = this.props.dispatch;
	      var _props$auth = this.props.auth,
	          user = _props$auth.user,
	          isAuthenticated = _props$auth.isAuthenticated;
	
	      var config = this.state.deviceConfig;
	      var classes = "";
	
	      if (config.isTablet) {
	        classes = classes + " tablet";
	      }
	
	      if (config.isPhone) {
	        classes = classes + " phone";
	      }
	
	      /*  const MatchWhenAuthorized = ({ component: AuthedComponent, ...rest }) => (
	        <Match
	          {...rest}
	          render={props => (
	            user.hasActiveGroup || user.hasActiveSubscription ? (
	              <AuthedComponent {...props} {...this.props} />
	            ) : (
	              <NoAuthorization user={user} />
	            )
	          )}
	        />
	      ); */
	
	      // This is a temporary arrangement so that the development of
	      // redux-based state management can be continued alongside other features.
	      // Use the justPronounce const defined above to control the output
	      var app = void 0;
	
	      // TODO: There's MatchWhenAuthorized right above, but for some reason it causes an unnecessary
	      // rerender. It's bad because the text input for content will lose focus because of it.
	      var pronounceApp = user.hasActiveGroup || user.hasActiveSubscription || user.onTrial || user.onGenericTrial ? _react2.default.createElement(_Pronounce2.default, Object.assign({
	        config: config,
	        standAlone: standAlone,
	        openIntro: this.state.openIntroductoryExercise
	      }, this.props)) : _react2.default.createElement(_Redirect2.default, {
	        to: {
	          pathname: "/account/subscription",
	          state: { from: this.props.location }
	        }
	      });
	
	      if (justPronounce) {
	        app = _react2.default.createElement(
	          "div",
	          { className: "pronounce" + classes },
	          _react2.default.createElement(_Pronounce2.default, Object.assign({}, this.props, {
	            config: config,
	            standAlone: standAlone,
	            justPronounce: justPronounce
	          }))
	        );
	      } else if (isAuthenticated) {
	        app = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_Header2.default, {
	            dispatch: dispatch,
	            auth: this.props.auth,
	            subscriptions: this.props.subscriptions,
	            showWelcomeScreen: this.openWelcome
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "pronounce " + classes },
	            _react2.default.createElement(_Match2.default, { exactly: true, pattern: "/", render: function render() {
	                return pronounceApp;
	              } }),
	            _react2.default.createElement(_Match2.default, {
	              pattern: "/register",
	              render: function render(props) {
	                return _react2.default.createElement(_Register2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, {
	              strict: true,
	              pattern: "/register/",
	              render: function render(props) {
	                return _react2.default.createElement(_Register2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, {
	              pattern: "/account",
	              render: function render(props) {
	                return _react2.default.createElement(_Account2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, {
	              exactly: true,
	              pattern: "/account/join-group",
	              render: function render(props) {
	                return _react2.default.createElement(_JoinGroup2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, {
	              exactly: true,
	              pattern: "/group-settings",
	              render: function render(props) {
	                return _react2.default.createElement(_GroupSettings2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, {
	              exactly: true,
	              pattern: "/group-settings/exercises",
	              render: function render(props) {
	                return _react2.default.createElement(_GroupExercises2.default, Object.assign({}, props, _this2.props));
	              }
	            }),
	            _react2.default.createElement(_Match2.default, { pattern: "/about", component: _About2.default }),
	            _react2.default.createElement(_Match2.default, { pattern: "/privacy", component: _Privacy2.default }),
	            _react2.default.createElement(_Match2.default, { pattern: "/terms", component: _Terms2.default }),
	            _react2.default.createElement(_Miss2.default, { render: function render() {
	                return _react2.default.createElement(_Redirect2.default, { to: { pathname: "/" } });
	              } }),
	            _react2.default.createElement(_Welcome2.default, {
	              open: this.state.openWelcomeScreen,
	              handleClose: this.closeWelcome,
	              auth: this.props.auth
	            })
	          )
	        );
	      } else {
	        app = _react2.default.createElement(
	          _GuestLayout2.default,
	          Object.assign({ classes: classes }, this.props),
	          _react2.default.createElement(_Match2.default, {
	            exactly: true,
	            pattern: "/",
	            render: function render(props) {
	              return _react2.default.createElement(_FrontPage2.default, Object.assign({}, props, _this2.props));
	            }
	          }),
	          _react2.default.createElement(_Match2.default, {
	            exactly: true,
	            pattern: "/register",
	            render: function render(props) {
	              return _react2.default.createElement(_Register2.default, Object.assign({}, props, _this2.props));
	            }
	          }),
	          _react2.default.createElement(_Match2.default, {
	            exactly: true,
	            pattern: "/password/email",
	            render: function render(props) {
	              return _react2.default.createElement(_ForgotPassword2.default, Object.assign({}, props, _this2.props));
	            }
	          }),
	          _react2.default.createElement(_Match2.default, {
	            pattern: "/password/reset/:resetToken",
	            render: function render(props) {
	              return _react2.default.createElement(_ResetPassword2.default, Object.assign({}, props, _this2.props));
	            }
	          }),
	          _react2.default.createElement(_Match2.default, { pattern: "/about", component: _About2.default }),
	          _react2.default.createElement(_Match2.default, { pattern: "/privacy", component: _Privacy2.default }),
	          _react2.default.createElement(_Match2.default, { pattern: "/terms", component: _Terms2.default }),
	          _react2.default.createElement(_Match2.default, {
	            pattern: "/create-account-android",
	            render: function render(props) {
	              return _react2.default.createElement(_LandingPage2.default, Object.assign({}, props, _this2.props));
	            }
	          }),
	          _react2.default.createElement(_Miss2.default, { render: function render() {
	              return _react2.default.createElement(_Redirect2.default, { to: { pathname: "/" } });
	            } }),
	          _react2.default.createElement(_Footer2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        _BrowserRouter2.default,
	        null,
	        app
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	// These props come from the application's
	// state when it is started
	
	
	function mapStateToProps(state) {
	  var isWaiting = state.isWaiting,
	      exercises = state.exercises,
	      group = state.group,
	      text = state.text,
	      history = state.history,
	      auth = state.auth,
	      validation = state.validation,
	      registration = state.registration,
	      trialregistration = state.trialregistration,
	      singleregistration = state.singleregistration,
	      joinGroup = state.joinGroup,
	      subscriptions = state.subscriptions,
	      invoices = state.invoices;
	
	
	  return {
	    isWaiting: isWaiting,
	    auth: auth,
	    registration: registration,
	    trialregistration: trialregistration,
	    singleregistration: singleregistration,
	    joinGroup: joinGroup,
	    subscriptions: subscriptions,
	    invoices: invoices,
	    exercises: exercises,
	    group: group,
	    text: text,
	    history: history,
	    validation: validation
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlayExample = __webpack_require__(636);
	
	var _PlayExample2 = _interopRequireDefault(_PlayExample);
	
	var _Record = __webpack_require__(640);
	
	var _Record2 = _interopRequireDefault(_Record);
	
	var _ListenRecording = __webpack_require__(627);
	
	var _ListenRecording2 = _interopRequireDefault(_ListenRecording);
	
	var _RateSlider = __webpack_require__(244);
	
	var _RateSlider2 = _interopRequireDefault(_RateSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Controls = function Controls(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'pronounce-controls' },
	    _react2.default.createElement(
	      'span',
	      { className: 'pronounce-buttons' },
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_PlayExample2.default, { config: props.config, deviceConfig: props.deviceConfig, voices: props.voices, togglePlayExample: props.togglePlayExample, text: props.text, mode: props.mode, isStopped: props.isStopped, isPlayingExample: props.isPlayingExample, rate: props.rate, setRate: props.setRate })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_Record2.default, { config: props.config, deviceConfig: props.deviceConfig, text: props.text, isStopped: props.isStopped, record: props.record, isRecording: props.isRecording })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_ListenRecording2.default, { config: props.config, deviceConfig: props.deviceConfig, text: props.text, isStopped: props.isStopped, isPlayingRecording: props.isPlayingRecording, toggleRecordPlayback: props.toggleRecordPlayback, downloadAudio: props.downloadAudio })
	      )
	    )
	  );
	};
	
	exports.default = Controls;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "footer" },
	    _react2.default.createElement(
	      "div",
	      { className: "footer-section" },
	      "\xA9 Sanako Oy",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { target: "_blank", href: "http://www.sanako.com/help/pronounce-live-faq/" },
	        "Pronounce Live FAQ"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { href: "/about" },
	        "About"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { href: "/terms" },
	        "Terms of Use"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { href: "/privacy" },
	        "Privacy"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "footer-section" },
	      "Pronounce Live:",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { href: "/register" },
	        "Create an account"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "a",
	        { href: "/password/email" },
	        "Reset your password"
	      )
	    )
	  );
	};
	
	exports.default = Footer;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var ForgotPassword = function (_Component) {
	  _inherits(ForgotPassword, _Component);
	
	  function ForgotPassword() {
	    _classCallCheck(this, ForgotPassword);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this));
	
	    _this.handleInput = function (event) {
	      event.preventDefault();
	      var email = _this.emailInput.getValue();
	      _this.setState({ email: email, message: '' });
	    };
	
	    _this.state = {
	      email: '',
	      message: ''
	    };
	    return _this;
	  }
	
	  _createClass(ForgotPassword, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.auth.passwordEmail.hasFetched && nextProps.auth.passwordEmail.isSuccess) {
	        this.setState({ email: '', message: 'Email sent!' });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	
	      var validEmail = this.state.email.match(emailRegexp);
	      if (validEmail) {
	        this.props.dispatch((0, _actions.sendResetPasswordLink)({ email: this.state.email }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _getErrors = (0, _geterrors2.default)(this.props.auth.passwordEmail.errors),
	          errorMessages = _getErrors.errorMessages,
	          validationErrors = _getErrors.validationErrors;
	
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	
	      var validEmail = this.state.email.match(emailRegexp);
	      var disabled = !validEmail || this.props.isWaiting.PASSWORD_EMAIL;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'unregistered', key: 'passwordforgot' },
	        _react2.default.createElement(
	          _Card.Card,
	          null,
	          _react2.default.createElement(_Card.CardHeader, { title: 'Reset password' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            'Fill out the form below and an email with a reset link will be sent to you.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'pronounce-login' },
	              _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(_TextField2.default, { autoFocus: true, onChange: this.handleInput, ref: function ref(input) {
	                    _this2.emailInput = input;
	                  }, errorText: emailErrorMessage, type: 'text', name: 'email', placeholder: 'email', value: this.state.email }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_FlatButton2.default, { type: 'submit', disabled: disabled, onClick: function onClick(event) {
	                    return _this2.handleClick(event);
	                  }, label: 'Send Password Reset Link' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            this.state.message
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            errorMessages.map(function (error) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  error
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ForgotPassword;
	}(_react.Component);
	
	exports.default = ForgotPassword;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Requirements = __webpack_require__(245);
	
	var _Requirements2 = _interopRequireDefault(_Requirements);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrontPage = function (_Component) {
	  _inherits(FrontPage, _Component);
	
	  function FrontPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FrontPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FrontPage.__proto__ || Object.getPrototypeOf(FrontPage)).call.apply(_ref, [this].concat(args))), _this), _this.scrollTo = function (el) {
	      switch (el) {
	        case "promo":
	          _this.promoSection.scrollIntoView({
	            block: "start",
	            behavior: "smooth"
	          });
	          break;
	        default:
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FrontPage, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "front-page" },
	        _react2.default.createElement(
	          "div",
	          { className: "hero" },
	          _react2.default.createElement("img", { width: "300", alt: "Pronounce Live", src: "white-logo.png" }),
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Perfect your pronunciation"
	          ),
	          _react2.default.createElement(_RaisedButton2.default, {
	            labelColor: "#fff",
	            backgroundColor: "#31C04C",
	            onClick: function onClick() {
	              _this2.scrollTo("promo");
	            },
	            label: "Learn More"
	          }),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "promo-content dark",
	            ref: function ref(el) {
	              _this2.promoSection = el;
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "section dark" },
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Pronounce Live boosts your confidence in speaking a foreign language."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Pronounce Live is a web application for pronunciation practice. You can listen to authentic speech models read any text or words, record your own voice for comparison and receive immediate feedback."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Perfect your pronunciation and practice for life!"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement("img", {
	                className: "img-responsive promo-laptop",
	                alt: "Pronounce Live running on a laptop",
	                src: "/images/frontpage-laptop.png"
	              }),
	              _react2.default.createElement(_Requirements2.default, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "wrapper white" },
	          _react2.default.createElement(
	            "div",
	            { className: "section" },
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Uno Dos Tres"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                " ",
	                "1. ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Listen"
	                ),
	                " to an authentic speech model read the model word or sentence",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "2. ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Record"
	                ),
	                " yourself speaking the same text",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "3. ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Review"
	                ),
	                " your performance with automatic scoring"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement("img", {
	                className: "img-responsive align-with-laptop",
	                alt: "Pronounce Live icons",
	                src: "/images/frontpage-control-icons.png"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "wrapper grey" },
	          _react2.default.createElement(
	            "div",
	            { className: "section" },
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement("img", {
	                className: "img-responsive",
	                alt: "Pronounce Live results",
	                src: "/images/frontpage-results.png"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Improve with instant feedback"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Color coding will mark words to focus on, and you also get an overall score for your pronunciation. Compete against yourself, the perfect score is only a syllable away!"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "wrapper blue" },
	            _react2.default.createElement(
	              "div",
	              { className: "section" },
	              _react2.default.createElement(
	                "div",
	                { className: "half-section" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Create your own exercises"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Use any content that suits your personal goals best - just copy and paste it and Pronounce Live will automatically divide the text into exercise sentences for you to practice with."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "half-section" },
	                _react2.default.createElement("img", {
	                  className: "img-responsive align-with-laptop",
	                  alt: "Pronounce Live results",
	                  src: "/images/Copy.png"
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FrontPage;
	}(_react.Component);
	
	exports.default = FrontPage;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Divider = __webpack_require__(200);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _ModifyExercise = __webpack_require__(631);
	
	var _ModifyExercise2 = _interopRequireDefault(_ModifyExercise);
	
	var _CreateExerciseForm = __webpack_require__(242);
	
	var _CreateExerciseForm2 = _interopRequireDefault(_CreateExerciseForm);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	var _languagenames = __webpack_require__(102);
	
	var _languagenames2 = _interopRequireDefault(_languagenames);
	
	__webpack_require__(332);
	
	var _actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-children-prop: "warn"*/
	
	var GroupExercises = function (_Component) {
	  _inherits(GroupExercises, _Component);
	
	  function GroupExercises() {
	    _classCallCheck(this, GroupExercises);
	
	    var _this = _possibleConstructorReturn(this, (GroupExercises.__proto__ || Object.getPrototypeOf(GroupExercises)).call(this));
	
	    _this.resetCreateForm = function () {
	      return _this.setState(Object.assign({}, _this.state, { name: '', language: 'en-GB', text: '' }));
	    };
	
	    _this.handleOpen = function (exercise) {
	      return _this.setState({ deleteExerciseDialog: true, exerciseForDeletion: exercise });
	    };
	
	    _this.handleClose = function () {
	      return _this.setState({ deleteExerciseDialog: false, exerciseForDeletion: null });
	    };
	
	    _this.handleUpdateExercise = function (id, exercise) {
	      var newExercise = Object.assign({}, exercise);
	      newExercise.saveToGroup = true;
	      _this.props.dispatch((0, _actions.updateExercise)(id, newExercise));
	    };
	
	    _this.saveExercise = function (name, language, text, mode) {
	      return _this.props.dispatch((0, _actions.createExercise)({ name: name, language: language, text: text, mode: mode, saveToGroup: true }));
	    };
	
	    _this.handleDeleteExercise = function (id) {
	      _this.handleClose();
	      _this.props.dispatch((0, _actions.deleteExercise)(id));
	    };
	
	    _this.renderExercise = function (exercise, index) {
	      console.log(exercise);
	      var disabled = _this.props.isWaiting.EXERCISE_DELETE;
	      var disabledModify = _this.props.isWaiting.EXERCISE_UPDATE;
	
	      var language = _languagenames2.default[exercise.language] || exercise.language;
	
	      return _react2.default.createElement(
	        'tr',
	        { key: 'exercise-' + exercise.id },
	        _react2.default.createElement(
	          'td',
	          null,
	          exercise.name
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          language
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          exercise.mode
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          exercise.creator
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          exercise.createdAt
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_ModifyExercise2.default, { isWaiting: _this.props.isWaiting.EXERCISE_UPDATE, exercise: exercise, exercises: _this.props.exercises, errors: _this.props.exercises.errors, disabled: disabled, disabledModify: disabledModify, save: _this.handleUpdateExercise })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_RaisedButton2.default, { disabled: disabled, label: 'Delete', onTouchTap: function onTouchTap() {
	              return _this.handleOpen(exercise);
	            } })
	        )
	      );
	    };
	
	    _this.state = {
	      name: '',
	      language: 'en-GB',
	      text: '',
	      mode: 'normal',
	      deleteExerciseDialog: false,
	      exerciseForDeletion: null,
	      showCreationForm: false
	    };
	    return _this;
	  }
	
	  _createClass(GroupExercises, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _actions.fetchExercises)());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.exercises.hasSaved && nextProps.exercises.hasSaved) {
	        this.setState({ showCreationForm: false });
	      }
	    }
	  }, {
	    key: 'renderRemovalDialog',
	    value: function renderRemovalDialog() {
	      var _this2 = this;
	
	      if (!this.state.deleteExerciseDialog || this.state.exerciseForDeletion === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var exercise = this.state.exerciseForDeletion;
	
	      var delLabel = this.props.isWaiting.EXERCISE_DELETE ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : 'Yes, delete exercise';
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'No, cancel',
	        primary: true,
	        onTouchTap: this.handleClose
	      }), _react2.default.createElement(_FlatButton2.default, {
	        label: delLabel,
	        primary: true,
	        onTouchTap: function onTouchTap() {
	          return _this2.handleDeleteExercise(exercise.id);
	        }
	      })];
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          actions: actions,
	          modal: false,
	          open: this.state.deleteExerciseDialog,
	          onRequestClose: this.handleClose
	        },
	        'Are you sure you want to delete this exercise?',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        exercise.name,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        exercise.text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _getErrors = (0, _geterrors2.default)(this.props.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var textErrorMessage = _apierrors2.default[validationErrors.text] || validationErrors.text;
	
	      var creationForm = this.state.showCreationForm ? _react2.default.createElement(_CreateExerciseForm2.default, { isWaiting: this.props.isWaiting, exercise: null, canSaveToGroup: true, forceGroupSave: true, nameErrorMessage: nameErrorMessage, textErrorMessage: textErrorMessage, saveExercise: this.saveExercise }) : _react2.default.createElement('span', null);
	
	      var exercises = this.props.exercises.exercises.filter(function (e) {
	        return e.group_id !== null;
	      });
	      exercises.sort(function (a, b) {
	        return b.id - a.id;
	      });
	      console.log(exercises);
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'group-exercises' },
	        _react2.default.createElement(
	          _Card.Card,
	          { className: 'card-wide' },
	          _react2.default.createElement(_Card.CardHeader, { title: 'Edit your group\'s exercises' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              'table',
	              { className: 'table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Language'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Mode'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Creator'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Created'
	                  ),
	                  _react2.default.createElement('th', null),
	                  _react2.default.createElement('th', null)
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                exercises.map(this.renderExercise)
	              )
	            )
	          ),
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(_Card.CardTitle, { title: 'Create a new exercise', showExpandableButton: true, onTouchTap: function onTouchTap() {
	              return _this3.setState({ showCreationForm: !_this3.state.showCreationForm });
	            } }),
	          _react2.default.createElement(_Card.CardText, { expandable: true, children: creationForm })
	        ),
	        this.renderRemovalDialog()
	      );
	    }
	  }]);
	
	  return GroupExercises;
	}(_react.Component);
	
	exports.default = GroupExercises;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _GroupUsers = __webpack_require__(621);
	
	var _GroupUsers2 = _interopRequireDefault(_GroupUsers);
	
	__webpack_require__(333);
	
	var _actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupSettings = function (_Component) {
	  _inherits(GroupSettings, _Component);
	
	  function GroupSettings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, GroupSettings);
	
	    var _this = _possibleConstructorReturn(this, (GroupSettings.__proto__ || Object.getPrototypeOf(GroupSettings)).call(this));
	
	    _this.handleExpandChange = function (element, expanded) {
	      _this.setState({ element: expanded });
	    };
	
	    _this.handleToggle = function (element, toggle) {
	      _this.setState({ element: toggle });
	    };
	
	    _this.handleExpand = function () {
	      _this.setState({ expanded: true });
	    };
	
	    _this.handleReduce = function () {
	      _this.setState({ expanded: false });
	    };
	
	    _this.handleConfirmationDialogOpen = function () {
	      _this.setState({ confirmationOpen: true });
	    };
	
	    _this.handleConfirmationDialogClose = function () {
	      _this.setState({ confirmationOpen: false });
	    };
	
	    _this.handleInput = function (event) {
	      event.preventDefault();
	      var groupName = _this.groupNameInput.getValue();
	      _this.setState({ groupName: groupName });
	    };
	
	    _this.updateGroup = function (event) {
	      event.preventDefault();
	      var data = {
	        name: _this.state.groupName
	      };
	      _this.props.dispatch((0, _actions.updateGroup)(data));
	    };
	
	    _this.handleTokenGeneration = function (event) {
	      event.preventDefault();
	      _this.props.dispatch((0, _actions.generateToken)());
	    };
	
	    _this.handleEmails = function (event) {
	      _this.setState({ invitationEmails: event.target.value });
	    };
	
	    _this.sendEmails = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	        var result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                event.preventDefault();
	                _context.next = 3;
	                return _this.props.dispatch((0, _actions.sendInvitation)(_this.state.invitationEmails));
	
	              case 3:
	                result = _context.sent;
	
	
	                if (result.type === "GROUP_SEND_INVITATION_SUCCESS") {
	                  _this.setState({ invitationEmails: '', confirmationOpen: true });
	                }
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      groupName: props.group.name,
	      invitationEmails: '',
	      tokenExpanded: false,
	      confirmationOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(GroupSettings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _actions.fetchGroup)());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ groupName: nextProps.group.name });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var group = this.props.group;
	      var confirmationOpen = this.state.confirmationOpen;
	
	
	      var disabled = this.props.isWaiting.GROUP_UPDATE;
	      var disabledToken = this.props.isWaiting.GROUP_TOKEN_REFRESH;
	      var disabledSendToken = this.props.isWaiting.GROUP_SEND_INVITATION || this.state.invitationEmails.length < 5;
	
	      var inviteLabel = this.props.isWaiting.GROUP_SEND_INVITATION ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : 'Send invitation';
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'OK',
	        primary: true,
	        onTouchTap: this.handleConfirmationDialogClose
	      })];
	
	      var tokenConfirmationDialog = _react2.default.createElement(
	        _Dialog2.default,
	        { title: 'Tokens sent', actions: actions, modal: false, open: confirmationOpen, onRequestClose: this.handleConfirmationDialogClose, autoScrollBodyContent: true },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Group tokens were sent!'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'group-settings' },
	        _react2.default.createElement(
	          _Card.Card,
	          { className: 'card-wide' },
	          _react2.default.createElement(_Card.CardHeader, { title: 'Edit your group\'s settings' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              'form',
	              null,
	              _react2.default.createElement(_TextField2.default, { className: 'input-long', onChange: this.handleInput, ref: function ref(input) {
	                  _this3.groupNameInput = input;
	                }, type: 'text', name: 'name', placeholder: 'Group Name', value: this.state.groupName }),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(_FlatButton2.default, { disabled: disabled, onClick: function onClick(event) {
	                  return _this3.updateGroup(event);
	                }, label: 'Save Changes' })
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Card.Card,
	          { className: 'card-wide' },
	          _react2.default.createElement(_Card.CardHeader, { title: 'License information' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            'Seats: ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              ' ',
	              group.seats
	            ),
	            ' (',
	            group.users.length,
	            ' used)',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Valid until: ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              group.validUntil
	            ),
	            ' (',
	            group.validPeriod,
	            ')',
	            _react2.default.createElement('br', null)
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Card.Card,
	          { className: 'card-wide' },
	          _react2.default.createElement(_Card.CardHeader, { title: 'Group token' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            { className: 'center' },
	            group.token !== null && _react2.default.createElement(
	              'span',
	              null,
	              'Let people join this group by giving them this token and instructing them to go to the register page:',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'h3',
	                { className: 'group-token' },
	                group.token
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(_FlatButton2.default, { disabled: disabledToken, onClick: function onClick(event) {
	                return _this3.handleTokenGeneration(event);
	              }, label: 'Regenerate token' }),
	            _react2.default.createElement('br', null),
	            '(This will invalidate the current token)'
	          ),
	          _react2.default.createElement(_Card.CardTitle, { title: 'Send token by email', showExpandableButton: true }),
	          _react2.default.createElement(
	            _Card.CardText,
	            { expandable: true },
	            'List the addresses you want to send the email to below. The token along with instructions how to join will be sent to them. Separate multiple addresses with a comma.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'form',
	              null,
	              _react2.default.createElement('textarea', { className: 'send-token', value: this.state.invitationEmails, onChange: this.handleEmails }),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(_FlatButton2.default, { disabled: disabledSendToken, onClick: function onClick(event) {
	                  return _this3.sendEmails(event);
	                }, label: inviteLabel }),
	              confirmationOpen && tokenConfirmationDialog
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_GroupUsers2.default, this.props)
	      );
	    }
	  }]);
	
	  return GroupSettings;
	}(_react.Component);
	
	exports.default = GroupSettings;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupUsers = function (_Component) {
	    _inherits(GroupUsers, _Component);
	
	    function GroupUsers() {
	        _classCallCheck(this, GroupUsers);
	
	        var _this = _possibleConstructorReturn(this, (GroupUsers.__proto__ || Object.getPrototypeOf(GroupUsers)).call(this));
	
	        _this.handleOpen = function (user) {
	            _this.setState({ userRemoveDialog: true, user: user });
	        };
	
	        _this.handleClose = function () {
	            _this.setState({ userRemoveDialog: false, user: null });
	        };
	
	        _this.handleOpenRole = function (user) {
	            _this.setState({ userRoleDialog: true, user: user });
	        };
	
	        _this.handleCloseRole = function () {
	            _this.setState({ userRoleDialog: false, user: null });
	        };
	
	        _this.removeUser = function (id) {
	            _this.handleClose();
	            _this.props.dispatch((0, _actions.removeUser)(id));
	        };
	
	        _this.changeRole = function (user) {
	            _this.handleCloseRole();
	            var newRole = user.role.name.toLowerCase() === 'editor' ? 'basic-user' : 'editor';
	            _this.props.dispatch((0, _actions.updateUser)(user.id, { role: newRole }));
	        };
	
	        _this.renderUser = function (user, index) {
	
	            var userRemoval = void 0;
	            var userRole = void 0;
	
	            if (_this.props.auth.user.id === user.id) {
	                userRemoval = _react2.default.createElement('span', null);
	                userRole = _react2.default.createElement('span', null);
	            } else {
	                userRemoval = _react2.default.createElement(_RaisedButton2.default, { label: 'Remove', onTouchTap: function onTouchTap() {
	                        return _this.handleOpen(user);
	                    } });
	                userRole = _react2.default.createElement(_RaisedButton2.default, { label: 'Change role', onTouchTap: function onTouchTap() {
	                        return _this.handleOpenRole(user);
	                    } });
	            }
	
	            return _react2.default.createElement(
	                'tr',
	                { key: index },
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    user.name,
	                    ' ',
	                    _this.props.auth.user.id === user.id && _react2.default.createElement(
	                        'span',
	                        null,
	                        '(You)'
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    user.email
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    user.role.label
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    userRole
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    userRemoval
	                )
	            );
	        };
	
	        _this.state = {
	            userRemoveDialog: false,
	            userRoleDialog: false
	        };
	        return _this;
	    }
	
	    _createClass(GroupUsers, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.dispatch((0, _actions.fetchGroupUsers)());
	        }
	    }, {
	        key: 'renderRemoveDialog',
	        value: function renderRemoveDialog() {
	            var _this2 = this;
	
	            if (!this.state.userRemoveDialog || this.state.user === null) {
	                return _react2.default.createElement('span', null);
	            }
	
	            var user = this.state.user;
	
	            var actions = [_react2.default.createElement(_FlatButton2.default, { label: 'No, cancel', primary: true, onTouchTap: this.handleClose }), _react2.default.createElement(_FlatButton2.default, { label: 'Yes, remove user', primary: true, onTouchTap: function onTouchTap() {
	                    return _this2.removeUser(user.id);
	                } })];
	
	            return _react2.default.createElement(
	                _Dialog2.default,
	                { actions: actions, modal: false, open: this.state.userRemoveDialog, onRequestClose: this.handleClose },
	                'Are you sure you want to remove this user from the group? This will not delete their account, and they can rejoin with an invitation or valid token.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                ' ',
	                user.name,
	                _react2.default.createElement('br', null),
	                ' ',
	                user.email
	            );
	        }
	    }, {
	        key: 'renderRoleDialog',
	        value: function renderRoleDialog() {
	            var _this3 = this;
	
	            if (!this.state.userRoleDialog || this.state.user === null) {
	                return _react2.default.createElement('span', null);
	            }
	
	            var user = this.state.user;
	
	            var actions = [_react2.default.createElement(_FlatButton2.default, { label: 'No, cancel', primary: true, onTouchTap: this.handleCloseRole }), _react2.default.createElement(_FlatButton2.default, { label: 'Yes, change role', primary: true, onTouchTap: function onTouchTap() {
	                    return _this3.changeRole(user);
	                } })];
	
	            var currentRole = user.role.label;
	            var newRole = user.role.name.toLowerCase() === 'editor' ? 'Basic User' : 'Editor';
	
	            return _react2.default.createElement(
	                _Dialog2.default,
	                { actions: actions, modal: false, open: this.state.userRoleDialog, onRequestClose: this.handleCloseRole },
	                'Are you sure you want to change this users role?',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                ' ',
	                user.name,
	                _react2.default.createElement('br', null),
	                ' ',
	                user.email,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Current role: ',
	                currentRole,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'New role: ',
	                    newRole
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card.Card,
	                    { className: 'card-wide', key: 'group-users' },
	                    _react2.default.createElement(_Card.CardHeader, { title: 'Users' }),
	                    _react2.default.createElement(
	                        _Card.CardText,
	                        null,
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table' },
	                            _react2.default.createElement(
	                                'thead',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Name'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Email'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Role'
	                                    ),
	                                    _react2.default.createElement('th', null),
	                                    _react2.default.createElement('th', null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                this.props.group.users.map(this.renderUser)
	                            )
	                        )
	                    )
	                ),
	                this.renderRemoveDialog(),
	                this.renderRoleDialog()
	            );
	        }
	    }]);
	
	    return GroupUsers;
	}(_react.Component);
	
	exports.default = GroupUsers;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(212);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Login = __webpack_require__(629);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GuestLayout = function (_Component) {
	  _inherits(GuestLayout, _Component);
	
	  function GuestLayout() {
	    _classCallCheck(this, GuestLayout);
	
	    var _this = _possibleConstructorReturn(this, (GuestLayout.__proto__ || Object.getPrototypeOf(GuestLayout)).call(this));
	
	    _this.handleOpen = function () {
	      _this.setState({ open: true });
	    };
	
	    _this.handleClose = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.state = { open: false };
	    return _this;
	  }
	
	  _createClass(GuestLayout, [{
	    key: 'render',
	    value: function render() {
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Cancel',
	        primary: true,
	        onTouchTap: this.handleClose
	      })];
	
	      var style = {
	        maxWidth: '500px',
	        margin: 'auto'
	      };
	
	      var registerClass = window.location.pathname === '/' ? 'is-front' : '';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pronounce-front ' + this.props.classes + ' ' + registerClass },
	          _react2.default.createElement(
	            'div',
	            { id: 'pronounce-front-page' },
	            window.location.pathname !== '/create-account-android' && _react2.default.createElement(
	              'div',
	              { className: 'pronounce-front-header' },
	              window.location.pathname !== '/' && _react2.default.createElement(
	                _Link2.default,
	                { to: '/' },
	                _react2.default.createElement('img', { alt: 'Pronounce Live', role: 'presentation', src: '/PL-logotest.png', width: '200' })
	              ),
	              window.location.pathname === '/' && _react2.default.createElement('span', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  { id: 'register', to: '/register' },
	                  'Have a group token? Register your account here'
	                ),
	                _react2.default.createElement(_RaisedButton2.default, { className: 'login-btn', id: 'login', label: 'Login', onTouchTap: this.handleOpen })
	              ),
	              _react2.default.createElement(
	                _Dialog2.default,
	                {
	                  contentStyle: style,
	                  title: '',
	                  actions: actions,
	                  modal: false,
	                  autoScrollBodyContent: true,
	                  open: this.state.open,
	                  onRequestClose: this.handleClose
	                },
	                _react2.default.createElement(_Login2.default, Object.assign({}, this.props, { handleClose: this.handleClose }))
	              )
	            ),
	            _react2.default.createElement(
	              _reactAddonsCssTransitionGroup2.default,
	              {
	                transitionName: 'example',
	                transitionEnterTimeout: 2500,
	                transitionLeaveTimeout: 2300
	              },
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GuestLayout;
	}(_react.Component);
	
	exports.default = GuestLayout;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _IconMenu = __webpack_require__(88);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _accountCircle = __webpack_require__(490);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	var _openInNew = __webpack_require__(496);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _arrowDropDown = __webpack_require__(208);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _help = __webpack_require__(494);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _herokuJsRuntimeEnv = __webpack_require__(161);
	
	var _herokuJsRuntimeEnv2 = _interopRequireDefault(_herokuJsRuntimeEnv);
	
	var _NotificationBanner = __webpack_require__(634);
	
	var _NotificationBanner2 = _interopRequireDefault(_NotificationBanner);
	
	var _actions = __webpack_require__(20);
	
	var _auth = __webpack_require__(154);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.handleOpenMenu = function () {
	      _this.setState({
	        mainMenuOpen: true
	      });
	    };
	
	    _this.handleOnRequestChange = function (value) {
	      _this.setState({
	        mainMenuOpen: value
	      });
	    };
	
	    _this.triggerHelp = function () {
	      return window.open('http://www.sanako.com/help/pronounce-live', '_blank');
	    };
	
	    _this.state = {
	      mainMenuOpen: false,
	      aboutDialog: false
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'handleLogout',
	    value: function handleLogout(event) {
	      event.preventDefault();
	      this.props.dispatch((0, _actions.logoutUser)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var env = (0, _herokuJsRuntimeEnv2.default)();
	      var auth = this.props.auth;
	
	      if (!auth.isAuthenticated) {
	        return _react2.default.createElement('span', null);
	      }
	
	      _auth2.default.setPermissions(auth.user.permissions);
	      _auth2.default.setRole(auth.user.role);
	
	      var name = void 0;
	      if (auth.user) {
	        name = auth.user.name;
	      }
	
	      var style = {};
	
	      var iconStyle = {
	        color: '#fff'
	
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Close',
	        primary: true,
	        onTouchTap: function onTouchTap() {
	          return _this2.setState({ aboutDialog: false });
	        }
	      })];
	
	      var aboutDialog = _react2.default.createElement(
	        _Dialog2.default,
	        {
	          title: 'About Pronounce Live',
	          actions: actions,
	          modal: false,
	          autoScrollBodyContent: true,
	          open: this.state.aboutDialog,
	          onRequestClose: function onRequestClose() {
	            return _this2.setState({ aboutDialog: false });
	          }
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sanako Pronounce Live is a true online solution for pronunciation practice, no installations or downloads are needed.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Pronounce Live requires the Google Chrome browser.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Build created: ',
	          env.REACT_APP_HEROKU_RELEASE_CREATED_AT
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Build version: ',
	          env.REACT_APP_HEROKU_RELEASE_VERSION
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'About Sanako Corporation'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sanako is the global leader in developing language teaching software and services for the educational sector. We have worked closely with our customers for over 50 years towards a single goal: to enable better comprehension, speaking and communication skills for language learners.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sanako Corporation is a global organization employing professionals on four continents. Our headquarters is located in Finland. Our network of partners worldwide ensures we are always close to our customers.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact Us'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Personal users'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you have any questions, please check our ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'http://www.sanako.com/help/pronounce-live-faq/' },
	            'FAQ'
	          ),
	          ' first.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If the FAQ doesn\'t answer your question, you can contact us at ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:pronouncelive@sanako.com' },
	            'pronouncelive@sanako.com'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Institutions'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Pronounce Live is available for institutions also. You can contact us for more information at:'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:pronouncelive@sanako.com' },
	            'pronouncelive@sanako.com'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Our reseller network around the world is ready to serve you. You can find the complete list of Sanako resellers at:'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'http://www.sanako.com/resellers/' },
	            'http://www.sanako.com/resellers/'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Don\u2019t hesitate to contact us if you cannot find a reseller or you want us to find the most suitable partner for you.'
	        )
	      );
	
	      var links = _react2.default.createElement(
	        'span',
	        { className: 'pronounce-header-user-info' },
	        _react2.default.createElement(
	          'span',
	          { onClick: function onClick() {
	              return _this2.handleOpenMenu();
	            }, className: 'pronounce-header-user-name' },
	          name
	        ),
	        _react2.default.createElement(
	          _IconMenu2.default,
	          {
	            open: this.state.mainMenuOpen,
	            onRequestChange: this.handleOnRequestChange,
	            style: style,
	            iconStyle: iconStyle,
	            iconButtonElement: _react2.default.createElement(
	              _IconButton2.default,
	              null,
	              _react2.default.createElement(_arrowDropDown2.default, null)
	            ),
	            anchorOrigin: { horizontal: 'left', vertical: 'top' },
	            targetOrigin: { horizontal: 'left', vertical: 'top' }
	          },
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'Use Pronounce Live', containerElement: _react2.default.createElement(_Link2.default, { to: '/' }) }),
	          _auth2.default.can('control-group') && _react2.default.createElement(_MenuItem2.default, { primaryText: 'Group Settings', containerElement: _react2.default.createElement(_Link2.default, { to: '/group-settings' }) }),
	          _auth2.default.can('control-group-exercises') && _react2.default.createElement(_MenuItem2.default, { primaryText: 'Exercises', containerElement: _react2.default.createElement(_Link2.default, { to: '/group-settings/exercises' }) }),
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'Account', containerElement: _react2.default.createElement(_Link2.default, { to: '/account' }) }),
	          !auth.user.hasGroup && !auth.user.hasActiveSubscription && _react2.default.createElement(_MenuItem2.default, { primaryText: 'Join Group', containerElement: _react2.default.createElement(_Link2.default, { to: '/account/join-group' }) }),
	          !auth.user.hasGroup && _react2.default.createElement(_MenuItem2.default, { primaryText: 'Subscription', containerElement: _react2.default.createElement(_Link2.default, { to: '/account/subscription' }) }),
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'About', onTouchTap: function onTouchTap() {
	              return _this2.setState({ aboutDialog: true });
	            } }),
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'Help', rightIcon: _react2.default.createElement(_openInNew2.default, null), onTouchTap: function onTouchTap() {
	              return _this2.triggerHelp();
	            } }),
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'Show welcome screen', onTouchTap: function onTouchTap(event) {
	              return _this2.props.showWelcomeScreen();
	            } }),
	          _react2.default.createElement(_MenuItem2.default, { primaryText: 'Log out', onTouchTap: function onTouchTap(event) {
	              return _this2.handleLogout(event);
	            } })
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            onTouchTap: function onTouchTap() {
	              return _this2.triggerHelp();
	            },
	            tooltip: 'Opens external help in a new tab',
	            iconStyle: iconStyle
	          },
	          _react2.default.createElement(_help2.default, null)
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pronounce-header-container' },
	          _react2.default.createElement(
	            _Link2.default,
	            { className: 'pronounce-header-logo-image', to: '/' },
	            _react2.default.createElement('img', { alt: 'Pronounce Live', src: '/logo.png', height: '30' })
	          ),
	          _react2.default.createElement(_NotificationBanner2.default, this.props),
	          links,
	          this.state.aboutDialog && aboutDialog
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _done = __webpack_require__(89);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _Redirect = __webpack_require__(101);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _actions = __webpack_require__(20);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinGroup = function (_Component) {
	  _inherits(JoinGroup, _Component);
	
	  function JoinGroup() {
	    _classCallCheck(this, JoinGroup);
	
	    var _this = _possibleConstructorReturn(this, (JoinGroup.__proto__ || Object.getPrototypeOf(JoinGroup)).call(this));
	
	    _this.handleInput = function (event) {
	      event.preventDefault();
	      var key = _this.tokenInput.getValue().trim();
	      _this.setState({ key: key });
	
	      if (key.length === 10) {
	        _this.props.dispatch((0, _actions.validateToken)({ key: key }));
	      }
	    };
	
	    _this.state = {
	      key: ''
	    };
	    return _this;
	  }
	
	  _createClass(JoinGroup, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	
	      var validToken = this.props.validation.token.isValid;
	      if (validToken) {
	        this.props.dispatch((0, _actions.joinGroup)({ key: this.state.key }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.auth.user.hasGroup) {
	        return _react2.default.createElement(_Redirect2.default, { to: { pathname: '/' } });
	      }
	
	      var joinGroup = this.props.joinGroup;
	      var token = this.props.validation.token;
	
	      var _getErrors = (0, _geterrors2.default)(this.props.validation.token.errors),
	          errorMessages = _getErrors.errorMessages;
	
	      var validToken = this.props.validation.token.isValid;
	      var disabled = !token.hasFetched || !validToken || joinGroup.isFetching;
	
	      var fetchingTokenMessage = this.props.isWaiting.VALIDATE_TOKEN ? 'Validating token...' : '';
	      var tokenError = void 0;
	      var TokenButtonIcon = void 0;
	
	      if (this.state.key.length === 10 && token.hasFetched && !token.isValid) {
	        tokenError = 'Token not valid or the group is full';
	      } else if (this.state.key.length === 10 && token.hasFetched && token.isValid) {
	        TokenButtonIcon = _react2.default.createElement(_done2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'unregistered', key: 'passwordforgot' },
	        _react2.default.createElement(
	          _Card.Card,
	          null,
	          _react2.default.createElement(_Card.CardHeader, { title: 'Join Group' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            'You need a registration token to join a user group. Ask your organization\'s administrator if you don\'t have one.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'pronounce-login' },
	              _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(_TextField2.default, { autoFocus: true, onChange: this.handleInput, ref: function ref(input) {
	                    _this2.tokenInput = input;
	                  }, errorText: tokenError, type: 'text', name: 'token', placeholder: 'Token', value: this.state.token }),
	                _react2.default.createElement('br', null),
	                fetchingTokenMessage,
	                _react2.default.createElement(_FlatButton2.default, { type: 'submit', disabled: disabled, icon: TokenButtonIcon, onClick: function onClick(event) {
	                    return _this2.handleClick(event);
	                  }, label: 'Join Group' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            errorMessages.map(function (error) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  error
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return JoinGroup;
	}(_react.Component);
	
	exports.default = JoinGroup;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Requirements = __webpack_require__(245);
	
	var _Requirements2 = _interopRequireDefault(_Requirements);
	
	var _SingleUserRegistrationAndroid = __webpack_require__(646);
	
	var _SingleUserRegistrationAndroid2 = _interopRequireDefault(_SingleUserRegistrationAndroid);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingPage = function (_Component) {
	  _inherits(LandingPage, _Component);
	
	  function LandingPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LandingPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LandingPage.__proto__ || Object.getPrototypeOf(LandingPage)).call.apply(_ref, [this].concat(args))), _this), _this.scrollTo = function (el) {
	      switch (el) {
	        case "registration":
	          _this.singleUserSection.scrollIntoView({
	            block: "start",
	            behavior: "smooth"
	          });
	          break;
	        case "promo":
	          _this.promoSection.scrollIntoView({
	            block: "start",
	            behavior: "smooth"
	          });
	          break;
	        default:
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LandingPage, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "landing-page android" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "promo-content middark",
	            ref: function ref(el) {
	              _this2.promoSection = el;
	            }
	          },
	          _react2.default.createElement("img", { src: "/white-logo.png", width: "200" }),
	          _react2.default.createElement(
	            "div",
	            { className: "section middark" },
	            _react2.default.createElement(
	              "div",
	              { className: "half-section" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Unfortunately we do not offer customer subscriptions for Pronounce Live anymore. If you are interested in having a school, please ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "mailto:info@sanako.com" },
	                  "contact us"
	                ),
	                "."
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LandingPage;
	}(_react.Component);
	
	exports.default = LandingPage;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	__webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint class-methods-use-this: "off"  */
	
	var LanguageMenu = function (_React$Component) {
	  _inherits(LanguageMenu, _React$Component);
	
	  function LanguageMenu() {
	    _classCallCheck(this, LanguageMenu);
	
	    return _possibleConstructorReturn(this, (LanguageMenu.__proto__ || Object.getPrototypeOf(LanguageMenu)).apply(this, arguments));
	  }
	
	  _createClass(LanguageMenu, [{
	    key: 'renderVoiceOption',
	    value: function renderVoiceOption(voice, index) {
	      return _react2.default.createElement(_MenuItem2.default, { className: 'menu-language-option', key: index, value: index, label: voice.languageName, primaryText: voice.languageName + ' - ' + voice.voice.name });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isActive = this.props.isStopped();
	
	      return _react2.default.createElement(
	        _SelectField2.default,
	        {
	          id: 'pronounce-language-menu',
	          className: 'pronounce-language-menu',
	          autoWidth: true,
	          disabled: !isActive,
	          value: this.props.activeVoice,
	          onChange: function onChange(e, index, value) {
	            return _this2.props.selectVoice(value);
	          }
	        },
	        this.props.voices.map(this.renderVoiceOption)
	      );
	    }
	  }]);
	
	  return LanguageMenu;
	}(_react2.default.Component);
	
	exports.default = LanguageMenu;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FloatingActionButton = __webpack_require__(128);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	var _stop = __webpack_require__(134);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _playArrow = __webpack_require__(500);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _moreVert = __webpack_require__(209);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _IconMenu = __webpack_require__(88);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyles = {
	  color: '#fff'
	};
	
	function preventHijacking(event) {
	  event.stopPropagation();
	  event.preventDefault();
	}
	
	var ListenRecording = function ListenRecording(props) {
	  if (!props.deviceConfig.supportsRecording || props.config.environment === 'android') {
	    return _react2.default.createElement('span', null);
	  }
	  console.log('listen', props.text.texts[props.text.activeText]);
	  var isActive = (props.isStopped() || props.isPlayingRecording) && props.text.texts.length > 0 && props.text.texts[props.text.activeText].audioBuffer !== null;
	  var label = props.isPlayingRecording ? _react2.default.createElement(_stop2.default, null) : _react2.default.createElement(_playArrow2.default, null);
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _FloatingActionButton2.default,
	      {
	        id: 'play',
	        title: 'Listen to your recording',
	        backgroundColor: '#d52b1e',
	        iconStyle: iconStyles,
	        onClick: props.toggleRecordPlayback,
	        className: 'pronounce-button play-recording',
	        disabled: !isActive
	      },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'listenBlock' },
	      'Play your take',
	      isActive && _react2.default.createElement(_IconMenu2.default, {
	        onClick: preventHijacking,
	        iconButtonElement: _react2.default.createElement(
	          _IconButton2.default,
	          { style: { padding: 0, width: 0, height: 0, marginTop: '-3px' } },
	          _react2.default.createElement(_moreVert2.default, null)
	        ),
	        anchorOrigin: { horizontal: 'left', vertical: 'top' },
	        targetOrigin: { horizontal: 'left', vertical: 'bottom' },
	        listStyle: { paddingTop: 0, paddingBottom: 0, overflow: 'hidden', width: 150 },
	        children: _react2.default.createElement(_MenuItem2.default, { primaryText: 'Download audio', onTouchTap: props.downloadAudio })
	      })
	    )
	  );
	};
	exports.default = ListenRecording;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _languagenames = __webpack_require__(102);
	
	var _languagenames2 = _interopRequireDefault(_languagenames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationBar = function LocationBar(props) {
	  var text = void 0;
	  var languageName = void 0;
	
	  if (props.exercises.activeExercise !== null) {
	    var exercise = props.exercises.exercises[props.exercises.activeExercise];
	    var description = exercise.group_id === null ? 'Personal exercise' : 'Group exercise';
	    languageName = _languagenames2.default[exercise.language] || exercise.language;
	    text = description + ': ' + exercise.name + '.';
	    text += ' (' + languageName + ')';
	
	    if (exercise.mode === 'flipped') {
	      text += ' Flipped mode. Try once before you can listen to the example.';
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pronounce-location' },
	    text
	  );
	};
	
	exports.default = LocationBar;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Card = __webpack_require__(22);
	
	var _Checkbox = __webpack_require__(127);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Divider = __webpack_require__(200);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/no-static-element-interactions: "off", no-restricted-syntax: "off", guard-for-in: "off" */
	
	/*
	 * Login has one responsibility - pass the credentials on to an action creator.
	 *
	 * The UI should reflect state and display error messages to guide the user.
	 *
	 * isFetching - show spinner and disable form
	 *
	 *
	 **/
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this));
	
	    _this.handleCheck = function (event, isChecked) {
	      _this.setState({ remember: isChecked });
	    };
	
	    _this.handleForm = function (event) {
	      event.preventDefault();
	      var state = Object.assign({}, _this.state);
	      state.email = _this.emailInput.getValue();
	      state.password = _this.passwordInput.getValue();
	
	      _this.setState(Object.assign({}, state));
	    };
	
	    _this.state = {
	      email: "",
	      password: "",
	      remember: false
	    };
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var auth = this.props.auth;
	
	
	      if (auth.isAuthenticated === false && nextProps.auth.isAuthenticated === true) {
	        this.setState({ email: "", password: "" });
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      var email = this.state.email.trim();
	      var password = this.state.password.trim();
	      var remember = this.state.remember;
	      var creds = { email: email, password: password, remember: remember };
	      this.props.dispatch((0, _actions.loginUser)(creds));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var auth = this.props.auth;
	
	      var disabled = auth.isFetching;
	      var submitDisabled = this.state.email.length < 4 || this.state.password.length < 6;
	
	      var _getErrors = (0, _geterrors2.default)(auth.errors),
	          errorMessages = _getErrors.errorMessages,
	          validationErrors = _getErrors.validationErrors;
	
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	      var passwordErrorMessage = _apierrors2.default[validationErrors.password] || validationErrors.password;
	
	      var label = auth.isFetching ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : "Login";
	      return _react2.default.createElement(
	        _Card.Card,
	        { key: "login" },
	        _react2.default.createElement(_Card.CardHeader, { title: "Login to Pronounce Live" }),
	        _react2.default.createElement(
	          "div",
	          { className: "pronounce-login" },
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              "form",
	              { onSubmit: function onSubmit(event) {
	                  return _this2.handleClick(event);
	                } },
	              _react2.default.createElement(_TextField2.default, {
	                autoFocus: true,
	                onChange: this.handleForm,
	                disabled: disabled,
	                ref: function ref(input) {
	                  _this2.emailInput = input;
	                },
	                errorText: emailErrorMessage,
	                type: "text",
	                name: "email",
	                placeholder: "email",
	                min: "4",
	                max: "100"
	              }),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(_TextField2.default, {
	                onChange: this.handleForm,
	                disabled: disabled,
	                ref: function ref(input) {
	                  _this2.passwordInput = input;
	                },
	                errorText: passwordErrorMessage,
	                type: "password",
	                name: "password",
	                placeholder: "password",
	                min: "6",
	                max: "100"
	              }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(_Checkbox2.default, {
	                label: "Remember me",
	                checked: this.state.remember,
	                onCheck: this.handleCheck
	              }),
	              _react2.default.createElement(_FlatButton2.default, {
	                type: "submit",
	                disabled: submitDisabled,
	                onClick: function onClick(event) {
	                  return _this2.handleClick(event);
	                },
	                label: label
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            errorMessages.map(function (error, index) {
	              return _react2.default.createElement(
	                "div",
	                { key: index },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  error
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              "span",
	              { onClick: this.props.handleClose },
	              _react2.default.createElement(
	                _Link2.default,
	                { to: "/password/email" },
	                "Forgot password"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          _Card.CardTitle,
	          null,
	          "No account yet? Interested in a subscription?"
	        ),
	        _react2.default.createElement(
	          _Card.CardText,
	          null,
	          "If you have a group token,",
	          " ",
	          _react2.default.createElement(
	            "span",
	            { onClick: this.props.handleClose },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: "/register" },
	              "register here"
	            )
	          ),
	          "."
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	exports.default = Login;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(505);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(506);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	__webpack_require__(330);
	
	var _scoreclass = __webpack_require__(103);
	
	var _scoreclass2 = _interopRequireDefault(_scoreclass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileChapters = function (_React$Component) {
	  _inherits(MobileChapters, _React$Component);
	
	  function MobileChapters() {
	    _classCallCheck(this, MobileChapters);
	
	    return _possibleConstructorReturn(this, (MobileChapters.__proto__ || Object.getPrototypeOf(MobileChapters)).apply(this, arguments));
	  }
	
	  _createClass(MobileChapters, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.activeText !== prevProps.activeText) {
	        if (this.activeListItem) {
	          this.activeListItem.scrollIntoView();
	        }
	      }
	    }
	
	    /* We want to display the *highest* score in the navigation, not the *latest* one.
	    * The score const below will search through the array and return the highest score,
	    * which will be used to decide the element class.
	    */
	
	  }, {
	    key: 'renderSelector',
	    value: function renderSelector(key, index) {
	      var _this2 = this;
	
	      if (this.props.texts.length <= 1) {
	        return _react2.default.createElement('span', { key: index });
	      }
	
	      var tries = key.results.length;
	      var active = this.props.activeText === index;
	      var scoreArray = key.results.map(function (result) {
	        return parseInt(result.score, 10);
	      });
	      var score = parseInt(Math.max.apply(Math, _toConsumableArray(scoreArray)), 10);
	      var scoreClass = (0, _scoreclass2.default)(score, tries);
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: active ? 'active' : '',
	          key: index,
	          title: 'You have tried this ' + tries + ' times',
	          ref: function ref(li) {
	            if (active) _this2.activeListItem = li;
	          }
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            disabled: !this.props.isStopped(),
	            onClick: function onClick() {
	              return _this2.props.dispatch(_this2.props.selectText(index));
	            }
	          },
	          index + 1
	        ),
	        _react2.default.createElement('div', { className: 'progress-indicator ' + scoreClass })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var active = this.props.activeText;
	      var disabled = !this.props.isStopped() || this.props.texts.length === 0;
	
	      var disabledPrev = disabled || active === 0;
	      var disabledNext = disabled || this.props.texts.length - 1 === active;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-chapters' },
	        _react2.default.createElement(
	          _IconButton2.default,
	          { className: 'mobile-prev', onClick: function onClick() {
	              return _this3.props.dispatch(_this3.props.prev());
	            }, disabled: disabledPrev },
	          _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement(
	          'ul',
	          { ref: function ref(ul) {
	              _this3.list = ul;
	            } },
	          this.props.texts.map(function (key, index) {
	            return _this3.renderSelector(key, index);
	          })
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          { className: 'mobile-next', onClick: function onClick() {
	              return _this3.props.dispatch(_this3.props.next());
	            }, disabled: disabledNext },
	          _react2.default.createElement(_chevronRight2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return MobileChapters;
	}(_react2.default.Component);
	
	exports.default = MobileChapters;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModifyExercise = function (_Component) {
	  _inherits(ModifyExercise, _Component);
	
	  function ModifyExercise(props) {
	    _classCallCheck(this, ModifyExercise);
	
	    var _this = _possibleConstructorReturn(this, (ModifyExercise.__proto__ || Object.getPrototypeOf(ModifyExercise)).call(this));
	
	    _this.handleOpen = function () {
	      _this.setState({ modifyExerciseDialog: true });
	    };
	
	    _this.handleClose = function () {
	      _this.setState({ modifyExerciseDialog: false });
	    };
	
	    _this.handleLanguageChange = function (event, index, language) {
	      return _this.setState({ language: language });
	    };
	
	    _this.handleMode = function (event, index, mode) {
	      return _this.setState({ mode: mode });
	    };
	
	    _this.handleInput = function (event) {
	      _this.setState({ name: event.target.value });
	    };
	
	    _this.handleTextarea = function (event) {
	      _this.setState({ text: event.target.value });
	    };
	
	    _this.state = {
	      name: props.exercise.name,
	      language: props.exercise.language,
	      text: props.exercise.text,
	      mode: props.exercise.mode,
	      modifyExerciseDialog: false
	    };
	    return _this;
	  }
	
	  _createClass(ModifyExercise, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.exercises.hasUpdated && nextProps.exercises.hasUpdated) {
	        this.setState({ modifyExerciseDialog: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          name = _state.name,
	          language = _state.language,
	          text = _state.text,
	          mode = _state.mode;
	
	      var id = this.props.exercise.id;
	
	      var stats = {
	        length: this.state.text.length,
	        words: this.state.text.length === 0 ? this.state.text.split(' ').length - 1 : this.state.text.split(' ').length
	      };
	
	      var updateLabel = this.props.isWaiting ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : 'Update exercise';
	
	      var _getErrors = (0, _geterrors2.default)(this.props.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var textErrorMessage = _apierrors2.default[validationErrors.text] || validationErrors.text;
	
	      var validSettings = this.state.name.length > 0 && this.state.text.length > 0;
	
	      var disabled = !validSettings || this.props.disabledModify;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        disabled: this.props.disabledModify,
	        label: 'Cancel',
	        primary: true,
	        onTouchTap: this.handleClose
	      }), _react2.default.createElement(_FlatButton2.default, {
	        disabled: disabled,
	        label: updateLabel,
	        primary: true,
	        onTouchTap: function onTouchTap() {
	          return _this2.props.save(id, { name: name, language: language, text: text, mode: mode });
	        }
	      })];
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_RaisedButton2.default, { label: 'Edit', onTouchTap: this.handleOpen }),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            actions: actions,
	            modal: false,
	            open: this.state.modifyExerciseDialog,
	            onRequestClose: this.handleClose
	          },
	          _react2.default.createElement(
	            'form',
	            null,
	            _react2.default.createElement(_TextField2.default, { onChange: this.handleInput, ref: function ref(input) {
	                _this2.exerciseName = input;
	              }, errorText: nameErrorMessage, type: 'text', name: 'name', floatingLabelText: 'Exercise name', value: this.state.name }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _SelectField2.default,
	              {
	                floatingLabelText: 'Language',
	                value: this.state.language,
	                onChange: this.handleLanguageChange
	              },
	              _react2.default.createElement(_MenuItem2.default, { value: 'en-GB', primaryText: 'English (UK)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'en-US', primaryText: 'English (US)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'en-IN', primaryText: 'English (Indian)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'de-DE', primaryText: 'German' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'es-ES', primaryText: 'Spanish' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'es-US', primaryText: 'Spanish (US)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'fr-FR', primaryText: 'French' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'hi-IN', primaryText: 'Hindi' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'id-ID', primaryText: 'Indonesian' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'it-IT', primaryText: 'Italian' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'ja-JP', primaryText: 'Japanese' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'ko-KR', primaryText: 'Korean' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'nl-NL', primaryText: 'Dutch' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'pl-PL', primaryText: 'Polish' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'pt-BR', primaryText: 'Portuguese (Brazil)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'ru-RU', primaryText: 'Russian' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'zh-CN', primaryText: 'Chinese' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'zh-TW', primaryText: 'Chinese (Taiwan)' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'zh-HK', primaryText: 'Chinese (Hong Kong)' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _SelectField2.default,
	              {
	                floatingLabelText: 'Mode',
	                value: this.state.mode,
	                onChange: this.handleMode
	              },
	              _react2.default.createElement(_MenuItem2.default, { value: 'normal', primaryText: 'Normal' }),
	              _react2.default.createElement(_MenuItem2.default, { value: 'flipped', primaryText: 'Flipped' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('textarea', { className: 'pronounce-exercise-text', value: this.state.text, onChange: this.handleTextarea }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              stats.length,
	              ' characters - ',
	              stats.words,
	              ' words'
	            ),
	            textErrorMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModifyExercise;
	}(_react.Component);
	
	exports.default = ModifyExercise;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Card = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoAuthorization = function NoAuthorization(props) {
	  var style = {
	    margin: 'auto'
	  };
	
	  var userText = void 0;
	
	  var btnStyle = {
	    color: '#fff'
	  };
	
	  if (props.user.role === 'basic-user') {
	    userText = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/account/subscription' },
	            'subscribe'
	          )
	        ),
	        ' to Pronounce Live to gain access.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Or, if your organization has access, ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/account/join-group' },
	            'join'
	          )
	        ),
	        ' its Pronounce Live group.'
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _Card.Card,
	    { style: style },
	    _react2.default.createElement(_Card.CardHeader, { title: 'Sorry, you have no access to Pronounce Live' }),
	    _react2.default.createElement(
	      _Card.CardText,
	      null,
	      userText
	    )
	  );
	};
	
	exports.default = NoAuthorization;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotSupported = function NotSupported() {
	  return _react2.default.createElement(
	    "div",
	    { className: "pronounce" },
	    "Sorry, your browser does not support speech synthesis or speech",
	    _react2.default.createElement(
	      "a",
	      { href: "https://www.google.com/chrome", target: "_blank", rel: "noopener noreferrer" },
	      "Google Chrome"
	    ),
	    "."
	  );
	};
	
	exports.default = NotSupported;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationBanner = function NotificationBanner(props) {
	
	  var auth = props.auth;
	  var message = void 0;
	
	  if (!auth.user.onGenericTrial) {
	    return _react2.default.createElement('span', null);
	  }
	
	  if (!auth.user.hasActiveSubscription && auth.user.onGenericTrial && props.subscriptions.info.untilTrialEnds) {
	    message = _react2.default.createElement(
	      'span',
	      null,
	      'You have ',
	      props.subscriptions.info.untilTrialEnds,
	      ' left of your trial period -\xA0',
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/account/subscription' },
	        ' subscribe here '
	      ),
	      '\xA0 to get access to Pronounce Live after that!'
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pronounce-notification-banner' },
	    message
	  );
	};
	
	exports.default = NotificationBanner;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Notifications = function Notifications(props) {
	  var error = void 0;
	  var micNote = void 0;
	  var versionNote = void 0;
	  var isChrome = navigator.userAgent.match(/Chrome\/(\S+)/);
	  var version = void 0;
	
	  if (props.config.environment === 'desktop' && props.deviceConfig.supportsRecording && !props.deviceConfig.allowsRecording) {
	    micNote = _react2.default.createElement(
	      'div',
	      null,
	      'Please give the browser a permission to use your microphone.'
	    );
	  }
	
	  if (isChrome) {
	    version = isChrome[1].substring(0, isChrome[1].indexOf('.'));
	
	    if (version < 53) {
	      versionNote = _react2.default.createElement(
	        'div',
	        null,
	        'You are using Chrome ',
	        version,
	        ', which is outdated. Please update your browser to use Pronounce Live.'
	      );
	    }
	  }
	
	  if (props.errorMessage) {
	    error = _react2.default.createElement(
	      'div',
	      null,
	      props.errorMessage
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pronounce-notifications' },
	    error,
	    micNote,
	    versionNote
	  );
	};
	
	exports.default = Notifications;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FloatingActionButton = __webpack_require__(128);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	var _volumeUp = __webpack_require__(501);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _stop = __webpack_require__(134);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _moreVert = __webpack_require__(209);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _IconMenu = __webpack_require__(88);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _RateSlider = __webpack_require__(244);
	
	var _RateSlider2 = _interopRequireDefault(_RateSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyles = {
	  color: '#fff'
	};
	
	var PlayExample = function PlayExample(props) {
	  if (!props.deviceConfig.supportsTTS) {
	    return _react2.default.createElement('span', null);
	  }
	
	  var disabled = props.mode === 'flipped' && props.text.texts[props.text.activeText].results.length === 0;
	
	  console.log(disabled);
	  console.log(props.mode);
	  console.log(props.text.texts[props.text.activeText].results.length);
	
	  var isActive = (props.isStopped() || props.isPlayingExample) && props.text.texts.length > 0 && props.text.texts[props.text.activeText].source.length > 0 && props.voices.length > 0 && !disabled;
	
	  var label = props.isPlayingExample ? _react2.default.createElement(_stop2.default, null) : _react2.default.createElement(_volumeUp2.default, null);
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _FloatingActionButton2.default,
	      {
	        id: 'listen',
	        title: 'Listen example',
	        backgroundColor: '#d52b1e',
	        iconStyle: iconStyles,
	        onClick: props.togglePlayExample,
	        disabled: !isActive
	      },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'listenBlock' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Listen'
	      ),
	      _react2.default.createElement(_IconMenu2.default, {
	        iconButtonElement: _react2.default.createElement(
	          _IconButton2.default,
	          { style: { padding: 0, width: 0, height: 0, marginTop: '-3px' } },
	          _react2.default.createElement(_moreVert2.default, null)
	        ),
	        anchorOrigin: { horizontal: 'left', vertical: 'top' },
	        targetOrigin: { horizontal: 'left', vertical: 'bottom' },
	        listStyle: { paddingTop: 0, paddingBottom: 0, overflow: 'hidden', width: 150 },
	        children: _react2.default.createElement(_RateSlider2.default, { isStopped: props.isStopped, rate: props.rate, setRate: props.setRate })
	      })
	    )
	  );
	};
	
	exports.default = PlayExample;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Privacy = function Privacy() {
	  return _react2.default.createElement(
	    _Card.Card,
	    { className: 'unregistered' },
	    _react2.default.createElement(_Card.CardHeader, { title: 'Privacy Policy' }),
	    _react2.default.createElement(
	      _Card.CardText,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Last updated: 10.04.2017'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sanako ("us", "we", or "our") operates https://www.pronouncelive.com (the "Service"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Service.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We use your Personal Information only for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Information Collection And Use'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'While using our Service, we ask you to provide us with personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name and email ("Personal Information").'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We do not share your Personal Information to third parties.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Log Data'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Like many site operators, we collect information that your browser sends whenever you visit our Service ("Log Data").'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This Log Data may include information such as your computer\'s Internet Protocol ("IP") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Communications'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We may use your Personal Information to contact you with marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Cookies'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer\'s hard drive.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Like many sites, we use cookies to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Security'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Changes To This Privacy Policy'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This Privacy Policy is effective as of 26.9.2016 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you have any questions about this Privacy Policy, please contact us.'
	      )
	    )
	  );
	};
	
	exports.default = Privacy;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LanguageMenu = __webpack_require__(626);
	
	var _LanguageMenu2 = _interopRequireDefault(_LanguageMenu);
	
	var _PronounceMenu = __webpack_require__(639);
	
	var _PronounceMenu2 = _interopRequireDefault(_PronounceMenu);
	
	var _MobileChapters = __webpack_require__(630);
	
	var _MobileChapters2 = _interopRequireDefault(_MobileChapters);
	
	var _TTSInput = __webpack_require__(649);
	
	var _TTSInput2 = _interopRequireDefault(_TTSInput);
	
	var _Controls = __webpack_require__(615);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _NotSupported = __webpack_require__(633);
	
	var _NotSupported2 = _interopRequireDefault(_NotSupported);
	
	var _Notifications = __webpack_require__(635);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _LocationBar = __webpack_require__(628);
	
	var _LocationBar2 = _interopRequireDefault(_LocationBar);
	
	var _Translation = __webpack_require__(651);
	
	var _Translation2 = _interopRequireDefault(_Translation);
	
	var _supports = __webpack_require__(661);
	
	var _supports2 = _interopRequireDefault(_supports);
	
	var _audio = __webpack_require__(248);
	
	var _speechrecognition = __webpack_require__(660);
	
	var _speechrecognition2 = _interopRequireDefault(_speechrecognition);
	
	var _recorderplayer = __webpack_require__(658);
	
	var _recorderplayer2 = _interopRequireDefault(_recorderplayer);
	
	var _fileSaver = __webpack_require__(358);
	
	__webpack_require__(336);
	
	var _actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint class-methods-use-this: "off", max-len: "off", no-console: "off" */
	
	var lamejs = __webpack_require__(413);
	
	var Pronounce = function (_Component) {
	  _inherits(Pronounce, _Component);
	
	  function Pronounce(props) {
	    _classCallCheck(this, Pronounce);
	
	    var _this = _possibleConstructorReturn(this, (Pronounce.__proto__ || Object.getPrototypeOf(Pronounce)).call(this, props));
	
	    _this.openIntroductoryExercise = function () {
	      console.log('open intro');
	      var introExercise = _this.findExerciseByName('Introductory Exercise');
	
	      if (introExercise) {
	        _this.launchExercise(introExercise.originalIndex);
	      }
	    };
	
	    _this.findExerciseByName = function (name) {
	      console.log('find byname');
	      var exerciseByName = null;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _this.props.exercises.exercises[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var exercise = _step.value;
	
	          if (exercise.name.toLowerCase() === name.toLowerCase()) {
	            exerciseByName = exercise;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return exerciseByName;
	    };
	
	    _this.logPlayExample = function () {
	      _this.setState({
	        player: Object.assign({}, _this.state.player, { startedRecording: performance.now() })
	      });
	    };
	
	    _this.logPlayExampleStop = function () {
	      var utteranceLength = performance.now() - _this.state.player.startedRecording;
	
	      _this.props.dispatch((0, _actions.setUtteranceLength)(utteranceLength));
	      _this.setState({
	        player: Object.assign({}, _this.state.player, {
	          isPlayingExample: false,
	          startedRecording: null
	        })
	      });
	    };
	
	    _this.logPlayExampleError = function (error) {
	      console.error(error);
	      _this.setState({
	        player: Object.assign({}, _this.state.player, {
	          isPlayingExample: false,
	          startedRecording: null
	        })
	      });
	    };
	
	    _this.togglePlayExample = function () {
	      _this.resetErrors();
	      if (_this.isStopped()) {
	        _this.setState({
	          player: Object.assign({}, _this.state.player, { isPlayingExample: true })
	        });
	
	        var isAndroid = _this.props.config.environment === 'android';
	
	        _audio.Speak.speak(_this.props.text.texts[_this.props.text.activeText].source, _this.state.ttsLanguage, _this.state.voices[_this.state.activeVoice], isAndroid, _this.logPlayExample, _this.logPlayExampleStop, _this.logPlayExampleError, _this.state.ttsRate);
	      } else if (_this.state.player.isPlayingExample) {
	        // If the user stops the example (instead of letting it play in whole),
	        // reset startedRecording. Otherwise a misleading length is used to decide
	        // when to pause recording automatically.
	        _this.setState({
	          player: Object.assign({}, _this.state.player, {
	            isPlayingExample: false,
	            startedRecording: null
	          })
	        });
	        _audio.Speak.cancel();
	      }
	    };
	
	    _this.record = function () {
	      _this.resetErrors();
	      if (_this.isStopped()) {
	        var recID = null;
	        var length = _this.props.text.texts[_this.props.text.activeText].utteranceLength || 20000;
	
	        var recLength = length * 2;
	        var stopAt = performance.now() + recLength;
	
	        // We're using requestAnimationFrame to test whether the recording should be stopped or not.
	        // Note that if the tab is inactive, different browsers behave differently. Chrome
	        // only calls requestAnimationFrame the next time the tab is active,
	        // which could lead into funny situations.
	        var step = function step(timestamp) {
	          if (_this.state.player.activeRecordingID === null) {
	            return;
	          }
	          if (timestamp < stopAt) {
	            window.requestAnimationFrame(step);
	          } else {
	            _this.stop();
	          }
	        };
	
	        recID = window.requestAnimationFrame(step);
	        var newState = Object.assign({}, _this.state);
	        newState.player.isRecording = true;
	        newState.player.activeRecordingID = recID;
	        _this.setState(Object.assign({}, newState));
	
	        if (_this.props.config.environment !== 'android') {
	          _recorderplayer2.default.startRecording(_this.setRecording);
	        }
	        if (_this.state.deviceConfig.supportsSpeechRecognition) {
	          _this.startRecognizing();
	        }
	      } else {
	        _this.stop();
	      }
	    };
	
	    _this.stop = function () {
	      if (_this.isStopped()) {
	        return;
	      }
	
	      if (_this.state.player.activeRecordingID !== null) {
	        window.cancelAnimationFrame(_this.state.player.activeRecordingID);
	      }
	      var newState = Object.assign({}, _this.state);
	      newState.player.isRecording = false;
	      newState.player.activeRecordingID = null;
	      _this.setState(Object.assign({}, newState));
	
	      if (_this.props.config.environment !== 'android') {
	        _recorderplayer2.default.stopRecording();
	      }
	      if (_this.state.deviceConfig.supportsSpeechRecognition) {
	        _this.stopRecognizing();
	      }
	    };
	
	    _this.toggleRecordPlayback = function () {
	      if (_this.state.player.isPlayingRecording === true) {
	        _this.stopPlayingRecording();
	      } else {
	        _this.playRecording();
	      }
	    };
	
	    _this.playRecording = function () {
	      if (_this.isStopped()) {
	        var audioBuffer = _this.props.text.texts[_this.props.text.activeText].audioBuffer;
	        if (_this.props.config.environment !== 'android') {
	          _recorderplayer2.default.play(audioBuffer, _this.stopPlayingRecording);
	        }
	
	        var newState = Object.assign({}, _this.state);
	        newState.player.isPlayingRecording = true;
	        _this.setState(Object.assign({}, newState));
	      }
	    };
	
	    _this.stopPlayingRecording = function () {
	      if (_this.state.player.isPlayingRecording === true) {
	        if (_this.props.config.environment !== 'android') _recorderplayer2.default.stop();
	        var newState = Object.assign({}, _this.state);
	        newState.player.isPlayingRecording = false;
	        _this.setState(Object.assign({}, newState));
	      }
	    };
	
	    _this.resetErrors = function () {
	      _this.setState({ player: Object.assign({}, _this.state.player, { errorMessage: '' }) });
	    };
	
	    _this.startRecognizing = function () {
	      _this.resetErrors();
	      _speechrecognition2.default.setOnEndCallback(_this.handleSpeechRecEnd);
	      _speechrecognition2.default.setOnErrorCallback(_this.handleSpeechRecError);
	      _speechrecognition2.default.start(_this.state.language);
	    };
	
	    _this.stopRecognizing = function () {
	      _speechrecognition2.default.stop();
	    };
	
	    _this.handleSpeechRecError = function (error) {
	      var message = void 0;
	
	      if (error === 'network') {
	        message = 'Network is down - please check your connection';
	      } else if (error === 'audio-capture') {
	        message = 'Something is wrong with the audio capture - please check your microphone';
	      }
	      _this.setState({ player: Object.assign({}, _this.state.player, { errorMessage: message }) });
	      _this.stop();
	    };
	
	    _this.setRecording = function (buffer, originalFloat32ArrayBuffers) {
	      _this.props.dispatch((0, _actions.setRecording)(buffer, originalFloat32ArrayBuffers));
	    };
	
	    _this.isStopped = function () {
	      return !_this.state.player.isPlayingExample && !_this.state.player.isRecording && !_this.state.player.isPlayingRecording;
	    };
	
	    _this.selectVoice = function (index) {
	      var lang = _this.state.voices[index].lang;
	      var ttsLang = _this.state.voices[index].ttsLang || lang;
	      _this.setState({ language: lang, ttsLanguage: ttsLang, activeVoice: index });
	
	      window.pronounceConfig.lang = lang;
	    };
	
	    _this.setRate = function (rate) {
	      _this.setState({ ttsRate: rate });
	    };
	
	    _this.selectVoiceByLanguage = function (lang) {
	      var index = 0;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = _this.state.voices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var voice = _step2.value;
	
	          console.log(voice);
	          if (voice.lang.toLowerCase() === lang.toLowerCase()) {
	            console.log('FOUND VOICe');
	            _this.selectVoice(index);
	            break;
	          }
	          index += 1;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    };
	
	    _this.updateVoices = function () {
	      var voices = (0, _audio.getVoices)();
	      _this.setState({ voices: voices });
	    };
	
	    _this.updateMicrophonePermission = function (permission) {
	      var deviceConfig = Object.assign({}, _this.state.deviceConfig);
	      deviceConfig.allowsRecording = permission;
	      _this.setState({ deviceConfig: deviceConfig });
	    };
	
	    _this.askMicrophonePermission = function () {
	      _recorderplayer2.default.setup(_this.updateMicrophonePermission);
	    };
	
	    _this.handleSpeechRecEnd = function () {
	      var results = _speechrecognition2.default.getResults();
	      if (results.result !== null) {
	        _this.props.dispatch((0, _actions.addResults)(results));
	        _this.props.dispatch((0, _actions.addHistory)({
	          text: _this.props.text.texts[_this.props.text.activeText].source,
	          results: results,
	          language: _this.state.language
	        }));
	      }
	      _speechrecognition2.default.reset();
	    };
	
	    _this.launchExercise = function (index) {
	      if (_this.props.exercises.exercises[index]) {
	        _this.selectVoiceByLanguage(_this.props.exercises.exercises[index].language);
	        _this.props.dispatch((0, _actions.launchExercise)(index));
	        _this.props.dispatch((0, _actions.launchText)(_this.props.exercises.exercises[index].text));
	      }
	    };
	
	    _this.saveExercise = function () {};
	
	    _this.clearExercise = function () {
	      _this.props.dispatch((0, _actions.clearExercise)());
	      _this.props.dispatch((0, _actions.clearText)());
	    };
	
	    _this.floatTo16BitPCM = function (input, output) {
	      for (var i = 0; i < input.length; i++) {
	        var s = Math.max(-1, Math.min(1, input[i]));
	        output[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
	      }
	    };
	
	    _this.convertBuffer = function (float32Array) {
	      var data = new Float32Array(float32Array);
	      var out = new Int16Array(float32Array.length);
	      _this.floatTo16BitPCM(data, out);
	      return out;
	    };
	
	    _this.downloadAudio = function (event) {
	      event.stopPropagation();
	      event.preventDefault();
	
	      var audioBuffer = _this.props.text.texts[_this.props.text.activeText].audioBuffer;
	      var float32ArrayBuffers = _this.props.text.texts[_this.props.text.activeText].float32ArrayBuffers;
	      var mp3Data = [];
	
	      var mp3encoder = new lamejs.Mp3Encoder(1, audioBuffer.sampleRate, 96); // mono 44.1khz encode to 128kbps
	      var samples = _this.convertBuffer(float32ArrayBuffers[0]);
	      var mp3Tmp = mp3encoder.encodeBuffer(samples); // encode mp3
	
	      // Push encode buffer to mp3Data variable
	      mp3Data.push(mp3Tmp);
	
	      // Get end part of mp3
	      mp3Tmp = mp3encoder.flush();
	
	      // Write last data to the output data, too
	      // mp3Data contains now the complete mp3Data
	      mp3Data.push(mp3Tmp);
	
	      var blob = new Blob(mp3Data, { type: 'audio/mpeg' });
	
	      var exercise = _this.props.exercises.activeExercise !== null ? _this.props.exercises.exercises[_this.props.exercises.activeExercise] : null;
	
	      var name = exercise ? exercise.name : 'no-exercise';
	
	      name = name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
	
	      var filename = 'pronounce-live-' + name + '-phrase-' + _this.props.text.activeText + '.mp3';
	
	      (0, _fileSaver.saveAs)(blob, filename);
	    };
	
	    _this.state = {
	      deviceConfig: {
	        supportsRecording: _supports2.default.recording(),
	        allowsRecording: false,
	        supportsTTS: _supports2.default.tts(),
	        supportsSpeechRecognition: _supports2.default.speechRecognition()
	      },
	      player: {
	        isPlayingExample: false,
	        isRecording: false,
	        isPlayingRecording: false,
	        startedRecording: null,
	        activeRecordingID: null,
	        errorMessage: ''
	      },
	      language: 'en-GB',
	      mode: 'normal',
	      ttsLanguage: 'en-GB',
	      ttsRate: 1.0,
	      activeVoice: 1,
	      voices: [],
	      initialLanguageLoaded: false,
	      introExerciseOpened: false
	    };
	    return _this;
	  }
	
	  _createClass(Pronounce, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateVoices();
	
	      if (this.state.deviceConfig.supportsRecording && this.props.config.environment !== 'android') {
	        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	        _recorderplayer2.default.init(this.audioContext, this.updateMicrophonePermission);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.standAlone === false) {
	        this.props.dispatch((0, _actions.fetchExercises)());
	      }
	      // getVoices on speechSynthesis will return an empty array if called too early.
	      // This hooks into SpeechSynthesis' onchange event for voices.
	      (0, _audio.onvoiceschanged)(this.updateVoices);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.voices.length > 0 && !this.state.initialLanguageLoaded) {
	        this.selectVoiceByLanguage('en-GB');
	        this.setState({ initialLanguageLoaded: true });
	      }
	
	      if (prevProps.exercises.isFetching === true && this.props.exercises.isFetching === false && !this.state.introExerciseOpened && this.props.openIntro && this.props.exercises.exercises.length > 0) {
	        this.openIntroductoryExercise();
	        this.setState({
	          introExerciseOpened: true
	        });
	      }
	
	      // If the exercise was updated, relaunch it. It won't be updated automatically,
	      // since we're actually dealing with a local and modified copy of the exercise.
	      if (prevProps.exercises.isFetching === true && prevProps.exercises.hasUpdated === false && this.props.exercises.hasUpdated === true) {
	        if (prevProps.exercises.activeExercise !== null) {
	          this.launchExercise(this.props.exercises.activeExercise);
	        }
	      }
	
	      // If there's a new exercise, we want to open it automatically. We can compare
	      // the exercise arrays in current and previous props, and deduce the new exercise from that.
	      // This works for any order the API will return the exercises.
	      if (prevProps.exercises.hasSaved === false && this.props.exercises.hasSaved === true && prevProps.exercises.exercises.length + 1 === this.props.exercises.exercises.length) {
	        var oldExercises = [].concat(_toConsumableArray(prevProps.exercises.exercises));
	        var newExercises = [].concat(_toConsumableArray(this.props.exercises.exercises));
	
	        var difference = newExercises.filter(function (x) {
	          var filtered = oldExercises.filter(function (y) {
	            return y.id === x.id;
	          });
	          return filtered.length === 0;
	        });
	
	        if (difference.length === 1) {
	          this.launchExercise(difference[0].originalIndex);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // The AudioContext needs to be closed on unmount. Otherwise re-rendering
	      // this element will create a new AudioContext everytime, and there's a
	      // maximum for how many there can be.
	      this.audioContext.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var config = this.state.deviceConfig;
	
	      var mode = 'normal';
	      var exercise = null;
	
	      if (this.props.exercises.activeExercise) {
	        exercise = this.props.exercises.exercises[this.props.exercises.activeExercise];
	
	        if (exercise.mode) {
	          mode = exercise.mode;
	        }
	      }
	
	      if (!config.supportsTTS || !config.supportsSpeechRecognition) {
	        return _react2.default.createElement(_NotSupported2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-module' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pronounce-toolbar' },
	          _react2.default.createElement(_LanguageMenu2.default, {
	            activeVoice: this.state.activeVoice,
	            voices: this.state.voices,
	            selectVoice: this.selectVoice,
	            isStopped: this.isStopped
	          }),
	          _react2.default.createElement(_PronounceMenu2.default, {
	            auth: this.props.auth,
	            language: this.state.language,
	            text: this.props.text,
	            isWaiting: this.props.isWaiting,
	            standAlone: this.props.standAlone,
	            dispatch: this.props.dispatch,
	            config: this.state.deviceConfig,
	            isStopped: this.isStopped,
	            exercises: this.props.exercises,
	            voices: this.state.voices,
	            saveExercise: this.saveExercise,
	            launchExercise: this.launchExercise,
	            clearExercise: this.clearExercise,
	            history: this.props.history
	          })
	        ),
	        _react2.default.createElement(_LocationBar2.default, { exercises: this.props.exercises }),
	        _react2.default.createElement(_TTSInput2.default, {
	          auth: this.props.auth,
	          language: this.state.language,
	          mode: mode,
	          clearExercise: this.clearExercise,
	          text: this.props.text,
	          isWaiting: this.props.isWaiting,
	          dispatch: this.props.dispatch,
	          isStopped: this.isStopped,
	          isRecording: this.state.player.isRecording,
	          exercises: this.props.exercises,
	          texts: this.props.text.texts,
	          updateSource: _actions.updateSource,
	          launchText: _actions.launchText,
	          spliceSentence: _actions.spliceSentence
	        }),
	        _react2.default.createElement(_MobileChapters2.default, {
	          dispatch: this.props.dispatch,
	          isStopped: this.isStopped,
	          activeText: this.props.text.activeText,
	          texts: this.props.text.texts,
	          selectText: _actions.selectText,
	          prev: _actions.prevSentence,
	          next: _actions.nextSentence
	        }),
	        _react2.default.createElement(_Notifications2.default, {
	          config: this.props.config,
	          deviceConfig: this.state.deviceConfig,
	          askMicrophonePermission: this.askMicrophonePermission,
	          errorMessage: this.state.player.errorMessage
	        }),
	        _react2.default.createElement(_Controls2.default, {
	          config: this.props.config,
	          deviceConfig: this.state.deviceConfig,
	          isStopped: this.isStopped,
	          voices: this.state.voices,
	          text: this.props.text,
	          mode: mode,
	          togglePlayExample: this.togglePlayExample,
	          isPlayingExample: this.isPlayingExample,
	          record: this.record,
	          isRecording: this.state.player.isRecording,
	          isPlayingRecording: this.state.player.isPlayingRecording,
	          toggleRecordPlayback: this.toggleRecordPlayback,
	          rate: this.state.ttsRate,
	          setRate: this.setRate,
	          downloadAudio: this.downloadAudio
	        }),
	        exercise && exercise.translations && _react2.default.createElement(_Translation2.default, { dispatch: this.props.dispatch, updateTranslation: _actions.updateTranslation, source: this.state.language, text: this.props.text })
	      );
	    }
	  }]);
	
	  return Pronounce;
	}(_react.Component);
	
	exports.default = Pronounce;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tabs = __webpack_require__(468);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _assignment = __webpack_require__(491);
	
	var _assignment2 = _interopRequireDefault(_assignment);
	
	var _list = __webpack_require__(495);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _Report = __webpack_require__(642);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	__webpack_require__(337);
	
	var _languagenames = __webpack_require__(102);
	
	var _languagenames2 = _interopRequireDefault(_languagenames);
	
	var _auth = __webpack_require__(154);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _actions = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PronounceMenu = function (_Component) {
	  _inherits(PronounceMenu, _Component);
	
	  function PronounceMenu(props) {
	    _classCallCheck(this, PronounceMenu);
	
	    var _this = _possibleConstructorReturn(this, (PronounceMenu.__proto__ || Object.getPrototypeOf(PronounceMenu)).call(this, props));
	
	    _this.handleDialogOpen = function () {
	      _this.setState({ open: true });
	    };
	
	    _this.handleDialogClose = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.handleSaveDialogOpen = function () {
	      _this.setState({ saveOpen: true });
	    };
	
	    _this.handleSaveDialogClose = function () {
	      _this.setState({ saveOpen: false });
	    };
	
	    _this.handleReportDialogOpen = function () {
	      _this.setState({ reportOpen: true });
	    };
	
	    _this.handleReportDialogClose = function () {
	      _this.setState({ reportOpen: false });
	    };
	
	    _this.getGroupExercises = function () {
	      return _this.props.exercises.exercises.filter(function (exercise) {
	        return exercise.group_id !== null;
	      });
	    };
	
	    _this.getMyExercises = function () {
	      return _this.props.exercises.exercises.filter(function (exercise) {
	        return exercise.group_id === null;
	      });
	    };
	
	    _this.downloadReport = function () {
	      var logTime = sessionStorage.getItem('pronounce-time-spent');
	      var timeSpent = performance.now() - logTime;
	
	      _this.props.dispatch((0, _actions.downloadReport)({ history: _this.props.history.history, timeSpent: timeSpent }));
	    };
	
	    _this.state = {
	      open: false,
	      saveOpen: false,
	      reportOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(PronounceMenu, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.history.hasFetched === false && this.props.history.hasFetched === true) {
	        var anchorEl = document.createElement('a');
	        anchorEl.setAttribute('target', '_blank');
	        anchorEl.setAttribute('href', this.props.history.reportURL);
	        anchorEl.click();
	      }
	    }
	  }, {
	    key: 'renderExercise',
	    value: function renderExercise(item, index) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'li',
	        { key: 'exercise-' + index },
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: function onClick() {
	              _this2.handleDialogClose();
	              _this2.props.launchExercise(item.originalIndex);
	            }
	          },
	          item.name
	        )
	      );
	    }
	  }, {
	    key: 'renderMenuItem',
	    value: function renderMenuItem(item, index, type) {
	      var _this3 = this;
	
	      var language = _languagenames2.default[item] || item;
	      var exercises = this.props.exercises.exercises;
	
	      var canBeUsed = this.props.voices.filter(function (v) {
	        return v.lang.toLowerCase() === item.toLowerCase();
	      }).length > 0; // eslint-disable-line max-len
	
	      exercises.forEach(function (exercise, exerciseIndex) {
	        exercise.originalIndex = exerciseIndex; // eslint-disable-line no-param-reassign
	      });
	
	      var filteredExercises = void 0;
	      if (type === 'group') {
	        filteredExercises = exercises.filter(function (v) {
	          return v.group_id !== null && v.language.toLowerCase() === item.toLowerCase();
	        }); // eslint-disable-line max-len
	      } else {
	        filteredExercises = exercises.filter(function (v) {
	          return v.group_id === null && v.language.toLowerCase() === item.toLowerCase();
	        }); // eslint-disable-line max-len
	      }
	      if (!canBeUsed) {
	        return _react2.default.createElement(
	          'h3',
	          { key: index },
	          'You have exercises in ',
	          language,
	          ', but your device does not support this language'
	        );
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'exercise-list', key: index },
	        _react2.default.createElement(
	          'li',
	          { className: 'exercise-language-header' },
	          language
	        ),
	        filteredExercises.map(function (exercise, i) {
	          return _this3.renderExercise(exercise, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var auth = this.props.auth;
	
	
	      _auth2.default.setPermissions(auth.user.permissions);
	      _auth2.default.setRole(auth.user.role);
	
	      var openLabel = !this.props.config.isTablet && !this.props.config.isPhone ? 'Exercises' : '';
	
	      var downloadLabel = !this.props.config.isTablet && !this.props.config.isPhone ? 'Report' : '';
	
	      var groupExercises = this.getGroupExercises();
	      var myExercises = this.getMyExercises();
	
	      var groupLanguages = Array.from([].concat(_toConsumableArray(new Set(groupExercises.map(function (item) {
	        return item.language;
	      })))));
	      var myLanguages = Array.from([].concat(_toConsumableArray(new Set(myExercises.map(function (item) {
	        return item.language;
	      })))));
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Cancel',
	        primary: true,
	        onTouchTap: this.handleDialogClose
	      })];
	
	      var reportActions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Cancel',
	        primary: true,
	        onTouchTap: this.handleReportDialogClose
	      }), _react2.default.createElement(_FlatButton2.default, {
	        id: 'dlReport',
	        label: 'Download PDF',
	        primary: true,
	        onTouchTap: this.downloadReport
	      })];
	
	      var style = {
	        marginRight: '12px'
	      };
	
	      var exerciseDialog = _react2.default.createElement(
	        _Dialog2.default,
	        { actions: actions, modal: false, open: this.state.open, onRequestClose: this.handleDialogClose, autoScrollBodyContent: true },
	        _react2.default.createElement(
	          _Tabs.Tabs,
	          null,
	          auth.user.hasGroup && _react2.default.createElement(
	            _Tabs.Tab,
	            { label: 'Group Exercises' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Group Exercises'
	            ),
	            groupLanguages.map(function (item, index) {
	              return _this4.renderMenuItem(item, index, 'group');
	            })
	          ),
	          _react2.default.createElement(
	            _Tabs.Tab,
	            { label: 'My Exercises' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'My Exercises'
	            ),
	            myLanguages.map(function (item, index) {
	              return _this4.renderMenuItem(item, index, 'my');
	            })
	          )
	        )
	      );
	
	      var reportDialog = _react2.default.createElement(
	        _Dialog2.default,
	        { title: 'Report', actions: reportActions, modal: false, open: this.state.reportOpen, onRequestClose: this.handleReportDialogClose, autoScrollBodyContent: true },
	        _react2.default.createElement(_Report2.default, { history: this.props.history })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-exercise-launcher' },
	        !this.props.standAlone && _react2.default.createElement(_RaisedButton2.default, {
	          id: 'loadExercises',
	          style: style,
	          label: openLabel,
	          disabled: !this.props.isStopped(),
	          onTouchTap: this.handleDialogOpen,
	          icon: _react2.default.createElement(_list2.default, null)
	        }),
	        this.state.open ? exerciseDialog : null,
	        !this.props.standAlone && _react2.default.createElement(_RaisedButton2.default, {
	          id: 'viewReport',
	          style: style,
	          disabled: !this.props.isStopped(),
	          onTouchTap: this.handleReportDialogOpen,
	          icon: _react2.default.createElement(_assignment2.default, null),
	          label: downloadLabel
	        }),
	        reportDialog
	      );
	    }
	  }]);
	
	  return PronounceMenu;
	}(_react.Component);
	
	exports.default = PronounceMenu;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FloatingActionButton = __webpack_require__(128);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	var _stop = __webpack_require__(134);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _mic = __webpack_require__(499);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyles = {
	  color: '#fff'
	};
	
	var Record = function Record(props) {
	  if (!props.deviceConfig.supportsRecording && props.config.environment !== 'android') {
	    return _react2.default.createElement('span', null);
	  }
	
	  var isActive = props.isStopped() || props.isRecording;
	
	  var disabled = !isActive;
	
	  disabled = disabled || !props.deviceConfig.allowsRecording && props.config.environment !== 'android';
	
	  var label = props.isRecording ? _react2.default.createElement(_stop2.default, null) : _react2.default.createElement(_mic2.default, null);
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _FloatingActionButton2.default,
	      {
	        id: 'record',
	        title: 'Record your take',
	        backgroundColor: '#d52b1e',
	        iconStyle: iconStyles,
	        onClick: props.record,
	        className: 'pronounce-button record',
	        disabled: disabled
	      },
	      label
	    ),
	    _react2.default.createElement('br', null),
	    'Try it yourself'
	  );
	};
	
	exports.default = Record;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Redirect = __webpack_require__(101);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Card = __webpack_require__(22);
	
	var _Stepper = __webpack_require__(460);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _done = __webpack_require__(89);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var Register = function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register(props) {
	    _classCallCheck(this, Register);
	
	    var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	
	    _this.handleNext = function () {
	      var stepIndex = _this.state.stepIndex;
	
	
	      if (stepIndex < 1) {
	        stepIndex += 1;
	        _this.setState({ stepIndex: stepIndex });
	      } else if (stepIndex === 1) {
	        _this.validateForm();
	      }
	    };
	
	    _this.validateForm = function () {
	      var creds = {
	        key: _this.state.form.token,
	        name: _this.state.form.name,
	        email: _this.state.form.email.value,
	        password: _this.state.form.password,
	        password_confirmation: _this.state.form.password_confirmation
	      };
	
	      _this.props.dispatch((0, _actions.registerUser)(creds));
	    };
	
	    _this.handleToken = function (event) {
	      event.preventDefault();
	      var form = Object.assign({}, _this.state.form);
	      var key = _this.tokenInput.getValue().trim();
	      form.token = key;
	
	      _this.setState({ form: form });
	      if (key.length === 10) {
	        _this.props.dispatch((0, _actions.validateToken)({ key: key }));
	      }
	    };
	
	    _this.handleForm = function (event) {
	      event.preventDefault();
	
	      var form = Object.assign({}, _this.state.form);
	
	      form.name = _this.nameInput.getValue();
	      form.email.value = _this.emailInput.getValue();
	      form.password = _this.pwInput.getValue();
	      form.password_confirmation = _this.pw_confInput.getValue();
	
	      var validEmail = form.email.value.match(emailRegexp);
	
	      if (validEmail) {
	        _this.props.dispatch((0, _actions.validateEmail)({ email: form.email.value }));
	      }
	
	      _this.setState({ form: form });
	    };
	
	    var token = "";
	    // Get the possible token from URL query string
	    if (props.location.query && typeof props.location.query.token === "string" && props.location.query.token.length === 10) {
	      token = props.location.query.token;
	      _this.props.dispatch((0, _actions.validateToken)({ key: token }));
	    }
	
	    _this.state = {
	      stepIndex: 0,
	      form: {
	        token: token,
	        name: "",
	        email: {
	          value: "",
	          error: ""
	        },
	        password: "",
	        password_confirmation: ""
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Register, [{
	    key: "renderStepActions",
	    value: function renderStepActions(step, disabled, icon) {
	      var stepIndex = this.state.stepIndex;
	
	
	      var disabledNext = disabled;
	
	      return _react2.default.createElement(
	        "div",
	        { style: { margin: "12px 0" } },
	        _react2.default.createElement(_RaisedButton2.default, {
	          type: "submit",
	          label: stepIndex === 1 ? "Create account" : "Next",
	          disabled: disabledNext,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          primary: true,
	          icon: icon,
	          onTouchTap: this.handleNext,
	          style: { marginRight: 12 }
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.auth.isAuthenticated) {
	        return _react2.default.createElement(_Redirect2.default, { to: "/" });
	      }
	
	      var token = this.props.validation.token;
	      var email = this.props.validation.email;
	      var disabled = this.state.form.token.length !== 10 || !token.hasFetched || !token.isValid;
	      var disabledFinal = this.state.form.name.length < 2 || this.state.form.password.length < 6 || this.state.form.password_confirmation.length < 6 || this.state.form.password !== this.state.form.password_confirmation || !email.hasFetched || !email.isValid;
	
	      var localPassWordErrorMessage = this.state.form.password.length > 6 && this.state.form.password_confirmation.length > 6 && this.state.form.password !== this.state.form.password_confirmation ? "Password confirmation does not match" : "";
	
	      var _getErrors = (0, _geterrors2.default)(this.props.registration.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	      var passwordErrorMessage = _apierrors2.default[validationErrors.password] || validationErrors.password || localPassWordErrorMessage;
	
	      var emailValidationError = email.isValid || !email.hasFetched ? "" : "This email is already in use";
	
	      var stepIndex = this.state.stepIndex;
	
	
	      var fetchingTokenMessage = this.props.isWaiting.VALIDATE_TOKEN ? "Validating token..." : "";
	      var tokenError = void 0;
	      var TokenButtonIcon = void 0;
	
	      if (this.state.form.token.length === 10 && token.hasFetched && !token.isValid) {
	        tokenError = "Token not valid or the group is full";
	      } else if (this.state.form.token.length === 10 && token.hasFetched && token.isValid) {
	        TokenButtonIcon = _react2.default.createElement(_done2.default, null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "unregistered", key: "registration" },
	        _react2.default.createElement(
	          _Card.Card,
	          null,
	          _react2.default.createElement(_Card.CardHeader, { title: "Create an account for Pronounce Live" }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "This registration is meant for organization users."
	            )
	          ),
	          _react2.default.createElement(
	            _Stepper.Stepper,
	            { activeStep: stepIndex, orientation: "vertical" },
	            _react2.default.createElement(
	              _Stepper.Step,
	              null,
	              _react2.default.createElement(
	                _Stepper.StepLabel,
	                null,
	                "Input your token"
	              ),
	              _react2.default.createElement(
	                _Stepper.StepContent,
	                null,
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "You need a registration token to create an account and join a user group. Ask your organization's administrator if you don't have one."
	                ),
	                _react2.default.createElement(_TextField2.default, {
	                  autoFocus: true,
	                  value: this.state.form.token,
	                  errorText: tokenError,
	                  onChange: this.handleToken,
	                  ref: function ref(input) {
	                    _this2.tokenInput = input;
	                  },
	                  type: "text",
	                  name: "key",
	                  placeholder: "token"
	                }),
	                fetchingTokenMessage,
	                this.renderStepActions(0, disabled, TokenButtonIcon)
	              )
	            ),
	            _react2.default.createElement(
	              _Stepper.Step,
	              null,
	              _react2.default.createElement(
	                _Stepper.StepLabel,
	                null,
	                "Create account"
	              ),
	              _react2.default.createElement(
	                _Stepper.StepContent,
	                null,
	                _react2.default.createElement(_TextField2.default, {
	                  errorText: nameErrorMessage,
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.nameInput = input;
	                  },
	                  floatingLabelText: "Your name",
	                  type: "text",
	                  name: "name",
	                  value: this.state.form.name
	                }),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(_TextField2.default, {
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.emailInput = input;
	                  },
	                  errorText: emailValidationError || emailErrorMessage,
	                  floatingLabelText: "Email",
	                  type: "email",
	                  name: "email",
	                  value: this.state.form.email.value
	                }),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(_TextField2.default, {
	                  errorText: passwordErrorMessage,
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.pwInput = input;
	                  },
	                  type: "password",
	                  name: "password",
	                  floatingLabelText: "Password",
	                  hintText: "At least 6 characters",
	                  value: this.state.form.password
	                }),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(_TextField2.default, {
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.pw_confInput = input;
	                  },
	                  type: "password",
	                  name: "password_confirmation",
	                  floatingLabelText: "Password Confirmation",
	                  hintText: "Match the password field",
	                  value: this.state.form.password_confirmation
	                }),
	                _react2.default.createElement("br", null),
	                this.renderStepActions(1, disabledFinal)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Register;
	}(_react.Component);
	
	exports.default = Register;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Gauge = __webpack_require__(243);
	
	var _Gauge2 = _interopRequireDefault(_Gauge);
	
	var _scoreclass = __webpack_require__(103);
	
	var _scoreclass2 = _interopRequireDefault(_scoreclass);
	
	__webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Report = function (_React$Component) {
	  _inherits(Report, _React$Component);
	
	  function Report() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Report);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Report.__proto__ || Object.getPrototypeOf(Report)).call.apply(_ref, [this].concat(args))), _this), _this.renderScoreRow = function (result, index) {
	      var score = parseInt(result.score, 10) || 0;
	      var scoreClass = (0, _scoreclass2.default)(score);
	
	      var style = {
	        width: 'calc(' + score + '% - 20px)'
	      };
	
	      return _react2.default.createElement(
	        'tr',
	        { key: index },
	        _react2.default.createElement(
	          'td',
	          null,
	          result.source
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          result.result.result
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          result.language
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'pronounce-results-score-indicator-wrapper', style: { width: '100%' } },
	          _react2.default.createElement(
	            'span',
	            { style: style, className: 'pronounce-results-score-indicator ' + scoreClass },
	            '\xA0'
	          ),
	          '\xA0',
	          score
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Report, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-report' },
	        _react2.default.createElement(
	          'table',
	          { className: 'pronounce-results-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Original'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Transcript'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Language'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Score'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.props.history.history.map(function (result, index) {
	              return _this2.renderScoreRow(result, index);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component);
	
	exports.default = Report;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var ForgotPassword = function (_Component) {
	  _inherits(ForgotPassword, _Component);
	
	  function ForgotPassword() {
	    _classCallCheck(this, ForgotPassword);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this));
	
	    _this.handleForm = function (event) {
	      event.preventDefault();
	
	      var email = _this.emailInput.getValue();
	      var password = _this.passwordInput.getValue();
	      var passwordConfirmation = _this.passwordConfirmationInput.getValue();
	
	      _this.setState({ email: email, password: password, passwordConfirmation: passwordConfirmation });
	    };
	
	    _this.state = {
	      email: '',
	      password: '',
	      passwordConfirmation: '',
	      successMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(ForgotPassword, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.auth.passwordReset.isSuccess && nextProps.auth.passwordReset.isSuccess) {
	        this.setState({ email: '', password: '', passwordConfirmation: '', successMessage: 'Your password was reset! ' });
	      } else {
	        this.setState({ successMessage: '' });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var token = this.props.params.resetToken;
	      var email = this.state.email.trim();
	      var password = this.state.password.trim();
	      var passwordConfirmation = this.state.passwordConfirmation.trim();
	
	      var creds = { token: token, email: email, password: password, password_confirmation: passwordConfirmation };
	      this.props.dispatch((0, _actions.resetPassword)(creds));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var token = this.props.params.resetToken;
	      var validEmail = this.state.email.match(emailRegexp);
	
	      var disabled = !validEmail || this.state.password.length < 6 || this.state.passwordConfirmation < 6 || token.length === 0 || this.props.isWaiting.PASSWORD_RESET;
	
	      var _getErrors = (0, _geterrors2.default)(this.props.auth.passwordReset.errors),
	          errorMessages = _getErrors.errorMessages,
	          validationErrors = _getErrors.validationErrors;
	
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	      var passwordErrorMessage = _apierrors2.default[validationErrors.password] || validationErrors.password;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'unregistered', key: 'passwordreset' },
	        _react2.default.createElement(
	          _Card.Card,
	          null,
	          _react2.default.createElement(_Card.CardHeader, { title: 'Reset your password' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'pronounce-login' },
	              _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(_TextField2.default, {
	                  autoFocus: true,
	                  errorText: emailErrorMessage,
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.emailInput = input;
	                  },
	                  type: 'text',
	                  name: 'email',
	                  value: this.state.email,
	                  floatingLabelText: 'Email'
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_TextField2.default, {
	                  errorText: passwordErrorMessage,
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.passwordInput = input;
	                  },
	                  type: 'password',
	                  name: 'password',
	                  value: this.state.password,
	                  floatingLabelText: 'Password',
	                  hintText: 'At least 6 characters'
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_TextField2.default, {
	                  onChange: this.handleForm,
	                  ref: function ref(input) {
	                    _this2.passwordConfirmationInput = input;
	                  },
	                  type: 'password',
	                  name: 'password_confirmation',
	                  value: this.state.password_confirmation,
	                  floatingLabelText: 'Password confirmation',
	                  hintText: 'Match the password field'
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_FlatButton2.default, {
	                  disabled: disabled,
	                  onClick: function onClick(event) {
	                    return _this2.handleClick(event);
	                  },
	                  type: 'submit',
	                  label: 'Reset Password'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            errorMessages.map(function (error) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  error
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            this.state.successMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return ForgotPassword;
	}(_react.Component);
	
	exports.default = ForgotPassword;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _poll = __webpack_require__(509);
	
	var _poll2 = _interopRequireDefault(_poll);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _ResultTrend = __webpack_require__(645);
	
	var _ResultTrend2 = _interopRequireDefault(_ResultTrend);
	
	var _scoreclass = __webpack_require__(103);
	
	var _scoreclass2 = _interopRequireDefault(_scoreclass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultHistory = function (_Component) {
	  _inherits(ResultHistory, _Component);
	
	  function ResultHistory(props) {
	    _classCallCheck(this, ResultHistory);
	
	    var _this = _possibleConstructorReturn(this, (ResultHistory.__proto__ || Object.getPrototypeOf(ResultHistory)).call(this, props));
	
	    _this.handleDialogOpen = function () {
	      _this.setState({ open: true });
	    };
	
	    _this.handleDialogClose = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.renderResult = function (result, index) {
	      var score = parseInt(result.score, 10) || 0;
	      var scoreClass = (0, _scoreclass2.default)(score);
	
	      var style = {
	        width: 'calc(' + score + '% - 20px)'
	      };
	      return _react2.default.createElement(
	        'tr',
	        { className: 'pronounce-results-row', key: index },
	        _react2.default.createElement(
	          'td',
	          null,
	          result.result.result
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'pronounce-results-score-indicator-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { style: style, className: 'pronounce-results-score-indicator ' + scoreClass },
	            '\xA0'
	          ),
	          '\xA0',
	          score
	        )
	      );
	    };
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(ResultHistory, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var tries = this.props.resultHistory.length;
	
	      var disabled = this.props.text.length === 0 || this.props.resultHistory.length === 0;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Close',
	        primary: true,
	        onTouchTap: this.handleDialogClose
	      })];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-result-history' },
	        _react2.default.createElement(
	          _IconButton2.default,
	          { title: 'View result history', disabled: disabled, onClick: this.handleDialogOpen },
	          _react2.default.createElement(_poll2.default, null)
	        ),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            actions: actions,
	            modal: false,
	            open: this.state.open,
	            onRequestClose: this.handleDialogClose,
	            autoScrollBodyContent: true
	          },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Original phrase:'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            this.props.text
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'You\'ve tried it ',
	            tries,
	            ' times'
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Result trend'
	          ),
	          _react2.default.createElement(_ResultTrend2.default, { resultHistory: this.props.resultHistory }),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Result history'
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'pronounce-results-table' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              this.props.resultHistory.map(function (result, index) {
	                return _this2.renderResult(result, index);
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResultHistory;
	}(_react.Component);
	
	exports.default = ResultHistory;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTrend = __webpack_require__(689);
	
	var _reactTrend2 = _interopRequireDefault(_reactTrend);
	
	var _scoreclass = __webpack_require__(103);
	
	var _scoreclass2 = _interopRequireDefault(_scoreclass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultTrend = function (_Component) {
	  _inherits(ResultTrend, _Component);
	
	  function ResultTrend(props) {
	    _classCallCheck(this, ResultTrend);
	
	    var _this = _possibleConstructorReturn(this, (ResultTrend.__proto__ || Object.getPrototypeOf(ResultTrend)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(ResultTrend, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.resultHistory.length < 2) {
	        return _react2.default.createElement('span', null);
	      }
	      var gradient = ['#ff0000', '#ffa500', '#ffff00', '#008000'];
	      var data = this.props.resultHistory.map(function (result) {
	        return parseInt(result.score, 10) || 0;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-result-trend' },
	        _react2.default.createElement(_reactTrend2.default, {
	          data: data,
	          autoDraw: true,
	          autoDrawDuration: 500,
	          autoDrawEasing: 'ease-in',
	          smooth: true,
	          radius: 6,
	          strokeWidth: 2
	        })
	      );
	    }
	  }]);
	
	  return ResultTrend;
	}(_react.Component);
	
	exports.default = ResultTrend;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Checkbox = __webpack_require__(127);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _errorOutline = __webpack_require__(498);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _done = __webpack_require__(89);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _StripeCheckout = __webpack_require__(648);
	
	var _StripeCheckout2 = _interopRequireDefault(_StripeCheckout);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Card = __webpack_require__(22);
	
	var _countries = __webpack_require__(249);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	__webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var SingleUserRegistrationAndroid = function (_Component) {
	  _inherits(SingleUserRegistrationAndroid, _Component);
	
	  function SingleUserRegistrationAndroid() {
	    _classCallCheck(this, SingleUserRegistrationAndroid);
	
	    var _this = _possibleConstructorReturn(this, (SingleUserRegistrationAndroid.__proto__ || Object.getPrototypeOf(SingleUserRegistrationAndroid)).call(this));
	
	    _this.validateForm = function () {
	      var creds = {
	        email: _this.state.form.email.value,
	        password: _this.state.form.password
	      };
	
	      _this.props.dispatch((0, _actions.registerSingleFreeUser)(creds));
	    };
	
	    _this.handleForm = function (event) {
	      event.preventDefault();
	
	      var form = Object.assign({}, _this.state.form);
	
	      form.email.value = _this.emailInput.getValue();
	      form.password = _this.pwInput.getValue();
	
	      var validEmail = form.email.value.match(emailRegexp);
	
	      if (validEmail) {
	        _this.props.dispatch((0, _actions.validateEmail)({ email: form.email.value }));
	      }
	
	      _this.setState({ form: form });
	    };
	
	    _this.renderAccountForm = function () {
	      var email = _this.props.validation.email;
	      var singleRegistration = _this.props.singleregistration;
	
	      var disabled = _this.state.form.password.length < 6 || !email.hasFetched || !email.isValid || singleRegistration.isFetching || singleRegistration.isRegistered;
	
	      //const { errorMessages, validationErrors } = getErrors(email.errors);
	
	      var _getErrors = (0, _geterrors2.default)(singleRegistration.errors),
	          errorMessages = _getErrors.errorMessages,
	          validationErrors = _getErrors.validationErrors;
	
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	      var passwordErrorMessage = _apierrors2.default[validationErrors.password] || validationErrors.password;
	
	      var emailError = void 0;
	
	      if (_this.state.form.email.value.length > 5 && !_this.state.form.email.value.match(emailRegexp)) {
	        emailError = 'This is not a valid email address';
	      }
	
	      if (email.hasFetched && !email.isValid) {
	        emailError = 'This address is already in use';
	      }
	
	      var validating = '';
	
	      var success = '';
	
	      if (singleRegistration.isRegistered) {
	        success = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_done2.default, { style: { width: '128px', height: '128px' }, color: 'green' }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            { style: { marginBottom: 0 } },
	            'OK! Now, just install the app:'
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', rel: 'noopener', href: 'https://play.google.com/store/apps/details?id=com.sanako.pronounce_live&utm_source=frontpage&utm_campaign=android-beta&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' },
	            _react2.default.createElement('img', { width: '160', alt: 'Get it on Google Play', src: 'https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' })
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: '14px' } },
	            '(Or ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.pronouncelive.com/' },
	              'login to the web version here'
	            ),
	            ')'
	          )
	        );
	      }
	
	      var label = singleRegistration.isFetching ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : "Let's Go";
	
	      var title = disabled ? 'Please fill out all the fields to activate this button' : 'This will create your account and start your trial';
	
	      var btnStyle = {
	        color: '#fff'
	      };
	
	      var subscriptionInfo = '';
	
	      var symbols = {
	        EUR: '€',
	        USD: '$',
	        GBP: '£'
	      };
	
	      if (_this.props.subscriptions.hasFetchedPlan) {
	        var price = _this.props.subscriptions.plan.price / 100;
	        var curSymbol = symbols[_this.props.subscriptions.plan.currency];
	        subscriptionInfo = 'Subscription available for 6 months / ' + price + ' ' + curSymbol;
	      }
	
	      return _react2.default.createElement(
	        _Card.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'account-form' },
	          _react2.default.createElement(_TextField2.default, {
	            autoFocus: true,
	            onChange: _this.handleForm,
	            ref: function ref(input) {
	              _this.emailInput = input;
	            },
	            errorText: emailErrorMessage || emailError,
	            floatingLabelText: 'Email',
	            type: 'email',
	            name: 'email',
	            value: _this.state.form.email.value
	          }),
	          validating,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_TextField2.default, {
	            errorText: passwordErrorMessage,
	            onChange: _this.handleForm,
	            ref: function ref(input) {
	              _this.pwInput = input;
	            },
	            type: 'password',
	            name: 'password',
	            floatingLabelText: 'Password',
	            hintText: 'At least 6 characters',
	            value: _this.state.form.password
	          }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_RaisedButton2.default, {
	            id: 'create-account',
	            backgroundColor: '#31C04C',
	            disabledBackgroundColor: 'rgb(203, 239, 210)',
	            style: btnStyle,
	            disabled: disabled,
	            onTouchTap: _this.validateForm,
	            label: label,
	            title: title,
	            primary: true
	          }),
	          _react2.default.createElement(
	            'p',
	            { className: 'details' },
	            'By creating this account you agree to our ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: '/terms', title: 'The terms will open in a new window' },
	              'Terms of Use'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: '/privacy', title: 'The privacy policy will open in a new window' },
	              'Privacy Policy'
	            ),
	            '.'
	          ),
	          errorMessages.map(function (error, index) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'error-form', key: index },
	              _react2.default.createElement(_errorOutline2.default, null),
	              _react2.default.createElement(
	                'span',
	                null,
	                error
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'account-success-overlay' },
	            success
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            subscriptionInfo
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Any questions? Check our ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.sanako.com/help/pronounce-live-faq/' },
	              'FAQ'
	            ),
	            '.'
	          )
	        )
	      );
	    };
	
	    _this.renderSubscriptionForm = function () {
	      return _react2.default.createElement(_StripeCheckout2.default, _this.props);
	    };
	
	    _this.state = {
	      form: {
	        name: '',
	        email: {
	          value: '',
	          error: ''
	        },
	        password: '',
	        countryCode: null,
	        remember: true
	      }
	    };
	    return _this;
	  }
	
	  _createClass(SingleUserRegistrationAndroid, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _actions.getPlan)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          singleregistration = _props.singleregistration,
	          subscriptions = _props.subscriptions;
	
	
	      if (!subscriptions.hasFetchedPlan) {
	        //return <span>Fetching plan...</span>;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'registration' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'center' },
	          'Use for free until the end of March 2018.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'account-creation' },
	          this.renderAccountForm()
	        )
	      );
	    }
	  }]);
	
	  return SingleUserRegistrationAndroid;
	}(_react.Component);
	
	exports.default = SingleUserRegistrationAndroid;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(212);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpeechRecognitionResult = function (_React$Component) {
	  _inherits(SpeechRecognitionResult, _React$Component);
	
	  function SpeechRecognitionResult() {
	    _classCallCheck(this, SpeechRecognitionResult);
	
	    return _possibleConstructorReturn(this, (SpeechRecognitionResult.__proto__ || Object.getPrototypeOf(SpeechRecognitionResult)).apply(this, arguments));
	  }
	
	  _createClass(SpeechRecognitionResult, [{
	    key: 'renderWords',
	    value: function renderWords(word, index) {
	      if (word.length === 0) {
	        return _react2.default.createElement('span', { key: index });
	      }
	
	      var color = 'transparent';
	      var opaqueColor = void 0;
	      var style = void 0;
	      var scoreByWord = this.props.scoreByWord[index];
	
	      if (scoreByWord >= 75) {
	        color = 'rgba(0,128,0,1)';
	      } else if (scoreByWord >= 50 && scoreByWord < 75) {
	        color = 'rgba(255,255,0,1)';
	        opaqueColor = 'rgba(255,255,0,0.1)';
	      } else if (scoreByWord >= 25 && scoreByWord < 50) {
	        color = 'rgba(255,165,0,1)';
	        opaqueColor = 'rgba(255,165,0,0.1)';
	      } else {
	        color = 'rgba(255,0,0,1)';
	        opaqueColor = 'rgba(255,0,0,0.1)';
	      }
	
	      if (scoreByWord >= 75) {
	        style = {
	          color: color
	        };
	      } else {
	        style = {
	          borderBottom: '2px solid ' + color,
	          background: opaqueColor
	        };
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { key: index },
	        _react2.default.createElement(
	          'span',
	          { style: style },
	          word
	        ),
	        '\xA0'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.isRecording) {
	        return _react2.default.createElement('div', { className: 'pronounce-speech-rec-result' });
	      }
	
	      var words = this.props.result.split(' ');
	      return _react2.default.createElement(
	        'div',
	        { className: 'pronounce-speech-rec-result' },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionName: 'example',
	            transitionEnterTimeout: 300,
	            transitionLeaveTimeout: 300
	          },
	          words.map(function (key, index) {
	            return _this2.renderWords(key, index);
	          })
	        )
	      );
	    }
	  }]);
	
	  return SpeechRecognitionResult;
	}(_react2.default.Component);
	
	exports.default = SpeechRecognitionResult;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _actions = __webpack_require__(20);
	
	__webpack_require__(341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReactScriptLoaderMixin = __webpack_require__(608).ReactScriptLoaderMixin; /* globals Stripe */
	/* eslint react/prefer-es6-class: "off"*/
	
	var StripeCheckout = _react2.default.createClass({
	  displayName: 'StripeCheckout',
	
	  mixins: [ReactScriptLoaderMixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      stripeLoading: true,
	      stripeLoadingError: false,
	      submitDisabled: false,
	      paymentError: null,
	      paymentComplete: false,
	      token: null
	    };
	  },
	  getScriptURL: function getScriptURL() {
	    return 'https://js.stripe.com/v2/';
	  },
	  onScriptLoaded: function onScriptLoaded() {
	    if (!StripeCheckout.getStripeToken) {
	      // Put your publishable key here
	      Stripe.setPublishableKey('pk_test_wm8nSTPbnGLFUcl2BkZ5bkcS');
	
	      this.setState({ stripeLoading: false, stripeLoadingError: false });
	    }
	  },
	  onScriptError: function onScriptError() {
	    this.setState({ stripeLoading: false, stripeLoadingError: true });
	  },
	  onSubmit: function onSubmit(event) {
	    var _this = this;
	
	    var self = this;
	    event.preventDefault();
	    this.setState({ submitDisabled: true, paymentError: null });
	    // send form here
	    Stripe.createToken(event.target, function (status, response) {
	      if (response.error) {
	        self.setState({ paymentError: response.error.message, submitDisabled: false });
	      } else {
	        self.setState({ paymentComplete: true, submitDisabled: false, token: response.id });
	        _this.props.dispatch((0, _actions.createSubscription)({
	          token: response.id,
	          jwt: _this.props.singleregistration.jwt
	        }));
	      }
	    });
	  },
	  render: function render() {
	    var subscribe = this.props.subscribe;
	    var info = '';
	
	    if (!this.props.singleregistration.isRegistered || !this.props.singleregistration.jwt === null) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Please create an account first.'
	      );
	    } else if (this.state.stripeLoading || subscribe.isFetching) {
	      return _react2.default.createElement(_CircularProgress2.default, null);
	    } else if (this.state.stripeLoadingError) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Error loading payment form'
	      );
	    } else if (this.state.paymentComplete && subscribe.didSucceed) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Payment complete'
	        ),
	        '! You should be redirected automatically.'
	      );
	    } else if (this.state.paymentComplete && subscribe.triedToSubscribe && !subscribe.didSucceed) {
	      info = _react2.default.createElement(
	        'div',
	        null,
	        'Server error! Your payment did not go through. Please try again.'
	      );
	    }
	
	    var submitLabel = 'Subscribe to Pronounce Live for ';
	    submitLabel += this.props.activePlan === 'pronounce-six-months' ? '6 months, 4€' : 'one year, 8€';
	
	    return _react2.default.createElement(
	      'form',
	      { className: 'subscription-form', onSubmit: this.onSubmit },
	      _react2.default.createElement(
	        'span',
	        { className: 'subscription-form--error' },
	        info
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'subscription-form--error' },
	        this.state.paymentError
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('input', { className: 'subscription-form--input', type: 'number', 'data-stripe': 'number', placeholder: 'Credit Card Number' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('input', { className: 'subscription-form--input', type: 'number', 'data-stripe': 'exp-month', placeholder: 'Expiration Month' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('input', { className: 'subscription-form--input', type: 'number', 'data-stripe': 'exp-year', placeholder: 'Expiration Year' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('input', { className: 'subscription-form--input', type: 'number', 'data-stripe': 'cvc', placeholder: 'CVC (back of the card)' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(_RaisedButton2.default, {
	        disabled: this.state.submitDisabled,
	        onTouchTap: this.validateForm,
	        label: submitLabel,
	        primary: true,
	        type: 'submit'
	      })
	    );
	  }
	});
	
	exports.default = StripeCheckout;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _IconMenu = __webpack_require__(88);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _IconButton = __webpack_require__(40);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _settings = __webpack_require__(497);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _delete = __webpack_require__(493);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _ResultHistory = __webpack_require__(644);
	
	var _ResultHistory2 = _interopRequireDefault(_ResultHistory);
	
	var _SpeechRecognitionResult = __webpack_require__(647);
	
	var _SpeechRecognitionResult2 = _interopRequireDefault(_SpeechRecognitionResult);
	
	var _Gauge = __webpack_require__(243);
	
	var _Gauge2 = _interopRequireDefault(_Gauge);
	
	var _CreateExerciseForm = __webpack_require__(242);
	
	var _CreateExerciseForm2 = _interopRequireDefault(_CreateExerciseForm);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	var _auth = __webpack_require__(154);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _actions = __webpack_require__(20);
	
	__webpack_require__(342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-return-assign: "off", max-len: "off" */
	
	
	var TTSInput = function (_React$Component) {
	  _inherits(TTSInput, _React$Component);
	
	  function TTSInput(props) {
	    _classCallCheck(this, TTSInput);
	
	    var _this = _possibleConstructorReturn(this, (TTSInput.__proto__ || Object.getPrototypeOf(TTSInput)).call(this, props));
	
	    _this.saveExercise = function (name, language, text, mode, saveToGroup) {
	      _this.props.dispatch((0, _actions.createExercise)({ name: name, language: language, text: text, mode: mode, saveToGroup: saveToGroup }));
	    };
	
	    _this.updateExercise = function (id, body) {
	      _this.props.dispatch((0, _actions.updateExercise)(id, body));
	    };
	
	    _this.deleteExercise = function (id) {
	      _this.setState({ deleteOpen: false });
	      _this.props.dispatch((0, _actions.deleteExercise)(id));
	      _this.props.clearExercise();
	    };
	
	    _this.handleUpdateExercise = function (id, exercise) {
	      _this.props.dispatch((0, _actions.updateExercise)(id, exercise));
	    };
	
	    _this.handleSettings = function (event, value) {
	      switch (value) {
	
	        case 'save':
	          _this.setState({ saveOpen: true });
	          break;
	        case 'delete':
	          _this.setState({ deleteOpen: true });
	          break;
	        case 'close':
	          _this.props.clearExercise();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.state = {
	      saveOpen: false,
	      modifyOpen: false,
	      deleteOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(TTSInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If an exercise creation request is successful and the save dialog is open,
	      // close the dialog.
	      if (this.props.exercises.hasSaved === false && nextProps.exercises.hasSaved === true || this.props.exercises.hasUpdated === false && nextProps.exercises.hasUpdated === true) {
	        this.setState({ saveOpen: false });
	      }
	    }
	
	    // preventDefault is needed, since paste event triggers a change event also,
	    // so both handleInput and handlePaste would be executed without it. It
	    // would result in a mess.
	
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e) {
	      e.preventDefault();
	      this.props.dispatch(this.props.updateSource(this.textInput.value));
	    }
	  }, {
	    key: 'handlePaste',
	    value: function handlePaste(e) {
	      e.preventDefault();
	      this.props.dispatch(this.props.launchText(e.clipboardData.getData('text/plain')));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          auth = _props.auth,
	          exercises = _props.exercises;
	
	
	      _auth2.default.setPermissions(auth.user.permissions);
	      _auth2.default.setRole(auth.user.role);
	
	      var _getErrors = (0, _geterrors2.default)(this.props.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var textErrorMessage = _apierrors2.default[validationErrors.text] || validationErrors.text;
	
	      var p = this.props;
	      var text = p.texts.activeText !== null ? p.texts[p.text.activeText].source : '';
	
	      var resultHistory = p.texts[p.text.activeText].results || [];
	
	      var result = p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0 ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].result.result : '';
	      var score = p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0 ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].score : '';
	
	      var scoreByWord = p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0 ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].scoreByWord : '';
	
	      var removeText = void 0;
	      var charIndicator = void 0;
	      var charClass = void 0;
	
	      var isGroupExercise = exercises.activeExercise !== null && exercises.exercises[exercises.activeExercise].group_id !== null;
	      var hasPermission = _auth2.default.can('control-group-exercises');
	
	      var iconMenuStyle = {};
	      // The icon  menu itself cannot be disabled, so
	      // change its color so it doesn't pop out.
	      if (!this.props.isStopped()) {
	        iconMenuStyle = {
	          color: '#bbb'
	        };
	      }
	
	      var settings = _react2.default.createElement(
	        'span',
	        { className: 'settings-menu' },
	        _react2.default.createElement(
	          _IconMenu2.default,
	          {
	            iconStyle: iconMenuStyle,
	            iconButtonElement: _react2.default.createElement(
	              _IconButton2.default,
	              null,
	              _react2.default.createElement(_settings2.default, null)
	            ),
	            onChange: this.handleSettings
	          },
	          _react2.default.createElement(_MenuItem2.default, { value: 'save', disabled: !this.props.isStopped() || isGroupExercise && !hasPermission, primaryText: 'Edit exercise' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'delete', disabled: !this.props.isStopped() || exercises.activeExercise === null || isGroupExercise && !hasPermission, primaryText: 'Delete exercise' }),
	          _react2.default.createElement(_MenuItem2.default, { value: 'close', disabled: !this.props.isStopped() || exercises.activeExercise === null && text.length === 0, primaryText: 'Close exercise' })
	        )
	      );
	
	      var saveActions = [_react2.default.createElement(_FlatButton2.default, {
	        label: 'Cancel',
	        primary: true,
	        onTouchTap: function onTouchTap() {
	          return _this2.setState({ saveOpen: false });
	        }
	      })];
	
	      var exercise = this.props.exercises.activeExercise !== null ? this.props.exercises.exercises[this.props.exercises.activeExercise] : null;
	
	      var saveDialog = _react2.default.createElement(
	        _Dialog2.default,
	        { title: 'Edit exercise', actions: saveActions, modal: false, open: this.state.saveOpen, onRequestClose: function onRequestClose() {
	            return _this2.setState({ saveOpen: false });
	          }, autoScrollBodyContent: true },
	        _react2.default.createElement(_CreateExerciseForm2.default, { exercise: exercise, canSaveToGroup: _auth2.default.can('control-group-exercises'), language: this.props.language, text: this.props.text, mode: this.props.mode, disabled: !this.props.isStopped(), isWaiting: this.props.isWaiting, nameErrorMessage: nameErrorMessage, textErrorMessage: textErrorMessage, updateExercise: this.updateExercise, saveExercise: this.saveExercise })
	      );
	
	      var deleteDialog = void 0;
	
	      if (p.exercises.activeExercise !== null) {
	        var delLabel = this.props.isWaiting.EXERCISE_DELETE ? _react2.default.createElement(_CircularProgress2.default, { size: 20 }) : 'Yes, delete exercise';
	
	        var deleteActions = [_react2.default.createElement(_FlatButton2.default, {
	          label: 'No, cancel',
	          primary: true,
	          onTouchTap: function onTouchTap() {
	            return _this2.setState({ deleteOpen: false });
	          }
	        }), _react2.default.createElement(_FlatButton2.default, {
	          label: delLabel,
	          primary: true,
	          onTouchTap: function onTouchTap() {
	            return _this2.deleteExercise(p.exercises.exercises[p.exercises.activeExercise].id);
	          }
	        })];
	
	        deleteDialog = _react2.default.createElement(
	          _Dialog2.default,
	          {
	            actions: deleteActions,
	            modal: false,
	            open: this.state.deleteOpen,
	            onRequestClose: function onRequestClose() {
	              return _this2.setState({ deleteOpen: false });
	            }
	          },
	          'Are you sure you want to delete this exercise?',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          p.exercises.exercises[p.exercises.activeExercise].name,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          p.exercises.exercises[p.exercises.activeExercise].text
	        );
	      }
	
	      if (p.isStopped() && p.text.activeText !== null && (!exercise || exercise.group_id === null || _auth2.default.can('control-group-exercises'))) {
	        removeText = _react2.default.createElement(
	          'span',
	          { className: 'remove-text' },
	          _react2.default.createElement(
	            _IconButton2.default,
	            { tooltip: 'Clear this sentence', disabled: text.length === 0, onClick: function onClick(e) {
	                e.preventDefault();p.dispatch(p.spliceSentence());
	              } },
	            _react2.default.createElement(_delete2.default, null)
	          )
	        );
	      }
	
	      if (text.length > 150) {
	        if (text.length === 200) {
	          charClass = 'maximum';
	        }
	        charIndicator = _react2.default.createElement(
	          'span',
	          { className: 'charIndicator ' + charClass },
	          text.length
	        );
	      }
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'pronounce-tts-form card' },
	        _react2.default.createElement(
	          'span',
	          { className: 'settings-area' },
	          settings,
	          this.state.saveOpen && saveDialog,
	          deleteDialog
	        ),
	        removeText,
	        _react2.default.createElement('textarea', {
	          id: 'pronounce-source-input',
	          maxLength: '200',
	          readOnly: !p.isStopped() || p.exercises.activeExercise !== null && !_auth2.default.can('control-group-exercises'),
	          value: text,
	          ref: function ref(input) {
	            return _this2.textInput = input;
	          },
	          onChange: function onChange(e) {
	            return _this2.handleInput(e);
	          },
	
	          onPaste: function onPaste(e) {
	            return _this2.handlePaste(e);
	          },
	          placeholder: 'Write or paste your text here, then listen and try to pronounce it yourself.'
	        }),
	        _react2.default.createElement('hr', { className: 'tts-divider' }),
	        _react2.default.createElement(_SpeechRecognitionResult2.default, { isRecording: this.props.isRecording, result: result, scoreByWord: scoreByWord }),
	        _react2.default.createElement(_Gauge2.default, { isStopped: this.props.isStopped(), score: score }),
	        _react2.default.createElement(_ResultHistory2.default, { text: text, resultHistory: resultHistory }),
	        charIndicator
	      );
	    }
	  }]);
	
	  return TTSInput;
	}(_react2.default.Component);
	
	exports.default = TTSInput;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Terms = function Terms() {
	  return _react2.default.createElement(
	    _Card.Card,
	    { className: 'unregistered' },
	    _react2.default.createElement(_Card.CardHeader, { title: 'Terms of Use' }),
	    _react2.default.createElement(
	      _Card.CardText,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Legal Notice'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '1. General'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '1.1 The Object of the Terms of Use and Description of Service.'
	        ),
	        '\xA0Sanako Oy, address: Ratapihankatu 53 C, FI 20100 Turku, Finland (hereinafter referred to as the\xA0',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '"Company"'
	        ),
	        ') offers services and products, such as the Pronounce Live service (hereinafter referred to as the\xA0',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '"Service"'
	        ),
	        '), to its users (hereinafter referred to as the\xA0',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '"Customer"'
	        ),
	        ') according to these Terms of Use. The exact content of the Service is determined in the descriptions and special terms of Service, presented on the Service website or otherwise at the time of ordering the Service.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '1.2 Applicable Terms of Contract and Order of Application.'
	        ),
	        '\xA0These Terms of Use apply to the Service and the use and ordering of services and products produced by Company and offered through the Service. In addition, different parts of the Service may require separate contracts with the Company, with special terms and descriptions of service that differ from or add to these terms. In case these general terms and the specific terms concerning a certain part of the Service are in conflict, the more specific terms will apply primarily, and these general terms secondarily where the part of the Service in question is concerned.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '1.3 Chargeable Services.'
	        ),
	        '\xA0The Customer can order the different products or services available through the Service by credit card payment. The Company will announce the price of each product or service according to method of payment and the Terms of Delivery complementing these terms separately.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '1.4 Customer\'s Right of Withdrawal.'
	        ),
	        '\xA0The Customer has no right of withdrawal of the order after the delivery of the product or service has begun by electronic means with the Customer\'s agreement.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '2. Beginning of Contract'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '2.1 Beginning of Contract in Service.'
	        ),
	        '\xA0The contract begins when the Customer, after registration, has agreed to these Terms of Use and when the Company has acknowledged the Customer\'s payment for the purchase of the product or service.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '2.2 Validity of the Information Provided by the Customer in the Service.'
	        ),
	        '\xA0The commissions of the Customer made in the Service are handled and delivered according to the information provided by the Customer. The Customer is responsible for the validity of the given information, and the Company has no obligation to check or add to the information.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '3. Identification'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '3.1 Means of Identification.'
	        ),
	        '\xA0The use of the Service requires a username and a personal password or another means of identification accepted by the Company. The email address provided by the Customer will function as the username.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '3.2 Customer\'s Means of Identification.'
	        ),
	        '\xA0After hearing the Customer, the Company has the right to choose and/or accept the usernames, passwords and other means of identification to be used by the Customer. They will remain the property of the Company, and the Customer has no rights to them after the end of the contract, unless otherwise agreed in writing.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '3.3 Company\'s Right to Change the Means of Identification.'
	        ),
	        '\xA0At any time, the Company has the right to change the Customer\'s means of identification. If possible within reason, the Company will inform the Customer of any changes in means of identification beforehand.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '3.4 Safekeeping of the Means of Identification.'
	        ),
	        '\xA0The Customer is responsible for the careful safekeeping of the Customer\'s means of identification. The Customer agrees to keep the password and any other possible, additional means of identification separate so that a third party cannot access them. The password used in connection with the means of identification is personal and is not to be given to a third party.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '4. Production and Use of Service'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '4.1 Production of Service.'
	        ),
	        '\xA0The Company has the right to produce the Service in any way it deems fit. The Company has the right to make changes that affect the content, technology and use of the Service. If these changes require changes in the Customer\'s equipment and software, the Customer must, at his or her own expense, take care of them. The Company strives to issue information on those changes affecting the Customer beforehand within a reasonable time, for example, by notifications published through the Service.\xA0',
	        _react2.default.createElement('br', null),
	        ' The Company has the right to stop the production of the Service or its part. In this case, the Company strives to inform the Customer of this beforehand within a reasonable time, for example, on the Service website.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '4.2 Right to Use the Material Published in the Service.'
	        ),
	        '\xA0The Service includes and provides material protected by copyright, trademark rights and/or other intellectual property rights. The Customer has no right to publish, copy, distribute to the public or otherwise utilize material that is acquired from or through the Service, except for the Customer\'s own private use, unless the Customer has acquired a specific written consent from the creator, the owner of such rights or the Company, or there has been a specific announcement of a wider right to use in the Service (for example, for press releases). The owner of rights of the material presented in or made available through the Service may make demands directly to the Customer in case of inappropriate use of protected material defined in this section.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '4.3 Right to Use the Software and Documents.'
	        ),
	        '\xA0The Company grants the Customer the right to use the machine code versions of the software and documents delivered by the Company according to the contract. According to the right to use, the Customer may use the software and documents only according to the possible licensing conditions accompanying the software, the instructions of the Company, and only directly pertaining to the use of the Service. The ownership and immaterial rights of software and documents, as well as their revised versions, are the property of the Company or a third party, and the Customer has no right, without a prior written consent from the Company, to copy, translate or change documents or software or distribute them for the use of a third party, unless compelled by mandatory legislation.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '4.4 Customer\'s Equipment and Software.'
	        ),
	        '\xA0The terminals, software and connections (such as connections to a mobile communication network and/or the Internet) that are required to use the Service are not included in the Service. The Customer is responsible for acquiring, maintaining and updating these devices, connections and software. In addition, the Customer is responsible for these devices and software not interfering or disturbing the functioning of the Company or the Service. Devices and software that may be causing disturbances must immediately be disconnected from the Service.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '5. Maintenance of Service and Repairing of Defects'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '5.1 Maintenance of Service and Repairing of Defects.'
	        ),
	        '\xA0The Company strives to take care, to the best of its ability, of the functionality of the Service and to repair any possible defects and or bugs in the Service within a reasonable time.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '5.2 Temporary Interruptions.'
	        ),
	        '\xA0The Company has the right to close the Service or a part of it temporarily if there is justifiable reason to do so. In this case, the Company strives to work so that the interruption will be as brief as possible and cause as little disadvantage to the Customer as possible. The Company will, within its capabilities and beforehand if necessary, inform the Customer of the interruption, for example, on the Service website.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '6. Reclamations Concerning the Service and Liability for Damage'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '6.1 Customer Reclamations.'
	        ),
	        '\xA0If the Customer notices a defect in the service, the Customer can make a reclamation and request a correction within a reasonable time after the defect was or should have been noticed. The reclamation can be made electronically through ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.pronouncelive.com' },
	          'https://www.pronouncelive.com'
	        ),
	        ' or by emailing\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:pronouncelive@sanako.com' },
	          'pronouncelive@sanako.com'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '6.2 Correction of the Defect.'
	        ),
	        '\xA0In case the Company offers, without delay, to correct the defect pointed out by the Customer, the Company has the right to correct the defect. In case the defect cannot be corrected or is not corrected within a reasonable time after the Customer pointed it out, the Customer has the right to receive a price reduction relative to the defect as defined by the Company.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '6.3 Liability for Damage.'
	        ),
	        '\xA0The Customer has the right to demand compensation for direct damage according to the Finnish Consumer Protection Act sections regarding compensation. The Company is not liable for damage caused by a defect in case the defect is caused by a reason unrelated to the Company or circumstances or reasons that are outside the Company\'s sphere of influence. The Customer has the right to be compensated for indirect damage caused by the defect only when the defect is caused by negligence on the part of the Company. The Customer is always obligated to act so that the damage caused by the defect does not increase needlessly due to the Customer\'s actions or negligence. The Company is only liable to consumer Customers for damage caused by the defect.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '6.4 Responsibilities in Sales to Companies and Educational Institutes.'
	        ),
	        '\xA0The products and services are always sold as is. The Company is not liable for direct or indirect damage or loss of profit caused by defects in the products or services and/or the use of the products or services. The liability of the Company is always limited according to the content of these Terms of Contract.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '6.5 Defects in Customer Controlled Devices or Software.'
	        ),
	        '\xA0If the Customer, knowingly or despite being notified by the Company, uses defective or disruptive devices or software, the Customer is liable to compensate the Company for any possible damages and the expenses of searching for the defects.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '7. Payments and Billing'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '7.1 Payments for Service.'
	        ),
	        '\xA0The Customer pays for the use of the chargeable parts of the Service according to the price list or contract. The prices of the Service are available on the Service website at\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.pronouncelive.com' },
	          'https://www.pronouncelive.com'
	        ),
	        '. The Company may use third party billing services to extract the payments for the use of the Service. In these cases, the payments for the use of the Service are exacted according to the billing periods and terms as defined in the contracts between the third parties in question (such as mobile communication operators) and the Customer, unless otherwise specified in the Service.\xA0'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'At the end of the trial period, should the account not have been terminated, the service will charge the Customer for the services. Access to the service is renewed automatically until the account is terminated by either party.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('br', null),
	        ' The payments are exacted in advance for each billing period. Payments must also be made in case of Service downtime caused by the Customer or a reason the Customer is responsible for. In case of end of contract, the Company will not refund the Customer for advance payments.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '7.2 Price Changes.'
	        ),
	        '\xA0The Company reserves the right to change its prices and the payments for the use of the Service. The current prices are announced on the Service website.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Stripe Payments UK, Ltd.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '7th Floor, The Bower Warehouse, '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '211 Old Street, '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'London EC1V 9NR, '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'United Kingdom'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '\xA0'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '8. Duration of Contract and the Usability of Personal Parts of Service'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '8.1 Running Time of Personal Services and Products.'
	        ),
	        '\xA0For the fixed-period parts of the Service, the Company will announce the running time of that part either during the ordering of the service or in some other way within the Service. The Customer must note that the Service and its inherent characteristics are not eternal by nature, and the Company does not guarantee that the Service or the products or services purchased through it will remain unchanged. The username and other personal data connected to the Service are stored for a minimum of twelve (12) months after the latest contract period of the Customer has ended. After this, the Company has the right to remove the Customer\'s username and other personal data connected to the Service.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '9. Closing the Customer\'s Service'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1 Company\'s Right to Close the Service.'
	        ),
	        '\xA0The Company has the right to close the Customer\'s Service completely or partially and leave the Customer\'s order unfulfilled if:\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.1'
	        ),
	        '\xA0The Customer has neglected to make a due payment despite being sent a reminder,',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.2'
	        ),
	        '\xA0Despite notification by the Company, the Customer uses disruptive devices or software,',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.3'
	        ),
	        '\xA0By use of the Service, the Customer has caused disruption to the Company, other Service users, or third parties,',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.4'
	        ),
	        '\xA0The Customer breaks the duties that are agreed to in the contract,',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.5'
	        ),
	        '\xA0The Customer has given fundamentally erroneous information during the opening of the Service or later, or',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '9.1.6'
	        ),
	        '\xA0There is cause to suspect that the Customer is using the Service for illegal actions.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '10. Termination of Contract'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.1 Customer\'s Right to Terminate the Contract.'
	        ),
	        '\xA0The Customer has the right to terminate at any time. If the termination occurs during the trial period no charge will be made. If the termination occurs after the paid period has begun the account will remain active until the end of the paid period.',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.2 Company\'s Right to Terminate the Contract.'
	        ),
	        '\xA0The Company has the right to terminate an open-ended contract with a one (1) month termination period.\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.3 Company\'s Right to Dissolve the Contract.'
	        ),
	        '\xA0The Company has the right to dissolve the contract if:\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.3.1'
	        ),
	        '\xA0The Customer has not used the Service for over twelve (12) months,\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.3.2'
	        ),
	        '\xA0The Customer\'s Service has been completely closed for one (1) month for a reason mentioned in section 9.1,\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '10.3.3'
	        ),
	        '\xA0The Customer has otherwise, essentially and despite being notified, neglected the duties that have been agreed to in the contract.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '11. Consequences of Termination of Contract'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '11.1 End of Service use and removal of data.'
	        ),
	        '\xA0When the contract ends, the Company has the right to stop the use of the Service with the Customer\'s user information and remove any possible data that the Customer may have saved in the customer-specific parts of the Service.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '12. Other Terms'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.1 Issuing Information.'
	        ),
	        '\xA0The Customer must, before commencing the use of the Service, provide the Company the information required for the Service (customer information) and make sure that the given information is valid. The Customer must immediately notify the Company of changes to customer information on the Service website under Menu item: Account.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.2 Notices.'
	        ),
	        '\xA0The Customer must send any written notices concerning this contract to the Company address\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:pronouncelive@sanako.com' },
	          'pronouncelive@sanako.com'
	        ),
	        '\xA0or Sanako Oy, Ratapihankatu 53C, FI 20100 Turku, Finland. Contract termination can be done either in writing to The Company at the address details above or through the online menu found on the service. The Company may send any written notices concerning this contract to the email address that the Customer has provided to the Company. General notices concerning the Service can also be published on the Service website. A notice sent by the Customer will be considered received on the seventh (7th) day after sending by post and on the next work day after sending by email.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.3 Transferring the Contract.'
	        ),
	        '\xA0The Company has the right to transfer the contract to a third party fully or in part. The Company will notify the Customer of the transfer. In addition, the Company has the right to transfer the payments due under the contract to the third party. After the notification of the transfer of due payments to the third party, the payments are only valid when made to the receiving party of the transfer. The Customer has no right to transfer the contract to a third party without a prior written agreement from the Company.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.4 Applicable Law and Venue.'
	        ),
	        '\xA0This contract and its service-specific special terms operate under the laws of Finland (excluding the choice of law provisions) and disputes concerning the contract are handled in Turku District Court. In addition, a Consumer has the right to bring the dispute to be handled by the Consumer Disputes Board or in the Consumer\'s domestic District Court in Finland. If the Consumer is not a resident of Finland, the dispute is handled in Turku District Court, Finland.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.5 Force Majeure.'
	        ),
	        '\xA0The parties are released from their duties and their duty to pay compensation when the breaking of the contract duties or failing to fulfill them is due to force majeure. A sufficient basis for the release from duty (force majeure) is an unusual event hindering the fulfilling of the contract that affects the matter, occurs after the contract is made, is independent of either party, and that cannot reasonably be avoided or overcome. Such events include war, rebellion, requisition or confiscation for general needs, termination of energy distribution, labor dispute, fire, thunderstorm or other natural phenomenon, cable damage caused by a third party, or another similarly effective and unusual event independent of either party. If the fulfilling of contract duty is delayed because of one of the abovementioned reasons, the period of fulfillment shall be extended for as long as is deemed reasonable with all the affecting circumstances in mind.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.12.6 Effective Date of Terms of Use.'
	        ),
	        '\xA0These terms of use are effective from 1.4.2017 and are effective until further notice. Terms of Use are available from the Company free of charge.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.7 Changes in Terms of Use.'
	        ),
	        '\xA0The Company can change these Terms of Use. The Customer will be notified of any new Terms of Use with customer notices and/or within the Service (for example, on the Service website at\xA0',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.pronouncelive.com' },
	          'www.pronouncelive.com'
	        ),
	        '). The changed Terms of Use will be applied to the contracts made before the effective date of the new terms.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Privacy Policy'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This privacy policy also serves as the registry declaration required by the Finnish Personal Data Act (523/1999) 10 \xA7.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '1. Name and Address of the Registry Keeper'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sanako Oy',
	        _react2.default.createElement('br', null),
	        ' Ratapihankatu 53C, FI 20100 Turku, Finland',
	        _react2.default.createElement('br', null),
	        ' Tel. +358 20 7939500'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '2. Person Responsible for Registry Issues'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Mark Barratt\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ',
	        _react2.default.createElement('br', null),
	        ' Ratapihankatu 53C, FI 20100 Turku, Finland',
	        _react2.default.createElement('br', null),
	        ' Tel. +358 50 576 4164'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '3. Name of Registry'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Customer registry of the Pronounce Live service ("Service").'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '4. Use of Information'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The registered information is for the care and maintenance of customer relations as well as the research and development of the company business and the Service by different methods of research. The information is used to send notices to customers and for direct advertising of the Company and its business partners, unless the Customer has forbidden such notices. The information can also be used to track and solve misuse issues.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '5. Information Source'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The personal information in the registry is acquired mainly from the users of the Service themselves, either directly or by the means of cookies (see section 10 below), in the following situations:',
	        _react2.default.createElement('br', null),
	        ' 1. when they subscribe to the newsletter,',
	        _react2.default.createElement('br', null),
	        ' 2. when they buy the chargeable parts of the Service,',
	        _react2.default.createElement('br', null),
	        ' 3. when they update their information and',
	        _react2.default.createElement('br', null),
	        ' 4. when they otherwise use the Service.',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        ' Information can also be gathered from and updated according to the registries of the Company and other companies belonging to the same concern, as well as third party registries (e.g. credit rating registry).'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '6. Validity of Information; Correcting of Information; Right to Verify'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Company does not verify the validity of the information. When logged in to the Service, the Customer has the option of checking and verifying the Customer\'s own registered personal information. The Customer cannot access other user information through the Service.',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        ' The Customer has the right to check and verify the personal information stored regarding to the Customer, or request that such information be corrected, by sending a written request to the address mentioned above.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '7. Information Content of Registry'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The registry contains the following information:',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        ' Customer information:',
	        _react2.default.createElement('br', null),
	        ' Name',
	        _react2.default.createElement('br', null),
	        ' Country',
	        _react2.default.createElement('br', null),
	        ' Email address',
	        _react2.default.createElement('br', null),
	        ' Any possible additional information provided by the Customer',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        ' Information concerning use:',
	        _react2.default.createElement('br', null),
	        ' Visits to the www.pronouncelive.com website, information related to studying and moving within the Service (username, time and IP address)',
	        _react2.default.createElement('br', null),
	        ' Computer-specific ID (the unique identifier of the computer from which the Customer logged in to the Service the last time)',
	        _react2.default.createElement('br', null),
	        ' Purchase events (username, purchased product, time)'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '8. Transfer of Information'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Company has the right to transfer necessary information to parties who handle the billing for services, products and content ordered or used through the Service. In addition, the Company has the right to transfer information to third parties for direct marketing, field sales and marketing and opinion research within legal boundaries. The Company also has the right to transfer information to another company within the same financial concern and as part of company reorganisation. Transfer of information to third parties for any other uses requires a separate agreement from the Customer.',
	        _react2.default.createElement('br', null),
	        ' The Company may use subcontractors to handle information, in which case the handling of information will be done according to Company guidelines and for and on behalf of the Company.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '9. Removing Information from the Registry'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Company will store customer and usage information for at least one (1) year after the Customer\'s last order has ended. After that, the information can be removed from the registry in database purges performed at intervals according to the Company\'s currently effective policy.',
	        _react2.default.createElement('br', null),
	        ' Regardless of the above, and for the sake of clarity, it must be noted that information regarding purchase events can be stored to the extent and for the time that the service provider deems it absolutely necessary for the fulfillment of its bookkeeping and other legally determined duties.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '10. Use of Cookies'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To track and make possible the use of the Service, so-called cookies may be sent to the Customer\'s computer from time to time. Cookies are used to recognize the Customer\'s computer and so provide a service that is better suited to the Customer\'s wishes and preferences. Cookies may also be used to offer the Customer better and more personal offers and product recommendations, either directly or through a third party, such as Google or Facebook. In addition, cookies are utilized in monitoring the number of Service users by the Company. Some parts of the content of the website will not function if cookies are not accepted.\xA0',
	        _react2.default.createElement('br', null),
	        ' ',
	        _react2.default.createElement('br', null),
	        ' At the moment, the Service is using the following Google Advertising Features: Remarketing, DoubleClick platform, Google Display network and Google Analytics reporting. For more information on cookies associated with Google services or opting out of Google Analytics Advertiser Features, visit http://www.google.fi/intl/en/policies/privacy/partners/ .'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '11. Registry Protection'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All persons handling the registry possess personal user permission (username, password and level of rights) from the registry keeper. The personal information of Customers is accessible only by persons who need this information to do their work. These include the customer service personnel and technical staff of the Service.',
	        _react2.default.createElement('br', null),
	        ' The Company will, to the best of its ability, strive to offer the Service in such a way that external parties will not get unlawful access to the Customer\'s information or communications. Other parties connected to providing the Service (e.g. network or mobile operators) are responsible for their own data security.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '12. Other Rights Related to Handling of Personal Information'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '12.1.\xA0'
	        ),
	        'The Customer may forbid the use and transfer of the Customer\'s personal information for direct marketing and survey purposes by contacting the Customer Service of the Company.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0'
	      )
	    )
	  );
	};
	
	exports.default = Terms;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectField = __webpack_require__(62);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(37);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _iso6391names = __webpack_require__(656);
	
	var _iso6391names2 = _interopRequireDefault(_iso6391names);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-return-assign: "off", max-len: "off" */
	
	
	var url = ("https://pronounce-live-admin.herokuapp.com/api/v1") + '/translate/';
	
	/* Displays translation controls and the translation itself for the currently visible text. */
	
	var Translation = function (_React$Component) {
	  _inherits(Translation, _React$Component);
	
	  function Translation(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Translation);
	
	    var _this = _possibleConstructorReturn(this, (Translation.__proto__ || Object.getPrototypeOf(Translation)).call(this, props));
	
	    _this.translate = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var text, sourceText, source_language, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              text = _this.props.text;
	
	              _this.setState({ loading: true });
	
	              if (!(_this.props.text.activeText === null)) {
	                _context.next = 4;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 4:
	              if (!(text.texts[text.activeText].translations && text.texts[text.activeText].translations[_this.state.target])) {
	                _context.next = 7;
	                break;
	              }
	
	              _this.setState({
	                loading: false,
	                translation: {
	                  text: text.texts[text.activeText].translations[_this.state.target]
	                }
	              });
	              return _context.abrupt('return');
	
	            case 7:
	              sourceText = text.texts[_this.props.text.activeText].source;
	              source_language = _this.props.source.substring(0, 2);
	              data = {
	                text: sourceText,
	                source_language: source_language,
	                target_language: _this.state.target
	              };
	
	
	              fetch(url, {
	                method: 'POST',
	                headers: {
	                  Accept: 'application/json, text/plain, */*',
	                  'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(data)
	              }).then(function (response) {
	                return response.json();
	              }).then(function (json) {
	                _this.setState({ loading: false, translation: json.translation });
	                var translation = {};
	                translation[_this.state.target] = json.translation.text;
	
	                _this.props.dispatch(_this.props.updateTranslation(translation));
	              }).catch(function (e) {
	                return _this.setState({ loading: false });
	              });
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.getSupportedLanguages = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var languageUrl, target, data;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              languageUrl = url + 'languages/';
	              target = _this.props.source.substring(0, 2);
	              data = {
	                target: target
	              };
	
	
	              fetch(languageUrl, {
	                method: 'POST',
	                headers: {
	                  Accept: 'application/json, text/plain, */*',
	                  'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(data)
	              }).then(function (response) {
	                return response.json();
	              }).then(function (json) {
	                var supportedLanguages = json.translation.map(function (l) {
	                  return l.code;
	                });
	                _this.setState({ supportedLanguages: supportedLanguages });
	              });
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	
	    _this.setTarget = function (target) {
	      return _this.setState({ target: target });
	    };
	
	    _this.renderLanguageOption = function (language, index) {
	      var disabled = _this.state.target === language || _this.props.source.substring(0, 2) === language;
	      return _react2.default.createElement(_MenuItem2.default, {
	        className: 'menu-language-option',
	        key: index,
	        value: language,
	        disabled: disabled,
	        label: _iso6391names2.default[language] || language,
	        primaryText: _iso6391names2.default[language] || language
	      });
	    };
	
	    _this.state = {
	      target: 'en',
	      loading: false,
	      translation: {},
	      supportedLanguages: []
	    };
	    return _this;
	  }
	
	  _createClass(Translation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSupportedLanguages();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.language != this.props.language) {
	        this.getSupportedLanguages();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var text = this.props.text;
	
	
	      var btnLabel = this.state.target ? 'Translate to ' + _iso6391names2.default[this.state.target] : 'Translate';
	
	      var disabled = this.state.loading || this.state.supportedLanguages.length === 0;
	
	      var translation = '';
	
	      if (text.texts[text.activeText].translations && text.texts[text.activeText].translations[this.state.target]) {
	        translation = text.texts[text.activeText].translations[this.state.target];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              position: 'relative',
	              display: 'flex',
	              flexDirection: 'row',
	              alignItems: 'flex-end',
	              justifyContent: 'center',
	              marginBottom: '8px'
	            }
	          },
	          _react2.default.createElement(
	            _SelectField2.default,
	            {
	              id: 'pronounce-translation-language-menu',
	              className: 'pronounce-language-menu',
	              style: { position: 'absolute', left: 0, width: '200px' },
	              autoWidth: true,
	              disabled: disabled,
	              value: this.state.target,
	              onChange: function onChange(e, index, value) {
	                return _this3.setTarget(value);
	              }
	            },
	            this.state.supportedLanguages.map(this.renderLanguageOption)
	          ),
	          _react2.default.createElement(_RaisedButton2.default, {
	            label: btnLabel,
	            style: { textAlign: 'center' },
	            disabled: disabled,
	            onTouchTap: this.translate
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card', style: { padding: '4px' } },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                padding: '8px',
	                textAlign: 'center',
	                fontSize: '18px',
	                minHeight: '23px'
	              }
	            },
	            this.state.loading && _react2.default.createElement(_CircularProgress2.default, { size: 20 }),
	            translation && _react2.default.createElement(
	              'span',
	              null,
	              translation
	            )
	          )
	        ),
	        _react2.default.createElement('img', {
	          style: { width: '200px', paddingTop: '4px', textAlign: 'center' },
	          src: '/images/google/greyscale-regular@3x.png',
	          alt: 'Translated by Google'
	        })
	      );
	    }
	  }]);
	
	  return Translation;
	}(_react2.default.Component);
	
	exports.default = Translation;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Redirect = __webpack_require__(101);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _Card = __webpack_require__(22);
	
	var _TextField = __webpack_require__(28);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _RaisedButton = __webpack_require__(31);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _CircularProgress = __webpack_require__(33);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _actions = __webpack_require__(20);
	
	var _apierrors = __webpack_require__(35);
	
	var _apierrors2 = _interopRequireDefault(_apierrors);
	
	var _geterrors = __webpack_require__(32);
	
	var _geterrors2 = _interopRequireDefault(_geterrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
	var emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	
	var TrialTokenRegistration = function (_Component) {
	  _inherits(TrialTokenRegistration, _Component);
	
	  function TrialTokenRegistration() {
	    _classCallCheck(this, TrialTokenRegistration);
	
	    var _this = _possibleConstructorReturn(this, (TrialTokenRegistration.__proto__ || Object.getPrototypeOf(TrialTokenRegistration)).call(this));
	
	    _this.validateForm = function (e) {
	      e.preventDefault();
	      var creds = {
	        key: _this.props.trialregistration.trialToken.token,
	        name: _this.state.form.name,
	        email: _this.state.form.email.value,
	        password: _this.state.form.password
	      };
	
	      _this.props.dispatch((0, _actions.registerTrialUser)(creds));
	    };
	
	    _this.handleForm = function (event) {
	      event.preventDefault();
	
	      var form = Object.assign({}, _this.state.form);
	
	      form.name = _this.nameInput.getValue();
	      form.email.value = _this.emailInput.getValue();
	      form.password = _this.pwInput.getValue();
	      form.password_confirmation = _this.pw_confInput.getValue();
	
	      var validEmail = form.email.value.match(emailRegexp);
	
	      if (validEmail) {
	        _this.props.dispatch((0, _actions.validateEmail)({ email: form.email.value }));
	      }
	
	      _this.setState({ form: form });
	    };
	
	    _this.renderForm = function () {
	      var email = _this.props.validation.email;
	
	      var disabled = _this.state.form.name.length < 2 || _this.state.form.password.length < 6 || _this.state.form.password_confirmation.length < 6 || _this.state.form.password !== _this.state.form.password_confirmation || !email.hasFetched || !email.isValid;
	
	      var _getErrors = (0, _geterrors2.default)(_this.props.trialregistration.errors),
	          validationErrors = _getErrors.validationErrors;
	
	      var localPassWordErrorMessage = _this.state.form.password.length > 6 && _this.state.form.password_confirmation.length > 6 && _this.state.form.password !== _this.state.form.password_confirmation ? 'Password confirmation does not match' : '';
	
	      var nameErrorMessage = _apierrors2.default[validationErrors.name] || validationErrors.name;
	      var emailErrorMessage = _apierrors2.default[validationErrors.email] || validationErrors.email;
	      var passwordErrorMessage = _apierrors2.default[validationErrors.password] || validationErrors.password || localPassWordErrorMessage;
	      var emailError = void 0;
	
	      if (!_this.state.form.email.value.match(emailRegexp)) {
	        emailError = 'This is not a valid email address';
	      }
	
	      if (email.hasFetched && !email.isValid) {
	        emailError = 'This address is already in use';
	      }
	      return _react2.default.createElement(
	        'form',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Register now to activate your ',
	          _this.props.trialregistration.trialToken.trialDays,
	          ' day free trial.'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _this.props.trialregistration.trialToken.description
	          )
	        ),
	        _react2.default.createElement(_TextField2.default, {
	          errorText: nameErrorMessage,
	          onChange: _this.handleForm,
	          ref: function ref(input) {
	            _this.nameInput = input;
	          },
	          floatingLabelText: 'Your name',
	          type: 'text',
	          name: 'name',
	          value: _this.state.form.name
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_TextField2.default, {
	          onChange: _this.handleForm,
	          ref: function ref(input) {
	            _this.emailInput = input;
	          },
	          errorText: emailError || emailErrorMessage,
	          floatingLabelText: 'Email',
	          type: 'email',
	          name: 'email',
	          value: _this.state.form.email.value
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_TextField2.default, {
	          errorText: passwordErrorMessage,
	          onChange: _this.handleForm,
	          ref: function ref(input) {
	            _this.pwInput = input;
	          },
	          type: 'password',
	          name: 'password',
	          floatingLabelText: 'Password',
	          hintText: 'At least 6 characters',
	          value: _this.state.form.password
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_TextField2.default, {
	          onChange: _this.handleForm,
	          ref: function ref(input) {
	            _this.pw_confInput = input;
	          },
	          type: 'password',
	          name: 'password_confirmation',
	          floatingLabelText: 'Password Confirmation',
	          hintText: 'Match the password field',
	          value: _this.state.form.password_confirmation
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_RaisedButton2.default, {
	          label: 'Create account',
	          disabled: disabled,
	          primary: true,
	          onTouchTap: _this.validateForm
	        })
	      );
	    };
	
	    _this.state = {
	      form: {
	        token: '',
	        name: '',
	        email: {
	          value: '',
	          error: ''
	        },
	        password: '',
	        password_confirmation: ''
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TrialTokenRegistration, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.trialregistration.hasValidated && !this.props.trialregistration.isFetchingValidation) {
	        var key = this.props.params.resetToken;
	        this.props.dispatch((0, _actions.validateTrialToken)({ key: key }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.auth.isAuthenticated) {
	        return _react2.default.createElement(_Redirect2.default, { to: '/' });
	      }
	
	      var content = void 0;
	
	      var resetToken = this.props.params.resetToken || '';
	      var isValidating = this.props.trialregistration.isFetchingValidation;
	
	      var _getErrors2 = (0, _geterrors2.default)(this.props.trialregistration.errors),
	          errorMessages = _getErrors2.errorMessages,
	          validationErrors = _getErrors2.validationErrors;
	
	      if (resetToken.length < 20) {
	        content = _react2.default.createElement(
	          'span',
	          null,
	          'Faulty token...'
	        );
	      } else if (isValidating) {
	        content = _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5 });
	      } else if (!this.props.trialregistration.hasValidated && this.props.trialregistration.errors.length > 0) {
	        content = errorMessages.map(function (error, index) {
	          return _react2.default.createElement(
	            'span',
	            { key: index },
	            _react2.default.createElement(
	              'strong',
	              null,
	              error
	            )
	          );
	        });
	
	        if (validationErrors.key) {
	          content = _react2.default.createElement(
	            'span',
	            { key: 'key' },
	            validationErrors.key[0]
	          );
	        }
	      } else if (this.props.trialregistration.hasValidated) {
	        content = this.renderForm();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'unregistered', key: 'trialregistration' },
	        _react2.default.createElement(
	          _Card.Card,
	          null,
	          _react2.default.createElement(_Card.CardHeader, { title: 'Start a free trial for Pronounce Live' }),
	          _react2.default.createElement(
	            _Card.CardText,
	            null,
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return TrialTokenRegistration;
	}(_react.Component);
	
	exports.default = TrialTokenRegistration;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(50);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Dialog = __webpack_require__(30);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(19);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Welcome = function Welcome(props) {
	  var imgStyle = {
	    verticalAlign: 'middle'
	  };
	  var actions = [_react2.default.createElement(_FlatButton2.default, {
	    label: 'Close',
	    primary: true,
	    onTouchTap: props.handleClose
	  })];
	
	  var customMessage = '';
	
	  if (props.auth.user.hasGroup) {
	    customMessage = _react2.default.createElement(
	      'span',
	      null,
	      'You are currently in group ',
	      props.auth.user.group.name,
	      '.'
	    );
	  }
	
	  if (props.auth.user.onTrial || props.auth.user.onGenericTrial) {
	    customMessage = _react2.default.createElement(
	      'span',
	      null,
	      'You are currently on your trial period. After that you need to get a subscription to access Pronounce Live - subscriptions are coming soon!'
	    );
	  }
	
	  if (!props.auth.user.onTrial && props.auth.user.hasActiveSubscription) {
	    customMessage = _react2.default.createElement(
	      'span',
	      null,
	      'Your subscription is currently valid. The subscription will be automatically renewed when it ends unless you cancel it beforehand.'
	    );
	  }
	
	  return _react2.default.createElement(
	    _Dialog2.default,
	    {
	      actions: actions,
	      modal: false,
	      open: props.open,
	      onRequestClose: props.handleClose,
	      autoScrollBodyContent: true
	    },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Welcome to Pronounce Live!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The easiest way to get started is to simply paste or type text in the text field and select a language for the text.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement('img', { alt: 'Pronounce Live example', src: '/images/welcome-example.png' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You are then ready for your first pronunciation exercise. '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement('img', { alt: 'Listen', style: imgStyle, src: '/images/welcome-listen.png' }),
	      ' Listen to the model pronunciation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement('img', { alt: 'Record', style: imgStyle, src: '/images/welcome-record.png' }),
	      ' Repeat after the model'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement('img', { alt: 'Play', style: imgStyle, src: '/images/welcome-play-your-take.png' }),
	      ' Review your performance'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Close this window to start!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      customMessage
	    )
	  );
	};
	
	exports.default = Welcome;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _redux = __webpack_require__(160);
	
	var _reactRedux = __webpack_require__(236);
	
	var _reduxThunk = __webpack_require__(712);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _MuiThemeProvider = __webpack_require__(206);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _reactTapEventPlugin = __webpack_require__(681);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _reducers = __webpack_require__(671);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _api = __webpack_require__(247);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _rollbar = __webpack_require__(659);
	
	var _rollbar2 = _interopRequireDefault(_rollbar);
	
	var _App = __webpack_require__(614);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _rollbar2.default)(); /* globals document */
	/* eslint react/jsx-filename-extension: "off" */
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, _api2.default)(_redux.createStore);
	var store = createStoreWithMiddleware(_reducers2.default);
	
	// Needed for onTouchTap
	// http://stackoverflow.com/a/34015469/988941
	(0, _reactTapEventPlugin2.default)();
	
	// Expose a small global config object - this is used just for Google
	// Analytics at the moment. Modifying it does nothing.
	window.pronounceConfig = {
	  lang: 'en-GB'
	};
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _MuiThemeProvider2.default,
	  null,
	  _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_App2.default, null)
	  )
	), document.getElementById('pronounce-app'));

/***/ },
/* 655 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var type = 'desktop';
	  var environment = 'browser';
	
	  var ua = navigator.userAgent;
	
	  if (phoneAndroid.test(ua)) {
	    type = 'phone';
	    environment = 'android';
	  }
	
	  if (tabletAndroid.test(ua)) {
	    type = 'tablet';
	    environment = 'android';
	  }
	
	  return {
	    type: type,
	    environment: environment
	  };
	};
	
	/* globals Regexp */
	var phoneAndroid = /(Android).*(Chrome\/[.0-9]).*(Mobile)/gi;
	var tabletAndroid = /(Android).*(Chrome\/[.0-9]).(?!.*Mobile).*/gi;

/***/ },
/* 656 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  af: 'Afrikaans',
	  sq: 'Albanian',
	  am: 'Amharic',
	  ar: 'Arabic',
	  hy: 'Armenian',
	  az: 'Azerbaijani',
	  eu: 'Basque',
	  be: 'Belarusian',
	  bn: 'Bengali',
	  bg: 'Bulgarian',
	  bs: 'Bosnian',
	  ca: 'Catalan',
	  ceb: 'Cebuano',
	  ny: 'Chewa',
	  zh: 'Chinese',
	  'zh-TW': 'Taiwanese',
	  co: 'Corsican',
	  hr: 'Croatian',
	  cs: 'Czech',
	  da: 'Danish',
	  nl: 'Dutch',
	  en: 'English',
	  eo: 'Esperanto',
	  et: 'Estonian',
	  tl: 'Tagalog',
	  fi: 'Finnish',
	  fr: 'French',
	  fy: 'Frisian',
	  gl: 'Galician',
	  ka: 'Georgian',
	  de: 'German',
	  el: 'Greek',
	  gu: 'Gujarati',
	  ht: 'Haitian',
	  ha: 'Hausa',
	  haw: 'Hawaiian',
	  iw: 'Hebrew',
	  hi: 'Hindi',
	  hmn: 'Hmong',
	  hu: 'Hungarian',
	  is: 'Icelandic',
	  ig: 'Igbo',
	  id: 'Indonesian',
	  ga: 'Irish',
	  it: 'Italian',
	  ja: 'Japanese',
	  jw: 'Javanese',
	  kn: 'Kannada',
	  km: 'Khmer',
	  kk: 'Kazakh',
	  ko: 'Korean',
	  ku: 'Kurdish',
	  ky: 'Kirghiz',
	  lo: 'Lao',
	  la: 'Latin',
	  lv: 'Latvian',
	  lt: 'Lithuanian',
	  lb: 'Luxembourgish',
	  mk: 'Macedonian',
	  mg: 'Malagasy',
	  ms: 'Malay',
	  ml: 'Malayalam',
	  mt: 'Maltese',
	  mi: 'Maori',
	  mr: 'Marathi',
	  mn: 'Mongolian',
	  my: 'Burmese',
	  ne: 'Nepali',
	  no: 'Norwegian',
	  ps: 'Pashto',
	  fa: 'Persian',
	  pl: 'Polish',
	  pt: 'Portuguese',
	  pa: 'Punjabi',
	  ro: 'Romanian',
	  ru: 'Russian',
	  sm: 'Samoan',
	  gd: 'Gaelic',
	  sr: 'Serbian',
	  st: 'Southern Sotho',
	  sn: 'Shona',
	  sd: 'Sindhi',
	  si: 'Sinhala',
	  sk: 'Slovak',
	  sl: 'Slovenian',
	  so: 'Somali',
	  es: 'Spanish',
	  su: 'Sundanese',
	  sw: 'Swahili',
	  sv: 'Swedish',
	  tg: 'Tajik',
	  ta: 'Tamil',
	  te: 'Telugu',
	  th: 'Thai',
	  tr: 'Turkish',
	  ur: 'Urdu',
	  uk: 'Ukrainian',
	  uz: 'Uzbek',
	  vi: 'Vietnamese',
	  cy: 'Welsh',
	  xh: 'Xhosa',
	  yo: 'Yoruba',
	  yi: 'Yiddish',
	  zu: 'Zulu'
	};

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Recorder = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint default-case: "off", eslint react/jsx-filename-extension: "off" */
	
	var _inlineWorker = __webpack_require__(389);
	
	var _inlineWorker2 = _interopRequireDefault(_inlineWorker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Recorder = exports.Recorder = function () {
	    function Recorder(source, cfg) {
	        var _this = this;
	
	        _classCallCheck(this, Recorder);
	
	        this.config = {
	            bufferLen: 4096,
	            numChannels: 2,
	            mimeType: 'audio/wav'
	        };
	        this.recording = false;
	        this.callbacks = {
	            getBuffer: [],
	            exportWAV: []
	        };
	
	        Object.assign(this.config, cfg);
	        this.context = source.context;
	        this.node = (this.context.createScriptProcessor || this.context.createJavaScriptNode).call(this.context, this.config.bufferLen, this.config.numChannels, this.config.numChannels);
	
	        this.node.onaudioprocess = function (e) {
	            if (!_this.recording) return;
	
	            var buffer = [];
	            for (var channel = 0; channel < _this.config.numChannels; channel++) {
	                buffer.push(e.inputBuffer.getChannelData(channel));
	            }
	            _this.worker.postMessage({
	                command: 'record',
	                buffer: buffer
	            });
	        };
	
	        source.connect(this.node);
	        this.node.connect(this.context.destination); //this should not be necessary
	
	        var self = {};
	        this.worker = new _inlineWorker2.default(function () {
	            var recLength = 0,
	                recBuffers = [],
	                sampleRate = void 0,
	                numChannels = void 0;
	
	            this.onmessage = function (e) {
	                switch (e.data.command) {
	                    case 'init':
	                        init(e.data.config);
	                        break;
	                    case 'record':
	                        record(e.data.buffer);
	                        break;
	                    case 'exportWAV':
	                        exportWAV(e.data.type);
	                        break;
	                    case 'getBuffer':
	                        getBuffer();
	                        break;
	                    case 'clear':
	                        clear();
	                        break;
	                }
	            };
	
	            function init(config) {
	                sampleRate = config.sampleRate;
	                numChannels = config.numChannels;
	                initBuffers();
	            }
	
	            function record(inputBuffer) {
	                for (var channel = 0; channel < numChannels; channel++) {
	                    recBuffers[channel].push(inputBuffer[channel]);
	                }
	                recLength += inputBuffer[0].length;
	            }
	
	            function exportWAV(type) {
	                var buffers = [];
	                for (var channel = 0; channel < numChannels; channel++) {
	                    buffers.push(mergeBuffers(recBuffers[channel], recLength));
	                }
	                var interleaved = void 0;
	                if (numChannels === 2) {
	                    interleaved = interleave(buffers[0], buffers[1]);
	                } else {
	                    interleaved = buffers[0];
	                }
	                var dataview = encodeWAV(interleaved);
	                var audioBlob = new Blob([dataview], { type: type });
	
	                this.postMessage({ command: 'exportWAV', data: audioBlob });
	            }
	
	            function getBuffer() {
	                var buffers = [];
	                for (var channel = 0; channel < numChannels; channel++) {
	                    buffers.push(mergeBuffers(recBuffers[channel], recLength));
	                }
	                this.postMessage({ command: 'getBuffer', data: buffers });
	            }
	
	            function clear() {
	                recLength = 0;
	                recBuffers = [];
	                initBuffers();
	            }
	
	            function initBuffers() {
	                for (var channel = 0; channel < numChannels; channel++) {
	                    recBuffers[channel] = [];
	                }
	            }
	
	            function mergeBuffers(recBuffers, recLength) {
	                var result = new Float32Array(recLength);
	                var offset = 0;
	                for (var i = 0; i < recBuffers.length; i++) {
	                    result.set(recBuffers[i], offset);
	                    offset += recBuffers[i].length;
	                }
	                return result;
	            }
	
	            function interleave(inputL, inputR) {
	                var length = inputL.length + inputR.length;
	                var result = new Float32Array(length);
	
	                var index = 0,
	                    inputIndex = 0;
	
	                while (index < length) {
	                    result[index++] = inputL[inputIndex];
	                    result[index++] = inputR[inputIndex];
	                    inputIndex++;
	                }
	                return result;
	            }
	
	            function floatTo16BitPCM(output, offset, input) {
	                for (var i = 0; i < input.length; i++, offset += 2) {
	                    var s = Math.max(-1, Math.min(1, input[i]));
	                    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
	                }
	            }
	
	            function writeString(view, offset, string) {
	                for (var i = 0; i < string.length; i++) {
	                    view.setUint8(offset + i, string.charCodeAt(i));
	                }
	            }
	
	            function encodeWAV(samples) {
	                var buffer = new ArrayBuffer(44 + samples.length * 2);
	                var view = new DataView(buffer);
	
	                /* RIFF identifier */
	                writeString(view, 0, 'RIFF');
	                /* RIFF chunk length */
	                view.setUint32(4, 36 + samples.length * 2, true);
	                /* RIFF type */
	                writeString(view, 8, 'WAVE');
	                /* format chunk identifier */
	                writeString(view, 12, 'fmt ');
	                /* format chunk length */
	                view.setUint32(16, 16, true);
	                /* sample format (raw) */
	                view.setUint16(20, 1, true);
	                /* channel count */
	                view.setUint16(22, numChannels, true);
	                /* sample rate */
	                view.setUint32(24, sampleRate, true);
	                /* byte rate (sample rate * block align) */
	                view.setUint32(28, sampleRate * 4, true);
	                /* block align (channel count * bytes per sample) */
	                view.setUint16(32, numChannels * 2, true);
	                /* bits per sample */
	                view.setUint16(34, 16, true);
	                /* data chunk identifier */
	                writeString(view, 36, 'data');
	                /* data chunk length */
	                view.setUint32(40, samples.length * 2, true);
	
	                floatTo16BitPCM(view, 44, samples);
	
	                return view;
	            }
	        }, self);
	
	        this.worker.postMessage({
	            command: 'init',
	            config: {
	                sampleRate: this.context.sampleRate,
	                numChannels: this.config.numChannels
	            }
	        });
	
	        this.worker.onmessage = function (e) {
	            var cb = _this.callbacks[e.data.command].pop();
	            if (typeof cb == 'function') {
	                cb(e.data.data);
	            }
	        };
	    }
	
	    _createClass(Recorder, [{
	        key: 'record',
	        value: function record() {
	            this.recording = true;
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.recording = false;
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            this.worker.postMessage({ command: 'clear' });
	        }
	    }, {
	        key: 'getBuffer',
	        value: function getBuffer(cb) {
	            cb = cb || this.config.callback;
	            if (!cb) throw new Error('Callback not set');
	
	            this.callbacks.getBuffer.push(cb);
	
	            this.worker.postMessage({ command: 'getBuffer' });
	        }
	    }, {
	        key: 'exportWAV',
	        value: function exportWAV(cb, mimeType) {
	            mimeType = mimeType || this.config.mimeType;
	            cb = cb || this.config.callback;
	            if (!cb) throw new Error('Callback not set');
	
	            this.callbacks.exportWAV.push(cb);
	
	            this.worker.postMessage({
	                command: 'exportWAV',
	                type: mimeType
	            });
	        }
	    }], [{
	        key: 'forceDownload',
	        value: function forceDownload(blob, filename) {
	            var url = (window.URL || window.webkitURL).createObjectURL(blob);
	            var link = window.document.createElement('a');
	            link.href = url;
	            link.download = filename || 'output.wav';
	            var click = document.createEvent("Event");
	            click.initEvent("click", true, true);
	            link.dispatchEvent(click);
	        }
	    }]);
	
	    return Recorder;
	}();
	
	exports.default = Recorder;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recorder = __webpack_require__(657);
	
	var _recorder2 = _interopRequireDefault(_recorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var input = void 0; /* eslint import/no-named-as-default: "off",
	                              import/no-named-as-default-member: "off",
	                              no-console: "off",
	                              no-unused-expressions: "off"
	                    */
	
	var recorderInstance = void 0;
	var audioContext = void 0;
	var onEndCallBack = null;
	var source = null;
	
	var recorderPlayer = {
	  startRecording: function startRecording(func) {
	    console.log('start recording');
	    this.setOnEndCallBack(func);
	    recorderInstance && recorderInstance.record();
	  },
	  stopRecording: function stopRecording() {
	    recorderInstance && recorderInstance.stop();
	    this.saveStream();
	    recorderInstance && recorderInstance.clear();
	  },
	  saveStream: function saveStream() {
	    recorderInstance.getBuffer(function (buffers) {
	      if (buffers.length > 0 && buffers[0].length > 0) {
	        var newBuffer = audioContext.createBuffer(1, buffers[0].length, audioContext.sampleRate);
	        newBuffer.getChannelData(0).set(buffers[0]);
	
	        onEndCallBack(newBuffer, buffers);
	      }
	    });
	  },
	  play: function play(audioBuffer, callback) {
	    console.log('playing recording');
	    source = audioContext.createBufferSource();
	
	    source.buffer = audioBuffer;
	    source.loop = false;
	    source.connect(audioContext.destination);
	
	    source.start();
	    source.onended = callback;
	  },
	  stop: function stop() {
	    if (source !== null) {
	      source.stop();
	      source = null;
	    }
	  },
	  init: function init(audioCtx, onPermissionCallBack) {
	    audioContext = audioCtx;
	    this.setup(onPermissionCallBack);
	  },
	  setup: function setup(onPermissionCallBack) {
	    var getMic = navigator.mediaDevices.getUserMedia({
	      audio: true
	    });
	
	    getMic.then(function (mediaStream) {
	      input = audioContext.createMediaStreamSource(mediaStream);
	      recorderInstance = new _recorder2.default(input);
	      onPermissionCallBack(true);
	    });
	
	    getMic.catch(function (err) {
	      console.error(err.name);
	      onPermissionCallBack(false);
	    });
	  },
	  setOnEndCallBack: function setOnEndCallBack(func) {
	    if (typeof func === 'function') {
	      onEndCallBack = func;
	    }
	  }
	};
	
	exports.default = recorderPlayer;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = setupRollbar;
	
	var _herokuJsRuntimeEnv = __webpack_require__(161);
	
	var _herokuJsRuntimeEnv2 = _interopRequireDefault(_herokuJsRuntimeEnv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setupRollbar() {
	  var env = (0, _herokuJsRuntimeEnv2.default)();
	
	  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && navigator.userAgent.toLowerCase().indexOf('edge') === -1 && navigator.userAgent.toLowerCase().indexOf('opr') === -1;
	  var herokuReleaseVersion = env.REACT_APP_HEROKU_RELEASE_VERSION;
	
	  if (isChrome && typeof herokuReleaseVersion !== 'undefined') {
	    var _rollbarConfig = {
	      accessToken: '67a46a30f98e4ef28d75d160fd823ecb',
	      captureUncaught: true,
	      captureUnhandledRejections: true,
	      payload: {
	        environment: env.NODE_ENV,
	        client: {
	          javascript: {
	            source_map_enabled: true,
	            code_version: herokuReleaseVersion,
	            // Optionally have Rollbar guess which frames the error was thrown from
	            // when the browser does not provide line and column numbers.
	            guess_uncaught_frames: true
	          }
	        }
	      }
	    };
	    // Rollbar Snippet
	    !function (r) {
	      function e(n) {
	        if (o[n]) return o[n].exports;var t = o[n] = { exports: {}, id: n, loaded: !1 };return r[n].call(t.exports, t, t.exports, e), t.loaded = !0, t.exports;
	      }var o = {};return e.m = r, e.c = o, e.p = "", e(0);
	    }([function (r, e, o) {
	      "use strict";
	      var n = o(1).Rollbar,
	          t = o(2);_rollbarConfig.rollbarJsUrl = _rollbarConfig.rollbarJsUrl || "https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/1.9.3/rollbar.min.js";var a = n.init(window, _rollbarConfig),
	          i = t(a, _rollbarConfig);a.loadFull(window, document, !_rollbarConfig.async, _rollbarConfig, i);
	    }, function (r, e) {
	      "use strict";
	      function o(r) {
	        return function () {
	          try {
	            return r.apply(this, arguments);
	          } catch (r) {
	            try {
	              console.error("[Rollbar]: Internal error", r);
	            } catch (r) {}
	          }
	        };
	      }function n(r, e, o) {
	        window._rollbarWrappedError && (o[4] || (o[4] = window._rollbarWrappedError), o[5] || (o[5] = window._rollbarWrappedError._rollbarContext), window._rollbarWrappedError = null), r.uncaughtError.apply(r, o), e && e.apply(window, o);
	      }function t(r) {
	        var e = function e() {
	          var e = Array.prototype.slice.call(arguments, 0);n(r, r._rollbarOldOnError, e);
	        };return e.belongsToShim = !0, e;
	      }function a(r) {
	        this.shimId = ++c, this.notifier = null, this.parentShim = r, this._rollbarOldOnError = null;
	      }function i(r) {
	        var e = a;return o(function () {
	          if (this.notifier) return this.notifier[r].apply(this.notifier, arguments);var o = this,
	              n = "scope" === r;n && (o = new e(this));var t = Array.prototype.slice.call(arguments, 0),
	              a = { shim: o, method: r, args: t, ts: new Date() };return window._rollbarShimQueue.push(a), n ? o : void 0;
	        });
	      }function l(r, e) {
	        if (e.hasOwnProperty && e.hasOwnProperty("addEventListener")) {
	          var o = e.addEventListener;e.addEventListener = function (e, n, t) {
	            o.call(this, e, r.wrap(n), t);
	          };var n = e.removeEventListener;e.removeEventListener = function (r, e, o) {
	            n.call(this, r, e && e._wrapped ? e._wrapped : e, o);
	          };
	        }
	      }var c = 0;a.init = function (r, e) {
	        var n = e.globalAlias || "Rollbar";if ("object" == _typeof(r[n])) return r[n];r._rollbarShimQueue = [], r._rollbarWrappedError = null, e = e || {};var i = new a();return o(function () {
	          if (i.configure(e), e.captureUncaught) {
	            i._rollbarOldOnError = r.onerror, r.onerror = t(i);var o,
	                a,
	                c = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for (o = 0; o < c.length; ++o) {
	              a = c[o], r[a] && r[a].prototype && l(i, r[a].prototype);
	            }
	          }return e.captureUnhandledRejections && (i._unhandledRejectionHandler = function (r) {
	            var e = r.reason,
	                o = r.promise,
	                n = r.detail;!e && n && (e = n.reason, o = n.promise), i.unhandledRejection(e, o);
	          }, r.addEventListener("unhandledrejection", i._unhandledRejectionHandler)), r[n] = i, i;
	        })();
	      }, a.prototype.loadFull = function (r, e, n, t, a) {
	        var i = function i() {
	          var e;if (void 0 === r._rollbarPayloadQueue) {
	            var o, n, t, i;for (e = new Error("rollbar.js did not load"); o = r._rollbarShimQueue.shift();) {
	              for (t = o.args, i = 0; i < t.length; ++i) {
	                if (n = t[i], "function" == typeof n) {
	                  n(e);break;
	                }
	              }
	            }
	          }"function" == typeof a && a(e);
	        },
	            l = !1,
	            c = e.createElement("script"),
	            p = e.getElementsByTagName("script")[0],
	            s = p.parentNode;c.crossOrigin = "", c.src = t.rollbarJsUrl, c.async = !n, c.onload = c.onreadystatechange = o(function () {
	          if (!(l || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState)) {
	            c.onload = c.onreadystatechange = null;try {
	              s.removeChild(c);
	            } catch (r) {}l = !0, i();
	          }
	        }), s.insertBefore(c, p);
	      }, a.prototype.wrap = function (r, e) {
	        try {
	          var o;if (o = "function" == typeof e ? e : function () {
	            return e || {};
	          }, "function" != typeof r) return r;if (r._isWrap) return r;if (!r._wrapped) {
	            r._wrapped = function () {
	              try {
	                return r.apply(this, arguments);
	              } catch (e) {
	                throw "string" == typeof e && (e = new String(e)), e._rollbarContext = o() || {}, e._rollbarContext._wrappedSource = r.toString(), window._rollbarWrappedError = e, e;
	              }
	            }, r._wrapped._isWrap = !0;for (var n in r) {
	              r.hasOwnProperty(n) && (r._wrapped[n] = r[n]);
	            }
	          }return r._wrapped;
	        } catch (e) {
	          return r;
	        }
	      };for (var p = "log,debug,info,warn,warning,error,critical,global,configure,scope,uncaughtError,unhandledRejection".split(","), s = 0; s < p.length; ++s) {
	        a.prototype[p[s]] = i(p[s]);
	      }r.exports = { Rollbar: a, _rollbarWindowOnError: n };
	    }, function (r, e) {
	      "use strict";
	      r.exports = function (r, e) {
	        return function (o) {
	          if (!o && !window._rollbarInitialized) {
	            var n = window.RollbarNotifier,
	                t = e || {},
	                a = t.globalAlias || "Rollbar",
	                i = window.Rollbar.init(t, r);i._processShimQueue(window._rollbarShimQueue || []), window[a] = i, window._rollbarInitialized = !0, n.processPayloads();
	          }
	        };
	      };
	    }]);
	    // End Rollbar Snippet
	  }
	}

/***/ },
/* 660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global webkitSpeechRecognition */
	/* eslint no-console: "off" */
	
	var recognition = void 0;
	var results = null;
	var hasFinished = true;
	var confidence = void 0;
	var onEndCallback = null;
	var onErrorCallback = null;
	
	var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition;
	
	var recognize = function recognizeInit() {
	  if (typeof SpeechRecognition === 'function') {
	    recognition = new SpeechRecognition(); // eslint-disable-line new-cap
	    recognition.continuous = true;
	    recognition.interimResults = true;
	  } else {
	    recognition = {};
	  }
	
	  recognition.onstart = function onRecognitionStart() {
	    console.log('speech recognition - onstart event.');
	    hasFinished = false;
	  };
	
	  recognition.onresult = function onRecognitionResult(event) {
	    console.log('speech recognition - onresult event.');
	    var finalResults = '';
	    var finalConfidence = void 0;
	    var interimResults = '';
	
	    for (var i = event.resultIndex; i < event.results.length; ++i) {
	      if (event.results[i].isFinal) {
	        finalResults += event.results[i][0].transcript;
	        finalConfidence = event.results[i][0].confidence;
	      } else {
	        interimResults += event.results[i][0].transcript;
	      }
	    }
	    results = finalResults || interimResults;
	    confidence = finalConfidence;
	  };
	
	  recognition.onerror = function onRecognitionError(event) {
	    console.error(event.error);
	    console.error(event.message);
	    hasFinished = true;
	
	    if (typeof onEndCallback === 'function') {
	      onErrorCallback(event.error);
	    }
	  };
	
	  recognition.onend = function onRecognitionEnd() {
	    console.log('speech recognition - onend event.');
	    hasFinished = true;
	    if (typeof onEndCallback === 'function') {
	      onEndCallback();
	    }
	  };
	
	  recognition.onaudiostart = function () {
	    console.log('Speech recognition - audiostart event.');
	  };
	  recognition.onaudioend = function () {
	    console.log('Speech recognition - audioend event.');
	  };
	  recognition.onnomatch = function () {
	    console.log('Speech recognition - nomatch event.');
	  };
	  recognition.onsoundstart = function () {
	    console.log('Speech recognition - onsoundstart event.');
	  };
	  recognition.onsoundend = function () {
	    console.log('Speech recognition - onsoundend event.');
	  };
	  recognition.onspeechstart = function () {
	    console.log('Speech recognition - onspeechstart event.');
	  };
	  recognition.onspeechend = function () {
	    console.log('Speech recognition - onspeechend event.');
	  };
	
	  function start(lang) {
	    recognition.lang = lang;
	    console.log('recognise in ' + lang);
	    recognition.start();
	  }
	
	  function stop() {
	    recognition.stop();
	  }
	
	  function getResults() {
	    return {
	      result: results,
	      confidence: confidence || 0
	    };
	  }
	
	  function reset() {
	    results = null;
	    confidence = 0;
	  }
	
	  function setOnEndCallback(func) {
	    if (typeof func === 'function') {
	      onEndCallback = func;
	    }
	  }
	
	  function setOnErrorCallback(func) {
	    if (typeof func === 'function') {
	      onErrorCallback = func;
	    }
	  }
	
	  return {
	    start: start,
	    stop: stop,
	    reset: reset,
	    getResults: getResults,
	    hasFinished: hasFinished,
	    setOnEndCallback: setOnEndCallback,
	    setOnErrorCallback: setOnErrorCallback
	  };
	}();
	
	exports.default = recognize;

/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function supportsRecording() {
	  return _typeof(navigator.mediaDevices) === 'object' && typeof navigator.mediaDevices.getUserMedia === 'function';
	}
	
	function supportsTTS() {
	  return 'speechSynthesis' in window;
	}
	
	function supportsSpeechRecognition() {
	  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition;
	
	  return typeof SpeechRecognition === 'function';
	}
	
	exports.default = {
	  recording: supportsRecording,
	  tts: supportsTTS,
	  speechRecognition: supportsSpeechRecognition
	};

/***/ },
/* 662 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * Replaces periods with a considered-safe group of characters
	 * from the array defined in the second parameter
	 */
	var makeSpecialCasesSafe = function makeSpecialCasesSafe(string, cases) {
	  var safe = string;
	  var regex = void 0;
	  cases.forEach(function (cas) {
	    var replacement = cas.replace(/\./g, '****');
	    regex = new RegExp(cas, 'g');
	    safe = safe.replace(regex, replacement);
	  });
	
	  return safe;
	};
	/*
	 * Restores periods to the array defined in the second parameter
	 */
	var revertSpecialCases = function revertSpecialCases(string, cases) {
	  var reverted = string;
	  var regex = void 0;
	  cases.forEach(function (cas) {
	    var replacement = cas.replace(/\./g, '\\*\\*\\*\\*');
	    regex = new RegExp(replacement, 'g');
	    reverted = reverted.replace(regex, cas);
	  });
	  return reverted;
	};
	
	var cleanText = function cleanText(text) {
	  return text.replace(/\s+/g, ' ');
	};
	
	var splitText = function splitText(text) {
	  var split = text.trim();
	  // Handle special cases - words that contain periods
	  // TO DO - more coverate with this list
	  var specialCases = ['Dr.', 'Mr.', 'Mrs.', 'St. ', 'Rd. ', 'Ct. '];
	  var re = /(["']?([А-Я]|[A-ZÁÉÍÓÚÜÑÇ])[^.?!]+((?![.?!]['"]?\s["']?([А-Я]|[A-ZÁÉÍÓÚÜÑÇ]|[¿¡])[^.?!]).)+[.?!'"]+[.?!'"]?)/igm;
	  var reZh = /([｡。！？])/gm;
	
	  split = makeSpecialCasesSafe(split, specialCases);
	  split = split.replace(re, '$1|');
	  split = revertSpecialCases(split, specialCases);
	  split = split.replace(reZh, '$1|');
	  split = split.split('|');
	  split = split.filter(function (v) {
	    return v !== '';
	  });
	  return split;
	};
	
	var formatText = function formatText(text) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-gb';
	
	  var formatted = text;
	  formatted = cleanText(formatted);
	  formatted = splitText(formatted, lang);
	
	  if (formatted.length === 0) {
	    return [{
	      source: '',
	      results: [],
	      audioBuffer: null
	    }];
	  }
	
	  var formattedText = formatted.map(function (sentence) {
	    var singularText = {
	      source: sentence.trim(),
	      results: [],
	      audioBuffer: null
	    };
	
	    return singularText;
	  });
	
	  return formattedText;
	};
	
	exports.default = formatText;

/***/ },
/* 663 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  'name': 'Pacific/Midway',
	  'timezone': 'GMT-11:00'
	}, {
	  'name': 'US/Samoa',
	  'timezone': 'GMT-11:00'
	}, {
	  'name': 'US/Hawaii',
	  'timezone': 'GMT-10:00'
	}, {
	  'name': 'US/Alaska',
	  'timezone': 'GMT-09:00'
	}, {
	  'name': 'US/Pacific',
	  'timezone': 'GMT-08:00'
	}, {
	  'name': 'America/Tijuana',
	  'timezone': 'GMT-08:00'
	}, {
	  'name': 'US/Arizona',
	  'timezone': 'GMT-07:00'
	}, {
	  'name': 'US/Mountain',
	  'timezone': 'GMT-07:00'
	}, {
	  'name': 'America/Chihuahua',
	  'timezone': 'GMT-07:00'
	}, {
	  'name': 'America/Mazatlan',
	  'timezone': 'GMT-07:00'
	}, {
	  'name': 'America/Mexico_City',
	  'timezone': 'GMT-06:00'
	}, {
	  'name': 'America/Monterrey',
	  'timezone': 'GMT-06:00'
	}, {
	  'name': 'Canada/Saskatchewan',
	  'timezone': 'GMT-06:00'
	}, {
	  'name': 'US/Central',
	  'timezone': 'GMT-06:00'
	}, {
	  'name': 'US/Eastern',
	  'timezone': 'GMT-05:00'
	}, {
	  'name': 'US/East-Indiana',
	  'timezone': 'GMT-05:00'
	}, {
	  'name': 'America/Bogota',
	  'timezone': 'GMT-05:00'
	}, {
	  'name': 'America/Lima',
	  'timezone': 'GMT-05:00'
	}, {
	  'name': 'America/Caracas',
	  'timezone': 'GMT-04:30'
	}, {
	  'name': 'Canada/Atlantic',
	  'timezone': 'GMT-04:00'
	}, {
	  'name': 'America/La_Paz',
	  'timezone': 'GMT-04:00'
	}, {
	  'name': 'America/Santiago',
	  'timezone': 'GMT-04:00'
	}, {
	  'name': 'Canada/Newfoundland',
	  'timezone': 'GMT-03:30'
	}, {
	  'name': 'America/Buenos_Aires',
	  'timezone': 'GMT-03:00'
	}, {
	  'name': 'Greenland',
	  'timezone': 'GMT-03:00'
	}, {
	  'name': 'Atlantic/Stanley',
	  'timezone': 'GMT-02:00'
	}, {
	  'name': 'Atlantic/Azores',
	  'timezone': 'GMT-01:00'
	}, {
	  'name': 'Atlantic/Cape_Verde',
	  'timezone': 'GMT-01:00'
	}, {
	  'name': 'Africa/Casablanca',
	  'timezone': 'GMT'
	}, {
	  'name': 'Europe/Dublin',
	  'timezone': 'GMT'
	}, {
	  'name': 'Europe/Lisbon',
	  'timezone': 'GMT'
	}, {
	  'name': 'Europe/London',
	  'timezone': 'GMT'
	}, {
	  'name': 'Africa/Monrovia',
	  'timezone': 'GMT'
	}, {
	  'name': 'Europe/Amsterdam',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Belgrade',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Berlin',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Bratislava',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Brussels',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Budapest',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Copenhagen',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Ljubljana',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Madrid',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Paris',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Prague',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Rome',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Sarajevo',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Skopje',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Stockholm',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Vienna',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Warsaw',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Zagreb',
	  'timezone': 'GMT+01:00'
	}, {
	  'name': 'Europe/Athens',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Bucharest',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Africa/Cairo',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Africa/Harare',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Helsinki',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Istanbul',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Asia/Jerusalem',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Kiev',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Minsk',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Riga',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Sofia',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Tallinn',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Europe/Vilnius',
	  'timezone': 'GMT+02:00'
	}, {
	  'name': 'Asia/Baghdad',
	  'timezone': 'GMT+03:00'
	}, {
	  'name': 'Asia/Kuwait',
	  'timezone': 'GMT+03:00'
	}, {
	  'name': 'Africa/Nairobi',
	  'timezone': 'GMT+03:00'
	}, {
	  'name': 'Asia/Riyadh',
	  'timezone': 'GMT+03:00'
	}, {
	  'name': 'Europe/Moscow',
	  'timezone': 'GMT+03:00'
	}, {
	  'name': 'Asia/Tehran',
	  'timezone': 'GMT+03:30'
	}, {
	  'name': 'Asia/Baku',
	  'timezone': 'GMT+04:00'
	}, {
	  'name': 'Europe/Volgograd',
	  'timezone': 'GMT+04:00'
	}, {
	  'name': 'Asia/Muscat',
	  'timezone': 'GMT+04:00'
	}, {
	  'name': 'Asia/Tbilisi',
	  'timezone': 'GMT+04:00'
	}, {
	  'name': 'Asia/Yerevan',
	  'timezone': 'GMT+04:00'
	}, {
	  'name': 'Asia/Kabul',
	  'timezone': 'GMT+04:30'
	}, {
	  'name': 'Asia/Karachi',
	  'timezone': 'GMT+05:00'
	}, {
	  'name': 'Asia/Tashkent',
	  'timezone': 'GMT+05:00'
	}, {
	  'name': 'Asia/Kolkata',
	  'timezone': 'GMT+05:30'
	}, {
	  'name': 'Asia/Kathmandu',
	  'timezone': 'GMT+05:45'
	}, {
	  'name': 'Asia/Yekaterinburg',
	  'timezone': 'GMT+06:00'
	}, {
	  'name': 'Asia/Almaty',
	  'timezone': 'GMT+06:00'
	}, {
	  'name': 'Asia/Dhaka',
	  'timezone': 'GMT+06:00'
	}, {
	  'name': 'Asia/Novosibirsk',
	  'timezone': 'GMT+07:00'
	}, {
	  'name': 'Asia/Bangkok',
	  'timezone': 'GMT+07:00'
	}, {
	  'name': 'Asia/Jakarta',
	  'timezone': 'GMT+07:00'
	}, {
	  'name': 'Asia/Krasnoyarsk',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Chongqing',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Hong_Kong',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Kuala_Lumpur',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Australia/Perth',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Singapore',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Taipei',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Ulaanbaatar',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Urumqi',
	  'timezone': 'GMT+08:00'
	}, {
	  'name': 'Asia/Irkutsk',
	  'timezone': 'GMT+09:00'
	}, {
	  'name': 'Asia/Seoul',
	  'timezone': 'GMT+09:00'
	}, {
	  'name': 'Asia/Tokyo',
	  'timezone': 'GMT+09:00'
	}, {
	  'name': 'Australia/Adelaide',
	  'timezone': 'GMT+09:30'
	}, {
	  'name': 'Australia/Darwin',
	  'timezone': 'GMT+09:30'
	}, {
	  'name': 'Asia/Yakutsk',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Australia/Brisbane',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Australia/Canberra',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Pacific/Guam',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Australia/Hobart',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Australia/Melbourne',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Pacific/Port_Moresby',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Australia/Sydney',
	  'timezone': 'GMT+10:00'
	}, {
	  'name': 'Asia/Vladivostok',
	  'timezone': 'GMT+11:00'
	}, {
	  'name': 'Asia/Magadan',
	  'timezone': 'GMT+12:00'
	}, {
	  'name': 'Pacific/Auckland',
	  'timezone': 'GMT+12:00'
	}, {
	  'name': 'Pacific/Fiji',
	  'timezone': 'GMT+12:00'
	}];

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	var _getjwtdata = __webpack_require__(155);
	
	var _getjwtdata2 = _interopRequireDefault(_getjwtdata);
	
	var _store = __webpack_require__(251);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// The auth reducer. The starting state sets authentication
	// based on a token being in local storage. In a real app,
	// we would also want a util to check if the token is expired.
	function auth() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    isFetchingPassword: false,
	    isAuthenticated: localStorage.getItem('token') ? _getjwtdata2.default.verify(localStorage.getItem('token')) : false,
	    user: localStorage.getItem('token') ? _getjwtdata2.default.decode(localStorage.getItem('token')) : {},
	    localData: localStorage.getItem('token') ? _store2.default.get(_getjwtdata2.default.decode(localStorage.getItem('token')).id) : {},
	    rememberUser: localStorage.getItem('token'),
	    errors: [],
	    passwordEmail: {
	      isFetching: false,
	      hasFetched: false,
	      isSuccess: false,
	      errors: []
	    },
	    passwordReset: {
	      isFetching: false,
	      hasFetched: false,
	      isSuccess: false,
	      errors: []
	    }
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LOGIN_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isAuthenticated: false,
	        user: {},
	        errors: []
	      });
	    case types.LOGIN_SUCCESS:
	      ;
	      return Object.assign({}, state, {
	        isFetching: false,
	        isAuthenticated: true,
	        user: action.user,
	        localData: action.localData,
	        errors: []
	      });
	    case types.LOGIN_REFRESH:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isAuthenticated: true,
	        user: action.user,
	        errors: []
	      });
	    case types.HAS_LOGGED_IN:
	      _store2.default.set(state.user.id, Object.assign({}, state.localData, { hasLoggedIn: action.hasLoggedIn }));
	      return Object.assign({}, state, {
	        localData: Object.assign({}, state.localData, { hasLoggedIn: action.hasLoggedIn })
	      });
	
	    case types.LOGIN_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isAuthenticated: false,
	        user: {},
	        errors: action.errors
	      });
	
	    case types.LOGOUT_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case types.LOGOUT_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isAuthenticated: false,
	        user: {}
	      });
	
	    case types.LOGOUT_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        errors: action.errors
	      });
	
	    case types.PASSWORD_EMAIL_REQUEST:
	      return Object.assign({}, state, {
	        passwordEmail: {
	          isFetching: true,
	          hasFetched: false,
	          isSuccess: false,
	          errors: []
	        }
	      });
	
	    case types.PASSWORD_EMAIL_SUCCESS:
	      return Object.assign({}, state, {
	        passwordEmail: {
	          isFetching: false,
	          hasFetched: true,
	          isSuccess: true,
	          errors: []
	        }
	      });
	
	    case types.PASSWORD_EMAIL_FAILURE:
	      return Object.assign({}, state, {
	        passwordEmail: {
	          isFetching: false,
	          hasFetched: true,
	          isSuccess: false,
	          errors: action.errors
	        }
	      });
	
	    case types.PASSWORD_RESET_REQUEST:
	      return Object.assign({}, state, {
	        passwordReset: {
	          isFetching: true,
	          hasFetched: false,
	          isSuccess: false
	        }
	      });
	
	    case types.PASSWORD_RESET_SUCCESS:
	      return Object.assign({}, state, {
	        passwordReset: {
	          isFetching: false,
	          hasFetched: true,
	          isSuccess: true
	        }
	      });
	
	    case types.PASSWORD_RESET_FAILURE:
	      return Object.assign({}, state, {
	        passwordReset: {
	          isFetching: false,
	          hasFetched: true,
	          isSuccess: false,
	          errors: action.errors
	        }
	      });
	
	    case types.CHANGE_SETTINGS_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        errors: []
	      });
	
	    case types.CHANGE_SETTINGS_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        errors: []
	      });
	
	    case types.CHANGE_SETTINGS_FAILURE:
	      console.log(action);
	      return Object.assign({}, state, {
	        isFetching: false,
	        errors: action.errors
	      });
	
	    case types.CHANGE_PASSWORD_REQUEST:
	      return Object.assign({}, state, {
	        isFetchingPassword: true,
	        errors: []
	      });
	
	    case types.CHANGE_PASSWORD_SUCCESS:
	      return Object.assign({}, state, {
	        isFetchingPassword: false,
	        errors: []
	      });
	
	    case types.CHANGE_PASSWORD_FAILURE:
	      return Object.assign({}, state, {
	        isFetchingPassword: false,
	        errors: action.errors
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = auth;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var demoExercises = window.demoExercises || [];
	
	function exercises() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    hasSaved: false,
	    hasUpdated: false,
	    exercises: demoExercises || [],
	    activeExercise: null,
	    errors: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.EXERCISE_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case types.EXERCISE_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        exercises: action.response
	      });
	
	    case types.EXERCISE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	    case types.EXERCISE_CREATE_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        hasSaved: false
	      });
	
	    case types.EXERCISE_CREATE_SUCCESS:
	      {
	        var newExercises = [].concat(_toConsumableArray(state.exercises));
	        newExercises.push(action.response);
	        return Object.assign({}, state, {
	          isFetching: false,
	          hasSaved: true,
	          exercises: newExercises
	        });
	      }
	    case types.EXERCISE_CREATE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasSaved: false
	      });
	    case types.EXERCISE_UPDATE_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        hasUpdated: false,
	        errors: []
	      });
	
	    case types.EXERCISE_UPDATE_SUCCESS:
	      {
	        var _newExercises = [].concat(_toConsumableArray(state.exercises));
	        _newExercises.forEach(function (item, i, array) {
	          if (item.id === action.response.id) array[i] = action.response; // eslint-disable-line no-param-reassign
	        });
	
	        return Object.assign({}, state, {
	          isFetching: false,
	          hasUpdated: true,
	          exercises: _newExercises
	        });
	      }
	    case types.EXERCISE_UPDATE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasUpdated: false,
	        errors: action.errors
	      });
	    case types.EXERCISE_DELETE_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case types.EXERCISE_DELETE_SUCCESS:
	      {
	        var _newExercises2 = [].concat(_toConsumableArray(state.exercises));
	        _newExercises2.forEach(function (item, i, array) {
	          if (item.id === action.response.id) array.splice(i, 1);
	        });
	
	        return Object.assign({}, state, {
	          isFetching: false,
	          exercises: _newExercises2,
	          activeExercise: null
	        });
	      }
	    case types.EXERCISE_DELETE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	    case types.LAUNCH_EXERCISE:
	      return Object.assign({}, state, {
	        activeExercise: action.activeExercise
	      });
	    case types.CLEAR_EXERCISE:
	      return Object.assign({}, state, {
	        activeExercise: null
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = exercises;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function group() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    hasFetched: false,
	    name: '',
	    seats: 0,
	    validUntil: null,
	    token: '',
	    users: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.GROUP_SUCCESS:
	      return Object.assign({}, state, {
	        hasFetched: true
	      }, action.response);
	
	    case types.GROUP_FAILURE:
	      return Object.assign({}, state, {
	        hasFetched: false
	      });
	    case types.GROUP_UPDATE_SUCCESS:
	      return Object.assign({}, state, {
	        hasFetched: true
	      }, action.response);
	
	    case types.GROUP_UPDATE_FAILURE:
	      return Object.assign({}, state, {
	        hasFetched: false
	      });
	
	    case types.GROUP_TOKEN_REFRESH_SUCCESS:
	      return Object.assign({}, state, {
	        hasFetched: true,
	        token: action.response.token
	      });
	
	    case types.GROUP_TOKEN_REFRESH_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	
	    case types.GROUP_USERS_SUCCESS:
	      return Object.assign({}, state, {
	        hasFetched: true,
	        users: action.response
	      });
	
	    case types.GROUP_USERS_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	
	    case types.GROUP_USER_UPDATE_SUCCESS:
	      {
	        var newUsers = [].concat(_toConsumableArray(state.users));
	        newUsers.forEach(function (item, i, array) {
	          if (item.id === action.response.id) array[i] = action.response;
	        }); // eslint-disable-line no-param-reassign
	
	        return Object.assign({}, state, {
	          isFetching: false,
	          hasFetched: true,
	          users: newUsers
	        });
	      }
	    case types.GROUP_USER_UPDATE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	
	    case types.GROUP_USER_REMOVE_SUCCESS:
	
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: true,
	        users: action.response
	      });
	
	    case types.GROUP_USER_REMOVE_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	
	    case types.GROUP_SEND_INVITATION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: true
	      });
	
	    case types.GROUP_SEND_INVITATION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = group;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	var _scoring = __webpack_require__(250);
	
	var _scoring2 = _interopRequireDefault(_scoring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function history() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    history: [],
	    isFetching: false,
	    hasFetched: false,
	    reportURL: ''
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.ADD_HISTORY:
	      {
	        var newState = Object.assign({}, state);
	        var score = _scoring2.default.getTotalScore(action.text, action.results.result, action.results.confidence);
	
	        var scoreByWord = _scoring2.default.getScoreByWord(action.text, action.results.result, score, action.results.confidence);
	
	        var historyPackage = {
	          source: action.text,
	          language: action.language,
	          result: action.results,
	          score: score,
	          scoreByWord: scoreByWord
	        };
	
	        newState.history.push(historyPackage);
	        return Object.assign({}, newState);
	      }
	    case types.HISTORY_REPORT_REQUEST:
	      {
	        return Object.assign({}, state, {
	          isFetching: true,
	          hasFetched: false,
	          reportURL: ''
	        });
	      }
	    case types.HISTORY_REPORT_SUCCESS:
	      {
	        return Object.assign({}, state, {
	          isFetching: false,
	          hasFetched: true,
	          reportURL: URL.createObjectURL(action.response)
	        });
	      }
	    case types.HISTORY_REPORT_FAILURE:
	      {
	        return Object.assign({}, state, {
	          isFetching: false,
	          hasFetched: false,
	          reportURL: ''
	        });
	      }
	    default:
	      return state;
	  }
	}
	
	exports.default = history;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function invoices() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    hasFetched: false,
	    invoices: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.INVOICES_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        hasFetched: false
	      });
	
	    case types.INVOICES_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: true,
	        invoices: action.response
	      });
	
	    case types.INVOICES_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = invoices;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function joinGroup() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    didSucceed: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.JOIN_GROUP_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        didSucceed: false
	      });
	
	    case types.JOIN_GROUP_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        didSucceed: true
	      });
	
	    case types.JOIN_GROUP_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        didSucceed: false
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = joinGroup;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isWaiting = function isWaiting() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LOGIN_REQUEST:
	    case types.REGISTRATION_REQUEST:
	    case types.LOGOUT_REQUEST:
	    case types.PASSWORD_EMAIL_REQUEST:
	    case types.PASSWORD_RESET_REQUEST:
	    case types.EXERCISE_REQUEST:
	    case types.EXERCISE_CREATE_REQUEST:
	    case types.EXERCISE_UPDATE_REQUEST:
	    case types.EXERCISE_DELETE_REQUEST:
	    case types.HISTORY_REPORT_REQUEST:
	    case types.CHANGE_SETTINGS_REQUEST:
	    case types.CHANGE_PASSWORD_REQUEST:
	    case types.VALIDATE_TOKEN_REQUEST:
	    case types.VALIDATE_EMAIL_REQUEST:
	    case types.GROUP_REQUEST:
	    case types.GROUP_UPDATE_REQUEST:
	    case types.GROUP_TOKEN_REFRESH_REQUEST:
	    case types.GROUP_USERS_REQUEST:
	    case types.GROUP_USER_UPDATE_REQUEST:
	    case types.GROUP_USER_REMOVE_REQUEST:
	    case types.GROUP_SEND_INVITATION_REQUEST:
	      {
	        var newState = Object.assign({}, state);
	        var actionGroup = action.type.replace('_REQUEST', '');
	        newState[actionGroup] = true;
	        return Object.assign({}, newState);
	      }
	    case types.LOGIN_SUCCESS:
	    case types.REGISTRATION_SUCCESS:
	    case types.LOGOUT_SUCCESS:
	    case types.PASSWORD_EMAIL_SUCCESS:
	    case types.PASSWORD_RESET_SUCCESS:
	    case types.EXERCISE_SUCCESS:
	    case types.EXERCISE_CREATE_SUCCESS:
	    case types.EXERCISE_UPDATE_SUCCESS:
	    case types.EXERCISE_DELETE_SUCCESS:
	    case types.HISTORY_REPORT_SUCCESS:
	    case types.CHANGE_SETTINGS_SUCCESS:
	    case types.CHANGE_PASSWORD_SUCCESS:
	    case types.VALIDATE_TOKEN_SUCCESS:
	    case types.VALIDATE_EMAIL_SUCCESS:
	    case types.GROUP_SUCCESS:
	    case types.GROUP_UPDATE_SUCCESS:
	    case types.GROUP_TOKEN_REFRESH_SUCCESS:
	    case types.GROUP_USERS_SUCCESS:
	    case types.GROUP_USER_UPDATE_SUCCESS:
	    case types.GROUP_USER_REMOVE_SUCCESS:
	    case types.GROUP_SEND_INVITATION_SUCCESS:
	      {
	        var newSuccessState = Object.assign({}, state);
	        var actionGroupSuccess = action.type.replace('_SUCCESS', '');
	        newSuccessState[actionGroupSuccess] = false;
	        return Object.assign({}, newSuccessState);
	      }
	    case types.LOGIN_FAILURE:
	    case types.REGISTRATION_FAILURE:
	    case types.LOGOUT_FAILURE:
	    case types.PASSWORD_EMAIL_FAILURE:
	    case types.PASSWORD_RESET_FAILURE:
	    case types.EXERCISE_FAILURE:
	    case types.EXERCISE_CREATE_FAILURE:
	    case types.EXERCISE_UPDATE_FAILURE:
	    case types.EXERCISE_DELETE_FAILURE:
	    case types.HISTORY_REPORT_FAILURE:
	    case types.CHANGE_SETTINGS_FAILURE:
	    case types.CHANGE_PASSWORD_FAILURE:
	    case types.VALIDATE_TOKEN_FAILURE:
	    case types.VALIDATE_EMAIL_FAILURE:
	    case types.GROUP_FAILURE:
	    case types.GROUP_UPDATE_FAILURE:
	    case types.GROUP_TOKEN_REFRESH_FAILURE:
	    case types.GROUP_USERS_FAILURE:
	    case types.GROUP_USER_UPDATE_FAILURE:
	    case types.GROUP_USER_REMOVE_FAILURE:
	    case types.GROUP_SEND_INVITATION_FAILURE:
	      {
	        var newFailureState = Object.assign({}, state);
	        var actionGroupFailure = action.type.replace('_FAILURE', '');
	        newFailureState[actionGroupFailure] = false;
	        return Object.assign({}, newFailureState);
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = isWaiting;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(160);
	
	var _network = __webpack_require__(670);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _auth = __webpack_require__(664);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _registration = __webpack_require__(672);
	
	var _registration2 = _interopRequireDefault(_registration);
	
	var _trialregistration = __webpack_require__(676);
	
	var _trialregistration2 = _interopRequireDefault(_trialregistration);
	
	var _singleregistration = __webpack_require__(673);
	
	var _singleregistration2 = _interopRequireDefault(_singleregistration);
	
	var _joinGroup = __webpack_require__(669);
	
	var _joinGroup2 = _interopRequireDefault(_joinGroup);
	
	var _subscriptions = __webpack_require__(674);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _invoices = __webpack_require__(668);
	
	var _invoices2 = _interopRequireDefault(_invoices);
	
	var _exercises = __webpack_require__(665);
	
	var _exercises2 = _interopRequireDefault(_exercises);
	
	var _group = __webpack_require__(666);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _text = __webpack_require__(675);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _history = __webpack_require__(667);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _validation = __webpack_require__(677);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appReducer = (0, _redux.combineReducers)({
	  isWaiting: _network2.default,
	  auth: _auth2.default,
	  registration: _registration2.default,
	  trialregistration: _trialregistration2.default,
	  singleregistration: _singleregistration2.default,
	  joinGroup: _joinGroup2.default,
	  subscriptions: _subscriptions2.default,
	  invoices: _invoices2.default,
	  group: _group2.default,
	  exercises: _exercises2.default,
	  text: _text2.default,
	  history: _history2.default,
	  validation: _validation2.default
	});
	
	var rootReducer = function rootReducer(state, action) {
	  var returnedState = state;
	  if (action.type === 'LOGOUT_SUCCESS' || action.type === 'LOGOUT_FAIL') {
	    returnedState = undefined;
	  }
	
	  return appReducer(returnedState, action);
	};
	
	exports.default = rootReducer;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function registration() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    isRegistered: false,
	    errors: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.REGISTRATION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isRegistered: false,
	        errors: []
	      });
	
	    case types.REGISTRATION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: true
	      });
	
	    case types.REGISTRATION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: false,
	        errors: action.errors
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = registration;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function singleregistration() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    isRegistered: false,
	    token: null,
	    errors: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SINGLE_REGISTRATION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isRegistered: false,
	        jwt: null,
	        errors: []
	      });
	
	    case types.SINGLE_REGISTRATION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: true,
	        jwt: action.token,
	        errors: []
	      });
	
	    case types.SINGLE_REGISTRATION_FAILURE:
	      console.log(action);
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: false,
	        jwt: null,
	        errors: action.errors
	      });
	    case types.SINGLE_FREE_REGISTRATION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isRegistered: false,
	        jwt: null,
	        errors: []
	      });
	
	    case types.SINGLE_FREE_REGISTRATION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: true,
	        jwt: action.token,
	        errors: []
	      });
	
	    case types.SINGLE_FREE_REGISTRATION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: false,
	        jwt: null,
	        errors: action.errors
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = singleregistration;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function subscriptions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    hasFetched: false,
	    isFetchingPlan: false,
	    hasFetchedPlan: false,
	    isCreatingSubscription: false,
	    isUpdatingCard: false,
	    isCancellingSubscription: false,
	    isResumingSubscription: false,
	    triedToSubscribe: false,
	    didSucceed: false,
	    plan: {},
	    info: {},
	    subscriptions: [],
	    errors: []
	  };
	  var action = arguments[1];
	
	  console.log(action.type);
	  console.log(action);
	  switch (action.type) {
	    case types.PLAN_REQUEST:
	      return Object.assign({}, state, {
	        isFetchingPlan: true,
	        hasFetchedPlan: false,
	        errors: []
	      });
	
	    case types.PLAN_SUCCESS:
	
	      console.log(action);
	      return Object.assign({}, state, {
	        isFetchingPlan: false,
	        hasFetchedPlan: true,
	        plan: action.response.plan,
	        errors: []
	      });
	
	    case types.PLAN_FAILURE:
	      return Object.assign({}, state, {
	        isFetchingPlan: false,
	        hasFetchedPlan: false,
	        plan: {},
	        errors: action.errors
	      });
	    case types.CREATE_SUBSCRIPTION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isCreatingSubscription: true,
	        triedToSubscribe: false,
	        didSucceed: false,
	        errors: []
	      });
	
	    case types.CREATE_SUBSCRIPTION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isCreatingSubscription: false,
	        triedToSubscribe: true,
	        didSucceed: true,
	        info: action.response.info,
	        subscriptions: action.response.subscriptions,
	        errors: []
	      });
	
	    case types.CREATE_SUBSCRIPTION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isCreatingSubscription: false,
	        triedToSubscribe: true,
	        didSucceed: false,
	        errors: action.errors
	      });
	    case types.SUBSCRIPTIONS_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        hasFetched: false,
	        errors: []
	      });
	
	    case types.SUBSCRIPTIONS_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: true,
	        info: action.response.info,
	        subscriptions: action.response.subscriptions,
	        errors: []
	      });
	
	    case types.SUBSCRIPTIONS_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        hasFetched: false,
	        errors: action.errors
	      });
	
	    case types.CANCEL_SUBSCRIPTION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isCancellingSubscription: true,
	        hasFetched: false
	      });
	
	    case types.CANCEL_SUBSCRIPTION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isCancellingSubscription: false,
	        hasFetched: true,
	        info: action.response.info,
	        subscriptions: action.response.subscriptions,
	        errors: []
	      });
	
	    case types.CANCEL_SUBSCRIPTION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isCancellingSubscription: false,
	        hasFetched: false,
	        errors: action.errors
	      });
	
	    case types.RESUME_SUBSCRIPTION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isResumingSubscription: true,
	        hasFetched: false
	      });
	
	    case types.RESUME_SUBSCRIPTION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isResumingSubscription: false,
	        hasFetched: true,
	        info: action.response.info,
	        subscriptions: action.response.subscriptions,
	        errors: []
	      });
	
	    case types.RESUME_SUBSCRIPTION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isResumingSubscription: false,
	        hasFetched: false,
	        errors: action.errors
	      });
	
	    case types.UPDATE_CARD_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isUpdatingCard: true,
	        hasFetched: false,
	        errors: []
	      });
	
	    case types.UPDATE_CARD_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isUpdatingCard: false,
	        hasFetched: true,
	        info: action.response.info,
	        subscriptions: action.response.subscriptions,
	        errors: []
	      });
	
	    case types.UPDATE_CARD_FAILURE:
	      return Object.assign({}, state, {
	        isUpdatingCard: false,
	        isFetching: false,
	        errors: action.errors
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = subscriptions;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	var _scoring = __webpack_require__(250);
	
	var _scoring2 = _interopRequireDefault(_scoring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint consistent-return: "warn" */
	
	
	var initialTextState = {
	  activeText: 0,
	  texts: [{
	    source: '',
	    utteranceLength: 0,
	    results: [{
	      result: {
	        confidence: 0,
	        result: ''
	      },
	      score: '',
	      scoreByWord: []
	    }],
	    audioBuffer: null
	  }]
	};
	
	function text() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.assign({}, initialTextState);
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LAUNCH_TEXT:
	      return Object.assign({}, state, { activeText: 0, texts: action.texts });
	    case types.SELECT_TEXT:
	      return Object.assign({}, state, { activeText: action.index });
	
	    case types.CLEAR_TEXT:
	      return {
	        activeText: 0,
	        texts: [{
	          source: '',
	          utteranceLength: 0,
	          results: [{
	            result: {
	              confidence: 0,
	              result: ''
	            },
	            score: '',
	            scoreByWord: []
	          }],
	          audioBuffer: null
	        }]
	      };
	    case types.UPDATE_SOURCE:
	      {
	        if (action.source.length > 200) {
	          return state;
	        }
	
	        var newState = Object.assign({}, state);
	        newState.texts[state.activeText] = {
	          source: action.source,
	          translations: {},
	          results: [],
	          audioBuffer: null
	        };
	        return newState;
	      }
	      break;
	    case types.UPDATE_TRANSLATION:
	      {
	        console.log('update in reducer');
	        var _newState = Object.assign({}, state);
	        var translations = Object.assign({}, _newState.texts[state.activeText].translations);
	        console.log(translations);
	        Object.assign(translations, action.translation);
	        _newState.texts[state.activeText].translations = translations;
	        console.log(_newState);
	        return _newState;
	      }
	      break;
	    case types.NEXT_SENTENCE:
	      if (state.texts.length > state.activeText) {
	        return Object.assign({}, state, { activeText: state.activeText + 1 });
	      }
	      break;
	
	    case types.PREV_SENTENCE:
	      if (state.activeText > 0) {
	        return Object.assign({}, state, { activeText: state.activeText - 1 });
	      }
	      break;
	
	    case types.SPLICE_SENTENCE:
	      {
	        var texts = [].concat(_toConsumableArray(state.texts));
	        var activeText = state.activeText;
	
	        if (texts.length > 1) {
	          texts.splice(state.activeText, 1);
	        } else {
	          texts[state.activeText] = {
	            source: '',
	            results: [],
	            audioBuffer: null
	          };
	        }
	        activeText = activeText > 0 ? activeText - 1 : 0;
	
	        return Object.assign({}, state, { texts: texts, activeText: activeText });
	      }
	    case types.SET_UTTERANCE_LENGTH:
	      {
	        var newTexts = [].concat(_toConsumableArray(state.texts));
	        newTexts[state.activeText].utteranceLength = action.utteranceLength;
	        return Object.assign({}, state, { texts: newTexts });
	      }
	    case types.SET_RECORDING:
	      {
	        var recTexts = [].concat(_toConsumableArray(state.texts));
	        recTexts[state.activeText].audioBuffer = action.buffer;
	        recTexts[state.activeText].float32ArrayBuffers = action.float32ArrayBuffers;
	        return Object.assign({}, state, { texts: recTexts });
	      }
	    case types.ADD_RESULTS:
	      {
	        var score = _scoring2.default.getTotalScore(state.texts[state.activeText].source, action.results.result, action.results.confidence);
	
	        var scoreByWord = _scoring2.default.getScoreByWord(state.texts[state.activeText].source, action.results.result, score, action.results.confidence);
	
	        var resultPackage = {
	          result: action.results,
	          score: score,
	          scoreByWord: scoreByWord
	        };
	
	        var resultTexts = [].concat(_toConsumableArray(state.texts));
	        resultTexts[state.activeText].results.push(resultPackage);
	
	        return Object.assign({}, state, { texts: resultTexts });
	      }
	    default:
	      return state;
	  }
	}
	
	exports.default = text;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function trialRegistration() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isFetching: false,
	    isFetchingValidation: false,
	    hasValidated: false,
	    trialToken: {},
	    errors: [],
	    isRegistered: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.VALIDATE_TRIAL_TOKEN_REQUEST:
	      return Object.assign({}, state, {
	        isFetchingValidation: true,
	        trialToken: {},
	        errors: []
	      });
	
	    case types.VALIDATE_TRIAL_TOKEN_SUCCESS:
	      return Object.assign({}, state, {
	        isFetchingValidation: false,
	        hasValidated: true,
	        trialToken: action.response,
	        errors: []
	      });
	
	    case types.VALIDATE_TRIAL_TOKEN_FAILURE:
	      return Object.assign({}, state, {
	        isFetchingValidation: false,
	        hasValidated: false,
	        trialToken: {},
	        errors: action.errors
	      });
	    case types.TRIAL_REGISTRATION_REQUEST:
	      return Object.assign({}, state, {
	        isFetching: true,
	        isRegistered: false
	      });
	
	    case types.TRIAL_REGISTRATION_SUCCESS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: true
	      });
	
	    case types.TRIAL_REGISTRATION_FAILURE:
	      return Object.assign({}, state, {
	        isFetching: false,
	        isRegistered: false
	      });
	
	    default:
	      return state;
	  }
	}
	
	exports.default = trialRegistration;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(27);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function validation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    token: {
	      isFetching: false,
	      hasFetched: false,
	      isValid: false,
	      errors: []
	    },
	    email: {
	      isFetching: false,
	      hasFetched: false,
	      isValid: false,
	      errors: []
	    }
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.VALIDATE_TOKEN_REQUEST:
	      return Object.assign({}, state, {
	        token: {
	          isFetching: true,
	          hasFetched: false,
	          errors: []
	        }
	      });
	    case types.VALIDATE_TOKEN_SUCCESS:
	      return Object.assign({}, state, {
	        token: {
	          isFetching: false,
	          hasFetched: true,
	          isValid: true,
	          errors: []
	        }
	      });
	    case types.VALIDATE_TOKEN_FAILURE:
	      return Object.assign({}, state, {
	        token: {
	          isFetching: false,
	          hasFetched: true,
	          isValid: false,
	          errors: action.errors
	        }
	      });
	    case types.VALIDATE_EMAIL_REQUEST:
	      return Object.assign({}, state, {
	        email: {
	          isFetching: true,
	          hasFetched: false,
	          errors: []
	        }
	      });
	    case types.VALIDATE_EMAIL_SUCCESS:
	      return Object.assign({}, state, {
	        email: {
	          isFetching: false,
	          hasFetched: true,
	          isValid: true,
	          errors: []
	        }
	      });
	    case types.VALIDATE_EMAIL_FAILURE:
	      console.log(action.errors);
	      return Object.assign({}, state, {
	        email: {
	          isFetching: false,
	          hasFetched: true,
	          isValid: false,
	          errors: action.errors
	        }
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = validation;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(536);
	var EventPluginUtils = __webpack_require__(93);
	var EventPropagators = __webpack_require__(67);
	var SyntheticUIEvent = __webpack_require__(69);
	var TouchEventUtils = __webpack_require__(679);
	var ViewportMetrics = __webpack_require__(145);
	
	var keyOf = __webpack_require__(356);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 680 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(10);
	var defaultClickRejectionStrategy = __webpack_require__(680);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(66).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(678)(shouldRejectClick)
	  });
	};


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(273);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(25);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.generateAutoDrawCss = exports.normalizeDataset = undefined;
	
	var _math = __webpack_require__(156);
	
	var normalizeDataset = exports.normalizeDataset = function normalizeDataset(data, _ref) {
	  var minX = _ref.minX,
	      maxX = _ref.maxX,
	      minY = _ref.minY,
	      maxY = _ref.maxY;
	
	  // For the X axis, we want to normalize it based on its index in the array.
	  // For the Y axis, we want to normalize it based on the element's value.
	  //
	  // X axis is easy: just evenly-space each item in the array.
	  // For the Y axis, we first need to find the min and max of our array,
	  // and then normalize those values between 0 and 1.
	  var boundariesX = { min: 0, max: data.length - 1 };
	  var boundariesY = { min: Math.min.apply(Math, data), max: Math.max.apply(Math, data) };
	
	  var normalizedData = data.map(function (point, index) {
	    return {
	      x: (0, _math.normalize)({
	        value: index,
	        min: boundariesX.min,
	        max: boundariesX.max,
	        scaleMin: minX,
	        scaleMax: maxX
	      }),
	      y: (0, _math.normalize)({
	        value: point,
	        min: boundariesY.min,
	        max: boundariesY.max,
	        scaleMin: minY,
	        scaleMax: maxY
	      })
	    };
	  });
	
	  // According to the SVG spec, paths with a height/width of `0` can't have
	  // linear gradients applied. This means that our lines are invisible when
	  // the dataset is flat (eg. [0, 0, 0, 0]).
	  //
	  // The hacky solution is to apply a very slight offset to the first point of
	  // the dataset. As ugly as it is, it's the best solution we can find (there
	  // are ways within the SVG spec of changing it, but not without causing
	  // breaking changes).
	  if (boundariesY.min === boundariesY.max) {
	    // eslint-disable-next-line no-param-reassign
	    normalizedData[0].y += 0.0001;
	  }
	
	  return normalizedData;
	};
	
	var generateAutoDrawCss = exports.generateAutoDrawCss = function generateAutoDrawCss(_ref2) {
	  var id = _ref2.id,
	      lineLength = _ref2.lineLength,
	      duration = _ref2.duration,
	      easing = _ref2.easing;
	
	  // We do the animation using the dash array/offset trick
	  // https://css-tricks.com/svg-line-animation-works/
	  var autodrawKeyframeAnimation = '\n    @keyframes react-trend-autodraw-' + id + ' {\n      0% {\n        stroke-dasharray: ' + lineLength + ';\n        stroke-dashoffset: ' + lineLength + '\n      }\n      100% {\n        stroke-dasharray: ' + lineLength + ';\n        stroke-dashoffset: 0;\n      }\n      100% {\n        stroke-dashoffset: \'\';\n        stroke-dasharray: \'\';\n      }\n    }\n  ';
	
	  // One unfortunate side-effect of the auto-draw is that the line is
	  // actually 1 big dash, the same length as the line itself. If the
	  // line length changes (eg. radius change, new data), that dash won't
	  // be the same length anymore. We can fix that by removing those
	  // properties once the auto-draw is completed.
	  var cleanupKeyframeAnimation = '\n    @keyframes react-trend-autodraw-cleanup-' + id + ' {\n      to {\n        stroke-dasharray: \'\';\n        stroke-dashoffset: \'\';\n      }\n    }\n  ';
	
	  return '\n    ' + autodrawKeyframeAnimation + '\n\n    ' + cleanupKeyframeAnimation + '\n\n    #react-trend-' + id + ' {\n      animation:\n        react-trend-autodraw-' + id + ' ' + duration + 'ms ' + easing + ',\n        react-trend-autodraw-cleanup-' + id + ' 1ms ' + duration + 'ms\n      ;\n    }\n  ';
	};

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(136);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(690);
	
	var _DOM = __webpack_require__(687);
	
	var _math = __webpack_require__(156);
	
	var _misc = __webpack_require__(688);
	
	var _Trend = __webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    value: _propTypes2.default.number
	  })]).isRequired).isRequired,
	  smooth: _propTypes2.default.bool,
	  autoDraw: _propTypes2.default.bool,
	  autoDrawDuration: _propTypes2.default.number,
	  autoDrawEasing: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  padding: _propTypes2.default.number,
	  radius: _propTypes2.default.number,
	  gradient: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	var defaultProps = {
	  radius: 10,
	  stroke: 'black',
	  padding: 8,
	  strokeWidth: 1,
	  autoDraw: false,
	  autoDrawDuration: 2000,
	  autoDrawEasing: 'ease'
	};
	
	var Trend = function (_Component) {
	  _inherits(Trend, _Component);
	
	  function Trend(props) {
	    _classCallCheck(this, Trend);
	
	    // Generate a random ID. This is important for distinguishing between
	    // Trend components on a page, so that they can have different keyframe
	    // animations.
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.trendId = (0, _misc.generateId)();
	    _this.gradientId = 'react-trend-vertical-gradient-' + _this.trendId;
	    return _this;
	  }
	
	  Trend.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        autoDraw = _props.autoDraw,
	        autoDrawDuration = _props.autoDrawDuration,
	        autoDrawEasing = _props.autoDrawEasing;
	
	
	    if (autoDraw) {
	      this.lineLength = this.path.getTotalLength();
	
	      var css = (0, _Trend.generateAutoDrawCss)({
	        id: this.trendId,
	        lineLength: this.lineLength,
	        duration: autoDrawDuration,
	        easing: autoDrawEasing
	      });
	
	      (0, _DOM.injectStyleTag)(css);
	    }
	  };
	
	  Trend.prototype.getDelegatedProps = function getDelegatedProps() {
	    return (0, _utils.omit)(this.props, Object.keys(propTypes));
	  };
	
	  Trend.prototype.renderGradientDefinition = function renderGradientDefinition() {
	    var gradient = this.props.gradient;
	
	
	    return _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement(
	        'linearGradient',
	        {
	          id: this.gradientId,
	          x1: '0%',
	          y1: '0%',
	          x2: '0%',
	          y2: '100%'
	        },
	        gradient.slice().reverse().map(function (c, index) {
	          return _react2.default.createElement('stop', {
	            key: index,
	            offset: (0, _math.normalize)({
	              value: index,
	              min: 0,
	              // If we only supply a single colour, it will try to normalize
	              // between 0 and 0, which will create NaN. By making the `max`
	              // at least 1, we ensure single-color "gradients" work.
	              max: gradient.length - 1 || 1
	            }),
	            stopColor: c
	          });
	        })
	      )
	    );
	  };
	
	  Trend.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        data = _props2.data,
	        smooth = _props2.smooth,
	        width = _props2.width,
	        height = _props2.height,
	        padding = _props2.padding,
	        radius = _props2.radius,
	        gradient = _props2.gradient;
	
	    // We need at least 2 points to draw a graph.
	
	    if (!data || data.length < 2) {
	      return null;
	    }
	
	    // `data` can either be an array of numbers:
	    // [1, 2, 3]
	    // or, an array of objects containing a value:
	    // [ { value: 1 }, { value: 2 }, { value: 3 }]
	    //
	    // For now, we're just going to convert the second form to the first.
	    // Later on, if/when we support tooltips, we may adjust.
	    var plainValues = data.map(function (point) {
	      return typeof point === 'number' ? point : point.value;
	    });
	
	    // Our viewbox needs to be in absolute units, so we'll default to 300x75
	    // Our SVG can be a %, though; this is what makes it scalable.
	    // By defaulting to percentages, the SVG will grow to fill its parent
	    // container, preserving a 1/4 aspect ratio.
	    var viewBoxWidth = width || 300;
	    var viewBoxHeight = height || 75;
	    var svgWidth = width || '100%';
	    var svgHeight = height || '25%';
	
	    var normalizedValues = (0, _Trend.normalizeDataset)(plainValues, {
	      minX: padding,
	      maxX: viewBoxWidth - padding,
	      // NOTE: Because SVGs are indexed from the top left, but most data is
	      // indexed from the bottom left, we're inverting the Y min/max.
	      minY: viewBoxHeight - padding,
	      maxY: padding
	    });
	
	    var path = smooth ? (0, _DOM.buildSmoothPath)(normalizedValues, { radius: radius }) : (0, _DOM.buildLinearPath)(normalizedValues);
	
	    return _react2.default.createElement(
	      'svg',
	      _extends({
	        width: svgWidth,
	        height: svgHeight,
	        viewBox: '0 0 ' + viewBoxWidth + ' ' + viewBoxHeight
	      }, this.getDelegatedProps()),
	      gradient && this.renderGradientDefinition(),
	      _react2.default.createElement('path', {
	        ref: function ref(elem) {
	          _this2.path = elem;
	        },
	        id: 'react-trend-' + this.trendId,
	        d: path,
	        fill: 'none',
	        stroke: gradient ? 'url(#' + this.gradientId + ')' : undefined
	      })
	    );
	  };
	
	  return Trend;
	}(_react.Component);
	
	 false ? Trend.propTypes = propTypes : void 0;
	Trend.defaultProps = defaultProps;
	
	exports.default = Trend;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Trend = __webpack_require__(685);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Trend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.injectStyleTag = exports.buildSmoothPath = exports.buildLinearPath = undefined;
	
	var _math = __webpack_require__(156);
	
	var buildLinearPath = exports.buildLinearPath = function buildLinearPath(data) {
	  return data.reduce(function (path, _ref, index) {
	    var x = _ref.x,
	        y = _ref.y;
	
	    // The very first instruction needs to be a "move".
	    // The rest will be a "line".
	    var isFirstInstruction = index === 0;
	    var instruction = isFirstInstruction ? 'M' : 'L';
	
	    return '' + path + instruction + ' ' + x + ',' + y + '\n';
	  }, '');
	};
	
	var buildSmoothPath = exports.buildSmoothPath = function buildSmoothPath(data, _ref2) {
	  var radius = _ref2.radius;
	  var firstPoint = data[0],
	      otherPoints = data.slice(1);
	
	
	  return otherPoints.reduce(function (path, point, index) {
	    var next = otherPoints[index + 1];
	    var prev = otherPoints[index - 1] || firstPoint;
	
	    var isCollinear = next && (0, _math.checkForCollinearPoints)(prev, point, next);
	
	    if (!next || isCollinear) {
	      // The very last line in the sequence can just be a regular line.
	      return path + '\nL ' + point.x + ',' + point.y;
	    }
	
	    var distanceFromPrev = (0, _math.getDistanceBetween)(prev, point);
	    var distanceFromNext = (0, _math.getDistanceBetween)(next, point);
	    var threshold = Math.min(distanceFromPrev, distanceFromNext);
	
	    var isTooCloseForRadius = threshold / 2 < radius;
	
	    var radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
	
	    var before = (0, _math.moveTo)(prev, point, radiusForPoint);
	    var after = (0, _math.moveTo)(next, point, radiusForPoint);
	
	    return [path, 'L ' + before.x + ',' + before.y, 'S ' + point.x + ',' + point.y + ' ' + after.x + ',' + after.y].join('\n');
	  }, 'M ' + firstPoint.x + ',' + firstPoint.y);
	};
	
	// Taken from Khan Academy's Aphrodite
	// https://github.com/Khan/aphrodite/blob/master/src/inject.js
	var styleTag = void 0;
	var injectStyleTag = exports.injectStyleTag = function injectStyleTag(cssContents) {
	  if (styleTag == null) {
	    // Try to find a style tag with the `data-react-trend` attribute first.
	    styleTag = document.querySelector('style[data-react-trend]');
	
	    // If that doesn't work, generate a new style tag.
	    if (styleTag == null) {
	      // Taken from
	      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
	      var head = document.head || document.getElementsByTagName('head')[0];
	      styleTag = document.createElement('style');
	
	      styleTag.type = 'text/css';
	      styleTag.setAttribute('data-react-trend', '');
	      head.appendChild(styleTag);
	    }
	  }
	
	  styleTag.appendChild(document.createTextNode(cssContents));
	};

/***/ },
/* 688 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// eslint-disable-next-line no-restricted-properties
	var generateId = exports.generateId = function generateId() {
	  return Math.round(Math.random() * Math.pow(10, 16));
	};

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Trend = __webpack_require__(686);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Trend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var range = exports.range = function range(to) {
	  return [].concat(Array(to).keys());
	};
	
	var pick = exports.pick = function pick(obj, keys) {
	  return keys.reduce(function (acc, key) {
	    var _extends2;
	
	    return _extends({}, acc, (_extends2 = {}, _extends2[key] = obj[key], _extends2));
	  }, {});
	};
	
	var omit = exports.omit = function omit(obj, keys) {
	  return Object.keys(obj).reduce(function (acc, key) {
	    var _extends3;
	
	    if (keys.indexOf(key) !== -1) {
	      return acc;
	    }
	
	    return _extends({}, acc, (_extends3 = {}, _extends3[key] = obj[key], _extends3));
	  }, {});
	};

/***/ },
/* 691 */
[723, 71],
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(216);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	if (false) {
	  var ReactPerf;
	  var ReactTestUtils;
	
	  exports.getReactPerf = function () {
	    if (!ReactPerf) {
	      ReactPerf = require('react-dom/lib/ReactPerf');
	    }
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    if (!ReactTestUtils) {
	      ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	    }
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(42);
	
	var ReactTransitionGroup = __webpack_require__(703);
	var ReactCSSTransitionGroupChild = __webpack_require__(694);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: React.PropTypes.bool,
	  transitionEnter: React.PropTypes.bool,
	  transitionLeave: React.PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(42);
	var ReactAddonsDOMDependencies = __webpack_require__(692);
	
	var CSSCore = __webpack_require__(344);
	var ReactTransitionEvents = __webpack_require__(702);
	
	var onlyChild = __webpack_require__(257);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(691);
	var ReactElement = __webpack_require__(70);
	
	var emptyFunction = __webpack_require__(26);
	var traverseAllChildren = __webpack_require__(258);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71),
	    _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(157);
	var ReactElement = __webpack_require__(70);
	var ReactPropTypeLocationNames = __webpack_require__(254);
	var ReactNoopUpdateQueue = __webpack_require__(159);
	
	var emptyObject = __webpack_require__(77);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(11);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(70);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(70);
	var ReactPropTypeLocationNames = __webpack_require__(254);
	var ReactPropTypesSecret = __webpack_require__(699);
	
	var emptyFunction = __webpack_require__(26);
	var getIteratorFn = __webpack_require__(256);
	var warning = __webpack_require__(11);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 699 */
562,
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(157);
	var ReactNoopUpdateQueue = __webpack_require__(159);
	
	var emptyObject = __webpack_require__(77);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(705);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var getVendorPrefixedEventName = __webpack_require__(229);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(42);
	var ReactTransitionChildMapping = __webpack_require__(701);
	
	var emptyFunction = __webpack_require__(26);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: React.PropTypes.any,
	  childFactory: React.PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 704 */
567,
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(252);
	var traverseAllChildren = __webpack_require__(258);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ROLLBAR_ACCESS_TOKEN":"8bd15db033ec48a3a60bc809335305ab","REACT_APP_API_URL":"https://pronounce-live-admin.herokuapp.com/api/v1"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(158);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ },
/* 706 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(711);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(709);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 708 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(708);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(259);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(707);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 712 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(260);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 714 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(261);
	
	var _isPlainObject = __webpack_require__(126);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(262);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 716 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 717 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(719);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(263)(module)))

/***/ },
/* 719 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 720 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 721 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 722 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.e2c08b3e.js